import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  _int4: { input: any; output: any; }
  _text: { input: any; output: any; }
  _uuid: { input: any; output: any; }
  bigint: { input: any; output: any; }
  bytea: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CallbackCustomInput = {
  my_custom_id?: InputMaybe<Scalars['String']['input']>;
};

export type CallbackHeadersInput = {
  session_id?: InputMaybe<Scalars['String']['input']>;
};

export type CallbackInput = {
  custom?: InputMaybe<CallbackCustomInput>;
  field?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<CallbackHeadersInput>;
  method?: InputMaybe<CallbackMethod>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum CallbackMethod {
  GET = 'GET',
  JSON = 'JSON',
  POST = 'POST'
}

export type ConfirmoGetFirmaInput = {
  id: Scalars['uuid']['input'];
};

export type ConfirmoGetFirmaOutput = {
  __typename?: 'ConfirmoGetFirmaOutput';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ConfirmoGetInput = {
  id: Scalars['uuid']['input'];
};

export type ConfirmoGetOutput = {
  __typename?: 'ConfirmoGetOutput';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ConfirmoInput = {
  IDEvento: Scalars['Int']['input'];
  id: Scalars['uuid']['input'];
};

export type ConfirmoOutput = {
  __typename?: 'ConfirmoOutput';
  error?: Maybe<Scalars['String']['output']>;
  rowsUpdated?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum MessageEncoding {
  GSM7 = 'GSM_7',
  UTF8 = 'UTF_8'
}

export type MessageOptionsInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  failOnMultipleMessages?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MessageState {
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  NEW = 'NEW',
  SENT = 'SENT'
}

export type OpenapiSmsInput = {
  blocklisted?: InputMaybe<Scalars['Boolean']['input']>;
  blocklistedReason?: InputMaybe<Scalars['String']['input']>;
  callback?: InputMaybe<CallbackInput>;
  charactersCount?: InputMaybe<Scalars['Int']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveredAt?: InputMaybe<Scalars['timestamptz']['input']>;
  encoding?: InputMaybe<MessageEncoding>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internationalPrefix?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<MessageOptionsInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  recipient: Scalars['String']['input'];
  sender: Scalars['String']['input'];
  sentAt?: InputMaybe<Scalars['timestamptz']['input']>;
  state?: InputMaybe<MessageState>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  username: Scalars['String']['input'];
};

export type OpenapiSmsOutput = {
  __typename?: 'OpenapiSmsOutput';
  error?: Maybe<Scalars['String']['output']>;
  rowsUpdated?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ParseBollettaInput = {
  base_url: Scalars['String']['input'];
  email: Scalars['String']['input'];
  file_id: Scalars['uuid']['input'];
  save: Scalars['Boolean']['input'];
  tipologia_intestatario: Scalars['JSON']['input'];
};

export type ParseBollettaOutput = {
  __typename?: 'ParseBollettaOutput';
  data?: Maybe<Scalars['JSON']['output']>;
  sottoscrizione?: Maybe<Staging_Sottoscrizione>;
  staging_id?: Maybe<Scalars['uuid']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PreviewPdfInput = {
  allegati_img?: InputMaybe<Array<Scalars['String']['input']>>;
  allegati_pdf?: InputMaybe<Array<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  variables: Scalars['json']['input'];
};

export type PreviewPdfOutput = {
  __typename?: 'PreviewPdfOutput';
  base64_pdf: Scalars['String']['output'];
};

export type RegisterUserResponse = {
  __typename?: 'RegisterUserResponse';
  detail?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "_destinazione_compatibile" */
export type _Destinazione_Compatibile = {
  __typename?: '_destinazione_compatibile';
  descrizione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  predefinita?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "_destinazione_compatibile" */
export type _Destinazione_Compatibile_Aggregate = {
  __typename?: '_destinazione_compatibile_aggregate';
  aggregate?: Maybe<_Destinazione_Compatibile_Aggregate_Fields>;
  nodes: Array<_Destinazione_Compatibile>;
};

/** aggregate fields of "_destinazione_compatibile" */
export type _Destinazione_Compatibile_Aggregate_Fields = {
  __typename?: '_destinazione_compatibile_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<_Destinazione_Compatibile_Max_Fields>;
  min?: Maybe<_Destinazione_Compatibile_Min_Fields>;
};


/** aggregate fields of "_destinazione_compatibile" */
export type _Destinazione_Compatibile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "_destinazione_compatibile". All fields are combined with a logical 'AND'. */
export type _Destinazione_Compatibile_Bool_Exp = {
  _and?: InputMaybe<Array<_Destinazione_Compatibile_Bool_Exp>>;
  _not?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
  _or?: InputMaybe<Array<_Destinazione_Compatibile_Bool_Exp>>;
  descrizione?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  predefinita?: InputMaybe<Boolean_Comparison_Exp>;
};

/** input type for inserting data into table "_destinazione_compatibile" */
export type _Destinazione_Compatibile_Insert_Input = {
  descrizione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  predefinita?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type _Destinazione_Compatibile_Max_Fields = {
  __typename?: '_destinazione_compatibile_max_fields';
  descrizione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type _Destinazione_Compatibile_Min_Fields = {
  __typename?: '_destinazione_compatibile_min_fields';
  descrizione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "_destinazione_compatibile" */
export type _Destinazione_Compatibile_Mutation_Response = {
  __typename?: '_destinazione_compatibile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<_Destinazione_Compatibile>;
};

/** Ordering options when selecting data from "_destinazione_compatibile". */
export type _Destinazione_Compatibile_Order_By = {
  descrizione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  predefinita?: InputMaybe<Order_By>;
};

/** select columns of table "_destinazione_compatibile" */
export enum _Destinazione_Compatibile_Select_Column {
  /** column name */
  Descrizione = 'descrizione',
  /** column name */
  Id = 'id',
  /** column name */
  Predefinita = 'predefinita'
}

/** input type for updating data in table "_destinazione_compatibile" */
export type _Destinazione_Compatibile_Set_Input = {
  descrizione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  predefinita?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "_destinazione_compatibile" */
export type _Destinazione_Compatibile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: _Destinazione_Compatibile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _Destinazione_Compatibile_Stream_Cursor_Value_Input = {
  descrizione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  predefinita?: InputMaybe<Scalars['Boolean']['input']>;
};

export type _Destinazione_Compatibile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_Destinazione_Compatibile_Set_Input>;
  /** filter the rows which have to be updated */
  where: _Destinazione_Compatibile_Bool_Exp;
};

/** columns and relationships of "_pod_duplicato" */
export type _Pod_Duplicato = {
  __typename?: '_pod_duplicato';
  pod: Scalars['String']['output'];
};

/** aggregated selection of "_pod_duplicato" */
export type _Pod_Duplicato_Aggregate = {
  __typename?: '_pod_duplicato_aggregate';
  aggregate?: Maybe<_Pod_Duplicato_Aggregate_Fields>;
  nodes: Array<_Pod_Duplicato>;
};

/** aggregate fields of "_pod_duplicato" */
export type _Pod_Duplicato_Aggregate_Fields = {
  __typename?: '_pod_duplicato_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<_Pod_Duplicato_Max_Fields>;
  min?: Maybe<_Pod_Duplicato_Min_Fields>;
};


/** aggregate fields of "_pod_duplicato" */
export type _Pod_Duplicato_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "_pod_duplicato". All fields are combined with a logical 'AND'. */
export type _Pod_Duplicato_Bool_Exp = {
  _and?: InputMaybe<Array<_Pod_Duplicato_Bool_Exp>>;
  _not?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
  _or?: InputMaybe<Array<_Pod_Duplicato_Bool_Exp>>;
  pod?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "_pod_duplicato" */
export enum _Pod_Duplicato_Constraint {
  /** unique or primary key constraint on columns "pod" */
  _PodDuplicatoPkey = '_pod_duplicato_pkey'
}

/** input type for inserting data into table "_pod_duplicato" */
export type _Pod_Duplicato_Insert_Input = {
  pod?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type _Pod_Duplicato_Max_Fields = {
  __typename?: '_pod_duplicato_max_fields';
  pod?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type _Pod_Duplicato_Min_Fields = {
  __typename?: '_pod_duplicato_min_fields';
  pod?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "_pod_duplicato" */
export type _Pod_Duplicato_Mutation_Response = {
  __typename?: '_pod_duplicato_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<_Pod_Duplicato>;
};

/** on_conflict condition type for table "_pod_duplicato" */
export type _Pod_Duplicato_On_Conflict = {
  constraint: _Pod_Duplicato_Constraint;
  update_columns?: Array<_Pod_Duplicato_Update_Column>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};

/** Ordering options when selecting data from "_pod_duplicato". */
export type _Pod_Duplicato_Order_By = {
  pod?: InputMaybe<Order_By>;
};

/** primary key columns input for table: _pod_duplicato */
export type _Pod_Duplicato_Pk_Columns_Input = {
  pod: Scalars['String']['input'];
};

/** select columns of table "_pod_duplicato" */
export enum _Pod_Duplicato_Select_Column {
  /** column name */
  Pod = 'pod'
}

/** input type for updating data in table "_pod_duplicato" */
export type _Pod_Duplicato_Set_Input = {
  pod?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "_pod_duplicato" */
export type _Pod_Duplicato_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: _Pod_Duplicato_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _Pod_Duplicato_Stream_Cursor_Value_Input = {
  pod?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "_pod_duplicato" */
export enum _Pod_Duplicato_Update_Column {
  /** column name */
  Pod = 'pod'
}

export type _Pod_Duplicato_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_Pod_Duplicato_Set_Input>;
  /** filter the rows which have to be updated */
  where: _Pod_Duplicato_Bool_Exp;
};

/** columns and relationships of "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta = {
  __typename?: '_sottoscrizione_tipo_richiesta';
  text: Scalars['String']['output'];
};

/** aggregated selection of "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_Aggregate = {
  __typename?: '_sottoscrizione_tipo_richiesta_aggregate';
  aggregate?: Maybe<_Sottoscrizione_Tipo_Richiesta_Aggregate_Fields>;
  nodes: Array<_Sottoscrizione_Tipo_Richiesta>;
};

/** aggregate fields of "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_Aggregate_Fields = {
  __typename?: '_sottoscrizione_tipo_richiesta_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<_Sottoscrizione_Tipo_Richiesta_Max_Fields>;
  min?: Maybe<_Sottoscrizione_Tipo_Richiesta_Min_Fields>;
};


/** aggregate fields of "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "_sottoscrizione_tipo_richiesta". All fields are combined with a logical 'AND'. */
export type _Sottoscrizione_Tipo_Richiesta_Bool_Exp = {
  _and?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>>;
  _not?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>;
  _or?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "_sottoscrizione_tipo_richiesta" */
export enum _Sottoscrizione_Tipo_Richiesta_Constraint {
  /** unique or primary key constraint on columns "text" */
  _SottoscrizioneTipoRichiestaPkey = '_sottoscrizione_tipo_richiesta_pkey'
}

export enum _Sottoscrizione_Tipo_Richiesta_Enum {
  Consumer = 'consumer',
  Future = 'future',
  Prosumer = 'prosumer',
  Terzo = 'terzo'
}

/** Boolean expression to compare columns of type "_sottoscrizione_tipo_richiesta_enum". All fields are combined with logical 'AND'. */
export type _Sottoscrizione_Tipo_Richiesta_Enum_Comparison_Exp = {
  _eq?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Enum>;
  _in?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Enum>;
  _nin?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Enum>>;
};

/** input type for inserting data into table "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type _Sottoscrizione_Tipo_Richiesta_Max_Fields = {
  __typename?: '_sottoscrizione_tipo_richiesta_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type _Sottoscrizione_Tipo_Richiesta_Min_Fields = {
  __typename?: '_sottoscrizione_tipo_richiesta_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_Mutation_Response = {
  __typename?: '_sottoscrizione_tipo_richiesta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<_Sottoscrizione_Tipo_Richiesta>;
};

/** on_conflict condition type for table "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_On_Conflict = {
  constraint: _Sottoscrizione_Tipo_Richiesta_Constraint;
  update_columns?: Array<_Sottoscrizione_Tipo_Richiesta_Update_Column>;
  where?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>;
};

/** Ordering options when selecting data from "_sottoscrizione_tipo_richiesta". */
export type _Sottoscrizione_Tipo_Richiesta_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: _sottoscrizione_tipo_richiesta */
export type _Sottoscrizione_Tipo_Richiesta_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "_sottoscrizione_tipo_richiesta" */
export enum _Sottoscrizione_Tipo_Richiesta_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "_sottoscrizione_tipo_richiesta" */
export type _Sottoscrizione_Tipo_Richiesta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: _Sottoscrizione_Tipo_Richiesta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _Sottoscrizione_Tipo_Richiesta_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "_sottoscrizione_tipo_richiesta" */
export enum _Sottoscrizione_Tipo_Richiesta_Update_Column {
  /** column name */
  Text = 'text'
}

export type _Sottoscrizione_Tipo_Richiesta_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Set_Input>;
  /** filter the rows which have to be updated */
  where: _Sottoscrizione_Tipo_Richiesta_Bool_Exp;
};

/** columns and relationships of "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito = {
  __typename?: '_superadmin_elimina_sottoscrizione_esito';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  modalita: Scalars['String']['output'];
  sottoscrizione_id: Scalars['uuid']['output'];
};

/** aggregated selection of "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Aggregate = {
  __typename?: '_superadmin_elimina_sottoscrizione_esito_aggregate';
  aggregate?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito_Aggregate_Fields>;
  nodes: Array<_Superadmin_Elimina_Sottoscrizione_Esito>;
};

/** aggregate fields of "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Aggregate_Fields = {
  __typename?: '_superadmin_elimina_sottoscrizione_esito_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito_Max_Fields>;
  min?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito_Min_Fields>;
};


/** aggregate fields of "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "_superadmin_elimina_sottoscrizione_esito". All fields are combined with a logical 'AND'. */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp = {
  _and?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>>;
  _not?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
  _or?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  modalita?: InputMaybe<String_Comparison_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "_superadmin_elimina_sottoscrizione_esito" */
export enum _Superadmin_Elimina_Sottoscrizione_Esito_Constraint {
  /** unique or primary key constraint on columns "sottoscrizione_id" */
  _SuperadminEliminaSottoscrizioneEsitoPkey = '_superadmin_elimina_sottoscrizione_esito_pkey'
}

/** input type for inserting data into table "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Insert_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  modalita?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Max_Fields = {
  __typename?: '_superadmin_elimina_sottoscrizione_esito_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  modalita?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Min_Fields = {
  __typename?: '_superadmin_elimina_sottoscrizione_esito_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  modalita?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Mutation_Response = {
  __typename?: '_superadmin_elimina_sottoscrizione_esito_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<_Superadmin_Elimina_Sottoscrizione_Esito>;
};

/** on_conflict condition type for table "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_On_Conflict = {
  constraint: _Superadmin_Elimina_Sottoscrizione_Esito_Constraint;
  update_columns?: Array<_Superadmin_Elimina_Sottoscrizione_Esito_Update_Column>;
  where?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
};

/** Ordering options when selecting data from "_superadmin_elimina_sottoscrizione_esito". */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  modalita?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: _superadmin_elimina_sottoscrizione_esito */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Pk_Columns_Input = {
  sottoscrizione_id: Scalars['uuid']['input'];
};

/** select columns of table "_superadmin_elimina_sottoscrizione_esito" */
export enum _Superadmin_Elimina_Sottoscrizione_Esito_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  Modalita = 'modalita',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id'
}

/** input type for updating data in table "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  modalita?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "_superadmin_elimina_sottoscrizione_esito" */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: _Superadmin_Elimina_Sottoscrizione_Esito_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _Superadmin_Elimina_Sottoscrizione_Esito_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  modalita?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "_superadmin_elimina_sottoscrizione_esito" */
export enum _Superadmin_Elimina_Sottoscrizione_Esito_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  Modalita = 'modalita',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id'
}

export type _Superadmin_Elimina_Sottoscrizione_Esito_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Set_Input>;
  /** filter the rows which have to be updated */
  where: _Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp;
};

/** columns and relationships of "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo = {
  __typename?: '_tipo_dato_consumo';
  text: Scalars['String']['output'];
};

/** aggregated selection of "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_Aggregate = {
  __typename?: '_tipo_dato_consumo_aggregate';
  aggregate?: Maybe<_Tipo_Dato_Consumo_Aggregate_Fields>;
  nodes: Array<_Tipo_Dato_Consumo>;
};

/** aggregate fields of "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_Aggregate_Fields = {
  __typename?: '_tipo_dato_consumo_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<_Tipo_Dato_Consumo_Max_Fields>;
  min?: Maybe<_Tipo_Dato_Consumo_Min_Fields>;
};


/** aggregate fields of "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<_Tipo_Dato_Consumo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "_tipo_dato_consumo". All fields are combined with a logical 'AND'. */
export type _Tipo_Dato_Consumo_Bool_Exp = {
  _and?: InputMaybe<Array<_Tipo_Dato_Consumo_Bool_Exp>>;
  _not?: InputMaybe<_Tipo_Dato_Consumo_Bool_Exp>;
  _or?: InputMaybe<Array<_Tipo_Dato_Consumo_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "_tipo_dato_consumo" */
export enum _Tipo_Dato_Consumo_Constraint {
  /** unique or primary key constraint on columns "text" */
  _TipoDatoConsumoPkey = '_tipo_dato_consumo_pkey'
}

export enum _Tipo_Dato_Consumo_Enum {
  Annuale = 'annuale',
  Mensile = 'mensile'
}

/** Boolean expression to compare columns of type "_tipo_dato_consumo_enum". All fields are combined with logical 'AND'. */
export type _Tipo_Dato_Consumo_Enum_Comparison_Exp = {
  _eq?: InputMaybe<_Tipo_Dato_Consumo_Enum>;
  _in?: InputMaybe<Array<_Tipo_Dato_Consumo_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<_Tipo_Dato_Consumo_Enum>;
  _nin?: InputMaybe<Array<_Tipo_Dato_Consumo_Enum>>;
};

/** input type for inserting data into table "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type _Tipo_Dato_Consumo_Max_Fields = {
  __typename?: '_tipo_dato_consumo_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type _Tipo_Dato_Consumo_Min_Fields = {
  __typename?: '_tipo_dato_consumo_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_Mutation_Response = {
  __typename?: '_tipo_dato_consumo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<_Tipo_Dato_Consumo>;
};

/** on_conflict condition type for table "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_On_Conflict = {
  constraint: _Tipo_Dato_Consumo_Constraint;
  update_columns?: Array<_Tipo_Dato_Consumo_Update_Column>;
  where?: InputMaybe<_Tipo_Dato_Consumo_Bool_Exp>;
};

/** Ordering options when selecting data from "_tipo_dato_consumo". */
export type _Tipo_Dato_Consumo_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: _tipo_dato_consumo */
export type _Tipo_Dato_Consumo_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "_tipo_dato_consumo" */
export enum _Tipo_Dato_Consumo_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "_tipo_dato_consumo" */
export type _Tipo_Dato_Consumo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: _Tipo_Dato_Consumo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _Tipo_Dato_Consumo_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "_tipo_dato_consumo" */
export enum _Tipo_Dato_Consumo_Update_Column {
  /** column name */
  Text = 'text'
}

export type _Tipo_Dato_Consumo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_Tipo_Dato_Consumo_Set_Input>;
  /** filter the rows which have to be updated */
  where: _Tipo_Dato_Consumo_Bool_Exp;
};

/** columns and relationships of "_tipologia_profilo" */
export type _Tipologia_Profilo = {
  __typename?: '_tipologia_profilo';
  value: Scalars['String']['output'];
};

/** aggregated selection of "_tipologia_profilo" */
export type _Tipologia_Profilo_Aggregate = {
  __typename?: '_tipologia_profilo_aggregate';
  aggregate?: Maybe<_Tipologia_Profilo_Aggregate_Fields>;
  nodes: Array<_Tipologia_Profilo>;
};

/** aggregate fields of "_tipologia_profilo" */
export type _Tipologia_Profilo_Aggregate_Fields = {
  __typename?: '_tipologia_profilo_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<_Tipologia_Profilo_Max_Fields>;
  min?: Maybe<_Tipologia_Profilo_Min_Fields>;
};


/** aggregate fields of "_tipologia_profilo" */
export type _Tipologia_Profilo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<_Tipologia_Profilo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "_tipologia_profilo". All fields are combined with a logical 'AND'. */
export type _Tipologia_Profilo_Bool_Exp = {
  _and?: InputMaybe<Array<_Tipologia_Profilo_Bool_Exp>>;
  _not?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
  _or?: InputMaybe<Array<_Tipologia_Profilo_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "_tipologia_profilo" */
export enum _Tipologia_Profilo_Constraint {
  /** unique or primary key constraint on columns "value" */
  TipologiaProfiloPkey = 'tipologia_profilo_pkey'
}

export enum _Tipologia_Profilo_Enum {
  Bolletta = 'bolletta',
  Founder = 'founder',
  Installatore = 'installatore',
  Prosumer = 'prosumer',
  Superadmin = 'superadmin',
  Tecnico = 'tecnico'
}

/** Boolean expression to compare columns of type "_tipologia_profilo_enum". All fields are combined with logical 'AND'. */
export type _Tipologia_Profilo_Enum_Comparison_Exp = {
  _eq?: InputMaybe<_Tipologia_Profilo_Enum>;
  _in?: InputMaybe<Array<_Tipologia_Profilo_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<_Tipologia_Profilo_Enum>;
  _nin?: InputMaybe<Array<_Tipologia_Profilo_Enum>>;
};

/** input type for inserting data into table "_tipologia_profilo" */
export type _Tipologia_Profilo_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type _Tipologia_Profilo_Max_Fields = {
  __typename?: '_tipologia_profilo_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type _Tipologia_Profilo_Min_Fields = {
  __typename?: '_tipologia_profilo_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "_tipologia_profilo" */
export type _Tipologia_Profilo_Mutation_Response = {
  __typename?: '_tipologia_profilo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<_Tipologia_Profilo>;
};

/** input type for inserting object relation for remote table "_tipologia_profilo" */
export type _Tipologia_Profilo_Obj_Rel_Insert_Input = {
  data: _Tipologia_Profilo_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<_Tipologia_Profilo_On_Conflict>;
};

/** on_conflict condition type for table "_tipologia_profilo" */
export type _Tipologia_Profilo_On_Conflict = {
  constraint: _Tipologia_Profilo_Constraint;
  update_columns?: Array<_Tipologia_Profilo_Update_Column>;
  where?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
};

/** Ordering options when selecting data from "_tipologia_profilo". */
export type _Tipologia_Profilo_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: _tipologia_profilo */
export type _Tipologia_Profilo_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "_tipologia_profilo" */
export enum _Tipologia_Profilo_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "_tipologia_profilo" */
export type _Tipologia_Profilo_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "_tipologia_profilo" */
export type _Tipologia_Profilo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: _Tipologia_Profilo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type _Tipologia_Profilo_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "_tipologia_profilo" */
export enum _Tipologia_Profilo_Update_Column {
  /** column name */
  Value = 'value'
}

export type _Tipologia_Profilo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<_Tipologia_Profilo_Set_Input>;
  /** filter the rows which have to be updated */
  where: _Tipologia_Profilo_Bool_Exp;
};

export type Abilita_Richieste_Args = {
  cerid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione = {
  __typename?: 'admin__stato_richiesta_pubblicazione';
  stato: Scalars['String']['output'];
};

/** aggregated selection of "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_Aggregate = {
  __typename?: 'admin__stato_richiesta_pubblicazione_aggregate';
  aggregate?: Maybe<Admin__Stato_Richiesta_Pubblicazione_Aggregate_Fields>;
  nodes: Array<Admin__Stato_Richiesta_Pubblicazione>;
};

/** aggregate fields of "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_Aggregate_Fields = {
  __typename?: 'admin__stato_richiesta_pubblicazione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin__Stato_Richiesta_Pubblicazione_Max_Fields>;
  min?: Maybe<Admin__Stato_Richiesta_Pubblicazione_Min_Fields>;
};


/** aggregate fields of "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin._stato_richiesta_pubblicazione". All fields are combined with a logical 'AND'. */
export type Admin__Stato_Richiesta_Pubblicazione_Bool_Exp = {
  _and?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>>;
  _not?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>;
  _or?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>>;
  stato?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin._stato_richiesta_pubblicazione" */
export enum Admin__Stato_Richiesta_Pubblicazione_Constraint {
  /** unique or primary key constraint on columns "stato" */
  _StatoRichiestaPubblicazionePkey = '_stato_richiesta_pubblicazione_pkey'
}

export enum Admin__Stato_Richiesta_Pubblicazione_Enum {
  Accettata = 'accettata',
  Inviata = 'inviata'
}

/** Boolean expression to compare columns of type "admin__stato_richiesta_pubblicazione_enum". All fields are combined with logical 'AND'. */
export type Admin__Stato_Richiesta_Pubblicazione_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Enum>;
  _in?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Enum>;
  _nin?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Enum>>;
};

/** input type for inserting data into table "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_Insert_Input = {
  stato?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Admin__Stato_Richiesta_Pubblicazione_Max_Fields = {
  __typename?: 'admin__stato_richiesta_pubblicazione_max_fields';
  stato?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Admin__Stato_Richiesta_Pubblicazione_Min_Fields = {
  __typename?: 'admin__stato_richiesta_pubblicazione_min_fields';
  stato?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_Mutation_Response = {
  __typename?: 'admin__stato_richiesta_pubblicazione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin__Stato_Richiesta_Pubblicazione>;
};

/** on_conflict condition type for table "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_On_Conflict = {
  constraint: Admin__Stato_Richiesta_Pubblicazione_Constraint;
  update_columns?: Array<Admin__Stato_Richiesta_Pubblicazione_Update_Column>;
  where?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>;
};

/** Ordering options when selecting data from "admin._stato_richiesta_pubblicazione". */
export type Admin__Stato_Richiesta_Pubblicazione_Order_By = {
  stato?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin._stato_richiesta_pubblicazione */
export type Admin__Stato_Richiesta_Pubblicazione_Pk_Columns_Input = {
  stato: Scalars['String']['input'];
};

/** select columns of table "admin._stato_richiesta_pubblicazione" */
export enum Admin__Stato_Richiesta_Pubblicazione_Select_Column {
  /** column name */
  Stato = 'stato'
}

/** input type for updating data in table "admin._stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_Set_Input = {
  stato?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "admin__stato_richiesta_pubblicazione" */
export type Admin__Stato_Richiesta_Pubblicazione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin__Stato_Richiesta_Pubblicazione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin__Stato_Richiesta_Pubblicazione_Stream_Cursor_Value_Input = {
  stato?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "admin._stato_richiesta_pubblicazione" */
export enum Admin__Stato_Richiesta_Pubblicazione_Update_Column {
  /** column name */
  Stato = 'stato'
}

export type Admin__Stato_Richiesta_Pubblicazione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin__Stato_Richiesta_Pubblicazione_Bool_Exp;
};

/** columns and relationships of "admin._type_referral" */
export type Admin__Type_Referral = {
  __typename?: 'admin__type_referral';
  text: Scalars['String']['output'];
};

/** aggregated selection of "admin._type_referral" */
export type Admin__Type_Referral_Aggregate = {
  __typename?: 'admin__type_referral_aggregate';
  aggregate?: Maybe<Admin__Type_Referral_Aggregate_Fields>;
  nodes: Array<Admin__Type_Referral>;
};

/** aggregate fields of "admin._type_referral" */
export type Admin__Type_Referral_Aggregate_Fields = {
  __typename?: 'admin__type_referral_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin__Type_Referral_Max_Fields>;
  min?: Maybe<Admin__Type_Referral_Min_Fields>;
};


/** aggregate fields of "admin._type_referral" */
export type Admin__Type_Referral_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin__Type_Referral_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin._type_referral". All fields are combined with a logical 'AND'. */
export type Admin__Type_Referral_Bool_Exp = {
  _and?: InputMaybe<Array<Admin__Type_Referral_Bool_Exp>>;
  _not?: InputMaybe<Admin__Type_Referral_Bool_Exp>;
  _or?: InputMaybe<Array<Admin__Type_Referral_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin._type_referral" */
export enum Admin__Type_Referral_Constraint {
  /** unique or primary key constraint on columns "text" */
  _TypeReferralPkey = '_type_referral_pkey'
}

export enum Admin__Type_Referral_Enum {
  Campagna = 'campagna',
  Utente = 'utente'
}

/** Boolean expression to compare columns of type "admin__type_referral_enum". All fields are combined with logical 'AND'. */
export type Admin__Type_Referral_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Admin__Type_Referral_Enum>;
  _in?: InputMaybe<Array<Admin__Type_Referral_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Admin__Type_Referral_Enum>;
  _nin?: InputMaybe<Array<Admin__Type_Referral_Enum>>;
};

/** input type for inserting data into table "admin._type_referral" */
export type Admin__Type_Referral_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Admin__Type_Referral_Max_Fields = {
  __typename?: 'admin__type_referral_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Admin__Type_Referral_Min_Fields = {
  __typename?: 'admin__type_referral_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "admin._type_referral" */
export type Admin__Type_Referral_Mutation_Response = {
  __typename?: 'admin__type_referral_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin__Type_Referral>;
};

/** on_conflict condition type for table "admin._type_referral" */
export type Admin__Type_Referral_On_Conflict = {
  constraint: Admin__Type_Referral_Constraint;
  update_columns?: Array<Admin__Type_Referral_Update_Column>;
  where?: InputMaybe<Admin__Type_Referral_Bool_Exp>;
};

/** Ordering options when selecting data from "admin._type_referral". */
export type Admin__Type_Referral_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin._type_referral */
export type Admin__Type_Referral_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "admin._type_referral" */
export enum Admin__Type_Referral_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "admin._type_referral" */
export type Admin__Type_Referral_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "admin__type_referral" */
export type Admin__Type_Referral_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin__Type_Referral_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin__Type_Referral_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "admin._type_referral" */
export enum Admin__Type_Referral_Update_Column {
  /** column name */
  Text = 'text'
}

export type Admin__Type_Referral_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin__Type_Referral_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin__Type_Referral_Bool_Exp;
};

/** columns and relationships of "admin.consenso_privacy" */
export type Admin_Consenso_Privacy = {
  __typename?: 'admin_consenso_privacy';
  auth_id?: Maybe<Scalars['String']['output']>;
  comunicazioni_commerciali?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  indagini_soddisfazione?: Maybe<Scalars['Boolean']['output']>;
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  sondaggi_statistici?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Aggregate = {
  __typename?: 'admin_consenso_privacy_aggregate';
  aggregate?: Maybe<Admin_Consenso_Privacy_Aggregate_Fields>;
  nodes: Array<Admin_Consenso_Privacy>;
};

export type Admin_Consenso_Privacy_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Admin_Consenso_Privacy_Aggregate_Bool_Exp_Count>;
};

export type Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_And = {
  arguments: Admin_Consenso_Privacy_Select_Column_Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Admin_Consenso_Privacy_Select_Column_Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Admin_Consenso_Privacy_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Aggregate_Fields = {
  __typename?: 'admin_consenso_privacy_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Consenso_Privacy_Max_Fields>;
  min?: Maybe<Admin_Consenso_Privacy_Min_Fields>;
};


/** aggregate fields of "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Admin_Consenso_Privacy_Max_Order_By>;
  min?: InputMaybe<Admin_Consenso_Privacy_Min_Order_By>;
};

/** input type for inserting array relation for remote table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Arr_Rel_Insert_Input = {
  data: Array<Admin_Consenso_Privacy_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_Consenso_Privacy_On_Conflict>;
};

/** Boolean expression to filter rows from the table "admin.consenso_privacy". All fields are combined with a logical 'AND'. */
export type Admin_Consenso_Privacy_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Consenso_Privacy_Bool_Exp>>;
  _not?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Consenso_Privacy_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  comunicazioni_commerciali?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indagini_soddisfazione?: InputMaybe<Boolean_Comparison_Exp>;
  newsletter?: InputMaybe<Boolean_Comparison_Exp>;
  sondaggi_statistici?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin.consenso_privacy" */
export enum Admin_Consenso_Privacy_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConsensoPrivacyPkey = 'consenso_privacy_pkey'
}

/** input type for inserting data into table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  comunicazioni_commerciali?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indagini_soddisfazione?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  sondaggi_statistici?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Admin_Consenso_Privacy_Max_Fields = {
  __typename?: 'admin_consenso_privacy_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Max_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Admin_Consenso_Privacy_Min_Fields = {
  __typename?: 'admin_consenso_privacy_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Min_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Mutation_Response = {
  __typename?: 'admin_consenso_privacy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Consenso_Privacy>;
};

/** on_conflict condition type for table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_On_Conflict = {
  constraint: Admin_Consenso_Privacy_Constraint;
  update_columns?: Array<Admin_Consenso_Privacy_Update_Column>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};

/** Ordering options when selecting data from "admin.consenso_privacy". */
export type Admin_Consenso_Privacy_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  comunicazioni_commerciali?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indagini_soddisfazione?: InputMaybe<Order_By>;
  newsletter?: InputMaybe<Order_By>;
  sondaggi_statistici?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin.consenso_privacy */
export type Admin_Consenso_Privacy_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin.consenso_privacy" */
export enum Admin_Consenso_Privacy_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ComunicazioniCommerciali = 'comunicazioni_commerciali',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndaginiSoddisfazione = 'indagini_soddisfazione',
  /** column name */
  Newsletter = 'newsletter',
  /** column name */
  SondaggiStatistici = 'sondaggi_statistici',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "admin_consenso_privacy_aggregate_bool_exp_bool_and_arguments_columns" columns of table "admin.consenso_privacy" */
export enum Admin_Consenso_Privacy_Select_Column_Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ComunicazioniCommerciali = 'comunicazioni_commerciali',
  /** column name */
  IndaginiSoddisfazione = 'indagini_soddisfazione',
  /** column name */
  Newsletter = 'newsletter',
  /** column name */
  SondaggiStatistici = 'sondaggi_statistici'
}

/** select "admin_consenso_privacy_aggregate_bool_exp_bool_or_arguments_columns" columns of table "admin.consenso_privacy" */
export enum Admin_Consenso_Privacy_Select_Column_Admin_Consenso_Privacy_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ComunicazioniCommerciali = 'comunicazioni_commerciali',
  /** column name */
  IndaginiSoddisfazione = 'indagini_soddisfazione',
  /** column name */
  Newsletter = 'newsletter',
  /** column name */
  SondaggiStatistici = 'sondaggi_statistici'
}

/** input type for updating data in table "admin.consenso_privacy" */
export type Admin_Consenso_Privacy_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  comunicazioni_commerciali?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indagini_soddisfazione?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  sondaggi_statistici?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "admin_consenso_privacy" */
export type Admin_Consenso_Privacy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Consenso_Privacy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Consenso_Privacy_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  comunicazioni_commerciali?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indagini_soddisfazione?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  sondaggi_statistici?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "admin.consenso_privacy" */
export enum Admin_Consenso_Privacy_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ComunicazioniCommerciali = 'comunicazioni_commerciali',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndaginiSoddisfazione = 'indagini_soddisfazione',
  /** column name */
  Newsletter = 'newsletter',
  /** column name */
  SondaggiStatistici = 'sondaggi_statistici',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Admin_Consenso_Privacy_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Consenso_Privacy_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Consenso_Privacy_Bool_Exp;
};

/** columns and relationships of "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi = {
  __typename?: 'admin_parametri_algoritmo_incentivi';
  anno: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  dati_mercato: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  parametri_fissati: Scalars['jsonb']['output'];
  parametri_legge: Scalars['jsonb']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_IncentiviDati_MercatoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_IncentiviParametri_FissatiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_IncentiviParametri_LeggeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_Aggregate = {
  __typename?: 'admin_parametri_algoritmo_incentivi_aggregate';
  aggregate?: Maybe<Admin_Parametri_Algoritmo_Incentivi_Aggregate_Fields>;
  nodes: Array<Admin_Parametri_Algoritmo_Incentivi>;
};

/** aggregate fields of "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_Aggregate_Fields = {
  __typename?: 'admin_parametri_algoritmo_incentivi_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Parametri_Algoritmo_Incentivi_Max_Fields>;
  min?: Maybe<Admin_Parametri_Algoritmo_Incentivi_Min_Fields>;
};


/** aggregate fields of "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Admin_Parametri_Algoritmo_Incentivi_Append_Input = {
  dati_mercato?: InputMaybe<Scalars['jsonb']['input']>;
  parametri_fissati?: InputMaybe<Scalars['jsonb']['input']>;
  parametri_legge?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "admin.parametri_algoritmo_incentivi". All fields are combined with a logical 'AND'. */
export type Admin_Parametri_Algoritmo_Incentivi_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>>;
  _not?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>>;
  anno?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dati_mercato?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parametri_fissati?: InputMaybe<Jsonb_Comparison_Exp>;
  parametri_legge?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin.parametri_algoritmo_incentivi" */
export enum Admin_Parametri_Algoritmo_Incentivi_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParametriAlgoritmoIncentiviPkey = 'parametri_algoritmo_incentivi_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Admin_Parametri_Algoritmo_Incentivi_Delete_At_Path_Input = {
  dati_mercato?: InputMaybe<Array<Scalars['String']['input']>>;
  parametri_fissati?: InputMaybe<Array<Scalars['String']['input']>>;
  parametri_legge?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Admin_Parametri_Algoritmo_Incentivi_Delete_Elem_Input = {
  dati_mercato?: InputMaybe<Scalars['Int']['input']>;
  parametri_fissati?: InputMaybe<Scalars['Int']['input']>;
  parametri_legge?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Admin_Parametri_Algoritmo_Incentivi_Delete_Key_Input = {
  dati_mercato?: InputMaybe<Scalars['String']['input']>;
  parametri_fissati?: InputMaybe<Scalars['String']['input']>;
  parametri_legge?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_Insert_Input = {
  anno?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dati_mercato?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parametri_fissati?: InputMaybe<Scalars['jsonb']['input']>;
  parametri_legge?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Admin_Parametri_Algoritmo_Incentivi_Max_Fields = {
  __typename?: 'admin_parametri_algoritmo_incentivi_max_fields';
  anno?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Admin_Parametri_Algoritmo_Incentivi_Min_Fields = {
  __typename?: 'admin_parametri_algoritmo_incentivi_min_fields';
  anno?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_Mutation_Response = {
  __typename?: 'admin_parametri_algoritmo_incentivi_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Parametri_Algoritmo_Incentivi>;
};

/** on_conflict condition type for table "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_On_Conflict = {
  constraint: Admin_Parametri_Algoritmo_Incentivi_Constraint;
  update_columns?: Array<Admin_Parametri_Algoritmo_Incentivi_Update_Column>;
  where?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>;
};

/** Ordering options when selecting data from "admin.parametri_algoritmo_incentivi". */
export type Admin_Parametri_Algoritmo_Incentivi_Order_By = {
  anno?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dati_mercato?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parametri_fissati?: InputMaybe<Order_By>;
  parametri_legge?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin.parametri_algoritmo_incentivi */
export type Admin_Parametri_Algoritmo_Incentivi_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Admin_Parametri_Algoritmo_Incentivi_Prepend_Input = {
  dati_mercato?: InputMaybe<Scalars['jsonb']['input']>;
  parametri_fissati?: InputMaybe<Scalars['jsonb']['input']>;
  parametri_legge?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "admin.parametri_algoritmo_incentivi" */
export enum Admin_Parametri_Algoritmo_Incentivi_Select_Column {
  /** column name */
  Anno = 'anno',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatiMercato = 'dati_mercato',
  /** column name */
  Id = 'id',
  /** column name */
  ParametriFissati = 'parametri_fissati',
  /** column name */
  ParametriLegge = 'parametri_legge',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "admin.parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_Set_Input = {
  anno?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dati_mercato?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parametri_fissati?: InputMaybe<Scalars['jsonb']['input']>;
  parametri_legge?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "admin_parametri_algoritmo_incentivi" */
export type Admin_Parametri_Algoritmo_Incentivi_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Parametri_Algoritmo_Incentivi_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Parametri_Algoritmo_Incentivi_Stream_Cursor_Value_Input = {
  anno?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dati_mercato?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parametri_fissati?: InputMaybe<Scalars['jsonb']['input']>;
  parametri_legge?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "admin.parametri_algoritmo_incentivi" */
export enum Admin_Parametri_Algoritmo_Incentivi_Update_Column {
  /** column name */
  Anno = 'anno',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatiMercato = 'dati_mercato',
  /** column name */
  Id = 'id',
  /** column name */
  ParametriFissati = 'parametri_fissati',
  /** column name */
  ParametriLegge = 'parametri_legge',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Admin_Parametri_Algoritmo_Incentivi_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Parametri_Algoritmo_Incentivi_Bool_Exp;
};

/** columns and relationships of "admin.referral" */
export type Admin_Referral = {
  __typename?: 'admin_referral';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: Admin__Type_Referral_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_entity?: Maybe<Auth_User_Entity>;
};

/** aggregated selection of "admin.referral" */
export type Admin_Referral_Aggregate = {
  __typename?: 'admin_referral_aggregate';
  aggregate?: Maybe<Admin_Referral_Aggregate_Fields>;
  nodes: Array<Admin_Referral>;
};

/** aggregate fields of "admin.referral" */
export type Admin_Referral_Aggregate_Fields = {
  __typename?: 'admin_referral_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Referral_Max_Fields>;
  min?: Maybe<Admin_Referral_Min_Fields>;
};


/** aggregate fields of "admin.referral" */
export type Admin_Referral_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Referral_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin.referral". All fields are combined with a logical 'AND'. */
export type Admin_Referral_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Referral_Bool_Exp>>;
  _not?: InputMaybe<Admin_Referral_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Referral_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Admin__Type_Referral_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_entity?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};

/** unique or primary key constraints on table "admin.referral" */
export enum Admin_Referral_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReferralPkey = 'referral_pkey'
}

/** input type for inserting data into table "admin.referral" */
export type Admin_Referral_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Admin__Type_Referral_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_entity?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Admin_Referral_Max_Fields = {
  __typename?: 'admin_referral_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Admin_Referral_Min_Fields = {
  __typename?: 'admin_referral_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "admin.referral" */
export type Admin_Referral_Mutation_Response = {
  __typename?: 'admin_referral_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Referral>;
};

/** input type for inserting object relation for remote table "admin.referral" */
export type Admin_Referral_Obj_Rel_Insert_Input = {
  data: Admin_Referral_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_Referral_On_Conflict>;
};

/** on_conflict condition type for table "admin.referral" */
export type Admin_Referral_On_Conflict = {
  constraint: Admin_Referral_Constraint;
  update_columns?: Array<Admin_Referral_Update_Column>;
  where?: InputMaybe<Admin_Referral_Bool_Exp>;
};

/** Ordering options when selecting data from "admin.referral". */
export type Admin_Referral_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_entity?: InputMaybe<Auth_User_Entity_Order_By>;
};

/** primary key columns input for table: admin.referral */
export type Admin_Referral_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin.referral" */
export enum Admin_Referral_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "admin.referral" */
export type Admin_Referral_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Admin__Type_Referral_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "admin_referral" */
export type Admin_Referral_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Referral_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Referral_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Admin__Type_Referral_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "admin.referral" */
export enum Admin_Referral_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Admin_Referral_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Referral_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Referral_Bool_Exp;
};

/** columns and relationships of "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione = {
  __typename?: 'admin_richiesta_pubblicazione';
  /** An object relationship */
  cer: Cer;
  cer_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  stato: Admin__Stato_Richiesta_Pubblicazione_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Aggregate = {
  __typename?: 'admin_richiesta_pubblicazione_aggregate';
  aggregate?: Maybe<Admin_Richiesta_Pubblicazione_Aggregate_Fields>;
  nodes: Array<Admin_Richiesta_Pubblicazione>;
};

export type Admin_Richiesta_Pubblicazione_Aggregate_Bool_Exp = {
  count?: InputMaybe<Admin_Richiesta_Pubblicazione_Aggregate_Bool_Exp_Count>;
};

export type Admin_Richiesta_Pubblicazione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Aggregate_Fields = {
  __typename?: 'admin_richiesta_pubblicazione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Richiesta_Pubblicazione_Max_Fields>;
  min?: Maybe<Admin_Richiesta_Pubblicazione_Min_Fields>;
};


/** aggregate fields of "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Admin_Richiesta_Pubblicazione_Max_Order_By>;
  min?: InputMaybe<Admin_Richiesta_Pubblicazione_Min_Order_By>;
};

/** input type for inserting array relation for remote table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Arr_Rel_Insert_Input = {
  data: Array<Admin_Richiesta_Pubblicazione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_Richiesta_Pubblicazione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "admin.richiesta_pubblicazione". All fields are combined with a logical 'AND'. */
export type Admin_Richiesta_Pubblicazione_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Bool_Exp>>;
  _not?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Bool_Exp>>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin.richiesta_pubblicazione" */
export enum Admin_Richiesta_Pubblicazione_Constraint {
  /** unique or primary key constraint on columns "id" */
  RichiestaPubblicazionePkey = 'richiesta_pubblicazione_pkey'
}

/** input type for inserting data into table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Insert_Input = {
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Admin_Richiesta_Pubblicazione_Max_Fields = {
  __typename?: 'admin_richiesta_pubblicazione_max_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Max_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Admin_Richiesta_Pubblicazione_Min_Fields = {
  __typename?: 'admin_richiesta_pubblicazione_min_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Min_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Mutation_Response = {
  __typename?: 'admin_richiesta_pubblicazione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Richiesta_Pubblicazione>;
};

/** on_conflict condition type for table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_On_Conflict = {
  constraint: Admin_Richiesta_Pubblicazione_Constraint;
  update_columns?: Array<Admin_Richiesta_Pubblicazione_Update_Column>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};

/** Ordering options when selecting data from "admin.richiesta_pubblicazione". */
export type Admin_Richiesta_Pubblicazione_Order_By = {
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin.richiesta_pubblicazione */
export type Admin_Richiesta_Pubblicazione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin.richiesta_pubblicazione" */
export enum Admin_Richiesta_Pubblicazione_Select_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "admin.richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Set_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "admin_richiesta_pubblicazione" */
export type Admin_Richiesta_Pubblicazione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Richiesta_Pubblicazione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Richiesta_Pubblicazione_Stream_Cursor_Value_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "admin.richiesta_pubblicazione" */
export enum Admin_Richiesta_Pubblicazione_Update_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Admin_Richiesta_Pubblicazione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Richiesta_Pubblicazione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Richiesta_Pubblicazione_Bool_Exp;
};

/** columns and relationships of "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral = {
  __typename?: 'admin_utilizzo_referral';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  nuovo_utente?: Maybe<Auth_User_Entity>;
  /** An object relationship */
  referral: Admin_Referral;
  referral_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral_Aggregate = {
  __typename?: 'admin_utilizzo_referral_aggregate';
  aggregate?: Maybe<Admin_Utilizzo_Referral_Aggregate_Fields>;
  nodes: Array<Admin_Utilizzo_Referral>;
};

/** aggregate fields of "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral_Aggregate_Fields = {
  __typename?: 'admin_utilizzo_referral_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_Utilizzo_Referral_Max_Fields>;
  min?: Maybe<Admin_Utilizzo_Referral_Min_Fields>;
};


/** aggregate fields of "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Utilizzo_Referral_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin.utilizzo_referral". All fields are combined with a logical 'AND'. */
export type Admin_Utilizzo_Referral_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Utilizzo_Referral_Bool_Exp>>;
  _not?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Utilizzo_Referral_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nuovo_utente?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  referral?: InputMaybe<Admin_Referral_Bool_Exp>;
  referral_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin.utilizzo_referral" */
export enum Admin_Utilizzo_Referral_Constraint {
  /** unique or primary key constraint on columns "id" */
  UtilizzoReferralPkey = 'utilizzo_referral_pkey'
}

/** input type for inserting data into table "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nuovo_utente?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
  referral?: InputMaybe<Admin_Referral_Obj_Rel_Insert_Input>;
  referral_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Admin_Utilizzo_Referral_Max_Fields = {
  __typename?: 'admin_utilizzo_referral_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referral_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Admin_Utilizzo_Referral_Min_Fields = {
  __typename?: 'admin_utilizzo_referral_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referral_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral_Mutation_Response = {
  __typename?: 'admin_utilizzo_referral_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Utilizzo_Referral>;
};

/** on_conflict condition type for table "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral_On_Conflict = {
  constraint: Admin_Utilizzo_Referral_Constraint;
  update_columns?: Array<Admin_Utilizzo_Referral_Update_Column>;
  where?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
};

/** Ordering options when selecting data from "admin.utilizzo_referral". */
export type Admin_Utilizzo_Referral_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nuovo_utente?: InputMaybe<Auth_User_Entity_Order_By>;
  referral?: InputMaybe<Admin_Referral_Order_By>;
  referral_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin.utilizzo_referral */
export type Admin_Utilizzo_Referral_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin.utilizzo_referral" */
export enum Admin_Utilizzo_Referral_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReferralId = 'referral_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "admin.utilizzo_referral" */
export type Admin_Utilizzo_Referral_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referral_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "admin_utilizzo_referral" */
export type Admin_Utilizzo_Referral_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Utilizzo_Referral_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Utilizzo_Referral_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  referral_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "admin.utilizzo_referral" */
export enum Admin_Utilizzo_Referral_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReferralId = 'referral_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Admin_Utilizzo_Referral_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Utilizzo_Referral_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Utilizzo_Referral_Bool_Exp;
};

/** columns and relationships of "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco = {
  __typename?: 'anagrafica_codice_ateco';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_Aggregate = {
  __typename?: 'anagrafica_codice_ateco_aggregate';
  aggregate?: Maybe<Anagrafica_Codice_Ateco_Aggregate_Fields>;
  nodes: Array<Anagrafica_Codice_Ateco>;
};

/** aggregate fields of "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_Aggregate_Fields = {
  __typename?: 'anagrafica_codice_ateco_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Anagrafica_Codice_Ateco_Max_Fields>;
  min?: Maybe<Anagrafica_Codice_Ateco_Min_Fields>;
};


/** aggregate fields of "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anagrafica_Codice_Ateco_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "anagrafica.codice_ateco". All fields are combined with a logical 'AND'. */
export type Anagrafica_Codice_Ateco_Bool_Exp = {
  _and?: InputMaybe<Array<Anagrafica_Codice_Ateco_Bool_Exp>>;
  _not?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
  _or?: InputMaybe<Array<Anagrafica_Codice_Ateco_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "anagrafica.codice_ateco" */
export enum Anagrafica_Codice_Ateco_Constraint {
  /** unique or primary key constraint on columns "id" */
  CodiceAtecoPkey = 'codice_ateco_pkey'
}

/** input type for inserting data into table "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Anagrafica_Codice_Ateco_Max_Fields = {
  __typename?: 'anagrafica_codice_ateco_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Anagrafica_Codice_Ateco_Min_Fields = {
  __typename?: 'anagrafica_codice_ateco_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_Mutation_Response = {
  __typename?: 'anagrafica_codice_ateco_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anagrafica_Codice_Ateco>;
};

/** input type for inserting object relation for remote table "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_Obj_Rel_Insert_Input = {
  data: Anagrafica_Codice_Ateco_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anagrafica_Codice_Ateco_On_Conflict>;
};

/** on_conflict condition type for table "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_On_Conflict = {
  constraint: Anagrafica_Codice_Ateco_Constraint;
  update_columns?: Array<Anagrafica_Codice_Ateco_Update_Column>;
  where?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
};

/** Ordering options when selecting data from "anagrafica.codice_ateco". */
export type Anagrafica_Codice_Ateco_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anagrafica.codice_ateco */
export type Anagrafica_Codice_Ateco_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "anagrafica.codice_ateco" */
export enum Anagrafica_Codice_Ateco_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "anagrafica.codice_ateco" */
export type Anagrafica_Codice_Ateco_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "anagrafica_codice_ateco" */
export type Anagrafica_Codice_Ateco_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anagrafica_Codice_Ateco_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anagrafica_Codice_Ateco_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "anagrafica.codice_ateco" */
export enum Anagrafica_Codice_Ateco_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Anagrafica_Codice_Ateco_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anagrafica_Codice_Ateco_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anagrafica_Codice_Ateco_Bool_Exp;
};

/** columns and relationships of "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica = {
  __typename?: 'anagrafica_forma_giuridica';
  accesso_eccedentario: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "anagrafica.forma_giuridica_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  rules?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_GiuridicaRulesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Aggregate = {
  __typename?: 'anagrafica_forma_giuridica_aggregate';
  aggregate?: Maybe<Anagrafica_Forma_Giuridica_Aggregate_Fields>;
  nodes: Array<Anagrafica_Forma_Giuridica>;
};

/** aggregate fields of "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Aggregate_Fields = {
  __typename?: 'anagrafica_forma_giuridica_aggregate_fields';
  avg?: Maybe<Anagrafica_Forma_Giuridica_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anagrafica_Forma_Giuridica_Max_Fields>;
  min?: Maybe<Anagrafica_Forma_Giuridica_Min_Fields>;
  stddev?: Maybe<Anagrafica_Forma_Giuridica_Stddev_Fields>;
  stddev_pop?: Maybe<Anagrafica_Forma_Giuridica_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anagrafica_Forma_Giuridica_Stddev_Samp_Fields>;
  sum?: Maybe<Anagrafica_Forma_Giuridica_Sum_Fields>;
  var_pop?: Maybe<Anagrafica_Forma_Giuridica_Var_Pop_Fields>;
  var_samp?: Maybe<Anagrafica_Forma_Giuridica_Var_Samp_Fields>;
  variance?: Maybe<Anagrafica_Forma_Giuridica_Variance_Fields>;
};


/** aggregate fields of "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Anagrafica_Forma_Giuridica_Append_Input = {
  rules?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Anagrafica_Forma_Giuridica_Avg_Fields = {
  __typename?: 'anagrafica_forma_giuridica_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "anagrafica.forma_giuridica". All fields are combined with a logical 'AND'. */
export type Anagrafica_Forma_Giuridica_Bool_Exp = {
  _and?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Bool_Exp>>;
  _not?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
  _or?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Bool_Exp>>;
  accesso_eccedentario?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  rules?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer = {
  __typename?: 'anagrafica_forma_giuridica_cer';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "anagrafica.forma_giuridica_cer_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Aggregate = {
  __typename?: 'anagrafica_forma_giuridica_cer_aggregate';
  aggregate?: Maybe<Anagrafica_Forma_Giuridica_Cer_Aggregate_Fields>;
  nodes: Array<Anagrafica_Forma_Giuridica_Cer>;
};

/** aggregate fields of "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Aggregate_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_aggregate_fields';
  avg?: Maybe<Anagrafica_Forma_Giuridica_Cer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anagrafica_Forma_Giuridica_Cer_Max_Fields>;
  min?: Maybe<Anagrafica_Forma_Giuridica_Cer_Min_Fields>;
  stddev?: Maybe<Anagrafica_Forma_Giuridica_Cer_Stddev_Fields>;
  stddev_pop?: Maybe<Anagrafica_Forma_Giuridica_Cer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anagrafica_Forma_Giuridica_Cer_Stddev_Samp_Fields>;
  sum?: Maybe<Anagrafica_Forma_Giuridica_Cer_Sum_Fields>;
  var_pop?: Maybe<Anagrafica_Forma_Giuridica_Cer_Var_Pop_Fields>;
  var_samp?: Maybe<Anagrafica_Forma_Giuridica_Cer_Var_Samp_Fields>;
  variance?: Maybe<Anagrafica_Forma_Giuridica_Cer_Variance_Fields>;
};


/** aggregate fields of "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Anagrafica_Forma_Giuridica_Cer_Avg_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "anagrafica.forma_giuridica_cer". All fields are combined with a logical 'AND'. */
export type Anagrafica_Forma_Giuridica_Cer_Bool_Exp = {
  _and?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>>;
  _not?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
  _or?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "anagrafica.forma_giuridica_cer" */
export enum Anagrafica_Forma_Giuridica_Cer_Constraint {
  /** unique or primary key constraint on columns "id" */
  FormaGiuridicaCerPkey = 'forma_giuridica_cer_pkey'
}

/** input type for incrementing numeric columns in table "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Anagrafica_Forma_Giuridica_Cer_Max_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.forma_giuridica_cer_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Anagrafica_Forma_Giuridica_Cer_Min_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.forma_giuridica_cer_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Mutation_Response = {
  __typename?: 'anagrafica_forma_giuridica_cer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anagrafica_Forma_Giuridica_Cer>;
};

/** input type for inserting object relation for remote table "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Obj_Rel_Insert_Input = {
  data: Anagrafica_Forma_Giuridica_Cer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_On_Conflict>;
};

/** on_conflict condition type for table "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_On_Conflict = {
  constraint: Anagrafica_Forma_Giuridica_Cer_Constraint;
  update_columns?: Array<Anagrafica_Forma_Giuridica_Cer_Update_Column>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
};

/** Ordering options when selecting data from "anagrafica.forma_giuridica_cer". */
export type Anagrafica_Forma_Giuridica_Cer_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anagrafica.forma_giuridica_cer */
export type Anagrafica_Forma_Giuridica_Cer_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "anagrafica.forma_giuridica_cer" */
export enum Anagrafica_Forma_Giuridica_Cer_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "anagrafica.forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Anagrafica_Forma_Giuridica_Cer_Stddev_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Anagrafica_Forma_Giuridica_Cer_Stddev_Pop_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Anagrafica_Forma_Giuridica_Cer_Stddev_Samp_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "anagrafica_forma_giuridica_cer" */
export type Anagrafica_Forma_Giuridica_Cer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anagrafica_Forma_Giuridica_Cer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anagrafica_Forma_Giuridica_Cer_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Anagrafica_Forma_Giuridica_Cer_Sum_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "anagrafica.forma_giuridica_cer" */
export enum Anagrafica_Forma_Giuridica_Cer_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Anagrafica_Forma_Giuridica_Cer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anagrafica_Forma_Giuridica_Cer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anagrafica_Forma_Giuridica_Cer_Var_Pop_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Anagrafica_Forma_Giuridica_Cer_Var_Samp_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Anagrafica_Forma_Giuridica_Cer_Variance_Fields = {
  __typename?: 'anagrafica_forma_giuridica_cer_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "anagrafica.forma_giuridica" */
export enum Anagrafica_Forma_Giuridica_Constraint {
  /** unique or primary key constraint on columns "id" */
  FormaGiuridicaPkey = 'forma_giuridica_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Anagrafica_Forma_Giuridica_Delete_At_Path_Input = {
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Anagrafica_Forma_Giuridica_Delete_Elem_Input = {
  rules?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Anagrafica_Forma_Giuridica_Delete_Key_Input = {
  rules?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Insert_Input = {
  accesso_eccedentario?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Anagrafica_Forma_Giuridica_Max_Fields = {
  __typename?: 'anagrafica_forma_giuridica_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.forma_giuridica_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Anagrafica_Forma_Giuridica_Min_Fields = {
  __typename?: 'anagrafica_forma_giuridica_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.forma_giuridica_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Mutation_Response = {
  __typename?: 'anagrafica_forma_giuridica_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anagrafica_Forma_Giuridica>;
};

/** input type for inserting object relation for remote table "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Obj_Rel_Insert_Input = {
  data: Anagrafica_Forma_Giuridica_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anagrafica_Forma_Giuridica_On_Conflict>;
};

/** on_conflict condition type for table "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_On_Conflict = {
  constraint: Anagrafica_Forma_Giuridica_Constraint;
  update_columns?: Array<Anagrafica_Forma_Giuridica_Update_Column>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
};

/** Ordering options when selecting data from "anagrafica.forma_giuridica". */
export type Anagrafica_Forma_Giuridica_Order_By = {
  accesso_eccedentario?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rules?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anagrafica.forma_giuridica */
export type Anagrafica_Forma_Giuridica_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Anagrafica_Forma_Giuridica_Prepend_Input = {
  rules?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "anagrafica.forma_giuridica" */
export enum Anagrafica_Forma_Giuridica_Select_Column {
  /** column name */
  AccessoEccedentario = 'accesso_eccedentario',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  Rules = 'rules',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "anagrafica.forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Set_Input = {
  accesso_eccedentario?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Anagrafica_Forma_Giuridica_Stddev_Fields = {
  __typename?: 'anagrafica_forma_giuridica_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Anagrafica_Forma_Giuridica_Stddev_Pop_Fields = {
  __typename?: 'anagrafica_forma_giuridica_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Anagrafica_Forma_Giuridica_Stddev_Samp_Fields = {
  __typename?: 'anagrafica_forma_giuridica_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "anagrafica_forma_giuridica" */
export type Anagrafica_Forma_Giuridica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anagrafica_Forma_Giuridica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anagrafica_Forma_Giuridica_Stream_Cursor_Value_Input = {
  accesso_eccedentario?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Anagrafica_Forma_Giuridica_Sum_Fields = {
  __typename?: 'anagrafica_forma_giuridica_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "anagrafica.forma_giuridica" */
export enum Anagrafica_Forma_Giuridica_Update_Column {
  /** column name */
  AccessoEccedentario = 'accesso_eccedentario',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  Rules = 'rules',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Anagrafica_Forma_Giuridica_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Anagrafica_Forma_Giuridica_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anagrafica_Forma_Giuridica_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Anagrafica_Forma_Giuridica_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anagrafica_Forma_Giuridica_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anagrafica_Forma_Giuridica_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anagrafica_Forma_Giuridica_Var_Pop_Fields = {
  __typename?: 'anagrafica_forma_giuridica_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Anagrafica_Forma_Giuridica_Var_Samp_Fields = {
  __typename?: 'anagrafica_forma_giuridica_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Anagrafica_Forma_Giuridica_Variance_Fields = {
  __typename?: 'anagrafica_forma_giuridica_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto = {
  __typename?: 'anagrafica_tipo_contatto';
  created_at: Scalars['timestamptz']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "anagrafica.tipo_contatto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  validation?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_ContattoValidationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Aggregate = {
  __typename?: 'anagrafica_tipo_contatto_aggregate';
  aggregate?: Maybe<Anagrafica_Tipo_Contatto_Aggregate_Fields>;
  nodes: Array<Anagrafica_Tipo_Contatto>;
};

/** aggregate fields of "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Aggregate_Fields = {
  __typename?: 'anagrafica_tipo_contatto_aggregate_fields';
  avg?: Maybe<Anagrafica_Tipo_Contatto_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anagrafica_Tipo_Contatto_Max_Fields>;
  min?: Maybe<Anagrafica_Tipo_Contatto_Min_Fields>;
  stddev?: Maybe<Anagrafica_Tipo_Contatto_Stddev_Fields>;
  stddev_pop?: Maybe<Anagrafica_Tipo_Contatto_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anagrafica_Tipo_Contatto_Stddev_Samp_Fields>;
  sum?: Maybe<Anagrafica_Tipo_Contatto_Sum_Fields>;
  var_pop?: Maybe<Anagrafica_Tipo_Contatto_Var_Pop_Fields>;
  var_samp?: Maybe<Anagrafica_Tipo_Contatto_Var_Samp_Fields>;
  variance?: Maybe<Anagrafica_Tipo_Contatto_Variance_Fields>;
};


/** aggregate fields of "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Anagrafica_Tipo_Contatto_Append_Input = {
  validation?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Anagrafica_Tipo_Contatto_Avg_Fields = {
  __typename?: 'anagrafica_tipo_contatto_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "anagrafica.tipo_contatto". All fields are combined with a logical 'AND'. */
export type Anagrafica_Tipo_Contatto_Bool_Exp = {
  _and?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Bool_Exp>>;
  _not?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
  _or?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  validation?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "anagrafica.tipo_contatto" */
export enum Anagrafica_Tipo_Contatto_Constraint {
  /** unique or primary key constraint on columns "id" */
  TipoContattoPkey = 'tipo_contatto_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Anagrafica_Tipo_Contatto_Delete_At_Path_Input = {
  validation?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Anagrafica_Tipo_Contatto_Delete_Elem_Input = {
  validation?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Anagrafica_Tipo_Contatto_Delete_Key_Input = {
  validation?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validation?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Anagrafica_Tipo_Contatto_Max_Fields = {
  __typename?: 'anagrafica_tipo_contatto_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.tipo_contatto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Anagrafica_Tipo_Contatto_Min_Fields = {
  __typename?: 'anagrafica_tipo_contatto_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.tipo_contatto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Mutation_Response = {
  __typename?: 'anagrafica_tipo_contatto_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anagrafica_Tipo_Contatto>;
};

/** input type for inserting object relation for remote table "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Obj_Rel_Insert_Input = {
  data: Anagrafica_Tipo_Contatto_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anagrafica_Tipo_Contatto_On_Conflict>;
};

/** on_conflict condition type for table "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_On_Conflict = {
  constraint: Anagrafica_Tipo_Contatto_Constraint;
  update_columns?: Array<Anagrafica_Tipo_Contatto_Update_Column>;
  where?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
};

/** Ordering options when selecting data from "anagrafica.tipo_contatto". */
export type Anagrafica_Tipo_Contatto_Order_By = {
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validation?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anagrafica.tipo_contatto */
export type Anagrafica_Tipo_Contatto_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Anagrafica_Tipo_Contatto_Prepend_Input = {
  validation?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "anagrafica.tipo_contatto" */
export enum Anagrafica_Tipo_Contatto_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Validation = 'validation'
}

/** input type for updating data in table "anagrafica.tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validation?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Anagrafica_Tipo_Contatto_Stddev_Fields = {
  __typename?: 'anagrafica_tipo_contatto_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Anagrafica_Tipo_Contatto_Stddev_Pop_Fields = {
  __typename?: 'anagrafica_tipo_contatto_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Anagrafica_Tipo_Contatto_Stddev_Samp_Fields = {
  __typename?: 'anagrafica_tipo_contatto_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "anagrafica_tipo_contatto" */
export type Anagrafica_Tipo_Contatto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anagrafica_Tipo_Contatto_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anagrafica_Tipo_Contatto_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validation?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Anagrafica_Tipo_Contatto_Sum_Fields = {
  __typename?: 'anagrafica_tipo_contatto_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "anagrafica.tipo_contatto" */
export enum Anagrafica_Tipo_Contatto_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Validation = 'validation'
}

export type Anagrafica_Tipo_Contatto_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Anagrafica_Tipo_Contatto_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anagrafica_Tipo_Contatto_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Anagrafica_Tipo_Contatto_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anagrafica_Tipo_Contatto_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anagrafica_Tipo_Contatto_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anagrafica_Tipo_Contatto_Var_Pop_Fields = {
  __typename?: 'anagrafica_tipo_contatto_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Anagrafica_Tipo_Contatto_Var_Samp_Fields = {
  __typename?: 'anagrafica_tipo_contatto_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Anagrafica_Tipo_Contatto_Variance_Fields = {
  __typename?: 'anagrafica_tipo_contatto_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore = {
  __typename?: 'anagrafica_tipo_promotore';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "anagrafica.tipo_promotore_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Aggregate = {
  __typename?: 'anagrafica_tipo_promotore_aggregate';
  aggregate?: Maybe<Anagrafica_Tipo_Promotore_Aggregate_Fields>;
  nodes: Array<Anagrafica_Tipo_Promotore>;
};

/** aggregate fields of "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Aggregate_Fields = {
  __typename?: 'anagrafica_tipo_promotore_aggregate_fields';
  avg?: Maybe<Anagrafica_Tipo_Promotore_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anagrafica_Tipo_Promotore_Max_Fields>;
  min?: Maybe<Anagrafica_Tipo_Promotore_Min_Fields>;
  stddev?: Maybe<Anagrafica_Tipo_Promotore_Stddev_Fields>;
  stddev_pop?: Maybe<Anagrafica_Tipo_Promotore_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anagrafica_Tipo_Promotore_Stddev_Samp_Fields>;
  sum?: Maybe<Anagrafica_Tipo_Promotore_Sum_Fields>;
  var_pop?: Maybe<Anagrafica_Tipo_Promotore_Var_Pop_Fields>;
  var_samp?: Maybe<Anagrafica_Tipo_Promotore_Var_Samp_Fields>;
  variance?: Maybe<Anagrafica_Tipo_Promotore_Variance_Fields>;
};


/** aggregate fields of "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Anagrafica_Tipo_Promotore_Avg_Fields = {
  __typename?: 'anagrafica_tipo_promotore_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "anagrafica.tipo_promotore". All fields are combined with a logical 'AND'. */
export type Anagrafica_Tipo_Promotore_Bool_Exp = {
  _and?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Bool_Exp>>;
  _not?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
  _or?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "anagrafica.tipo_promotore" */
export enum Anagrafica_Tipo_Promotore_Constraint {
  /** unique or primary key constraint on columns "id" */
  TipoPromotorePkey = 'tipo_promotore_pkey'
}

/** input type for incrementing numeric columns in table "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Anagrafica_Tipo_Promotore_Max_Fields = {
  __typename?: 'anagrafica_tipo_promotore_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.tipo_promotore_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Anagrafica_Tipo_Promotore_Min_Fields = {
  __typename?: 'anagrafica_tipo_promotore_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.tipo_promotore_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Mutation_Response = {
  __typename?: 'anagrafica_tipo_promotore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anagrafica_Tipo_Promotore>;
};

/** input type for inserting object relation for remote table "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Obj_Rel_Insert_Input = {
  data: Anagrafica_Tipo_Promotore_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anagrafica_Tipo_Promotore_On_Conflict>;
};

/** on_conflict condition type for table "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_On_Conflict = {
  constraint: Anagrafica_Tipo_Promotore_Constraint;
  update_columns?: Array<Anagrafica_Tipo_Promotore_Update_Column>;
  where?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
};

/** Ordering options when selecting data from "anagrafica.tipo_promotore". */
export type Anagrafica_Tipo_Promotore_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anagrafica.tipo_promotore */
export type Anagrafica_Tipo_Promotore_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "anagrafica.tipo_promotore" */
export enum Anagrafica_Tipo_Promotore_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "anagrafica.tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Anagrafica_Tipo_Promotore_Stddev_Fields = {
  __typename?: 'anagrafica_tipo_promotore_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Anagrafica_Tipo_Promotore_Stddev_Pop_Fields = {
  __typename?: 'anagrafica_tipo_promotore_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Anagrafica_Tipo_Promotore_Stddev_Samp_Fields = {
  __typename?: 'anagrafica_tipo_promotore_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "anagrafica_tipo_promotore" */
export type Anagrafica_Tipo_Promotore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anagrafica_Tipo_Promotore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anagrafica_Tipo_Promotore_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Anagrafica_Tipo_Promotore_Sum_Fields = {
  __typename?: 'anagrafica_tipo_promotore_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "anagrafica.tipo_promotore" */
export enum Anagrafica_Tipo_Promotore_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Anagrafica_Tipo_Promotore_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anagrafica_Tipo_Promotore_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anagrafica_Tipo_Promotore_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anagrafica_Tipo_Promotore_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anagrafica_Tipo_Promotore_Var_Pop_Fields = {
  __typename?: 'anagrafica_tipo_promotore_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Anagrafica_Tipo_Promotore_Var_Samp_Fields = {
  __typename?: 'anagrafica_tipo_promotore_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Anagrafica_Tipo_Promotore_Variance_Fields = {
  __typename?: 'anagrafica_tipo_promotore_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante = {
  __typename?: 'anagrafica_tipologia_rappresentante';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "anagrafica.tipologia_rappresentante_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Aggregate = {
  __typename?: 'anagrafica_tipologia_rappresentante_aggregate';
  aggregate?: Maybe<Anagrafica_Tipologia_Rappresentante_Aggregate_Fields>;
  nodes: Array<Anagrafica_Tipologia_Rappresentante>;
};

/** aggregate fields of "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Aggregate_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_aggregate_fields';
  avg?: Maybe<Anagrafica_Tipologia_Rappresentante_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anagrafica_Tipologia_Rappresentante_Max_Fields>;
  min?: Maybe<Anagrafica_Tipologia_Rappresentante_Min_Fields>;
  stddev?: Maybe<Anagrafica_Tipologia_Rappresentante_Stddev_Fields>;
  stddev_pop?: Maybe<Anagrafica_Tipologia_Rappresentante_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anagrafica_Tipologia_Rappresentante_Stddev_Samp_Fields>;
  sum?: Maybe<Anagrafica_Tipologia_Rappresentante_Sum_Fields>;
  var_pop?: Maybe<Anagrafica_Tipologia_Rappresentante_Var_Pop_Fields>;
  var_samp?: Maybe<Anagrafica_Tipologia_Rappresentante_Var_Samp_Fields>;
  variance?: Maybe<Anagrafica_Tipologia_Rappresentante_Variance_Fields>;
};


/** aggregate fields of "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Anagrafica_Tipologia_Rappresentante_Avg_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "anagrafica.tipologia_rappresentante". All fields are combined with a logical 'AND'. */
export type Anagrafica_Tipologia_Rappresentante_Bool_Exp = {
  _and?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Bool_Exp>>;
  _not?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
  _or?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "anagrafica.tipologia_rappresentante" */
export enum Anagrafica_Tipologia_Rappresentante_Constraint {
  /** unique or primary key constraint on columns "id" */
  TipologiaRappresentantePkey = 'tipologia_rappresentante_pkey'
}

/** input type for incrementing numeric columns in table "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Anagrafica_Tipologia_Rappresentante_Max_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.tipologia_rappresentante_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Anagrafica_Tipologia_Rappresentante_Min_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "anagrafica.tipologia_rappresentante_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Mutation_Response = {
  __typename?: 'anagrafica_tipologia_rappresentante_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anagrafica_Tipologia_Rappresentante>;
};

/** input type for inserting object relation for remote table "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Obj_Rel_Insert_Input = {
  data: Anagrafica_Tipologia_Rappresentante_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anagrafica_Tipologia_Rappresentante_On_Conflict>;
};

/** on_conflict condition type for table "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_On_Conflict = {
  constraint: Anagrafica_Tipologia_Rappresentante_Constraint;
  update_columns?: Array<Anagrafica_Tipologia_Rappresentante_Update_Column>;
  where?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
};

/** Ordering options when selecting data from "anagrafica.tipologia_rappresentante". */
export type Anagrafica_Tipologia_Rappresentante_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anagrafica.tipologia_rappresentante */
export type Anagrafica_Tipologia_Rappresentante_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "anagrafica.tipologia_rappresentante" */
export enum Anagrafica_Tipologia_Rappresentante_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "anagrafica.tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Anagrafica_Tipologia_Rappresentante_Stddev_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Anagrafica_Tipologia_Rappresentante_Stddev_Pop_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Anagrafica_Tipologia_Rappresentante_Stddev_Samp_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "anagrafica_tipologia_rappresentante" */
export type Anagrafica_Tipologia_Rappresentante_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anagrafica_Tipologia_Rappresentante_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anagrafica_Tipologia_Rappresentante_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Anagrafica_Tipologia_Rappresentante_Sum_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "anagrafica.tipologia_rappresentante" */
export enum Anagrafica_Tipologia_Rappresentante_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Anagrafica_Tipologia_Rappresentante_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anagrafica_Tipologia_Rappresentante_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anagrafica_Tipologia_Rappresentante_Var_Pop_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Anagrafica_Tipologia_Rappresentante_Var_Samp_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Anagrafica_Tipologia_Rappresentante_Variance_Fields = {
  __typename?: 'anagrafica_tipologia_rappresentante_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "asset" */
export type Asset = {
  __typename?: 'asset';
  aiuto?: Maybe<Scalars['Boolean']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  altre_info?: Maybe<Scalars['jsonb']['output']>;
  associato: Scalars['Boolean']['output'];
  autoconsumo?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  cabina?: Maybe<Energy_Village_Cabina>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  caratteristiche: Array<Asset_Caratteristica>;
  /** An aggregate relationship */
  caratteristiche_aggregate: Asset_Caratteristica_Aggregate;
  /** An array relationship */
  condivisioni: Array<Condivisione_Condivisione>;
  /** An aggregate relationship */
  condivisioni_aggregate: Condivisione_Condivisione_Aggregate;
  /** An array relationship */
  consumi: Array<Asset_Consumo>;
  /** An aggregate relationship */
  consumi_aggregate: Asset_Consumo_Aggregate;
  consumo?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  data_allaccio_prevista?: Maybe<Scalars['timestamptz']['output']>;
  data_installazione_impianto?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  dimensione?: Maybe<Energy_Village_Dimensione>;
  dimensione_id?: Maybe<Scalars['uuid']['output']>;
  domenica_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  energia: Array<Asset_Energia>;
  /** An aggregate relationship */
  energia_aggregate: Asset_Energia_Aggregate;
  /** An array relationship */
  founders: Array<Asset_Founder>;
  /** An aggregate relationship */
  founders_aggregate: Asset_Founder_Aggregate;
  /** An array relationship */
  gestori: Array<Asset_Gestore>;
  /** An aggregate relationship */
  gestori_aggregate: Asset_Gestore_Aggregate;
  giovedi_id?: Maybe<Scalars['uuid']['output']>;
  has_sottoscrizioni_attive: Scalars['Boolean']['output'];
  has_sottoscrizioni_non_attive: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  impianto?: Maybe<Scalars['Boolean']['output']>;
  incentivi_impianto?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  indirizzo?: Maybe<Indirizzo>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  inseritore?: Maybe<Inseritore>;
  inseritore_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  installatore?: Maybe<Installatore>;
  installatore_id?: Maybe<Scalars['uuid']['output']>;
  lunedi_id?: Maybe<Scalars['uuid']['output']>;
  martedi_id?: Maybe<Scalars['uuid']['output']>;
  mercoledi_id?: Maybe<Scalars['uuid']['output']>;
  notifiche: Scalars['Int']['output'];
  opzionato: Scalars['Boolean']['output'];
  posizione_esatta: Scalars['Boolean']['output'];
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva: Scalars['numeric']['output'];
  potenza_impianto_prevista: Scalars['numeric']['output'];
  /** An array relationship */
  produzioni: Array<Asset_Produzione>;
  /** An aggregate relationship */
  produzioni_aggregate: Asset_Produzione_Aggregate;
  proprieta?: Maybe<Scalars['Boolean']['output']>;
  realizzando_impianto?: Maybe<Scalars['Boolean']['output']>;
  richiesta_pnrr?: Maybe<Scalars['Boolean']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  sabato_id?: Maybe<Scalars['uuid']['output']>;
  scambio_su_posto?: Maybe<Scalars['Boolean']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  spazi_disponibili: Array<Asset_Spazio>;
  /** An aggregate relationship */
  spazi_disponibili_aggregate: Asset_Spazio_Aggregate;
  spazio_disponibile?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tipologia_abitativa?: Maybe<Energy_Village_Tipologia_Abitativa>;
  tipologia_abitativa_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tipologia_asset?: Maybe<Energy_Village_Tipologia_Asset>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  update: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  venerdi_id?: Maybe<Scalars['uuid']['output']>;
  visibilita_nome: Scalars['Boolean']['output'];
  /** An object relationship */
  white_label?: Maybe<White_Label_Configurazione>;
  white_label_tag?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "asset" */
export type AssetAltre_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "asset" */
export type AssetAutoconsumoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "asset" */
export type AssetCaratteristicheArgs = {
  distinct_on?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Caratteristica_Order_By>>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetCaratteristiche_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Caratteristica_Order_By>>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetCondivisioniArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetCondivisioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetConsumiArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetConsumi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetEnergiaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Energia_Order_By>>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetEnergia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Energia_Order_By>>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetFoundersArgs = {
  distinct_on?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Founder_Order_By>>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetFounders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Founder_Order_By>>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetGestoriArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetGestori_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetIncentivi_ImpiantoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "asset" */
export type AssetProduzioniArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetProduzioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetSpazi_DisponibiliArgs = {
  distinct_on?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Spazio_Order_By>>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};


/** columns and relationships of "asset" */
export type AssetSpazi_Disponibili_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Spazio_Order_By>>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};

/** aggregated selection of "asset" */
export type Asset_Aggregate = {
  __typename?: 'asset_aggregate';
  aggregate?: Maybe<Asset_Aggregate_Fields>;
  nodes: Array<Asset>;
};

export type Asset_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Asset_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Asset_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Asset_Aggregate_Bool_Exp_Count>;
};

export type Asset_Aggregate_Bool_Exp_Bool_And = {
  arguments: Asset_Select_Column_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Asset_Select_Column_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset" */
export type Asset_Aggregate_Fields = {
  __typename?: 'asset_aggregate_fields';
  avg?: Maybe<Asset_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Max_Fields>;
  min?: Maybe<Asset_Min_Fields>;
  stddev?: Maybe<Asset_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Sum_Fields>;
  var_pop?: Maybe<Asset_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Var_Samp_Fields>;
  variance?: Maybe<Asset_Variance_Fields>;
};


/** aggregate fields of "asset" */
export type Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset" */
export type Asset_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Max_Order_By>;
  min?: InputMaybe<Asset_Min_Order_By>;
  stddev?: InputMaybe<Asset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Asset_Append_Input = {
  altre_info?: InputMaybe<Scalars['jsonb']['input']>;
  autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "asset" */
export type Asset_Arr_Rel_Insert_Input = {
  data: Array<Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Avg_Fields = {
  __typename?: 'asset_avg_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset" */
export type Asset_Avg_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset". All fields are combined with a logical 'AND'. */
export type Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Bool_Exp>>;
  _not?: InputMaybe<Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Bool_Exp>>;
  aiuto?: InputMaybe<Boolean_Comparison_Exp>;
  alias?: InputMaybe<String_Comparison_Exp>;
  altre_info?: InputMaybe<Jsonb_Comparison_Exp>;
  associato?: InputMaybe<Boolean_Comparison_Exp>;
  autoconsumo?: InputMaybe<Jsonb_Comparison_Exp>;
  cabina?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
  cabina_id?: InputMaybe<Int_Comparison_Exp>;
  capacita_batteria_prevista?: InputMaybe<Numeric_Comparison_Exp>;
  caratteristiche?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
  caratteristiche_aggregate?: InputMaybe<Asset_Caratteristica_Aggregate_Bool_Exp>;
  condivisioni?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
  condivisioni_aggregate?: InputMaybe<Condivisione_Condivisione_Aggregate_Bool_Exp>;
  consumi?: InputMaybe<Asset_Consumo_Bool_Exp>;
  consumi_aggregate?: InputMaybe<Asset_Consumo_Aggregate_Bool_Exp>;
  consumo?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_allaccio_prevista?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_installazione_impianto?: InputMaybe<Timestamptz_Comparison_Exp>;
  dimensione?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
  dimensione_id?: InputMaybe<Uuid_Comparison_Exp>;
  domenica_id?: InputMaybe<Uuid_Comparison_Exp>;
  energia?: InputMaybe<Asset_Energia_Bool_Exp>;
  energia_aggregate?: InputMaybe<Asset_Energia_Aggregate_Bool_Exp>;
  founders?: InputMaybe<Asset_Founder_Bool_Exp>;
  founders_aggregate?: InputMaybe<Asset_Founder_Aggregate_Bool_Exp>;
  gestori?: InputMaybe<Asset_Gestore_Bool_Exp>;
  gestori_aggregate?: InputMaybe<Asset_Gestore_Aggregate_Bool_Exp>;
  giovedi_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_sottoscrizioni_attive?: InputMaybe<Boolean_Comparison_Exp>;
  has_sottoscrizioni_non_attive?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impianto?: InputMaybe<Boolean_Comparison_Exp>;
  incentivi_impianto?: InputMaybe<Jsonb_Comparison_Exp>;
  indirizzo?: InputMaybe<Indirizzo_Bool_Exp>;
  indirizzo_id?: InputMaybe<Uuid_Comparison_Exp>;
  inseritore?: InputMaybe<Inseritore_Bool_Exp>;
  inseritore_id?: InputMaybe<Uuid_Comparison_Exp>;
  installatore?: InputMaybe<Installatore_Bool_Exp>;
  installatore_id?: InputMaybe<Uuid_Comparison_Exp>;
  lunedi_id?: InputMaybe<Uuid_Comparison_Exp>;
  martedi_id?: InputMaybe<Uuid_Comparison_Exp>;
  mercoledi_id?: InputMaybe<Uuid_Comparison_Exp>;
  notifiche?: InputMaybe<Int_Comparison_Exp>;
  opzionato?: InputMaybe<Boolean_Comparison_Exp>;
  posizione_esatta?: InputMaybe<Boolean_Comparison_Exp>;
  potenza_batteria?: InputMaybe<Numeric_Comparison_Exp>;
  potenza_effettiva?: InputMaybe<Numeric_Comparison_Exp>;
  potenza_impianto_prevista?: InputMaybe<Numeric_Comparison_Exp>;
  produzioni?: InputMaybe<Asset_Produzione_Bool_Exp>;
  produzioni_aggregate?: InputMaybe<Asset_Produzione_Aggregate_Bool_Exp>;
  proprieta?: InputMaybe<Boolean_Comparison_Exp>;
  realizzando_impianto?: InputMaybe<Boolean_Comparison_Exp>;
  richiesta_pnrr?: InputMaybe<Boolean_Comparison_Exp>;
  root_id?: InputMaybe<Uuid_Comparison_Exp>;
  sabato_id?: InputMaybe<Uuid_Comparison_Exp>;
  scambio_su_posto?: InputMaybe<Boolean_Comparison_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  spazi_disponibili?: InputMaybe<Asset_Spazio_Bool_Exp>;
  spazi_disponibili_aggregate?: InputMaybe<Asset_Spazio_Aggregate_Bool_Exp>;
  spazio_disponibile?: InputMaybe<Boolean_Comparison_Exp>;
  tipologia_abitativa?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
  tipologia_abitativa_id?: InputMaybe<Uuid_Comparison_Exp>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  update?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  venerdi_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibilita_nome?: InputMaybe<Boolean_Comparison_Exp>;
  white_label?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
  white_label_tag?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "asset_caratteristica" */
export type Asset_Caratteristica = {
  __typename?: 'asset_caratteristica';
  /** An object relationship */
  asset: Asset;
  asset_id: Scalars['uuid']['output'];
  /** An object relationship */
  caratteristica: Energy_Village_Caratteristica;
  caratteristica_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "asset_caratteristica" */
export type Asset_Caratteristica_Aggregate = {
  __typename?: 'asset_caratteristica_aggregate';
  aggregate?: Maybe<Asset_Caratteristica_Aggregate_Fields>;
  nodes: Array<Asset_Caratteristica>;
};

export type Asset_Caratteristica_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Caratteristica_Aggregate_Bool_Exp_Count>;
};

export type Asset_Caratteristica_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_caratteristica" */
export type Asset_Caratteristica_Aggregate_Fields = {
  __typename?: 'asset_caratteristica_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Caratteristica_Max_Fields>;
  min?: Maybe<Asset_Caratteristica_Min_Fields>;
};


/** aggregate fields of "asset_caratteristica" */
export type Asset_Caratteristica_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_caratteristica" */
export type Asset_Caratteristica_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Caratteristica_Max_Order_By>;
  min?: InputMaybe<Asset_Caratteristica_Min_Order_By>;
};

/** input type for inserting array relation for remote table "asset_caratteristica" */
export type Asset_Caratteristica_Arr_Rel_Insert_Input = {
  data: Array<Asset_Caratteristica_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Caratteristica_On_Conflict>;
};

/** Boolean expression to filter rows from the table "asset_caratteristica". All fields are combined with a logical 'AND'. */
export type Asset_Caratteristica_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Caratteristica_Bool_Exp>>;
  _not?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Caratteristica_Bool_Exp>>;
  asset?: InputMaybe<Asset_Bool_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  caratteristica?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
  caratteristica_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_caratteristica" */
export enum Asset_Caratteristica_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetCaratteristicaPkey = 'asset_caratteristica_pkey'
}

/** input type for inserting data into table "asset_caratteristica" */
export type Asset_Caratteristica_Insert_Input = {
  asset?: InputMaybe<Asset_Obj_Rel_Insert_Input>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  caratteristica?: InputMaybe<Energy_Village_Caratteristica_Obj_Rel_Insert_Input>;
  caratteristica_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Caratteristica_Max_Fields = {
  __typename?: 'asset_caratteristica_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  caratteristica_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_caratteristica" */
export type Asset_Caratteristica_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  caratteristica_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Caratteristica_Min_Fields = {
  __typename?: 'asset_caratteristica_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  caratteristica_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_caratteristica" */
export type Asset_Caratteristica_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  caratteristica_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_caratteristica" */
export type Asset_Caratteristica_Mutation_Response = {
  __typename?: 'asset_caratteristica_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Caratteristica>;
};

/** on_conflict condition type for table "asset_caratteristica" */
export type Asset_Caratteristica_On_Conflict = {
  constraint: Asset_Caratteristica_Constraint;
  update_columns?: Array<Asset_Caratteristica_Update_Column>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_caratteristica". */
export type Asset_Caratteristica_Order_By = {
  asset?: InputMaybe<Asset_Order_By>;
  asset_id?: InputMaybe<Order_By>;
  caratteristica?: InputMaybe<Energy_Village_Caratteristica_Order_By>;
  caratteristica_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_caratteristica */
export type Asset_Caratteristica_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_caratteristica" */
export enum Asset_Caratteristica_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CaratteristicaId = 'caratteristica_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_caratteristica" */
export type Asset_Caratteristica_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  caratteristica_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "asset_caratteristica" */
export type Asset_Caratteristica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Caratteristica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Caratteristica_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  caratteristica_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "asset_caratteristica" */
export enum Asset_Caratteristica_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CaratteristicaId = 'caratteristica_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Caratteristica_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Caratteristica_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Caratteristica_Bool_Exp;
};

/** unique or primary key constraints on table "asset" */
export enum Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetPkey = 'asset_pkey'
}

/** columns and relationships of "asset_consumo" */
export type Asset_Consumo = {
  __typename?: 'asset_consumo';
  accumulo_standalone?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  asset?: Maybe<Asset>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  dati_consumo: Array<Asset_Dato_Consumo>;
  /** An aggregate relationship */
  dati_consumo_aggregate: Asset_Dato_Consumo_Aggregate;
  foglio?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  intestatario?: Maybe<Persona>;
  intestatario_id?: Maybe<Scalars['uuid']['output']>;
  particella?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sezione_catastale?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sottoscrizioni: Array<Sottoscrizione>;
  /** An aggregate relationship */
  sottoscrizioni_aggregate: Sottoscrizione_Aggregate;
  subalterno?: Maybe<Scalars['String']['output']>;
  tipo_pod_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "asset_consumo" */
export type Asset_ConsumoDati_ConsumoArgs = {
  distinct_on?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Dato_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};


/** columns and relationships of "asset_consumo" */
export type Asset_ConsumoDati_Consumo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Dato_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};


/** columns and relationships of "asset_consumo" */
export type Asset_ConsumoSottoscrizioniArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "asset_consumo" */
export type Asset_ConsumoSottoscrizioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};

/** aggregated selection of "asset_consumo" */
export type Asset_Consumo_Aggregate = {
  __typename?: 'asset_consumo_aggregate';
  aggregate?: Maybe<Asset_Consumo_Aggregate_Fields>;
  nodes: Array<Asset_Consumo>;
};

export type Asset_Consumo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Consumo_Aggregate_Bool_Exp_Count>;
};

export type Asset_Consumo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Consumo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_consumo" */
export type Asset_Consumo_Aggregate_Fields = {
  __typename?: 'asset_consumo_aggregate_fields';
  avg?: Maybe<Asset_Consumo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Consumo_Max_Fields>;
  min?: Maybe<Asset_Consumo_Min_Fields>;
  stddev?: Maybe<Asset_Consumo_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Consumo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Consumo_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Consumo_Sum_Fields>;
  var_pop?: Maybe<Asset_Consumo_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Consumo_Var_Samp_Fields>;
  variance?: Maybe<Asset_Consumo_Variance_Fields>;
};


/** aggregate fields of "asset_consumo" */
export type Asset_Consumo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_consumo" */
export type Asset_Consumo_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Consumo_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Consumo_Max_Order_By>;
  min?: InputMaybe<Asset_Consumo_Min_Order_By>;
  stddev?: InputMaybe<Asset_Consumo_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Consumo_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Consumo_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Consumo_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Consumo_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Consumo_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Consumo_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_consumo" */
export type Asset_Consumo_Arr_Rel_Insert_Input = {
  data: Array<Asset_Consumo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Consumo_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Consumo_Avg_Fields = {
  __typename?: 'asset_consumo_avg_fields';
  accumulo_standalone?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_consumo" */
export type Asset_Consumo_Avg_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_consumo". All fields are combined with a logical 'AND'. */
export type Asset_Consumo_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Consumo_Bool_Exp>>;
  _not?: InputMaybe<Asset_Consumo_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Consumo_Bool_Exp>>;
  accumulo_standalone?: InputMaybe<Numeric_Comparison_Exp>;
  asset?: InputMaybe<Asset_Bool_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dati_consumo?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
  dati_consumo_aggregate?: InputMaybe<Asset_Dato_Consumo_Aggregate_Bool_Exp>;
  foglio?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intestatario?: InputMaybe<Persona_Bool_Exp>;
  intestatario_id?: InputMaybe<Uuid_Comparison_Exp>;
  particella?: InputMaybe<String_Comparison_Exp>;
  pod?: InputMaybe<String_Comparison_Exp>;
  sezione_catastale?: InputMaybe<String_Comparison_Exp>;
  sottoscrizioni?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizioni_aggregate?: InputMaybe<Sottoscrizione_Aggregate_Bool_Exp>;
  subalterno?: InputMaybe<String_Comparison_Exp>;
  tipo_pod_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_consumo" */
export enum Asset_Consumo_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetConsumoPkey = 'asset_consumo_pkey'
}

/** input type for incrementing numeric columns in table "asset_consumo" */
export type Asset_Consumo_Inc_Input = {
  accumulo_standalone?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset_consumo" */
export type Asset_Consumo_Insert_Input = {
  accumulo_standalone?: InputMaybe<Scalars['numeric']['input']>;
  asset?: InputMaybe<Asset_Obj_Rel_Insert_Input>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dati_consumo?: InputMaybe<Asset_Dato_Consumo_Arr_Rel_Insert_Input>;
  foglio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  intestatario_id?: InputMaybe<Scalars['uuid']['input']>;
  particella?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  sezione_catastale?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioni?: InputMaybe<Sottoscrizione_Arr_Rel_Insert_Input>;
  subalterno?: InputMaybe<Scalars['String']['input']>;
  tipo_pod_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Consumo_Max_Fields = {
  __typename?: 'asset_consumo_max_fields';
  accumulo_standalone?: Maybe<Scalars['numeric']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  foglio?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_id?: Maybe<Scalars['uuid']['output']>;
  particella?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sezione_catastale?: Maybe<Scalars['String']['output']>;
  subalterno?: Maybe<Scalars['String']['output']>;
  tipo_pod_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_consumo" */
export type Asset_Consumo_Max_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  foglio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intestatario_id?: InputMaybe<Order_By>;
  particella?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  sezione_catastale?: InputMaybe<Order_By>;
  subalterno?: InputMaybe<Order_By>;
  tipo_pod_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Consumo_Min_Fields = {
  __typename?: 'asset_consumo_min_fields';
  accumulo_standalone?: Maybe<Scalars['numeric']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  foglio?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_id?: Maybe<Scalars['uuid']['output']>;
  particella?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sezione_catastale?: Maybe<Scalars['String']['output']>;
  subalterno?: Maybe<Scalars['String']['output']>;
  tipo_pod_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_consumo" */
export type Asset_Consumo_Min_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  foglio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intestatario_id?: InputMaybe<Order_By>;
  particella?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  sezione_catastale?: InputMaybe<Order_By>;
  subalterno?: InputMaybe<Order_By>;
  tipo_pod_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_consumo" */
export type Asset_Consumo_Mutation_Response = {
  __typename?: 'asset_consumo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Consumo>;
};

/** input type for inserting object relation for remote table "asset_consumo" */
export type Asset_Consumo_Obj_Rel_Insert_Input = {
  data: Asset_Consumo_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Consumo_On_Conflict>;
};

/** on_conflict condition type for table "asset_consumo" */
export type Asset_Consumo_On_Conflict = {
  constraint: Asset_Consumo_Constraint;
  update_columns?: Array<Asset_Consumo_Update_Column>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_consumo". */
export type Asset_Consumo_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
  asset?: InputMaybe<Asset_Order_By>;
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dati_consumo_aggregate?: InputMaybe<Asset_Dato_Consumo_Aggregate_Order_By>;
  foglio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intestatario?: InputMaybe<Persona_Order_By>;
  intestatario_id?: InputMaybe<Order_By>;
  particella?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  sezione_catastale?: InputMaybe<Order_By>;
  sottoscrizioni_aggregate?: InputMaybe<Sottoscrizione_Aggregate_Order_By>;
  subalterno?: InputMaybe<Order_By>;
  tipo_pod_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_consumo */
export type Asset_Consumo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_consumo" */
export enum Asset_Consumo_Select_Column {
  /** column name */
  AccumuloStandalone = 'accumulo_standalone',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Foglio = 'foglio',
  /** column name */
  Id = 'id',
  /** column name */
  IntestatarioId = 'intestatario_id',
  /** column name */
  Particella = 'particella',
  /** column name */
  Pod = 'pod',
  /** column name */
  SezioneCatastale = 'sezione_catastale',
  /** column name */
  Subalterno = 'subalterno',
  /** column name */
  TipoPodId = 'tipo_pod_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_consumo" */
export type Asset_Consumo_Set_Input = {
  accumulo_standalone?: InputMaybe<Scalars['numeric']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  foglio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario_id?: InputMaybe<Scalars['uuid']['input']>;
  particella?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  sezione_catastale?: InputMaybe<Scalars['String']['input']>;
  subalterno?: InputMaybe<Scalars['String']['input']>;
  tipo_pod_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Consumo_Stddev_Fields = {
  __typename?: 'asset_consumo_stddev_fields';
  accumulo_standalone?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_consumo" */
export type Asset_Consumo_Stddev_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Consumo_Stddev_Pop_Fields = {
  __typename?: 'asset_consumo_stddev_pop_fields';
  accumulo_standalone?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_consumo" */
export type Asset_Consumo_Stddev_Pop_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Consumo_Stddev_Samp_Fields = {
  __typename?: 'asset_consumo_stddev_samp_fields';
  accumulo_standalone?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_consumo" */
export type Asset_Consumo_Stddev_Samp_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_consumo" */
export type Asset_Consumo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Consumo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Consumo_Stream_Cursor_Value_Input = {
  accumulo_standalone?: InputMaybe<Scalars['numeric']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  foglio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario_id?: InputMaybe<Scalars['uuid']['input']>;
  particella?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  sezione_catastale?: InputMaybe<Scalars['String']['input']>;
  subalterno?: InputMaybe<Scalars['String']['input']>;
  tipo_pod_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Asset_Consumo_Sum_Fields = {
  __typename?: 'asset_consumo_sum_fields';
  accumulo_standalone?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset_consumo" */
export type Asset_Consumo_Sum_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** update columns of table "asset_consumo" */
export enum Asset_Consumo_Update_Column {
  /** column name */
  AccumuloStandalone = 'accumulo_standalone',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Foglio = 'foglio',
  /** column name */
  Id = 'id',
  /** column name */
  IntestatarioId = 'intestatario_id',
  /** column name */
  Particella = 'particella',
  /** column name */
  Pod = 'pod',
  /** column name */
  SezioneCatastale = 'sezione_catastale',
  /** column name */
  Subalterno = 'subalterno',
  /** column name */
  TipoPodId = 'tipo_pod_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Consumo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Consumo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Consumo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Consumo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Consumo_Var_Pop_Fields = {
  __typename?: 'asset_consumo_var_pop_fields';
  accumulo_standalone?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_consumo" */
export type Asset_Consumo_Var_Pop_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Consumo_Var_Samp_Fields = {
  __typename?: 'asset_consumo_var_samp_fields';
  accumulo_standalone?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_consumo" */
export type Asset_Consumo_Var_Samp_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Consumo_Variance_Fields = {
  __typename?: 'asset_consumo_variance_fields';
  accumulo_standalone?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_consumo" */
export type Asset_Consumo_Variance_Order_By = {
  accumulo_standalone?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_dato_consumo" */
export type Asset_Dato_Consumo = {
  __typename?: 'asset_dato_consumo';
  /** An object relationship */
  asset_consumo: Asset_Consumo;
  asset_consumo_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  data_fine?: Maybe<Scalars['timestamptz']['output']>;
  data_inizio?: Maybe<Scalars['timestamptz']['output']>;
  f1?: Maybe<Scalars['numeric']['output']>;
  f2?: Maybe<Scalars['numeric']['output']>;
  f3?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  tipo_dato: _Tipo_Dato_Consumo_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "asset_dato_consumo" */
export type Asset_Dato_Consumo_Aggregate = {
  __typename?: 'asset_dato_consumo_aggregate';
  aggregate?: Maybe<Asset_Dato_Consumo_Aggregate_Fields>;
  nodes: Array<Asset_Dato_Consumo>;
};

export type Asset_Dato_Consumo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Dato_Consumo_Aggregate_Bool_Exp_Count>;
};

export type Asset_Dato_Consumo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_dato_consumo" */
export type Asset_Dato_Consumo_Aggregate_Fields = {
  __typename?: 'asset_dato_consumo_aggregate_fields';
  avg?: Maybe<Asset_Dato_Consumo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Dato_Consumo_Max_Fields>;
  min?: Maybe<Asset_Dato_Consumo_Min_Fields>;
  stddev?: Maybe<Asset_Dato_Consumo_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Dato_Consumo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Dato_Consumo_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Dato_Consumo_Sum_Fields>;
  var_pop?: Maybe<Asset_Dato_Consumo_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Dato_Consumo_Var_Samp_Fields>;
  variance?: Maybe<Asset_Dato_Consumo_Variance_Fields>;
};


/** aggregate fields of "asset_dato_consumo" */
export type Asset_Dato_Consumo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Dato_Consumo_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Dato_Consumo_Max_Order_By>;
  min?: InputMaybe<Asset_Dato_Consumo_Min_Order_By>;
  stddev?: InputMaybe<Asset_Dato_Consumo_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Dato_Consumo_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Dato_Consumo_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Dato_Consumo_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Dato_Consumo_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Dato_Consumo_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Dato_Consumo_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Arr_Rel_Insert_Input = {
  data: Array<Asset_Dato_Consumo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Dato_Consumo_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Dato_Consumo_Avg_Fields = {
  __typename?: 'asset_dato_consumo_avg_fields';
  f1?: Maybe<Scalars['Float']['output']>;
  f2?: Maybe<Scalars['Float']['output']>;
  f3?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Avg_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_dato_consumo". All fields are combined with a logical 'AND'. */
export type Asset_Dato_Consumo_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Dato_Consumo_Bool_Exp>>;
  _not?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Dato_Consumo_Bool_Exp>>;
  asset_consumo?: InputMaybe<Asset_Consumo_Bool_Exp>;
  asset_consumo_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_fine?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_inizio?: InputMaybe<Timestamptz_Comparison_Exp>;
  f1?: InputMaybe<Numeric_Comparison_Exp>;
  f2?: InputMaybe<Numeric_Comparison_Exp>;
  f3?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  tipo_dato?: InputMaybe<_Tipo_Dato_Consumo_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_dato_consumo" */
export enum Asset_Dato_Consumo_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetDatoConsumoPkey = 'asset_dato_consumo_pkey'
}

/** input type for incrementing numeric columns in table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Inc_Input = {
  f1?: InputMaybe<Scalars['numeric']['input']>;
  f2?: InputMaybe<Scalars['numeric']['input']>;
  f3?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Insert_Input = {
  asset_consumo?: InputMaybe<Asset_Consumo_Obj_Rel_Insert_Input>;
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_fine?: InputMaybe<Scalars['timestamptz']['input']>;
  data_inizio?: InputMaybe<Scalars['timestamptz']['input']>;
  f1?: InputMaybe<Scalars['numeric']['input']>;
  f2?: InputMaybe<Scalars['numeric']['input']>;
  f3?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_dato?: InputMaybe<_Tipo_Dato_Consumo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Dato_Consumo_Max_Fields = {
  __typename?: 'asset_dato_consumo_max_fields';
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_fine?: Maybe<Scalars['timestamptz']['output']>;
  data_inizio?: Maybe<Scalars['timestamptz']['output']>;
  f1?: Maybe<Scalars['numeric']['output']>;
  f2?: Maybe<Scalars['numeric']['output']>;
  f3?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Max_Order_By = {
  asset_consumo_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_fine?: InputMaybe<Order_By>;
  data_inizio?: InputMaybe<Order_By>;
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Dato_Consumo_Min_Fields = {
  __typename?: 'asset_dato_consumo_min_fields';
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_fine?: Maybe<Scalars['timestamptz']['output']>;
  data_inizio?: Maybe<Scalars['timestamptz']['output']>;
  f1?: Maybe<Scalars['numeric']['output']>;
  f2?: Maybe<Scalars['numeric']['output']>;
  f3?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Min_Order_By = {
  asset_consumo_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_fine?: InputMaybe<Order_By>;
  data_inizio?: InputMaybe<Order_By>;
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Mutation_Response = {
  __typename?: 'asset_dato_consumo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Dato_Consumo>;
};

/** on_conflict condition type for table "asset_dato_consumo" */
export type Asset_Dato_Consumo_On_Conflict = {
  constraint: Asset_Dato_Consumo_Constraint;
  update_columns?: Array<Asset_Dato_Consumo_Update_Column>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_dato_consumo". */
export type Asset_Dato_Consumo_Order_By = {
  asset_consumo?: InputMaybe<Asset_Consumo_Order_By>;
  asset_consumo_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_fine?: InputMaybe<Order_By>;
  data_inizio?: InputMaybe<Order_By>;
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipo_dato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_dato_consumo */
export type Asset_Dato_Consumo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_dato_consumo" */
export enum Asset_Dato_Consumo_Select_Column {
  /** column name */
  AssetConsumoId = 'asset_consumo_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFine = 'data_fine',
  /** column name */
  DataInizio = 'data_inizio',
  /** column name */
  F1 = 'f1',
  /** column name */
  F2 = 'f2',
  /** column name */
  F3 = 'f3',
  /** column name */
  Id = 'id',
  /** column name */
  TipoDato = 'tipo_dato',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Set_Input = {
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_fine?: InputMaybe<Scalars['timestamptz']['input']>;
  data_inizio?: InputMaybe<Scalars['timestamptz']['input']>;
  f1?: InputMaybe<Scalars['numeric']['input']>;
  f2?: InputMaybe<Scalars['numeric']['input']>;
  f3?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_dato?: InputMaybe<_Tipo_Dato_Consumo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Dato_Consumo_Stddev_Fields = {
  __typename?: 'asset_dato_consumo_stddev_fields';
  f1?: Maybe<Scalars['Float']['output']>;
  f2?: Maybe<Scalars['Float']['output']>;
  f3?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Stddev_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Dato_Consumo_Stddev_Pop_Fields = {
  __typename?: 'asset_dato_consumo_stddev_pop_fields';
  f1?: Maybe<Scalars['Float']['output']>;
  f2?: Maybe<Scalars['Float']['output']>;
  f3?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Stddev_Pop_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Dato_Consumo_Stddev_Samp_Fields = {
  __typename?: 'asset_dato_consumo_stddev_samp_fields';
  f1?: Maybe<Scalars['Float']['output']>;
  f2?: Maybe<Scalars['Float']['output']>;
  f3?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Stddev_Samp_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Dato_Consumo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Dato_Consumo_Stream_Cursor_Value_Input = {
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_fine?: InputMaybe<Scalars['timestamptz']['input']>;
  data_inizio?: InputMaybe<Scalars['timestamptz']['input']>;
  f1?: InputMaybe<Scalars['numeric']['input']>;
  f2?: InputMaybe<Scalars['numeric']['input']>;
  f3?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_dato?: InputMaybe<_Tipo_Dato_Consumo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Asset_Dato_Consumo_Sum_Fields = {
  __typename?: 'asset_dato_consumo_sum_fields';
  f1?: Maybe<Scalars['numeric']['output']>;
  f2?: Maybe<Scalars['numeric']['output']>;
  f3?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Sum_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** update columns of table "asset_dato_consumo" */
export enum Asset_Dato_Consumo_Update_Column {
  /** column name */
  AssetConsumoId = 'asset_consumo_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFine = 'data_fine',
  /** column name */
  DataInizio = 'data_inizio',
  /** column name */
  F1 = 'f1',
  /** column name */
  F2 = 'f2',
  /** column name */
  F3 = 'f3',
  /** column name */
  Id = 'id',
  /** column name */
  TipoDato = 'tipo_dato',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Dato_Consumo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Dato_Consumo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Dato_Consumo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Dato_Consumo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Dato_Consumo_Var_Pop_Fields = {
  __typename?: 'asset_dato_consumo_var_pop_fields';
  f1?: Maybe<Scalars['Float']['output']>;
  f2?: Maybe<Scalars['Float']['output']>;
  f3?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Var_Pop_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Dato_Consumo_Var_Samp_Fields = {
  __typename?: 'asset_dato_consumo_var_samp_fields';
  f1?: Maybe<Scalars['Float']['output']>;
  f2?: Maybe<Scalars['Float']['output']>;
  f3?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Var_Samp_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Dato_Consumo_Variance_Fields = {
  __typename?: 'asset_dato_consumo_variance_fields';
  f1?: Maybe<Scalars['Float']['output']>;
  f2?: Maybe<Scalars['Float']['output']>;
  f3?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_dato_consumo" */
export type Asset_Dato_Consumo_Variance_Order_By = {
  f1?: InputMaybe<Order_By>;
  f2?: InputMaybe<Order_By>;
  f3?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Asset_Delete_At_Path_Input = {
  altre_info?: InputMaybe<Array<Scalars['String']['input']>>;
  autoconsumo?: InputMaybe<Array<Scalars['String']['input']>>;
  incentivi_impianto?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Asset_Delete_Elem_Input = {
  altre_info?: InputMaybe<Scalars['Int']['input']>;
  autoconsumo?: InputMaybe<Scalars['Int']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Asset_Delete_Key_Input = {
  altre_info?: InputMaybe<Scalars['String']['input']>;
  autoconsumo?: InputMaybe<Scalars['String']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "asset_energia" */
export type Asset_Energia = {
  __typename?: 'asset_energia';
  asset_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  immessa?: Maybe<Scalars['numeric']['output']>;
  prelevata?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "asset_energia" */
export type Asset_Energia_Aggregate = {
  __typename?: 'asset_energia_aggregate';
  aggregate?: Maybe<Asset_Energia_Aggregate_Fields>;
  nodes: Array<Asset_Energia>;
};

export type Asset_Energia_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Energia_Aggregate_Bool_Exp_Count>;
};

export type Asset_Energia_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Energia_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_energia" */
export type Asset_Energia_Aggregate_Fields = {
  __typename?: 'asset_energia_aggregate_fields';
  avg?: Maybe<Asset_Energia_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Energia_Max_Fields>;
  min?: Maybe<Asset_Energia_Min_Fields>;
  stddev?: Maybe<Asset_Energia_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Energia_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Energia_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Energia_Sum_Fields>;
  var_pop?: Maybe<Asset_Energia_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Energia_Var_Samp_Fields>;
  variance?: Maybe<Asset_Energia_Variance_Fields>;
};


/** aggregate fields of "asset_energia" */
export type Asset_Energia_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_energia" */
export type Asset_Energia_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Energia_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Energia_Max_Order_By>;
  min?: InputMaybe<Asset_Energia_Min_Order_By>;
  stddev?: InputMaybe<Asset_Energia_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Energia_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Energia_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Energia_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Energia_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Energia_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Energia_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_energia" */
export type Asset_Energia_Arr_Rel_Insert_Input = {
  data: Array<Asset_Energia_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Energia_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Energia_Avg_Fields = {
  __typename?: 'asset_energia_avg_fields';
  immessa?: Maybe<Scalars['Float']['output']>;
  prelevata?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_energia" */
export type Asset_Energia_Avg_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_energia". All fields are combined with a logical 'AND'. */
export type Asset_Energia_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Energia_Bool_Exp>>;
  _not?: InputMaybe<Asset_Energia_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Energia_Bool_Exp>>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  immessa?: InputMaybe<Numeric_Comparison_Exp>;
  prelevata?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_energia" */
export enum Asset_Energia_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetEnergiaPkey = 'asset_energia_pkey'
}

/** input type for incrementing numeric columns in table "asset_energia" */
export type Asset_Energia_Inc_Input = {
  immessa?: InputMaybe<Scalars['numeric']['input']>;
  prelevata?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset_energia" */
export type Asset_Energia_Insert_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  immessa?: InputMaybe<Scalars['numeric']['input']>;
  prelevata?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Energia_Max_Fields = {
  __typename?: 'asset_energia_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  immessa?: Maybe<Scalars['numeric']['output']>;
  prelevata?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_energia" */
export type Asset_Energia_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Energia_Min_Fields = {
  __typename?: 'asset_energia_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  immessa?: Maybe<Scalars['numeric']['output']>;
  prelevata?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_energia" */
export type Asset_Energia_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_energia" */
export type Asset_Energia_Mutation_Response = {
  __typename?: 'asset_energia_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Energia>;
};

/** on_conflict condition type for table "asset_energia" */
export type Asset_Energia_On_Conflict = {
  constraint: Asset_Energia_Constraint;
  update_columns?: Array<Asset_Energia_Update_Column>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_energia". */
export type Asset_Energia_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_energia */
export type Asset_Energia_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_energia" */
export enum Asset_Energia_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Immessa = 'immessa',
  /** column name */
  Prelevata = 'prelevata',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_energia" */
export type Asset_Energia_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  immessa?: InputMaybe<Scalars['numeric']['input']>;
  prelevata?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Energia_Stddev_Fields = {
  __typename?: 'asset_energia_stddev_fields';
  immessa?: Maybe<Scalars['Float']['output']>;
  prelevata?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_energia" */
export type Asset_Energia_Stddev_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Energia_Stddev_Pop_Fields = {
  __typename?: 'asset_energia_stddev_pop_fields';
  immessa?: Maybe<Scalars['Float']['output']>;
  prelevata?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_energia" */
export type Asset_Energia_Stddev_Pop_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Energia_Stddev_Samp_Fields = {
  __typename?: 'asset_energia_stddev_samp_fields';
  immessa?: Maybe<Scalars['Float']['output']>;
  prelevata?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_energia" */
export type Asset_Energia_Stddev_Samp_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_energia" */
export type Asset_Energia_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Energia_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Energia_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  immessa?: InputMaybe<Scalars['numeric']['input']>;
  prelevata?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Asset_Energia_Sum_Fields = {
  __typename?: 'asset_energia_sum_fields';
  immessa?: Maybe<Scalars['numeric']['output']>;
  prelevata?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset_energia" */
export type Asset_Energia_Sum_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** update columns of table "asset_energia" */
export enum Asset_Energia_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Immessa = 'immessa',
  /** column name */
  Prelevata = 'prelevata',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Energia_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Energia_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Energia_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Energia_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Energia_Var_Pop_Fields = {
  __typename?: 'asset_energia_var_pop_fields';
  immessa?: Maybe<Scalars['Float']['output']>;
  prelevata?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_energia" */
export type Asset_Energia_Var_Pop_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Energia_Var_Samp_Fields = {
  __typename?: 'asset_energia_var_samp_fields';
  immessa?: Maybe<Scalars['Float']['output']>;
  prelevata?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_energia" */
export type Asset_Energia_Var_Samp_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Energia_Variance_Fields = {
  __typename?: 'asset_energia_variance_fields';
  immessa?: Maybe<Scalars['Float']['output']>;
  prelevata?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_energia" */
export type Asset_Energia_Variance_Order_By = {
  immessa?: InputMaybe<Order_By>;
  prelevata?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_founder" */
export type Asset_Founder = {
  __typename?: 'asset_founder';
  asset_id: Scalars['uuid']['output'];
  auth_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "asset_founder" */
export type Asset_Founder_Aggregate = {
  __typename?: 'asset_founder_aggregate';
  aggregate?: Maybe<Asset_Founder_Aggregate_Fields>;
  nodes: Array<Asset_Founder>;
};

export type Asset_Founder_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Founder_Aggregate_Bool_Exp_Count>;
};

export type Asset_Founder_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Founder_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_founder" */
export type Asset_Founder_Aggregate_Fields = {
  __typename?: 'asset_founder_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Founder_Max_Fields>;
  min?: Maybe<Asset_Founder_Min_Fields>;
};


/** aggregate fields of "asset_founder" */
export type Asset_Founder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_founder" */
export type Asset_Founder_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Founder_Max_Order_By>;
  min?: InputMaybe<Asset_Founder_Min_Order_By>;
};

/** input type for inserting array relation for remote table "asset_founder" */
export type Asset_Founder_Arr_Rel_Insert_Input = {
  data: Array<Asset_Founder_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Founder_On_Conflict>;
};

/** Boolean expression to filter rows from the table "asset_founder". All fields are combined with a logical 'AND'. */
export type Asset_Founder_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Founder_Bool_Exp>>;
  _not?: InputMaybe<Asset_Founder_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Founder_Bool_Exp>>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_founder" */
export enum Asset_Founder_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetFounderPkey = 'asset_founder_pkey'
}

/** input type for inserting data into table "asset_founder" */
export type Asset_Founder_Insert_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Founder_Max_Fields = {
  __typename?: 'asset_founder_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_founder" */
export type Asset_Founder_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Founder_Min_Fields = {
  __typename?: 'asset_founder_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_founder" */
export type Asset_Founder_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_founder" */
export type Asset_Founder_Mutation_Response = {
  __typename?: 'asset_founder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Founder>;
};

/** on_conflict condition type for table "asset_founder" */
export type Asset_Founder_On_Conflict = {
  constraint: Asset_Founder_Constraint;
  update_columns?: Array<Asset_Founder_Update_Column>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_founder". */
export type Asset_Founder_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_founder */
export type Asset_Founder_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_founder" */
export enum Asset_Founder_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_founder" */
export type Asset_Founder_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "asset_founder" */
export type Asset_Founder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Founder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Founder_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "asset_founder" */
export enum Asset_Founder_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Founder_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Founder_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Founder_Bool_Exp;
};

/** columns and relationships of "asset_gestore" */
export type Asset_Gestore = {
  __typename?: 'asset_gestore';
  /** An object relationship */
  asset: Asset;
  asset_id: Scalars['uuid']['output'];
  auth_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  utente: Auth_User_Entity;
};

/** aggregated selection of "asset_gestore" */
export type Asset_Gestore_Aggregate = {
  __typename?: 'asset_gestore_aggregate';
  aggregate?: Maybe<Asset_Gestore_Aggregate_Fields>;
  nodes: Array<Asset_Gestore>;
};

export type Asset_Gestore_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Gestore_Aggregate_Bool_Exp_Count>;
};

export type Asset_Gestore_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Gestore_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_gestore" */
export type Asset_Gestore_Aggregate_Fields = {
  __typename?: 'asset_gestore_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Gestore_Max_Fields>;
  min?: Maybe<Asset_Gestore_Min_Fields>;
};


/** aggregate fields of "asset_gestore" */
export type Asset_Gestore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_gestore" */
export type Asset_Gestore_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Gestore_Max_Order_By>;
  min?: InputMaybe<Asset_Gestore_Min_Order_By>;
};

/** input type for inserting array relation for remote table "asset_gestore" */
export type Asset_Gestore_Arr_Rel_Insert_Input = {
  data: Array<Asset_Gestore_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Gestore_On_Conflict>;
};

/** Boolean expression to filter rows from the table "asset_gestore". All fields are combined with a logical 'AND'. */
export type Asset_Gestore_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Gestore_Bool_Exp>>;
  _not?: InputMaybe<Asset_Gestore_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Gestore_Bool_Exp>>;
  asset?: InputMaybe<Asset_Bool_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utente?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};

/** unique or primary key constraints on table "asset_gestore" */
export enum Asset_Gestore_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetGestorePkey = 'asset_gestore_pkey'
}

/** input type for inserting data into table "asset_gestore" */
export type Asset_Gestore_Insert_Input = {
  asset?: InputMaybe<Asset_Obj_Rel_Insert_Input>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utente?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Asset_Gestore_Max_Fields = {
  __typename?: 'asset_gestore_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_gestore" */
export type Asset_Gestore_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Gestore_Min_Fields = {
  __typename?: 'asset_gestore_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_gestore" */
export type Asset_Gestore_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_gestore" */
export type Asset_Gestore_Mutation_Response = {
  __typename?: 'asset_gestore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Gestore>;
};

/** on_conflict condition type for table "asset_gestore" */
export type Asset_Gestore_On_Conflict = {
  constraint: Asset_Gestore_Constraint;
  update_columns?: Array<Asset_Gestore_Update_Column>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_gestore". */
export type Asset_Gestore_Order_By = {
  asset?: InputMaybe<Asset_Order_By>;
  asset_id?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utente?: InputMaybe<Auth_User_Entity_Order_By>;
};

/** primary key columns input for table: asset_gestore */
export type Asset_Gestore_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_gestore" */
export enum Asset_Gestore_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_gestore" */
export type Asset_Gestore_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "asset_gestore" */
export type Asset_Gestore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Gestore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Gestore_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "asset_gestore" */
export enum Asset_Gestore_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Gestore_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Gestore_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Gestore_Bool_Exp;
};

/** input type for incrementing numeric columns in table "asset" */
export type Asset_Inc_Input = {
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  capacita_batteria_prevista?: InputMaybe<Scalars['numeric']['input']>;
  consumo?: InputMaybe<Scalars['numeric']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
  potenza_impianto_prevista?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset" */
export type Asset_Insert_Input = {
  aiuto?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  altre_info?: InputMaybe<Scalars['jsonb']['input']>;
  associato?: InputMaybe<Scalars['Boolean']['input']>;
  autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  cabina?: InputMaybe<Energy_Village_Cabina_Obj_Rel_Insert_Input>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  capacita_batteria_prevista?: InputMaybe<Scalars['numeric']['input']>;
  caratteristiche?: InputMaybe<Asset_Caratteristica_Arr_Rel_Insert_Input>;
  condivisioni?: InputMaybe<Condivisione_Condivisione_Arr_Rel_Insert_Input>;
  consumi?: InputMaybe<Asset_Consumo_Arr_Rel_Insert_Input>;
  consumo?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_allaccio_prevista?: InputMaybe<Scalars['timestamptz']['input']>;
  data_installazione_impianto?: InputMaybe<Scalars['timestamptz']['input']>;
  dimensione?: InputMaybe<Energy_Village_Dimensione_Obj_Rel_Insert_Input>;
  dimensione_id?: InputMaybe<Scalars['uuid']['input']>;
  domenica_id?: InputMaybe<Scalars['uuid']['input']>;
  energia?: InputMaybe<Asset_Energia_Arr_Rel_Insert_Input>;
  founders?: InputMaybe<Asset_Founder_Arr_Rel_Insert_Input>;
  gestori?: InputMaybe<Asset_Gestore_Arr_Rel_Insert_Input>;
  giovedi_id?: InputMaybe<Scalars['uuid']['input']>;
  has_sottoscrizioni_attive?: InputMaybe<Scalars['Boolean']['input']>;
  has_sottoscrizioni_non_attive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impianto?: InputMaybe<Scalars['Boolean']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['jsonb']['input']>;
  indirizzo?: InputMaybe<Indirizzo_Obj_Rel_Insert_Input>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  inseritore?: InputMaybe<Inseritore_Obj_Rel_Insert_Input>;
  inseritore_id?: InputMaybe<Scalars['uuid']['input']>;
  installatore?: InputMaybe<Installatore_Obj_Rel_Insert_Input>;
  installatore_id?: InputMaybe<Scalars['uuid']['input']>;
  lunedi_id?: InputMaybe<Scalars['uuid']['input']>;
  martedi_id?: InputMaybe<Scalars['uuid']['input']>;
  mercoledi_id?: InputMaybe<Scalars['uuid']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  opzionato?: InputMaybe<Scalars['Boolean']['input']>;
  posizione_esatta?: InputMaybe<Scalars['Boolean']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
  potenza_impianto_prevista?: InputMaybe<Scalars['numeric']['input']>;
  produzioni?: InputMaybe<Asset_Produzione_Arr_Rel_Insert_Input>;
  proprieta?: InputMaybe<Scalars['Boolean']['input']>;
  realizzando_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  sabato_id?: InputMaybe<Scalars['uuid']['input']>;
  scambio_su_posto?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  spazi_disponibili?: InputMaybe<Asset_Spazio_Arr_Rel_Insert_Input>;
  spazio_disponibile?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_abitativa?: InputMaybe<Energy_Village_Tipologia_Abitativa_Obj_Rel_Insert_Input>;
  tipologia_abitativa_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Obj_Rel_Insert_Input>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  venerdi_id?: InputMaybe<Scalars['uuid']['input']>;
  visibilita_nome?: InputMaybe<Scalars['Boolean']['input']>;
  white_label?: InputMaybe<White_Label_Configurazione_Obj_Rel_Insert_Input>;
  white_label_tag?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Asset_Max_Fields = {
  __typename?: 'asset_max_fields';
  alias?: Maybe<Scalars['String']['output']>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['numeric']['output']>;
  consumo?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_allaccio_prevista?: Maybe<Scalars['timestamptz']['output']>;
  data_installazione_impianto?: Maybe<Scalars['timestamptz']['output']>;
  dimensione_id?: Maybe<Scalars['uuid']['output']>;
  domenica_id?: Maybe<Scalars['uuid']['output']>;
  giovedi_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  inseritore_id?: Maybe<Scalars['uuid']['output']>;
  installatore_id?: Maybe<Scalars['uuid']['output']>;
  lunedi_id?: Maybe<Scalars['uuid']['output']>;
  martedi_id?: Maybe<Scalars['uuid']['output']>;
  mercoledi_id?: Maybe<Scalars['uuid']['output']>;
  notifiche?: Maybe<Scalars['Int']['output']>;
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva?: Maybe<Scalars['numeric']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['numeric']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  sabato_id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_abitativa_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  venerdi_id?: Maybe<Scalars['uuid']['output']>;
  white_label_tag?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "asset" */
export type Asset_Max_Order_By = {
  alias?: InputMaybe<Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_allaccio_prevista?: InputMaybe<Order_By>;
  data_installazione_impianto?: InputMaybe<Order_By>;
  dimensione_id?: InputMaybe<Order_By>;
  domenica_id?: InputMaybe<Order_By>;
  giovedi_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  inseritore_id?: InputMaybe<Order_By>;
  installatore_id?: InputMaybe<Order_By>;
  lunedi_id?: InputMaybe<Order_By>;
  martedi_id?: InputMaybe<Order_By>;
  mercoledi_id?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  sabato_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  tipologia_abitativa_id?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  venerdi_id?: InputMaybe<Order_By>;
  white_label_tag?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Min_Fields = {
  __typename?: 'asset_min_fields';
  alias?: Maybe<Scalars['String']['output']>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['numeric']['output']>;
  consumo?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_allaccio_prevista?: Maybe<Scalars['timestamptz']['output']>;
  data_installazione_impianto?: Maybe<Scalars['timestamptz']['output']>;
  dimensione_id?: Maybe<Scalars['uuid']['output']>;
  domenica_id?: Maybe<Scalars['uuid']['output']>;
  giovedi_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  inseritore_id?: Maybe<Scalars['uuid']['output']>;
  installatore_id?: Maybe<Scalars['uuid']['output']>;
  lunedi_id?: Maybe<Scalars['uuid']['output']>;
  martedi_id?: Maybe<Scalars['uuid']['output']>;
  mercoledi_id?: Maybe<Scalars['uuid']['output']>;
  notifiche?: Maybe<Scalars['Int']['output']>;
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva?: Maybe<Scalars['numeric']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['numeric']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  sabato_id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_abitativa_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  venerdi_id?: Maybe<Scalars['uuid']['output']>;
  white_label_tag?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "asset" */
export type Asset_Min_Order_By = {
  alias?: InputMaybe<Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_allaccio_prevista?: InputMaybe<Order_By>;
  data_installazione_impianto?: InputMaybe<Order_By>;
  dimensione_id?: InputMaybe<Order_By>;
  domenica_id?: InputMaybe<Order_By>;
  giovedi_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  inseritore_id?: InputMaybe<Order_By>;
  installatore_id?: InputMaybe<Order_By>;
  lunedi_id?: InputMaybe<Order_By>;
  martedi_id?: InputMaybe<Order_By>;
  mercoledi_id?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  sabato_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  tipologia_abitativa_id?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  venerdi_id?: InputMaybe<Order_By>;
  white_label_tag?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset" */
export type Asset_Mutation_Response = {
  __typename?: 'asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset>;
};

/** input type for inserting object relation for remote table "asset" */
export type Asset_Obj_Rel_Insert_Input = {
  data: Asset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_On_Conflict>;
};

/** on_conflict condition type for table "asset" */
export type Asset_On_Conflict = {
  constraint: Asset_Constraint;
  update_columns?: Array<Asset_Update_Column>;
  where?: InputMaybe<Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "asset". */
export type Asset_Order_By = {
  aiuto?: InputMaybe<Order_By>;
  alias?: InputMaybe<Order_By>;
  altre_info?: InputMaybe<Order_By>;
  associato?: InputMaybe<Order_By>;
  autoconsumo?: InputMaybe<Order_By>;
  cabina?: InputMaybe<Energy_Village_Cabina_Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  caratteristiche_aggregate?: InputMaybe<Asset_Caratteristica_Aggregate_Order_By>;
  condivisioni_aggregate?: InputMaybe<Condivisione_Condivisione_Aggregate_Order_By>;
  consumi_aggregate?: InputMaybe<Asset_Consumo_Aggregate_Order_By>;
  consumo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_allaccio_prevista?: InputMaybe<Order_By>;
  data_installazione_impianto?: InputMaybe<Order_By>;
  dimensione?: InputMaybe<Energy_Village_Dimensione_Order_By>;
  dimensione_id?: InputMaybe<Order_By>;
  domenica_id?: InputMaybe<Order_By>;
  energia_aggregate?: InputMaybe<Asset_Energia_Aggregate_Order_By>;
  founders_aggregate?: InputMaybe<Asset_Founder_Aggregate_Order_By>;
  gestori_aggregate?: InputMaybe<Asset_Gestore_Aggregate_Order_By>;
  giovedi_id?: InputMaybe<Order_By>;
  has_sottoscrizioni_attive?: InputMaybe<Order_By>;
  has_sottoscrizioni_non_attive?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impianto?: InputMaybe<Order_By>;
  incentivi_impianto?: InputMaybe<Order_By>;
  indirizzo?: InputMaybe<Indirizzo_Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  inseritore?: InputMaybe<Inseritore_Order_By>;
  inseritore_id?: InputMaybe<Order_By>;
  installatore?: InputMaybe<Installatore_Order_By>;
  installatore_id?: InputMaybe<Order_By>;
  lunedi_id?: InputMaybe<Order_By>;
  martedi_id?: InputMaybe<Order_By>;
  mercoledi_id?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  opzionato?: InputMaybe<Order_By>;
  posizione_esatta?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
  produzioni_aggregate?: InputMaybe<Asset_Produzione_Aggregate_Order_By>;
  proprieta?: InputMaybe<Order_By>;
  realizzando_impianto?: InputMaybe<Order_By>;
  richiesta_pnrr?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  sabato_id?: InputMaybe<Order_By>;
  scambio_su_posto?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  spazi_disponibili_aggregate?: InputMaybe<Asset_Spazio_Aggregate_Order_By>;
  spazio_disponibile?: InputMaybe<Order_By>;
  tipologia_abitativa?: InputMaybe<Energy_Village_Tipologia_Abitativa_Order_By>;
  tipologia_abitativa_id?: InputMaybe<Order_By>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  update?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  venerdi_id?: InputMaybe<Order_By>;
  visibilita_nome?: InputMaybe<Order_By>;
  white_label?: InputMaybe<White_Label_Configurazione_Order_By>;
  white_label_tag?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset */
export type Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Asset_Prepend_Input = {
  altre_info?: InputMaybe<Scalars['jsonb']['input']>;
  autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "asset_produzione" */
export type Asset_Produzione = {
  __typename?: 'asset_produzione';
  aderenza_delibera_autoconsumo?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  asset?: Maybe<Asset>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  cod_censimp?: Maybe<Scalars['String']['output']>;
  cod_richiesta_terna?: Maybe<Scalars['String']['output']>;
  codice_fatturato_pnrr?: Maybe<Scalars['String']['output']>;
  configurazione_accumulo_id?: Maybe<Scalars['uuid']['output']>;
  contratto_ridc?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  crtip?: Maybe<Scalars['numeric']['output']>;
  data_adesione_autoconsumo?: Maybe<Scalars['timestamptz']['output']>;
  data_installazione_impianto?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  delibera_gse_pnrr?: Maybe<Files>;
  delibera_gse_pnrr_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  documenti_pnrr: Array<Pnrr_Documenti>;
  /** An aggregate relationship */
  documenti_pnrr_aggregate: Pnrr_Documenti_Aggregate;
  energia_immessa?: Maybe<Scalars['numeric']['output']>;
  esito_pnrr?: Maybe<Scalars['Boolean']['output']>;
  foglio?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indirizzo?: Maybe<Indirizzo>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  intestatario?: Maybe<Persona>;
  intestatario_id?: Maybe<Scalars['uuid']['output']>;
  motivanzione_no_pnrr?: Maybe<Scalars['String']['output']>;
  particella?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva?: Maybe<Scalars['numeric']['output']>;
  prelievi_non_ausiliari?: Maybe<Scalars['Boolean']['output']>;
  presenza_accumulo?: Maybe<Scalars['Boolean']['output']>;
  referente_gse_email?: Maybe<Scalars['String']['output']>;
  referente_gse_nome?: Maybe<Scalars['String']['output']>;
  richiesta_modello_unico?: Maybe<Scalars['Boolean']['output']>;
  richiesta_pnrr?: Maybe<Scalars['Boolean']['output']>;
  sezione_catastale?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sottoscrizioni: Array<Sottoscrizione>;
  /** An aggregate relationship */
  sottoscrizioni_aggregate: Sottoscrizione_Aggregate;
  subalterno?: Maybe<Scalars['String']['output']>;
  tipologia_impianto_id?: Maybe<Scalars['uuid']['output']>;
  ubicazione_impianto_aderente?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  unita: Array<Asset_Produzione_Unita>;
  /** An aggregate relationship */
  unita_aggregate: Asset_Produzione_Unita_Aggregate;
  update: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "asset_produzione" */
export type Asset_ProduzioneDocumenti_PnrrArgs = {
  distinct_on?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pnrr_Documenti_Order_By>>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};


/** columns and relationships of "asset_produzione" */
export type Asset_ProduzioneDocumenti_Pnrr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pnrr_Documenti_Order_By>>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};


/** columns and relationships of "asset_produzione" */
export type Asset_ProduzioneSottoscrizioniArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "asset_produzione" */
export type Asset_ProduzioneSottoscrizioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "asset_produzione" */
export type Asset_ProduzioneUnitaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};


/** columns and relationships of "asset_produzione" */
export type Asset_ProduzioneUnita_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};

/** aggregated selection of "asset_produzione" */
export type Asset_Produzione_Aggregate = {
  __typename?: 'asset_produzione_aggregate';
  aggregate?: Maybe<Asset_Produzione_Aggregate_Fields>;
  nodes: Array<Asset_Produzione>;
};

export type Asset_Produzione_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Asset_Produzione_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Asset_Produzione_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Asset_Produzione_Aggregate_Bool_Exp_Count>;
};

export type Asset_Produzione_Aggregate_Bool_Exp_Bool_And = {
  arguments: Asset_Produzione_Select_Column_Asset_Produzione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Produzione_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Asset_Produzione_Select_Column_Asset_Produzione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Produzione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_produzione" */
export type Asset_Produzione_Aggregate_Fields = {
  __typename?: 'asset_produzione_aggregate_fields';
  avg?: Maybe<Asset_Produzione_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Produzione_Max_Fields>;
  min?: Maybe<Asset_Produzione_Min_Fields>;
  stddev?: Maybe<Asset_Produzione_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Produzione_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Produzione_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Produzione_Sum_Fields>;
  var_pop?: Maybe<Asset_Produzione_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Produzione_Var_Samp_Fields>;
  variance?: Maybe<Asset_Produzione_Variance_Fields>;
};


/** aggregate fields of "asset_produzione" */
export type Asset_Produzione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_produzione" */
export type Asset_Produzione_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Produzione_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Produzione_Max_Order_By>;
  min?: InputMaybe<Asset_Produzione_Min_Order_By>;
  stddev?: InputMaybe<Asset_Produzione_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Produzione_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Produzione_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Produzione_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Produzione_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Produzione_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Produzione_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_produzione" */
export type Asset_Produzione_Arr_Rel_Insert_Input = {
  data: Array<Asset_Produzione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Produzione_Avg_Fields = {
  __typename?: 'asset_produzione_avg_fields';
  crtip?: Maybe<Scalars['Float']['output']>;
  energia_immessa?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_produzione" */
export type Asset_Produzione_Avg_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_produzione". All fields are combined with a logical 'AND'. */
export type Asset_Produzione_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Produzione_Bool_Exp>>;
  _not?: InputMaybe<Asset_Produzione_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Produzione_Bool_Exp>>;
  aderenza_delibera_autoconsumo?: InputMaybe<Boolean_Comparison_Exp>;
  asset?: InputMaybe<Asset_Bool_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  cod_censimp?: InputMaybe<String_Comparison_Exp>;
  cod_richiesta_terna?: InputMaybe<String_Comparison_Exp>;
  codice_fatturato_pnrr?: InputMaybe<String_Comparison_Exp>;
  configurazione_accumulo_id?: InputMaybe<Uuid_Comparison_Exp>;
  contratto_ridc?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crtip?: InputMaybe<Numeric_Comparison_Exp>;
  data_adesione_autoconsumo?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_installazione_impianto?: InputMaybe<Timestamptz_Comparison_Exp>;
  delibera_gse_pnrr?: InputMaybe<Files_Bool_Exp>;
  delibera_gse_pnrr_id?: InputMaybe<Uuid_Comparison_Exp>;
  documenti_pnrr?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
  documenti_pnrr_aggregate?: InputMaybe<Pnrr_Documenti_Aggregate_Bool_Exp>;
  energia_immessa?: InputMaybe<Numeric_Comparison_Exp>;
  esito_pnrr?: InputMaybe<Boolean_Comparison_Exp>;
  foglio?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indirizzo?: InputMaybe<Indirizzo_Bool_Exp>;
  indirizzo_id?: InputMaybe<Uuid_Comparison_Exp>;
  intestatario?: InputMaybe<Persona_Bool_Exp>;
  intestatario_id?: InputMaybe<Uuid_Comparison_Exp>;
  motivanzione_no_pnrr?: InputMaybe<String_Comparison_Exp>;
  particella?: InputMaybe<String_Comparison_Exp>;
  pod?: InputMaybe<String_Comparison_Exp>;
  potenza_batteria?: InputMaybe<Numeric_Comparison_Exp>;
  potenza_effettiva?: InputMaybe<Numeric_Comparison_Exp>;
  prelievi_non_ausiliari?: InputMaybe<Boolean_Comparison_Exp>;
  presenza_accumulo?: InputMaybe<Boolean_Comparison_Exp>;
  referente_gse_email?: InputMaybe<String_Comparison_Exp>;
  referente_gse_nome?: InputMaybe<String_Comparison_Exp>;
  richiesta_modello_unico?: InputMaybe<Boolean_Comparison_Exp>;
  richiesta_pnrr?: InputMaybe<Boolean_Comparison_Exp>;
  sezione_catastale?: InputMaybe<String_Comparison_Exp>;
  sottoscrizioni?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizioni_aggregate?: InputMaybe<Sottoscrizione_Aggregate_Bool_Exp>;
  subalterno?: InputMaybe<String_Comparison_Exp>;
  tipologia_impianto_id?: InputMaybe<Uuid_Comparison_Exp>;
  ubicazione_impianto_aderente?: InputMaybe<Boolean_Comparison_Exp>;
  unita?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
  unita_aggregate?: InputMaybe<Asset_Produzione_Unita_Aggregate_Bool_Exp>;
  update?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_produzione" */
export enum Asset_Produzione_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetProduzionePkey = 'asset_produzione_pkey'
}

/** input type for incrementing numeric columns in table "asset_produzione" */
export type Asset_Produzione_Inc_Input = {
  crtip?: InputMaybe<Scalars['numeric']['input']>;
  energia_immessa?: InputMaybe<Scalars['numeric']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset_produzione" */
export type Asset_Produzione_Insert_Input = {
  aderenza_delibera_autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  asset?: InputMaybe<Asset_Obj_Rel_Insert_Input>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  cod_censimp?: InputMaybe<Scalars['String']['input']>;
  cod_richiesta_terna?: InputMaybe<Scalars['String']['input']>;
  codice_fatturato_pnrr?: InputMaybe<Scalars['String']['input']>;
  configurazione_accumulo_id?: InputMaybe<Scalars['uuid']['input']>;
  contratto_ridc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crtip?: InputMaybe<Scalars['numeric']['input']>;
  data_adesione_autoconsumo?: InputMaybe<Scalars['timestamptz']['input']>;
  data_installazione_impianto?: InputMaybe<Scalars['timestamptz']['input']>;
  delibera_gse_pnrr?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  delibera_gse_pnrr_id?: InputMaybe<Scalars['uuid']['input']>;
  documenti_pnrr?: InputMaybe<Pnrr_Documenti_Arr_Rel_Insert_Input>;
  energia_immessa?: InputMaybe<Scalars['numeric']['input']>;
  esito_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  foglio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indirizzo?: InputMaybe<Indirizzo_Obj_Rel_Insert_Input>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  intestatario_id?: InputMaybe<Scalars['uuid']['input']>;
  motivanzione_no_pnrr?: InputMaybe<Scalars['String']['input']>;
  particella?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
  prelievi_non_ausiliari?: InputMaybe<Scalars['Boolean']['input']>;
  presenza_accumulo?: InputMaybe<Scalars['Boolean']['input']>;
  referente_gse_email?: InputMaybe<Scalars['String']['input']>;
  referente_gse_nome?: InputMaybe<Scalars['String']['input']>;
  richiesta_modello_unico?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  sezione_catastale?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioni?: InputMaybe<Sottoscrizione_Arr_Rel_Insert_Input>;
  subalterno?: InputMaybe<Scalars['String']['input']>;
  tipologia_impianto_id?: InputMaybe<Scalars['uuid']['input']>;
  ubicazione_impianto_aderente?: InputMaybe<Scalars['Boolean']['input']>;
  unita?: InputMaybe<Asset_Produzione_Unita_Arr_Rel_Insert_Input>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Produzione_Max_Fields = {
  __typename?: 'asset_produzione_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  cod_censimp?: Maybe<Scalars['String']['output']>;
  cod_richiesta_terna?: Maybe<Scalars['String']['output']>;
  codice_fatturato_pnrr?: Maybe<Scalars['String']['output']>;
  configurazione_accumulo_id?: Maybe<Scalars['uuid']['output']>;
  contratto_ridc?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crtip?: Maybe<Scalars['numeric']['output']>;
  data_adesione_autoconsumo?: Maybe<Scalars['timestamptz']['output']>;
  data_installazione_impianto?: Maybe<Scalars['timestamptz']['output']>;
  delibera_gse_pnrr_id?: Maybe<Scalars['uuid']['output']>;
  energia_immessa?: Maybe<Scalars['numeric']['output']>;
  foglio?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  intestatario_id?: Maybe<Scalars['uuid']['output']>;
  motivanzione_no_pnrr?: Maybe<Scalars['String']['output']>;
  particella?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva?: Maybe<Scalars['numeric']['output']>;
  referente_gse_email?: Maybe<Scalars['String']['output']>;
  referente_gse_nome?: Maybe<Scalars['String']['output']>;
  sezione_catastale?: Maybe<Scalars['String']['output']>;
  subalterno?: Maybe<Scalars['String']['output']>;
  tipologia_impianto_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_produzione" */
export type Asset_Produzione_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  cod_censimp?: InputMaybe<Order_By>;
  cod_richiesta_terna?: InputMaybe<Order_By>;
  codice_fatturato_pnrr?: InputMaybe<Order_By>;
  configurazione_accumulo_id?: InputMaybe<Order_By>;
  contratto_ridc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crtip?: InputMaybe<Order_By>;
  data_adesione_autoconsumo?: InputMaybe<Order_By>;
  data_installazione_impianto?: InputMaybe<Order_By>;
  delibera_gse_pnrr_id?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  foglio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  intestatario_id?: InputMaybe<Order_By>;
  motivanzione_no_pnrr?: InputMaybe<Order_By>;
  particella?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  referente_gse_email?: InputMaybe<Order_By>;
  referente_gse_nome?: InputMaybe<Order_By>;
  sezione_catastale?: InputMaybe<Order_By>;
  subalterno?: InputMaybe<Order_By>;
  tipologia_impianto_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Produzione_Min_Fields = {
  __typename?: 'asset_produzione_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  cod_censimp?: Maybe<Scalars['String']['output']>;
  cod_richiesta_terna?: Maybe<Scalars['String']['output']>;
  codice_fatturato_pnrr?: Maybe<Scalars['String']['output']>;
  configurazione_accumulo_id?: Maybe<Scalars['uuid']['output']>;
  contratto_ridc?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crtip?: Maybe<Scalars['numeric']['output']>;
  data_adesione_autoconsumo?: Maybe<Scalars['timestamptz']['output']>;
  data_installazione_impianto?: Maybe<Scalars['timestamptz']['output']>;
  delibera_gse_pnrr_id?: Maybe<Scalars['uuid']['output']>;
  energia_immessa?: Maybe<Scalars['numeric']['output']>;
  foglio?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  intestatario_id?: Maybe<Scalars['uuid']['output']>;
  motivanzione_no_pnrr?: Maybe<Scalars['String']['output']>;
  particella?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva?: Maybe<Scalars['numeric']['output']>;
  referente_gse_email?: Maybe<Scalars['String']['output']>;
  referente_gse_nome?: Maybe<Scalars['String']['output']>;
  sezione_catastale?: Maybe<Scalars['String']['output']>;
  subalterno?: Maybe<Scalars['String']['output']>;
  tipologia_impianto_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_produzione" */
export type Asset_Produzione_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  cod_censimp?: InputMaybe<Order_By>;
  cod_richiesta_terna?: InputMaybe<Order_By>;
  codice_fatturato_pnrr?: InputMaybe<Order_By>;
  configurazione_accumulo_id?: InputMaybe<Order_By>;
  contratto_ridc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crtip?: InputMaybe<Order_By>;
  data_adesione_autoconsumo?: InputMaybe<Order_By>;
  data_installazione_impianto?: InputMaybe<Order_By>;
  delibera_gse_pnrr_id?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  foglio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  intestatario_id?: InputMaybe<Order_By>;
  motivanzione_no_pnrr?: InputMaybe<Order_By>;
  particella?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  referente_gse_email?: InputMaybe<Order_By>;
  referente_gse_nome?: InputMaybe<Order_By>;
  sezione_catastale?: InputMaybe<Order_By>;
  subalterno?: InputMaybe<Order_By>;
  tipologia_impianto_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_produzione" */
export type Asset_Produzione_Mutation_Response = {
  __typename?: 'asset_produzione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Produzione>;
};

/** input type for inserting object relation for remote table "asset_produzione" */
export type Asset_Produzione_Obj_Rel_Insert_Input = {
  data: Asset_Produzione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_On_Conflict>;
};

/** on_conflict condition type for table "asset_produzione" */
export type Asset_Produzione_On_Conflict = {
  constraint: Asset_Produzione_Constraint;
  update_columns?: Array<Asset_Produzione_Update_Column>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_produzione". */
export type Asset_Produzione_Order_By = {
  aderenza_delibera_autoconsumo?: InputMaybe<Order_By>;
  asset?: InputMaybe<Asset_Order_By>;
  asset_id?: InputMaybe<Order_By>;
  cod_censimp?: InputMaybe<Order_By>;
  cod_richiesta_terna?: InputMaybe<Order_By>;
  codice_fatturato_pnrr?: InputMaybe<Order_By>;
  configurazione_accumulo_id?: InputMaybe<Order_By>;
  contratto_ridc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crtip?: InputMaybe<Order_By>;
  data_adesione_autoconsumo?: InputMaybe<Order_By>;
  data_installazione_impianto?: InputMaybe<Order_By>;
  delibera_gse_pnrr?: InputMaybe<Files_Order_By>;
  delibera_gse_pnrr_id?: InputMaybe<Order_By>;
  documenti_pnrr_aggregate?: InputMaybe<Pnrr_Documenti_Aggregate_Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  esito_pnrr?: InputMaybe<Order_By>;
  foglio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo?: InputMaybe<Indirizzo_Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  intestatario?: InputMaybe<Persona_Order_By>;
  intestatario_id?: InputMaybe<Order_By>;
  motivanzione_no_pnrr?: InputMaybe<Order_By>;
  particella?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  prelievi_non_ausiliari?: InputMaybe<Order_By>;
  presenza_accumulo?: InputMaybe<Order_By>;
  referente_gse_email?: InputMaybe<Order_By>;
  referente_gse_nome?: InputMaybe<Order_By>;
  richiesta_modello_unico?: InputMaybe<Order_By>;
  richiesta_pnrr?: InputMaybe<Order_By>;
  sezione_catastale?: InputMaybe<Order_By>;
  sottoscrizioni_aggregate?: InputMaybe<Sottoscrizione_Aggregate_Order_By>;
  subalterno?: InputMaybe<Order_By>;
  tipologia_impianto_id?: InputMaybe<Order_By>;
  ubicazione_impianto_aderente?: InputMaybe<Order_By>;
  unita_aggregate?: InputMaybe<Asset_Produzione_Unita_Aggregate_Order_By>;
  update?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_produzione */
export type Asset_Produzione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_produzione" */
export enum Asset_Produzione_Select_Column {
  /** column name */
  AderenzaDeliberaAutoconsumo = 'aderenza_delibera_autoconsumo',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CodCensimp = 'cod_censimp',
  /** column name */
  CodRichiestaTerna = 'cod_richiesta_terna',
  /** column name */
  CodiceFatturatoPnrr = 'codice_fatturato_pnrr',
  /** column name */
  ConfigurazioneAccumuloId = 'configurazione_accumulo_id',
  /** column name */
  ContrattoRidc = 'contratto_ridc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crtip = 'crtip',
  /** column name */
  DataAdesioneAutoconsumo = 'data_adesione_autoconsumo',
  /** column name */
  DataInstallazioneImpianto = 'data_installazione_impianto',
  /** column name */
  DeliberaGsePnrrId = 'delibera_gse_pnrr_id',
  /** column name */
  EnergiaImmessa = 'energia_immessa',
  /** column name */
  EsitoPnrr = 'esito_pnrr',
  /** column name */
  Foglio = 'foglio',
  /** column name */
  Id = 'id',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  IntestatarioId = 'intestatario_id',
  /** column name */
  MotivanzioneNoPnrr = 'motivanzione_no_pnrr',
  /** column name */
  Particella = 'particella',
  /** column name */
  Pod = 'pod',
  /** column name */
  PotenzaBatteria = 'potenza_batteria',
  /** column name */
  PotenzaEffettiva = 'potenza_effettiva',
  /** column name */
  PrelieviNonAusiliari = 'prelievi_non_ausiliari',
  /** column name */
  PresenzaAccumulo = 'presenza_accumulo',
  /** column name */
  ReferenteGseEmail = 'referente_gse_email',
  /** column name */
  ReferenteGseNome = 'referente_gse_nome',
  /** column name */
  RichiestaModelloUnico = 'richiesta_modello_unico',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  SezioneCatastale = 'sezione_catastale',
  /** column name */
  Subalterno = 'subalterno',
  /** column name */
  TipologiaImpiantoId = 'tipologia_impianto_id',
  /** column name */
  UbicazioneImpiantoAderente = 'ubicazione_impianto_aderente',
  /** column name */
  Update = 'update',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "asset_produzione_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_produzione" */
export enum Asset_Produzione_Select_Column_Asset_Produzione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AderenzaDeliberaAutoconsumo = 'aderenza_delibera_autoconsumo',
  /** column name */
  EsitoPnrr = 'esito_pnrr',
  /** column name */
  PrelieviNonAusiliari = 'prelievi_non_ausiliari',
  /** column name */
  PresenzaAccumulo = 'presenza_accumulo',
  /** column name */
  RichiestaModelloUnico = 'richiesta_modello_unico',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  UbicazioneImpiantoAderente = 'ubicazione_impianto_aderente',
  /** column name */
  Update = 'update'
}

/** select "asset_produzione_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_produzione" */
export enum Asset_Produzione_Select_Column_Asset_Produzione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AderenzaDeliberaAutoconsumo = 'aderenza_delibera_autoconsumo',
  /** column name */
  EsitoPnrr = 'esito_pnrr',
  /** column name */
  PrelieviNonAusiliari = 'prelievi_non_ausiliari',
  /** column name */
  PresenzaAccumulo = 'presenza_accumulo',
  /** column name */
  RichiestaModelloUnico = 'richiesta_modello_unico',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  UbicazioneImpiantoAderente = 'ubicazione_impianto_aderente',
  /** column name */
  Update = 'update'
}

/** input type for updating data in table "asset_produzione" */
export type Asset_Produzione_Set_Input = {
  aderenza_delibera_autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  cod_censimp?: InputMaybe<Scalars['String']['input']>;
  cod_richiesta_terna?: InputMaybe<Scalars['String']['input']>;
  codice_fatturato_pnrr?: InputMaybe<Scalars['String']['input']>;
  configurazione_accumulo_id?: InputMaybe<Scalars['uuid']['input']>;
  contratto_ridc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crtip?: InputMaybe<Scalars['numeric']['input']>;
  data_adesione_autoconsumo?: InputMaybe<Scalars['timestamptz']['input']>;
  data_installazione_impianto?: InputMaybe<Scalars['timestamptz']['input']>;
  delibera_gse_pnrr_id?: InputMaybe<Scalars['uuid']['input']>;
  energia_immessa?: InputMaybe<Scalars['numeric']['input']>;
  esito_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  foglio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario_id?: InputMaybe<Scalars['uuid']['input']>;
  motivanzione_no_pnrr?: InputMaybe<Scalars['String']['input']>;
  particella?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
  prelievi_non_ausiliari?: InputMaybe<Scalars['Boolean']['input']>;
  presenza_accumulo?: InputMaybe<Scalars['Boolean']['input']>;
  referente_gse_email?: InputMaybe<Scalars['String']['input']>;
  referente_gse_nome?: InputMaybe<Scalars['String']['input']>;
  richiesta_modello_unico?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  sezione_catastale?: InputMaybe<Scalars['String']['input']>;
  subalterno?: InputMaybe<Scalars['String']['input']>;
  tipologia_impianto_id?: InputMaybe<Scalars['uuid']['input']>;
  ubicazione_impianto_aderente?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Produzione_Stddev_Fields = {
  __typename?: 'asset_produzione_stddev_fields';
  crtip?: Maybe<Scalars['Float']['output']>;
  energia_immessa?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_produzione" */
export type Asset_Produzione_Stddev_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Produzione_Stddev_Pop_Fields = {
  __typename?: 'asset_produzione_stddev_pop_fields';
  crtip?: Maybe<Scalars['Float']['output']>;
  energia_immessa?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_produzione" */
export type Asset_Produzione_Stddev_Pop_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Produzione_Stddev_Samp_Fields = {
  __typename?: 'asset_produzione_stddev_samp_fields';
  crtip?: Maybe<Scalars['Float']['output']>;
  energia_immessa?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_produzione" */
export type Asset_Produzione_Stddev_Samp_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_produzione" */
export type Asset_Produzione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Produzione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Produzione_Stream_Cursor_Value_Input = {
  aderenza_delibera_autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  cod_censimp?: InputMaybe<Scalars['String']['input']>;
  cod_richiesta_terna?: InputMaybe<Scalars['String']['input']>;
  codice_fatturato_pnrr?: InputMaybe<Scalars['String']['input']>;
  configurazione_accumulo_id?: InputMaybe<Scalars['uuid']['input']>;
  contratto_ridc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crtip?: InputMaybe<Scalars['numeric']['input']>;
  data_adesione_autoconsumo?: InputMaybe<Scalars['timestamptz']['input']>;
  data_installazione_impianto?: InputMaybe<Scalars['timestamptz']['input']>;
  delibera_gse_pnrr_id?: InputMaybe<Scalars['uuid']['input']>;
  energia_immessa?: InputMaybe<Scalars['numeric']['input']>;
  esito_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  foglio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario_id?: InputMaybe<Scalars['uuid']['input']>;
  motivanzione_no_pnrr?: InputMaybe<Scalars['String']['input']>;
  particella?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
  prelievi_non_ausiliari?: InputMaybe<Scalars['Boolean']['input']>;
  presenza_accumulo?: InputMaybe<Scalars['Boolean']['input']>;
  referente_gse_email?: InputMaybe<Scalars['String']['input']>;
  referente_gse_nome?: InputMaybe<Scalars['String']['input']>;
  richiesta_modello_unico?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  sezione_catastale?: InputMaybe<Scalars['String']['input']>;
  subalterno?: InputMaybe<Scalars['String']['input']>;
  tipologia_impianto_id?: InputMaybe<Scalars['uuid']['input']>;
  ubicazione_impianto_aderente?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Asset_Produzione_Sum_Fields = {
  __typename?: 'asset_produzione_sum_fields';
  crtip?: Maybe<Scalars['numeric']['output']>;
  energia_immessa?: Maybe<Scalars['numeric']['output']>;
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset_produzione" */
export type Asset_Produzione_Sum_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_produzione_unita" */
export type Asset_Produzione_Unita = {
  __typename?: 'asset_produzione_unita';
  /** An object relationship */
  asset_produzione: Asset_Produzione;
  asset_produzione_id: Scalars['uuid']['output'];
  cod_up?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  data_attivazione?: Maybe<Scalars['timestamptz']['output']>;
  data_disattivazione?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  sezioni: Array<Asset_Produzione_Unita_Sezione>;
  /** An aggregate relationship */
  sezioni_aggregate: Asset_Produzione_Unita_Sezione_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "asset_produzione_unita" */
export type Asset_Produzione_UnitaSezioniArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};


/** columns and relationships of "asset_produzione_unita" */
export type Asset_Produzione_UnitaSezioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};

/** aggregated selection of "asset_produzione_unita" */
export type Asset_Produzione_Unita_Aggregate = {
  __typename?: 'asset_produzione_unita_aggregate';
  aggregate?: Maybe<Asset_Produzione_Unita_Aggregate_Fields>;
  nodes: Array<Asset_Produzione_Unita>;
};

export type Asset_Produzione_Unita_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Produzione_Unita_Aggregate_Bool_Exp_Count>;
};

export type Asset_Produzione_Unita_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_produzione_unita" */
export type Asset_Produzione_Unita_Aggregate_Fields = {
  __typename?: 'asset_produzione_unita_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Produzione_Unita_Max_Fields>;
  min?: Maybe<Asset_Produzione_Unita_Min_Fields>;
};


/** aggregate fields of "asset_produzione_unita" */
export type Asset_Produzione_Unita_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Produzione_Unita_Max_Order_By>;
  min?: InputMaybe<Asset_Produzione_Unita_Min_Order_By>;
};

/** input type for inserting array relation for remote table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Arr_Rel_Insert_Input = {
  data: Array<Asset_Produzione_Unita_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_Unita_On_Conflict>;
};

/** Boolean expression to filter rows from the table "asset_produzione_unita". All fields are combined with a logical 'AND'. */
export type Asset_Produzione_Unita_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Produzione_Unita_Bool_Exp>>;
  _not?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Produzione_Unita_Bool_Exp>>;
  asset_produzione?: InputMaybe<Asset_Produzione_Bool_Exp>;
  asset_produzione_id?: InputMaybe<Uuid_Comparison_Exp>;
  cod_up?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_attivazione?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_disattivazione?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sezioni?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
  sezioni_aggregate?: InputMaybe<Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_produzione_unita" */
export enum Asset_Produzione_Unita_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetProduzioneUnitaPkey = 'asset_produzione_unita_pkey'
}

/** input type for inserting data into table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Insert_Input = {
  asset_produzione?: InputMaybe<Asset_Produzione_Obj_Rel_Insert_Input>;
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  cod_up?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_attivazione?: InputMaybe<Scalars['timestamptz']['input']>;
  data_disattivazione?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sezioni?: InputMaybe<Asset_Produzione_Unita_Sezione_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Produzione_Unita_Max_Fields = {
  __typename?: 'asset_produzione_unita_max_fields';
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  cod_up?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_attivazione?: Maybe<Scalars['timestamptz']['output']>;
  data_disattivazione?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Max_Order_By = {
  asset_produzione_id?: InputMaybe<Order_By>;
  cod_up?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_attivazione?: InputMaybe<Order_By>;
  data_disattivazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Produzione_Unita_Min_Fields = {
  __typename?: 'asset_produzione_unita_min_fields';
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  cod_up?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_attivazione?: Maybe<Scalars['timestamptz']['output']>;
  data_disattivazione?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Min_Order_By = {
  asset_produzione_id?: InputMaybe<Order_By>;
  cod_up?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_attivazione?: InputMaybe<Order_By>;
  data_disattivazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Mutation_Response = {
  __typename?: 'asset_produzione_unita_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Produzione_Unita>;
};

/** input type for inserting object relation for remote table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Obj_Rel_Insert_Input = {
  data: Asset_Produzione_Unita_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_Unita_On_Conflict>;
};

/** on_conflict condition type for table "asset_produzione_unita" */
export type Asset_Produzione_Unita_On_Conflict = {
  constraint: Asset_Produzione_Unita_Constraint;
  update_columns?: Array<Asset_Produzione_Unita_Update_Column>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_produzione_unita". */
export type Asset_Produzione_Unita_Order_By = {
  asset_produzione?: InputMaybe<Asset_Produzione_Order_By>;
  asset_produzione_id?: InputMaybe<Order_By>;
  cod_up?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_attivazione?: InputMaybe<Order_By>;
  data_disattivazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sezioni_aggregate?: InputMaybe<Asset_Produzione_Unita_Sezione_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_produzione_unita */
export type Asset_Produzione_Unita_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_produzione_unita" */
export enum Asset_Produzione_Unita_Select_Column {
  /** column name */
  AssetProduzioneId = 'asset_produzione_id',
  /** column name */
  CodUp = 'cod_up',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataAttivazione = 'data_attivazione',
  /** column name */
  DataDisattivazione = 'data_disattivazione',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Set_Input = {
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  cod_up?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_attivazione?: InputMaybe<Scalars['timestamptz']['input']>;
  data_disattivazione?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione = {
  __typename?: 'asset_produzione_unita_sezione';
  /** An object relationship */
  asset_produzione_unita: Asset_Produzione_Unita;
  asset_produzione_unita_id: Scalars['uuid']['output'];
  codice_sezione?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  data_decorrenza_autoconsumo?: Maybe<Scalars['timestamptz']['output']>;
  dispositivo_inseguimento_solare?: Maybe<Scalars['Boolean']['output']>;
  esposizione_prevalente_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  incentivi: Array<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** An aggregate relationship */
  incentivi_aggregate: Asset_Produzione_Unita_Sezione_Incentivi_Aggregate;
  inclinazione_prevalente?: Maybe<Scalars['Int']['output']>;
  incompatibilita_incentivi_altro?: Maybe<Scalars['String']['output']>;
  incompatibilita_incentivi_id?: Maybe<Scalars['uuid']['output']>;
  pannelli_bifacciali?: Maybe<Scalars['Boolean']['output']>;
  tipologia_sito_impianto_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  titoli_autorizzativi: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** An aggregate relationship */
  titoli_autorizzativi_aggregate: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_SezioneIncentiviArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};


/** columns and relationships of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_SezioneIncentivi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};


/** columns and relationships of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_SezioneTitoli_AutorizzativiArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};


/** columns and relationships of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_SezioneTitoli_Autorizzativi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};

/** aggregated selection of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Aggregate = {
  __typename?: 'asset_produzione_unita_sezione_aggregate';
  aggregate?: Maybe<Asset_Produzione_Unita_Sezione_Aggregate_Fields>;
  nodes: Array<Asset_Produzione_Unita_Sezione>;
};

export type Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Count>;
};

export type Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_And = {
  arguments: Asset_Produzione_Unita_Sezione_Select_Column_Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Asset_Produzione_Unita_Sezione_Select_Column_Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Aggregate_Fields = {
  __typename?: 'asset_produzione_unita_sezione_aggregate_fields';
  avg?: Maybe<Asset_Produzione_Unita_Sezione_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Produzione_Unita_Sezione_Max_Fields>;
  min?: Maybe<Asset_Produzione_Unita_Sezione_Min_Fields>;
  stddev?: Maybe<Asset_Produzione_Unita_Sezione_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Produzione_Unita_Sezione_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Produzione_Unita_Sezione_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Produzione_Unita_Sezione_Sum_Fields>;
  var_pop?: Maybe<Asset_Produzione_Unita_Sezione_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Produzione_Unita_Sezione_Var_Samp_Fields>;
  variance?: Maybe<Asset_Produzione_Unita_Sezione_Variance_Fields>;
};


/** aggregate fields of "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Produzione_Unita_Sezione_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Produzione_Unita_Sezione_Max_Order_By>;
  min?: InputMaybe<Asset_Produzione_Unita_Sezione_Min_Order_By>;
  stddev?: InputMaybe<Asset_Produzione_Unita_Sezione_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Produzione_Unita_Sezione_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Produzione_Unita_Sezione_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Produzione_Unita_Sezione_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Produzione_Unita_Sezione_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Produzione_Unita_Sezione_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Produzione_Unita_Sezione_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Arr_Rel_Insert_Input = {
  data: Array<Asset_Produzione_Unita_Sezione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Produzione_Unita_Sezione_Avg_Fields = {
  __typename?: 'asset_produzione_unita_sezione_avg_fields';
  inclinazione_prevalente?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Avg_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_produzione_unita_sezione". All fields are combined with a logical 'AND'. */
export type Asset_Produzione_Unita_Sezione_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Bool_Exp>>;
  _not?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Bool_Exp>>;
  asset_produzione_unita?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
  asset_produzione_unita_id?: InputMaybe<Uuid_Comparison_Exp>;
  codice_sezione?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_decorrenza_autoconsumo?: InputMaybe<Timestamptz_Comparison_Exp>;
  dispositivo_inseguimento_solare?: InputMaybe<Boolean_Comparison_Exp>;
  esposizione_prevalente_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  incentivi?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
  incentivi_aggregate?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp>;
  inclinazione_prevalente?: InputMaybe<Int_Comparison_Exp>;
  incompatibilita_incentivi_altro?: InputMaybe<String_Comparison_Exp>;
  incompatibilita_incentivi_id?: InputMaybe<Uuid_Comparison_Exp>;
  pannelli_bifacciali?: InputMaybe<Boolean_Comparison_Exp>;
  tipologia_sito_impianto_id?: InputMaybe<Uuid_Comparison_Exp>;
  titoli_autorizzativi?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
  titoli_autorizzativi_aggregate?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_produzione_unita_sezione" */
export enum Asset_Produzione_Unita_Sezione_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetProduzioneUnitaSezionePkey = 'asset_produzione_unita_sezione_pkey'
}

/** input type for incrementing numeric columns in table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Inc_Input = {
  inclinazione_prevalente?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi = {
  __typename?: 'asset_produzione_unita_sezione_incentivi';
  /** An object relationship */
  asset_produzione_unita_sezione: Asset_Produzione_Unita_Sezione;
  asset_produzione_unita_sezione_id: Scalars['uuid']['output'];
  contributi_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  quota_incentivo?: Maybe<Scalars['Int']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['numeric']['output']>;
  rispetto_principio_dns?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  usufruito_incentivi_rilancio?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_aggregate';
  aggregate?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Fields>;
  nodes: Array<Asset_Produzione_Unita_Sezione_Incentivi>;
};

export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Count>;
};

export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_And = {
  arguments: Asset_Produzione_Unita_Sezione_Incentivi_Select_Column_Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Asset_Produzione_Unita_Sezione_Incentivi_Select_Column_Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_aggregate_fields';
  avg?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Max_Fields>;
  min?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Min_Fields>;
  stddev?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Sum_Fields>;
  var_pop?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Var_Samp_Fields>;
  variance?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Variance_Fields>;
};


/** aggregate fields of "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Max_Order_By>;
  min?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Min_Order_By>;
  stddev?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Arr_Rel_Insert_Input = {
  data: Array<Asset_Produzione_Unita_Sezione_Incentivi_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Avg_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_avg_fields';
  quota_incentivo?: Maybe<Scalars['Float']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Avg_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_produzione_unita_sezione_incentivi". All fields are combined with a logical 'AND'. */
export type Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>>;
  _not?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>>;
  asset_produzione_unita_sezione?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
  asset_produzione_unita_sezione_id?: InputMaybe<Uuid_Comparison_Exp>;
  contributi_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quota_incentivo?: InputMaybe<Int_Comparison_Exp>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Numeric_Comparison_Exp>;
  rispetto_principio_dns?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usufruito_incentivi_rilancio?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_produzione_unita_sezione_incentivi" */
export enum Asset_Produzione_Unita_Sezione_Incentivi_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetProduzioneUnitaSezioneIncentiviPkey = 'asset_produzione_unita_sezione_incentivi_pkey'
}

/** input type for incrementing numeric columns in table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Inc_Input = {
  quota_incentivo?: InputMaybe<Scalars['Int']['input']>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Insert_Input = {
  asset_produzione_unita_sezione?: InputMaybe<Asset_Produzione_Unita_Sezione_Obj_Rel_Insert_Input>;
  asset_produzione_unita_sezione_id?: InputMaybe<Scalars['uuid']['input']>;
  contributi_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quota_incentivo?: InputMaybe<Scalars['Int']['input']>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Scalars['numeric']['input']>;
  rispetto_principio_dns?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usufruito_incentivi_rilancio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Max_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_max_fields';
  asset_produzione_unita_sezione_id?: Maybe<Scalars['uuid']['output']>;
  contributi_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quota_incentivo?: Maybe<Scalars['Int']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Max_Order_By = {
  asset_produzione_unita_sezione_id?: InputMaybe<Order_By>;
  contributi_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Min_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_min_fields';
  asset_produzione_unita_sezione_id?: Maybe<Scalars['uuid']['output']>;
  contributi_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quota_incentivo?: Maybe<Scalars['Int']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Min_Order_By = {
  asset_produzione_unita_sezione_id?: InputMaybe<Order_By>;
  contributi_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Mutation_Response = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Produzione_Unita_Sezione_Incentivi>;
};

/** on_conflict condition type for table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_On_Conflict = {
  constraint: Asset_Produzione_Unita_Sezione_Incentivi_Constraint;
  update_columns?: Array<Asset_Produzione_Unita_Sezione_Incentivi_Update_Column>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_produzione_unita_sezione_incentivi". */
export type Asset_Produzione_Unita_Sezione_Incentivi_Order_By = {
  asset_produzione_unita_sezione?: InputMaybe<Asset_Produzione_Unita_Sezione_Order_By>;
  asset_produzione_unita_sezione_id?: InputMaybe<Order_By>;
  contributi_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
  rispetto_principio_dns?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usufruito_incentivi_rilancio?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_produzione_unita_sezione_incentivi */
export type Asset_Produzione_Unita_Sezione_Incentivi_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_produzione_unita_sezione_incentivi" */
export enum Asset_Produzione_Unita_Sezione_Incentivi_Select_Column {
  /** column name */
  AssetProduzioneUnitaSezioneId = 'asset_produzione_unita_sezione_id',
  /** column name */
  ContributiId = 'contributi_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuotaIncentivo = 'quota_incentivo',
  /** column name */
  QuotaPotenzaRinnovabiliObbligo = 'quota_potenza_rinnovabili_obbligo',
  /** column name */
  RispettoPrincipioDns = 'rispetto_principio_dns',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsufruitoIncentiviRilancio = 'usufruito_incentivi_rilancio'
}

/** select "asset_produzione_unita_sezione_incentivi_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_produzione_unita_sezione_incentivi" */
export enum Asset_Produzione_Unita_Sezione_Incentivi_Select_Column_Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RispettoPrincipioDns = 'rispetto_principio_dns',
  /** column name */
  UsufruitoIncentiviRilancio = 'usufruito_incentivi_rilancio'
}

/** select "asset_produzione_unita_sezione_incentivi_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_produzione_unita_sezione_incentivi" */
export enum Asset_Produzione_Unita_Sezione_Incentivi_Select_Column_Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RispettoPrincipioDns = 'rispetto_principio_dns',
  /** column name */
  UsufruitoIncentiviRilancio = 'usufruito_incentivi_rilancio'
}

/** input type for updating data in table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Set_Input = {
  asset_produzione_unita_sezione_id?: InputMaybe<Scalars['uuid']['input']>;
  contributi_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quota_incentivo?: InputMaybe<Scalars['Int']['input']>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Scalars['numeric']['input']>;
  rispetto_principio_dns?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usufruito_incentivi_rilancio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_stddev_fields';
  quota_incentivo?: Maybe<Scalars['Float']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Pop_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_stddev_pop_fields';
  quota_incentivo?: Maybe<Scalars['Float']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Pop_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Samp_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_stddev_samp_fields';
  quota_incentivo?: Maybe<Scalars['Float']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stddev_Samp_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Produzione_Unita_Sezione_Incentivi_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Produzione_Unita_Sezione_Incentivi_Stream_Cursor_Value_Input = {
  asset_produzione_unita_sezione_id?: InputMaybe<Scalars['uuid']['input']>;
  contributi_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quota_incentivo?: InputMaybe<Scalars['Int']['input']>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Scalars['numeric']['input']>;
  rispetto_principio_dns?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usufruito_incentivi_rilancio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Sum_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_sum_fields';
  quota_incentivo?: Maybe<Scalars['Int']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Sum_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** update columns of table "asset_produzione_unita_sezione_incentivi" */
export enum Asset_Produzione_Unita_Sezione_Incentivi_Update_Column {
  /** column name */
  AssetProduzioneUnitaSezioneId = 'asset_produzione_unita_sezione_id',
  /** column name */
  ContributiId = 'contributi_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuotaIncentivo = 'quota_incentivo',
  /** column name */
  QuotaPotenzaRinnovabiliObbligo = 'quota_potenza_rinnovabili_obbligo',
  /** column name */
  RispettoPrincipioDns = 'rispetto_principio_dns',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsufruitoIncentiviRilancio = 'usufruito_incentivi_rilancio'
}

export type Asset_Produzione_Unita_Sezione_Incentivi_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Var_Pop_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_var_pop_fields';
  quota_incentivo?: Maybe<Scalars['Float']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Var_Pop_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Var_Samp_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_var_samp_fields';
  quota_incentivo?: Maybe<Scalars['Float']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Var_Samp_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Produzione_Unita_Sezione_Incentivi_Variance_Fields = {
  __typename?: 'asset_produzione_unita_sezione_incentivi_variance_fields';
  quota_incentivo?: Maybe<Scalars['Float']['output']>;
  quota_potenza_rinnovabili_obbligo?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_produzione_unita_sezione_incentivi" */
export type Asset_Produzione_Unita_Sezione_Incentivi_Variance_Order_By = {
  quota_incentivo?: InputMaybe<Order_By>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Insert_Input = {
  asset_produzione_unita?: InputMaybe<Asset_Produzione_Unita_Obj_Rel_Insert_Input>;
  asset_produzione_unita_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_sezione?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_decorrenza_autoconsumo?: InputMaybe<Scalars['timestamptz']['input']>;
  dispositivo_inseguimento_solare?: InputMaybe<Scalars['Boolean']['input']>;
  esposizione_prevalente_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  incentivi?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Arr_Rel_Insert_Input>;
  inclinazione_prevalente?: InputMaybe<Scalars['Int']['input']>;
  incompatibilita_incentivi_altro?: InputMaybe<Scalars['String']['input']>;
  incompatibilita_incentivi_id?: InputMaybe<Scalars['uuid']['input']>;
  pannelli_bifacciali?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_sito_impianto_id?: InputMaybe<Scalars['uuid']['input']>;
  titoli_autorizzativi?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Produzione_Unita_Sezione_Max_Fields = {
  __typename?: 'asset_produzione_unita_sezione_max_fields';
  asset_produzione_unita_id?: Maybe<Scalars['uuid']['output']>;
  codice_sezione?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_decorrenza_autoconsumo?: Maybe<Scalars['timestamptz']['output']>;
  esposizione_prevalente_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inclinazione_prevalente?: Maybe<Scalars['Int']['output']>;
  incompatibilita_incentivi_altro?: Maybe<Scalars['String']['output']>;
  incompatibilita_incentivi_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_sito_impianto_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Max_Order_By = {
  asset_produzione_unita_id?: InputMaybe<Order_By>;
  codice_sezione?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_decorrenza_autoconsumo?: InputMaybe<Order_By>;
  esposizione_prevalente_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inclinazione_prevalente?: InputMaybe<Order_By>;
  incompatibilita_incentivi_altro?: InputMaybe<Order_By>;
  incompatibilita_incentivi_id?: InputMaybe<Order_By>;
  tipologia_sito_impianto_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Produzione_Unita_Sezione_Min_Fields = {
  __typename?: 'asset_produzione_unita_sezione_min_fields';
  asset_produzione_unita_id?: Maybe<Scalars['uuid']['output']>;
  codice_sezione?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_decorrenza_autoconsumo?: Maybe<Scalars['timestamptz']['output']>;
  esposizione_prevalente_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inclinazione_prevalente?: Maybe<Scalars['Int']['output']>;
  incompatibilita_incentivi_altro?: Maybe<Scalars['String']['output']>;
  incompatibilita_incentivi_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_sito_impianto_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Min_Order_By = {
  asset_produzione_unita_id?: InputMaybe<Order_By>;
  codice_sezione?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_decorrenza_autoconsumo?: InputMaybe<Order_By>;
  esposizione_prevalente_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inclinazione_prevalente?: InputMaybe<Order_By>;
  incompatibilita_incentivi_altro?: InputMaybe<Order_By>;
  incompatibilita_incentivi_id?: InputMaybe<Order_By>;
  tipologia_sito_impianto_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Mutation_Response = {
  __typename?: 'asset_produzione_unita_sezione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Produzione_Unita_Sezione>;
};

/** input type for inserting object relation for remote table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Obj_Rel_Insert_Input = {
  data: Asset_Produzione_Unita_Sezione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_On_Conflict>;
};

/** on_conflict condition type for table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_On_Conflict = {
  constraint: Asset_Produzione_Unita_Sezione_Constraint;
  update_columns?: Array<Asset_Produzione_Unita_Sezione_Update_Column>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_produzione_unita_sezione". */
export type Asset_Produzione_Unita_Sezione_Order_By = {
  asset_produzione_unita?: InputMaybe<Asset_Produzione_Unita_Order_By>;
  asset_produzione_unita_id?: InputMaybe<Order_By>;
  codice_sezione?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_decorrenza_autoconsumo?: InputMaybe<Order_By>;
  dispositivo_inseguimento_solare?: InputMaybe<Order_By>;
  esposizione_prevalente_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incentivi_aggregate?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Aggregate_Order_By>;
  inclinazione_prevalente?: InputMaybe<Order_By>;
  incompatibilita_incentivi_altro?: InputMaybe<Order_By>;
  incompatibilita_incentivi_id?: InputMaybe<Order_By>;
  pannelli_bifacciali?: InputMaybe<Order_By>;
  tipologia_sito_impianto_id?: InputMaybe<Order_By>;
  titoli_autorizzativi_aggregate?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_produzione_unita_sezione */
export type Asset_Produzione_Unita_Sezione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_produzione_unita_sezione" */
export enum Asset_Produzione_Unita_Sezione_Select_Column {
  /** column name */
  AssetProduzioneUnitaId = 'asset_produzione_unita_id',
  /** column name */
  CodiceSezione = 'codice_sezione',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataDecorrenzaAutoconsumo = 'data_decorrenza_autoconsumo',
  /** column name */
  DispositivoInseguimentoSolare = 'dispositivo_inseguimento_solare',
  /** column name */
  EsposizionePrevalenteId = 'esposizione_prevalente_id',
  /** column name */
  Id = 'id',
  /** column name */
  InclinazionePrevalente = 'inclinazione_prevalente',
  /** column name */
  IncompatibilitaIncentiviAltro = 'incompatibilita_incentivi_altro',
  /** column name */
  IncompatibilitaIncentiviId = 'incompatibilita_incentivi_id',
  /** column name */
  PannelliBifacciali = 'pannelli_bifacciali',
  /** column name */
  TipologiaSitoImpiantoId = 'tipologia_sito_impianto_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "asset_produzione_unita_sezione_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_produzione_unita_sezione" */
export enum Asset_Produzione_Unita_Sezione_Select_Column_Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DispositivoInseguimentoSolare = 'dispositivo_inseguimento_solare',
  /** column name */
  PannelliBifacciali = 'pannelli_bifacciali'
}

/** select "asset_produzione_unita_sezione_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_produzione_unita_sezione" */
export enum Asset_Produzione_Unita_Sezione_Select_Column_Asset_Produzione_Unita_Sezione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DispositivoInseguimentoSolare = 'dispositivo_inseguimento_solare',
  /** column name */
  PannelliBifacciali = 'pannelli_bifacciali'
}

/** input type for updating data in table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Set_Input = {
  asset_produzione_unita_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_sezione?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_decorrenza_autoconsumo?: InputMaybe<Scalars['timestamptz']['input']>;
  dispositivo_inseguimento_solare?: InputMaybe<Scalars['Boolean']['input']>;
  esposizione_prevalente_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inclinazione_prevalente?: InputMaybe<Scalars['Int']['input']>;
  incompatibilita_incentivi_altro?: InputMaybe<Scalars['String']['input']>;
  incompatibilita_incentivi_id?: InputMaybe<Scalars['uuid']['input']>;
  pannelli_bifacciali?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_sito_impianto_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Produzione_Unita_Sezione_Stddev_Fields = {
  __typename?: 'asset_produzione_unita_sezione_stddev_fields';
  inclinazione_prevalente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Stddev_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Produzione_Unita_Sezione_Stddev_Pop_Fields = {
  __typename?: 'asset_produzione_unita_sezione_stddev_pop_fields';
  inclinazione_prevalente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Stddev_Pop_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Produzione_Unita_Sezione_Stddev_Samp_Fields = {
  __typename?: 'asset_produzione_unita_sezione_stddev_samp_fields';
  inclinazione_prevalente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Stddev_Samp_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Produzione_Unita_Sezione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Produzione_Unita_Sezione_Stream_Cursor_Value_Input = {
  asset_produzione_unita_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_sezione?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_decorrenza_autoconsumo?: InputMaybe<Scalars['timestamptz']['input']>;
  dispositivo_inseguimento_solare?: InputMaybe<Scalars['Boolean']['input']>;
  esposizione_prevalente_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inclinazione_prevalente?: InputMaybe<Scalars['Int']['input']>;
  incompatibilita_incentivi_altro?: InputMaybe<Scalars['String']['input']>;
  incompatibilita_incentivi_id?: InputMaybe<Scalars['uuid']['input']>;
  pannelli_bifacciali?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_sito_impianto_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Asset_Produzione_Unita_Sezione_Sum_Fields = {
  __typename?: 'asset_produzione_unita_sezione_sum_fields';
  inclinazione_prevalente?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Sum_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo';
  /** An object relationship */
  asset_produzione_unita_sezione: Asset_Produzione_Unita_Sezione;
  asset_produzione_unita_sezione_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  data?: Maybe<Scalars['timestamptz']['output']>;
  ente?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  protocollo?: Maybe<Scalars['numeric']['output']>;
  tipo_titolo_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_aggregate';
  aggregate?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Fields>;
  nodes: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
};

export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Bool_Exp_Count>;
};

export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_aggregate_fields';
  avg?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Max_Fields>;
  min?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Min_Fields>;
  stddev?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Sum_Fields>;
  var_pop?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Samp_Fields>;
  variance?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Variance_Fields>;
};


/** aggregate fields of "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Max_Order_By>;
  min?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Min_Order_By>;
  stddev?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Arr_Rel_Insert_Input = {
  data: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Avg_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_avg_fields';
  protocollo?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Avg_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_produzione_unita_sezione_titolo_autorizzativo". All fields are combined with a logical 'AND'. */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>>;
  _not?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>>;
  asset_produzione_unita_sezione?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
  asset_produzione_unita_sezione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Timestamptz_Comparison_Exp>;
  ente?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  protocollo?: InputMaybe<Numeric_Comparison_Exp>;
  tipo_titolo_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export enum Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetProduzioneUnitaSezioneTitoloAutorizzativoPkey = 'asset_produzione_unita_sezione_titolo_autorizzativo_pkey'
}

/** input type for incrementing numeric columns in table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Inc_Input = {
  protocollo?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Insert_Input = {
  asset_produzione_unita_sezione?: InputMaybe<Asset_Produzione_Unita_Sezione_Obj_Rel_Insert_Input>;
  asset_produzione_unita_sezione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['timestamptz']['input']>;
  ente?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  protocollo?: InputMaybe<Scalars['numeric']['input']>;
  tipo_titolo_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Max_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_max_fields';
  asset_produzione_unita_sezione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['timestamptz']['output']>;
  ente?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  protocollo?: Maybe<Scalars['numeric']['output']>;
  tipo_titolo_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Max_Order_By = {
  asset_produzione_unita_sezione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  ente?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  protocollo?: InputMaybe<Order_By>;
  tipo_titolo_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Min_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_min_fields';
  asset_produzione_unita_sezione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['timestamptz']['output']>;
  ente?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  protocollo?: Maybe<Scalars['numeric']['output']>;
  tipo_titolo_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Min_Order_By = {
  asset_produzione_unita_sezione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  ente?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  protocollo?: InputMaybe<Order_By>;
  tipo_titolo_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Mutation_Response = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
};

/** on_conflict condition type for table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_On_Conflict = {
  constraint: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Constraint;
  update_columns?: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Update_Column>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_produzione_unita_sezione_titolo_autorizzativo". */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Order_By = {
  asset_produzione_unita_sezione?: InputMaybe<Asset_Produzione_Unita_Sezione_Order_By>;
  asset_produzione_unita_sezione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  ente?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  protocollo?: InputMaybe<Order_By>;
  tipo_titolo_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_produzione_unita_sezione_titolo_autorizzativo */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export enum Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column {
  /** column name */
  AssetProduzioneUnitaSezioneId = 'asset_produzione_unita_sezione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Ente = 'ente',
  /** column name */
  Id = 'id',
  /** column name */
  Protocollo = 'protocollo',
  /** column name */
  TipoTitoloId = 'tipo_titolo_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Set_Input = {
  asset_produzione_unita_sezione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['timestamptz']['input']>;
  ente?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  protocollo?: InputMaybe<Scalars['numeric']['input']>;
  tipo_titolo_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_stddev_fields';
  protocollo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Pop_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_stddev_pop_fields';
  protocollo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Pop_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Samp_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_stddev_samp_fields';
  protocollo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stddev_Samp_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stream_Cursor_Value_Input = {
  asset_produzione_unita_sezione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['timestamptz']['input']>;
  ente?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  protocollo?: InputMaybe<Scalars['numeric']['input']>;
  tipo_titolo_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Sum_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_sum_fields';
  protocollo?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Sum_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** update columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export enum Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Update_Column {
  /** column name */
  AssetProduzioneUnitaSezioneId = 'asset_produzione_unita_sezione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Ente = 'ente',
  /** column name */
  Id = 'id',
  /** column name */
  Protocollo = 'protocollo',
  /** column name */
  TipoTitoloId = 'tipo_titolo_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Pop_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_var_pop_fields';
  protocollo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Pop_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Samp_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_var_samp_fields';
  protocollo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Var_Samp_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Variance_Fields = {
  __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo_variance_fields';
  protocollo?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_produzione_unita_sezione_titolo_autorizzativo" */
export type Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Variance_Order_By = {
  protocollo?: InputMaybe<Order_By>;
};

/** update columns of table "asset_produzione_unita_sezione" */
export enum Asset_Produzione_Unita_Sezione_Update_Column {
  /** column name */
  AssetProduzioneUnitaId = 'asset_produzione_unita_id',
  /** column name */
  CodiceSezione = 'codice_sezione',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataDecorrenzaAutoconsumo = 'data_decorrenza_autoconsumo',
  /** column name */
  DispositivoInseguimentoSolare = 'dispositivo_inseguimento_solare',
  /** column name */
  EsposizionePrevalenteId = 'esposizione_prevalente_id',
  /** column name */
  Id = 'id',
  /** column name */
  InclinazionePrevalente = 'inclinazione_prevalente',
  /** column name */
  IncompatibilitaIncentiviAltro = 'incompatibilita_incentivi_altro',
  /** column name */
  IncompatibilitaIncentiviId = 'incompatibilita_incentivi_id',
  /** column name */
  PannelliBifacciali = 'pannelli_bifacciali',
  /** column name */
  TipologiaSitoImpiantoId = 'tipologia_sito_impianto_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Produzione_Unita_Sezione_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Produzione_Unita_Sezione_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Produzione_Unita_Sezione_Var_Pop_Fields = {
  __typename?: 'asset_produzione_unita_sezione_var_pop_fields';
  inclinazione_prevalente?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Var_Pop_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Produzione_Unita_Sezione_Var_Samp_Fields = {
  __typename?: 'asset_produzione_unita_sezione_var_samp_fields';
  inclinazione_prevalente?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Var_Samp_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Produzione_Unita_Sezione_Variance_Fields = {
  __typename?: 'asset_produzione_unita_sezione_variance_fields';
  inclinazione_prevalente?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_produzione_unita_sezione" */
export type Asset_Produzione_Unita_Sezione_Variance_Order_By = {
  inclinazione_prevalente?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_produzione_unita" */
export type Asset_Produzione_Unita_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Produzione_Unita_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Produzione_Unita_Stream_Cursor_Value_Input = {
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  cod_up?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_attivazione?: InputMaybe<Scalars['timestamptz']['input']>;
  data_disattivazione?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "asset_produzione_unita" */
export enum Asset_Produzione_Unita_Update_Column {
  /** column name */
  AssetProduzioneId = 'asset_produzione_id',
  /** column name */
  CodUp = 'cod_up',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataAttivazione = 'data_attivazione',
  /** column name */
  DataDisattivazione = 'data_disattivazione',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Produzione_Unita_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Produzione_Unita_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Produzione_Unita_Bool_Exp;
};

/** update columns of table "asset_produzione" */
export enum Asset_Produzione_Update_Column {
  /** column name */
  AderenzaDeliberaAutoconsumo = 'aderenza_delibera_autoconsumo',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CodCensimp = 'cod_censimp',
  /** column name */
  CodRichiestaTerna = 'cod_richiesta_terna',
  /** column name */
  CodiceFatturatoPnrr = 'codice_fatturato_pnrr',
  /** column name */
  ConfigurazioneAccumuloId = 'configurazione_accumulo_id',
  /** column name */
  ContrattoRidc = 'contratto_ridc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crtip = 'crtip',
  /** column name */
  DataAdesioneAutoconsumo = 'data_adesione_autoconsumo',
  /** column name */
  DataInstallazioneImpianto = 'data_installazione_impianto',
  /** column name */
  DeliberaGsePnrrId = 'delibera_gse_pnrr_id',
  /** column name */
  EnergiaImmessa = 'energia_immessa',
  /** column name */
  EsitoPnrr = 'esito_pnrr',
  /** column name */
  Foglio = 'foglio',
  /** column name */
  Id = 'id',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  IntestatarioId = 'intestatario_id',
  /** column name */
  MotivanzioneNoPnrr = 'motivanzione_no_pnrr',
  /** column name */
  Particella = 'particella',
  /** column name */
  Pod = 'pod',
  /** column name */
  PotenzaBatteria = 'potenza_batteria',
  /** column name */
  PotenzaEffettiva = 'potenza_effettiva',
  /** column name */
  PrelieviNonAusiliari = 'prelievi_non_ausiliari',
  /** column name */
  PresenzaAccumulo = 'presenza_accumulo',
  /** column name */
  ReferenteGseEmail = 'referente_gse_email',
  /** column name */
  ReferenteGseNome = 'referente_gse_nome',
  /** column name */
  RichiestaModelloUnico = 'richiesta_modello_unico',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  SezioneCatastale = 'sezione_catastale',
  /** column name */
  Subalterno = 'subalterno',
  /** column name */
  TipologiaImpiantoId = 'tipologia_impianto_id',
  /** column name */
  UbicazioneImpiantoAderente = 'ubicazione_impianto_aderente',
  /** column name */
  Update = 'update',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Produzione_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Produzione_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Produzione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Produzione_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Produzione_Var_Pop_Fields = {
  __typename?: 'asset_produzione_var_pop_fields';
  crtip?: Maybe<Scalars['Float']['output']>;
  energia_immessa?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_produzione" */
export type Asset_Produzione_Var_Pop_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Produzione_Var_Samp_Fields = {
  __typename?: 'asset_produzione_var_samp_fields';
  crtip?: Maybe<Scalars['Float']['output']>;
  energia_immessa?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_produzione" */
export type Asset_Produzione_Var_Samp_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Produzione_Variance_Fields = {
  __typename?: 'asset_produzione_variance_fields';
  crtip?: Maybe<Scalars['Float']['output']>;
  energia_immessa?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_produzione" */
export type Asset_Produzione_Variance_Order_By = {
  crtip?: InputMaybe<Order_By>;
  energia_immessa?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
};

/** select columns of table "asset" */
export enum Asset_Select_Column {
  /** column name */
  Aiuto = 'aiuto',
  /** column name */
  Alias = 'alias',
  /** column name */
  AltreInfo = 'altre_info',
  /** column name */
  Associato = 'associato',
  /** column name */
  Autoconsumo = 'autoconsumo',
  /** column name */
  CabinaId = 'cabina_id',
  /** column name */
  CapacitaBatteriaPrevista = 'capacita_batteria_prevista',
  /** column name */
  Consumo = 'consumo',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataAllaccioPrevista = 'data_allaccio_prevista',
  /** column name */
  DataInstallazioneImpianto = 'data_installazione_impianto',
  /** column name */
  DimensioneId = 'dimensione_id',
  /** column name */
  DomenicaId = 'domenica_id',
  /** column name */
  GiovediId = 'giovedi_id',
  /** column name */
  HasSottoscrizioniAttive = 'has_sottoscrizioni_attive',
  /** column name */
  HasSottoscrizioniNonAttive = 'has_sottoscrizioni_non_attive',
  /** column name */
  Id = 'id',
  /** column name */
  Impianto = 'impianto',
  /** column name */
  IncentiviImpianto = 'incentivi_impianto',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  InseritoreId = 'inseritore_id',
  /** column name */
  InstallatoreId = 'installatore_id',
  /** column name */
  LunediId = 'lunedi_id',
  /** column name */
  MartediId = 'martedi_id',
  /** column name */
  MercolediId = 'mercoledi_id',
  /** column name */
  Notifiche = 'notifiche',
  /** column name */
  Opzionato = 'opzionato',
  /** column name */
  PosizioneEsatta = 'posizione_esatta',
  /** column name */
  PotenzaBatteria = 'potenza_batteria',
  /** column name */
  PotenzaEffettiva = 'potenza_effettiva',
  /** column name */
  PotenzaImpiantoPrevista = 'potenza_impianto_prevista',
  /** column name */
  Proprieta = 'proprieta',
  /** column name */
  RealizzandoImpianto = 'realizzando_impianto',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  RootId = 'root_id',
  /** column name */
  SabatoId = 'sabato_id',
  /** column name */
  ScambioSuPosto = 'scambio_su_posto',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  SpazioDisponibile = 'spazio_disponibile',
  /** column name */
  TipologiaAbitativaId = 'tipologia_abitativa_id',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  Update = 'update',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VenerdiId = 'venerdi_id',
  /** column name */
  VisibilitaNome = 'visibilita_nome',
  /** column name */
  WhiteLabelTag = 'white_label_tag'
}

/** select "asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset" */
export enum Asset_Select_Column_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Aiuto = 'aiuto',
  /** column name */
  Associato = 'associato',
  /** column name */
  HasSottoscrizioniAttive = 'has_sottoscrizioni_attive',
  /** column name */
  HasSottoscrizioniNonAttive = 'has_sottoscrizioni_non_attive',
  /** column name */
  Impianto = 'impianto',
  /** column name */
  Opzionato = 'opzionato',
  /** column name */
  PosizioneEsatta = 'posizione_esatta',
  /** column name */
  Proprieta = 'proprieta',
  /** column name */
  RealizzandoImpianto = 'realizzando_impianto',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  ScambioSuPosto = 'scambio_su_posto',
  /** column name */
  SpazioDisponibile = 'spazio_disponibile',
  /** column name */
  Update = 'update',
  /** column name */
  VisibilitaNome = 'visibilita_nome'
}

/** select "asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset" */
export enum Asset_Select_Column_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Aiuto = 'aiuto',
  /** column name */
  Associato = 'associato',
  /** column name */
  HasSottoscrizioniAttive = 'has_sottoscrizioni_attive',
  /** column name */
  HasSottoscrizioniNonAttive = 'has_sottoscrizioni_non_attive',
  /** column name */
  Impianto = 'impianto',
  /** column name */
  Opzionato = 'opzionato',
  /** column name */
  PosizioneEsatta = 'posizione_esatta',
  /** column name */
  Proprieta = 'proprieta',
  /** column name */
  RealizzandoImpianto = 'realizzando_impianto',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  ScambioSuPosto = 'scambio_su_posto',
  /** column name */
  SpazioDisponibile = 'spazio_disponibile',
  /** column name */
  Update = 'update',
  /** column name */
  VisibilitaNome = 'visibilita_nome'
}

/** input type for updating data in table "asset" */
export type Asset_Set_Input = {
  aiuto?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  altre_info?: InputMaybe<Scalars['jsonb']['input']>;
  associato?: InputMaybe<Scalars['Boolean']['input']>;
  autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  capacita_batteria_prevista?: InputMaybe<Scalars['numeric']['input']>;
  consumo?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_allaccio_prevista?: InputMaybe<Scalars['timestamptz']['input']>;
  data_installazione_impianto?: InputMaybe<Scalars['timestamptz']['input']>;
  dimensione_id?: InputMaybe<Scalars['uuid']['input']>;
  domenica_id?: InputMaybe<Scalars['uuid']['input']>;
  giovedi_id?: InputMaybe<Scalars['uuid']['input']>;
  has_sottoscrizioni_attive?: InputMaybe<Scalars['Boolean']['input']>;
  has_sottoscrizioni_non_attive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impianto?: InputMaybe<Scalars['Boolean']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['jsonb']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  inseritore_id?: InputMaybe<Scalars['uuid']['input']>;
  installatore_id?: InputMaybe<Scalars['uuid']['input']>;
  lunedi_id?: InputMaybe<Scalars['uuid']['input']>;
  martedi_id?: InputMaybe<Scalars['uuid']['input']>;
  mercoledi_id?: InputMaybe<Scalars['uuid']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  opzionato?: InputMaybe<Scalars['Boolean']['input']>;
  posizione_esatta?: InputMaybe<Scalars['Boolean']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
  potenza_impianto_prevista?: InputMaybe<Scalars['numeric']['input']>;
  proprieta?: InputMaybe<Scalars['Boolean']['input']>;
  realizzando_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  sabato_id?: InputMaybe<Scalars['uuid']['input']>;
  scambio_su_posto?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  spazio_disponibile?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_abitativa_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  venerdi_id?: InputMaybe<Scalars['uuid']['input']>;
  visibilita_nome?: InputMaybe<Scalars['Boolean']['input']>;
  white_label_tag?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "asset_spazio" */
export type Asset_Spazio = {
  __typename?: 'asset_spazio';
  /** An object relationship */
  asset: Asset;
  asset_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  dimensione: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  tipo_area?: Maybe<Energy_Village_Tipo_Spazio_Disponibile>;
  tipo_area_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "asset_spazio" */
export type Asset_Spazio_Aggregate = {
  __typename?: 'asset_spazio_aggregate';
  aggregate?: Maybe<Asset_Spazio_Aggregate_Fields>;
  nodes: Array<Asset_Spazio>;
};

export type Asset_Spazio_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Spazio_Aggregate_Bool_Exp_Count>;
};

export type Asset_Spazio_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Asset_Spazio_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_spazio" */
export type Asset_Spazio_Aggregate_Fields = {
  __typename?: 'asset_spazio_aggregate_fields';
  avg?: Maybe<Asset_Spazio_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Asset_Spazio_Max_Fields>;
  min?: Maybe<Asset_Spazio_Min_Fields>;
  stddev?: Maybe<Asset_Spazio_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Spazio_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Spazio_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Spazio_Sum_Fields>;
  var_pop?: Maybe<Asset_Spazio_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Spazio_Var_Samp_Fields>;
  variance?: Maybe<Asset_Spazio_Variance_Fields>;
};


/** aggregate fields of "asset_spazio" */
export type Asset_Spazio_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "asset_spazio" */
export type Asset_Spazio_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Spazio_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Spazio_Max_Order_By>;
  min?: InputMaybe<Asset_Spazio_Min_Order_By>;
  stddev?: InputMaybe<Asset_Spazio_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Spazio_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Spazio_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Spazio_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Spazio_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Spazio_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Spazio_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_spazio" */
export type Asset_Spazio_Arr_Rel_Insert_Input = {
  data: Array<Asset_Spazio_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Spazio_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Spazio_Avg_Fields = {
  __typename?: 'asset_spazio_avg_fields';
  dimensione?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "asset_spazio" */
export type Asset_Spazio_Avg_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_spazio". All fields are combined with a logical 'AND'. */
export type Asset_Spazio_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Spazio_Bool_Exp>>;
  _not?: InputMaybe<Asset_Spazio_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Spazio_Bool_Exp>>;
  asset?: InputMaybe<Asset_Bool_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dimensione?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  tipo_area?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
  tipo_area_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_spazio" */
export enum Asset_Spazio_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetSpazioPkey = 'asset_spazio_pkey'
}

/** input type for incrementing numeric columns in table "asset_spazio" */
export type Asset_Spazio_Inc_Input = {
  dimensione?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "asset_spazio" */
export type Asset_Spazio_Insert_Input = {
  asset?: InputMaybe<Asset_Obj_Rel_Insert_Input>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dimensione?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_area?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Obj_Rel_Insert_Input>;
  tipo_area_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Asset_Spazio_Max_Fields = {
  __typename?: 'asset_spazio_max_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dimensione?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tipo_area_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "asset_spazio" */
export type Asset_Spazio_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dimensione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipo_area_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Spazio_Min_Fields = {
  __typename?: 'asset_spazio_min_fields';
  asset_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dimensione?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tipo_area_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "asset_spazio" */
export type Asset_Spazio_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dimensione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipo_area_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_spazio" */
export type Asset_Spazio_Mutation_Response = {
  __typename?: 'asset_spazio_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Spazio>;
};

/** on_conflict condition type for table "asset_spazio" */
export type Asset_Spazio_On_Conflict = {
  constraint: Asset_Spazio_Constraint;
  update_columns?: Array<Asset_Spazio_Update_Column>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_spazio". */
export type Asset_Spazio_Order_By = {
  asset?: InputMaybe<Asset_Order_By>;
  asset_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dimensione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipo_area?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Order_By>;
  tipo_area_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_spazio */
export type Asset_Spazio_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "asset_spazio" */
export enum Asset_Spazio_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dimensione = 'dimensione',
  /** column name */
  Id = 'id',
  /** column name */
  TipoAreaId = 'tipo_area_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_spazio" */
export type Asset_Spazio_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dimensione?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_area_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Asset_Spazio_Stddev_Fields = {
  __typename?: 'asset_spazio_stddev_fields';
  dimensione?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset_spazio" */
export type Asset_Spazio_Stddev_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Spazio_Stddev_Pop_Fields = {
  __typename?: 'asset_spazio_stddev_pop_fields';
  dimensione?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset_spazio" */
export type Asset_Spazio_Stddev_Pop_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Spazio_Stddev_Samp_Fields = {
  __typename?: 'asset_spazio_stddev_samp_fields';
  dimensione?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset_spazio" */
export type Asset_Spazio_Stddev_Samp_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_spazio" */
export type Asset_Spazio_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Spazio_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Spazio_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dimensione?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_area_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Asset_Spazio_Sum_Fields = {
  __typename?: 'asset_spazio_sum_fields';
  dimensione?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset_spazio" */
export type Asset_Spazio_Sum_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** update columns of table "asset_spazio" */
export enum Asset_Spazio_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dimensione = 'dimensione',
  /** column name */
  Id = 'id',
  /** column name */
  TipoAreaId = 'tipo_area_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Spazio_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Spazio_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Spazio_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Spazio_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Spazio_Var_Pop_Fields = {
  __typename?: 'asset_spazio_var_pop_fields';
  dimensione?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset_spazio" */
export type Asset_Spazio_Var_Pop_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Spazio_Var_Samp_Fields = {
  __typename?: 'asset_spazio_var_samp_fields';
  dimensione?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset_spazio" */
export type Asset_Spazio_Var_Samp_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Spazio_Variance_Fields = {
  __typename?: 'asset_spazio_variance_fields';
  dimensione?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset_spazio" */
export type Asset_Spazio_Variance_Order_By = {
  dimensione?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Asset_Stddev_Fields = {
  __typename?: 'asset_stddev_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "asset" */
export type Asset_Stddev_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Stddev_Pop_Fields = {
  __typename?: 'asset_stddev_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "asset" */
export type Asset_Stddev_Pop_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Stddev_Samp_Fields = {
  __typename?: 'asset_stddev_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "asset" */
export type Asset_Stddev_Samp_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset" */
export type Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Stream_Cursor_Value_Input = {
  aiuto?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  altre_info?: InputMaybe<Scalars['jsonb']['input']>;
  associato?: InputMaybe<Scalars['Boolean']['input']>;
  autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  capacita_batteria_prevista?: InputMaybe<Scalars['numeric']['input']>;
  consumo?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_allaccio_prevista?: InputMaybe<Scalars['timestamptz']['input']>;
  data_installazione_impianto?: InputMaybe<Scalars['timestamptz']['input']>;
  dimensione_id?: InputMaybe<Scalars['uuid']['input']>;
  domenica_id?: InputMaybe<Scalars['uuid']['input']>;
  giovedi_id?: InputMaybe<Scalars['uuid']['input']>;
  has_sottoscrizioni_attive?: InputMaybe<Scalars['Boolean']['input']>;
  has_sottoscrizioni_non_attive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impianto?: InputMaybe<Scalars['Boolean']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['jsonb']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  inseritore_id?: InputMaybe<Scalars['uuid']['input']>;
  installatore_id?: InputMaybe<Scalars['uuid']['input']>;
  lunedi_id?: InputMaybe<Scalars['uuid']['input']>;
  martedi_id?: InputMaybe<Scalars['uuid']['input']>;
  mercoledi_id?: InputMaybe<Scalars['uuid']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  opzionato?: InputMaybe<Scalars['Boolean']['input']>;
  posizione_esatta?: InputMaybe<Scalars['Boolean']['input']>;
  potenza_batteria?: InputMaybe<Scalars['numeric']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['numeric']['input']>;
  potenza_impianto_prevista?: InputMaybe<Scalars['numeric']['input']>;
  proprieta?: InputMaybe<Scalars['Boolean']['input']>;
  realizzando_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  sabato_id?: InputMaybe<Scalars['uuid']['input']>;
  scambio_su_posto?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  spazio_disponibile?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_abitativa_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  venerdi_id?: InputMaybe<Scalars['uuid']['input']>;
  visibilita_nome?: InputMaybe<Scalars['Boolean']['input']>;
  white_label_tag?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Asset_Sum_Fields = {
  __typename?: 'asset_sum_fields';
  cabina_id?: Maybe<Scalars['Int']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['numeric']['output']>;
  consumo?: Maybe<Scalars['numeric']['output']>;
  notifiche?: Maybe<Scalars['Int']['output']>;
  potenza_batteria?: Maybe<Scalars['numeric']['output']>;
  potenza_effettiva?: Maybe<Scalars['numeric']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "asset" */
export type Asset_Sum_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** update columns of table "asset" */
export enum Asset_Update_Column {
  /** column name */
  Aiuto = 'aiuto',
  /** column name */
  Alias = 'alias',
  /** column name */
  AltreInfo = 'altre_info',
  /** column name */
  Associato = 'associato',
  /** column name */
  Autoconsumo = 'autoconsumo',
  /** column name */
  CabinaId = 'cabina_id',
  /** column name */
  CapacitaBatteriaPrevista = 'capacita_batteria_prevista',
  /** column name */
  Consumo = 'consumo',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataAllaccioPrevista = 'data_allaccio_prevista',
  /** column name */
  DataInstallazioneImpianto = 'data_installazione_impianto',
  /** column name */
  DimensioneId = 'dimensione_id',
  /** column name */
  DomenicaId = 'domenica_id',
  /** column name */
  GiovediId = 'giovedi_id',
  /** column name */
  HasSottoscrizioniAttive = 'has_sottoscrizioni_attive',
  /** column name */
  HasSottoscrizioniNonAttive = 'has_sottoscrizioni_non_attive',
  /** column name */
  Id = 'id',
  /** column name */
  Impianto = 'impianto',
  /** column name */
  IncentiviImpianto = 'incentivi_impianto',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  InseritoreId = 'inseritore_id',
  /** column name */
  InstallatoreId = 'installatore_id',
  /** column name */
  LunediId = 'lunedi_id',
  /** column name */
  MartediId = 'martedi_id',
  /** column name */
  MercolediId = 'mercoledi_id',
  /** column name */
  Notifiche = 'notifiche',
  /** column name */
  Opzionato = 'opzionato',
  /** column name */
  PosizioneEsatta = 'posizione_esatta',
  /** column name */
  PotenzaBatteria = 'potenza_batteria',
  /** column name */
  PotenzaEffettiva = 'potenza_effettiva',
  /** column name */
  PotenzaImpiantoPrevista = 'potenza_impianto_prevista',
  /** column name */
  Proprieta = 'proprieta',
  /** column name */
  RealizzandoImpianto = 'realizzando_impianto',
  /** column name */
  RichiestaPnrr = 'richiesta_pnrr',
  /** column name */
  RootId = 'root_id',
  /** column name */
  SabatoId = 'sabato_id',
  /** column name */
  ScambioSuPosto = 'scambio_su_posto',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  SpazioDisponibile = 'spazio_disponibile',
  /** column name */
  TipologiaAbitativaId = 'tipologia_abitativa_id',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  Update = 'update',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VenerdiId = 'venerdi_id',
  /** column name */
  VisibilitaNome = 'visibilita_nome',
  /** column name */
  WhiteLabelTag = 'white_label_tag'
}

export type Asset_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Asset_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Asset_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Asset_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Asset_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Asset_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Var_Pop_Fields = {
  __typename?: 'asset_var_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "asset" */
export type Asset_Var_Pop_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Var_Samp_Fields = {
  __typename?: 'asset_var_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "asset" */
export type Asset_Var_Samp_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Variance_Fields = {
  __typename?: 'asset_variance_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  capacita_batteria_prevista?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  potenza_batteria?: Maybe<Scalars['Float']['output']>;
  potenza_effettiva?: Maybe<Scalars['Float']['output']>;
  potenza_impianto_prevista?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "asset" */
export type Asset_Variance_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  capacita_batteria_prevista?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  potenza_batteria?: InputMaybe<Order_By>;
  potenza_effettiva?: InputMaybe<Order_By>;
  potenza_impianto_prevista?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth.event_entity" */
export type Auth_Event_Entity = {
  __typename?: 'auth_event_entity';
  client_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['String']['output'];
  realm_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "auth.event_entity" */
export type Auth_Event_Entity_Aggregate = {
  __typename?: 'auth_event_entity_aggregate';
  aggregate?: Maybe<Auth_Event_Entity_Aggregate_Fields>;
  nodes: Array<Auth_Event_Entity>;
};

/** aggregate fields of "auth.event_entity" */
export type Auth_Event_Entity_Aggregate_Fields = {
  __typename?: 'auth_event_entity_aggregate_fields';
  avg?: Maybe<Auth_Event_Entity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Event_Entity_Max_Fields>;
  min?: Maybe<Auth_Event_Entity_Min_Fields>;
  stddev?: Maybe<Auth_Event_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Event_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Event_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Event_Entity_Sum_Fields>;
  var_pop?: Maybe<Auth_Event_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Event_Entity_Var_Samp_Fields>;
  variance?: Maybe<Auth_Event_Entity_Variance_Fields>;
};


/** aggregate fields of "auth.event_entity" */
export type Auth_Event_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Event_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Auth_Event_Entity_Avg_Fields = {
  __typename?: 'auth_event_entity_avg_fields';
  event_time?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "auth.event_entity". All fields are combined with a logical 'AND'. */
export type Auth_Event_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Event_Entity_Bool_Exp>>;
  _not?: InputMaybe<Auth_Event_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Event_Entity_Bool_Exp>>;
  client_id?: InputMaybe<String_Comparison_Exp>;
  event_time?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  realm_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.event_entity" */
export enum Auth_Event_Entity_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventEntityPkey = 'event_entity_pkey'
}

/** input type for incrementing numeric columns in table "auth.event_entity" */
export type Auth_Event_Entity_Inc_Input = {
  event_time?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "auth.event_entity" */
export type Auth_Event_Entity_Insert_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  event_time?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Auth_Event_Entity_Max_Fields = {
  __typename?: 'auth_event_entity_max_fields';
  client_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  realm_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_Event_Entity_Min_Fields = {
  __typename?: 'auth_event_entity_min_fields';
  client_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  realm_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.event_entity" */
export type Auth_Event_Entity_Mutation_Response = {
  __typename?: 'auth_event_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Event_Entity>;
};

/** on_conflict condition type for table "auth.event_entity" */
export type Auth_Event_Entity_On_Conflict = {
  constraint: Auth_Event_Entity_Constraint;
  update_columns?: Array<Auth_Event_Entity_Update_Column>;
  where?: InputMaybe<Auth_Event_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.event_entity". */
export type Auth_Event_Entity_Order_By = {
  client_id?: InputMaybe<Order_By>;
  event_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  realm_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.event_entity */
export type Auth_Event_Entity_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.event_entity" */
export enum Auth_Event_Entity_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EventTime = 'event_time',
  /** column name */
  Id = 'id',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "auth.event_entity" */
export type Auth_Event_Entity_Set_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  event_time?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Auth_Event_Entity_Stddev_Fields = {
  __typename?: 'auth_event_entity_stddev_fields';
  event_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Auth_Event_Entity_Stddev_Pop_Fields = {
  __typename?: 'auth_event_entity_stddev_pop_fields';
  event_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Auth_Event_Entity_Stddev_Samp_Fields = {
  __typename?: 'auth_event_entity_stddev_samp_fields';
  event_time?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "auth_event_entity" */
export type Auth_Event_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Event_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Event_Entity_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  event_time?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Auth_Event_Entity_Sum_Fields = {
  __typename?: 'auth_event_entity_sum_fields';
  event_time?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "auth.event_entity" */
export enum Auth_Event_Entity_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EventTime = 'event_time',
  /** column name */
  Id = 'id',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Auth_Event_Entity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Event_Entity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Event_Entity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Event_Entity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Event_Entity_Var_Pop_Fields = {
  __typename?: 'auth_event_entity_var_pop_fields';
  event_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Auth_Event_Entity_Var_Samp_Fields = {
  __typename?: 'auth_event_entity_var_samp_fields';
  event_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Auth_Event_Entity_Variance_Fields = {
  __typename?: 'auth_event_entity_variance_fields';
  event_time?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "auth.federated_identity" */
export type Auth_Federated_Identity = {
  __typename?: 'auth_federated_identity';
  federated_user_id?: Maybe<Scalars['String']['output']>;
  federated_username?: Maybe<Scalars['String']['output']>;
  identity_provider: Scalars['String']['output'];
  realm_id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "auth.federated_identity" */
export type Auth_Federated_Identity_Aggregate = {
  __typename?: 'auth_federated_identity_aggregate';
  aggregate?: Maybe<Auth_Federated_Identity_Aggregate_Fields>;
  nodes: Array<Auth_Federated_Identity>;
};

/** aggregate fields of "auth.federated_identity" */
export type Auth_Federated_Identity_Aggregate_Fields = {
  __typename?: 'auth_federated_identity_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Federated_Identity_Max_Fields>;
  min?: Maybe<Auth_Federated_Identity_Min_Fields>;
};


/** aggregate fields of "auth.federated_identity" */
export type Auth_Federated_Identity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Federated_Identity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.federated_identity". All fields are combined with a logical 'AND'. */
export type Auth_Federated_Identity_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Federated_Identity_Bool_Exp>>;
  _not?: InputMaybe<Auth_Federated_Identity_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Federated_Identity_Bool_Exp>>;
  federated_user_id?: InputMaybe<String_Comparison_Exp>;
  federated_username?: InputMaybe<String_Comparison_Exp>;
  identity_provider?: InputMaybe<String_Comparison_Exp>;
  realm_id?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.federated_identity" */
export enum Auth_Federated_Identity_Constraint {
  /** unique or primary key constraint on columns "user_id", "identity_provider" */
  FederatedIdentityPkey = 'federated_identity_pkey'
}

/** input type for inserting data into table "auth.federated_identity" */
export type Auth_Federated_Identity_Insert_Input = {
  federated_user_id?: InputMaybe<Scalars['String']['input']>;
  federated_username?: InputMaybe<Scalars['String']['input']>;
  identity_provider?: InputMaybe<Scalars['String']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Auth_Federated_Identity_Max_Fields = {
  __typename?: 'auth_federated_identity_max_fields';
  federated_user_id?: Maybe<Scalars['String']['output']>;
  federated_username?: Maybe<Scalars['String']['output']>;
  identity_provider?: Maybe<Scalars['String']['output']>;
  realm_id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_Federated_Identity_Min_Fields = {
  __typename?: 'auth_federated_identity_min_fields';
  federated_user_id?: Maybe<Scalars['String']['output']>;
  federated_username?: Maybe<Scalars['String']['output']>;
  identity_provider?: Maybe<Scalars['String']['output']>;
  realm_id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.federated_identity" */
export type Auth_Federated_Identity_Mutation_Response = {
  __typename?: 'auth_federated_identity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Federated_Identity>;
};

/** on_conflict condition type for table "auth.federated_identity" */
export type Auth_Federated_Identity_On_Conflict = {
  constraint: Auth_Federated_Identity_Constraint;
  update_columns?: Array<Auth_Federated_Identity_Update_Column>;
  where?: InputMaybe<Auth_Federated_Identity_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.federated_identity". */
export type Auth_Federated_Identity_Order_By = {
  federated_user_id?: InputMaybe<Order_By>;
  federated_username?: InputMaybe<Order_By>;
  identity_provider?: InputMaybe<Order_By>;
  realm_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.federated_identity */
export type Auth_Federated_Identity_Pk_Columns_Input = {
  identity_provider: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "auth.federated_identity" */
export enum Auth_Federated_Identity_Select_Column {
  /** column name */
  FederatedUserId = 'federated_user_id',
  /** column name */
  FederatedUsername = 'federated_username',
  /** column name */
  IdentityProvider = 'identity_provider',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "auth.federated_identity" */
export type Auth_Federated_Identity_Set_Input = {
  federated_user_id?: InputMaybe<Scalars['String']['input']>;
  federated_username?: InputMaybe<Scalars['String']['input']>;
  identity_provider?: InputMaybe<Scalars['String']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_federated_identity" */
export type Auth_Federated_Identity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Federated_Identity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Federated_Identity_Stream_Cursor_Value_Input = {
  federated_user_id?: InputMaybe<Scalars['String']['input']>;
  federated_username?: InputMaybe<Scalars['String']['input']>;
  identity_provider?: InputMaybe<Scalars['String']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.federated_identity" */
export enum Auth_Federated_Identity_Update_Column {
  /** column name */
  FederatedUserId = 'federated_user_id',
  /** column name */
  FederatedUsername = 'federated_username',
  /** column name */
  IdentityProvider = 'identity_provider',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

export type Auth_Federated_Identity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Federated_Identity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Federated_Identity_Bool_Exp;
};

/** columns and relationships of "auth.role_attribute" */
export type Auth_Role_Attribute = {
  __typename?: 'auth_role_attribute';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role_id: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "auth.role_attribute" */
export type Auth_Role_Attribute_Aggregate = {
  __typename?: 'auth_role_attribute_aggregate';
  aggregate?: Maybe<Auth_Role_Attribute_Aggregate_Fields>;
  nodes: Array<Auth_Role_Attribute>;
};

/** aggregate fields of "auth.role_attribute" */
export type Auth_Role_Attribute_Aggregate_Fields = {
  __typename?: 'auth_role_attribute_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Role_Attribute_Max_Fields>;
  min?: Maybe<Auth_Role_Attribute_Min_Fields>;
};


/** aggregate fields of "auth.role_attribute" */
export type Auth_Role_Attribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Role_Attribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.role_attribute". All fields are combined with a logical 'AND'. */
export type Auth_Role_Attribute_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Role_Attribute_Bool_Exp>>;
  _not?: InputMaybe<Auth_Role_Attribute_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Role_Attribute_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.role_attribute" */
export enum Auth_Role_Attribute_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoleAttributePkey = 'role_attribute_pkey'
}

/** input type for inserting data into table "auth.role_attribute" */
export type Auth_Role_Attribute_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Auth_Role_Attribute_Max_Fields = {
  __typename?: 'auth_role_attribute_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_Role_Attribute_Min_Fields = {
  __typename?: 'auth_role_attribute_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.role_attribute" */
export type Auth_Role_Attribute_Mutation_Response = {
  __typename?: 'auth_role_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Role_Attribute>;
};

/** on_conflict condition type for table "auth.role_attribute" */
export type Auth_Role_Attribute_On_Conflict = {
  constraint: Auth_Role_Attribute_Constraint;
  update_columns?: Array<Auth_Role_Attribute_Update_Column>;
  where?: InputMaybe<Auth_Role_Attribute_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.role_attribute". */
export type Auth_Role_Attribute_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.role_attribute */
export type Auth_Role_Attribute_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.role_attribute" */
export enum Auth_Role_Attribute_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "auth.role_attribute" */
export type Auth_Role_Attribute_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_role_attribute" */
export type Auth_Role_Attribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Role_Attribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Role_Attribute_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.role_attribute" */
export enum Auth_Role_Attribute_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  Value = 'value'
}

export type Auth_Role_Attribute_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Role_Attribute_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Role_Attribute_Bool_Exp;
};

/** columns and relationships of "auth.user_attribute" */
export type Auth_User_Attribute = {
  __typename?: 'auth_user_attribute';
  id: Scalars['String']['output'];
  long_value?: Maybe<Scalars['String']['output']>;
  long_value_hash?: Maybe<Scalars['bytea']['output']>;
  long_value_hash_lower_case?: Maybe<Scalars['bytea']['output']>;
  name: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  white_label?: Maybe<White_Label_Configurazione>;
};

/** aggregated selection of "auth.user_attribute" */
export type Auth_User_Attribute_Aggregate = {
  __typename?: 'auth_user_attribute_aggregate';
  aggregate?: Maybe<Auth_User_Attribute_Aggregate_Fields>;
  nodes: Array<Auth_User_Attribute>;
};

export type Auth_User_Attribute_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_User_Attribute_Aggregate_Bool_Exp_Count>;
};

export type Auth_User_Attribute_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_attribute" */
export type Auth_User_Attribute_Aggregate_Fields = {
  __typename?: 'auth_user_attribute_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_User_Attribute_Max_Fields>;
  min?: Maybe<Auth_User_Attribute_Min_Fields>;
};


/** aggregate fields of "auth.user_attribute" */
export type Auth_User_Attribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_attribute" */
export type Auth_User_Attribute_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_User_Attribute_Max_Order_By>;
  min?: InputMaybe<Auth_User_Attribute_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_attribute" */
export type Auth_User_Attribute_Arr_Rel_Insert_Input = {
  data: Array<Auth_User_Attribute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_User_Attribute_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_attribute". All fields are combined with a logical 'AND'. */
export type Auth_User_Attribute_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_User_Attribute_Bool_Exp>>;
  _not?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_User_Attribute_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  long_value?: InputMaybe<String_Comparison_Exp>;
  long_value_hash?: InputMaybe<Bytea_Comparison_Exp>;
  long_value_hash_lower_case?: InputMaybe<Bytea_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  white_label?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.user_attribute" */
export enum Auth_User_Attribute_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAttributePkey = 'user_attribute_pkey'
}

/** input type for inserting data into table "auth.user_attribute" */
export type Auth_User_Attribute_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  long_value?: InputMaybe<Scalars['String']['input']>;
  long_value_hash?: InputMaybe<Scalars['bytea']['input']>;
  long_value_hash_lower_case?: InputMaybe<Scalars['bytea']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  white_label?: InputMaybe<White_Label_Configurazione_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_User_Attribute_Max_Fields = {
  __typename?: 'auth_user_attribute_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  long_value?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "auth.user_attribute" */
export type Auth_User_Attribute_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  long_value?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_User_Attribute_Min_Fields = {
  __typename?: 'auth_user_attribute_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  long_value?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "auth.user_attribute" */
export type Auth_User_Attribute_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  long_value?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_attribute" */
export type Auth_User_Attribute_Mutation_Response = {
  __typename?: 'auth_user_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_User_Attribute>;
};

/** on_conflict condition type for table "auth.user_attribute" */
export type Auth_User_Attribute_On_Conflict = {
  constraint: Auth_User_Attribute_Constraint;
  update_columns?: Array<Auth_User_Attribute_Update_Column>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_attribute". */
export type Auth_User_Attribute_Order_By = {
  id?: InputMaybe<Order_By>;
  long_value?: InputMaybe<Order_By>;
  long_value_hash?: InputMaybe<Order_By>;
  long_value_hash_lower_case?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  white_label?: InputMaybe<White_Label_Configurazione_Order_By>;
};

/** primary key columns input for table: auth.user_attribute */
export type Auth_User_Attribute_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.user_attribute" */
export enum Auth_User_Attribute_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LongValue = 'long_value',
  /** column name */
  LongValueHash = 'long_value_hash',
  /** column name */
  LongValueHashLowerCase = 'long_value_hash_lower_case',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "auth.user_attribute" */
export type Auth_User_Attribute_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  long_value?: InputMaybe<Scalars['String']['input']>;
  long_value_hash?: InputMaybe<Scalars['bytea']['input']>;
  long_value_hash_lower_case?: InputMaybe<Scalars['bytea']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_user_attribute" */
export type Auth_User_Attribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_User_Attribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_User_Attribute_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  long_value?: InputMaybe<Scalars['String']['input']>;
  long_value_hash?: InputMaybe<Scalars['bytea']['input']>;
  long_value_hash_lower_case?: InputMaybe<Scalars['bytea']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.user_attribute" */
export enum Auth_User_Attribute_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LongValue = 'long_value',
  /** column name */
  LongValueHash = 'long_value_hash',
  /** column name */
  LongValueHashLowerCase = 'long_value_hash_lower_case',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type Auth_User_Attribute_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_User_Attribute_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_User_Attribute_Bool_Exp;
};

/** columns and relationships of "auth.user_entity" */
export type Auth_User_Entity = {
  __typename?: 'auth_user_entity';
  /** A computed field, executes function "auth.anonymization_email" */
  anonymized_email?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "auth.anonymization_first_name" */
  anonymized_first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "auth.anonymization_last_name" */
  anonymized_last_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  assets: Array<Asset_Gestore>;
  /** An aggregate relationship */
  assets_aggregate: Asset_Gestore_Aggregate;
  /** An object relationship */
  codice_operatore?: Maybe<Codice_Operatore>;
  /** An array relationship */
  consenso_privacy: Array<Admin_Consenso_Privacy>;
  /** An aggregate relationship */
  consenso_privacy_aggregate: Admin_Consenso_Privacy_Aggregate;
  created_timestamp?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_constraint?: Maybe<Scalars['String']['output']>;
  email_verified: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  federation_link?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  not_before: Scalars['Int']['output'];
  /** An array relationship */
  profili: Array<Profilo>;
  /** An aggregate relationship */
  profili_aggregate: Profilo_Aggregate;
  realm_id?: Maybe<Scalars['String']['output']>;
  service_account_client_link?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_attributes: Array<Auth_User_Attribute>;
  /** An aggregate relationship */
  user_attributes_aggregate: Auth_User_Attribute_Aggregate;
  username?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityAssetsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityConsenso_PrivacyArgs = {
  distinct_on?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Consenso_Privacy_Order_By>>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityConsenso_Privacy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Consenso_Privacy_Order_By>>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityProfiliArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityProfili_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityUser_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Attribute_Order_By>>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};


/** columns and relationships of "auth.user_entity" */
export type Auth_User_EntityUser_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Attribute_Order_By>>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};

/** aggregated selection of "auth.user_entity" */
export type Auth_User_Entity_Aggregate = {
  __typename?: 'auth_user_entity_aggregate';
  aggregate?: Maybe<Auth_User_Entity_Aggregate_Fields>;
  nodes: Array<Auth_User_Entity>;
};

/** aggregate fields of "auth.user_entity" */
export type Auth_User_Entity_Aggregate_Fields = {
  __typename?: 'auth_user_entity_aggregate_fields';
  avg?: Maybe<Auth_User_Entity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_User_Entity_Max_Fields>;
  min?: Maybe<Auth_User_Entity_Min_Fields>;
  stddev?: Maybe<Auth_User_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_User_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_User_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_User_Entity_Sum_Fields>;
  var_pop?: Maybe<Auth_User_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_User_Entity_Var_Samp_Fields>;
  variance?: Maybe<Auth_User_Entity_Variance_Fields>;
};


/** aggregate fields of "auth.user_entity" */
export type Auth_User_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Auth_User_Entity_Avg_Fields = {
  __typename?: 'auth_user_entity_avg_fields';
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "auth.user_entity". All fields are combined with a logical 'AND'. */
export type Auth_User_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_User_Entity_Bool_Exp>>;
  _not?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_User_Entity_Bool_Exp>>;
  anonymized_email?: InputMaybe<String_Comparison_Exp>;
  anonymized_first_name?: InputMaybe<String_Comparison_Exp>;
  anonymized_last_name?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Asset_Gestore_Bool_Exp>;
  assets_aggregate?: InputMaybe<Asset_Gestore_Aggregate_Bool_Exp>;
  codice_operatore?: InputMaybe<Codice_Operatore_Bool_Exp>;
  consenso_privacy?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
  consenso_privacy_aggregate?: InputMaybe<Admin_Consenso_Privacy_Aggregate_Bool_Exp>;
  created_timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_constraint?: InputMaybe<String_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  federation_link?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  not_before?: InputMaybe<Int_Comparison_Exp>;
  profili?: InputMaybe<Profilo_Bool_Exp>;
  profili_aggregate?: InputMaybe<Profilo_Aggregate_Bool_Exp>;
  realm_id?: InputMaybe<String_Comparison_Exp>;
  service_account_client_link?: InputMaybe<String_Comparison_Exp>;
  user_attributes?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
  user_attributes_aggregate?: InputMaybe<Auth_User_Attribute_Aggregate_Bool_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_entity" */
export enum Auth_User_Entity_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserEntityPkey = 'user_entity_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_entity" */
export type Auth_User_Entity_Inc_Input = {
  created_timestamp?: InputMaybe<Scalars['bigint']['input']>;
  not_before?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "auth.user_entity" */
export type Auth_User_Entity_Insert_Input = {
  assets?: InputMaybe<Asset_Gestore_Arr_Rel_Insert_Input>;
  codice_operatore?: InputMaybe<Codice_Operatore_Obj_Rel_Insert_Input>;
  consenso_privacy?: InputMaybe<Admin_Consenso_Privacy_Arr_Rel_Insert_Input>;
  created_timestamp?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_constraint?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  federation_link?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  not_before?: InputMaybe<Scalars['Int']['input']>;
  profili?: InputMaybe<Profilo_Arr_Rel_Insert_Input>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  service_account_client_link?: InputMaybe<Scalars['String']['input']>;
  user_attributes?: InputMaybe<Auth_User_Attribute_Arr_Rel_Insert_Input>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Auth_User_Entity_Max_Fields = {
  __typename?: 'auth_user_entity_max_fields';
  /** A computed field, executes function "auth.anonymization_email" */
  anonymized_email?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "auth.anonymization_first_name" */
  anonymized_first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "auth.anonymization_last_name" */
  anonymized_last_name?: Maybe<Scalars['String']['output']>;
  created_timestamp?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_constraint?: Maybe<Scalars['String']['output']>;
  federation_link?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  not_before?: Maybe<Scalars['Int']['output']>;
  realm_id?: Maybe<Scalars['String']['output']>;
  service_account_client_link?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_User_Entity_Min_Fields = {
  __typename?: 'auth_user_entity_min_fields';
  /** A computed field, executes function "auth.anonymization_email" */
  anonymized_email?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "auth.anonymization_first_name" */
  anonymized_first_name?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "auth.anonymization_last_name" */
  anonymized_last_name?: Maybe<Scalars['String']['output']>;
  created_timestamp?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_constraint?: Maybe<Scalars['String']['output']>;
  federation_link?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  not_before?: Maybe<Scalars['Int']['output']>;
  realm_id?: Maybe<Scalars['String']['output']>;
  service_account_client_link?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.user_entity" */
export type Auth_User_Entity_Mutation_Response = {
  __typename?: 'auth_user_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_User_Entity>;
};

/** input type for inserting object relation for remote table "auth.user_entity" */
export type Auth_User_Entity_Obj_Rel_Insert_Input = {
  data: Auth_User_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_User_Entity_On_Conflict>;
};

/** on_conflict condition type for table "auth.user_entity" */
export type Auth_User_Entity_On_Conflict = {
  constraint: Auth_User_Entity_Constraint;
  update_columns?: Array<Auth_User_Entity_Update_Column>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_entity". */
export type Auth_User_Entity_Order_By = {
  anonymized_email?: InputMaybe<Order_By>;
  anonymized_first_name?: InputMaybe<Order_By>;
  anonymized_last_name?: InputMaybe<Order_By>;
  assets_aggregate?: InputMaybe<Asset_Gestore_Aggregate_Order_By>;
  codice_operatore?: InputMaybe<Codice_Operatore_Order_By>;
  consenso_privacy_aggregate?: InputMaybe<Admin_Consenso_Privacy_Aggregate_Order_By>;
  created_timestamp?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_constraint?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  federation_link?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  not_before?: InputMaybe<Order_By>;
  profili_aggregate?: InputMaybe<Profilo_Aggregate_Order_By>;
  realm_id?: InputMaybe<Order_By>;
  service_account_client_link?: InputMaybe<Order_By>;
  user_attributes_aggregate?: InputMaybe<Auth_User_Attribute_Aggregate_Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.user_entity */
export type Auth_User_Entity_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.user_entity" */
export enum Auth_User_Entity_Select_Column {
  /** column name */
  CreatedTimestamp = 'created_timestamp',
  /** column name */
  Email = 'email',
  /** column name */
  EmailConstraint = 'email_constraint',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FederationLink = 'federation_link',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NotBefore = 'not_before',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  ServiceAccountClientLink = 'service_account_client_link',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "auth.user_entity" */
export type Auth_User_Entity_Set_Input = {
  created_timestamp?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_constraint?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  federation_link?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  not_before?: InputMaybe<Scalars['Int']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  service_account_client_link?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Auth_User_Entity_Stddev_Fields = {
  __typename?: 'auth_user_entity_stddev_fields';
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Auth_User_Entity_Stddev_Pop_Fields = {
  __typename?: 'auth_user_entity_stddev_pop_fields';
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Auth_User_Entity_Stddev_Samp_Fields = {
  __typename?: 'auth_user_entity_stddev_samp_fields';
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "auth_user_entity" */
export type Auth_User_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_User_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_User_Entity_Stream_Cursor_Value_Input = {
  created_timestamp?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_constraint?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  federation_link?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  not_before?: InputMaybe<Scalars['Int']['input']>;
  realm_id?: InputMaybe<Scalars['String']['input']>;
  service_account_client_link?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Auth_User_Entity_Sum_Fields = {
  __typename?: 'auth_user_entity_sum_fields';
  created_timestamp?: Maybe<Scalars['bigint']['output']>;
  not_before?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "auth.user_entity" */
export enum Auth_User_Entity_Update_Column {
  /** column name */
  CreatedTimestamp = 'created_timestamp',
  /** column name */
  Email = 'email',
  /** column name */
  EmailConstraint = 'email_constraint',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FederationLink = 'federation_link',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NotBefore = 'not_before',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  ServiceAccountClientLink = 'service_account_client_link',
  /** column name */
  Username = 'username'
}

export type Auth_User_Entity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_User_Entity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_User_Entity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_User_Entity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_User_Entity_Var_Pop_Fields = {
  __typename?: 'auth_user_entity_var_pop_fields';
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Auth_User_Entity_Var_Samp_Fields = {
  __typename?: 'auth_user_entity_var_samp_fields';
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Auth_User_Entity_Variance_Fields = {
  __typename?: 'auth_user_entity_variance_fields';
  created_timestamp?: Maybe<Scalars['Float']['output']>;
  not_before?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  downloadExpiration: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String']['output'];
  maxUploadFileSize: Scalars['Int']['output'];
  minUploadFileSize: Scalars['Int']['output'];
  presignedUrlsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>;
  _not?: InputMaybe<Buckets_Bool_Exp>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  downloadExpiration?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  maxUploadFileSize?: InputMaybe<Order_By>;
  minUploadFileSize?: InputMaybe<Order_By>;
  presignedUrlsEnabled?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

export type Cambia_Stato_Cabina_Args = {
  action?: InputMaybe<Scalars['String']['input']>;
  cercabinaid?: InputMaybe<Scalars['uuid']['input']>;
  codice?: InputMaybe<Scalars['String']['input']>;
};

export type Cambia_Stato_Founder_Args = {
  action?: InputMaybe<Scalars['String']['input']>;
  feedbackaltro?: InputMaybe<Scalars['String']['input']>;
  feedbackid?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

export type Cambia_Stato_Installatore_Args = {
  action?: InputMaybe<Scalars['String']['input']>;
  feedbackaltro?: InputMaybe<Scalars['String']['input']>;
  feedbackid?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

export type Cambia_Stato_Prosumer_Args = {
  action?: InputMaybe<Scalars['String']['input']>;
  feedbackaltro?: InputMaybe<Scalars['String']['input']>;
  feedbackid?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

export type Cambia_Stato_Tecnico_Args = {
  action?: InputMaybe<Scalars['String']['input']>;
  feedbackaltro?: InputMaybe<Scalars['String']['input']>;
  feedbackid?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "cer" */
export type Cer = {
  __typename?: 'cer';
  _consumatori_dichiarati: Scalars['Int']['output'];
  _potenza_dichiarata?: Maybe<Scalars['numeric']['output']>;
  _produttori_dichiarati: Scalars['Int']['output'];
  abilita_richieste: Scalars['Boolean']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  alias_mail?: Maybe<Scalars['String']['output']>;
  attive: Scalars['Int']['output'];
  /** An array relationship */
  categorie_adesione: Array<Cer_Categoria_Adesione>;
  /** An aggregate relationship */
  categorie_adesione_aggregate: Cer_Categoria_Adesione_Aggregate;
  /** An array relationship */
  cer_cabina: Array<Cer_Cabina>;
  /** An aggregate relationship */
  cer_cabina_aggregate: Cer_Cabina_Aggregate;
  /** An object relationship */
  cer_padre?: Maybe<Cer>;
  codice_gse?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  configurazioni: Array<Cer>;
  /** An aggregate relationship */
  configurazioni_aggregate: Cer_Aggregate;
  consumatori_dichiarati: Scalars['Int']['output'];
  consumo: Scalars['Int']['output'];
  /** An array relationship */
  contatti: Array<Cer_Contatti>;
  /** An aggregate relationship */
  contatti_aggregate: Cer_Contatti_Aggregate;
  costi?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  data_costituzione?: Maybe<Scalars['timestamptz']['output']>;
  delete_categorie: Scalars['Boolean']['output'];
  descrizione?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  destinazioni_contributi: Array<Cer_Destinazione_Contributo>;
  /** An aggregate relationship */
  destinazioni_contributi_aggregate: Cer_Destinazione_Contributo_Aggregate;
  /** An array relationship */
  destinazioni_contributi_collegate: Array<Cer_Configurazione_Destinazione_Contributo>;
  /** An aggregate relationship */
  destinazioni_contributi_collegate_aggregate: Cer_Configurazione_Destinazione_Contributo_Aggregate;
  documenti_richiesti?: Maybe<Scalars['jsonb']['output']>;
  domande_richieste?: Maybe<Scalars['jsonb']['output']>;
  email_template: Scalars['jsonb']['output'];
  /** An object relationship */
  geom?: Maybe<Cer_Geom>;
  /** An array relationship */
  gestori: Array<Cer_Gestore>;
  /** An aggregate relationship */
  gestori_aggregate: Cer_Gestore_Aggregate;
  id: Scalars['uuid']['output'];
  impianti: Scalars['Int']['output'];
  /** An object relationship */
  indirizzo?: Maybe<Indirizzo>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  iniziative: Scalars['Int']['output'];
  /** An object relationship */
  logo?: Maybe<Files>;
  logo_id?: Maybe<Scalars['uuid']['output']>;
  modulo_richiesta?: Maybe<Scalars['jsonb']['output']>;
  mostra: Scalars['Boolean']['output'];
  notifiche: Scalars['Int']['output'];
  partecipanti: Scalars['Int']['output'];
  potenza: Scalars['Int']['output'];
  potenza_dichiarata: Scalars['Int']['output'];
  produttori_dichiarati: Scalars['Int']['output'];
  /** An object relationship */
  promotore?: Maybe<Persona>;
  promotore_id?: Maybe<Scalars['uuid']['output']>;
  pubblicata: Scalars['Boolean']['output'];
  referral?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  regolamento?: Maybe<Files>;
  regolamento_id?: Maybe<Scalars['uuid']['output']>;
  richiesta_iban?: Maybe<Scalars['Boolean']['output']>;
  richiesta_iniziativa_sociale?: Maybe<Scalars['Boolean']['output']>;
  richieste: Scalars['Int']['output'];
  /** An array relationship */
  richieste_pubblicazione: Array<Admin_Richiesta_Pubblicazione>;
  /** An aggregate relationship */
  richieste_pubblicazione_aggregate: Admin_Richiesta_Pubblicazione_Aggregate;
  root_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  societa?: Maybe<Persona>;
  societa_id?: Maybe<Scalars['uuid']['output']>;
  soggetto_referente_gse?: Maybe<Scalars['String']['output']>;
  stato_cer?: Maybe<Energy_Village__Stato_Cer_Enum>;
  /** An object relationship */
  statuto?: Maybe<Files>;
  statuto_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  tecnici: Array<Cer_Tecnico>;
  /** An aggregate relationship */
  tecnici_aggregate: Cer_Tecnico_Aggregate;
  /** An object relationship */
  tipologia_asset?: Maybe<Energy_Village_Tipologia_Asset>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  volantino?: Maybe<Files>;
  volantino_id?: Maybe<Scalars['uuid']['output']>;
  white_label: Scalars['Boolean']['output'];
  /** An object relationship */
  white_label_logo_chiaro?: Maybe<Files>;
  white_label_logo_chiaro_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  white_label_logo_scuro?: Maybe<Files>;
  white_label_logo_scuro_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  white_label_terms?: Maybe<Files>;
  white_label_terms_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  whitelabel: Array<White_Label_Associazione>;
  /** An aggregate relationship */
  whitelabel_aggregate: White_Label_Associazione_Aggregate;
};


/** columns and relationships of "cer" */
export type CerCategorie_AdesioneArgs = {
  distinct_on?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Categoria_Adesione_Order_By>>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerCategorie_Adesione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Categoria_Adesione_Order_By>>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerCer_CabinaArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerCer_Cabina_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerConfigurazioniArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerConfigurazioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerContattiArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerContatti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerCostiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "cer" */
export type CerDestinazioni_ContributiArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerDestinazioni_Contributi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerDestinazioni_Contributi_CollegateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerDestinazioni_Contributi_Collegate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerDocumenti_RichiestiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "cer" */
export type CerDomande_RichiesteArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "cer" */
export type CerEmail_TemplateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "cer" */
export type CerGestoriArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerGestori_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerModulo_RichiestaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "cer" */
export type CerRichieste_PubblicazioneArgs = {
  distinct_on?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerRichieste_Pubblicazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerTecniciArgs = {
  distinct_on?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Tecnico_Order_By>>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerTecnici_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Tecnico_Order_By>>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerWhitelabelArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


/** columns and relationships of "cer" */
export type CerWhitelabel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};

/** aggregated selection of "cer" */
export type Cer_Aggregate = {
  __typename?: 'cer_aggregate';
  aggregate?: Maybe<Cer_Aggregate_Fields>;
  nodes: Array<Cer>;
};

export type Cer_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cer_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cer_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cer_Aggregate_Bool_Exp_Count>;
};

export type Cer_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cer_Select_Column_Cer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cer_Select_Column_Cer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer" */
export type Cer_Aggregate_Fields = {
  __typename?: 'cer_aggregate_fields';
  avg?: Maybe<Cer_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Max_Fields>;
  min?: Maybe<Cer_Min_Fields>;
  stddev?: Maybe<Cer_Stddev_Fields>;
  stddev_pop?: Maybe<Cer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cer_Stddev_Samp_Fields>;
  sum?: Maybe<Cer_Sum_Fields>;
  var_pop?: Maybe<Cer_Var_Pop_Fields>;
  var_samp?: Maybe<Cer_Var_Samp_Fields>;
  variance?: Maybe<Cer_Variance_Fields>;
};


/** aggregate fields of "cer" */
export type Cer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer" */
export type Cer_Aggregate_Order_By = {
  avg?: InputMaybe<Cer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Max_Order_By>;
  min?: InputMaybe<Cer_Min_Order_By>;
  stddev?: InputMaybe<Cer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cer_Sum_Order_By>;
  var_pop?: InputMaybe<Cer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cer_Var_Samp_Order_By>;
  variance?: InputMaybe<Cer_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cer_Append_Input = {
  costi?: InputMaybe<Scalars['jsonb']['input']>;
  documenti_richiesti?: InputMaybe<Scalars['jsonb']['input']>;
  domande_richieste?: InputMaybe<Scalars['jsonb']['input']>;
  email_template?: InputMaybe<Scalars['jsonb']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "cer" */
export type Cer_Arr_Rel_Insert_Input = {
  data: Array<Cer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_On_Conflict>;
};

/** aggregate avg on columns */
export type Cer_Avg_Fields = {
  __typename?: 'cer_avg_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  attive?: Maybe<Scalars['Float']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  impianti?: Maybe<Scalars['Float']['output']>;
  iniziative?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  partecipanti?: Maybe<Scalars['Float']['output']>;
  potenza?: Maybe<Scalars['Float']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cer" */
export type Cer_Avg_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cer". All fields are combined with a logical 'AND'. */
export type Cer_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Bool_Exp>>;
  _consumatori_dichiarati?: InputMaybe<Int_Comparison_Exp>;
  _not?: InputMaybe<Cer_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Bool_Exp>>;
  _potenza_dichiarata?: InputMaybe<Numeric_Comparison_Exp>;
  _produttori_dichiarati?: InputMaybe<Int_Comparison_Exp>;
  abilita_richieste?: InputMaybe<Boolean_Comparison_Exp>;
  alias?: InputMaybe<String_Comparison_Exp>;
  alias_mail?: InputMaybe<String_Comparison_Exp>;
  attive?: InputMaybe<Int_Comparison_Exp>;
  categorie_adesione?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
  categorie_adesione_aggregate?: InputMaybe<Cer_Categoria_Adesione_Aggregate_Bool_Exp>;
  cer_cabina?: InputMaybe<Cer_Cabina_Bool_Exp>;
  cer_cabina_aggregate?: InputMaybe<Cer_Cabina_Aggregate_Bool_Exp>;
  cer_padre?: InputMaybe<Cer_Bool_Exp>;
  codice_gse?: InputMaybe<String_Comparison_Exp>;
  configurazioni?: InputMaybe<Cer_Bool_Exp>;
  configurazioni_aggregate?: InputMaybe<Cer_Aggregate_Bool_Exp>;
  consumatori_dichiarati?: InputMaybe<Int_Comparison_Exp>;
  consumo?: InputMaybe<Int_Comparison_Exp>;
  contatti?: InputMaybe<Cer_Contatti_Bool_Exp>;
  contatti_aggregate?: InputMaybe<Cer_Contatti_Aggregate_Bool_Exp>;
  costi?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_costituzione?: InputMaybe<Timestamptz_Comparison_Exp>;
  delete_categorie?: InputMaybe<Boolean_Comparison_Exp>;
  descrizione?: InputMaybe<String_Comparison_Exp>;
  destinazioni_contributi?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  destinazioni_contributi_aggregate?: InputMaybe<Cer_Destinazione_Contributo_Aggregate_Bool_Exp>;
  destinazioni_contributi_collegate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
  destinazioni_contributi_collegate_aggregate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Aggregate_Bool_Exp>;
  documenti_richiesti?: InputMaybe<Jsonb_Comparison_Exp>;
  domande_richieste?: InputMaybe<Jsonb_Comparison_Exp>;
  email_template?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Cer_Geom_Bool_Exp>;
  gestori?: InputMaybe<Cer_Gestore_Bool_Exp>;
  gestori_aggregate?: InputMaybe<Cer_Gestore_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impianti?: InputMaybe<Int_Comparison_Exp>;
  indirizzo?: InputMaybe<Indirizzo_Bool_Exp>;
  indirizzo_id?: InputMaybe<Uuid_Comparison_Exp>;
  iniziative?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<Files_Bool_Exp>;
  logo_id?: InputMaybe<Uuid_Comparison_Exp>;
  modulo_richiesta?: InputMaybe<Jsonb_Comparison_Exp>;
  mostra?: InputMaybe<Boolean_Comparison_Exp>;
  notifiche?: InputMaybe<Int_Comparison_Exp>;
  partecipanti?: InputMaybe<Int_Comparison_Exp>;
  potenza?: InputMaybe<Int_Comparison_Exp>;
  potenza_dichiarata?: InputMaybe<Int_Comparison_Exp>;
  produttori_dichiarati?: InputMaybe<Int_Comparison_Exp>;
  promotore?: InputMaybe<Persona_Bool_Exp>;
  promotore_id?: InputMaybe<Uuid_Comparison_Exp>;
  pubblicata?: InputMaybe<Boolean_Comparison_Exp>;
  referral?: InputMaybe<String_Comparison_Exp>;
  regolamento?: InputMaybe<Files_Bool_Exp>;
  regolamento_id?: InputMaybe<Uuid_Comparison_Exp>;
  richiesta_iban?: InputMaybe<Boolean_Comparison_Exp>;
  richiesta_iniziativa_sociale?: InputMaybe<Boolean_Comparison_Exp>;
  richieste?: InputMaybe<Int_Comparison_Exp>;
  richieste_pubblicazione?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
  richieste_pubblicazione_aggregate?: InputMaybe<Admin_Richiesta_Pubblicazione_Aggregate_Bool_Exp>;
  root_id?: InputMaybe<Uuid_Comparison_Exp>;
  societa?: InputMaybe<Persona_Bool_Exp>;
  societa_id?: InputMaybe<Uuid_Comparison_Exp>;
  soggetto_referente_gse?: InputMaybe<String_Comparison_Exp>;
  stato_cer?: InputMaybe<Energy_Village__Stato_Cer_Enum_Comparison_Exp>;
  statuto?: InputMaybe<Files_Bool_Exp>;
  statuto_id?: InputMaybe<Uuid_Comparison_Exp>;
  tecnici?: InputMaybe<Cer_Tecnico_Bool_Exp>;
  tecnici_aggregate?: InputMaybe<Cer_Tecnico_Aggregate_Bool_Exp>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  volantino?: InputMaybe<Files_Bool_Exp>;
  volantino_id?: InputMaybe<Uuid_Comparison_Exp>;
  white_label?: InputMaybe<Boolean_Comparison_Exp>;
  white_label_logo_chiaro?: InputMaybe<Files_Bool_Exp>;
  white_label_logo_chiaro_id?: InputMaybe<Uuid_Comparison_Exp>;
  white_label_logo_scuro?: InputMaybe<Files_Bool_Exp>;
  white_label_logo_scuro_id?: InputMaybe<Uuid_Comparison_Exp>;
  white_label_terms?: InputMaybe<Files_Bool_Exp>;
  white_label_terms_id?: InputMaybe<Uuid_Comparison_Exp>;
  whitelabel?: InputMaybe<White_Label_Associazione_Bool_Exp>;
  whitelabel_aggregate?: InputMaybe<White_Label_Associazione_Aggregate_Bool_Exp>;
};

/** columns and relationships of "cer_cabina" */
export type Cer_Cabina = {
  __typename?: 'cer_cabina';
  alias?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  cabina: Energy_Village_Cabina;
  cabina_id: Scalars['Int']['output'];
  cancellato: Scalars['Boolean']['output'];
  /** An object relationship */
  cer: Cer;
  cer_id: Scalars['uuid']['output'];
  codice_gse?: Maybe<Scalars['String']['output']>;
  codice_modifica?: Maybe<Scalars['String']['output']>;
  codice_richiesta?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  snapshot: Array<Cer_Cabina_Snapshot>;
  /** An aggregate relationship */
  snapshot_aggregate: Cer_Cabina_Snapshot_Aggregate;
  /** An array relationship */
  sottoscrizioni: Array<Sottoscrizione>;
  /** An aggregate relationship */
  sottoscrizioni_aggregate: Sottoscrizione_Aggregate;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "cer_cabina" */
export type Cer_CabinaSnapshotArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Snapshot_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};


/** columns and relationships of "cer_cabina" */
export type Cer_CabinaSnapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Snapshot_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};


/** columns and relationships of "cer_cabina" */
export type Cer_CabinaSottoscrizioniArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "cer_cabina" */
export type Cer_CabinaSottoscrizioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};

/** aggregated selection of "cer_cabina" */
export type Cer_Cabina_Aggregate = {
  __typename?: 'cer_cabina_aggregate';
  aggregate?: Maybe<Cer_Cabina_Aggregate_Fields>;
  nodes: Array<Cer_Cabina>;
};

export type Cer_Cabina_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cer_Cabina_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cer_Cabina_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cer_Cabina_Aggregate_Bool_Exp_Count>;
};

export type Cer_Cabina_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cer_Cabina_Select_Column_Cer_Cabina_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Cabina_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Cabina_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cer_Cabina_Select_Column_Cer_Cabina_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Cabina_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Cabina_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Cabina_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_cabina" */
export type Cer_Cabina_Aggregate_Fields = {
  __typename?: 'cer_cabina_aggregate_fields';
  avg?: Maybe<Cer_Cabina_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Cabina_Max_Fields>;
  min?: Maybe<Cer_Cabina_Min_Fields>;
  stddev?: Maybe<Cer_Cabina_Stddev_Fields>;
  stddev_pop?: Maybe<Cer_Cabina_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cer_Cabina_Stddev_Samp_Fields>;
  sum?: Maybe<Cer_Cabina_Sum_Fields>;
  var_pop?: Maybe<Cer_Cabina_Var_Pop_Fields>;
  var_samp?: Maybe<Cer_Cabina_Var_Samp_Fields>;
  variance?: Maybe<Cer_Cabina_Variance_Fields>;
};


/** aggregate fields of "cer_cabina" */
export type Cer_Cabina_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_cabina" */
export type Cer_Cabina_Aggregate_Order_By = {
  avg?: InputMaybe<Cer_Cabina_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Cabina_Max_Order_By>;
  min?: InputMaybe<Cer_Cabina_Min_Order_By>;
  stddev?: InputMaybe<Cer_Cabina_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cer_Cabina_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cer_Cabina_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cer_Cabina_Sum_Order_By>;
  var_pop?: InputMaybe<Cer_Cabina_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cer_Cabina_Var_Samp_Order_By>;
  variance?: InputMaybe<Cer_Cabina_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cer_cabina" */
export type Cer_Cabina_Arr_Rel_Insert_Input = {
  data: Array<Cer_Cabina_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Cabina_On_Conflict>;
};

/** aggregate avg on columns */
export type Cer_Cabina_Avg_Fields = {
  __typename?: 'cer_cabina_avg_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cer_cabina" */
export type Cer_Cabina_Avg_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cer_cabina". All fields are combined with a logical 'AND'. */
export type Cer_Cabina_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Cabina_Bool_Exp>>;
  _not?: InputMaybe<Cer_Cabina_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Cabina_Bool_Exp>>;
  alias?: InputMaybe<String_Comparison_Exp>;
  cabina?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
  cabina_id?: InputMaybe<Int_Comparison_Exp>;
  cancellato?: InputMaybe<Boolean_Comparison_Exp>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  codice_gse?: InputMaybe<String_Comparison_Exp>;
  codice_modifica?: InputMaybe<String_Comparison_Exp>;
  codice_richiesta?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  snapshot?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
  snapshot_aggregate?: InputMaybe<Cer_Cabina_Snapshot_Aggregate_Bool_Exp>;
  sottoscrizioni?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizioni_aggregate?: InputMaybe<Sottoscrizione_Aggregate_Bool_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_cabina" */
export enum Cer_Cabina_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerCabinaPkey = 'cer_cabina_pkey'
}

/** input type for incrementing numeric columns in table "cer_cabina" */
export type Cer_Cabina_Inc_Input = {
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cer_cabina" */
export type Cer_Cabina_Insert_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  cabina?: InputMaybe<Energy_Village_Cabina_Obj_Rel_Insert_Input>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  cancellato?: InputMaybe<Scalars['Boolean']['input']>;
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_gse?: InputMaybe<Scalars['String']['input']>;
  codice_modifica?: InputMaybe<Scalars['String']['input']>;
  codice_richiesta?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  snapshot?: InputMaybe<Cer_Cabina_Snapshot_Arr_Rel_Insert_Input>;
  sottoscrizioni?: InputMaybe<Sottoscrizione_Arr_Rel_Insert_Input>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Cabina_Max_Fields = {
  __typename?: 'cer_cabina_max_fields';
  alias?: Maybe<Scalars['String']['output']>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  codice_gse?: Maybe<Scalars['String']['output']>;
  codice_modifica?: Maybe<Scalars['String']['output']>;
  codice_richiesta?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cer_cabina" */
export type Cer_Cabina_Max_Order_By = {
  alias?: InputMaybe<Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  codice_gse?: InputMaybe<Order_By>;
  codice_modifica?: InputMaybe<Order_By>;
  codice_richiesta?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Cabina_Min_Fields = {
  __typename?: 'cer_cabina_min_fields';
  alias?: Maybe<Scalars['String']['output']>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  codice_gse?: Maybe<Scalars['String']['output']>;
  codice_modifica?: Maybe<Scalars['String']['output']>;
  codice_richiesta?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cer_cabina" */
export type Cer_Cabina_Min_Order_By = {
  alias?: InputMaybe<Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  codice_gse?: InputMaybe<Order_By>;
  codice_modifica?: InputMaybe<Order_By>;
  codice_richiesta?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_cabina" */
export type Cer_Cabina_Mutation_Response = {
  __typename?: 'cer_cabina_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Cabina>;
};

/** input type for inserting object relation for remote table "cer_cabina" */
export type Cer_Cabina_Obj_Rel_Insert_Input = {
  data: Cer_Cabina_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Cabina_On_Conflict>;
};

/** on_conflict condition type for table "cer_cabina" */
export type Cer_Cabina_On_Conflict = {
  constraint: Cer_Cabina_Constraint;
  update_columns?: Array<Cer_Cabina_Update_Column>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_cabina". */
export type Cer_Cabina_Order_By = {
  alias?: InputMaybe<Order_By>;
  cabina?: InputMaybe<Energy_Village_Cabina_Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  cancellato?: InputMaybe<Order_By>;
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  codice_gse?: InputMaybe<Order_By>;
  codice_modifica?: InputMaybe<Order_By>;
  codice_richiesta?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  snapshot_aggregate?: InputMaybe<Cer_Cabina_Snapshot_Aggregate_Order_By>;
  sottoscrizioni_aggregate?: InputMaybe<Sottoscrizione_Aggregate_Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_cabina */
export type Cer_Cabina_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cer_cabina" */
export enum Cer_Cabina_Select_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CabinaId = 'cabina_id',
  /** column name */
  Cancellato = 'cancellato',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CodiceGse = 'codice_gse',
  /** column name */
  CodiceModifica = 'codice_modifica',
  /** column name */
  CodiceRichiesta = 'codice_richiesta',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "cer_cabina_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cer_cabina" */
export enum Cer_Cabina_Select_Column_Cer_Cabina_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Cancellato = 'cancellato'
}

/** select "cer_cabina_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cer_cabina" */
export enum Cer_Cabina_Select_Column_Cer_Cabina_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Cancellato = 'cancellato'
}

/** input type for updating data in table "cer_cabina" */
export type Cer_Cabina_Set_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  cancellato?: InputMaybe<Scalars['Boolean']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_gse?: InputMaybe<Scalars['String']['input']>;
  codice_modifica?: InputMaybe<Scalars['String']['input']>;
  codice_richiesta?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot = {
  __typename?: 'cer_cabina_snapshot';
  applicato_at?: Maybe<Scalars['timestamptz']['output']>;
  auth_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cer_cabina: Cer_Cabina;
  cer_cabina_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  sottoscrizione: Sottoscrizione;
  sottoscrizione_id: Scalars['uuid']['output'];
  tipo: Scalars['String']['output'];
};

/** aggregated selection of "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Aggregate = {
  __typename?: 'cer_cabina_snapshot_aggregate';
  aggregate?: Maybe<Cer_Cabina_Snapshot_Aggregate_Fields>;
  nodes: Array<Cer_Cabina_Snapshot>;
};

export type Cer_Cabina_Snapshot_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cer_Cabina_Snapshot_Aggregate_Bool_Exp_Count>;
};

export type Cer_Cabina_Snapshot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Aggregate_Fields = {
  __typename?: 'cer_cabina_snapshot_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Cabina_Snapshot_Max_Fields>;
  min?: Maybe<Cer_Cabina_Snapshot_Min_Fields>;
};


/** aggregate fields of "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Cabina_Snapshot_Max_Order_By>;
  min?: InputMaybe<Cer_Cabina_Snapshot_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Arr_Rel_Insert_Input = {
  data: Array<Cer_Cabina_Snapshot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Cabina_Snapshot_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cer_cabina_snapshot". All fields are combined with a logical 'AND'. */
export type Cer_Cabina_Snapshot_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Cabina_Snapshot_Bool_Exp>>;
  _not?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Cabina_Snapshot_Bool_Exp>>;
  applicato_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  auth_id?: InputMaybe<Uuid_Comparison_Exp>;
  cer_cabina?: InputMaybe<Cer_Cabina_Bool_Exp>;
  cer_cabina_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  tipo?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_cabina_snapshot" */
export enum Cer_Cabina_Snapshot_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerCabinaSnapshotPkey = 'cer_cabina_snapshot_pkey',
  /** unique or primary key constraint on columns "cer_cabina_id", "sottoscrizione_id" */
  CerCabinaSnapshotVivaUq = 'cer_cabina_snapshot_viva_uq'
}

/** input type for inserting data into table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Insert_Input = {
  applicato_at?: InputMaybe<Scalars['timestamptz']['input']>;
  auth_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_cabina?: InputMaybe<Cer_Cabina_Obj_Rel_Insert_Input>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Cer_Cabina_Snapshot_Max_Fields = {
  __typename?: 'cer_cabina_snapshot_max_fields';
  applicato_at?: Maybe<Scalars['timestamptz']['output']>;
  auth_id?: Maybe<Scalars['uuid']['output']>;
  cer_cabina_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  tipo?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Max_Order_By = {
  applicato_at?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  cer_cabina_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Cabina_Snapshot_Min_Fields = {
  __typename?: 'cer_cabina_snapshot_min_fields';
  applicato_at?: Maybe<Scalars['timestamptz']['output']>;
  auth_id?: Maybe<Scalars['uuid']['output']>;
  cer_cabina_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  tipo?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Min_Order_By = {
  applicato_at?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  cer_cabina_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Mutation_Response = {
  __typename?: 'cer_cabina_snapshot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Cabina_Snapshot>;
};

/** on_conflict condition type for table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_On_Conflict = {
  constraint: Cer_Cabina_Snapshot_Constraint;
  update_columns?: Array<Cer_Cabina_Snapshot_Update_Column>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_cabina_snapshot". */
export type Cer_Cabina_Snapshot_Order_By = {
  applicato_at?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  cer_cabina?: InputMaybe<Cer_Cabina_Order_By>;
  cer_cabina_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_cabina_snapshot */
export type Cer_Cabina_Snapshot_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cer_cabina_snapshot" */
export enum Cer_Cabina_Snapshot_Select_Column {
  /** column name */
  ApplicatoAt = 'applicato_at',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CerCabinaId = 'cer_cabina_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Tipo = 'tipo'
}

/** input type for updating data in table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Set_Input = {
  applicato_at?: InputMaybe<Scalars['timestamptz']['input']>;
  auth_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "cer_cabina_snapshot" */
export type Cer_Cabina_Snapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Cabina_Snapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Cabina_Snapshot_Stream_Cursor_Value_Input = {
  applicato_at?: InputMaybe<Scalars['timestamptz']['input']>;
  auth_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "cer_cabina_snapshot" */
export enum Cer_Cabina_Snapshot_Update_Column {
  /** column name */
  ApplicatoAt = 'applicato_at',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CerCabinaId = 'cer_cabina_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Tipo = 'tipo'
}

export type Cer_Cabina_Snapshot_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Cabina_Snapshot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Cabina_Snapshot_Bool_Exp;
};

/** aggregate stddev on columns */
export type Cer_Cabina_Stddev_Fields = {
  __typename?: 'cer_cabina_stddev_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cer_cabina" */
export type Cer_Cabina_Stddev_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cer_Cabina_Stddev_Pop_Fields = {
  __typename?: 'cer_cabina_stddev_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cer_cabina" */
export type Cer_Cabina_Stddev_Pop_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cer_Cabina_Stddev_Samp_Fields = {
  __typename?: 'cer_cabina_stddev_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cer_cabina" */
export type Cer_Cabina_Stddev_Samp_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cer_cabina" */
export type Cer_Cabina_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Cabina_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Cabina_Stream_Cursor_Value_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  cancellato?: InputMaybe<Scalars['Boolean']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_gse?: InputMaybe<Scalars['String']['input']>;
  codice_modifica?: InputMaybe<Scalars['String']['input']>;
  codice_richiesta?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Cer_Cabina_Sum_Fields = {
  __typename?: 'cer_cabina_sum_fields';
  cabina_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cer_cabina" */
export type Cer_Cabina_Sum_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** update columns of table "cer_cabina" */
export enum Cer_Cabina_Update_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CabinaId = 'cabina_id',
  /** column name */
  Cancellato = 'cancellato',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CodiceGse = 'codice_gse',
  /** column name */
  CodiceModifica = 'codice_modifica',
  /** column name */
  CodiceRichiesta = 'codice_richiesta',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Cabina_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cer_Cabina_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Cabina_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Cabina_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cer_Cabina_Var_Pop_Fields = {
  __typename?: 'cer_cabina_var_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cer_cabina" */
export type Cer_Cabina_Var_Pop_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cer_Cabina_Var_Samp_Fields = {
  __typename?: 'cer_cabina_var_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cer_cabina" */
export type Cer_Cabina_Var_Samp_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cer_Cabina_Variance_Fields = {
  __typename?: 'cer_cabina_variance_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cer_cabina" */
export type Cer_Cabina_Variance_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "cer_categoria_adesione" */
export type Cer_Categoria_Adesione = {
  __typename?: 'cer_categoria_adesione';
  categoria?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  cer?: Maybe<Cer>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  chiesto?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  delete: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  regole?: Maybe<Scalars['jsonb']['output']>;
  tipologia?: Maybe<Scalars['uuid']['output']>;
  tipologia_richiesta?: Maybe<Array<Scalars['String']['output']>>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "cer_categoria_adesione" */
export type Cer_Categoria_AdesioneRegoleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Aggregate = {
  __typename?: 'cer_categoria_adesione_aggregate';
  aggregate?: Maybe<Cer_Categoria_Adesione_Aggregate_Fields>;
  nodes: Array<Cer_Categoria_Adesione>;
};

export type Cer_Categoria_Adesione_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cer_Categoria_Adesione_Aggregate_Bool_Exp_Count>;
};

export type Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cer_Categoria_Adesione_Select_Column_Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cer_Categoria_Adesione_Select_Column_Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Categoria_Adesione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Aggregate_Fields = {
  __typename?: 'cer_categoria_adesione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Categoria_Adesione_Max_Fields>;
  min?: Maybe<Cer_Categoria_Adesione_Min_Fields>;
};


/** aggregate fields of "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Categoria_Adesione_Max_Order_By>;
  min?: InputMaybe<Cer_Categoria_Adesione_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cer_Categoria_Adesione_Append_Input = {
  regole?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Arr_Rel_Insert_Input = {
  data: Array<Cer_Categoria_Adesione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Categoria_Adesione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cer_categoria_adesione". All fields are combined with a logical 'AND'. */
export type Cer_Categoria_Adesione_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Categoria_Adesione_Bool_Exp>>;
  _not?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Categoria_Adesione_Bool_Exp>>;
  categoria?: InputMaybe<String_Comparison_Exp>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  chiesto?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delete?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  regole?: InputMaybe<Jsonb_Comparison_Exp>;
  tipologia?: InputMaybe<Uuid_Comparison_Exp>;
  tipologia_richiesta?: InputMaybe<String_Array_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_categoria_adesione" */
export enum Cer_Categoria_Adesione_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerCategoriaAdesionePkey = 'cer_categoria_adesione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cer_Categoria_Adesione_Delete_At_Path_Input = {
  regole?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cer_Categoria_Adesione_Delete_Elem_Input = {
  regole?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cer_Categoria_Adesione_Delete_Key_Input = {
  regole?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Insert_Input = {
  categoria?: InputMaybe<Scalars['String']['input']>;
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  chiesto?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  regole?: InputMaybe<Scalars['jsonb']['input']>;
  tipologia?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_richiesta?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Categoria_Adesione_Max_Fields = {
  __typename?: 'cer_categoria_adesione_max_fields';
  categoria?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tipologia?: Maybe<Scalars['uuid']['output']>;
  tipologia_richiesta?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Max_Order_By = {
  categoria?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipologia?: InputMaybe<Order_By>;
  tipologia_richiesta?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Categoria_Adesione_Min_Fields = {
  __typename?: 'cer_categoria_adesione_min_fields';
  categoria?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tipologia?: Maybe<Scalars['uuid']['output']>;
  tipologia_richiesta?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Min_Order_By = {
  categoria?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipologia?: InputMaybe<Order_By>;
  tipologia_richiesta?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Mutation_Response = {
  __typename?: 'cer_categoria_adesione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Categoria_Adesione>;
};

/** input type for inserting object relation for remote table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Obj_Rel_Insert_Input = {
  data: Cer_Categoria_Adesione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Categoria_Adesione_On_Conflict>;
};

/** on_conflict condition type for table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_On_Conflict = {
  constraint: Cer_Categoria_Adesione_Constraint;
  update_columns?: Array<Cer_Categoria_Adesione_Update_Column>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_categoria_adesione". */
export type Cer_Categoria_Adesione_Order_By = {
  categoria?: InputMaybe<Order_By>;
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  chiesto?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delete?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  regole?: InputMaybe<Order_By>;
  tipologia?: InputMaybe<Order_By>;
  tipologia_richiesta?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_categoria_adesione */
export type Cer_Categoria_Adesione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cer_Categoria_Adesione_Prepend_Input = {
  regole?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "cer_categoria_adesione" */
export enum Cer_Categoria_Adesione_Select_Column {
  /** column name */
  Categoria = 'categoria',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  Chiesto = 'chiesto',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delete = 'delete',
  /** column name */
  Id = 'id',
  /** column name */
  Regole = 'regole',
  /** column name */
  Tipologia = 'tipologia',
  /** column name */
  TipologiaRichiesta = 'tipologia_richiesta',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "cer_categoria_adesione_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cer_categoria_adesione" */
export enum Cer_Categoria_Adesione_Select_Column_Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Chiesto = 'chiesto',
  /** column name */
  Delete = 'delete'
}

/** select "cer_categoria_adesione_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cer_categoria_adesione" */
export enum Cer_Categoria_Adesione_Select_Column_Cer_Categoria_Adesione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Chiesto = 'chiesto',
  /** column name */
  Delete = 'delete'
}

/** input type for updating data in table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Set_Input = {
  categoria?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  chiesto?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  regole?: InputMaybe<Scalars['jsonb']['input']>;
  tipologia?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_richiesta?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "cer_categoria_adesione" */
export type Cer_Categoria_Adesione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Categoria_Adesione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Categoria_Adesione_Stream_Cursor_Value_Input = {
  categoria?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  chiesto?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  regole?: InputMaybe<Scalars['jsonb']['input']>;
  tipologia?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_richiesta?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "cer_categoria_adesione" */
export enum Cer_Categoria_Adesione_Update_Column {
  /** column name */
  Categoria = 'categoria',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  Chiesto = 'chiesto',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delete = 'delete',
  /** column name */
  Id = 'id',
  /** column name */
  Regole = 'regole',
  /** column name */
  Tipologia = 'tipologia',
  /** column name */
  TipologiaRichiesta = 'tipologia_richiesta',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Categoria_Adesione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cer_Categoria_Adesione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cer_Categoria_Adesione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cer_Categoria_Adesione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cer_Categoria_Adesione_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cer_Categoria_Adesione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Categoria_Adesione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Categoria_Adesione_Bool_Exp;
};

/** columns and relationships of "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo = {
  __typename?: 'cer_configurazione_destinazione_contributo';
  /** An object relationship */
  cer: Cer;
  /** An object relationship */
  cer_destinazione_contributo: Cer_Destinazione_Contributo;
  cer_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  destinazione_contributo_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Aggregate = {
  __typename?: 'cer_configurazione_destinazione_contributo_aggregate';
  aggregate?: Maybe<Cer_Configurazione_Destinazione_Contributo_Aggregate_Fields>;
  nodes: Array<Cer_Configurazione_Destinazione_Contributo>;
};

export type Cer_Configurazione_Destinazione_Contributo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Aggregate_Bool_Exp_Count>;
};

export type Cer_Configurazione_Destinazione_Contributo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Aggregate_Fields = {
  __typename?: 'cer_configurazione_destinazione_contributo_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Configurazione_Destinazione_Contributo_Max_Fields>;
  min?: Maybe<Cer_Configurazione_Destinazione_Contributo_Min_Fields>;
};


/** aggregate fields of "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Max_Order_By>;
  min?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Arr_Rel_Insert_Input = {
  data: Array<Cer_Configurazione_Destinazione_Contributo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cer_configurazione_destinazione_contributo". All fields are combined with a logical 'AND'. */
export type Cer_Configurazione_Destinazione_Contributo_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>>;
  _not?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_destinazione_contributo?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  destinazione_contributo_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_configurazione_destinazione_contributo" */
export enum Cer_Configurazione_Destinazione_Contributo_Constraint {
  /** unique or primary key constraint on columns "cer_id", "destinazione_contributo_id" */
  CerConfDestContributoUnique = 'cer_conf_dest_contributo_unique',
  /** unique or primary key constraint on columns "id" */
  CerConfigurazioneDestinazioneContributoPkey = 'cer_configurazione_destinazione_contributo_pkey'
}

/** input type for inserting data into table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Insert_Input = {
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_destinazione_contributo?: InputMaybe<Cer_Destinazione_Contributo_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  destinazione_contributo_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Cer_Configurazione_Destinazione_Contributo_Max_Fields = {
  __typename?: 'cer_configurazione_destinazione_contributo_max_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  destinazione_contributo_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Max_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  destinazione_contributo_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Configurazione_Destinazione_Contributo_Min_Fields = {
  __typename?: 'cer_configurazione_destinazione_contributo_min_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  destinazione_contributo_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Min_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  destinazione_contributo_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Mutation_Response = {
  __typename?: 'cer_configurazione_destinazione_contributo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Configurazione_Destinazione_Contributo>;
};

/** on_conflict condition type for table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_On_Conflict = {
  constraint: Cer_Configurazione_Destinazione_Contributo_Constraint;
  update_columns?: Array<Cer_Configurazione_Destinazione_Contributo_Update_Column>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_configurazione_destinazione_contributo". */
export type Cer_Configurazione_Destinazione_Contributo_Order_By = {
  cer?: InputMaybe<Cer_Order_By>;
  cer_destinazione_contributo?: InputMaybe<Cer_Destinazione_Contributo_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  destinazione_contributo_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_configurazione_destinazione_contributo */
export type Cer_Configurazione_Destinazione_Contributo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cer_configurazione_destinazione_contributo" */
export enum Cer_Configurazione_Destinazione_Contributo_Select_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DestinazioneContributoId = 'destinazione_contributo_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Set_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  destinazione_contributo_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "cer_configurazione_destinazione_contributo" */
export type Cer_Configurazione_Destinazione_Contributo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Configurazione_Destinazione_Contributo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Configurazione_Destinazione_Contributo_Stream_Cursor_Value_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  destinazione_contributo_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "cer_configurazione_destinazione_contributo" */
export enum Cer_Configurazione_Destinazione_Contributo_Update_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DestinazioneContributoId = 'destinazione_contributo_id',
  /** column name */
  Id = 'id'
}

export type Cer_Configurazione_Destinazione_Contributo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Configurazione_Destinazione_Contributo_Bool_Exp;
};

/** unique or primary key constraints on table "cer" */
export enum Cer_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerPkey = 'cer_pkey',
  /** unique or primary key constraint on columns "referral" */
  CerReferralKey = 'cer_referral_key',
  /** unique or primary key constraint on columns "soggetto_referente_gse" */
  CerSoggettoReferenteGseKey = 'cer_soggetto_referente_gse_key'
}

/** columns and relationships of "cer_contatti" */
export type Cer_Contatti = {
  __typename?: 'cer_contatti';
  /** An object relationship */
  cer: Cer;
  cer_id: Scalars['uuid']['output'];
  /** An object relationship */
  contatto: Contatto;
  contatto_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "cer_contatti" */
export type Cer_Contatti_Aggregate = {
  __typename?: 'cer_contatti_aggregate';
  aggregate?: Maybe<Cer_Contatti_Aggregate_Fields>;
  nodes: Array<Cer_Contatti>;
};

export type Cer_Contatti_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cer_Contatti_Aggregate_Bool_Exp_Count>;
};

export type Cer_Contatti_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Contatti_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_contatti" */
export type Cer_Contatti_Aggregate_Fields = {
  __typename?: 'cer_contatti_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Contatti_Max_Fields>;
  min?: Maybe<Cer_Contatti_Min_Fields>;
};


/** aggregate fields of "cer_contatti" */
export type Cer_Contatti_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_contatti" */
export type Cer_Contatti_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Contatti_Max_Order_By>;
  min?: InputMaybe<Cer_Contatti_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cer_contatti" */
export type Cer_Contatti_Arr_Rel_Insert_Input = {
  data: Array<Cer_Contatti_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Contatti_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cer_contatti". All fields are combined with a logical 'AND'. */
export type Cer_Contatti_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Contatti_Bool_Exp>>;
  _not?: InputMaybe<Cer_Contatti_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Contatti_Bool_Exp>>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  contatto?: InputMaybe<Contatto_Bool_Exp>;
  contatto_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_contatti" */
export enum Cer_Contatti_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerContattiPkey = 'cer_contatti_pkey'
}

/** input type for inserting data into table "cer_contatti" */
export type Cer_Contatti_Insert_Input = {
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  contatto?: InputMaybe<Contatto_Obj_Rel_Insert_Input>;
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Contatti_Max_Fields = {
  __typename?: 'cer_contatti_max_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  contatto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cer_contatti" */
export type Cer_Contatti_Max_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  contatto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Contatti_Min_Fields = {
  __typename?: 'cer_contatti_min_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  contatto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cer_contatti" */
export type Cer_Contatti_Min_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  contatto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_contatti" */
export type Cer_Contatti_Mutation_Response = {
  __typename?: 'cer_contatti_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Contatti>;
};

/** on_conflict condition type for table "cer_contatti" */
export type Cer_Contatti_On_Conflict = {
  constraint: Cer_Contatti_Constraint;
  update_columns?: Array<Cer_Contatti_Update_Column>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_contatti". */
export type Cer_Contatti_Order_By = {
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  contatto?: InputMaybe<Contatto_Order_By>;
  contatto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_contatti */
export type Cer_Contatti_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cer_contatti" */
export enum Cer_Contatti_Select_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  ContattoId = 'contatto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cer_contatti" */
export type Cer_Contatti_Set_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "cer_contatti" */
export type Cer_Contatti_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Contatti_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Contatti_Stream_Cursor_Value_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "cer_contatti" */
export enum Cer_Contatti_Update_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  ContattoId = 'contatto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Contatti_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Contatti_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Contatti_Bool_Exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cer_Delete_At_Path_Input = {
  costi?: InputMaybe<Array<Scalars['String']['input']>>;
  documenti_richiesti?: InputMaybe<Array<Scalars['String']['input']>>;
  domande_richieste?: InputMaybe<Array<Scalars['String']['input']>>;
  email_template?: InputMaybe<Array<Scalars['String']['input']>>;
  modulo_richiesta?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cer_Delete_Elem_Input = {
  costi?: InputMaybe<Scalars['Int']['input']>;
  documenti_richiesti?: InputMaybe<Scalars['Int']['input']>;
  domande_richieste?: InputMaybe<Scalars['Int']['input']>;
  email_template?: InputMaybe<Scalars['Int']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cer_Delete_Key_Input = {
  costi?: InputMaybe<Scalars['String']['input']>;
  documenti_richiesti?: InputMaybe<Scalars['String']['input']>;
  domande_richieste?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['String']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo = {
  __typename?: 'cer_destinazione_contributo';
  ambito: Scalars['String']['output'];
  /** An object relationship */
  cer?: Maybe<Cer>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  configurazioni_collegate: Array<Cer_Configurazione_Destinazione_Contributo>;
  /** An aggregate relationship */
  configurazioni_collegate_aggregate: Cer_Configurazione_Destinazione_Contributo_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  descrizione: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  persona?: Maybe<Persona>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  predefinita: Scalars['Boolean']['output'];
  /** An array relationship */
  sottoscrizione_iniziativas: Array<Sottoscrizione_Iniziativa>;
  /** An aggregate relationship */
  sottoscrizione_iniziativas_aggregate: Sottoscrizione_Iniziativa_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "cer_destinazione_contributo" */
export type Cer_Destinazione_ContributoConfigurazioni_CollegateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "cer_destinazione_contributo" */
export type Cer_Destinazione_ContributoConfigurazioni_Collegate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "cer_destinazione_contributo" */
export type Cer_Destinazione_ContributoSottoscrizione_IniziativasArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


/** columns and relationships of "cer_destinazione_contributo" */
export type Cer_Destinazione_ContributoSottoscrizione_Iniziativas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};

/** aggregated selection of "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Aggregate = {
  __typename?: 'cer_destinazione_contributo_aggregate';
  aggregate?: Maybe<Cer_Destinazione_Contributo_Aggregate_Fields>;
  nodes: Array<Cer_Destinazione_Contributo>;
};

export type Cer_Destinazione_Contributo_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Count>;
};

export type Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cer_Destinazione_Contributo_Select_Column_Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cer_Destinazione_Contributo_Select_Column_Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Aggregate_Fields = {
  __typename?: 'cer_destinazione_contributo_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Destinazione_Contributo_Max_Fields>;
  min?: Maybe<Cer_Destinazione_Contributo_Min_Fields>;
};


/** aggregate fields of "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Destinazione_Contributo_Max_Order_By>;
  min?: InputMaybe<Cer_Destinazione_Contributo_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Arr_Rel_Insert_Input = {
  data: Array<Cer_Destinazione_Contributo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Destinazione_Contributo_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cer_destinazione_contributo". All fields are combined with a logical 'AND'. */
export type Cer_Destinazione_Contributo_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Destinazione_Contributo_Bool_Exp>>;
  _not?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Destinazione_Contributo_Bool_Exp>>;
  ambito?: InputMaybe<String_Comparison_Exp>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  configurazioni_collegate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
  configurazioni_collegate_aggregate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  descrizione?: InputMaybe<String_Comparison_Exp>;
  iban?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  persona?: InputMaybe<Persona_Bool_Exp>;
  persona_id?: InputMaybe<Uuid_Comparison_Exp>;
  predefinita?: InputMaybe<Boolean_Comparison_Exp>;
  sottoscrizione_iniziativas?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
  sottoscrizione_iniziativas_aggregate?: InputMaybe<Sottoscrizione_Iniziativa_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_destinazione_contributo" */
export enum Cer_Destinazione_Contributo_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerDestinazioneContributoPkey = 'cer_destinazione_contributo_pkey',
  /** unique or primary key constraint on columns "predefinita" */
  CerDestinazioneContributoPredefinitaUidx = 'cer_destinazione_contributo_predefinita_uidx'
}

/** input type for inserting data into table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Insert_Input = {
  ambito?: InputMaybe<Scalars['String']['input']>;
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  configurazioni_collegate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  descrizione?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  persona?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  predefinita?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione_iniziativas?: InputMaybe<Sottoscrizione_Iniziativa_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Destinazione_Contributo_Max_Fields = {
  __typename?: 'cer_destinazione_contributo_max_fields';
  ambito?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Max_Order_By = {
  ambito?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  descrizione?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  persona_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Destinazione_Contributo_Min_Fields = {
  __typename?: 'cer_destinazione_contributo_min_fields';
  ambito?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Min_Order_By = {
  ambito?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  descrizione?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  persona_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Mutation_Response = {
  __typename?: 'cer_destinazione_contributo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Destinazione_Contributo>;
};

/** input type for inserting object relation for remote table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Obj_Rel_Insert_Input = {
  data: Cer_Destinazione_Contributo_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Destinazione_Contributo_On_Conflict>;
};

/** on_conflict condition type for table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_On_Conflict = {
  constraint: Cer_Destinazione_Contributo_Constraint;
  update_columns?: Array<Cer_Destinazione_Contributo_Update_Column>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_destinazione_contributo". */
export type Cer_Destinazione_Contributo_Order_By = {
  ambito?: InputMaybe<Order_By>;
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  configurazioni_collegate_aggregate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  descrizione?: InputMaybe<Order_By>;
  iban?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  persona?: InputMaybe<Persona_Order_By>;
  persona_id?: InputMaybe<Order_By>;
  predefinita?: InputMaybe<Order_By>;
  sottoscrizione_iniziativas_aggregate?: InputMaybe<Sottoscrizione_Iniziativa_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_destinazione_contributo */
export type Cer_Destinazione_Contributo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cer_destinazione_contributo" */
export enum Cer_Destinazione_Contributo_Select_Column {
  /** column name */
  Ambito = 'ambito',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Descrizione = 'descrizione',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  PersonaId = 'persona_id',
  /** column name */
  Predefinita = 'predefinita',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "cer_destinazione_contributo_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cer_destinazione_contributo" */
export enum Cer_Destinazione_Contributo_Select_Column_Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Predefinita = 'predefinita'
}

/** select "cer_destinazione_contributo_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cer_destinazione_contributo" */
export enum Cer_Destinazione_Contributo_Select_Column_Cer_Destinazione_Contributo_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Predefinita = 'predefinita'
}

/** input type for updating data in table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Set_Input = {
  ambito?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  descrizione?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  predefinita?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "cer_destinazione_contributo" */
export type Cer_Destinazione_Contributo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Destinazione_Contributo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Destinazione_Contributo_Stream_Cursor_Value_Input = {
  ambito?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  descrizione?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  predefinita?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "cer_destinazione_contributo" */
export enum Cer_Destinazione_Contributo_Update_Column {
  /** column name */
  Ambito = 'ambito',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Descrizione = 'descrizione',
  /** column name */
  Iban = 'iban',
  /** column name */
  Id = 'id',
  /** column name */
  PersonaId = 'persona_id',
  /** column name */
  Predefinita = 'predefinita',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Destinazione_Contributo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Destinazione_Contributo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Destinazione_Contributo_Bool_Exp;
};

/** columns and relationships of "cer_geom" */
export type Cer_Geom = {
  __typename?: 'cer_geom';
  cabina_ids?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  cer?: Maybe<Cer>;
  created_at: Scalars['timestamptz']['output'];
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "cer_geom" */
export type Cer_GeomCabina_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cer_geom" */
export type Cer_Geom_Aggregate = {
  __typename?: 'cer_geom_aggregate';
  aggregate?: Maybe<Cer_Geom_Aggregate_Fields>;
  nodes: Array<Cer_Geom>;
};

/** aggregate fields of "cer_geom" */
export type Cer_Geom_Aggregate_Fields = {
  __typename?: 'cer_geom_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Geom_Max_Fields>;
  min?: Maybe<Cer_Geom_Min_Fields>;
};


/** aggregate fields of "cer_geom" */
export type Cer_Geom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Geom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cer_Geom_Append_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "cer_geom". All fields are combined with a logical 'AND'. */
export type Cer_Geom_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Geom_Bool_Exp>>;
  _not?: InputMaybe<Cer_Geom_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Geom_Bool_Exp>>;
  cabina_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_geom" */
export enum Cer_Geom_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerGeomPkey = 'cer_geom_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cer_Geom_Delete_At_Path_Input = {
  cabina_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cer_Geom_Delete_Elem_Input = {
  cabina_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cer_Geom_Delete_Key_Input = {
  cabina_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "cer_geom" */
export type Cer_Geom_Insert_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Geom_Max_Fields = {
  __typename?: 'cer_geom_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Cer_Geom_Min_Fields = {
  __typename?: 'cer_geom_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "cer_geom" */
export type Cer_Geom_Mutation_Response = {
  __typename?: 'cer_geom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Geom>;
};

/** input type for inserting object relation for remote table "cer_geom" */
export type Cer_Geom_Obj_Rel_Insert_Input = {
  data: Cer_Geom_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Geom_On_Conflict>;
};

/** on_conflict condition type for table "cer_geom" */
export type Cer_Geom_On_Conflict = {
  constraint: Cer_Geom_Constraint;
  update_columns?: Array<Cer_Geom_Update_Column>;
  where?: InputMaybe<Cer_Geom_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_geom". */
export type Cer_Geom_Order_By = {
  cabina_ids?: InputMaybe<Order_By>;
  cer?: InputMaybe<Cer_Order_By>;
  created_at?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_geom */
export type Cer_Geom_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cer_Geom_Prepend_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "cer_geom" */
export enum Cer_Geom_Select_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cer_geom" */
export type Cer_Geom_Set_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "cer_geom" */
export type Cer_Geom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Geom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Geom_Stream_Cursor_Value_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "cer_geom" */
export enum Cer_Geom_Update_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Geom_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cer_Geom_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cer_Geom_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cer_Geom_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cer_Geom_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cer_Geom_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Geom_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Geom_Bool_Exp;
};

/** columns and relationships of "cer_gestore" */
export type Cer_Gestore = {
  __typename?: 'cer_gestore';
  auth_id: Scalars['String']['output'];
  /** An object relationship */
  cer: Cer;
  cer_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  gestore: Auth_User_Entity;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "cer_gestore" */
export type Cer_Gestore_Aggregate = {
  __typename?: 'cer_gestore_aggregate';
  aggregate?: Maybe<Cer_Gestore_Aggregate_Fields>;
  nodes: Array<Cer_Gestore>;
};

export type Cer_Gestore_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cer_Gestore_Aggregate_Bool_Exp_Count>;
};

export type Cer_Gestore_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Gestore_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_gestore" */
export type Cer_Gestore_Aggregate_Fields = {
  __typename?: 'cer_gestore_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Gestore_Max_Fields>;
  min?: Maybe<Cer_Gestore_Min_Fields>;
};


/** aggregate fields of "cer_gestore" */
export type Cer_Gestore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_gestore" */
export type Cer_Gestore_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Gestore_Max_Order_By>;
  min?: InputMaybe<Cer_Gestore_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cer_gestore" */
export type Cer_Gestore_Arr_Rel_Insert_Input = {
  data: Array<Cer_Gestore_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Gestore_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cer_gestore". All fields are combined with a logical 'AND'. */
export type Cer_Gestore_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Gestore_Bool_Exp>>;
  _not?: InputMaybe<Cer_Gestore_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Gestore_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gestore?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_gestore" */
export enum Cer_Gestore_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerGestorePkey = 'cer_gestore_pkey'
}

/** input type for inserting data into table "cer_gestore" */
export type Cer_Gestore_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gestore?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Gestore_Max_Fields = {
  __typename?: 'cer_gestore_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cer_gestore" */
export type Cer_Gestore_Max_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Gestore_Min_Fields = {
  __typename?: 'cer_gestore_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cer_gestore" */
export type Cer_Gestore_Min_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_gestore" */
export type Cer_Gestore_Mutation_Response = {
  __typename?: 'cer_gestore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Gestore>;
};

/** on_conflict condition type for table "cer_gestore" */
export type Cer_Gestore_On_Conflict = {
  constraint: Cer_Gestore_Constraint;
  update_columns?: Array<Cer_Gestore_Update_Column>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_gestore". */
export type Cer_Gestore_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gestore?: InputMaybe<Auth_User_Entity_Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_gestore */
export type Cer_Gestore_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cer_gestore" */
export enum Cer_Gestore_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cer_gestore" */
export type Cer_Gestore_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "cer_gestore" */
export type Cer_Gestore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Gestore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Gestore_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "cer_gestore" */
export enum Cer_Gestore_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Gestore_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Gestore_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Gestore_Bool_Exp;
};

/** input type for incrementing numeric columns in table "cer" */
export type Cer_Inc_Input = {
  _consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  _potenza_dichiarata?: InputMaybe<Scalars['numeric']['input']>;
  _produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  attive?: InputMaybe<Scalars['Int']['input']>;
  consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  consumo?: InputMaybe<Scalars['Int']['input']>;
  impianti?: InputMaybe<Scalars['Int']['input']>;
  iniziative?: InputMaybe<Scalars['Int']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  partecipanti?: InputMaybe<Scalars['Int']['input']>;
  potenza?: InputMaybe<Scalars['Int']['input']>;
  potenza_dichiarata?: InputMaybe<Scalars['Int']['input']>;
  produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  richieste?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cer" */
export type Cer_Insert_Input = {
  _consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  _potenza_dichiarata?: InputMaybe<Scalars['numeric']['input']>;
  _produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  alias_mail?: InputMaybe<Scalars['String']['input']>;
  attive?: InputMaybe<Scalars['Int']['input']>;
  categorie_adesione?: InputMaybe<Cer_Categoria_Adesione_Arr_Rel_Insert_Input>;
  cer_cabina?: InputMaybe<Cer_Cabina_Arr_Rel_Insert_Input>;
  cer_padre?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  codice_gse?: InputMaybe<Scalars['String']['input']>;
  configurazioni?: InputMaybe<Cer_Arr_Rel_Insert_Input>;
  consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  consumo?: InputMaybe<Scalars['Int']['input']>;
  contatti?: InputMaybe<Cer_Contatti_Arr_Rel_Insert_Input>;
  costi?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_costituzione?: InputMaybe<Scalars['timestamptz']['input']>;
  delete_categorie?: InputMaybe<Scalars['Boolean']['input']>;
  descrizione?: InputMaybe<Scalars['String']['input']>;
  destinazioni_contributi?: InputMaybe<Cer_Destinazione_Contributo_Arr_Rel_Insert_Input>;
  destinazioni_contributi_collegate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Arr_Rel_Insert_Input>;
  documenti_richiesti?: InputMaybe<Scalars['jsonb']['input']>;
  domande_richieste?: InputMaybe<Scalars['jsonb']['input']>;
  email_template?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Cer_Geom_Obj_Rel_Insert_Input>;
  gestori?: InputMaybe<Cer_Gestore_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impianti?: InputMaybe<Scalars['Int']['input']>;
  indirizzo?: InputMaybe<Indirizzo_Obj_Rel_Insert_Input>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  iniziative?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  logo_id?: InputMaybe<Scalars['uuid']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['jsonb']['input']>;
  mostra?: InputMaybe<Scalars['Boolean']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  partecipanti?: InputMaybe<Scalars['Int']['input']>;
  potenza?: InputMaybe<Scalars['Int']['input']>;
  potenza_dichiarata?: InputMaybe<Scalars['Int']['input']>;
  produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  promotore?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  promotore_id?: InputMaybe<Scalars['uuid']['input']>;
  pubblicata?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regolamento?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  regolamento_id?: InputMaybe<Scalars['uuid']['input']>;
  richiesta_iban?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_iniziativa_sociale?: InputMaybe<Scalars['Boolean']['input']>;
  richieste?: InputMaybe<Scalars['Int']['input']>;
  richieste_pubblicazione?: InputMaybe<Admin_Richiesta_Pubblicazione_Arr_Rel_Insert_Input>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  societa?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  societa_id?: InputMaybe<Scalars['uuid']['input']>;
  soggetto_referente_gse?: InputMaybe<Scalars['String']['input']>;
  stato_cer?: InputMaybe<Energy_Village__Stato_Cer_Enum>;
  statuto?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  statuto_id?: InputMaybe<Scalars['uuid']['input']>;
  tecnici?: InputMaybe<Cer_Tecnico_Arr_Rel_Insert_Input>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Obj_Rel_Insert_Input>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  volantino?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  volantino_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label?: InputMaybe<Scalars['Boolean']['input']>;
  white_label_logo_chiaro?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  white_label_logo_chiaro_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label_logo_scuro?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  white_label_logo_scuro_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label_terms?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  white_label_terms_id?: InputMaybe<Scalars['uuid']['input']>;
  whitelabel?: InputMaybe<White_Label_Associazione_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Cer_Max_Fields = {
  __typename?: 'cer_max_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Int']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['numeric']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Int']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  alias_mail?: Maybe<Scalars['String']['output']>;
  attive?: Maybe<Scalars['Int']['output']>;
  codice_gse?: Maybe<Scalars['String']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Int']['output']>;
  consumo?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_costituzione?: Maybe<Scalars['timestamptz']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impianti?: Maybe<Scalars['Int']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  iniziative?: Maybe<Scalars['Int']['output']>;
  logo_id?: Maybe<Scalars['uuid']['output']>;
  notifiche?: Maybe<Scalars['Int']['output']>;
  partecipanti?: Maybe<Scalars['Int']['output']>;
  potenza?: Maybe<Scalars['Int']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Int']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Int']['output']>;
  promotore_id?: Maybe<Scalars['uuid']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  regolamento_id?: Maybe<Scalars['uuid']['output']>;
  richieste?: Maybe<Scalars['Int']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  societa_id?: Maybe<Scalars['uuid']['output']>;
  soggetto_referente_gse?: Maybe<Scalars['String']['output']>;
  statuto_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  volantino_id?: Maybe<Scalars['uuid']['output']>;
  white_label_logo_chiaro_id?: Maybe<Scalars['uuid']['output']>;
  white_label_logo_scuro_id?: Maybe<Scalars['uuid']['output']>;
  white_label_terms_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "cer" */
export type Cer_Max_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  alias?: InputMaybe<Order_By>;
  alias_mail?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  codice_gse?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_costituzione?: InputMaybe<Order_By>;
  descrizione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  logo_id?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  promotore_id?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  regolamento_id?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  societa_id?: InputMaybe<Order_By>;
  soggetto_referente_gse?: InputMaybe<Order_By>;
  statuto_id?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  volantino_id?: InputMaybe<Order_By>;
  white_label_logo_chiaro_id?: InputMaybe<Order_By>;
  white_label_logo_scuro_id?: InputMaybe<Order_By>;
  white_label_terms_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Min_Fields = {
  __typename?: 'cer_min_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Int']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['numeric']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Int']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  alias_mail?: Maybe<Scalars['String']['output']>;
  attive?: Maybe<Scalars['Int']['output']>;
  codice_gse?: Maybe<Scalars['String']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Int']['output']>;
  consumo?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_costituzione?: Maybe<Scalars['timestamptz']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  impianti?: Maybe<Scalars['Int']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  iniziative?: Maybe<Scalars['Int']['output']>;
  logo_id?: Maybe<Scalars['uuid']['output']>;
  notifiche?: Maybe<Scalars['Int']['output']>;
  partecipanti?: Maybe<Scalars['Int']['output']>;
  potenza?: Maybe<Scalars['Int']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Int']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Int']['output']>;
  promotore_id?: Maybe<Scalars['uuid']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  regolamento_id?: Maybe<Scalars['uuid']['output']>;
  richieste?: Maybe<Scalars['Int']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  societa_id?: Maybe<Scalars['uuid']['output']>;
  soggetto_referente_gse?: Maybe<Scalars['String']['output']>;
  statuto_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  volantino_id?: Maybe<Scalars['uuid']['output']>;
  white_label_logo_chiaro_id?: Maybe<Scalars['uuid']['output']>;
  white_label_logo_scuro_id?: Maybe<Scalars['uuid']['output']>;
  white_label_terms_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "cer" */
export type Cer_Min_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  alias?: InputMaybe<Order_By>;
  alias_mail?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  codice_gse?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_costituzione?: InputMaybe<Order_By>;
  descrizione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  logo_id?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  promotore_id?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  regolamento_id?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  societa_id?: InputMaybe<Order_By>;
  soggetto_referente_gse?: InputMaybe<Order_By>;
  statuto_id?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  volantino_id?: InputMaybe<Order_By>;
  white_label_logo_chiaro_id?: InputMaybe<Order_By>;
  white_label_logo_scuro_id?: InputMaybe<Order_By>;
  white_label_terms_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer" */
export type Cer_Mutation_Response = {
  __typename?: 'cer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer>;
};

/** input type for inserting object relation for remote table "cer" */
export type Cer_Obj_Rel_Insert_Input = {
  data: Cer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_On_Conflict>;
};

/** on_conflict condition type for table "cer" */
export type Cer_On_Conflict = {
  constraint: Cer_Constraint;
  update_columns?: Array<Cer_Update_Column>;
  where?: InputMaybe<Cer_Bool_Exp>;
};

/** Ordering options when selecting data from "cer". */
export type Cer_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  abilita_richieste?: InputMaybe<Order_By>;
  alias?: InputMaybe<Order_By>;
  alias_mail?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  categorie_adesione_aggregate?: InputMaybe<Cer_Categoria_Adesione_Aggregate_Order_By>;
  cer_cabina_aggregate?: InputMaybe<Cer_Cabina_Aggregate_Order_By>;
  cer_padre?: InputMaybe<Cer_Order_By>;
  codice_gse?: InputMaybe<Order_By>;
  configurazioni_aggregate?: InputMaybe<Cer_Aggregate_Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  contatti_aggregate?: InputMaybe<Cer_Contatti_Aggregate_Order_By>;
  costi?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_costituzione?: InputMaybe<Order_By>;
  delete_categorie?: InputMaybe<Order_By>;
  descrizione?: InputMaybe<Order_By>;
  destinazioni_contributi_aggregate?: InputMaybe<Cer_Destinazione_Contributo_Aggregate_Order_By>;
  destinazioni_contributi_collegate_aggregate?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Aggregate_Order_By>;
  documenti_richiesti?: InputMaybe<Order_By>;
  domande_richieste?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Order_By>;
  geom?: InputMaybe<Cer_Geom_Order_By>;
  gestori_aggregate?: InputMaybe<Cer_Gestore_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  indirizzo?: InputMaybe<Indirizzo_Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  logo?: InputMaybe<Files_Order_By>;
  logo_id?: InputMaybe<Order_By>;
  modulo_richiesta?: InputMaybe<Order_By>;
  mostra?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  promotore?: InputMaybe<Persona_Order_By>;
  promotore_id?: InputMaybe<Order_By>;
  pubblicata?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  regolamento?: InputMaybe<Files_Order_By>;
  regolamento_id?: InputMaybe<Order_By>;
  richiesta_iban?: InputMaybe<Order_By>;
  richiesta_iniziativa_sociale?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
  richieste_pubblicazione_aggregate?: InputMaybe<Admin_Richiesta_Pubblicazione_Aggregate_Order_By>;
  root_id?: InputMaybe<Order_By>;
  societa?: InputMaybe<Persona_Order_By>;
  societa_id?: InputMaybe<Order_By>;
  soggetto_referente_gse?: InputMaybe<Order_By>;
  stato_cer?: InputMaybe<Order_By>;
  statuto?: InputMaybe<Files_Order_By>;
  statuto_id?: InputMaybe<Order_By>;
  tecnici_aggregate?: InputMaybe<Cer_Tecnico_Aggregate_Order_By>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  volantino?: InputMaybe<Files_Order_By>;
  volantino_id?: InputMaybe<Order_By>;
  white_label?: InputMaybe<Order_By>;
  white_label_logo_chiaro?: InputMaybe<Files_Order_By>;
  white_label_logo_chiaro_id?: InputMaybe<Order_By>;
  white_label_logo_scuro?: InputMaybe<Files_Order_By>;
  white_label_logo_scuro_id?: InputMaybe<Order_By>;
  white_label_terms?: InputMaybe<Files_Order_By>;
  white_label_terms_id?: InputMaybe<Order_By>;
  whitelabel_aggregate?: InputMaybe<White_Label_Associazione_Aggregate_Order_By>;
};

/** primary key columns input for table: cer */
export type Cer_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cer_Prepend_Input = {
  costi?: InputMaybe<Scalars['jsonb']['input']>;
  documenti_richiesti?: InputMaybe<Scalars['jsonb']['input']>;
  domande_richieste?: InputMaybe<Scalars['jsonb']['input']>;
  email_template?: InputMaybe<Scalars['jsonb']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "cer_search_index" */
export type Cer_Search_Index = {
  __typename?: 'cer_search_index';
  abilita_richieste?: Maybe<Scalars['Boolean']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  cer_id: Scalars['uuid']['output'];
  richieste?: Maybe<Scalars['Int']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  search_blob?: Maybe<Scalars['String']['output']>;
  stato_cer?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "cer_search_index" */
export type Cer_Search_Index_Aggregate = {
  __typename?: 'cer_search_index_aggregate';
  aggregate?: Maybe<Cer_Search_Index_Aggregate_Fields>;
  nodes: Array<Cer_Search_Index>;
};

/** aggregate fields of "cer_search_index" */
export type Cer_Search_Index_Aggregate_Fields = {
  __typename?: 'cer_search_index_aggregate_fields';
  avg?: Maybe<Cer_Search_Index_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Search_Index_Max_Fields>;
  min?: Maybe<Cer_Search_Index_Min_Fields>;
  stddev?: Maybe<Cer_Search_Index_Stddev_Fields>;
  stddev_pop?: Maybe<Cer_Search_Index_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cer_Search_Index_Stddev_Samp_Fields>;
  sum?: Maybe<Cer_Search_Index_Sum_Fields>;
  var_pop?: Maybe<Cer_Search_Index_Var_Pop_Fields>;
  var_samp?: Maybe<Cer_Search_Index_Var_Samp_Fields>;
  variance?: Maybe<Cer_Search_Index_Variance_Fields>;
};


/** aggregate fields of "cer_search_index" */
export type Cer_Search_Index_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Search_Index_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Cer_Search_Index_Avg_Fields = {
  __typename?: 'cer_search_index_avg_fields';
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cer_search_index". All fields are combined with a logical 'AND'. */
export type Cer_Search_Index_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Search_Index_Bool_Exp>>;
  _not?: InputMaybe<Cer_Search_Index_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Search_Index_Bool_Exp>>;
  abilita_richieste?: InputMaybe<Boolean_Comparison_Exp>;
  alias?: InputMaybe<String_Comparison_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  richieste?: InputMaybe<Int_Comparison_Exp>;
  root_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_blob?: InputMaybe<String_Comparison_Exp>;
  stato_cer?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_search_index" */
export enum Cer_Search_Index_Constraint {
  /** unique or primary key constraint on columns "cer_id" */
  CerSearchIndexPkey = 'cer_search_index_pkey'
}

/** input type for incrementing numeric columns in table "cer_search_index" */
export type Cer_Search_Index_Inc_Input = {
  richieste?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cer_search_index" */
export type Cer_Search_Index_Insert_Input = {
  abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  richieste?: InputMaybe<Scalars['Int']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  search_blob?: InputMaybe<Scalars['String']['input']>;
  stato_cer?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Search_Index_Max_Fields = {
  __typename?: 'cer_search_index_max_fields';
  alias?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  richieste?: Maybe<Scalars['Int']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  search_blob?: Maybe<Scalars['String']['output']>;
  stato_cer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Cer_Search_Index_Min_Fields = {
  __typename?: 'cer_search_index_min_fields';
  alias?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  richieste?: Maybe<Scalars['Int']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  search_blob?: Maybe<Scalars['String']['output']>;
  stato_cer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "cer_search_index" */
export type Cer_Search_Index_Mutation_Response = {
  __typename?: 'cer_search_index_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Search_Index>;
};

/** on_conflict condition type for table "cer_search_index" */
export type Cer_Search_Index_On_Conflict = {
  constraint: Cer_Search_Index_Constraint;
  update_columns?: Array<Cer_Search_Index_Update_Column>;
  where?: InputMaybe<Cer_Search_Index_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_search_index". */
export type Cer_Search_Index_Order_By = {
  abilita_richieste?: InputMaybe<Order_By>;
  alias?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  search_blob?: InputMaybe<Order_By>;
  stato_cer?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_search_index */
export type Cer_Search_Index_Pk_Columns_Input = {
  cer_id: Scalars['uuid']['input'];
};

/** select columns of table "cer_search_index" */
export enum Cer_Search_Index_Select_Column {
  /** column name */
  AbilitaRichieste = 'abilita_richieste',
  /** column name */
  Alias = 'alias',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  Richieste = 'richieste',
  /** column name */
  RootId = 'root_id',
  /** column name */
  SearchBlob = 'search_blob',
  /** column name */
  StatoCer = 'stato_cer',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cer_search_index" */
export type Cer_Search_Index_Set_Input = {
  abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  richieste?: InputMaybe<Scalars['Int']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  search_blob?: InputMaybe<Scalars['String']['input']>;
  stato_cer?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Cer_Search_Index_Stddev_Fields = {
  __typename?: 'cer_search_index_stddev_fields';
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Cer_Search_Index_Stddev_Pop_Fields = {
  __typename?: 'cer_search_index_stddev_pop_fields';
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Cer_Search_Index_Stddev_Samp_Fields = {
  __typename?: 'cer_search_index_stddev_samp_fields';
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "cer_search_index" */
export type Cer_Search_Index_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Search_Index_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Search_Index_Stream_Cursor_Value_Input = {
  abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  richieste?: InputMaybe<Scalars['Int']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  search_blob?: InputMaybe<Scalars['String']['input']>;
  stato_cer?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Cer_Search_Index_Sum_Fields = {
  __typename?: 'cer_search_index_sum_fields';
  richieste?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "cer_search_index" */
export enum Cer_Search_Index_Update_Column {
  /** column name */
  AbilitaRichieste = 'abilita_richieste',
  /** column name */
  Alias = 'alias',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  Richieste = 'richieste',
  /** column name */
  RootId = 'root_id',
  /** column name */
  SearchBlob = 'search_blob',
  /** column name */
  StatoCer = 'stato_cer',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Search_Index_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cer_Search_Index_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Search_Index_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Search_Index_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cer_Search_Index_Var_Pop_Fields = {
  __typename?: 'cer_search_index_var_pop_fields';
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Cer_Search_Index_Var_Samp_Fields = {
  __typename?: 'cer_search_index_var_samp_fields';
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Cer_Search_Index_Variance_Fields = {
  __typename?: 'cer_search_index_variance_fields';
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "cer" */
export enum Cer_Select_Column {
  /** column name */
  _ConsumatoriDichiarati = '_consumatori_dichiarati',
  /** column name */
  _PotenzaDichiarata = '_potenza_dichiarata',
  /** column name */
  _ProduttoriDichiarati = '_produttori_dichiarati',
  /** column name */
  AbilitaRichieste = 'abilita_richieste',
  /** column name */
  Alias = 'alias',
  /** column name */
  AliasMail = 'alias_mail',
  /** column name */
  Attive = 'attive',
  /** column name */
  CodiceGse = 'codice_gse',
  /** column name */
  ConsumatoriDichiarati = 'consumatori_dichiarati',
  /** column name */
  Consumo = 'consumo',
  /** column name */
  Costi = 'costi',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataCostituzione = 'data_costituzione',
  /** column name */
  DeleteCategorie = 'delete_categorie',
  /** column name */
  Descrizione = 'descrizione',
  /** column name */
  DocumentiRichiesti = 'documenti_richiesti',
  /** column name */
  DomandeRichieste = 'domande_richieste',
  /** column name */
  EmailTemplate = 'email_template',
  /** column name */
  Id = 'id',
  /** column name */
  Impianti = 'impianti',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  Iniziative = 'iniziative',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  ModuloRichiesta = 'modulo_richiesta',
  /** column name */
  Mostra = 'mostra',
  /** column name */
  Notifiche = 'notifiche',
  /** column name */
  Partecipanti = 'partecipanti',
  /** column name */
  Potenza = 'potenza',
  /** column name */
  PotenzaDichiarata = 'potenza_dichiarata',
  /** column name */
  ProduttoriDichiarati = 'produttori_dichiarati',
  /** column name */
  PromotoreId = 'promotore_id',
  /** column name */
  Pubblicata = 'pubblicata',
  /** column name */
  Referral = 'referral',
  /** column name */
  RegolamentoId = 'regolamento_id',
  /** column name */
  RichiestaIban = 'richiesta_iban',
  /** column name */
  RichiestaIniziativaSociale = 'richiesta_iniziativa_sociale',
  /** column name */
  Richieste = 'richieste',
  /** column name */
  RootId = 'root_id',
  /** column name */
  SocietaId = 'societa_id',
  /** column name */
  SoggettoReferenteGse = 'soggetto_referente_gse',
  /** column name */
  StatoCer = 'stato_cer',
  /** column name */
  StatutoId = 'statuto_id',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolantinoId = 'volantino_id',
  /** column name */
  WhiteLabel = 'white_label',
  /** column name */
  WhiteLabelLogoChiaroId = 'white_label_logo_chiaro_id',
  /** column name */
  WhiteLabelLogoScuroId = 'white_label_logo_scuro_id',
  /** column name */
  WhiteLabelTermsId = 'white_label_terms_id'
}

/** select "cer_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cer" */
export enum Cer_Select_Column_Cer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AbilitaRichieste = 'abilita_richieste',
  /** column name */
  DeleteCategorie = 'delete_categorie',
  /** column name */
  Mostra = 'mostra',
  /** column name */
  Pubblicata = 'pubblicata',
  /** column name */
  RichiestaIban = 'richiesta_iban',
  /** column name */
  RichiestaIniziativaSociale = 'richiesta_iniziativa_sociale',
  /** column name */
  WhiteLabel = 'white_label'
}

/** select "cer_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cer" */
export enum Cer_Select_Column_Cer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AbilitaRichieste = 'abilita_richieste',
  /** column name */
  DeleteCategorie = 'delete_categorie',
  /** column name */
  Mostra = 'mostra',
  /** column name */
  Pubblicata = 'pubblicata',
  /** column name */
  RichiestaIban = 'richiesta_iban',
  /** column name */
  RichiestaIniziativaSociale = 'richiesta_iniziativa_sociale',
  /** column name */
  WhiteLabel = 'white_label'
}

/** input type for updating data in table "cer" */
export type Cer_Set_Input = {
  _consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  _potenza_dichiarata?: InputMaybe<Scalars['numeric']['input']>;
  _produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  alias_mail?: InputMaybe<Scalars['String']['input']>;
  attive?: InputMaybe<Scalars['Int']['input']>;
  codice_gse?: InputMaybe<Scalars['String']['input']>;
  consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  consumo?: InputMaybe<Scalars['Int']['input']>;
  costi?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_costituzione?: InputMaybe<Scalars['timestamptz']['input']>;
  delete_categorie?: InputMaybe<Scalars['Boolean']['input']>;
  descrizione?: InputMaybe<Scalars['String']['input']>;
  documenti_richiesti?: InputMaybe<Scalars['jsonb']['input']>;
  domande_richieste?: InputMaybe<Scalars['jsonb']['input']>;
  email_template?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impianti?: InputMaybe<Scalars['Int']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  iniziative?: InputMaybe<Scalars['Int']['input']>;
  logo_id?: InputMaybe<Scalars['uuid']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['jsonb']['input']>;
  mostra?: InputMaybe<Scalars['Boolean']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  partecipanti?: InputMaybe<Scalars['Int']['input']>;
  potenza?: InputMaybe<Scalars['Int']['input']>;
  potenza_dichiarata?: InputMaybe<Scalars['Int']['input']>;
  produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  promotore_id?: InputMaybe<Scalars['uuid']['input']>;
  pubblicata?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regolamento_id?: InputMaybe<Scalars['uuid']['input']>;
  richiesta_iban?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_iniziativa_sociale?: InputMaybe<Scalars['Boolean']['input']>;
  richieste?: InputMaybe<Scalars['Int']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  societa_id?: InputMaybe<Scalars['uuid']['input']>;
  soggetto_referente_gse?: InputMaybe<Scalars['String']['input']>;
  stato_cer?: InputMaybe<Energy_Village__Stato_Cer_Enum>;
  statuto_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  volantino_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label?: InputMaybe<Scalars['Boolean']['input']>;
  white_label_logo_chiaro_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label_logo_scuro_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label_terms_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Cer_Stddev_Fields = {
  __typename?: 'cer_stddev_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  attive?: Maybe<Scalars['Float']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  impianti?: Maybe<Scalars['Float']['output']>;
  iniziative?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  partecipanti?: Maybe<Scalars['Float']['output']>;
  potenza?: Maybe<Scalars['Float']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cer" */
export type Cer_Stddev_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cer_Stddev_Pop_Fields = {
  __typename?: 'cer_stddev_pop_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  attive?: Maybe<Scalars['Float']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  impianti?: Maybe<Scalars['Float']['output']>;
  iniziative?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  partecipanti?: Maybe<Scalars['Float']['output']>;
  potenza?: Maybe<Scalars['Float']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cer" */
export type Cer_Stddev_Pop_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cer_Stddev_Samp_Fields = {
  __typename?: 'cer_stddev_samp_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  attive?: Maybe<Scalars['Float']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  impianti?: Maybe<Scalars['Float']['output']>;
  iniziative?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  partecipanti?: Maybe<Scalars['Float']['output']>;
  potenza?: Maybe<Scalars['Float']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cer" */
export type Cer_Stddev_Samp_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cer" */
export type Cer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Stream_Cursor_Value_Input = {
  _consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  _potenza_dichiarata?: InputMaybe<Scalars['numeric']['input']>;
  _produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  alias_mail?: InputMaybe<Scalars['String']['input']>;
  attive?: InputMaybe<Scalars['Int']['input']>;
  codice_gse?: InputMaybe<Scalars['String']['input']>;
  consumatori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  consumo?: InputMaybe<Scalars['Int']['input']>;
  costi?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_costituzione?: InputMaybe<Scalars['timestamptz']['input']>;
  delete_categorie?: InputMaybe<Scalars['Boolean']['input']>;
  descrizione?: InputMaybe<Scalars['String']['input']>;
  documenti_richiesti?: InputMaybe<Scalars['jsonb']['input']>;
  domande_richieste?: InputMaybe<Scalars['jsonb']['input']>;
  email_template?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impianti?: InputMaybe<Scalars['Int']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  iniziative?: InputMaybe<Scalars['Int']['input']>;
  logo_id?: InputMaybe<Scalars['uuid']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['jsonb']['input']>;
  mostra?: InputMaybe<Scalars['Boolean']['input']>;
  notifiche?: InputMaybe<Scalars['Int']['input']>;
  partecipanti?: InputMaybe<Scalars['Int']['input']>;
  potenza?: InputMaybe<Scalars['Int']['input']>;
  potenza_dichiarata?: InputMaybe<Scalars['Int']['input']>;
  produttori_dichiarati?: InputMaybe<Scalars['Int']['input']>;
  promotore_id?: InputMaybe<Scalars['uuid']['input']>;
  pubblicata?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regolamento_id?: InputMaybe<Scalars['uuid']['input']>;
  richiesta_iban?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_iniziativa_sociale?: InputMaybe<Scalars['Boolean']['input']>;
  richieste?: InputMaybe<Scalars['Int']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  societa_id?: InputMaybe<Scalars['uuid']['input']>;
  soggetto_referente_gse?: InputMaybe<Scalars['String']['input']>;
  stato_cer?: InputMaybe<Energy_Village__Stato_Cer_Enum>;
  statuto_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  volantino_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label?: InputMaybe<Scalars['Boolean']['input']>;
  white_label_logo_chiaro_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label_logo_scuro_id?: InputMaybe<Scalars['uuid']['input']>;
  white_label_terms_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Cer_Sum_Fields = {
  __typename?: 'cer_sum_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Int']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['numeric']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Int']['output']>;
  attive?: Maybe<Scalars['Int']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Int']['output']>;
  consumo?: Maybe<Scalars['Int']['output']>;
  impianti?: Maybe<Scalars['Int']['output']>;
  iniziative?: Maybe<Scalars['Int']['output']>;
  notifiche?: Maybe<Scalars['Int']['output']>;
  partecipanti?: Maybe<Scalars['Int']['output']>;
  potenza?: Maybe<Scalars['Int']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Int']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Int']['output']>;
  richieste?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cer" */
export type Cer_Sum_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

/** columns and relationships of "cer_tecnico" */
export type Cer_Tecnico = {
  __typename?: 'cer_tecnico';
  cer_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  tecnico_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "cer_tecnico" */
export type Cer_Tecnico_Aggregate = {
  __typename?: 'cer_tecnico_aggregate';
  aggregate?: Maybe<Cer_Tecnico_Aggregate_Fields>;
  nodes: Array<Cer_Tecnico>;
};

export type Cer_Tecnico_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cer_Tecnico_Aggregate_Bool_Exp_Count>;
};

export type Cer_Tecnico_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cer_Tecnico_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cer_tecnico" */
export type Cer_Tecnico_Aggregate_Fields = {
  __typename?: 'cer_tecnico_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cer_Tecnico_Max_Fields>;
  min?: Maybe<Cer_Tecnico_Min_Fields>;
};


/** aggregate fields of "cer_tecnico" */
export type Cer_Tecnico_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cer_tecnico" */
export type Cer_Tecnico_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cer_Tecnico_Max_Order_By>;
  min?: InputMaybe<Cer_Tecnico_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cer_tecnico" */
export type Cer_Tecnico_Arr_Rel_Insert_Input = {
  data: Array<Cer_Tecnico_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cer_Tecnico_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cer_tecnico". All fields are combined with a logical 'AND'. */
export type Cer_Tecnico_Bool_Exp = {
  _and?: InputMaybe<Array<Cer_Tecnico_Bool_Exp>>;
  _not?: InputMaybe<Cer_Tecnico_Bool_Exp>;
  _or?: InputMaybe<Array<Cer_Tecnico_Bool_Exp>>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  tecnico_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cer_tecnico" */
export enum Cer_Tecnico_Constraint {
  /** unique or primary key constraint on columns "id" */
  CerTecnicoPkey = 'cer_tecnico_pkey'
}

/** input type for inserting data into table "cer_tecnico" */
export type Cer_Tecnico_Insert_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tecnico_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Cer_Tecnico_Max_Fields = {
  __typename?: 'cer_tecnico_max_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tecnico_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cer_tecnico" */
export type Cer_Tecnico_Max_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tecnico_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cer_Tecnico_Min_Fields = {
  __typename?: 'cer_tecnico_min_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tecnico_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cer_tecnico" */
export type Cer_Tecnico_Min_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tecnico_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cer_tecnico" */
export type Cer_Tecnico_Mutation_Response = {
  __typename?: 'cer_tecnico_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cer_Tecnico>;
};

/** on_conflict condition type for table "cer_tecnico" */
export type Cer_Tecnico_On_Conflict = {
  constraint: Cer_Tecnico_Constraint;
  update_columns?: Array<Cer_Tecnico_Update_Column>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};

/** Ordering options when selecting data from "cer_tecnico". */
export type Cer_Tecnico_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tecnico_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cer_tecnico */
export type Cer_Tecnico_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cer_tecnico" */
export enum Cer_Tecnico_Select_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TecnicoId = 'tecnico_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cer_tecnico" */
export type Cer_Tecnico_Set_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tecnico_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "cer_tecnico" */
export type Cer_Tecnico_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cer_Tecnico_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cer_Tecnico_Stream_Cursor_Value_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tecnico_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "cer_tecnico" */
export enum Cer_Tecnico_Update_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TecnicoId = 'tecnico_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cer_Tecnico_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Tecnico_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Tecnico_Bool_Exp;
};

/** update columns of table "cer" */
export enum Cer_Update_Column {
  /** column name */
  _ConsumatoriDichiarati = '_consumatori_dichiarati',
  /** column name */
  _PotenzaDichiarata = '_potenza_dichiarata',
  /** column name */
  _ProduttoriDichiarati = '_produttori_dichiarati',
  /** column name */
  AbilitaRichieste = 'abilita_richieste',
  /** column name */
  Alias = 'alias',
  /** column name */
  AliasMail = 'alias_mail',
  /** column name */
  Attive = 'attive',
  /** column name */
  CodiceGse = 'codice_gse',
  /** column name */
  ConsumatoriDichiarati = 'consumatori_dichiarati',
  /** column name */
  Consumo = 'consumo',
  /** column name */
  Costi = 'costi',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataCostituzione = 'data_costituzione',
  /** column name */
  DeleteCategorie = 'delete_categorie',
  /** column name */
  Descrizione = 'descrizione',
  /** column name */
  DocumentiRichiesti = 'documenti_richiesti',
  /** column name */
  DomandeRichieste = 'domande_richieste',
  /** column name */
  EmailTemplate = 'email_template',
  /** column name */
  Id = 'id',
  /** column name */
  Impianti = 'impianti',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  Iniziative = 'iniziative',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  ModuloRichiesta = 'modulo_richiesta',
  /** column name */
  Mostra = 'mostra',
  /** column name */
  Notifiche = 'notifiche',
  /** column name */
  Partecipanti = 'partecipanti',
  /** column name */
  Potenza = 'potenza',
  /** column name */
  PotenzaDichiarata = 'potenza_dichiarata',
  /** column name */
  ProduttoriDichiarati = 'produttori_dichiarati',
  /** column name */
  PromotoreId = 'promotore_id',
  /** column name */
  Pubblicata = 'pubblicata',
  /** column name */
  Referral = 'referral',
  /** column name */
  RegolamentoId = 'regolamento_id',
  /** column name */
  RichiestaIban = 'richiesta_iban',
  /** column name */
  RichiestaIniziativaSociale = 'richiesta_iniziativa_sociale',
  /** column name */
  Richieste = 'richieste',
  /** column name */
  RootId = 'root_id',
  /** column name */
  SocietaId = 'societa_id',
  /** column name */
  SoggettoReferenteGse = 'soggetto_referente_gse',
  /** column name */
  StatoCer = 'stato_cer',
  /** column name */
  StatutoId = 'statuto_id',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolantinoId = 'volantino_id',
  /** column name */
  WhiteLabel = 'white_label',
  /** column name */
  WhiteLabelLogoChiaroId = 'white_label_logo_chiaro_id',
  /** column name */
  WhiteLabelLogoScuroId = 'white_label_logo_scuro_id',
  /** column name */
  WhiteLabelTermsId = 'white_label_terms_id'
}

export type Cer_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cer_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cer_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cer_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cer_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cer_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cer_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cer_Var_Pop_Fields = {
  __typename?: 'cer_var_pop_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  attive?: Maybe<Scalars['Float']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  impianti?: Maybe<Scalars['Float']['output']>;
  iniziative?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  partecipanti?: Maybe<Scalars['Float']['output']>;
  potenza?: Maybe<Scalars['Float']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cer" */
export type Cer_Var_Pop_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cer_Var_Samp_Fields = {
  __typename?: 'cer_var_samp_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  attive?: Maybe<Scalars['Float']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  impianti?: Maybe<Scalars['Float']['output']>;
  iniziative?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  partecipanti?: Maybe<Scalars['Float']['output']>;
  potenza?: Maybe<Scalars['Float']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cer" */
export type Cer_Var_Samp_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cer_Variance_Fields = {
  __typename?: 'cer_variance_fields';
  _consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  _potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  _produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  attive?: Maybe<Scalars['Float']['output']>;
  consumatori_dichiarati?: Maybe<Scalars['Float']['output']>;
  consumo?: Maybe<Scalars['Float']['output']>;
  impianti?: Maybe<Scalars['Float']['output']>;
  iniziative?: Maybe<Scalars['Float']['output']>;
  notifiche?: Maybe<Scalars['Float']['output']>;
  partecipanti?: Maybe<Scalars['Float']['output']>;
  potenza?: Maybe<Scalars['Float']['output']>;
  potenza_dichiarata?: Maybe<Scalars['Float']['output']>;
  produttori_dichiarati?: Maybe<Scalars['Float']['output']>;
  richieste?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cer" */
export type Cer_Variance_Order_By = {
  _consumatori_dichiarati?: InputMaybe<Order_By>;
  _potenza_dichiarata?: InputMaybe<Order_By>;
  _produttori_dichiarati?: InputMaybe<Order_By>;
  attive?: InputMaybe<Order_By>;
  consumatori_dichiarati?: InputMaybe<Order_By>;
  consumo?: InputMaybe<Order_By>;
  impianti?: InputMaybe<Order_By>;
  iniziative?: InputMaybe<Order_By>;
  notifiche?: InputMaybe<Order_By>;
  partecipanti?: InputMaybe<Order_By>;
  potenza?: InputMaybe<Order_By>;
  potenza_dichiarata?: InputMaybe<Order_By>;
  produttori_dichiarati?: InputMaybe<Order_By>;
  richieste?: InputMaybe<Order_By>;
};

export type Check_Pod_Duplicato_Args = {
  p_exclude_id?: InputMaybe<Scalars['uuid']['input']>;
  p_exclude_staging_id?: InputMaybe<Scalars['uuid']['input']>;
  p_include_staging?: InputMaybe<Scalars['Boolean']['input']>;
  p_pods?: InputMaybe<Scalars['_text']['input']>;
  p_tipologia?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "codice_operatore" */
export type Codice_Operatore = {
  __typename?: 'codice_operatore';
  auth_id: Scalars['String']['output'];
  codice: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  user_entity: Auth_User_Entity;
};

/** aggregated selection of "codice_operatore" */
export type Codice_Operatore_Aggregate = {
  __typename?: 'codice_operatore_aggregate';
  aggregate?: Maybe<Codice_Operatore_Aggregate_Fields>;
  nodes: Array<Codice_Operatore>;
};

/** aggregate fields of "codice_operatore" */
export type Codice_Operatore_Aggregate_Fields = {
  __typename?: 'codice_operatore_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Codice_Operatore_Max_Fields>;
  min?: Maybe<Codice_Operatore_Min_Fields>;
};


/** aggregate fields of "codice_operatore" */
export type Codice_Operatore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Codice_Operatore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "codice_operatore". All fields are combined with a logical 'AND'. */
export type Codice_Operatore_Bool_Exp = {
  _and?: InputMaybe<Array<Codice_Operatore_Bool_Exp>>;
  _not?: InputMaybe<Codice_Operatore_Bool_Exp>;
  _or?: InputMaybe<Array<Codice_Operatore_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  codice?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_entity?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};

/** unique or primary key constraints on table "codice_operatore" */
export enum Codice_Operatore_Constraint {
  /** unique or primary key constraint on columns "codice" */
  CodiceOperatoreCodiceKey = 'codice_operatore_codice_key',
  /** unique or primary key constraint on columns "id" */
  CodiceOperatorePkey = 'codice_operatore_pkey'
}

/** input type for inserting data into table "codice_operatore" */
export type Codice_Operatore_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  codice?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_entity?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Codice_Operatore_Max_Fields = {
  __typename?: 'codice_operatore_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  codice?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Codice_Operatore_Min_Fields = {
  __typename?: 'codice_operatore_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  codice?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "codice_operatore" */
export type Codice_Operatore_Mutation_Response = {
  __typename?: 'codice_operatore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Codice_Operatore>;
};

/** input type for inserting object relation for remote table "codice_operatore" */
export type Codice_Operatore_Obj_Rel_Insert_Input = {
  data: Codice_Operatore_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Codice_Operatore_On_Conflict>;
};

/** on_conflict condition type for table "codice_operatore" */
export type Codice_Operatore_On_Conflict = {
  constraint: Codice_Operatore_Constraint;
  update_columns?: Array<Codice_Operatore_Update_Column>;
  where?: InputMaybe<Codice_Operatore_Bool_Exp>;
};

/** Ordering options when selecting data from "codice_operatore". */
export type Codice_Operatore_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  codice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_entity?: InputMaybe<Auth_User_Entity_Order_By>;
};

/** primary key columns input for table: codice_operatore */
export type Codice_Operatore_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "codice_operatore" */
export enum Codice_Operatore_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  Codice = 'codice',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "codice_operatore" */
export type Codice_Operatore_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  codice?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "codice_operatore" */
export type Codice_Operatore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Codice_Operatore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Codice_Operatore_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  codice?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "codice_operatore" */
export enum Codice_Operatore_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  Codice = 'codice',
  /** column name */
  Id = 'id'
}

export type Codice_Operatore_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Codice_Operatore_Set_Input>;
  /** filter the rows which have to be updated */
  where: Codice_Operatore_Bool_Exp;
};

/** columns and relationships of "comunicazioni.email" */
export type Comunicazioni_Email = {
  __typename?: 'comunicazioni_email';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  destinatario: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  /** An array relationship */
  mittente_cer_gestori: Array<Cer_Gestore>;
  /** An aggregate relationship */
  mittente_cer_gestori_aggregate: Cer_Gestore_Aggregate;
  oggetto: Scalars['String']['output'];
  /** An object relationship */
  sottoscrizione?: Maybe<Sottoscrizione>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "comunicazioni.email" */
export type Comunicazioni_EmailMittente_Cer_GestoriArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


/** columns and relationships of "comunicazioni.email" */
export type Comunicazioni_EmailMittente_Cer_Gestori_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};

/** aggregated selection of "comunicazioni.email" */
export type Comunicazioni_Email_Aggregate = {
  __typename?: 'comunicazioni_email_aggregate';
  aggregate?: Maybe<Comunicazioni_Email_Aggregate_Fields>;
  nodes: Array<Comunicazioni_Email>;
};

/** aggregate fields of "comunicazioni.email" */
export type Comunicazioni_Email_Aggregate_Fields = {
  __typename?: 'comunicazioni_email_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Comunicazioni_Email_Max_Fields>;
  min?: Maybe<Comunicazioni_Email_Min_Fields>;
};


/** aggregate fields of "comunicazioni.email" */
export type Comunicazioni_Email_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comunicazioni_Email_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "comunicazioni.email". All fields are combined with a logical 'AND'. */
export type Comunicazioni_Email_Bool_Exp = {
  _and?: InputMaybe<Array<Comunicazioni_Email_Bool_Exp>>;
  _not?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
  _or?: InputMaybe<Array<Comunicazioni_Email_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  destinatario?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  mittente_cer_gestori?: InputMaybe<Cer_Gestore_Bool_Exp>;
  mittente_cer_gestori_aggregate?: InputMaybe<Cer_Gestore_Aggregate_Bool_Exp>;
  oggetto?: InputMaybe<String_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "comunicazioni.email" */
export enum Comunicazioni_Email_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailPkey = 'email_pkey'
}

/** input type for inserting data into table "comunicazioni.email" */
export type Comunicazioni_Email_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  destinatario?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  mittente_cer_gestori?: InputMaybe<Cer_Gestore_Arr_Rel_Insert_Input>;
  oggetto?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Comunicazioni_Email_Max_Fields = {
  __typename?: 'comunicazioni_email_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  destinatario?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  oggetto?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Comunicazioni_Email_Min_Fields = {
  __typename?: 'comunicazioni_email_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  destinatario?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  oggetto?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "comunicazioni.email" */
export type Comunicazioni_Email_Mutation_Response = {
  __typename?: 'comunicazioni_email_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comunicazioni_Email>;
};

/** on_conflict condition type for table "comunicazioni.email" */
export type Comunicazioni_Email_On_Conflict = {
  constraint: Comunicazioni_Email_Constraint;
  update_columns?: Array<Comunicazioni_Email_Update_Column>;
  where?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
};

/** Ordering options when selecting data from "comunicazioni.email". */
export type Comunicazioni_Email_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  destinatario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  mittente_cer_gestori_aggregate?: InputMaybe<Cer_Gestore_Aggregate_Order_By>;
  oggetto?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comunicazioni.email */
export type Comunicazioni_Email_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "comunicazioni.email" */
export enum Comunicazioni_Email_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Destinatario = 'destinatario',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Oggetto = 'oggetto',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "comunicazioni.email" */
export type Comunicazioni_Email_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  destinatario?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oggetto?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "comunicazioni_email" */
export type Comunicazioni_Email_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comunicazioni_Email_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comunicazioni_Email_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  destinatario?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oggetto?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "comunicazioni.email_template" */
export type Comunicazioni_Email_Template = {
  __typename?: 'comunicazioni_email_template';
  auth_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  configurazione?: Maybe<White_Label_Configurazione>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  nome: Scalars['String']['output'];
  oggetto: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "comunicazioni.email_template" */
export type Comunicazioni_Email_Template_Aggregate = {
  __typename?: 'comunicazioni_email_template_aggregate';
  aggregate?: Maybe<Comunicazioni_Email_Template_Aggregate_Fields>;
  nodes: Array<Comunicazioni_Email_Template>;
};

/** aggregate fields of "comunicazioni.email_template" */
export type Comunicazioni_Email_Template_Aggregate_Fields = {
  __typename?: 'comunicazioni_email_template_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Comunicazioni_Email_Template_Max_Fields>;
  min?: Maybe<Comunicazioni_Email_Template_Min_Fields>;
};


/** aggregate fields of "comunicazioni.email_template" */
export type Comunicazioni_Email_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comunicazioni_Email_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "comunicazioni.email_template". All fields are combined with a logical 'AND'. */
export type Comunicazioni_Email_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Comunicazioni_Email_Template_Bool_Exp>>;
  _not?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Comunicazioni_Email_Template_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  configurazione?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
  configurazione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  oggetto?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "comunicazioni.email_template" */
export enum Comunicazioni_Email_Template_Constraint {
  /** unique or primary key constraint on columns "nome", "auth_id" */
  EmailTemplateAuthNomeKey = 'email_template_auth_nome_key',
  /** unique or primary key constraint on columns "nome", "configurazione_id" */
  EmailTemplateConfigurazioneNomeKey = 'email_template_configurazione_nome_key',
  /** unique or primary key constraint on columns "id" */
  EmailTemplatePkey = 'email_template_pkey'
}

/** input type for inserting data into table "comunicazioni.email_template" */
export type Comunicazioni_Email_Template_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  configurazione?: InputMaybe<White_Label_Configurazione_Obj_Rel_Insert_Input>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  oggetto?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Comunicazioni_Email_Template_Max_Fields = {
  __typename?: 'comunicazioni_email_template_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  oggetto?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Comunicazioni_Email_Template_Min_Fields = {
  __typename?: 'comunicazioni_email_template_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  oggetto?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "comunicazioni.email_template" */
export type Comunicazioni_Email_Template_Mutation_Response = {
  __typename?: 'comunicazioni_email_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comunicazioni_Email_Template>;
};

/** on_conflict condition type for table "comunicazioni.email_template" */
export type Comunicazioni_Email_Template_On_Conflict = {
  constraint: Comunicazioni_Email_Template_Constraint;
  update_columns?: Array<Comunicazioni_Email_Template_Update_Column>;
  where?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "comunicazioni.email_template". */
export type Comunicazioni_Email_Template_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  configurazione?: InputMaybe<White_Label_Configurazione_Order_By>;
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  oggetto?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comunicazioni.email_template */
export type Comunicazioni_Email_Template_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "comunicazioni.email_template" */
export enum Comunicazioni_Email_Template_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Nome = 'nome',
  /** column name */
  Oggetto = 'oggetto',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "comunicazioni.email_template" */
export type Comunicazioni_Email_Template_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  oggetto?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "comunicazioni_email_template" */
export type Comunicazioni_Email_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comunicazioni_Email_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comunicazioni_Email_Template_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  oggetto?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "comunicazioni.email_template" */
export enum Comunicazioni_Email_Template_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Nome = 'nome',
  /** column name */
  Oggetto = 'oggetto',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Comunicazioni_Email_Template_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comunicazioni_Email_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comunicazioni_Email_Template_Bool_Exp;
};

/** update columns of table "comunicazioni.email" */
export enum Comunicazioni_Email_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Destinatario = 'destinatario',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Oggetto = 'oggetto',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Comunicazioni_Email_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comunicazioni_Email_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comunicazioni_Email_Bool_Exp;
};

/** columns and relationships of "comunicazioni.sms" */
export type Comunicazioni_Sms = {
  __typename?: 'comunicazioni_sms';
  cellulare: Scalars['String']['output'];
  /** An object relationship */
  cer?: Maybe<Cer>;
  cer_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  stato?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "comunicazioni.sms" */
export type Comunicazioni_Sms_Aggregate = {
  __typename?: 'comunicazioni_sms_aggregate';
  aggregate?: Maybe<Comunicazioni_Sms_Aggregate_Fields>;
  nodes: Array<Comunicazioni_Sms>;
};

/** aggregate fields of "comunicazioni.sms" */
export type Comunicazioni_Sms_Aggregate_Fields = {
  __typename?: 'comunicazioni_sms_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Comunicazioni_Sms_Max_Fields>;
  min?: Maybe<Comunicazioni_Sms_Min_Fields>;
};


/** aggregate fields of "comunicazioni.sms" */
export type Comunicazioni_Sms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comunicazioni_Sms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "comunicazioni.sms". All fields are combined with a logical 'AND'. */
export type Comunicazioni_Sms_Bool_Exp = {
  _and?: InputMaybe<Array<Comunicazioni_Sms_Bool_Exp>>;
  _not?: InputMaybe<Comunicazioni_Sms_Bool_Exp>;
  _or?: InputMaybe<Array<Comunicazioni_Sms_Bool_Exp>>;
  cellulare?: InputMaybe<String_Comparison_Exp>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "comunicazioni.sms" */
export enum Comunicazioni_Sms_Constraint {
  /** unique or primary key constraint on columns "id" */
  SmsPkey = 'sms_pkey'
}

/** input type for inserting data into table "comunicazioni.sms" */
export type Comunicazioni_Sms_Insert_Input = {
  cellulare?: InputMaybe<Scalars['String']['input']>;
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Comunicazioni_Sms_Max_Fields = {
  __typename?: 'comunicazioni_sms_max_fields';
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Comunicazioni_Sms_Min_Fields = {
  __typename?: 'comunicazioni_sms_min_fields';
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "comunicazioni.sms" */
export type Comunicazioni_Sms_Mutation_Response = {
  __typename?: 'comunicazioni_sms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comunicazioni_Sms>;
};

/** on_conflict condition type for table "comunicazioni.sms" */
export type Comunicazioni_Sms_On_Conflict = {
  constraint: Comunicazioni_Sms_Constraint;
  update_columns?: Array<Comunicazioni_Sms_Update_Column>;
  where?: InputMaybe<Comunicazioni_Sms_Bool_Exp>;
};

/** Ordering options when selecting data from "comunicazioni.sms". */
export type Comunicazioni_Sms_Order_By = {
  cellulare?: InputMaybe<Order_By>;
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comunicazioni.sms */
export type Comunicazioni_Sms_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "comunicazioni.sms" */
export enum Comunicazioni_Sms_Select_Column {
  /** column name */
  Cellulare = 'cellulare',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "comunicazioni.sms" */
export type Comunicazioni_Sms_Set_Input = {
  cellulare?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "comunicazioni_sms" */
export type Comunicazioni_Sms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comunicazioni_Sms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comunicazioni_Sms_Stream_Cursor_Value_Input = {
  cellulare?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "comunicazioni.sms" */
export enum Comunicazioni_Sms_Update_Column {
  /** column name */
  Cellulare = 'cellulare',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Comunicazioni_Sms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comunicazioni_Sms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comunicazioni_Sms_Bool_Exp;
};

/** columns and relationships of "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione = {
  __typename?: 'condivisione__stato_condivisione';
  text: Scalars['String']['output'];
};

/** aggregated selection of "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione_Aggregate = {
  __typename?: 'condivisione__stato_condivisione_aggregate';
  aggregate?: Maybe<Condivisione__Stato_Condivisione_Aggregate_Fields>;
  nodes: Array<Condivisione__Stato_Condivisione>;
};

/** aggregate fields of "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione_Aggregate_Fields = {
  __typename?: 'condivisione__stato_condivisione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Condivisione__Stato_Condivisione_Max_Fields>;
  min?: Maybe<Condivisione__Stato_Condivisione_Min_Fields>;
};


/** aggregate fields of "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Condivisione__Stato_Condivisione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "condivisione._stato_condivisione". All fields are combined with a logical 'AND'. */
export type Condivisione__Stato_Condivisione_Bool_Exp = {
  _and?: InputMaybe<Array<Condivisione__Stato_Condivisione_Bool_Exp>>;
  _not?: InputMaybe<Condivisione__Stato_Condivisione_Bool_Exp>;
  _or?: InputMaybe<Array<Condivisione__Stato_Condivisione_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "condivisione._stato_condivisione" */
export enum Condivisione__Stato_Condivisione_Constraint {
  /** unique or primary key constraint on columns "text" */
  StatoCondivisionePkey = 'stato_condivisione_pkey'
}

export enum Condivisione__Stato_Condivisione_Enum {
  Accettato = 'accettato',
  Cancellata = 'cancellata',
  Condiviso = 'condiviso',
  Inviato = 'inviato',
  Rifiutato = 'rifiutato'
}

/** Boolean expression to compare columns of type "condivisione__stato_condivisione_enum". All fields are combined with logical 'AND'. */
export type Condivisione__Stato_Condivisione_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Condivisione__Stato_Condivisione_Enum>;
  _in?: InputMaybe<Array<Condivisione__Stato_Condivisione_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Condivisione__Stato_Condivisione_Enum>;
  _nin?: InputMaybe<Array<Condivisione__Stato_Condivisione_Enum>>;
};

/** input type for inserting data into table "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Condivisione__Stato_Condivisione_Max_Fields = {
  __typename?: 'condivisione__stato_condivisione_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Condivisione__Stato_Condivisione_Min_Fields = {
  __typename?: 'condivisione__stato_condivisione_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione_Mutation_Response = {
  __typename?: 'condivisione__stato_condivisione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Condivisione__Stato_Condivisione>;
};

/** on_conflict condition type for table "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione_On_Conflict = {
  constraint: Condivisione__Stato_Condivisione_Constraint;
  update_columns?: Array<Condivisione__Stato_Condivisione_Update_Column>;
  where?: InputMaybe<Condivisione__Stato_Condivisione_Bool_Exp>;
};

/** Ordering options when selecting data from "condivisione._stato_condivisione". */
export type Condivisione__Stato_Condivisione_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: condivisione._stato_condivisione */
export type Condivisione__Stato_Condivisione_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "condivisione._stato_condivisione" */
export enum Condivisione__Stato_Condivisione_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "condivisione._stato_condivisione" */
export type Condivisione__Stato_Condivisione_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "condivisione__stato_condivisione" */
export type Condivisione__Stato_Condivisione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Condivisione__Stato_Condivisione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Condivisione__Stato_Condivisione_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "condivisione._stato_condivisione" */
export enum Condivisione__Stato_Condivisione_Update_Column {
  /** column name */
  Text = 'text'
}

export type Condivisione__Stato_Condivisione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Condivisione__Stato_Condivisione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Condivisione__Stato_Condivisione_Bool_Exp;
};

export type Condivisione_Accetta_Args = {
  condivisioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "condivisione.accetta_response" */
export type Condivisione_Accetta_Response = {
  __typename?: 'condivisione_accetta_response';
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "condivisione.accetta_response" */
export type Condivisione_Accetta_Response_Aggregate = {
  __typename?: 'condivisione_accetta_response_aggregate';
  aggregate?: Maybe<Condivisione_Accetta_Response_Aggregate_Fields>;
  nodes: Array<Condivisione_Accetta_Response>;
};

/** aggregate fields of "condivisione.accetta_response" */
export type Condivisione_Accetta_Response_Aggregate_Fields = {
  __typename?: 'condivisione_accetta_response_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Condivisione_Accetta_Response_Max_Fields>;
  min?: Maybe<Condivisione_Accetta_Response_Min_Fields>;
};


/** aggregate fields of "condivisione.accetta_response" */
export type Condivisione_Accetta_Response_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Condivisione_Accetta_Response_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "condivisione.accetta_response". All fields are combined with a logical 'AND'. */
export type Condivisione_Accetta_Response_Bool_Exp = {
  _and?: InputMaybe<Array<Condivisione_Accetta_Response_Bool_Exp>>;
  _not?: InputMaybe<Condivisione_Accetta_Response_Bool_Exp>;
  _or?: InputMaybe<Array<Condivisione_Accetta_Response_Bool_Exp>>;
  condivisione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "condivisione.accetta_response" */
export type Condivisione_Accetta_Response_Insert_Input = {
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Condivisione_Accetta_Response_Max_Fields = {
  __typename?: 'condivisione_accetta_response_max_fields';
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Condivisione_Accetta_Response_Min_Fields = {
  __typename?: 'condivisione_accetta_response_min_fields';
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "condivisione.accetta_response" */
export type Condivisione_Accetta_Response_Mutation_Response = {
  __typename?: 'condivisione_accetta_response_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Condivisione_Accetta_Response>;
};

/** Ordering options when selecting data from "condivisione.accetta_response". */
export type Condivisione_Accetta_Response_Order_By = {
  condivisione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** select columns of table "condivisione.accetta_response" */
export enum Condivisione_Accetta_Response_Select_Column {
  /** column name */
  CondivisioneId = 'condivisione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Message = 'message',
  /** column name */
  Stato = 'stato',
  /** column name */
  Success = 'success',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "condivisione.accetta_response" */
export type Condivisione_Accetta_Response_Set_Input = {
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "condivisione_accetta_response" */
export type Condivisione_Accetta_Response_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Condivisione_Accetta_Response_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Condivisione_Accetta_Response_Stream_Cursor_Value_Input = {
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Condivisione_Accetta_Response_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Condivisione_Accetta_Response_Set_Input>;
  /** filter the rows which have to be updated */
  where: Condivisione_Accetta_Response_Bool_Exp;
};

/** columns and relationships of "condivisione.condivisione" */
export type Condivisione_Condivisione = {
  __typename?: 'condivisione_condivisione';
  /** An object relationship */
  asset?: Maybe<Asset>;
  /** A computed field, executes function "condivisione.asset_alias" */
  asset_alias?: Maybe<Scalars['String']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "condivisione.asset_indirizzo" */
  asset_indirizzo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  auth?: Maybe<Auth_User_Entity>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  email_verificata: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  installatore?: Maybe<Installatore>;
  installatore_id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  proprietario?: Maybe<Auth_User_Entity>;
  proprietario_id?: Maybe<Scalars['String']['output']>;
  ruolo?: Maybe<Scalars['jsonb']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato: Condivisione__Stato_Condivisione_Enum;
  termini?: Maybe<Scalars['Boolean']['output']>;
  tipo_profilo?: Maybe<_Tipologia_Profilo_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  utilizzatore?: Maybe<Auth_User_Entity>;
  utilizzatore_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "condivisione.condivisione" */
export type Condivisione_CondivisioneRuoloArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "condivisione.condivisione" */
export type Condivisione_Condivisione_Aggregate = {
  __typename?: 'condivisione_condivisione_aggregate';
  aggregate?: Maybe<Condivisione_Condivisione_Aggregate_Fields>;
  nodes: Array<Condivisione_Condivisione>;
};

export type Condivisione_Condivisione_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Condivisione_Condivisione_Aggregate_Bool_Exp_Count>;
};

export type Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_And = {
  arguments: Condivisione_Condivisione_Select_Column_Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Condivisione_Condivisione_Select_Column_Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Condivisione_Condivisione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "condivisione.condivisione" */
export type Condivisione_Condivisione_Aggregate_Fields = {
  __typename?: 'condivisione_condivisione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Condivisione_Condivisione_Max_Fields>;
  min?: Maybe<Condivisione_Condivisione_Min_Fields>;
};


/** aggregate fields of "condivisione.condivisione" */
export type Condivisione_Condivisione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "condivisione.condivisione" */
export type Condivisione_Condivisione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Condivisione_Condivisione_Max_Order_By>;
  min?: InputMaybe<Condivisione_Condivisione_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Condivisione_Condivisione_Append_Input = {
  ruolo?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "condivisione.condivisione" */
export type Condivisione_Condivisione_Arr_Rel_Insert_Input = {
  data: Array<Condivisione_Condivisione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Condivisione_Condivisione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "condivisione.condivisione". All fields are combined with a logical 'AND'. */
export type Condivisione_Condivisione_Bool_Exp = {
  _and?: InputMaybe<Array<Condivisione_Condivisione_Bool_Exp>>;
  _not?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
  _or?: InputMaybe<Array<Condivisione_Condivisione_Bool_Exp>>;
  asset?: InputMaybe<Asset_Bool_Exp>;
  asset_alias?: InputMaybe<String_Comparison_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  asset_indirizzo?: InputMaybe<String_Comparison_Exp>;
  auth?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  baseUrl?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_verificata?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  installatore?: InputMaybe<Installatore_Bool_Exp>;
  installatore_id?: InputMaybe<Uuid_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  proprietario?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  proprietario_id?: InputMaybe<String_Comparison_Exp>;
  ruolo?: InputMaybe<Jsonb_Comparison_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<Condivisione__Stato_Condivisione_Enum_Comparison_Exp>;
  termini?: InputMaybe<Boolean_Comparison_Exp>;
  tipo_profilo?: InputMaybe<_Tipologia_Profilo_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utilizzatore?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  utilizzatore_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "condivisione.condivisione" */
export enum Condivisione_Condivisione_Constraint {
  /** unique or primary key constraint on columns "id" */
  CondivisionePkey = 'condivisione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Condivisione_Condivisione_Delete_At_Path_Input = {
  ruolo?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Condivisione_Condivisione_Delete_Elem_Input = {
  ruolo?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Condivisione_Condivisione_Delete_Key_Input = {
  ruolo?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "condivisione.condivisione" */
export type Condivisione_Condivisione_Insert_Input = {
  asset?: InputMaybe<Asset_Obj_Rel_Insert_Input>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  auth?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verificata?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installatore?: InputMaybe<Installatore_Obj_Rel_Insert_Input>;
  installatore_id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  proprietario?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
  proprietario_id?: InputMaybe<Scalars['String']['input']>;
  ruolo?: InputMaybe<Scalars['jsonb']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Condivisione__Stato_Condivisione_Enum>;
  termini?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_profilo?: InputMaybe<_Tipologia_Profilo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utilizzatore?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
  utilizzatore_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Condivisione_Condivisione_Max_Fields = {
  __typename?: 'condivisione_condivisione_max_fields';
  /** A computed field, executes function "condivisione.asset_alias" */
  asset_alias?: Maybe<Scalars['String']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "condivisione.asset_indirizzo" */
  asset_indirizzo?: Maybe<Scalars['String']['output']>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installatore_id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  proprietario_id?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  utilizzatore_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "condivisione.condivisione" */
export type Condivisione_Condivisione_Max_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  baseUrl?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installatore_id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  proprietario_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utilizzatore_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Condivisione_Condivisione_Min_Fields = {
  __typename?: 'condivisione_condivisione_min_fields';
  /** A computed field, executes function "condivisione.asset_alias" */
  asset_alias?: Maybe<Scalars['String']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "condivisione.asset_indirizzo" */
  asset_indirizzo?: Maybe<Scalars['String']['output']>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  installatore_id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  proprietario_id?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  utilizzatore_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "condivisione.condivisione" */
export type Condivisione_Condivisione_Min_Order_By = {
  asset_id?: InputMaybe<Order_By>;
  baseUrl?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installatore_id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  proprietario_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utilizzatore_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "condivisione.condivisione" */
export type Condivisione_Condivisione_Mutation_Response = {
  __typename?: 'condivisione_condivisione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Condivisione_Condivisione>;
};

/** on_conflict condition type for table "condivisione.condivisione" */
export type Condivisione_Condivisione_On_Conflict = {
  constraint: Condivisione_Condivisione_Constraint;
  update_columns?: Array<Condivisione_Condivisione_Update_Column>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};

/** Ordering options when selecting data from "condivisione.condivisione". */
export type Condivisione_Condivisione_Order_By = {
  asset?: InputMaybe<Asset_Order_By>;
  asset_alias?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  asset_indirizzo?: InputMaybe<Order_By>;
  auth?: InputMaybe<Auth_User_Entity_Order_By>;
  baseUrl?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_verificata?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  installatore?: InputMaybe<Installatore_Order_By>;
  installatore_id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  proprietario?: InputMaybe<Auth_User_Entity_Order_By>;
  proprietario_id?: InputMaybe<Order_By>;
  ruolo?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  termini?: InputMaybe<Order_By>;
  tipo_profilo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utilizzatore?: InputMaybe<Auth_User_Entity_Order_By>;
  utilizzatore_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: condivisione.condivisione */
export type Condivisione_Condivisione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Condivisione_Condivisione_Prepend_Input = {
  ruolo?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "condivisione.condivisione" */
export enum Condivisione_Condivisione_Select_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BaseUrl = 'baseUrl',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerificata = 'email_verificata',
  /** column name */
  Id = 'id',
  /** column name */
  InstallatoreId = 'installatore_id',
  /** column name */
  Nome = 'nome',
  /** column name */
  ProprietarioId = 'proprietario_id',
  /** column name */
  Ruolo = 'ruolo',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  Termini = 'termini',
  /** column name */
  TipoProfilo = 'tipo_profilo',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtilizzatoreId = 'utilizzatore_id'
}

/** select "condivisione_condivisione_aggregate_bool_exp_bool_and_arguments_columns" columns of table "condivisione.condivisione" */
export enum Condivisione_Condivisione_Select_Column_Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EmailVerificata = 'email_verificata',
  /** column name */
  Termini = 'termini'
}

/** select "condivisione_condivisione_aggregate_bool_exp_bool_or_arguments_columns" columns of table "condivisione.condivisione" */
export enum Condivisione_Condivisione_Select_Column_Condivisione_Condivisione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EmailVerificata = 'email_verificata',
  /** column name */
  Termini = 'termini'
}

/** input type for updating data in table "condivisione.condivisione" */
export type Condivisione_Condivisione_Set_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verificata?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installatore_id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  proprietario_id?: InputMaybe<Scalars['String']['input']>;
  ruolo?: InputMaybe<Scalars['jsonb']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Condivisione__Stato_Condivisione_Enum>;
  termini?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_profilo?: InputMaybe<_Tipologia_Profilo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utilizzatore_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "condivisione_condivisione" */
export type Condivisione_Condivisione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Condivisione_Condivisione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Condivisione_Condivisione_Stream_Cursor_Value_Input = {
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verificata?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  installatore_id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  proprietario_id?: InputMaybe<Scalars['String']['input']>;
  ruolo?: InputMaybe<Scalars['jsonb']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Condivisione__Stato_Condivisione_Enum>;
  termini?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_profilo?: InputMaybe<_Tipologia_Profilo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utilizzatore_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "condivisione.condivisione" */
export enum Condivisione_Condivisione_Update_Column {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BaseUrl = 'baseUrl',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerificata = 'email_verificata',
  /** column name */
  Id = 'id',
  /** column name */
  InstallatoreId = 'installatore_id',
  /** column name */
  Nome = 'nome',
  /** column name */
  ProprietarioId = 'proprietario_id',
  /** column name */
  Ruolo = 'ruolo',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  Termini = 'termini',
  /** column name */
  TipoProfilo = 'tipo_profilo',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtilizzatoreId = 'utilizzatore_id'
}

export type Condivisione_Condivisione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Condivisione_Condivisione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Condivisione_Condivisione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Condivisione_Condivisione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Condivisione_Condivisione_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Condivisione_Condivisione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Condivisione_Condivisione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Condivisione_Condivisione_Bool_Exp;
};

/** columns and relationships of "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione = {
  __typename?: 'condivisione_log_condivisione';
  azione: Scalars['String']['output'];
  condivisione_id: Scalars['uuid']['output'];
  dettagli?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  ts: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "condivisione.log_condivisione" */
export type Condivisione_Log_CondivisioneDettagliArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione_Aggregate = {
  __typename?: 'condivisione_log_condivisione_aggregate';
  aggregate?: Maybe<Condivisione_Log_Condivisione_Aggregate_Fields>;
  nodes: Array<Condivisione_Log_Condivisione>;
};

/** aggregate fields of "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione_Aggregate_Fields = {
  __typename?: 'condivisione_log_condivisione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Condivisione_Log_Condivisione_Max_Fields>;
  min?: Maybe<Condivisione_Log_Condivisione_Min_Fields>;
};


/** aggregate fields of "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Condivisione_Log_Condivisione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Condivisione_Log_Condivisione_Append_Input = {
  dettagli?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "condivisione.log_condivisione". All fields are combined with a logical 'AND'. */
export type Condivisione_Log_Condivisione_Bool_Exp = {
  _and?: InputMaybe<Array<Condivisione_Log_Condivisione_Bool_Exp>>;
  _not?: InputMaybe<Condivisione_Log_Condivisione_Bool_Exp>;
  _or?: InputMaybe<Array<Condivisione_Log_Condivisione_Bool_Exp>>;
  azione?: InputMaybe<String_Comparison_Exp>;
  condivisione_id?: InputMaybe<Uuid_Comparison_Exp>;
  dettagli?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "condivisione.log_condivisione" */
export enum Condivisione_Log_Condivisione_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogCondivisionePkey = 'log_condivisione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Condivisione_Log_Condivisione_Delete_At_Path_Input = {
  dettagli?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Condivisione_Log_Condivisione_Delete_Elem_Input = {
  dettagli?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Condivisione_Log_Condivisione_Delete_Key_Input = {
  dettagli?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione_Insert_Input = {
  azione?: InputMaybe<Scalars['String']['input']>;
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  dettagli?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ts?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Condivisione_Log_Condivisione_Max_Fields = {
  __typename?: 'condivisione_log_condivisione_max_fields';
  azione?: Maybe<Scalars['String']['output']>;
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ts?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Condivisione_Log_Condivisione_Min_Fields = {
  __typename?: 'condivisione_log_condivisione_min_fields';
  azione?: Maybe<Scalars['String']['output']>;
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ts?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione_Mutation_Response = {
  __typename?: 'condivisione_log_condivisione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Condivisione_Log_Condivisione>;
};

/** on_conflict condition type for table "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione_On_Conflict = {
  constraint: Condivisione_Log_Condivisione_Constraint;
  update_columns?: Array<Condivisione_Log_Condivisione_Update_Column>;
  where?: InputMaybe<Condivisione_Log_Condivisione_Bool_Exp>;
};

/** Ordering options when selecting data from "condivisione.log_condivisione". */
export type Condivisione_Log_Condivisione_Order_By = {
  azione?: InputMaybe<Order_By>;
  condivisione_id?: InputMaybe<Order_By>;
  dettagli?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ts?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: condivisione.log_condivisione */
export type Condivisione_Log_Condivisione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Condivisione_Log_Condivisione_Prepend_Input = {
  dettagli?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "condivisione.log_condivisione" */
export enum Condivisione_Log_Condivisione_Select_Column {
  /** column name */
  Azione = 'azione',
  /** column name */
  CondivisioneId = 'condivisione_id',
  /** column name */
  Dettagli = 'dettagli',
  /** column name */
  Id = 'id',
  /** column name */
  Ts = 'ts',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "condivisione.log_condivisione" */
export type Condivisione_Log_Condivisione_Set_Input = {
  azione?: InputMaybe<Scalars['String']['input']>;
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  dettagli?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ts?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "condivisione_log_condivisione" */
export type Condivisione_Log_Condivisione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Condivisione_Log_Condivisione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Condivisione_Log_Condivisione_Stream_Cursor_Value_Input = {
  azione?: InputMaybe<Scalars['String']['input']>;
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  dettagli?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ts?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "condivisione.log_condivisione" */
export enum Condivisione_Log_Condivisione_Update_Column {
  /** column name */
  Azione = 'azione',
  /** column name */
  CondivisioneId = 'condivisione_id',
  /** column name */
  Dettagli = 'dettagli',
  /** column name */
  Id = 'id',
  /** column name */
  Ts = 'ts',
  /** column name */
  UserId = 'user_id'
}

export type Condivisione_Log_Condivisione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Condivisione_Log_Condivisione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Condivisione_Log_Condivisione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Condivisione_Log_Condivisione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Condivisione_Log_Condivisione_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Condivisione_Log_Condivisione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Condivisione_Log_Condivisione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Condivisione_Log_Condivisione_Bool_Exp;
};

/** columns and relationships of "contatto" */
export type Contatto = {
  __typename?: 'contatto';
  /** An array relationship */
  cer_contatti: Array<Cer_Contatti>;
  /** An aggregate relationship */
  cer_contatti_aggregate: Cer_Contatti_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  persone: Array<Persona_Contatto>;
  /** An aggregate relationship */
  persone_aggregate: Persona_Contatto_Aggregate;
  /** An object relationship */
  tipo_contatto: Anagrafica_Tipo_Contatto;
  tipo_contatto_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
  verificata: Scalars['Boolean']['output'];
};


/** columns and relationships of "contatto" */
export type ContattoCer_ContattiArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


/** columns and relationships of "contatto" */
export type ContattoCer_Contatti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


/** columns and relationships of "contatto" */
export type ContattoPersoneArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


/** columns and relationships of "contatto" */
export type ContattoPersone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};

/** aggregated selection of "contatto" */
export type Contatto_Aggregate = {
  __typename?: 'contatto_aggregate';
  aggregate?: Maybe<Contatto_Aggregate_Fields>;
  nodes: Array<Contatto>;
};

/** aggregate fields of "contatto" */
export type Contatto_Aggregate_Fields = {
  __typename?: 'contatto_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contatto_Max_Fields>;
  min?: Maybe<Contatto_Min_Fields>;
};


/** aggregate fields of "contatto" */
export type Contatto_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contatto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "contatto". All fields are combined with a logical 'AND'. */
export type Contatto_Bool_Exp = {
  _and?: InputMaybe<Array<Contatto_Bool_Exp>>;
  _not?: InputMaybe<Contatto_Bool_Exp>;
  _or?: InputMaybe<Array<Contatto_Bool_Exp>>;
  cer_contatti?: InputMaybe<Cer_Contatti_Bool_Exp>;
  cer_contatti_aggregate?: InputMaybe<Cer_Contatti_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  persone?: InputMaybe<Persona_Contatto_Bool_Exp>;
  persone_aggregate?: InputMaybe<Persona_Contatto_Aggregate_Bool_Exp>;
  tipo_contatto?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
  tipo_contatto_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  verificata?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "contatto" */
export enum Contatto_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContattoPkey = 'contatto_pkey'
}

/** input type for inserting data into table "contatto" */
export type Contatto_Insert_Input = {
  cer_contatti?: InputMaybe<Cer_Contatti_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  persone?: InputMaybe<Persona_Contatto_Arr_Rel_Insert_Input>;
  tipo_contatto?: InputMaybe<Anagrafica_Tipo_Contatto_Obj_Rel_Insert_Input>;
  tipo_contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  verificata?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Contatto_Max_Fields = {
  __typename?: 'contatto_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tipo_contatto_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Contatto_Min_Fields = {
  __typename?: 'contatto_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tipo_contatto_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "contatto" */
export type Contatto_Mutation_Response = {
  __typename?: 'contatto_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contatto>;
};

/** input type for inserting object relation for remote table "contatto" */
export type Contatto_Obj_Rel_Insert_Input = {
  data: Contatto_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contatto_On_Conflict>;
};

/** on_conflict condition type for table "contatto" */
export type Contatto_On_Conflict = {
  constraint: Contatto_Constraint;
  update_columns?: Array<Contatto_Update_Column>;
  where?: InputMaybe<Contatto_Bool_Exp>;
};

/** Ordering options when selecting data from "contatto". */
export type Contatto_Order_By = {
  cer_contatti_aggregate?: InputMaybe<Cer_Contatti_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  persone_aggregate?: InputMaybe<Persona_Contatto_Aggregate_Order_By>;
  tipo_contatto?: InputMaybe<Anagrafica_Tipo_Contatto_Order_By>;
  tipo_contatto_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  verificata?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contatto */
export type Contatto_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "contatto" */
export enum Contatto_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TipoContattoId = 'tipo_contatto_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  Verificata = 'verificata'
}

/** input type for updating data in table "contatto" */
export type Contatto_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  verificata?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "contatto" */
export type Contatto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contatto_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contatto_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipo_contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  verificata?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "contatto" */
export enum Contatto_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TipoContattoId = 'tipo_contatto_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  Verificata = 'verificata'
}

export type Contatto_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contatto_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contatto_Bool_Exp;
};

/** columns and relationships of "crm.audit_event" */
export type Crm_Audit_Event = {
  __typename?: 'crm_audit_event';
  actor_auth_id?: Maybe<Scalars['String']['output']>;
  actor_mode: Scalars['String']['output'];
  asset_id?: Maybe<Scalars['uuid']['output']>;
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  domain: Scalars['String']['output'];
  entity_pk: Scalars['String']['output'];
  entity_schema: Scalars['String']['output'];
  entity_table: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  execution_mode: Scalars['String']['output'];
  from_stato?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  metadata: Scalars['jsonb']['output'];
  new_data?: Maybe<Scalars['jsonb']['output']>;
  old_data?: Maybe<Scalars['jsonb']['output']>;
  operation: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  to_stato?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "crm.audit_event" */
export type Crm_Audit_EventMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "crm.audit_event" */
export type Crm_Audit_EventNew_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "crm.audit_event" */
export type Crm_Audit_EventOld_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "crm.audit_event" */
export type Crm_Audit_Event_Aggregate = {
  __typename?: 'crm_audit_event_aggregate';
  aggregate?: Maybe<Crm_Audit_Event_Aggregate_Fields>;
  nodes: Array<Crm_Audit_Event>;
};

/** aggregate fields of "crm.audit_event" */
export type Crm_Audit_Event_Aggregate_Fields = {
  __typename?: 'crm_audit_event_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Audit_Event_Max_Fields>;
  min?: Maybe<Crm_Audit_Event_Min_Fields>;
};


/** aggregate fields of "crm.audit_event" */
export type Crm_Audit_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Audit_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Crm_Audit_Event_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "crm.audit_event". All fields are combined with a logical 'AND'. */
export type Crm_Audit_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Audit_Event_Bool_Exp>>;
  _not?: InputMaybe<Crm_Audit_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Audit_Event_Bool_Exp>>;
  actor_auth_id?: InputMaybe<String_Comparison_Exp>;
  actor_mode?: InputMaybe<String_Comparison_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  changed_fields?: InputMaybe<String_Array_Comparison_Exp>;
  condivisione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  entity_pk?: InputMaybe<String_Comparison_Exp>;
  entity_schema?: InputMaybe<String_Comparison_Exp>;
  entity_table?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  execution_mode?: InputMaybe<String_Comparison_Exp>;
  from_stato?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  new_data?: InputMaybe<Jsonb_Comparison_Exp>;
  old_data?: InputMaybe<Jsonb_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  origin?: InputMaybe<String_Comparison_Exp>;
  to_stato?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "crm.audit_event" */
export enum Crm_Audit_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  AuditEventPkey = 'audit_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Crm_Audit_Event_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  new_data?: InputMaybe<Array<Scalars['String']['input']>>;
  old_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Crm_Audit_Event_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
  new_data?: InputMaybe<Scalars['Int']['input']>;
  old_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Crm_Audit_Event_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  new_data?: InputMaybe<Scalars['String']['input']>;
  old_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "crm.audit_event" */
export type Crm_Audit_Event_Insert_Input = {
  actor_auth_id?: InputMaybe<Scalars['String']['input']>;
  actor_mode?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  entity_pk?: InputMaybe<Scalars['String']['input']>;
  entity_schema?: InputMaybe<Scalars['String']['input']>;
  entity_table?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  execution_mode?: InputMaybe<Scalars['String']['input']>;
  from_stato?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_data?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  to_stato?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Crm_Audit_Event_Max_Fields = {
  __typename?: 'crm_audit_event_max_fields';
  actor_auth_id?: Maybe<Scalars['String']['output']>;
  actor_mode?: Maybe<Scalars['String']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  entity_pk?: Maybe<Scalars['String']['output']>;
  entity_schema?: Maybe<Scalars['String']['output']>;
  entity_table?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  execution_mode?: Maybe<Scalars['String']['output']>;
  from_stato?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  to_stato?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Crm_Audit_Event_Min_Fields = {
  __typename?: 'crm_audit_event_min_fields';
  actor_auth_id?: Maybe<Scalars['String']['output']>;
  actor_mode?: Maybe<Scalars['String']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  changed_fields?: Maybe<Array<Scalars['String']['output']>>;
  condivisione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  entity_pk?: Maybe<Scalars['String']['output']>;
  entity_schema?: Maybe<Scalars['String']['output']>;
  entity_table?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  execution_mode?: Maybe<Scalars['String']['output']>;
  from_stato?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  to_stato?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.audit_event" */
export type Crm_Audit_Event_Mutation_Response = {
  __typename?: 'crm_audit_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Crm_Audit_Event>;
};

/** on_conflict condition type for table "crm.audit_event" */
export type Crm_Audit_Event_On_Conflict = {
  constraint: Crm_Audit_Event_Constraint;
  update_columns?: Array<Crm_Audit_Event_Update_Column>;
  where?: InputMaybe<Crm_Audit_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "crm.audit_event". */
export type Crm_Audit_Event_Order_By = {
  actor_auth_id?: InputMaybe<Order_By>;
  actor_mode?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  changed_fields?: InputMaybe<Order_By>;
  condivisione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  entity_pk?: InputMaybe<Order_By>;
  entity_schema?: InputMaybe<Order_By>;
  entity_table?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  execution_mode?: InputMaybe<Order_By>;
  from_stato?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  new_data?: InputMaybe<Order_By>;
  old_data?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  to_stato?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crm.audit_event */
export type Crm_Audit_Event_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Crm_Audit_Event_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "crm.audit_event" */
export enum Crm_Audit_Event_Select_Column {
  /** column name */
  ActorAuthId = 'actor_auth_id',
  /** column name */
  ActorMode = 'actor_mode',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  CondivisioneId = 'condivisione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Domain = 'domain',
  /** column name */
  EntityPk = 'entity_pk',
  /** column name */
  EntitySchema = 'entity_schema',
  /** column name */
  EntityTable = 'entity_table',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ExecutionMode = 'execution_mode',
  /** column name */
  FromStato = 'from_stato',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewData = 'new_data',
  /** column name */
  OldData = 'old_data',
  /** column name */
  Operation = 'operation',
  /** column name */
  Origin = 'origin',
  /** column name */
  ToStato = 'to_stato'
}

/** input type for updating data in table "crm.audit_event" */
export type Crm_Audit_Event_Set_Input = {
  actor_auth_id?: InputMaybe<Scalars['String']['input']>;
  actor_mode?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  entity_pk?: InputMaybe<Scalars['String']['input']>;
  entity_schema?: InputMaybe<Scalars['String']['input']>;
  entity_table?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  execution_mode?: InputMaybe<Scalars['String']['input']>;
  from_stato?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_data?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  to_stato?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_audit_event" */
export type Crm_Audit_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crm_Audit_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crm_Audit_Event_Stream_Cursor_Value_Input = {
  actor_auth_id?: InputMaybe<Scalars['String']['input']>;
  actor_mode?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  changed_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  condivisione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  entity_pk?: InputMaybe<Scalars['String']['input']>;
  entity_schema?: InputMaybe<Scalars['String']['input']>;
  entity_table?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  execution_mode?: InputMaybe<Scalars['String']['input']>;
  from_stato?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  new_data?: InputMaybe<Scalars['jsonb']['input']>;
  old_data?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  to_stato?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.audit_event" */
export enum Crm_Audit_Event_Update_Column {
  /** column name */
  ActorAuthId = 'actor_auth_id',
  /** column name */
  ActorMode = 'actor_mode',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ChangedFields = 'changed_fields',
  /** column name */
  CondivisioneId = 'condivisione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Domain = 'domain',
  /** column name */
  EntityPk = 'entity_pk',
  /** column name */
  EntitySchema = 'entity_schema',
  /** column name */
  EntityTable = 'entity_table',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ExecutionMode = 'execution_mode',
  /** column name */
  FromStato = 'from_stato',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewData = 'new_data',
  /** column name */
  OldData = 'old_data',
  /** column name */
  Operation = 'operation',
  /** column name */
  Origin = 'origin',
  /** column name */
  ToStato = 'to_stato'
}

export type Crm_Audit_Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Crm_Audit_Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Crm_Audit_Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Crm_Audit_Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Crm_Audit_Event_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Crm_Audit_Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crm_Audit_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Crm_Audit_Event_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log = {
  __typename?: 'debug_sottoscrizione_after_log';
  a_id?: Maybe<Scalars['uuid']['output']>;
  cer_padre_id?: Maybe<Scalars['uuid']['output']>;
  cerid?: Maybe<Scalars['uuid']['output']>;
  cond_incentivo_key?: Maybe<Scalars['Boolean']['output']>;
  cond_prosumer?: Maybe<Scalars['Boolean']['output']>;
  cond_stato_inviata?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  incentivi?: Maybe<Scalars['jsonb']['output']>;
  new_row?: Maybe<Scalars['jsonb']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  stato_input?: Maybe<Scalars['String']['output']>;
  stato_output?: Maybe<Scalars['String']['output']>;
  tg_op?: Maybe<Scalars['String']['output']>;
  tg_table?: Maybe<Scalars['String']['output']>;
  tipologia_richiesta?: Maybe<Scalars['String']['output']>;
  ts?: Maybe<Scalars['timestamptz']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_LogIncentiviArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_LogNew_RowArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Aggregate = {
  __typename?: 'debug_sottoscrizione_after_log_aggregate';
  aggregate?: Maybe<Debug_Sottoscrizione_After_Log_Aggregate_Fields>;
  nodes: Array<Debug_Sottoscrizione_After_Log>;
};

/** aggregate fields of "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Aggregate_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_aggregate_fields';
  avg?: Maybe<Debug_Sottoscrizione_After_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Debug_Sottoscrizione_After_Log_Max_Fields>;
  min?: Maybe<Debug_Sottoscrizione_After_Log_Min_Fields>;
  stddev?: Maybe<Debug_Sottoscrizione_After_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Debug_Sottoscrizione_After_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Debug_Sottoscrizione_After_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Debug_Sottoscrizione_After_Log_Sum_Fields>;
  var_pop?: Maybe<Debug_Sottoscrizione_After_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Debug_Sottoscrizione_After_Log_Var_Samp_Fields>;
  variance?: Maybe<Debug_Sottoscrizione_After_Log_Variance_Fields>;
};


/** aggregate fields of "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Debug_Sottoscrizione_After_Log_Append_Input = {
  incentivi?: InputMaybe<Scalars['jsonb']['input']>;
  new_row?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Debug_Sottoscrizione_After_Log_Avg_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "debug.sottoscrizione_after_log". All fields are combined with a logical 'AND'. */
export type Debug_Sottoscrizione_After_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Bool_Exp>>;
  _not?: InputMaybe<Debug_Sottoscrizione_After_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Bool_Exp>>;
  a_id?: InputMaybe<Uuid_Comparison_Exp>;
  cer_padre_id?: InputMaybe<Uuid_Comparison_Exp>;
  cerid?: InputMaybe<Uuid_Comparison_Exp>;
  cond_incentivo_key?: InputMaybe<Boolean_Comparison_Exp>;
  cond_prosumer?: InputMaybe<Boolean_Comparison_Exp>;
  cond_stato_inviata?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  incentivi?: InputMaybe<Jsonb_Comparison_Exp>;
  new_row?: InputMaybe<Jsonb_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  stato_input?: InputMaybe<String_Comparison_Exp>;
  stato_output?: InputMaybe<String_Comparison_Exp>;
  tg_op?: InputMaybe<String_Comparison_Exp>;
  tg_table?: InputMaybe<String_Comparison_Exp>;
  tipologia_richiesta?: InputMaybe<String_Comparison_Exp>;
  ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "debug.sottoscrizione_after_log" */
export enum Debug_Sottoscrizione_After_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  SottoscrizioneAfterLogPkey = 'sottoscrizione_after_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Debug_Sottoscrizione_After_Log_Delete_At_Path_Input = {
  incentivi?: InputMaybe<Array<Scalars['String']['input']>>;
  new_row?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Debug_Sottoscrizione_After_Log_Delete_Elem_Input = {
  incentivi?: InputMaybe<Scalars['Int']['input']>;
  new_row?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Debug_Sottoscrizione_After_Log_Delete_Key_Input = {
  incentivi?: InputMaybe<Scalars['String']['input']>;
  new_row?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Insert_Input = {
  a_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_padre_id?: InputMaybe<Scalars['uuid']['input']>;
  cerid?: InputMaybe<Scalars['uuid']['input']>;
  cond_incentivo_key?: InputMaybe<Scalars['Boolean']['input']>;
  cond_prosumer?: InputMaybe<Scalars['Boolean']['input']>;
  cond_stato_inviata?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  incentivi?: InputMaybe<Scalars['jsonb']['input']>;
  new_row?: InputMaybe<Scalars['jsonb']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  stato_input?: InputMaybe<Scalars['String']['input']>;
  stato_output?: InputMaybe<Scalars['String']['input']>;
  tg_op?: InputMaybe<Scalars['String']['input']>;
  tg_table?: InputMaybe<Scalars['String']['input']>;
  tipologia_richiesta?: InputMaybe<Scalars['String']['input']>;
  ts?: InputMaybe<Scalars['timestamptz']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Debug_Sottoscrizione_After_Log_Max_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_max_fields';
  a_id?: Maybe<Scalars['uuid']['output']>;
  cer_padre_id?: Maybe<Scalars['uuid']['output']>;
  cerid?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  stato_input?: Maybe<Scalars['String']['output']>;
  stato_output?: Maybe<Scalars['String']['output']>;
  tg_op?: Maybe<Scalars['String']['output']>;
  tg_table?: Maybe<Scalars['String']['output']>;
  tipologia_richiesta?: Maybe<Scalars['String']['output']>;
  ts?: Maybe<Scalars['timestamptz']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Debug_Sottoscrizione_After_Log_Min_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_min_fields';
  a_id?: Maybe<Scalars['uuid']['output']>;
  cer_padre_id?: Maybe<Scalars['uuid']['output']>;
  cerid?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  stato_input?: Maybe<Scalars['String']['output']>;
  stato_output?: Maybe<Scalars['String']['output']>;
  tg_op?: Maybe<Scalars['String']['output']>;
  tg_table?: Maybe<Scalars['String']['output']>;
  tipologia_richiesta?: Maybe<Scalars['String']['output']>;
  ts?: Maybe<Scalars['timestamptz']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Mutation_Response = {
  __typename?: 'debug_sottoscrizione_after_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Debug_Sottoscrizione_After_Log>;
};

/** on_conflict condition type for table "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_On_Conflict = {
  constraint: Debug_Sottoscrizione_After_Log_Constraint;
  update_columns?: Array<Debug_Sottoscrizione_After_Log_Update_Column>;
  where?: InputMaybe<Debug_Sottoscrizione_After_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "debug.sottoscrizione_after_log". */
export type Debug_Sottoscrizione_After_Log_Order_By = {
  a_id?: InputMaybe<Order_By>;
  cer_padre_id?: InputMaybe<Order_By>;
  cerid?: InputMaybe<Order_By>;
  cond_incentivo_key?: InputMaybe<Order_By>;
  cond_prosumer?: InputMaybe<Order_By>;
  cond_stato_inviata?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incentivi?: InputMaybe<Order_By>;
  new_row?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  stato_input?: InputMaybe<Order_By>;
  stato_output?: InputMaybe<Order_By>;
  tg_op?: InputMaybe<Order_By>;
  tg_table?: InputMaybe<Order_By>;
  tipologia_richiesta?: InputMaybe<Order_By>;
  ts?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: debug.sottoscrizione_after_log */
export type Debug_Sottoscrizione_After_Log_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Debug_Sottoscrizione_After_Log_Prepend_Input = {
  incentivi?: InputMaybe<Scalars['jsonb']['input']>;
  new_row?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "debug.sottoscrizione_after_log" */
export enum Debug_Sottoscrizione_After_Log_Select_Column {
  /** column name */
  AId = 'a_id',
  /** column name */
  CerPadreId = 'cer_padre_id',
  /** column name */
  Cerid = 'cerid',
  /** column name */
  CondIncentivoKey = 'cond_incentivo_key',
  /** column name */
  CondProsumer = 'cond_prosumer',
  /** column name */
  CondStatoInviata = 'cond_stato_inviata',
  /** column name */
  Id = 'id',
  /** column name */
  Incentivi = 'incentivi',
  /** column name */
  NewRow = 'new_row',
  /** column name */
  Note = 'note',
  /** column name */
  StatoInput = 'stato_input',
  /** column name */
  StatoOutput = 'stato_output',
  /** column name */
  TgOp = 'tg_op',
  /** column name */
  TgTable = 'tg_table',
  /** column name */
  TipologiaRichiesta = 'tipologia_richiesta',
  /** column name */
  Ts = 'ts',
  /** column name */
  UserName = 'user_name'
}

/** input type for updating data in table "debug.sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Set_Input = {
  a_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_padre_id?: InputMaybe<Scalars['uuid']['input']>;
  cerid?: InputMaybe<Scalars['uuid']['input']>;
  cond_incentivo_key?: InputMaybe<Scalars['Boolean']['input']>;
  cond_prosumer?: InputMaybe<Scalars['Boolean']['input']>;
  cond_stato_inviata?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  incentivi?: InputMaybe<Scalars['jsonb']['input']>;
  new_row?: InputMaybe<Scalars['jsonb']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  stato_input?: InputMaybe<Scalars['String']['input']>;
  stato_output?: InputMaybe<Scalars['String']['input']>;
  tg_op?: InputMaybe<Scalars['String']['input']>;
  tg_table?: InputMaybe<Scalars['String']['input']>;
  tipologia_richiesta?: InputMaybe<Scalars['String']['input']>;
  ts?: InputMaybe<Scalars['timestamptz']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Debug_Sottoscrizione_After_Log_Stddev_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Debug_Sottoscrizione_After_Log_Stddev_Pop_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Debug_Sottoscrizione_After_Log_Stddev_Samp_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "debug_sottoscrizione_after_log" */
export type Debug_Sottoscrizione_After_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Debug_Sottoscrizione_After_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Debug_Sottoscrizione_After_Log_Stream_Cursor_Value_Input = {
  a_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_padre_id?: InputMaybe<Scalars['uuid']['input']>;
  cerid?: InputMaybe<Scalars['uuid']['input']>;
  cond_incentivo_key?: InputMaybe<Scalars['Boolean']['input']>;
  cond_prosumer?: InputMaybe<Scalars['Boolean']['input']>;
  cond_stato_inviata?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  incentivi?: InputMaybe<Scalars['jsonb']['input']>;
  new_row?: InputMaybe<Scalars['jsonb']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  stato_input?: InputMaybe<Scalars['String']['input']>;
  stato_output?: InputMaybe<Scalars['String']['input']>;
  tg_op?: InputMaybe<Scalars['String']['input']>;
  tg_table?: InputMaybe<Scalars['String']['input']>;
  tipologia_richiesta?: InputMaybe<Scalars['String']['input']>;
  ts?: InputMaybe<Scalars['timestamptz']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Debug_Sottoscrizione_After_Log_Sum_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "debug.sottoscrizione_after_log" */
export enum Debug_Sottoscrizione_After_Log_Update_Column {
  /** column name */
  AId = 'a_id',
  /** column name */
  CerPadreId = 'cer_padre_id',
  /** column name */
  Cerid = 'cerid',
  /** column name */
  CondIncentivoKey = 'cond_incentivo_key',
  /** column name */
  CondProsumer = 'cond_prosumer',
  /** column name */
  CondStatoInviata = 'cond_stato_inviata',
  /** column name */
  Id = 'id',
  /** column name */
  Incentivi = 'incentivi',
  /** column name */
  NewRow = 'new_row',
  /** column name */
  Note = 'note',
  /** column name */
  StatoInput = 'stato_input',
  /** column name */
  StatoOutput = 'stato_output',
  /** column name */
  TgOp = 'tg_op',
  /** column name */
  TgTable = 'tg_table',
  /** column name */
  TipologiaRichiesta = 'tipologia_richiesta',
  /** column name */
  Ts = 'ts',
  /** column name */
  UserName = 'user_name'
}

export type Debug_Sottoscrizione_After_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Debug_Sottoscrizione_After_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Debug_Sottoscrizione_After_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Debug_Sottoscrizione_After_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Debug_Sottoscrizione_After_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Debug_Sottoscrizione_After_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Debug_Sottoscrizione_After_Log_Var_Pop_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Debug_Sottoscrizione_After_Log_Var_Samp_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Debug_Sottoscrizione_After_Log_Variance_Fields = {
  __typename?: 'debug_sottoscrizione_after_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Destinazioni_Compatibili_Args = {
  p_cer_id?: InputMaybe<Scalars['uuid']['input']>;
  p_lat?: InputMaybe<Scalars['float8']['input']>;
  p_lng?: InputMaybe<Scalars['float8']['input']>;
};

/** columns and relationships of "device.device" */
export type Device_Device = {
  __typename?: 'device_device';
  /** An object relationship */
  asset_consumo?: Maybe<Asset_Consumo>;
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  device_imei: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "device.device" */
export type Device_Device_Aggregate = {
  __typename?: 'device_device_aggregate';
  aggregate?: Maybe<Device_Device_Aggregate_Fields>;
  nodes: Array<Device_Device>;
};

/** aggregate fields of "device.device" */
export type Device_Device_Aggregate_Fields = {
  __typename?: 'device_device_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Device_Device_Max_Fields>;
  min?: Maybe<Device_Device_Min_Fields>;
};


/** aggregate fields of "device.device" */
export type Device_Device_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Device_Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "device.device". All fields are combined with a logical 'AND'. */
export type Device_Device_Bool_Exp = {
  _and?: InputMaybe<Array<Device_Device_Bool_Exp>>;
  _not?: InputMaybe<Device_Device_Bool_Exp>;
  _or?: InputMaybe<Array<Device_Device_Bool_Exp>>;
  asset_consumo?: InputMaybe<Asset_Consumo_Bool_Exp>;
  asset_consumo_id?: InputMaybe<Uuid_Comparison_Exp>;
  device_imei?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "device.device" */
export enum Device_Device_Constraint {
  /** unique or primary key constraint on columns "id" */
  DevicePkey = 'device_pkey'
}

/** input type for inserting data into table "device.device" */
export type Device_Device_Insert_Input = {
  asset_consumo?: InputMaybe<Asset_Consumo_Obj_Rel_Insert_Input>;
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  device_imei?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Device_Device_Max_Fields = {
  __typename?: 'device_device_max_fields';
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  device_imei?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Device_Device_Min_Fields = {
  __typename?: 'device_device_min_fields';
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  device_imei?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "device.device" */
export type Device_Device_Mutation_Response = {
  __typename?: 'device_device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Device_Device>;
};

/** on_conflict condition type for table "device.device" */
export type Device_Device_On_Conflict = {
  constraint: Device_Device_Constraint;
  update_columns?: Array<Device_Device_Update_Column>;
  where?: InputMaybe<Device_Device_Bool_Exp>;
};

/** Ordering options when selecting data from "device.device". */
export type Device_Device_Order_By = {
  asset_consumo?: InputMaybe<Asset_Consumo_Order_By>;
  asset_consumo_id?: InputMaybe<Order_By>;
  device_imei?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: device.device */
export type Device_Device_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "device.device" */
export enum Device_Device_Select_Column {
  /** column name */
  AssetConsumoId = 'asset_consumo_id',
  /** column name */
  DeviceImei = 'device_imei',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id'
}

/** input type for updating data in table "device.device" */
export type Device_Device_Set_Input = {
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  device_imei?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "device_device" */
export type Device_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Device_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Device_Device_Stream_Cursor_Value_Input = {
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  device_imei?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "device.device" */
export enum Device_Device_Update_Column {
  /** column name */
  AssetConsumoId = 'asset_consumo_id',
  /** column name */
  DeviceImei = 'device_imei',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id'
}

export type Device_Device_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Device_Device_Set_Input>;
  /** filter the rows which have to be updated */
  where: Device_Device_Bool_Exp;
};

/** columns and relationships of "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione = {
  __typename?: 'energy_village__azioni_founder_sottoscrizione';
  text: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Aggregate = {
  __typename?: 'energy_village__azioni_founder_sottoscrizione_aggregate';
  aggregate?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Energy_Village__Azioni_Founder_Sottoscrizione>;
};

/** aggregate fields of "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'energy_village__azioni_founder_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione_Max_Fields>;
  min?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._azioni_founder_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._azioni_founder_sottoscrizione" */
export enum Energy_Village__Azioni_Founder_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "text" */
  _AzioniFounderSottoscrizionePkey = '_azioni_founder_sottoscrizione_pkey'
}

export enum Energy_Village__Azioni_Founder_Sottoscrizione_Enum {
  Accetta = 'accetta',
  Ammetti = 'ammetti',
  ConcludiDisdetta = 'concludi_disdetta',
  ConcludiRecesso = 'concludi_recesso',
  InviaDisdetta = 'invia_disdetta',
  Opziona = 'opziona',
  Proroga = 'proroga',
  Rifiuta = 'rifiuta',
  RifiutaOpzione = 'rifiuta_opzione',
  RigettaAdesione = 'rigetta_adesione',
  RigettaDatiTecnici = 'rigetta_dati_tecnici'
}

/** Boolean expression to compare columns of type "energy_village__azioni_founder_sottoscrizione_enum". All fields are combined with logical 'AND'. */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Enum>;
  _in?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Enum>;
  _nin?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Enum>>;
};

/** input type for inserting data into table "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Max_Fields = {
  __typename?: 'energy_village__azioni_founder_sottoscrizione_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Min_Fields = {
  __typename?: 'energy_village__azioni_founder_sottoscrizione_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Mutation_Response = {
  __typename?: 'energy_village__azioni_founder_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Azioni_Founder_Sottoscrizione>;
};

/** on_conflict condition type for table "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_On_Conflict = {
  constraint: Energy_Village__Azioni_Founder_Sottoscrizione_Constraint;
  update_columns?: Array<Energy_Village__Azioni_Founder_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._azioni_founder_sottoscrizione". */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._azioni_founder_sottoscrizione */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "energy_village._azioni_founder_sottoscrizione" */
export enum Energy_Village__Azioni_Founder_Sottoscrizione_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "energy_village._azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__azioni_founder_sottoscrizione" */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Azioni_Founder_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Azioni_Founder_Sottoscrizione_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._azioni_founder_sottoscrizione" */
export enum Energy_Village__Azioni_Founder_Sottoscrizione_Update_Column {
  /** column name */
  Text = 'text'
}

export type Energy_Village__Azioni_Founder_Sottoscrizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione = {
  __typename?: 'energy_village__azioni_prosumer_sottoscrizione';
  text: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Aggregate = {
  __typename?: 'energy_village__azioni_prosumer_sottoscrizione_aggregate';
  aggregate?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
};

/** aggregate fields of "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'energy_village__azioni_prosumer_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Max_Fields>;
  min?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._azioni_prosumer_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._azioni_prosumer_sottoscrizione" */
export enum Energy_Village__Azioni_Prosumer_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "text" */
  _AzioniProsumerSottoscrizionePkey = '_azioni_prosumer_sottoscrizione_pkey'
}

export enum Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum {
  AnnullaRichiestaRecesso = 'annulla_richiesta_recesso',
  CancellaRichiesta = 'cancella_richiesta',
  CompletaPagamento = 'completa_pagamento',
  Consumer = 'consumer',
  Correggi = 'correggi',
  Future = 'future',
  Integra = 'integra',
  Procedi = 'procedi',
  ProcediPnrr = 'procedi_pnrr',
  ProcediTecnici = 'procedi_tecnici',
  Prosumer = 'prosumer',
  RichiediNuovamente = 'richiedi_nuovamente',
  RichiediRecesso = 'richiedi_recesso',
  SalvaPerDopo = 'salva_per_dopo',
  Segui = 'segui'
}

/** Boolean expression to compare columns of type "energy_village__azioni_prosumer_sottoscrizione_enum". All fields are combined with logical 'AND'. */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum>;
  _in?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum>;
  _nin?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum>>;
};

/** input type for inserting data into table "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Max_Fields = {
  __typename?: 'energy_village__azioni_prosumer_sottoscrizione_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Min_Fields = {
  __typename?: 'energy_village__azioni_prosumer_sottoscrizione_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Mutation_Response = {
  __typename?: 'energy_village__azioni_prosumer_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
};

/** on_conflict condition type for table "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_On_Conflict = {
  constraint: Energy_Village__Azioni_Prosumer_Sottoscrizione_Constraint;
  update_columns?: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._azioni_prosumer_sottoscrizione". */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._azioni_prosumer_sottoscrizione */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "energy_village._azioni_prosumer_sottoscrizione" */
export enum Energy_Village__Azioni_Prosumer_Sottoscrizione_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "energy_village._azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__azioni_prosumer_sottoscrizione" */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Azioni_Prosumer_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._azioni_prosumer_sottoscrizione" */
export enum Energy_Village__Azioni_Prosumer_Sottoscrizione_Update_Column {
  /** column name */
  Text = 'text'
}

export type Energy_Village__Azioni_Prosumer_Sottoscrizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione = {
  __typename?: 'energy_village__azioni_tecnico_sottoscrizione';
  text: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Aggregate = {
  __typename?: 'energy_village__azioni_tecnico_sottoscrizione_aggregate';
  aggregate?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
};

/** aggregate fields of "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'energy_village__azioni_tecnico_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Max_Fields>;
  min?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._azioni_tecnico_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._azioni_tecnico_sottoscrizione" */
export enum Energy_Village__Azioni_Tecnico_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "text" */
  _AzioniTecnicoSottoscrizionePkey = '_azioni_tecnico_sottoscrizione_pkey'
}

export enum Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum {
  AnnullaRichiestaRecesso = 'annulla_richiesta_recesso',
  CancellaRichiesta = 'cancella_richiesta',
  CompletaPagamento = 'completa_pagamento',
  Correggi = 'correggi',
  Integra = 'integra',
  Procedi = 'procedi',
  ProcediPnrr = 'procedi_pnrr',
  ProcediTecnici = 'procedi_tecnici',
  RichiediNuovamente = 'richiedi_nuovamente',
  RichiediRecesso = 'richiedi_recesso',
  Rifiuta = 'rifiuta',
  RigettaDatiPnrr = 'rigetta_dati_pnrr',
  SalvaPerDopo = 'salva_per_dopo',
  Segui = 'segui'
}

/** Boolean expression to compare columns of type "energy_village__azioni_tecnico_sottoscrizione_enum". All fields are combined with logical 'AND'. */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum>;
  _in?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum>;
  _nin?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum>>;
};

/** input type for inserting data into table "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Max_Fields = {
  __typename?: 'energy_village__azioni_tecnico_sottoscrizione_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Min_Fields = {
  __typename?: 'energy_village__azioni_tecnico_sottoscrizione_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Mutation_Response = {
  __typename?: 'energy_village__azioni_tecnico_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
};

/** on_conflict condition type for table "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_On_Conflict = {
  constraint: Energy_Village__Azioni_Tecnico_Sottoscrizione_Constraint;
  update_columns?: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._azioni_tecnico_sottoscrizione". */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._azioni_tecnico_sottoscrizione */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "energy_village._azioni_tecnico_sottoscrizione" */
export enum Energy_Village__Azioni_Tecnico_Sottoscrizione_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "energy_village._azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__azioni_tecnico_sottoscrizione" */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Azioni_Tecnico_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._azioni_tecnico_sottoscrizione" */
export enum Energy_Village__Azioni_Tecnico_Sottoscrizione_Update_Column {
  /** column name */
  Text = 'text'
}

export type Energy_Village__Azioni_Tecnico_Sottoscrizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options = {
  __typename?: 'energy_village__cer_filter_options';
  value: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_Aggregate = {
  __typename?: 'energy_village__cer_filter_options_aggregate';
  aggregate?: Maybe<Energy_Village__Cer_Filter_Options_Aggregate_Fields>;
  nodes: Array<Energy_Village__Cer_Filter_Options>;
};

/** aggregate fields of "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_Aggregate_Fields = {
  __typename?: 'energy_village__cer_filter_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Cer_Filter_Options_Max_Fields>;
  min?: Maybe<Energy_Village__Cer_Filter_Options_Min_Fields>;
};


/** aggregate fields of "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._cer_filter_options". All fields are combined with a logical 'AND'. */
export type Energy_Village__Cer_Filter_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Cer_Filter_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._cer_filter_options" */
export enum Energy_Village__Cer_Filter_Options_Constraint {
  /** unique or primary key constraint on columns "value" */
  _CerFilterOptionsPkey = '_cer_filter_options_pkey'
}

export enum Energy_Village__Cer_Filter_Options_Enum {
  Alias = 'alias',
  Attiva = 'attiva',
  Iniziativa = 'iniziativa',
  Richieste = 'richieste',
  Zgse = 'zgse'
}

/** Boolean expression to compare columns of type "energy_village__cer_filter_options_enum". All fields are combined with logical 'AND'. */
export type Energy_Village__Cer_Filter_Options_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Village__Cer_Filter_Options_Enum>;
  _in?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Village__Cer_Filter_Options_Enum>;
  _nin?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Enum>>;
};

/** input type for inserting data into table "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Cer_Filter_Options_Max_Fields = {
  __typename?: 'energy_village__cer_filter_options_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Cer_Filter_Options_Min_Fields = {
  __typename?: 'energy_village__cer_filter_options_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_Mutation_Response = {
  __typename?: 'energy_village__cer_filter_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Cer_Filter_Options>;
};

/** on_conflict condition type for table "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_On_Conflict = {
  constraint: Energy_Village__Cer_Filter_Options_Constraint;
  update_columns?: Array<Energy_Village__Cer_Filter_Options_Update_Column>;
  where?: InputMaybe<Energy_Village__Cer_Filter_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._cer_filter_options". */
export type Energy_Village__Cer_Filter_Options_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._cer_filter_options */
export type Energy_Village__Cer_Filter_Options_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "energy_village._cer_filter_options" */
export enum Energy_Village__Cer_Filter_Options_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "energy_village._cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__cer_filter_options" */
export type Energy_Village__Cer_Filter_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Cer_Filter_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Cer_Filter_Options_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._cer_filter_options" */
export enum Energy_Village__Cer_Filter_Options_Update_Column {
  /** column name */
  Value = 'value'
}

export type Energy_Village__Cer_Filter_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Cer_Filter_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Cer_Filter_Options_Bool_Exp;
};

/** columns and relationships of "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer = {
  __typename?: 'energy_village__stato_cer';
  value: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer_Aggregate = {
  __typename?: 'energy_village__stato_cer_aggregate';
  aggregate?: Maybe<Energy_Village__Stato_Cer_Aggregate_Fields>;
  nodes: Array<Energy_Village__Stato_Cer>;
};

/** aggregate fields of "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer_Aggregate_Fields = {
  __typename?: 'energy_village__stato_cer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Stato_Cer_Max_Fields>;
  min?: Maybe<Energy_Village__Stato_Cer_Min_Fields>;
};


/** aggregate fields of "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Stato_Cer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._stato_cer". All fields are combined with a logical 'AND'. */
export type Energy_Village__Stato_Cer_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Stato_Cer_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Stato_Cer_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Stato_Cer_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._stato_cer" */
export enum Energy_Village__Stato_Cer_Constraint {
  /** unique or primary key constraint on columns "value" */
  _StatoCerPkey = '_stato_cer_pkey'
}

export enum Energy_Village__Stato_Cer_Enum {
  Attiva = 'attiva',
  Iniziativa = 'iniziativa',
  Zgse = 'zgse'
}

/** Boolean expression to compare columns of type "energy_village__stato_cer_enum". All fields are combined with logical 'AND'. */
export type Energy_Village__Stato_Cer_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Village__Stato_Cer_Enum>;
  _in?: InputMaybe<Array<Energy_Village__Stato_Cer_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Village__Stato_Cer_Enum>;
  _nin?: InputMaybe<Array<Energy_Village__Stato_Cer_Enum>>;
};

/** input type for inserting data into table "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Stato_Cer_Max_Fields = {
  __typename?: 'energy_village__stato_cer_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Stato_Cer_Min_Fields = {
  __typename?: 'energy_village__stato_cer_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer_Mutation_Response = {
  __typename?: 'energy_village__stato_cer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Stato_Cer>;
};

/** on_conflict condition type for table "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer_On_Conflict = {
  constraint: Energy_Village__Stato_Cer_Constraint;
  update_columns?: Array<Energy_Village__Stato_Cer_Update_Column>;
  where?: InputMaybe<Energy_Village__Stato_Cer_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._stato_cer". */
export type Energy_Village__Stato_Cer_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._stato_cer */
export type Energy_Village__Stato_Cer_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "energy_village._stato_cer" */
export enum Energy_Village__Stato_Cer_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "energy_village._stato_cer" */
export type Energy_Village__Stato_Cer_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__stato_cer" */
export type Energy_Village__Stato_Cer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Stato_Cer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Stato_Cer_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._stato_cer" */
export enum Energy_Village__Stato_Cer_Update_Column {
  /** column name */
  Value = 'value'
}

export type Energy_Village__Stato_Cer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Stato_Cer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Stato_Cer_Bool_Exp;
};

/** columns and relationships of "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione = {
  __typename?: 'energy_village__stato_sottoscrizione';
  value: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_Aggregate = {
  __typename?: 'energy_village__stato_sottoscrizione_aggregate';
  aggregate?: Maybe<Energy_Village__Stato_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Energy_Village__Stato_Sottoscrizione>;
};

/** aggregate fields of "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'energy_village__stato_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Stato_Sottoscrizione_Max_Fields>;
  min?: Maybe<Energy_Village__Stato_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._stato_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Energy_Village__Stato_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._stato_sottoscrizione" */
export enum Energy_Village__Stato_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "value" */
  _StatoSottoscrizionePkey = '_stato_sottoscrizione_pkey'
}

export enum Energy_Village__Stato_Sottoscrizione_Enum {
  AdesioneDaCompletare = 'adesione_da_completare',
  Associata = 'associata',
  Cancellata = 'cancellata',
  DaFirmare = 'da_firmare',
  DaPagare = 'da_pagare',
  DaVerificare = 'da_verificare',
  DatiPnrrDaCompletare = 'dati_pnrr_da_completare',
  DatiTecniciDaCompletare = 'dati_tecnici_da_completare',
  DisdettaRichiesta = 'disdetta_richiesta',
  InAttesaDiFirma = 'in_attesa_di_firma',
  Interessato = 'interessato',
  Inviata = 'inviata',
  InviatoAlGse = 'inviato_al_gse',
  Opzionata = 'opzionata',
  OpzioneScaduta = 'opzione_scaduta',
  ProntoPerGse = 'pronto_per_gse',
  Recessa = 'recessa',
  RecessoRichiesto = 'recesso_richiesto',
  Rifiutata = 'rifiutata',
  VerificaPnrr = 'verifica_pnrr',
  WarningAdesione = 'warning_adesione',
  WarningDatiPnrr = 'warning_dati_pnrr',
  WarningDatiTecnici = 'warning_dati_tecnici'
}

/** Boolean expression to compare columns of type "energy_village__stato_sottoscrizione_enum". All fields are combined with logical 'AND'. */
export type Energy_Village__Stato_Sottoscrizione_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Enum>;
  _in?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Enum>;
  _nin?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Enum>>;
};

/** input type for inserting data into table "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Stato_Sottoscrizione_Max_Fields = {
  __typename?: 'energy_village__stato_sottoscrizione_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Stato_Sottoscrizione_Min_Fields = {
  __typename?: 'energy_village__stato_sottoscrizione_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_Mutation_Response = {
  __typename?: 'energy_village__stato_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Stato_Sottoscrizione>;
};

/** on_conflict condition type for table "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_On_Conflict = {
  constraint: Energy_Village__Stato_Sottoscrizione_Constraint;
  update_columns?: Array<Energy_Village__Stato_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._stato_sottoscrizione". */
export type Energy_Village__Stato_Sottoscrizione_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._stato_sottoscrizione */
export type Energy_Village__Stato_Sottoscrizione_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "energy_village._stato_sottoscrizione" */
export enum Energy_Village__Stato_Sottoscrizione_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "energy_village._stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__stato_sottoscrizione" */
export type Energy_Village__Stato_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Stato_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Stato_Sottoscrizione_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._stato_sottoscrizione" */
export enum Energy_Village__Stato_Sottoscrizione_Update_Column {
  /** column name */
  Value = 'value'
}

export type Energy_Village__Stato_Sottoscrizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Stato_Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda = {
  __typename?: 'energy_village__tipo_domanda';
  value: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda_Aggregate = {
  __typename?: 'energy_village__tipo_domanda_aggregate';
  aggregate?: Maybe<Energy_Village__Tipo_Domanda_Aggregate_Fields>;
  nodes: Array<Energy_Village__Tipo_Domanda>;
};

/** aggregate fields of "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda_Aggregate_Fields = {
  __typename?: 'energy_village__tipo_domanda_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Tipo_Domanda_Max_Fields>;
  min?: Maybe<Energy_Village__Tipo_Domanda_Min_Fields>;
};


/** aggregate fields of "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._tipo_domanda". All fields are combined with a logical 'AND'. */
export type Energy_Village__Tipo_Domanda_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Tipo_Domanda_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._tipo_domanda" */
export enum Energy_Village__Tipo_Domanda_Constraint {
  /** unique or primary key constraint on columns "value" */
  _TipoDomandaPkey = '_tipo_domanda_pkey'
}

/** input type for inserting data into table "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Tipo_Domanda_Max_Fields = {
  __typename?: 'energy_village__tipo_domanda_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Tipo_Domanda_Min_Fields = {
  __typename?: 'energy_village__tipo_domanda_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda_Mutation_Response = {
  __typename?: 'energy_village__tipo_domanda_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Tipo_Domanda>;
};

/** on_conflict condition type for table "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda_On_Conflict = {
  constraint: Energy_Village__Tipo_Domanda_Constraint;
  update_columns?: Array<Energy_Village__Tipo_Domanda_Update_Column>;
  where?: InputMaybe<Energy_Village__Tipo_Domanda_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._tipo_domanda". */
export type Energy_Village__Tipo_Domanda_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._tipo_domanda */
export type Energy_Village__Tipo_Domanda_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "energy_village._tipo_domanda" */
export enum Energy_Village__Tipo_Domanda_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "energy_village._tipo_domanda" */
export type Energy_Village__Tipo_Domanda_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__tipo_domanda" */
export type Energy_Village__Tipo_Domanda_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Tipo_Domanda_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Tipo_Domanda_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._tipo_domanda" */
export enum Energy_Village__Tipo_Domanda_Update_Column {
  /** column name */
  Value = 'value'
}

export type Energy_Village__Tipo_Domanda_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Tipo_Domanda_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Tipo_Domanda_Bool_Exp;
};

/** columns and relationships of "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback = {
  __typename?: 'energy_village__tipo_feedback';
  value: Scalars['String']['output'];
};

/** aggregated selection of "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback_Aggregate = {
  __typename?: 'energy_village__tipo_feedback_aggregate';
  aggregate?: Maybe<Energy_Village__Tipo_Feedback_Aggregate_Fields>;
  nodes: Array<Energy_Village__Tipo_Feedback>;
};

/** aggregate fields of "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback_Aggregate_Fields = {
  __typename?: 'energy_village__tipo_feedback_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village__Tipo_Feedback_Max_Fields>;
  min?: Maybe<Energy_Village__Tipo_Feedback_Min_Fields>;
};


/** aggregate fields of "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village._tipo_feedback". All fields are combined with a logical 'AND'. */
export type Energy_Village__Tipo_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village__Tipo_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village._tipo_feedback" */
export enum Energy_Village__Tipo_Feedback_Constraint {
  /** unique or primary key constraint on columns "value" */
  _TipoFeedbackPkey = '_tipo_feedback_pkey'
}

export enum Energy_Village__Tipo_Feedback_Enum {
  CancellaRichiesta = 'cancella_richiesta',
  ConcludiDisdetta = 'concludi_disdetta',
  ConcludiRecesso = 'concludi_recesso',
  EliminaRichiesta = 'elimina_richiesta',
  InviaDisdetta = 'invia_disdetta',
  Recesso = 'recesso',
  Rifiuta = 'rifiuta',
  RifiutaDataTecnici = 'rifiuta_data_tecnici',
  RifiutaOpzione = 'rifiuta_opzione',
  Rigetta = 'rigetta',
  RigettaDatiPnrr = 'rigetta_dati_pnrr',
  RigettaDatiTecnici = 'rigetta_dati_tecnici'
}

/** Boolean expression to compare columns of type "energy_village__tipo_feedback_enum". All fields are combined with logical 'AND'. */
export type Energy_Village__Tipo_Feedback_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Village__Tipo_Feedback_Enum>;
  _in?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Village__Tipo_Feedback_Enum>;
  _nin?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Enum>>;
};

/** input type for inserting data into table "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village__Tipo_Feedback_Max_Fields = {
  __typename?: 'energy_village__tipo_feedback_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village__Tipo_Feedback_Min_Fields = {
  __typename?: 'energy_village__tipo_feedback_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback_Mutation_Response = {
  __typename?: 'energy_village__tipo_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village__Tipo_Feedback>;
};

/** on_conflict condition type for table "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback_On_Conflict = {
  constraint: Energy_Village__Tipo_Feedback_Constraint;
  update_columns?: Array<Energy_Village__Tipo_Feedback_Update_Column>;
  where?: InputMaybe<Energy_Village__Tipo_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village._tipo_feedback". */
export type Energy_Village__Tipo_Feedback_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village._tipo_feedback */
export type Energy_Village__Tipo_Feedback_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "energy_village._tipo_feedback" */
export enum Energy_Village__Tipo_Feedback_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "energy_village._tipo_feedback" */
export type Energy_Village__Tipo_Feedback_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_village__tipo_feedback" */
export type Energy_Village__Tipo_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village__Tipo_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village__Tipo_Feedback_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_village._tipo_feedback" */
export enum Energy_Village__Tipo_Feedback_Update_Column {
  /** column name */
  Value = 'value'
}

export type Energy_Village__Tipo_Feedback_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village__Tipo_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village__Tipo_Feedback_Bool_Exp;
};

/** columns and relationships of "energy_village.area" */
export type Energy_Village_Area = {
  __typename?: 'energy_village_area';
  /** An object relationship */
  cabina: Energy_Village_Cabina;
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['Int']['output'];
  point?: Maybe<Scalars['geometry']['output']>;
};

/** aggregated selection of "energy_village.area" */
export type Energy_Village_Area_Aggregate = {
  __typename?: 'energy_village_area_aggregate';
  aggregate?: Maybe<Energy_Village_Area_Aggregate_Fields>;
  nodes: Array<Energy_Village_Area>;
};

/** aggregate fields of "energy_village.area" */
export type Energy_Village_Area_Aggregate_Fields = {
  __typename?: 'energy_village_area_aggregate_fields';
  avg?: Maybe<Energy_Village_Area_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Area_Max_Fields>;
  min?: Maybe<Energy_Village_Area_Min_Fields>;
  stddev?: Maybe<Energy_Village_Area_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Area_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Area_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Area_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Area_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Area_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Area_Variance_Fields>;
};


/** aggregate fields of "energy_village.area" */
export type Energy_Village_Area_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Area_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Area_Avg_Fields = {
  __typename?: 'energy_village_area_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.area". All fields are combined with a logical 'AND'. */
export type Energy_Village_Area_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Area_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Area_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Area_Bool_Exp>>;
  cabina?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  point?: InputMaybe<Geometry_Comparison_Exp>;
};

/** columns and relationships of "energy_village.area_citta" */
export type Energy_Village_Area_Citta = {
  __typename?: 'energy_village_area_citta';
  cabina_ids?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  citta: Unita_Amministrativa_Citta;
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['bigint']['output'];
};


/** columns and relationships of "energy_village.area_citta" */
export type Energy_Village_Area_CittaCabina_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "energy_village.area_citta" */
export type Energy_Village_Area_Citta_Aggregate = {
  __typename?: 'energy_village_area_citta_aggregate';
  aggregate?: Maybe<Energy_Village_Area_Citta_Aggregate_Fields>;
  nodes: Array<Energy_Village_Area_Citta>;
};

/** aggregate fields of "energy_village.area_citta" */
export type Energy_Village_Area_Citta_Aggregate_Fields = {
  __typename?: 'energy_village_area_citta_aggregate_fields';
  avg?: Maybe<Energy_Village_Area_Citta_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Area_Citta_Max_Fields>;
  min?: Maybe<Energy_Village_Area_Citta_Min_Fields>;
  stddev?: Maybe<Energy_Village_Area_Citta_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Area_Citta_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Area_Citta_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Area_Citta_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Area_Citta_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Area_Citta_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Area_Citta_Variance_Fields>;
};


/** aggregate fields of "energy_village.area_citta" */
export type Energy_Village_Area_Citta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Area_Citta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Area_Citta_Append_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Area_Citta_Avg_Fields = {
  __typename?: 'energy_village_area_citta_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.area_citta". All fields are combined with a logical 'AND'. */
export type Energy_Village_Area_Citta_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Area_Citta_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Area_Citta_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Area_Citta_Bool_Exp>>;
  cabina_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.area_citta" */
export enum Energy_Village_Area_Citta_Constraint {
  /** unique or primary key constraint on columns "id" */
  AreaCittaPkey = 'area_citta_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Energy_Village_Area_Citta_Delete_At_Path_Input = {
  cabina_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Energy_Village_Area_Citta_Delete_Elem_Input = {
  cabina_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Energy_Village_Area_Citta_Delete_Key_Input = {
  cabina_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "energy_village.area_citta" */
export type Energy_Village_Area_Citta_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "energy_village.area_citta" */
export type Energy_Village_Area_Citta_Insert_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Obj_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Area_Citta_Max_Fields = {
  __typename?: 'energy_village_area_citta_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Area_Citta_Min_Fields = {
  __typename?: 'energy_village_area_citta_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "energy_village.area_citta" */
export type Energy_Village_Area_Citta_Mutation_Response = {
  __typename?: 'energy_village_area_citta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Area_Citta>;
};

/** on_conflict condition type for table "energy_village.area_citta" */
export type Energy_Village_Area_Citta_On_Conflict = {
  constraint: Energy_Village_Area_Citta_Constraint;
  update_columns?: Array<Energy_Village_Area_Citta_Update_Column>;
  where?: InputMaybe<Energy_Village_Area_Citta_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.area_citta". */
export type Energy_Village_Area_Citta_Order_By = {
  cabina_ids?: InputMaybe<Order_By>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.area_citta */
export type Energy_Village_Area_Citta_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Area_Citta_Prepend_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "energy_village.area_citta" */
export enum Energy_Village_Area_Citta_Select_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "energy_village.area_citta" */
export type Energy_Village_Area_Citta_Set_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Area_Citta_Stddev_Fields = {
  __typename?: 'energy_village_area_citta_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Area_Citta_Stddev_Pop_Fields = {
  __typename?: 'energy_village_area_citta_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Area_Citta_Stddev_Samp_Fields = {
  __typename?: 'energy_village_area_citta_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_area_citta" */
export type Energy_Village_Area_Citta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Area_Citta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Area_Citta_Stream_Cursor_Value_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Area_Citta_Sum_Fields = {
  __typename?: 'energy_village_area_citta_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "energy_village.area_citta" */
export enum Energy_Village_Area_Citta_Update_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

export type Energy_Village_Area_Citta_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Energy_Village_Area_Citta_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Energy_Village_Area_Citta_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Energy_Village_Area_Citta_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Energy_Village_Area_Citta_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Area_Citta_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Energy_Village_Area_Citta_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Area_Citta_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Area_Citta_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Area_Citta_Var_Pop_Fields = {
  __typename?: 'energy_village_area_citta_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Area_Citta_Var_Samp_Fields = {
  __typename?: 'energy_village_area_citta_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Area_Citta_Variance_Fields = {
  __typename?: 'energy_village_area_citta_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "energy_village.area" */
export enum Energy_Village_Area_Constraint {
  /** unique or primary key constraint on columns "id" */
  AreaPkey = 'area_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.area" */
export type Energy_Village_Area_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.area" */
export type Energy_Village_Area_Insert_Input = {
  cabina?: InputMaybe<Energy_Village_Cabina_Obj_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  point?: InputMaybe<Scalars['geometry']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Area_Max_Fields = {
  __typename?: 'energy_village_area_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Area_Min_Fields = {
  __typename?: 'energy_village_area_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "energy_village.area" */
export type Energy_Village_Area_Mutation_Response = {
  __typename?: 'energy_village_area_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Area>;
};

/** input type for inserting object relation for remote table "energy_village.area" */
export type Energy_Village_Area_Obj_Rel_Insert_Input = {
  data: Energy_Village_Area_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Area_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.area" */
export type Energy_Village_Area_On_Conflict = {
  constraint: Energy_Village_Area_Constraint;
  update_columns?: Array<Energy_Village_Area_Update_Column>;
  where?: InputMaybe<Energy_Village_Area_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.area". */
export type Energy_Village_Area_Order_By = {
  cabina?: InputMaybe<Energy_Village_Cabina_Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.area */
export type Energy_Village_Area_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** columns and relationships of "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia = {
  __typename?: 'energy_village_area_provincia';
  cabina_ids: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  provincia: Unita_Amministrativa_Provincia;
};


/** columns and relationships of "energy_village.area_provincia" */
export type Energy_Village_Area_ProvinciaCabina_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_Aggregate = {
  __typename?: 'energy_village_area_provincia_aggregate';
  aggregate?: Maybe<Energy_Village_Area_Provincia_Aggregate_Fields>;
  nodes: Array<Energy_Village_Area_Provincia>;
};

/** aggregate fields of "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_Aggregate_Fields = {
  __typename?: 'energy_village_area_provincia_aggregate_fields';
  avg?: Maybe<Energy_Village_Area_Provincia_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Area_Provincia_Max_Fields>;
  min?: Maybe<Energy_Village_Area_Provincia_Min_Fields>;
  stddev?: Maybe<Energy_Village_Area_Provincia_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Area_Provincia_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Area_Provincia_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Area_Provincia_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Area_Provincia_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Area_Provincia_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Area_Provincia_Variance_Fields>;
};


/** aggregate fields of "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Area_Provincia_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Area_Provincia_Append_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Area_Provincia_Avg_Fields = {
  __typename?: 'energy_village_area_provincia_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.area_provincia". All fields are combined with a logical 'AND'. */
export type Energy_Village_Area_Provincia_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Area_Provincia_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Area_Provincia_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Area_Provincia_Bool_Exp>>;
  cabina_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};

/** unique or primary key constraints on table "energy_village.area_provincia" */
export enum Energy_Village_Area_Provincia_Constraint {
  /** unique or primary key constraint on columns "id" */
  AreaProvinciaPkey = 'area_provincia_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Energy_Village_Area_Provincia_Delete_At_Path_Input = {
  cabina_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Energy_Village_Area_Provincia_Delete_Elem_Input = {
  cabina_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Energy_Village_Area_Provincia_Delete_Key_Input = {
  cabina_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_Insert_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Energy_Village_Area_Provincia_Max_Fields = {
  __typename?: 'energy_village_area_provincia_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Area_Provincia_Min_Fields = {
  __typename?: 'energy_village_area_provincia_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_Mutation_Response = {
  __typename?: 'energy_village_area_provincia_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Area_Provincia>;
};

/** on_conflict condition type for table "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_On_Conflict = {
  constraint: Energy_Village_Area_Provincia_Constraint;
  update_columns?: Array<Energy_Village_Area_Provincia_Update_Column>;
  where?: InputMaybe<Energy_Village_Area_Provincia_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.area_provincia". */
export type Energy_Village_Area_Provincia_Order_By = {
  cabina_ids?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Order_By>;
};

/** primary key columns input for table: energy_village.area_provincia */
export type Energy_Village_Area_Provincia_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Area_Provincia_Prepend_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "energy_village.area_provincia" */
export enum Energy_Village_Area_Provincia_Select_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "energy_village.area_provincia" */
export type Energy_Village_Area_Provincia_Set_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Area_Provincia_Stddev_Fields = {
  __typename?: 'energy_village_area_provincia_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Area_Provincia_Stddev_Pop_Fields = {
  __typename?: 'energy_village_area_provincia_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Area_Provincia_Stddev_Samp_Fields = {
  __typename?: 'energy_village_area_provincia_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_area_provincia" */
export type Energy_Village_Area_Provincia_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Area_Provincia_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Area_Provincia_Stream_Cursor_Value_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Area_Provincia_Sum_Fields = {
  __typename?: 'energy_village_area_provincia_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "energy_village.area_provincia" */
export enum Energy_Village_Area_Provincia_Update_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

export type Energy_Village_Area_Provincia_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Energy_Village_Area_Provincia_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Energy_Village_Area_Provincia_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Energy_Village_Area_Provincia_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Energy_Village_Area_Provincia_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Area_Provincia_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Energy_Village_Area_Provincia_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Area_Provincia_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Area_Provincia_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Area_Provincia_Var_Pop_Fields = {
  __typename?: 'energy_village_area_provincia_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Area_Provincia_Var_Samp_Fields = {
  __typename?: 'energy_village_area_provincia_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Area_Provincia_Variance_Fields = {
  __typename?: 'energy_village_area_provincia_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "energy_village.area_regione" */
export type Energy_Village_Area_Regione = {
  __typename?: 'energy_village_area_regione';
  cabina_ids: Scalars['jsonb']['output'];
  citta_ids?: Maybe<Scalars['jsonb']['output']>;
  geom: Scalars['geometry']['output'];
  id: Scalars['bigint']['output'];
  provincia_ids?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  regione: Unita_Amministrativa_Regione;
};


/** columns and relationships of "energy_village.area_regione" */
export type Energy_Village_Area_RegioneCabina_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "energy_village.area_regione" */
export type Energy_Village_Area_RegioneCitta_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "energy_village.area_regione" */
export type Energy_Village_Area_RegioneProvincia_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "energy_village.area_regione" */
export type Energy_Village_Area_Regione_Aggregate = {
  __typename?: 'energy_village_area_regione_aggregate';
  aggregate?: Maybe<Energy_Village_Area_Regione_Aggregate_Fields>;
  nodes: Array<Energy_Village_Area_Regione>;
};

/** aggregate fields of "energy_village.area_regione" */
export type Energy_Village_Area_Regione_Aggregate_Fields = {
  __typename?: 'energy_village_area_regione_aggregate_fields';
  avg?: Maybe<Energy_Village_Area_Regione_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Area_Regione_Max_Fields>;
  min?: Maybe<Energy_Village_Area_Regione_Min_Fields>;
  stddev?: Maybe<Energy_Village_Area_Regione_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Area_Regione_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Area_Regione_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Area_Regione_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Area_Regione_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Area_Regione_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Area_Regione_Variance_Fields>;
};


/** aggregate fields of "energy_village.area_regione" */
export type Energy_Village_Area_Regione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Area_Regione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Area_Regione_Append_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  citta_ids?: InputMaybe<Scalars['jsonb']['input']>;
  provincia_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Area_Regione_Avg_Fields = {
  __typename?: 'energy_village_area_regione_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.area_regione". All fields are combined with a logical 'AND'. */
export type Energy_Village_Area_Regione_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Area_Regione_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Area_Regione_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Area_Regione_Bool_Exp>>;
  cabina_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  citta_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  provincia_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  regione?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
};

/** unique or primary key constraints on table "energy_village.area_regione" */
export enum Energy_Village_Area_Regione_Constraint {
  /** unique or primary key constraint on columns "id" */
  AreaRegionePkey = 'area_regione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Energy_Village_Area_Regione_Delete_At_Path_Input = {
  cabina_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  citta_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  provincia_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Energy_Village_Area_Regione_Delete_Elem_Input = {
  cabina_ids?: InputMaybe<Scalars['Int']['input']>;
  citta_ids?: InputMaybe<Scalars['Int']['input']>;
  provincia_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Energy_Village_Area_Regione_Delete_Key_Input = {
  cabina_ids?: InputMaybe<Scalars['String']['input']>;
  citta_ids?: InputMaybe<Scalars['String']['input']>;
  provincia_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "energy_village.area_regione" */
export type Energy_Village_Area_Regione_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "energy_village.area_regione" */
export type Energy_Village_Area_Regione_Insert_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  citta_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia_ids?: InputMaybe<Scalars['jsonb']['input']>;
  regione?: InputMaybe<Unita_Amministrativa_Regione_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Energy_Village_Area_Regione_Max_Fields = {
  __typename?: 'energy_village_area_regione_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Area_Regione_Min_Fields = {
  __typename?: 'energy_village_area_regione_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "energy_village.area_regione" */
export type Energy_Village_Area_Regione_Mutation_Response = {
  __typename?: 'energy_village_area_regione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Area_Regione>;
};

/** on_conflict condition type for table "energy_village.area_regione" */
export type Energy_Village_Area_Regione_On_Conflict = {
  constraint: Energy_Village_Area_Regione_Constraint;
  update_columns?: Array<Energy_Village_Area_Regione_Update_Column>;
  where?: InputMaybe<Energy_Village_Area_Regione_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.area_regione". */
export type Energy_Village_Area_Regione_Order_By = {
  cabina_ids?: InputMaybe<Order_By>;
  citta_ids?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_ids?: InputMaybe<Order_By>;
  regione?: InputMaybe<Unita_Amministrativa_Regione_Order_By>;
};

/** primary key columns input for table: energy_village.area_regione */
export type Energy_Village_Area_Regione_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Area_Regione_Prepend_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  citta_ids?: InputMaybe<Scalars['jsonb']['input']>;
  provincia_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "energy_village.area_regione" */
export enum Energy_Village_Area_Regione_Select_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  CittaIds = 'citta_ids',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  ProvinciaIds = 'provincia_ids'
}

/** input type for updating data in table "energy_village.area_regione" */
export type Energy_Village_Area_Regione_Set_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  citta_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Area_Regione_Stddev_Fields = {
  __typename?: 'energy_village_area_regione_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Area_Regione_Stddev_Pop_Fields = {
  __typename?: 'energy_village_area_regione_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Area_Regione_Stddev_Samp_Fields = {
  __typename?: 'energy_village_area_regione_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_area_regione" */
export type Energy_Village_Area_Regione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Area_Regione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Area_Regione_Stream_Cursor_Value_Input = {
  cabina_ids?: InputMaybe<Scalars['jsonb']['input']>;
  citta_ids?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Area_Regione_Sum_Fields = {
  __typename?: 'energy_village_area_regione_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "energy_village.area_regione" */
export enum Energy_Village_Area_Regione_Update_Column {
  /** column name */
  CabinaIds = 'cabina_ids',
  /** column name */
  CittaIds = 'citta_ids',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  ProvinciaIds = 'provincia_ids'
}

export type Energy_Village_Area_Regione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Energy_Village_Area_Regione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Energy_Village_Area_Regione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Energy_Village_Area_Regione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Energy_Village_Area_Regione_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Area_Regione_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Energy_Village_Area_Regione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Area_Regione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Area_Regione_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Area_Regione_Var_Pop_Fields = {
  __typename?: 'energy_village_area_regione_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Area_Regione_Var_Samp_Fields = {
  __typename?: 'energy_village_area_regione_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Area_Regione_Variance_Fields = {
  __typename?: 'energy_village_area_regione_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "energy_village.area" */
export enum Energy_Village_Area_Select_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Point = 'point'
}

/** input type for updating data in table "energy_village.area" */
export type Energy_Village_Area_Set_Input = {
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  point?: InputMaybe<Scalars['geometry']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Area_Stddev_Fields = {
  __typename?: 'energy_village_area_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Area_Stddev_Pop_Fields = {
  __typename?: 'energy_village_area_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Area_Stddev_Samp_Fields = {
  __typename?: 'energy_village_area_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_area" */
export type Energy_Village_Area_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Area_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Area_Stream_Cursor_Value_Input = {
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  point?: InputMaybe<Scalars['geometry']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Area_Sum_Fields = {
  __typename?: 'energy_village_area_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "energy_village.area" */
export enum Energy_Village_Area_Update_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Point = 'point'
}

export type Energy_Village_Area_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Area_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Area_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Area_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Area_Var_Pop_Fields = {
  __typename?: 'energy_village_area_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Area_Var_Samp_Fields = {
  __typename?: 'energy_village_area_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Area_Variance_Fields = {
  __typename?: 'energy_village_area_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "energy_village.azioni" */
export type Energy_Village_Azioni = {
  __typename?: 'energy_village_azioni';
  founder: Energy_Village__Azioni_Founder_Sottoscrizione_Enum;
  prosumer: Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum;
  tecnico: Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum;
};

/** aggregated selection of "energy_village.azioni" */
export type Energy_Village_Azioni_Aggregate = {
  __typename?: 'energy_village_azioni_aggregate';
  aggregate?: Maybe<Energy_Village_Azioni_Aggregate_Fields>;
  nodes: Array<Energy_Village_Azioni>;
};

/** aggregate fields of "energy_village.azioni" */
export type Energy_Village_Azioni_Aggregate_Fields = {
  __typename?: 'energy_village_azioni_aggregate_fields';
  count: Scalars['Int']['output'];
};


/** aggregate fields of "energy_village.azioni" */
export type Energy_Village_Azioni_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Azioni_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village.azioni". All fields are combined with a logical 'AND'. */
export type Energy_Village_Azioni_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Azioni_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Azioni_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Azioni_Bool_Exp>>;
  founder?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Enum_Comparison_Exp>;
  prosumer?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum_Comparison_Exp>;
  tecnico?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.azioni" */
export enum Energy_Village_Azioni_Constraint {
  /** unique or primary key constraint on columns "founder", "prosumer", "tecnico" */
  AzioniPkey = 'azioni_pkey'
}

/** input type for inserting data into table "energy_village.azioni" */
export type Energy_Village_Azioni_Insert_Input = {
  founder?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Enum>;
  prosumer?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum>;
  tecnico?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum>;
};

/** response of any mutation on the table "energy_village.azioni" */
export type Energy_Village_Azioni_Mutation_Response = {
  __typename?: 'energy_village_azioni_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Azioni>;
};

/** on_conflict condition type for table "energy_village.azioni" */
export type Energy_Village_Azioni_On_Conflict = {
  constraint: Energy_Village_Azioni_Constraint;
  update_columns?: Array<Energy_Village_Azioni_Update_Column>;
  where?: InputMaybe<Energy_Village_Azioni_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.azioni". */
export type Energy_Village_Azioni_Order_By = {
  founder?: InputMaybe<Order_By>;
  prosumer?: InputMaybe<Order_By>;
  tecnico?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.azioni */
export type Energy_Village_Azioni_Pk_Columns_Input = {
  founder: Energy_Village__Azioni_Founder_Sottoscrizione_Enum;
  prosumer: Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum;
  tecnico: Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum;
};

/** select columns of table "energy_village.azioni" */
export enum Energy_Village_Azioni_Select_Column {
  /** column name */
  Founder = 'founder',
  /** column name */
  Prosumer = 'prosumer',
  /** column name */
  Tecnico = 'tecnico'
}

/** input type for updating data in table "energy_village.azioni" */
export type Energy_Village_Azioni_Set_Input = {
  founder?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Enum>;
  prosumer?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum>;
  tecnico?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum>;
};

/** Streaming cursor of the table "energy_village_azioni" */
export type Energy_Village_Azioni_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Azioni_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Azioni_Stream_Cursor_Value_Input = {
  founder?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Enum>;
  prosumer?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum>;
  tecnico?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum>;
};

/** update columns of table "energy_village.azioni" */
export enum Energy_Village_Azioni_Update_Column {
  /** column name */
  Founder = 'founder',
  /** column name */
  Prosumer = 'prosumer',
  /** column name */
  Tecnico = 'tecnico'
}

export type Energy_Village_Azioni_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Azioni_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Azioni_Bool_Exp;
};

/** columns and relationships of "energy_village.cabina" */
export type Energy_Village_Cabina = {
  __typename?: 'energy_village_cabina';
  /** An object relationship */
  area?: Maybe<Energy_Village_Area>;
  /** An array relationship */
  assets: Array<Asset>;
  /** An aggregate relationship */
  assets_aggregate: Asset_Aggregate;
  /** An array relationship */
  cers: Array<Cer_Cabina>;
  /** An aggregate relationship */
  cers_aggregate: Cer_Cabina_Aggregate;
  /** An array relationship */
  citta: Array<Energy_Village_Cabina_Citta>;
  /** An aggregate relationship */
  citta_aggregate: Energy_Village_Cabina_Citta_Aggregate;
  cod_ac?: Maybe<Scalars['String']['output']>;
  cod_cons_1?: Maybe<Scalars['String']['output']>;
  cod_conseg?: Maybe<Scalars['String']['output']>;
  elenco_citta?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  p_cab_pri?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  potenzialita?: Maybe<Energy_Village_Potenzialita_Cabina>;
  rag_soc?: Maybe<Scalars['String']['output']>;
  rag_soc_1?: Maybe<Scalars['String']['output']>;
  t_cab_pri?: Maybe<Scalars['String']['output']>;
  txt1?: Maybe<Scalars['String']['output']>;
  txt1_1?: Maybe<Scalars['String']['output']>;
  txt2?: Maybe<Scalars['String']['output']>;
  txt2_1?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "energy_village.cabina" */
export type Energy_Village_CabinaAssetsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


/** columns and relationships of "energy_village.cabina" */
export type Energy_Village_CabinaAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


/** columns and relationships of "energy_village.cabina" */
export type Energy_Village_CabinaCersArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


/** columns and relationships of "energy_village.cabina" */
export type Energy_Village_CabinaCers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


/** columns and relationships of "energy_village.cabina" */
export type Energy_Village_CabinaCittaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};


/** columns and relationships of "energy_village.cabina" */
export type Energy_Village_CabinaCitta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};

/** aggregated selection of "energy_village.cabina" */
export type Energy_Village_Cabina_Aggregate = {
  __typename?: 'energy_village_cabina_aggregate';
  aggregate?: Maybe<Energy_Village_Cabina_Aggregate_Fields>;
  nodes: Array<Energy_Village_Cabina>;
};

/** aggregate fields of "energy_village.cabina" */
export type Energy_Village_Cabina_Aggregate_Fields = {
  __typename?: 'energy_village_cabina_aggregate_fields';
  avg?: Maybe<Energy_Village_Cabina_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Cabina_Max_Fields>;
  min?: Maybe<Energy_Village_Cabina_Min_Fields>;
  stddev?: Maybe<Energy_Village_Cabina_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Cabina_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Cabina_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Cabina_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Cabina_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Cabina_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Cabina_Variance_Fields>;
};


/** aggregate fields of "energy_village.cabina" */
export type Energy_Village_Cabina_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Cabina_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Cabina_Avg_Fields = {
  __typename?: 'energy_village_cabina_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.cabina". All fields are combined with a logical 'AND'. */
export type Energy_Village_Cabina_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Cabina_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Cabina_Bool_Exp>>;
  area?: InputMaybe<Energy_Village_Area_Bool_Exp>;
  assets?: InputMaybe<Asset_Bool_Exp>;
  assets_aggregate?: InputMaybe<Asset_Aggregate_Bool_Exp>;
  cers?: InputMaybe<Cer_Cabina_Bool_Exp>;
  cers_aggregate?: InputMaybe<Cer_Cabina_Aggregate_Bool_Exp>;
  citta?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
  citta_aggregate?: InputMaybe<Energy_Village_Cabina_Citta_Aggregate_Bool_Exp>;
  cod_ac?: InputMaybe<String_Comparison_Exp>;
  cod_cons_1?: InputMaybe<String_Comparison_Exp>;
  cod_conseg?: InputMaybe<String_Comparison_Exp>;
  elenco_citta?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  p_cab_pri?: InputMaybe<String_Comparison_Exp>;
  potenzialita?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
  rag_soc?: InputMaybe<String_Comparison_Exp>;
  rag_soc_1?: InputMaybe<String_Comparison_Exp>;
  t_cab_pri?: InputMaybe<String_Comparison_Exp>;
  txt1?: InputMaybe<String_Comparison_Exp>;
  txt1_1?: InputMaybe<String_Comparison_Exp>;
  txt2?: InputMaybe<String_Comparison_Exp>;
  txt2_1?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta = {
  __typename?: 'energy_village_cabina_citta';
  /** An object relationship */
  cabina: Energy_Village_Cabina;
  cabina_id: Scalars['Int']['output'];
  /** An object relationship */
  citta: Unita_Amministrativa_Citta;
  citta_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Aggregate = {
  __typename?: 'energy_village_cabina_citta_aggregate';
  aggregate?: Maybe<Energy_Village_Cabina_Citta_Aggregate_Fields>;
  nodes: Array<Energy_Village_Cabina_Citta>;
};

export type Energy_Village_Cabina_Citta_Aggregate_Bool_Exp = {
  count?: InputMaybe<Energy_Village_Cabina_Citta_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Cabina_Citta_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Aggregate_Fields = {
  __typename?: 'energy_village_cabina_citta_aggregate_fields';
  avg?: Maybe<Energy_Village_Cabina_Citta_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Cabina_Citta_Max_Fields>;
  min?: Maybe<Energy_Village_Cabina_Citta_Min_Fields>;
  stddev?: Maybe<Energy_Village_Cabina_Citta_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Cabina_Citta_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Cabina_Citta_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Cabina_Citta_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Cabina_Citta_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Cabina_Citta_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Cabina_Citta_Variance_Fields>;
};


/** aggregate fields of "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Cabina_Citta_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Cabina_Citta_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Cabina_Citta_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Cabina_Citta_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Cabina_Citta_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Cabina_Citta_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Cabina_Citta_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Cabina_Citta_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Cabina_Citta_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Cabina_Citta_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Cabina_Citta_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Cabina_Citta_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Cabina_Citta_Avg_Fields = {
  __typename?: 'energy_village_cabina_citta_avg_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Avg_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.cabina_citta". All fields are combined with a logical 'AND'. */
export type Energy_Village_Cabina_Citta_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Cabina_Citta_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Cabina_Citta_Bool_Exp>>;
  cabina?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
  cabina_id?: InputMaybe<Int_Comparison_Exp>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  citta_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.cabina_citta" */
export enum Energy_Village_Cabina_Citta_Constraint {
  /** unique or primary key constraint on columns "id" */
  CabinaCittaPkey = 'cabina_citta_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Inc_Input = {
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  citta_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Insert_Input = {
  cabina?: InputMaybe<Energy_Village_Cabina_Obj_Rel_Insert_Input>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Obj_Rel_Insert_Input>;
  citta_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Cabina_Citta_Max_Fields = {
  __typename?: 'energy_village_cabina_citta_max_fields';
  cabina_id?: Maybe<Scalars['Int']['output']>;
  citta_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Max_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Cabina_Citta_Min_Fields = {
  __typename?: 'energy_village_cabina_citta_min_fields';
  cabina_id?: Maybe<Scalars['Int']['output']>;
  citta_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Min_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Mutation_Response = {
  __typename?: 'energy_village_cabina_citta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Cabina_Citta>;
};

/** on_conflict condition type for table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_On_Conflict = {
  constraint: Energy_Village_Cabina_Citta_Constraint;
  update_columns?: Array<Energy_Village_Cabina_Citta_Update_Column>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.cabina_citta". */
export type Energy_Village_Cabina_Citta_Order_By = {
  cabina?: InputMaybe<Energy_Village_Cabina_Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Order_By>;
  citta_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.cabina_citta */
export type Energy_Village_Cabina_Citta_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.cabina_citta" */
export enum Energy_Village_Cabina_Citta_Select_Column {
  /** column name */
  CabinaId = 'cabina_id',
  /** column name */
  CittaId = 'citta_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Set_Input = {
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  citta_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Cabina_Citta_Stddev_Fields = {
  __typename?: 'energy_village_cabina_citta_stddev_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Stddev_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Cabina_Citta_Stddev_Pop_Fields = {
  __typename?: 'energy_village_cabina_citta_stddev_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Stddev_Pop_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Cabina_Citta_Stddev_Samp_Fields = {
  __typename?: 'energy_village_cabina_citta_stddev_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Stddev_Samp_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_cabina_citta" */
export type Energy_Village_Cabina_Citta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Cabina_Citta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Cabina_Citta_Stream_Cursor_Value_Input = {
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  citta_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Cabina_Citta_Sum_Fields = {
  __typename?: 'energy_village_cabina_citta_sum_fields';
  cabina_id?: Maybe<Scalars['Int']['output']>;
  citta_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Sum_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.cabina_citta" */
export enum Energy_Village_Cabina_Citta_Update_Column {
  /** column name */
  CabinaId = 'cabina_id',
  /** column name */
  CittaId = 'citta_id',
  /** column name */
  Id = 'id'
}

export type Energy_Village_Cabina_Citta_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Cabina_Citta_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Cabina_Citta_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Cabina_Citta_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Cabina_Citta_Var_Pop_Fields = {
  __typename?: 'energy_village_cabina_citta_var_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Var_Pop_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Cabina_Citta_Var_Samp_Fields = {
  __typename?: 'energy_village_cabina_citta_var_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Var_Samp_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Cabina_Citta_Variance_Fields = {
  __typename?: 'energy_village_cabina_citta_variance_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.cabina_citta" */
export type Energy_Village_Cabina_Citta_Variance_Order_By = {
  cabina_id?: InputMaybe<Order_By>;
  citta_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "energy_village.cabina" */
export enum Energy_Village_Cabina_Constraint {
  /** unique or primary key constraint on columns "id" */
  CabinaPkey = 'cabina_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.cabina" */
export type Energy_Village_Cabina_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.cabina" */
export type Energy_Village_Cabina_Insert_Input = {
  area?: InputMaybe<Energy_Village_Area_Obj_Rel_Insert_Input>;
  assets?: InputMaybe<Asset_Arr_Rel_Insert_Input>;
  cers?: InputMaybe<Cer_Cabina_Arr_Rel_Insert_Input>;
  citta?: InputMaybe<Energy_Village_Cabina_Citta_Arr_Rel_Insert_Input>;
  cod_ac?: InputMaybe<Scalars['String']['input']>;
  cod_cons_1?: InputMaybe<Scalars['String']['input']>;
  cod_conseg?: InputMaybe<Scalars['String']['input']>;
  elenco_citta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  p_cab_pri?: InputMaybe<Scalars['String']['input']>;
  potenzialita?: InputMaybe<Energy_Village_Potenzialita_Cabina_Obj_Rel_Insert_Input>;
  rag_soc?: InputMaybe<Scalars['String']['input']>;
  rag_soc_1?: InputMaybe<Scalars['String']['input']>;
  t_cab_pri?: InputMaybe<Scalars['String']['input']>;
  txt1?: InputMaybe<Scalars['String']['input']>;
  txt1_1?: InputMaybe<Scalars['String']['input']>;
  txt2?: InputMaybe<Scalars['String']['input']>;
  txt2_1?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Cabina_Max_Fields = {
  __typename?: 'energy_village_cabina_max_fields';
  cod_ac?: Maybe<Scalars['String']['output']>;
  cod_cons_1?: Maybe<Scalars['String']['output']>;
  cod_conseg?: Maybe<Scalars['String']['output']>;
  elenco_citta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  p_cab_pri?: Maybe<Scalars['String']['output']>;
  rag_soc?: Maybe<Scalars['String']['output']>;
  rag_soc_1?: Maybe<Scalars['String']['output']>;
  t_cab_pri?: Maybe<Scalars['String']['output']>;
  txt1?: Maybe<Scalars['String']['output']>;
  txt1_1?: Maybe<Scalars['String']['output']>;
  txt2?: Maybe<Scalars['String']['output']>;
  txt2_1?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Cabina_Min_Fields = {
  __typename?: 'energy_village_cabina_min_fields';
  cod_ac?: Maybe<Scalars['String']['output']>;
  cod_cons_1?: Maybe<Scalars['String']['output']>;
  cod_conseg?: Maybe<Scalars['String']['output']>;
  elenco_citta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  p_cab_pri?: Maybe<Scalars['String']['output']>;
  rag_soc?: Maybe<Scalars['String']['output']>;
  rag_soc_1?: Maybe<Scalars['String']['output']>;
  t_cab_pri?: Maybe<Scalars['String']['output']>;
  txt1?: Maybe<Scalars['String']['output']>;
  txt1_1?: Maybe<Scalars['String']['output']>;
  txt2?: Maybe<Scalars['String']['output']>;
  txt2_1?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_village.cabina" */
export type Energy_Village_Cabina_Mutation_Response = {
  __typename?: 'energy_village_cabina_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Cabina>;
};

/** input type for inserting object relation for remote table "energy_village.cabina" */
export type Energy_Village_Cabina_Obj_Rel_Insert_Input = {
  data: Energy_Village_Cabina_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Cabina_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.cabina" */
export type Energy_Village_Cabina_On_Conflict = {
  constraint: Energy_Village_Cabina_Constraint;
  update_columns?: Array<Energy_Village_Cabina_Update_Column>;
  where?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.cabina". */
export type Energy_Village_Cabina_Order_By = {
  area?: InputMaybe<Energy_Village_Area_Order_By>;
  assets_aggregate?: InputMaybe<Asset_Aggregate_Order_By>;
  cers_aggregate?: InputMaybe<Cer_Cabina_Aggregate_Order_By>;
  citta_aggregate?: InputMaybe<Energy_Village_Cabina_Citta_Aggregate_Order_By>;
  cod_ac?: InputMaybe<Order_By>;
  cod_cons_1?: InputMaybe<Order_By>;
  cod_conseg?: InputMaybe<Order_By>;
  elenco_citta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p_cab_pri?: InputMaybe<Order_By>;
  potenzialita?: InputMaybe<Energy_Village_Potenzialita_Cabina_Order_By>;
  rag_soc?: InputMaybe<Order_By>;
  rag_soc_1?: InputMaybe<Order_By>;
  t_cab_pri?: InputMaybe<Order_By>;
  txt1?: InputMaybe<Order_By>;
  txt1_1?: InputMaybe<Order_By>;
  txt2?: InputMaybe<Order_By>;
  txt2_1?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.cabina */
export type Energy_Village_Cabina_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "energy_village.cabina" */
export enum Energy_Village_Cabina_Select_Column {
  /** column name */
  CodAc = 'cod_ac',
  /** column name */
  CodCons1 = 'cod_cons_1',
  /** column name */
  CodConseg = 'cod_conseg',
  /** column name */
  ElencoCitta = 'elenco_citta',
  /** column name */
  Id = 'id',
  /** column name */
  PCabPri = 'p_cab_pri',
  /** column name */
  RagSoc = 'rag_soc',
  /** column name */
  RagSoc1 = 'rag_soc_1',
  /** column name */
  TCabPri = 't_cab_pri',
  /** column name */
  Txt1 = 'txt1',
  /** column name */
  Txt11 = 'txt1_1',
  /** column name */
  Txt2 = 'txt2',
  /** column name */
  Txt21 = 'txt2_1'
}

/** input type for updating data in table "energy_village.cabina" */
export type Energy_Village_Cabina_Set_Input = {
  cod_ac?: InputMaybe<Scalars['String']['input']>;
  cod_cons_1?: InputMaybe<Scalars['String']['input']>;
  cod_conseg?: InputMaybe<Scalars['String']['input']>;
  elenco_citta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  p_cab_pri?: InputMaybe<Scalars['String']['input']>;
  rag_soc?: InputMaybe<Scalars['String']['input']>;
  rag_soc_1?: InputMaybe<Scalars['String']['input']>;
  t_cab_pri?: InputMaybe<Scalars['String']['input']>;
  txt1?: InputMaybe<Scalars['String']['input']>;
  txt1_1?: InputMaybe<Scalars['String']['input']>;
  txt2?: InputMaybe<Scalars['String']['input']>;
  txt2_1?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Cabina_Stddev_Fields = {
  __typename?: 'energy_village_cabina_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Cabina_Stddev_Pop_Fields = {
  __typename?: 'energy_village_cabina_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Cabina_Stddev_Samp_Fields = {
  __typename?: 'energy_village_cabina_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_cabina" */
export type Energy_Village_Cabina_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Cabina_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Cabina_Stream_Cursor_Value_Input = {
  cod_ac?: InputMaybe<Scalars['String']['input']>;
  cod_cons_1?: InputMaybe<Scalars['String']['input']>;
  cod_conseg?: InputMaybe<Scalars['String']['input']>;
  elenco_citta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  p_cab_pri?: InputMaybe<Scalars['String']['input']>;
  rag_soc?: InputMaybe<Scalars['String']['input']>;
  rag_soc_1?: InputMaybe<Scalars['String']['input']>;
  t_cab_pri?: InputMaybe<Scalars['String']['input']>;
  txt1?: InputMaybe<Scalars['String']['input']>;
  txt1_1?: InputMaybe<Scalars['String']['input']>;
  txt2?: InputMaybe<Scalars['String']['input']>;
  txt2_1?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Cabina_Sum_Fields = {
  __typename?: 'energy_village_cabina_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "energy_village.cabina" */
export enum Energy_Village_Cabina_Update_Column {
  /** column name */
  CodAc = 'cod_ac',
  /** column name */
  CodCons1 = 'cod_cons_1',
  /** column name */
  CodConseg = 'cod_conseg',
  /** column name */
  ElencoCitta = 'elenco_citta',
  /** column name */
  Id = 'id',
  /** column name */
  PCabPri = 'p_cab_pri',
  /** column name */
  RagSoc = 'rag_soc',
  /** column name */
  RagSoc1 = 'rag_soc_1',
  /** column name */
  TCabPri = 't_cab_pri',
  /** column name */
  Txt1 = 'txt1',
  /** column name */
  Txt11 = 'txt1_1',
  /** column name */
  Txt2 = 'txt2',
  /** column name */
  Txt21 = 'txt2_1'
}

export type Energy_Village_Cabina_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Cabina_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Cabina_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Cabina_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Cabina_Var_Pop_Fields = {
  __typename?: 'energy_village_cabina_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Cabina_Var_Samp_Fields = {
  __typename?: 'energy_village_cabina_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Cabina_Variance_Fields = {
  __typename?: 'energy_village_cabina_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "energy_village.caratteristica" */
export type Energy_Village_Caratteristica = {
  __typename?: 'energy_village_caratteristica';
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "energy_village.energy_village_caratteristica_translate_description" */
  description?: Maybe<Scalars['String']['output']>;
  description_?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_caratteristica_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tipologia_asset_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Aggregate = {
  __typename?: 'energy_village_caratteristica_aggregate';
  aggregate?: Maybe<Energy_Village_Caratteristica_Aggregate_Fields>;
  nodes: Array<Energy_Village_Caratteristica>;
};

export type Energy_Village_Caratteristica_Aggregate_Bool_Exp = {
  count?: InputMaybe<Energy_Village_Caratteristica_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Caratteristica_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Aggregate_Fields = {
  __typename?: 'energy_village_caratteristica_aggregate_fields';
  avg?: Maybe<Energy_Village_Caratteristica_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Caratteristica_Max_Fields>;
  min?: Maybe<Energy_Village_Caratteristica_Min_Fields>;
  stddev?: Maybe<Energy_Village_Caratteristica_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Caratteristica_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Caratteristica_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Caratteristica_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Caratteristica_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Caratteristica_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Caratteristica_Variance_Fields>;
};


/** aggregate fields of "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Caratteristica_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Caratteristica_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Caratteristica_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Caratteristica_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Caratteristica_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Caratteristica_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Caratteristica_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Caratteristica_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Caratteristica_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Caratteristica_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Caratteristica_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Caratteristica_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Caratteristica_Avg_Fields = {
  __typename?: 'energy_village_caratteristica_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.caratteristica". All fields are combined with a logical 'AND'. */
export type Energy_Village_Caratteristica_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Caratteristica_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Caratteristica_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.caratteristica" */
export enum Energy_Village_Caratteristica_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaratteristicaPkey = 'caratteristica_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Caratteristica_Max_Fields = {
  __typename?: 'energy_village_caratteristica_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "energy_village.energy_village_caratteristica_translate_description" */
  description?: Maybe<Scalars['String']['output']>;
  description_?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_caratteristica_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description_?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Caratteristica_Min_Fields = {
  __typename?: 'energy_village_caratteristica_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "energy_village.energy_village_caratteristica_translate_description" */
  description?: Maybe<Scalars['String']['output']>;
  description_?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_caratteristica_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description_?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Mutation_Response = {
  __typename?: 'energy_village_caratteristica_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Caratteristica>;
};

/** input type for inserting object relation for remote table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Obj_Rel_Insert_Input = {
  data: Energy_Village_Caratteristica_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Caratteristica_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_On_Conflict = {
  constraint: Energy_Village_Caratteristica_Constraint;
  update_columns?: Array<Energy_Village_Caratteristica_Update_Column>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.caratteristica". */
export type Energy_Village_Caratteristica_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.caratteristica */
export type Energy_Village_Caratteristica_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.caratteristica" */
export enum Energy_Village_Caratteristica_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description_',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Caratteristica_Stddev_Fields = {
  __typename?: 'energy_village_caratteristica_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Caratteristica_Stddev_Pop_Fields = {
  __typename?: 'energy_village_caratteristica_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Caratteristica_Stddev_Samp_Fields = {
  __typename?: 'energy_village_caratteristica_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_caratteristica" */
export type Energy_Village_Caratteristica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Caratteristica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Caratteristica_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Caratteristica_Sum_Fields = {
  __typename?: 'energy_village_caratteristica_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.caratteristica" */
export enum Energy_Village_Caratteristica_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description_',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Caratteristica_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Caratteristica_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Caratteristica_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Caratteristica_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Caratteristica_Var_Pop_Fields = {
  __typename?: 'energy_village_caratteristica_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Caratteristica_Var_Samp_Fields = {
  __typename?: 'energy_village_caratteristica_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Caratteristica_Variance_Fields = {
  __typename?: 'energy_village_caratteristica_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.caratteristica" */
export type Energy_Village_Caratteristica_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options = {
  __typename?: 'energy_village_cer_filter_options';
  filter: Energy_Village__Cer_Filter_Options_Enum;
};

/** aggregated selection of "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_Aggregate = {
  __typename?: 'energy_village_cer_filter_options_aggregate';
  aggregate?: Maybe<Energy_Village_Cer_Filter_Options_Aggregate_Fields>;
  nodes: Array<Energy_Village_Cer_Filter_Options>;
};

/** aggregate fields of "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_Aggregate_Fields = {
  __typename?: 'energy_village_cer_filter_options_aggregate_fields';
  count: Scalars['Int']['output'];
};


/** aggregate fields of "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_village.cer_filter_options". All fields are combined with a logical 'AND'. */
export type Energy_Village_Cer_Filter_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Cer_Filter_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Bool_Exp>>;
  filter?: InputMaybe<Energy_Village__Cer_Filter_Options_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.cer_filter_options" */
export enum Energy_Village_Cer_Filter_Options_Constraint {
  /** unique or primary key constraint on columns "filter" */
  CerFilterOptionsPkey = 'cer_filter_options_pkey'
}

/** input type for inserting data into table "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_Insert_Input = {
  filter?: InputMaybe<Energy_Village__Cer_Filter_Options_Enum>;
};

/** response of any mutation on the table "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_Mutation_Response = {
  __typename?: 'energy_village_cer_filter_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Cer_Filter_Options>;
};

/** on_conflict condition type for table "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_On_Conflict = {
  constraint: Energy_Village_Cer_Filter_Options_Constraint;
  update_columns?: Array<Energy_Village_Cer_Filter_Options_Update_Column>;
  where?: InputMaybe<Energy_Village_Cer_Filter_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.cer_filter_options". */
export type Energy_Village_Cer_Filter_Options_Order_By = {
  filter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.cer_filter_options */
export type Energy_Village_Cer_Filter_Options_Pk_Columns_Input = {
  filter: Energy_Village__Cer_Filter_Options_Enum;
};

/** select columns of table "energy_village.cer_filter_options" */
export enum Energy_Village_Cer_Filter_Options_Select_Column {
  /** column name */
  Filter = 'filter'
}

/** input type for updating data in table "energy_village.cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_Set_Input = {
  filter?: InputMaybe<Energy_Village__Cer_Filter_Options_Enum>;
};

/** Streaming cursor of the table "energy_village_cer_filter_options" */
export type Energy_Village_Cer_Filter_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Cer_Filter_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Cer_Filter_Options_Stream_Cursor_Value_Input = {
  filter?: InputMaybe<Energy_Village__Cer_Filter_Options_Enum>;
};

/** update columns of table "energy_village.cer_filter_options" */
export enum Energy_Village_Cer_Filter_Options_Update_Column {
  /** column name */
  Filter = 'filter'
}

export type Energy_Village_Cer_Filter_Options_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Cer_Filter_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Cer_Filter_Options_Bool_Exp;
};

/** columns and relationships of "energy_village.dimensione" */
export type Energy_Village_Dimensione = {
  __typename?: 'energy_village_dimensione';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_dimensione_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tipologia_asset_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.dimensione" */
export type Energy_Village_Dimensione_Aggregate = {
  __typename?: 'energy_village_dimensione_aggregate';
  aggregate?: Maybe<Energy_Village_Dimensione_Aggregate_Fields>;
  nodes: Array<Energy_Village_Dimensione>;
};

export type Energy_Village_Dimensione_Aggregate_Bool_Exp = {
  count?: InputMaybe<Energy_Village_Dimensione_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Dimensione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.dimensione" */
export type Energy_Village_Dimensione_Aggregate_Fields = {
  __typename?: 'energy_village_dimensione_aggregate_fields';
  avg?: Maybe<Energy_Village_Dimensione_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Dimensione_Max_Fields>;
  min?: Maybe<Energy_Village_Dimensione_Min_Fields>;
  stddev?: Maybe<Energy_Village_Dimensione_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Dimensione_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Dimensione_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Dimensione_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Dimensione_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Dimensione_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Dimensione_Variance_Fields>;
};


/** aggregate fields of "energy_village.dimensione" */
export type Energy_Village_Dimensione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Dimensione_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Dimensione_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Dimensione_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Dimensione_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Dimensione_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Dimensione_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Dimensione_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Dimensione_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Dimensione_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Dimensione_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Dimensione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Dimensione_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Dimensione_Avg_Fields = {
  __typename?: 'energy_village_dimensione_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.dimensione". All fields are combined with a logical 'AND'. */
export type Energy_Village_Dimensione_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Dimensione_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Dimensione_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.dimensione" */
export enum Energy_Village_Dimensione_Constraint {
  /** unique or primary key constraint on columns "id" */
  DimensionePkey = 'dimensione_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Dimensione_Max_Fields = {
  __typename?: 'energy_village_dimensione_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_dimensione_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Dimensione_Min_Fields = {
  __typename?: 'energy_village_dimensione_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_dimensione_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Mutation_Response = {
  __typename?: 'energy_village_dimensione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Dimensione>;
};

/** input type for inserting object relation for remote table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Obj_Rel_Insert_Input = {
  data: Energy_Village_Dimensione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Dimensione_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.dimensione" */
export type Energy_Village_Dimensione_On_Conflict = {
  constraint: Energy_Village_Dimensione_Constraint;
  update_columns?: Array<Energy_Village_Dimensione_Update_Column>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.dimensione". */
export type Energy_Village_Dimensione_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.dimensione */
export type Energy_Village_Dimensione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.dimensione" */
export enum Energy_Village_Dimensione_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Dimensione_Stddev_Fields = {
  __typename?: 'energy_village_dimensione_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Dimensione_Stddev_Pop_Fields = {
  __typename?: 'energy_village_dimensione_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Dimensione_Stddev_Samp_Fields = {
  __typename?: 'energy_village_dimensione_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_dimensione" */
export type Energy_Village_Dimensione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Dimensione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Dimensione_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Dimensione_Sum_Fields = {
  __typename?: 'energy_village_dimensione_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.dimensione" */
export enum Energy_Village_Dimensione_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Dimensione_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Dimensione_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Dimensione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Dimensione_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Dimensione_Var_Pop_Fields = {
  __typename?: 'energy_village_dimensione_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Dimensione_Var_Samp_Fields = {
  __typename?: 'energy_village_dimensione_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Dimensione_Variance_Fields = {
  __typename?: 'energy_village_dimensione_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.dimensione" */
export type Energy_Village_Dimensione_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "energy_village.feedback" */
export type Energy_Village_Feedback = {
  __typename?: 'energy_village_feedback';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_feedback_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  type: Energy_Village__Tipo_Feedback_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.feedback" */
export type Energy_Village_Feedback_Aggregate = {
  __typename?: 'energy_village_feedback_aggregate';
  aggregate?: Maybe<Energy_Village_Feedback_Aggregate_Fields>;
  nodes: Array<Energy_Village_Feedback>;
};

/** aggregate fields of "energy_village.feedback" */
export type Energy_Village_Feedback_Aggregate_Fields = {
  __typename?: 'energy_village_feedback_aggregate_fields';
  avg?: Maybe<Energy_Village_Feedback_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Feedback_Max_Fields>;
  min?: Maybe<Energy_Village_Feedback_Min_Fields>;
  stddev?: Maybe<Energy_Village_Feedback_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Feedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Feedback_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Feedback_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Feedback_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Feedback_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Feedback_Variance_Fields>;
};


/** aggregate fields of "energy_village.feedback" */
export type Energy_Village_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Feedback_Avg_Fields = {
  __typename?: 'energy_village_feedback_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.feedback". All fields are combined with a logical 'AND'. */
export type Energy_Village_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Feedback_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Feedback_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Energy_Village__Tipo_Feedback_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.feedback" */
export enum Energy_Village_Feedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeedbackPkey = 'feedback_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.feedback" */
export type Energy_Village_Feedback_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.feedback" */
export type Energy_Village_Feedback_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Energy_Village__Tipo_Feedback_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Feedback_Max_Fields = {
  __typename?: 'energy_village_feedback_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_feedback_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Feedback_Min_Fields = {
  __typename?: 'energy_village_feedback_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_feedback_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "energy_village.feedback" */
export type Energy_Village_Feedback_Mutation_Response = {
  __typename?: 'energy_village_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Feedback>;
};

/** input type for inserting object relation for remote table "energy_village.feedback" */
export type Energy_Village_Feedback_Obj_Rel_Insert_Input = {
  data: Energy_Village_Feedback_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Feedback_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.feedback" */
export type Energy_Village_Feedback_On_Conflict = {
  constraint: Energy_Village_Feedback_Constraint;
  update_columns?: Array<Energy_Village_Feedback_Update_Column>;
  where?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.feedback". */
export type Energy_Village_Feedback_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.feedback */
export type Energy_Village_Feedback_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.feedback" */
export enum Energy_Village_Feedback_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.feedback" */
export type Energy_Village_Feedback_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Energy_Village__Tipo_Feedback_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Feedback_Stddev_Fields = {
  __typename?: 'energy_village_feedback_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Feedback_Stddev_Pop_Fields = {
  __typename?: 'energy_village_feedback_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Feedback_Stddev_Samp_Fields = {
  __typename?: 'energy_village_feedback_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_feedback" */
export type Energy_Village_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Feedback_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Energy_Village__Tipo_Feedback_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Feedback_Sum_Fields = {
  __typename?: 'energy_village_feedback_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "energy_village.feedback" */
export enum Energy_Village_Feedback_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Feedback_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Feedback_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Feedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Feedback_Var_Pop_Fields = {
  __typename?: 'energy_village_feedback_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Feedback_Var_Samp_Fields = {
  __typename?: 'energy_village_feedback_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Feedback_Variance_Fields = {
  __typename?: 'energy_village_feedback_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto = {
  __typename?: 'energy_village_incentivo_impianto';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_incentivo_impianto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Aggregate = {
  __typename?: 'energy_village_incentivo_impianto_aggregate';
  aggregate?: Maybe<Energy_Village_Incentivo_Impianto_Aggregate_Fields>;
  nodes: Array<Energy_Village_Incentivo_Impianto>;
};

export type Energy_Village_Incentivo_Impianto_Aggregate_Bool_Exp = {
  count?: InputMaybe<Energy_Village_Incentivo_Impianto_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Incentivo_Impianto_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Aggregate_Fields = {
  __typename?: 'energy_village_incentivo_impianto_aggregate_fields';
  avg?: Maybe<Energy_Village_Incentivo_Impianto_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Incentivo_Impianto_Max_Fields>;
  min?: Maybe<Energy_Village_Incentivo_Impianto_Min_Fields>;
  stddev?: Maybe<Energy_Village_Incentivo_Impianto_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Incentivo_Impianto_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Incentivo_Impianto_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Incentivo_Impianto_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Incentivo_Impianto_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Incentivo_Impianto_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Incentivo_Impianto_Variance_Fields>;
};


/** aggregate fields of "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Incentivo_Impianto_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Incentivo_Impianto_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Incentivo_Impianto_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Incentivo_Impianto_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Incentivo_Impianto_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Incentivo_Impianto_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Incentivo_Impianto_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Incentivo_Impianto_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Incentivo_Impianto_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Incentivo_Impianto_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Incentivo_Impianto_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Incentivo_Impianto_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Incentivo_Impianto_Avg_Fields = {
  __typename?: 'energy_village_incentivo_impianto_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.incentivo_impianto". All fields are combined with a logical 'AND'. */
export type Energy_Village_Incentivo_Impianto_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.incentivo_impianto" */
export enum Energy_Village_Incentivo_Impianto_Constraint {
  /** unique or primary key constraint on columns "id" */
  IncentivoImpiantoPkey = 'incentivo_impianto_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Incentivo_Impianto_Max_Fields = {
  __typename?: 'energy_village_incentivo_impianto_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_incentivo_impianto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Incentivo_Impianto_Min_Fields = {
  __typename?: 'energy_village_incentivo_impianto_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_incentivo_impianto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Mutation_Response = {
  __typename?: 'energy_village_incentivo_impianto_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Incentivo_Impianto>;
};

/** on_conflict condition type for table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_On_Conflict = {
  constraint: Energy_Village_Incentivo_Impianto_Constraint;
  update_columns?: Array<Energy_Village_Incentivo_Impianto_Update_Column>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.incentivo_impianto". */
export type Energy_Village_Incentivo_Impianto_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.incentivo_impianto */
export type Energy_Village_Incentivo_Impianto_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.incentivo_impianto" */
export enum Energy_Village_Incentivo_Impianto_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Incentivo_Impianto_Stddev_Fields = {
  __typename?: 'energy_village_incentivo_impianto_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Incentivo_Impianto_Stddev_Pop_Fields = {
  __typename?: 'energy_village_incentivo_impianto_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Incentivo_Impianto_Stddev_Samp_Fields = {
  __typename?: 'energy_village_incentivo_impianto_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Incentivo_Impianto_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Incentivo_Impianto_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Incentivo_Impianto_Sum_Fields = {
  __typename?: 'energy_village_incentivo_impianto_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.incentivo_impianto" */
export enum Energy_Village_Incentivo_Impianto_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Incentivo_Impianto_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Incentivo_Impianto_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Incentivo_Impianto_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Incentivo_Impianto_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Incentivo_Impianto_Var_Pop_Fields = {
  __typename?: 'energy_village_incentivo_impianto_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Incentivo_Impianto_Var_Samp_Fields = {
  __typename?: 'energy_village_incentivo_impianto_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Incentivo_Impianto_Variance_Fields = {
  __typename?: 'energy_village_incentivo_impianto_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.incentivo_impianto" */
export type Energy_Village_Incentivo_Impianto_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "energy_village.orario" */
export type Energy_Village_Orario = {
  __typename?: 'energy_village_orario';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_orario_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tipologia_asset_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.orario" */
export type Energy_Village_Orario_Aggregate = {
  __typename?: 'energy_village_orario_aggregate';
  aggregate?: Maybe<Energy_Village_Orario_Aggregate_Fields>;
  nodes: Array<Energy_Village_Orario>;
};

export type Energy_Village_Orario_Aggregate_Bool_Exp = {
  count?: InputMaybe<Energy_Village_Orario_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Orario_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.orario" */
export type Energy_Village_Orario_Aggregate_Fields = {
  __typename?: 'energy_village_orario_aggregate_fields';
  avg?: Maybe<Energy_Village_Orario_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Orario_Max_Fields>;
  min?: Maybe<Energy_Village_Orario_Min_Fields>;
  stddev?: Maybe<Energy_Village_Orario_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Orario_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Orario_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Orario_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Orario_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Orario_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Orario_Variance_Fields>;
};


/** aggregate fields of "energy_village.orario" */
export type Energy_Village_Orario_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.orario" */
export type Energy_Village_Orario_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Orario_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Orario_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Orario_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Orario_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Orario_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Orario_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Orario_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Orario_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Orario_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Orario_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "energy_village.orario" */
export type Energy_Village_Orario_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Orario_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Orario_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Orario_Avg_Fields = {
  __typename?: 'energy_village_orario_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.orario". All fields are combined with a logical 'AND'. */
export type Energy_Village_Orario_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Orario_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Orario_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.orario" */
export enum Energy_Village_Orario_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrarioPkey = 'orario_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.orario" */
export type Energy_Village_Orario_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.orario" */
export type Energy_Village_Orario_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Orario_Max_Fields = {
  __typename?: 'energy_village_orario_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_orario_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Orario_Min_Fields = {
  __typename?: 'energy_village_orario_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_orario_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.orario" */
export type Energy_Village_Orario_Mutation_Response = {
  __typename?: 'energy_village_orario_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Orario>;
};

/** on_conflict condition type for table "energy_village.orario" */
export type Energy_Village_Orario_On_Conflict = {
  constraint: Energy_Village_Orario_Constraint;
  update_columns?: Array<Energy_Village_Orario_Update_Column>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.orario". */
export type Energy_Village_Orario_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.orario */
export type Energy_Village_Orario_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.orario" */
export enum Energy_Village_Orario_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.orario" */
export type Energy_Village_Orario_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Orario_Stddev_Fields = {
  __typename?: 'energy_village_orario_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Orario_Stddev_Pop_Fields = {
  __typename?: 'energy_village_orario_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Orario_Stddev_Samp_Fields = {
  __typename?: 'energy_village_orario_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_orario" */
export type Energy_Village_Orario_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Orario_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Orario_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Orario_Sum_Fields = {
  __typename?: 'energy_village_orario_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.orario" */
export enum Energy_Village_Orario_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Orario_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Orario_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Orario_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Orario_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Orario_Var_Pop_Fields = {
  __typename?: 'energy_village_orario_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Orario_Var_Samp_Fields = {
  __typename?: 'energy_village_orario_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Orario_Variance_Fields = {
  __typename?: 'energy_village_orario_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.orario" */
export type Energy_Village_Orario_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto = {
  __typename?: 'energy_village_potenza_impianto';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_potenza_impianto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  max?: Maybe<Scalars['numeric']['output']>;
  min: Scalars['numeric']['output'];
  order: Scalars['Int']['output'];
  tipologia_asset_id: Scalars['uuid']['output'];
  unita: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Aggregate = {
  __typename?: 'energy_village_potenza_impianto_aggregate';
  aggregate?: Maybe<Energy_Village_Potenza_Impianto_Aggregate_Fields>;
  nodes: Array<Energy_Village_Potenza_Impianto>;
};

export type Energy_Village_Potenza_Impianto_Aggregate_Bool_Exp = {
  count?: InputMaybe<Energy_Village_Potenza_Impianto_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Potenza_Impianto_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Aggregate_Fields = {
  __typename?: 'energy_village_potenza_impianto_aggregate_fields';
  avg?: Maybe<Energy_Village_Potenza_Impianto_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Potenza_Impianto_Max_Fields>;
  min?: Maybe<Energy_Village_Potenza_Impianto_Min_Fields>;
  stddev?: Maybe<Energy_Village_Potenza_Impianto_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Potenza_Impianto_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Potenza_Impianto_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Potenza_Impianto_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Potenza_Impianto_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Potenza_Impianto_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Potenza_Impianto_Variance_Fields>;
};


/** aggregate fields of "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Potenza_Impianto_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Potenza_Impianto_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Potenza_Impianto_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Potenza_Impianto_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Potenza_Impianto_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Potenza_Impianto_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Potenza_Impianto_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Potenza_Impianto_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Potenza_Impianto_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Potenza_Impianto_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Potenza_Impianto_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Potenza_Impianto_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Potenza_Impianto_Avg_Fields = {
  __typename?: 'energy_village_potenza_impianto_avg_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Avg_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.potenza_impianto". All fields are combined with a logical 'AND'. */
export type Energy_Village_Potenza_Impianto_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  max?: InputMaybe<Numeric_Comparison_Exp>;
  min?: InputMaybe<Numeric_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  unita?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.potenza_impianto" */
export enum Energy_Village_Potenza_Impianto_Constraint {
  /** unique or primary key constraint on columns "id" */
  PotenzaImpiantoPkey = 'potenza_impianto_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Inc_Input = {
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  unita?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Potenza_Impianto_Max_Fields = {
  __typename?: 'energy_village_potenza_impianto_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_potenza_impianto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['numeric']['output']>;
  min?: Maybe<Scalars['numeric']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  unita?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  unita?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Potenza_Impianto_Min_Fields = {
  __typename?: 'energy_village_potenza_impianto_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_potenza_impianto_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['numeric']['output']>;
  min?: Maybe<Scalars['numeric']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  unita?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  unita?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Mutation_Response = {
  __typename?: 'energy_village_potenza_impianto_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Potenza_Impianto>;
};

/** on_conflict condition type for table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_On_Conflict = {
  constraint: Energy_Village_Potenza_Impianto_Constraint;
  update_columns?: Array<Energy_Village_Potenza_Impianto_Update_Column>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.potenza_impianto". */
export type Energy_Village_Potenza_Impianto_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  unita?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.potenza_impianto */
export type Energy_Village_Potenza_Impianto_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.potenza_impianto" */
export enum Energy_Village_Potenza_Impianto_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  Unita = 'unita',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  unita?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Potenza_Impianto_Stddev_Fields = {
  __typename?: 'energy_village_potenza_impianto_stddev_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Stddev_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Potenza_Impianto_Stddev_Pop_Fields = {
  __typename?: 'energy_village_potenza_impianto_stddev_pop_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Stddev_Pop_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Potenza_Impianto_Stddev_Samp_Fields = {
  __typename?: 'energy_village_potenza_impianto_stddev_samp_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Stddev_Samp_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Potenza_Impianto_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Potenza_Impianto_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  unita?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Potenza_Impianto_Sum_Fields = {
  __typename?: 'energy_village_potenza_impianto_sum_fields';
  max?: Maybe<Scalars['numeric']['output']>;
  min?: Maybe<Scalars['numeric']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Sum_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.potenza_impianto" */
export enum Energy_Village_Potenza_Impianto_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  Unita = 'unita',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Potenza_Impianto_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Potenza_Impianto_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Potenza_Impianto_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Potenza_Impianto_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Potenza_Impianto_Var_Pop_Fields = {
  __typename?: 'energy_village_potenza_impianto_var_pop_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Var_Pop_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Potenza_Impianto_Var_Samp_Fields = {
  __typename?: 'energy_village_potenza_impianto_var_samp_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Var_Samp_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Potenza_Impianto_Variance_Fields = {
  __typename?: 'energy_village_potenza_impianto_variance_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.potenza_impianto" */
export type Energy_Village_Potenza_Impianto_Variance_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina = {
  __typename?: 'energy_village_potenzialita_cabina';
  agricolo: Scalars['Int']['output'];
  altro: Scalars['Int']['output'];
  commerciale: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  industriale: Scalars['Int']['output'];
  pubblico: Scalars['Int']['output'];
  residenziale: Scalars['Int']['output'];
  superficie: Scalars['numeric']['output'];
  totale: Scalars['Int']['output'];
  yes: Scalars['Int']['output'];
};

/** aggregated selection of "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Aggregate = {
  __typename?: 'energy_village_potenzialita_cabina_aggregate';
  aggregate?: Maybe<Energy_Village_Potenzialita_Cabina_Aggregate_Fields>;
  nodes: Array<Energy_Village_Potenzialita_Cabina>;
};

/** aggregate fields of "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Aggregate_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_aggregate_fields';
  avg?: Maybe<Energy_Village_Potenzialita_Cabina_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Potenzialita_Cabina_Max_Fields>;
  min?: Maybe<Energy_Village_Potenzialita_Cabina_Min_Fields>;
  stddev?: Maybe<Energy_Village_Potenzialita_Cabina_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Potenzialita_Cabina_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Potenzialita_Cabina_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Potenzialita_Cabina_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Potenzialita_Cabina_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Potenzialita_Cabina_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Potenzialita_Cabina_Variance_Fields>;
};


/** aggregate fields of "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Potenzialita_Cabina_Avg_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_avg_fields';
  agricolo?: Maybe<Scalars['Float']['output']>;
  altro?: Maybe<Scalars['Float']['output']>;
  commerciale?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industriale?: Maybe<Scalars['Float']['output']>;
  pubblico?: Maybe<Scalars['Float']['output']>;
  residenziale?: Maybe<Scalars['Float']['output']>;
  superficie?: Maybe<Scalars['Float']['output']>;
  totale?: Maybe<Scalars['Float']['output']>;
  yes?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.potenzialita_cabina". All fields are combined with a logical 'AND'. */
export type Energy_Village_Potenzialita_Cabina_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Bool_Exp>>;
  agricolo?: InputMaybe<Int_Comparison_Exp>;
  altro?: InputMaybe<Int_Comparison_Exp>;
  commerciale?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  industriale?: InputMaybe<Int_Comparison_Exp>;
  pubblico?: InputMaybe<Int_Comparison_Exp>;
  residenziale?: InputMaybe<Int_Comparison_Exp>;
  superficie?: InputMaybe<Numeric_Comparison_Exp>;
  totale?: InputMaybe<Int_Comparison_Exp>;
  yes?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.potenzialita_cabina" */
export enum Energy_Village_Potenzialita_Cabina_Constraint {
  /** unique or primary key constraint on columns "id" */
  PotenzialitaCabinaPkey = 'potenzialita_cabina_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Inc_Input = {
  agricolo?: InputMaybe<Scalars['Int']['input']>;
  altro?: InputMaybe<Scalars['Int']['input']>;
  commerciale?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industriale?: InputMaybe<Scalars['Int']['input']>;
  pubblico?: InputMaybe<Scalars['Int']['input']>;
  residenziale?: InputMaybe<Scalars['Int']['input']>;
  superficie?: InputMaybe<Scalars['numeric']['input']>;
  totale?: InputMaybe<Scalars['Int']['input']>;
  yes?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Insert_Input = {
  agricolo?: InputMaybe<Scalars['Int']['input']>;
  altro?: InputMaybe<Scalars['Int']['input']>;
  commerciale?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industriale?: InputMaybe<Scalars['Int']['input']>;
  pubblico?: InputMaybe<Scalars['Int']['input']>;
  residenziale?: InputMaybe<Scalars['Int']['input']>;
  superficie?: InputMaybe<Scalars['numeric']['input']>;
  totale?: InputMaybe<Scalars['Int']['input']>;
  yes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Potenzialita_Cabina_Max_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_max_fields';
  agricolo?: Maybe<Scalars['Int']['output']>;
  altro?: Maybe<Scalars['Int']['output']>;
  commerciale?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  industriale?: Maybe<Scalars['Int']['output']>;
  pubblico?: Maybe<Scalars['Int']['output']>;
  residenziale?: Maybe<Scalars['Int']['output']>;
  superficie?: Maybe<Scalars['numeric']['output']>;
  totale?: Maybe<Scalars['Int']['output']>;
  yes?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Potenzialita_Cabina_Min_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_min_fields';
  agricolo?: Maybe<Scalars['Int']['output']>;
  altro?: Maybe<Scalars['Int']['output']>;
  commerciale?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  industriale?: Maybe<Scalars['Int']['output']>;
  pubblico?: Maybe<Scalars['Int']['output']>;
  residenziale?: Maybe<Scalars['Int']['output']>;
  superficie?: Maybe<Scalars['numeric']['output']>;
  totale?: Maybe<Scalars['Int']['output']>;
  yes?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Mutation_Response = {
  __typename?: 'energy_village_potenzialita_cabina_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Potenzialita_Cabina>;
};

/** input type for inserting object relation for remote table "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Obj_Rel_Insert_Input = {
  data: Energy_Village_Potenzialita_Cabina_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Potenzialita_Cabina_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_On_Conflict = {
  constraint: Energy_Village_Potenzialita_Cabina_Constraint;
  update_columns?: Array<Energy_Village_Potenzialita_Cabina_Update_Column>;
  where?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.potenzialita_cabina". */
export type Energy_Village_Potenzialita_Cabina_Order_By = {
  agricolo?: InputMaybe<Order_By>;
  altro?: InputMaybe<Order_By>;
  commerciale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industriale?: InputMaybe<Order_By>;
  pubblico?: InputMaybe<Order_By>;
  residenziale?: InputMaybe<Order_By>;
  superficie?: InputMaybe<Order_By>;
  totale?: InputMaybe<Order_By>;
  yes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.potenzialita_cabina */
export type Energy_Village_Potenzialita_Cabina_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "energy_village.potenzialita_cabina" */
export enum Energy_Village_Potenzialita_Cabina_Select_Column {
  /** column name */
  Agricolo = 'agricolo',
  /** column name */
  Altro = 'altro',
  /** column name */
  Commerciale = 'commerciale',
  /** column name */
  Id = 'id',
  /** column name */
  Industriale = 'industriale',
  /** column name */
  Pubblico = 'pubblico',
  /** column name */
  Residenziale = 'residenziale',
  /** column name */
  Superficie = 'superficie',
  /** column name */
  Totale = 'totale',
  /** column name */
  Yes = 'yes'
}

/** input type for updating data in table "energy_village.potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Set_Input = {
  agricolo?: InputMaybe<Scalars['Int']['input']>;
  altro?: InputMaybe<Scalars['Int']['input']>;
  commerciale?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industriale?: InputMaybe<Scalars['Int']['input']>;
  pubblico?: InputMaybe<Scalars['Int']['input']>;
  residenziale?: InputMaybe<Scalars['Int']['input']>;
  superficie?: InputMaybe<Scalars['numeric']['input']>;
  totale?: InputMaybe<Scalars['Int']['input']>;
  yes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Potenzialita_Cabina_Stddev_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_stddev_fields';
  agricolo?: Maybe<Scalars['Float']['output']>;
  altro?: Maybe<Scalars['Float']['output']>;
  commerciale?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industriale?: Maybe<Scalars['Float']['output']>;
  pubblico?: Maybe<Scalars['Float']['output']>;
  residenziale?: Maybe<Scalars['Float']['output']>;
  superficie?: Maybe<Scalars['Float']['output']>;
  totale?: Maybe<Scalars['Float']['output']>;
  yes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Potenzialita_Cabina_Stddev_Pop_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_stddev_pop_fields';
  agricolo?: Maybe<Scalars['Float']['output']>;
  altro?: Maybe<Scalars['Float']['output']>;
  commerciale?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industriale?: Maybe<Scalars['Float']['output']>;
  pubblico?: Maybe<Scalars['Float']['output']>;
  residenziale?: Maybe<Scalars['Float']['output']>;
  superficie?: Maybe<Scalars['Float']['output']>;
  totale?: Maybe<Scalars['Float']['output']>;
  yes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Potenzialita_Cabina_Stddev_Samp_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_stddev_samp_fields';
  agricolo?: Maybe<Scalars['Float']['output']>;
  altro?: Maybe<Scalars['Float']['output']>;
  commerciale?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industriale?: Maybe<Scalars['Float']['output']>;
  pubblico?: Maybe<Scalars['Float']['output']>;
  residenziale?: Maybe<Scalars['Float']['output']>;
  superficie?: Maybe<Scalars['Float']['output']>;
  totale?: Maybe<Scalars['Float']['output']>;
  yes?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_potenzialita_cabina" */
export type Energy_Village_Potenzialita_Cabina_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Potenzialita_Cabina_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Potenzialita_Cabina_Stream_Cursor_Value_Input = {
  agricolo?: InputMaybe<Scalars['Int']['input']>;
  altro?: InputMaybe<Scalars['Int']['input']>;
  commerciale?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industriale?: InputMaybe<Scalars['Int']['input']>;
  pubblico?: InputMaybe<Scalars['Int']['input']>;
  residenziale?: InputMaybe<Scalars['Int']['input']>;
  superficie?: InputMaybe<Scalars['numeric']['input']>;
  totale?: InputMaybe<Scalars['Int']['input']>;
  yes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Potenzialita_Cabina_Sum_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_sum_fields';
  agricolo?: Maybe<Scalars['Int']['output']>;
  altro?: Maybe<Scalars['Int']['output']>;
  commerciale?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  industriale?: Maybe<Scalars['Int']['output']>;
  pubblico?: Maybe<Scalars['Int']['output']>;
  residenziale?: Maybe<Scalars['Int']['output']>;
  superficie?: Maybe<Scalars['numeric']['output']>;
  totale?: Maybe<Scalars['Int']['output']>;
  yes?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "energy_village.potenzialita_cabina" */
export enum Energy_Village_Potenzialita_Cabina_Update_Column {
  /** column name */
  Agricolo = 'agricolo',
  /** column name */
  Altro = 'altro',
  /** column name */
  Commerciale = 'commerciale',
  /** column name */
  Id = 'id',
  /** column name */
  Industriale = 'industriale',
  /** column name */
  Pubblico = 'pubblico',
  /** column name */
  Residenziale = 'residenziale',
  /** column name */
  Superficie = 'superficie',
  /** column name */
  Totale = 'totale',
  /** column name */
  Yes = 'yes'
}

export type Energy_Village_Potenzialita_Cabina_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Potenzialita_Cabina_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Potenzialita_Cabina_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Potenzialita_Cabina_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Potenzialita_Cabina_Var_Pop_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_var_pop_fields';
  agricolo?: Maybe<Scalars['Float']['output']>;
  altro?: Maybe<Scalars['Float']['output']>;
  commerciale?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industriale?: Maybe<Scalars['Float']['output']>;
  pubblico?: Maybe<Scalars['Float']['output']>;
  residenziale?: Maybe<Scalars['Float']['output']>;
  superficie?: Maybe<Scalars['Float']['output']>;
  totale?: Maybe<Scalars['Float']['output']>;
  yes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Potenzialita_Cabina_Var_Samp_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_var_samp_fields';
  agricolo?: Maybe<Scalars['Float']['output']>;
  altro?: Maybe<Scalars['Float']['output']>;
  commerciale?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industriale?: Maybe<Scalars['Float']['output']>;
  pubblico?: Maybe<Scalars['Float']['output']>;
  residenziale?: Maybe<Scalars['Float']['output']>;
  superficie?: Maybe<Scalars['Float']['output']>;
  totale?: Maybe<Scalars['Float']['output']>;
  yes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Potenzialita_Cabina_Variance_Fields = {
  __typename?: 'energy_village_potenzialita_cabina_variance_fields';
  agricolo?: Maybe<Scalars['Float']['output']>;
  altro?: Maybe<Scalars['Float']['output']>;
  commerciale?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  industriale?: Maybe<Scalars['Float']['output']>;
  pubblico?: Maybe<Scalars['Float']['output']>;
  residenziale?: Maybe<Scalars['Float']['output']>;
  superficie?: Maybe<Scalars['Float']['output']>;
  totale?: Maybe<Scalars['Float']['output']>;
  yes?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile = {
  __typename?: 'energy_village_tipo_spazio_disponibile';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_tipo_spazio_disponibile_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  tipologia_asset?: Maybe<Energy_Village_Tipologia_Asset>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Aggregate = {
  __typename?: 'energy_village_tipo_spazio_disponibile_aggregate';
  aggregate?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Aggregate_Fields>;
  nodes: Array<Energy_Village_Tipo_Spazio_Disponibile>;
};

/** aggregate fields of "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Aggregate_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_aggregate_fields';
  avg?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Max_Fields>;
  min?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Min_Fields>;
  stddev?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Variance_Fields>;
};


/** aggregate fields of "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Avg_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.tipo_spazio_disponibile". All fields are combined with a logical 'AND'. */
export type Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.tipo_spazio_disponibile" */
export enum Energy_Village_Tipo_Spazio_Disponibile_Constraint {
  /** unique or primary key constraint on columns "id" */
  TipoSpazioDisponibilePkey = 'tipo_spazio_disponibile_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Obj_Rel_Insert_Input>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Max_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_tipo_spazio_disponibile_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Min_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_tipo_spazio_disponibile_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Mutation_Response = {
  __typename?: 'energy_village_tipo_spazio_disponibile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Tipo_Spazio_Disponibile>;
};

/** input type for inserting object relation for remote table "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Obj_Rel_Insert_Input = {
  data: Energy_Village_Tipo_Spazio_Disponibile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_On_Conflict = {
  constraint: Energy_Village_Tipo_Spazio_Disponibile_Constraint;
  update_columns?: Array<Energy_Village_Tipo_Spazio_Disponibile_Update_Column>;
  where?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.tipo_spazio_disponibile". */
export type Energy_Village_Tipo_Spazio_Disponibile_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset?: InputMaybe<Energy_Village_Tipologia_Asset_Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.tipo_spazio_disponibile */
export type Energy_Village_Tipo_Spazio_Disponibile_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.tipo_spazio_disponibile" */
export enum Energy_Village_Tipo_Spazio_Disponibile_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Stddev_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Stddev_Pop_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Stddev_Samp_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_tipo_spazio_disponibile" */
export type Energy_Village_Tipo_Spazio_Disponibile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Tipo_Spazio_Disponibile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Tipo_Spazio_Disponibile_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Sum_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "energy_village.tipo_spazio_disponibile" */
export enum Energy_Village_Tipo_Spazio_Disponibile_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Tipo_Spazio_Disponibile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Var_Pop_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Var_Samp_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Tipo_Spazio_Disponibile_Variance_Fields = {
  __typename?: 'energy_village_tipo_spazio_disponibile_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa = {
  __typename?: 'energy_village_tipologia_abitativa';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_tipologia_abitativa_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tipologia_asset_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Aggregate = {
  __typename?: 'energy_village_tipologia_abitativa_aggregate';
  aggregate?: Maybe<Energy_Village_Tipologia_Abitativa_Aggregate_Fields>;
  nodes: Array<Energy_Village_Tipologia_Abitativa>;
};

export type Energy_Village_Tipologia_Abitativa_Aggregate_Bool_Exp = {
  count?: InputMaybe<Energy_Village_Tipologia_Abitativa_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Tipologia_Abitativa_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Aggregate_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_aggregate_fields';
  avg?: Maybe<Energy_Village_Tipologia_Abitativa_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Tipologia_Abitativa_Max_Fields>;
  min?: Maybe<Energy_Village_Tipologia_Abitativa_Min_Fields>;
  stddev?: Maybe<Energy_Village_Tipologia_Abitativa_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Tipologia_Abitativa_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Tipologia_Abitativa_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Tipologia_Abitativa_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Tipologia_Abitativa_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Tipologia_Abitativa_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Tipologia_Abitativa_Variance_Fields>;
};


/** aggregate fields of "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Tipologia_Abitativa_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Tipologia_Abitativa_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Tipologia_Abitativa_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Tipologia_Abitativa_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Tipologia_Abitativa_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Tipologia_Abitativa_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Tipologia_Abitativa_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Tipologia_Abitativa_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Tipologia_Abitativa_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Tipologia_Abitativa_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Tipologia_Abitativa_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Abitativa_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Tipologia_Abitativa_Avg_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.tipologia_abitativa". All fields are combined with a logical 'AND'. */
export type Energy_Village_Tipologia_Abitativa_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tipologia_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.tipologia_abitativa" */
export enum Energy_Village_Tipologia_Abitativa_Constraint {
  /** unique or primary key constraint on columns "id" */
  TipologiaAbitativaPkey = 'tipologia_abitativa_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Tipologia_Abitativa_Max_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_tipologia_abitativa_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Tipologia_Abitativa_Min_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_tipologia_abitativa_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tipologia_asset_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Mutation_Response = {
  __typename?: 'energy_village_tipologia_abitativa_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Tipologia_Abitativa>;
};

/** input type for inserting object relation for remote table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Obj_Rel_Insert_Input = {
  data: Energy_Village_Tipologia_Abitativa_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Abitativa_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_On_Conflict = {
  constraint: Energy_Village_Tipologia_Abitativa_Constraint;
  update_columns?: Array<Energy_Village_Tipologia_Abitativa_Update_Column>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.tipologia_abitativa". */
export type Energy_Village_Tipologia_Abitativa_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tipologia_asset_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.tipologia_abitativa */
export type Energy_Village_Tipologia_Abitativa_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.tipologia_abitativa" */
export enum Energy_Village_Tipologia_Abitativa_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Tipologia_Abitativa_Stddev_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Tipologia_Abitativa_Stddev_Pop_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Tipologia_Abitativa_Stddev_Samp_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Tipologia_Abitativa_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Tipologia_Abitativa_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tipologia_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Tipologia_Abitativa_Sum_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.tipologia_abitativa" */
export enum Energy_Village_Tipologia_Abitativa_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  TipologiaAssetId = 'tipologia_asset_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Tipologia_Abitativa_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Tipologia_Abitativa_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Tipologia_Abitativa_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Tipologia_Abitativa_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Tipologia_Abitativa_Var_Pop_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Tipologia_Abitativa_Var_Samp_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Tipologia_Abitativa_Variance_Fields = {
  __typename?: 'energy_village_tipologia_abitativa_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.tipologia_abitativa" */
export type Energy_Village_Tipologia_Abitativa_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset = {
  __typename?: 'energy_village_tipologia_asset';
  /** An array relationship */
  caratteristiche: Array<Energy_Village_Caratteristica>;
  /** An aggregate relationship */
  caratteristiche_aggregate: Energy_Village_Caratteristica_Aggregate;
  card_impianto: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  dimensioni: Array<Energy_Village_Dimensione>;
  /** An aggregate relationship */
  dimensioni_aggregate: Energy_Village_Dimensione_Aggregate;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  img?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  incentivi_impianto: Array<Energy_Village_Incentivo_Impianto>;
  /** An aggregate relationship */
  incentivi_impianto_aggregate: Energy_Village_Incentivo_Impianto_Aggregate;
  /** A computed field, executes function "energy_village.energy_village_tipologia_asset_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  /** An array relationship */
  orari: Array<Energy_Village_Orario>;
  /** An aggregate relationship */
  orari_aggregate: Energy_Village_Orario_Aggregate;
  order: Scalars['Int']['output'];
  percentuale_autoconsumo?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  potenze_impianto: Array<Energy_Village_Potenza_Impianto>;
  /** An aggregate relationship */
  potenze_impianto_aggregate: Energy_Village_Potenza_Impianto_Aggregate;
  profilo_consumo?: Maybe<Scalars['jsonb']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  tipologia: Scalars['String']['output'];
  /** An array relationship */
  tipologia_asset_figli: Array<Energy_Village_Tipologia_Asset>;
  /** An aggregate relationship */
  tipologia_asset_figli_aggregate: Energy_Village_Tipologia_Asset_Aggregate;
  /** An object relationship */
  tipologia_asset_padre?: Maybe<Energy_Village_Tipologia_Asset>;
  tipologia_prosumer?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tipologie_abitativa: Array<Energy_Village_Tipologia_Abitativa>;
  /** An aggregate relationship */
  tipologie_abitativa_aggregate: Energy_Village_Tipologia_Abitativa_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  visibile: Scalars['Boolean']['output'];
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetCaratteristicheArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Caratteristica_Order_By>>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetCaratteristiche_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Caratteristica_Order_By>>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetDimensioniArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Dimensione_Order_By>>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetDimensioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Dimensione_Order_By>>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetIncentivi_ImpiantoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetIncentivi_Impianto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetOrariArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Orario_Order_By>>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetOrari_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Orario_Order_By>>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetPercentuale_AutoconsumoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetPotenze_ImpiantoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetPotenze_Impianto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetProfilo_ConsumoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetTipologia_Asset_FigliArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetTipologia_Asset_Figli_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetTipologie_AbitativaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};


/** columns and relationships of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_AssetTipologie_Abitativa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};

/** aggregated selection of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Aggregate = {
  __typename?: 'energy_village_tipologia_asset_aggregate';
  aggregate?: Maybe<Energy_Village_Tipologia_Asset_Aggregate_Fields>;
  nodes: Array<Energy_Village_Tipologia_Asset>;
};

export type Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Count>;
};

export type Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_And = {
  arguments: Energy_Village_Tipologia_Asset_Select_Column_Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Energy_Village_Tipologia_Asset_Select_Column_Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Aggregate_Fields = {
  __typename?: 'energy_village_tipologia_asset_aggregate_fields';
  avg?: Maybe<Energy_Village_Tipologia_Asset_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Tipologia_Asset_Max_Fields>;
  min?: Maybe<Energy_Village_Tipologia_Asset_Min_Fields>;
  stddev?: Maybe<Energy_Village_Tipologia_Asset_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Tipologia_Asset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Tipologia_Asset_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Tipologia_Asset_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Tipologia_Asset_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Tipologia_Asset_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Tipologia_Asset_Variance_Fields>;
};


/** aggregate fields of "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Aggregate_Order_By = {
  avg?: InputMaybe<Energy_Village_Tipologia_Asset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Energy_Village_Tipologia_Asset_Max_Order_By>;
  min?: InputMaybe<Energy_Village_Tipologia_Asset_Min_Order_By>;
  stddev?: InputMaybe<Energy_Village_Tipologia_Asset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Energy_Village_Tipologia_Asset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Energy_Village_Tipologia_Asset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Energy_Village_Tipologia_Asset_Sum_Order_By>;
  var_pop?: InputMaybe<Energy_Village_Tipologia_Asset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Energy_Village_Tipologia_Asset_Var_Samp_Order_By>;
  variance?: InputMaybe<Energy_Village_Tipologia_Asset_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Tipologia_Asset_Append_Input = {
  percentuale_autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  profilo_consumo?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Arr_Rel_Insert_Input = {
  data: Array<Energy_Village_Tipologia_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Asset_On_Conflict>;
};

/** aggregate avg on columns */
export type Energy_Village_Tipologia_Asset_Avg_Fields = {
  __typename?: 'energy_village_tipologia_asset_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "energy_village.tipologia_asset". All fields are combined with a logical 'AND'. */
export type Energy_Village_Tipologia_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Bool_Exp>>;
  caratteristiche?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
  caratteristiche_aggregate?: InputMaybe<Energy_Village_Caratteristica_Aggregate_Bool_Exp>;
  card_impianto?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dimensioni?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
  dimensioni_aggregate?: InputMaybe<Energy_Village_Dimensione_Aggregate_Bool_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  img?: InputMaybe<String_Comparison_Exp>;
  incentivi_impianto?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
  incentivi_impianto_aggregate?: InputMaybe<Energy_Village_Incentivo_Impianto_Aggregate_Bool_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  orari?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
  orari_aggregate?: InputMaybe<Energy_Village_Orario_Aggregate_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  percentuale_autoconsumo?: InputMaybe<Jsonb_Comparison_Exp>;
  potenze_impianto?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
  potenze_impianto_aggregate?: InputMaybe<Energy_Village_Potenza_Impianto_Aggregate_Bool_Exp>;
  profilo_consumo?: InputMaybe<Jsonb_Comparison_Exp>;
  root_id?: InputMaybe<Uuid_Comparison_Exp>;
  tipologia?: InputMaybe<String_Comparison_Exp>;
  tipologia_asset_figli?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  tipologia_asset_figli_aggregate?: InputMaybe<Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp>;
  tipologia_asset_padre?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
  tipologia_prosumer?: InputMaybe<String_Comparison_Exp>;
  tipologie_abitativa?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
  tipologie_abitativa_aggregate?: InputMaybe<Energy_Village_Tipologia_Abitativa_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visibile?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.tipologia_asset" */
export enum Energy_Village_Tipologia_Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  TipologiaAssetPkey = 'tipologia_asset_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Energy_Village_Tipologia_Asset_Delete_At_Path_Input = {
  percentuale_autoconsumo?: InputMaybe<Array<Scalars['String']['input']>>;
  profilo_consumo?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Energy_Village_Tipologia_Asset_Delete_Elem_Input = {
  percentuale_autoconsumo?: InputMaybe<Scalars['Int']['input']>;
  profilo_consumo?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Energy_Village_Tipologia_Asset_Delete_Key_Input = {
  percentuale_autoconsumo?: InputMaybe<Scalars['String']['input']>;
  profilo_consumo?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Insert_Input = {
  caratteristiche?: InputMaybe<Energy_Village_Caratteristica_Arr_Rel_Insert_Input>;
  card_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dimensioni?: InputMaybe<Energy_Village_Dimensione_Arr_Rel_Insert_Input>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  incentivi_impianto?: InputMaybe<Energy_Village_Incentivo_Impianto_Arr_Rel_Insert_Input>;
  label_?: InputMaybe<Scalars['String']['input']>;
  orari?: InputMaybe<Energy_Village_Orario_Arr_Rel_Insert_Input>;
  order?: InputMaybe<Scalars['Int']['input']>;
  percentuale_autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  potenze_impianto?: InputMaybe<Energy_Village_Potenza_Impianto_Arr_Rel_Insert_Input>;
  profilo_consumo?: InputMaybe<Scalars['jsonb']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia?: InputMaybe<Scalars['String']['input']>;
  tipologia_asset_figli?: InputMaybe<Energy_Village_Tipologia_Asset_Arr_Rel_Insert_Input>;
  tipologia_asset_padre?: InputMaybe<Energy_Village_Tipologia_Asset_Obj_Rel_Insert_Input>;
  tipologia_prosumer?: InputMaybe<Scalars['String']['input']>;
  tipologie_abitativa?: InputMaybe<Energy_Village_Tipologia_Abitativa_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visibile?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Tipologia_Asset_Max_Fields = {
  __typename?: 'energy_village_tipologia_asset_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "energy_village.energy_village_tipologia_asset_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  tipologia?: Maybe<Scalars['String']['output']>;
  tipologia_prosumer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  tipologia?: InputMaybe<Order_By>;
  tipologia_prosumer?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Energy_Village_Tipologia_Asset_Min_Fields = {
  __typename?: 'energy_village_tipologia_asset_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "energy_village.energy_village_tipologia_asset_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  root_id?: Maybe<Scalars['uuid']['output']>;
  tipologia?: Maybe<Scalars['String']['output']>;
  tipologia_prosumer?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  tipologia?: InputMaybe<Order_By>;
  tipologia_prosumer?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Mutation_Response = {
  __typename?: 'energy_village_tipologia_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Tipologia_Asset>;
};

/** input type for inserting object relation for remote table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Obj_Rel_Insert_Input = {
  data: Energy_Village_Tipologia_Asset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Asset_On_Conflict>;
};

/** on_conflict condition type for table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_On_Conflict = {
  constraint: Energy_Village_Tipologia_Asset_Constraint;
  update_columns?: Array<Energy_Village_Tipologia_Asset_Update_Column>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.tipologia_asset". */
export type Energy_Village_Tipologia_Asset_Order_By = {
  caratteristiche_aggregate?: InputMaybe<Energy_Village_Caratteristica_Aggregate_Order_By>;
  card_impianto?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dimensioni_aggregate?: InputMaybe<Energy_Village_Dimensione_Aggregate_Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img?: InputMaybe<Order_By>;
  incentivi_impianto_aggregate?: InputMaybe<Energy_Village_Incentivo_Impianto_Aggregate_Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  orari_aggregate?: InputMaybe<Energy_Village_Orario_Aggregate_Order_By>;
  order?: InputMaybe<Order_By>;
  percentuale_autoconsumo?: InputMaybe<Order_By>;
  potenze_impianto_aggregate?: InputMaybe<Energy_Village_Potenza_Impianto_Aggregate_Order_By>;
  profilo_consumo?: InputMaybe<Order_By>;
  root_id?: InputMaybe<Order_By>;
  tipologia?: InputMaybe<Order_By>;
  tipologia_asset_figli_aggregate?: InputMaybe<Energy_Village_Tipologia_Asset_Aggregate_Order_By>;
  tipologia_asset_padre?: InputMaybe<Energy_Village_Tipologia_Asset_Order_By>;
  tipologia_prosumer?: InputMaybe<Order_By>;
  tipologie_abitativa_aggregate?: InputMaybe<Energy_Village_Tipologia_Abitativa_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibile?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.tipologia_asset */
export type Energy_Village_Tipologia_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Energy_Village_Tipologia_Asset_Prepend_Input = {
  percentuale_autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  profilo_consumo?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "energy_village.tipologia_asset" */
export enum Energy_Village_Tipologia_Asset_Select_Column {
  /** column name */
  CardImpianto = 'card_impianto',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Img = 'img',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  PercentualeAutoconsumo = 'percentuale_autoconsumo',
  /** column name */
  ProfiloConsumo = 'profilo_consumo',
  /** column name */
  RootId = 'root_id',
  /** column name */
  Tipologia = 'tipologia',
  /** column name */
  TipologiaProsumer = 'tipologia_prosumer',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visibile = 'visibile'
}

/** select "energy_village_tipologia_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "energy_village.tipologia_asset" */
export enum Energy_Village_Tipologia_Asset_Select_Column_Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CardImpianto = 'card_impianto',
  /** column name */
  Visibile = 'visibile'
}

/** select "energy_village_tipologia_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "energy_village.tipologia_asset" */
export enum Energy_Village_Tipologia_Asset_Select_Column_Energy_Village_Tipologia_Asset_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CardImpianto = 'card_impianto',
  /** column name */
  Visibile = 'visibile'
}

/** input type for updating data in table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Set_Input = {
  card_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  percentuale_autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  profilo_consumo?: InputMaybe<Scalars['jsonb']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia?: InputMaybe<Scalars['String']['input']>;
  tipologia_prosumer?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visibile?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Tipologia_Asset_Stddev_Fields = {
  __typename?: 'energy_village_tipologia_asset_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Tipologia_Asset_Stddev_Pop_Fields = {
  __typename?: 'energy_village_tipologia_asset_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Tipologia_Asset_Stddev_Samp_Fields = {
  __typename?: 'energy_village_tipologia_asset_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "energy_village_tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Tipologia_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Tipologia_Asset_Stream_Cursor_Value_Input = {
  card_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  percentuale_autoconsumo?: InputMaybe<Scalars['jsonb']['input']>;
  profilo_consumo?: InputMaybe<Scalars['jsonb']['input']>;
  root_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia?: InputMaybe<Scalars['String']['input']>;
  tipologia_prosumer?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visibile?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Tipologia_Asset_Sum_Fields = {
  __typename?: 'energy_village_tipologia_asset_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "energy_village.tipologia_asset" */
export enum Energy_Village_Tipologia_Asset_Update_Column {
  /** column name */
  CardImpianto = 'card_impianto',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Img = 'img',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  PercentualeAutoconsumo = 'percentuale_autoconsumo',
  /** column name */
  ProfiloConsumo = 'profilo_consumo',
  /** column name */
  RootId = 'root_id',
  /** column name */
  Tipologia = 'tipologia',
  /** column name */
  TipologiaProsumer = 'tipologia_prosumer',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visibile = 'visibile'
}

export type Energy_Village_Tipologia_Asset_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Energy_Village_Tipologia_Asset_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Tipologia_Asset_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Energy_Village_Tipologia_Asset_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Tipologia_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Tipologia_Asset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Tipologia_Asset_Var_Pop_Fields = {
  __typename?: 'energy_village_tipologia_asset_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Tipologia_Asset_Var_Samp_Fields = {
  __typename?: 'energy_village_tipologia_asset_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Energy_Village_Tipologia_Asset_Variance_Fields = {
  __typename?: 'energy_village_tipologia_asset_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_village.tipologia_asset" */
export type Energy_Village_Tipologia_Asset_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo = {
  __typename?: 'energy_village_titolo_autorizzativo';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "energy_village.energy_village_titolo_autorizzativo_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Aggregate = {
  __typename?: 'energy_village_titolo_autorizzativo_aggregate';
  aggregate?: Maybe<Energy_Village_Titolo_Autorizzativo_Aggregate_Fields>;
  nodes: Array<Energy_Village_Titolo_Autorizzativo>;
};

/** aggregate fields of "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Aggregate_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_aggregate_fields';
  avg?: Maybe<Energy_Village_Titolo_Autorizzativo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Village_Titolo_Autorizzativo_Max_Fields>;
  min?: Maybe<Energy_Village_Titolo_Autorizzativo_Min_Fields>;
  stddev?: Maybe<Energy_Village_Titolo_Autorizzativo_Stddev_Fields>;
  stddev_pop?: Maybe<Energy_Village_Titolo_Autorizzativo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Energy_Village_Titolo_Autorizzativo_Stddev_Samp_Fields>;
  sum?: Maybe<Energy_Village_Titolo_Autorizzativo_Sum_Fields>;
  var_pop?: Maybe<Energy_Village_Titolo_Autorizzativo_Var_Pop_Fields>;
  var_samp?: Maybe<Energy_Village_Titolo_Autorizzativo_Var_Samp_Fields>;
  variance?: Maybe<Energy_Village_Titolo_Autorizzativo_Variance_Fields>;
};


/** aggregate fields of "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Energy_Village_Titolo_Autorizzativo_Avg_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "energy_village.titolo_autorizzativo". All fields are combined with a logical 'AND'. */
export type Energy_Village_Titolo_Autorizzativo_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Bool_Exp>>;
  _not?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_village.titolo_autorizzativo" */
export enum Energy_Village_Titolo_Autorizzativo_Constraint {
  /** unique or primary key constraint on columns "id" */
  TitoloAutorizzativoPkey = 'titolo_autorizzativo_pkey'
}

/** input type for incrementing numeric columns in table "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Energy_Village_Titolo_Autorizzativo_Max_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_titolo_autorizzativo_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Energy_Village_Titolo_Autorizzativo_Min_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "energy_village.energy_village_titolo_autorizzativo_translate_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Mutation_Response = {
  __typename?: 'energy_village_titolo_autorizzativo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Village_Titolo_Autorizzativo>;
};

/** on_conflict condition type for table "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_On_Conflict = {
  constraint: Energy_Village_Titolo_Autorizzativo_Constraint;
  update_columns?: Array<Energy_Village_Titolo_Autorizzativo_Update_Column>;
  where?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_village.titolo_autorizzativo". */
export type Energy_Village_Titolo_Autorizzativo_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_village.titolo_autorizzativo */
export type Energy_Village_Titolo_Autorizzativo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "energy_village.titolo_autorizzativo" */
export enum Energy_Village_Titolo_Autorizzativo_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "energy_village.titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Energy_Village_Titolo_Autorizzativo_Stddev_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Energy_Village_Titolo_Autorizzativo_Stddev_Pop_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Energy_Village_Titolo_Autorizzativo_Stddev_Samp_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "energy_village_titolo_autorizzativo" */
export type Energy_Village_Titolo_Autorizzativo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Village_Titolo_Autorizzativo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Village_Titolo_Autorizzativo_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Energy_Village_Titolo_Autorizzativo_Sum_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "energy_village.titolo_autorizzativo" */
export enum Energy_Village_Titolo_Autorizzativo_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label_',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Energy_Village_Titolo_Autorizzativo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Village_Titolo_Autorizzativo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Energy_Village_Titolo_Autorizzativo_Var_Pop_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Energy_Village_Titolo_Autorizzativo_Var_Samp_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Energy_Village_Titolo_Autorizzativo_Variance_Fields = {
  __typename?: 'energy_village_titolo_autorizzativo_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String']['output'];
  /** An array relationship */
  cersByVolantinoId: Array<Cer>;
  /** An aggregate relationship */
  cersByVolantinoId_aggregate: Cer_Aggregate;
  /** An array relationship */
  cersByWhiteLabelLogoChiaroId: Array<Cer>;
  /** An aggregate relationship */
  cersByWhiteLabelLogoChiaroId_aggregate: Cer_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "storage.files" */
export type FilesCersByVolantinoIdArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesCersByVolantinoId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesCersByWhiteLabelLogoChiaroIdArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesCersByWhiteLabelLogoChiaroId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  bucket?: InputMaybe<Buckets_Bool_Exp>;
  bucketId?: InputMaybe<String_Comparison_Exp>;
  cersByVolantinoId?: InputMaybe<Cer_Bool_Exp>;
  cersByVolantinoId_aggregate?: InputMaybe<Cer_Aggregate_Bool_Exp>;
  cersByWhiteLabelLogoChiaroId?: InputMaybe<Cer_Bool_Exp>;
  cersByWhiteLabelLogoChiaroId_aggregate?: InputMaybe<Cer_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  cersByVolantinoId?: InputMaybe<Cer_Arr_Rel_Insert_Input>;
  cersByWhiteLabelLogoChiaroId?: InputMaybe<Cer_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: InputMaybe<Buckets_Order_By>;
  bucketId?: InputMaybe<Order_By>;
  cersByVolantinoId_aggregate?: InputMaybe<Cer_Aggregate_Order_By>;
  cersByWhiteLabelLogoChiaroId_aggregate?: InputMaybe<Cer_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUploaded?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "flussi_gse.flusso" */
export type Flussi_Gse_Flusso = {
  __typename?: 'flussi_gse_flusso';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Int']['output']>;
  auth_id: Scalars['String']['output'];
  /** An object relationship */
  cer?: Maybe<Cer>;
  /** Colonna "Contratto ACC/CER" (in alcuni flussi "Contratto") */
  contratto_acc_cer?: Maybe<Scalars['String']['output']>;
  /** Colonna "Contratto RIDC" */
  contratto_ridc?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  /** Data di fatturazione (campo "Data fatturazione") */
  data_fatturazione?: Maybe<Scalars['date']['output']>;
  /** Data di incasso (campo "Data incasso") */
  data_incasso?: Maybe<Scalars['date']['output']>;
  /** Data di pagamento (campo "Data pagamento") */
  data_pagamento?: Maybe<Scalars['date']['output']>;
  /** Data di pubblicazione del flusso (campo "Data pubblicazione") */
  data_pubblicazione?: Maybe<Scalars['date']['output']>;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['numeric']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Int']['output']>;
  nome: Scalars['String']['output'];
  /** Numero della fattura (campo "Numero fattura", testo: può contenere lettere e separatori) */
  numero_fattura?: Maybe<Scalars['String']['output']>;
  /** Colonna "Soggetto Referente" */
  soggetto_referente?: Maybe<Scalars['String']['output']>;
  /** Stato della fattura del flusso (campo "Stato fattura", testo libero) */
  stato_fattura?: Maybe<Scalars['String']['output']>;
  /** Colonna "Tipo Corrispettivo" (in alcuni flussi "Natura economica") */
  tipo_corrispettivo?: Maybe<Scalars['String']['output']>;
  /** Tipologia calcolo (Acconto, Calcolo Completo/Parziale, Ricalcolo Completo/Parziale, Storno): id di selects.tipologia_calcolo */
  tipologia_calcolo_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "flussi_gse.flusso" */
export type Flussi_Gse_FlussoDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_Aggregate = {
  __typename?: 'flussi_gse_flusso_aggregate';
  aggregate?: Maybe<Flussi_Gse_Flusso_Aggregate_Fields>;
  nodes: Array<Flussi_Gse_Flusso>;
};

/** aggregate fields of "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_Aggregate_Fields = {
  __typename?: 'flussi_gse_flusso_aggregate_fields';
  avg?: Maybe<Flussi_Gse_Flusso_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Flussi_Gse_Flusso_Max_Fields>;
  min?: Maybe<Flussi_Gse_Flusso_Min_Fields>;
  stddev?: Maybe<Flussi_Gse_Flusso_Stddev_Fields>;
  stddev_pop?: Maybe<Flussi_Gse_Flusso_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flussi_Gse_Flusso_Stddev_Samp_Fields>;
  sum?: Maybe<Flussi_Gse_Flusso_Sum_Fields>;
  var_pop?: Maybe<Flussi_Gse_Flusso_Var_Pop_Fields>;
  var_samp?: Maybe<Flussi_Gse_Flusso_Var_Samp_Fields>;
  variance?: Maybe<Flussi_Gse_Flusso_Variance_Fields>;
};


/** aggregate fields of "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flussi_Gse_Flusso_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Flussi_Gse_Flusso_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Flussi_Gse_Flusso_Avg_Fields = {
  __typename?: 'flussi_gse_flusso_avg_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Float']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['Float']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "flussi_gse.flusso". All fields are combined with a logical 'AND'. */
export type Flussi_Gse_Flusso_Bool_Exp = {
  _and?: InputMaybe<Array<Flussi_Gse_Flusso_Bool_Exp>>;
  _not?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
  _or?: InputMaybe<Array<Flussi_Gse_Flusso_Bool_Exp>>;
  anno?: InputMaybe<Int_Comparison_Exp>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  contratto_acc_cer?: InputMaybe<String_Comparison_Exp>;
  contratto_ridc?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  data_fatturazione?: InputMaybe<Date_Comparison_Exp>;
  data_incasso?: InputMaybe<Date_Comparison_Exp>;
  data_pagamento?: InputMaybe<Date_Comparison_Exp>;
  data_pubblicazione?: InputMaybe<Date_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  importo?: InputMaybe<Numeric_Comparison_Exp>;
  mese?: InputMaybe<Int_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  numero_fattura?: InputMaybe<String_Comparison_Exp>;
  soggetto_referente?: InputMaybe<String_Comparison_Exp>;
  stato_fattura?: InputMaybe<String_Comparison_Exp>;
  tipo_corrispettivo?: InputMaybe<String_Comparison_Exp>;
  tipologia_calcolo_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "flussi_gse.flusso" */
export enum Flussi_Gse_Flusso_Constraint {
  /** unique or primary key constraint on columns "id" */
  FlussoPkey = 'flusso_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Flussi_Gse_Flusso_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Flussi_Gse_Flusso_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Flussi_Gse_Flusso_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_Inc_Input = {
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: InputMaybe<Scalars['Int']['input']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: InputMaybe<Scalars['numeric']['input']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_Insert_Input = {
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: InputMaybe<Scalars['Int']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  /** Colonna "Contratto ACC/CER" (in alcuni flussi "Contratto") */
  contratto_acc_cer?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Contratto RIDC" */
  contratto_ridc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Data di fatturazione (campo "Data fatturazione") */
  data_fatturazione?: InputMaybe<Scalars['date']['input']>;
  /** Data di incasso (campo "Data incasso") */
  data_incasso?: InputMaybe<Scalars['date']['input']>;
  /** Data di pagamento (campo "Data pagamento") */
  data_pagamento?: InputMaybe<Scalars['date']['input']>;
  /** Data di pubblicazione del flusso (campo "Data pubblicazione") */
  data_pubblicazione?: InputMaybe<Scalars['date']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: InputMaybe<Scalars['numeric']['input']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  /** Numero della fattura (campo "Numero fattura", testo: può contenere lettere e separatori) */
  numero_fattura?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Soggetto Referente" */
  soggetto_referente?: InputMaybe<Scalars['String']['input']>;
  /** Stato della fattura del flusso (campo "Stato fattura", testo libero) */
  stato_fattura?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Tipo Corrispettivo" (in alcuni flussi "Natura economica") */
  tipo_corrispettivo?: InputMaybe<Scalars['String']['input']>;
  /** Tipologia calcolo (Acconto, Calcolo Completo/Parziale, Ricalcolo Completo/Parziale, Storno): id di selects.tipologia_calcolo */
  tipologia_calcolo_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Flussi_Gse_Flusso_Max_Fields = {
  __typename?: 'flussi_gse_flusso_max_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Int']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  /** Colonna "Contratto ACC/CER" (in alcuni flussi "Contratto") */
  contratto_acc_cer?: Maybe<Scalars['String']['output']>;
  /** Colonna "Contratto RIDC" */
  contratto_ridc?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Data di fatturazione (campo "Data fatturazione") */
  data_fatturazione?: Maybe<Scalars['date']['output']>;
  /** Data di incasso (campo "Data incasso") */
  data_incasso?: Maybe<Scalars['date']['output']>;
  /** Data di pagamento (campo "Data pagamento") */
  data_pagamento?: Maybe<Scalars['date']['output']>;
  /** Data di pubblicazione del flusso (campo "Data pubblicazione") */
  data_pubblicazione?: Maybe<Scalars['date']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['numeric']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  /** Numero della fattura (campo "Numero fattura", testo: può contenere lettere e separatori) */
  numero_fattura?: Maybe<Scalars['String']['output']>;
  /** Colonna "Soggetto Referente" */
  soggetto_referente?: Maybe<Scalars['String']['output']>;
  /** Stato della fattura del flusso (campo "Stato fattura", testo libero) */
  stato_fattura?: Maybe<Scalars['String']['output']>;
  /** Colonna "Tipo Corrispettivo" (in alcuni flussi "Natura economica") */
  tipo_corrispettivo?: Maybe<Scalars['String']['output']>;
  /** Tipologia calcolo (Acconto, Calcolo Completo/Parziale, Ricalcolo Completo/Parziale, Storno): id di selects.tipologia_calcolo */
  tipologia_calcolo_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Flussi_Gse_Flusso_Min_Fields = {
  __typename?: 'flussi_gse_flusso_min_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Int']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  /** Colonna "Contratto ACC/CER" (in alcuni flussi "Contratto") */
  contratto_acc_cer?: Maybe<Scalars['String']['output']>;
  /** Colonna "Contratto RIDC" */
  contratto_ridc?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Data di fatturazione (campo "Data fatturazione") */
  data_fatturazione?: Maybe<Scalars['date']['output']>;
  /** Data di incasso (campo "Data incasso") */
  data_incasso?: Maybe<Scalars['date']['output']>;
  /** Data di pagamento (campo "Data pagamento") */
  data_pagamento?: Maybe<Scalars['date']['output']>;
  /** Data di pubblicazione del flusso (campo "Data pubblicazione") */
  data_pubblicazione?: Maybe<Scalars['date']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['numeric']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  /** Numero della fattura (campo "Numero fattura", testo: può contenere lettere e separatori) */
  numero_fattura?: Maybe<Scalars['String']['output']>;
  /** Colonna "Soggetto Referente" */
  soggetto_referente?: Maybe<Scalars['String']['output']>;
  /** Stato della fattura del flusso (campo "Stato fattura", testo libero) */
  stato_fattura?: Maybe<Scalars['String']['output']>;
  /** Colonna "Tipo Corrispettivo" (in alcuni flussi "Natura economica") */
  tipo_corrispettivo?: Maybe<Scalars['String']['output']>;
  /** Tipologia calcolo (Acconto, Calcolo Completo/Parziale, Ricalcolo Completo/Parziale, Storno): id di selects.tipologia_calcolo */
  tipologia_calcolo_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_Mutation_Response = {
  __typename?: 'flussi_gse_flusso_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Flussi_Gse_Flusso>;
};

/** on_conflict condition type for table "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_On_Conflict = {
  constraint: Flussi_Gse_Flusso_Constraint;
  update_columns?: Array<Flussi_Gse_Flusso_Update_Column>;
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
};

/** Ordering options when selecting data from "flussi_gse.flusso". */
export type Flussi_Gse_Flusso_Order_By = {
  anno?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  cer?: InputMaybe<Cer_Order_By>;
  contratto_acc_cer?: InputMaybe<Order_By>;
  contratto_ridc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  data_fatturazione?: InputMaybe<Order_By>;
  data_incasso?: InputMaybe<Order_By>;
  data_pagamento?: InputMaybe<Order_By>;
  data_pubblicazione?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importo?: InputMaybe<Order_By>;
  mese?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  numero_fattura?: InputMaybe<Order_By>;
  soggetto_referente?: InputMaybe<Order_By>;
  stato_fattura?: InputMaybe<Order_By>;
  tipo_corrispettivo?: InputMaybe<Order_By>;
  tipologia_calcolo_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: flussi_gse.flusso */
export type Flussi_Gse_Flusso_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Flussi_Gse_Flusso_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "flussi_gse.flusso" */
export enum Flussi_Gse_Flusso_Select_Column {
  /** column name */
  Anno = 'anno',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ContrattoAccCer = 'contratto_acc_cer',
  /** column name */
  ContrattoRidc = 'contratto_ridc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DataFatturazione = 'data_fatturazione',
  /** column name */
  DataIncasso = 'data_incasso',
  /** column name */
  DataPagamento = 'data_pagamento',
  /** column name */
  DataPubblicazione = 'data_pubblicazione',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Importo = 'importo',
  /** column name */
  Mese = 'mese',
  /** column name */
  Nome = 'nome',
  /** column name */
  NumeroFattura = 'numero_fattura',
  /** column name */
  SoggettoReferente = 'soggetto_referente',
  /** column name */
  StatoFattura = 'stato_fattura',
  /** column name */
  TipoCorrispettivo = 'tipo_corrispettivo',
  /** column name */
  TipologiaCalcoloId = 'tipologia_calcolo_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "flussi_gse.flusso" */
export type Flussi_Gse_Flusso_Set_Input = {
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: InputMaybe<Scalars['Int']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Contratto ACC/CER" (in alcuni flussi "Contratto") */
  contratto_acc_cer?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Contratto RIDC" */
  contratto_ridc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Data di fatturazione (campo "Data fatturazione") */
  data_fatturazione?: InputMaybe<Scalars['date']['input']>;
  /** Data di incasso (campo "Data incasso") */
  data_incasso?: InputMaybe<Scalars['date']['input']>;
  /** Data di pagamento (campo "Data pagamento") */
  data_pagamento?: InputMaybe<Scalars['date']['input']>;
  /** Data di pubblicazione del flusso (campo "Data pubblicazione") */
  data_pubblicazione?: InputMaybe<Scalars['date']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: InputMaybe<Scalars['numeric']['input']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  /** Numero della fattura (campo "Numero fattura", testo: può contenere lettere e separatori) */
  numero_fattura?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Soggetto Referente" */
  soggetto_referente?: InputMaybe<Scalars['String']['input']>;
  /** Stato della fattura del flusso (campo "Stato fattura", testo libero) */
  stato_fattura?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Tipo Corrispettivo" (in alcuni flussi "Natura economica") */
  tipo_corrispettivo?: InputMaybe<Scalars['String']['input']>;
  /** Tipologia calcolo (Acconto, Calcolo Completo/Parziale, Ricalcolo Completo/Parziale, Storno): id di selects.tipologia_calcolo */
  tipologia_calcolo_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Flussi_Gse_Flusso_Stddev_Fields = {
  __typename?: 'flussi_gse_flusso_stddev_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Float']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['Float']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Flussi_Gse_Flusso_Stddev_Pop_Fields = {
  __typename?: 'flussi_gse_flusso_stddev_pop_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Float']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['Float']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Flussi_Gse_Flusso_Stddev_Samp_Fields = {
  __typename?: 'flussi_gse_flusso_stddev_samp_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Float']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['Float']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "flussi_gse_flusso" */
export type Flussi_Gse_Flusso_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flussi_Gse_Flusso_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Flussi_Gse_Flusso_Stream_Cursor_Value_Input = {
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: InputMaybe<Scalars['Int']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Contratto ACC/CER" (in alcuni flussi "Contratto") */
  contratto_acc_cer?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Contratto RIDC" */
  contratto_ridc?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Data di fatturazione (campo "Data fatturazione") */
  data_fatturazione?: InputMaybe<Scalars['date']['input']>;
  /** Data di incasso (campo "Data incasso") */
  data_incasso?: InputMaybe<Scalars['date']['input']>;
  /** Data di pagamento (campo "Data pagamento") */
  data_pagamento?: InputMaybe<Scalars['date']['input']>;
  /** Data di pubblicazione del flusso (campo "Data pubblicazione") */
  data_pubblicazione?: InputMaybe<Scalars['date']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: InputMaybe<Scalars['numeric']['input']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  /** Numero della fattura (campo "Numero fattura", testo: può contenere lettere e separatori) */
  numero_fattura?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Soggetto Referente" */
  soggetto_referente?: InputMaybe<Scalars['String']['input']>;
  /** Stato della fattura del flusso (campo "Stato fattura", testo libero) */
  stato_fattura?: InputMaybe<Scalars['String']['input']>;
  /** Colonna "Tipo Corrispettivo" (in alcuni flussi "Natura economica") */
  tipo_corrispettivo?: InputMaybe<Scalars['String']['input']>;
  /** Tipologia calcolo (Acconto, Calcolo Completo/Parziale, Ricalcolo Completo/Parziale, Storno): id di selects.tipologia_calcolo */
  tipologia_calcolo_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Flussi_Gse_Flusso_Sum_Fields = {
  __typename?: 'flussi_gse_flusso_sum_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Int']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['numeric']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "flussi_gse.flusso" */
export enum Flussi_Gse_Flusso_Update_Column {
  /** column name */
  Anno = 'anno',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ContrattoAccCer = 'contratto_acc_cer',
  /** column name */
  ContrattoRidc = 'contratto_ridc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  DataFatturazione = 'data_fatturazione',
  /** column name */
  DataIncasso = 'data_incasso',
  /** column name */
  DataPagamento = 'data_pagamento',
  /** column name */
  DataPubblicazione = 'data_pubblicazione',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Importo = 'importo',
  /** column name */
  Mese = 'mese',
  /** column name */
  Nome = 'nome',
  /** column name */
  NumeroFattura = 'numero_fattura',
  /** column name */
  SoggettoReferente = 'soggetto_referente',
  /** column name */
  StatoFattura = 'stato_fattura',
  /** column name */
  TipoCorrispettivo = 'tipo_corrispettivo',
  /** column name */
  TipologiaCalcoloId = 'tipologia_calcolo_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Flussi_Gse_Flusso_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Flussi_Gse_Flusso_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Flussi_Gse_Flusso_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Flussi_Gse_Flusso_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Flussi_Gse_Flusso_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Flussi_Gse_Flusso_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Flussi_Gse_Flusso_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flussi_Gse_Flusso_Set_Input>;
  /** filter the rows which have to be updated */
  where: Flussi_Gse_Flusso_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Flussi_Gse_Flusso_Var_Pop_Fields = {
  __typename?: 'flussi_gse_flusso_var_pop_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Float']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['Float']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Flussi_Gse_Flusso_Var_Samp_Fields = {
  __typename?: 'flussi_gse_flusso_var_samp_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Float']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['Float']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Flussi_Gse_Flusso_Variance_Fields = {
  __typename?: 'flussi_gse_flusso_variance_fields';
  /** Anno di competenza del flusso (colonna "Anno") */
  anno?: Maybe<Scalars['Float']['output']>;
  /** Importo in euro, due decimali (campo "Importo (€)"); nessun vincolo di segno: storni e ricalcoli possono essere negativi */
  importo?: Maybe<Scalars['Float']['output']>;
  /** Mese di competenza, 1-12 (colonna "Mese") */
  mese?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "funzione_log" */
export type Funzione_Log = {
  __typename?: 'funzione_log';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  funzione?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  messaggio?: Maybe<Scalars['String']['output']>;
  sottoscrizioneid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "funzione_log" */
export type Funzione_Log_Aggregate = {
  __typename?: 'funzione_log_aggregate';
  aggregate?: Maybe<Funzione_Log_Aggregate_Fields>;
  nodes: Array<Funzione_Log>;
};

/** aggregate fields of "funzione_log" */
export type Funzione_Log_Aggregate_Fields = {
  __typename?: 'funzione_log_aggregate_fields';
  avg?: Maybe<Funzione_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Funzione_Log_Max_Fields>;
  min?: Maybe<Funzione_Log_Min_Fields>;
  stddev?: Maybe<Funzione_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Funzione_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Funzione_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Funzione_Log_Sum_Fields>;
  var_pop?: Maybe<Funzione_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Funzione_Log_Var_Samp_Fields>;
  variance?: Maybe<Funzione_Log_Variance_Fields>;
};


/** aggregate fields of "funzione_log" */
export type Funzione_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funzione_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Funzione_Log_Avg_Fields = {
  __typename?: 'funzione_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "funzione_log". All fields are combined with a logical 'AND'. */
export type Funzione_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Funzione_Log_Bool_Exp>>;
  _not?: InputMaybe<Funzione_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Funzione_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  funzione?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  messaggio?: InputMaybe<String_Comparison_Exp>;
  sottoscrizioneid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "funzione_log" */
export enum Funzione_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  FunzioneLogPkey = 'funzione_log_pkey'
}

/** input type for incrementing numeric columns in table "funzione_log" */
export type Funzione_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "funzione_log" */
export type Funzione_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  funzione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messaggio?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Funzione_Log_Max_Fields = {
  __typename?: 'funzione_log_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  funzione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messaggio?: Maybe<Scalars['String']['output']>;
  sottoscrizioneid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Funzione_Log_Min_Fields = {
  __typename?: 'funzione_log_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  funzione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messaggio?: Maybe<Scalars['String']['output']>;
  sottoscrizioneid?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "funzione_log" */
export type Funzione_Log_Mutation_Response = {
  __typename?: 'funzione_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Funzione_Log>;
};

/** on_conflict condition type for table "funzione_log" */
export type Funzione_Log_On_Conflict = {
  constraint: Funzione_Log_Constraint;
  update_columns?: Array<Funzione_Log_Update_Column>;
  where?: InputMaybe<Funzione_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "funzione_log". */
export type Funzione_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  funzione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messaggio?: InputMaybe<Order_By>;
  sottoscrizioneid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: funzione_log */
export type Funzione_Log_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "funzione_log" */
export enum Funzione_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Funzione = 'funzione',
  /** column name */
  Id = 'id',
  /** column name */
  Messaggio = 'messaggio',
  /** column name */
  Sottoscrizioneid = 'sottoscrizioneid'
}

/** input type for updating data in table "funzione_log" */
export type Funzione_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  funzione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messaggio?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Funzione_Log_Stddev_Fields = {
  __typename?: 'funzione_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Funzione_Log_Stddev_Pop_Fields = {
  __typename?: 'funzione_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Funzione_Log_Stddev_Samp_Fields = {
  __typename?: 'funzione_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "funzione_log" */
export type Funzione_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funzione_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funzione_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  funzione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messaggio?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Funzione_Log_Sum_Fields = {
  __typename?: 'funzione_log_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "funzione_log" */
export enum Funzione_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Funzione = 'funzione',
  /** column name */
  Id = 'id',
  /** column name */
  Messaggio = 'messaggio',
  /** column name */
  Sottoscrizioneid = 'sottoscrizioneid'
}

export type Funzione_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Funzione_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funzione_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Funzione_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Funzione_Log_Var_Pop_Fields = {
  __typename?: 'funzione_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Funzione_Log_Var_Samp_Fields = {
  __typename?: 'funzione_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Funzione_Log_Variance_Fields = {
  __typename?: 'funzione_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

/** columns and relationships of "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo = {
  __typename?: 'incentivi__stato_calcolo';
  text: Scalars['String']['output'];
};

/** aggregated selection of "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo_Aggregate = {
  __typename?: 'incentivi__stato_calcolo_aggregate';
  aggregate?: Maybe<Incentivi__Stato_Calcolo_Aggregate_Fields>;
  nodes: Array<Incentivi__Stato_Calcolo>;
};

/** aggregate fields of "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo_Aggregate_Fields = {
  __typename?: 'incentivi__stato_calcolo_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Incentivi__Stato_Calcolo_Max_Fields>;
  min?: Maybe<Incentivi__Stato_Calcolo_Min_Fields>;
};


/** aggregate fields of "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incentivi__Stato_Calcolo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "incentivi._stato_calcolo". All fields are combined with a logical 'AND'. */
export type Incentivi__Stato_Calcolo_Bool_Exp = {
  _and?: InputMaybe<Array<Incentivi__Stato_Calcolo_Bool_Exp>>;
  _not?: InputMaybe<Incentivi__Stato_Calcolo_Bool_Exp>;
  _or?: InputMaybe<Array<Incentivi__Stato_Calcolo_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "incentivi._stato_calcolo" */
export enum Incentivi__Stato_Calcolo_Constraint {
  /** unique or primary key constraint on columns "text" */
  _StatoCalcoloPkey = '_stato_calcolo_pkey'
}

export enum Incentivi__Stato_Calcolo_Enum {
  Completato = 'completato',
  Errore = 'errore',
  InElaborazione = 'in_elaborazione',
  NonPresente = 'non_presente'
}

/** Boolean expression to compare columns of type "incentivi__stato_calcolo_enum". All fields are combined with logical 'AND'. */
export type Incentivi__Stato_Calcolo_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Incentivi__Stato_Calcolo_Enum>;
  _in?: InputMaybe<Array<Incentivi__Stato_Calcolo_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Incentivi__Stato_Calcolo_Enum>;
  _nin?: InputMaybe<Array<Incentivi__Stato_Calcolo_Enum>>;
};

/** input type for inserting data into table "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Incentivi__Stato_Calcolo_Max_Fields = {
  __typename?: 'incentivi__stato_calcolo_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Incentivi__Stato_Calcolo_Min_Fields = {
  __typename?: 'incentivi__stato_calcolo_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo_Mutation_Response = {
  __typename?: 'incentivi__stato_calcolo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incentivi__Stato_Calcolo>;
};

/** on_conflict condition type for table "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo_On_Conflict = {
  constraint: Incentivi__Stato_Calcolo_Constraint;
  update_columns?: Array<Incentivi__Stato_Calcolo_Update_Column>;
  where?: InputMaybe<Incentivi__Stato_Calcolo_Bool_Exp>;
};

/** Ordering options when selecting data from "incentivi._stato_calcolo". */
export type Incentivi__Stato_Calcolo_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incentivi._stato_calcolo */
export type Incentivi__Stato_Calcolo_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "incentivi._stato_calcolo" */
export enum Incentivi__Stato_Calcolo_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "incentivi._stato_calcolo" */
export type Incentivi__Stato_Calcolo_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "incentivi__stato_calcolo" */
export type Incentivi__Stato_Calcolo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incentivi__Stato_Calcolo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incentivi__Stato_Calcolo_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "incentivi._stato_calcolo" */
export enum Incentivi__Stato_Calcolo_Update_Column {
  /** column name */
  Text = 'text'
}

export type Incentivi__Stato_Calcolo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incentivi__Stato_Calcolo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incentivi__Stato_Calcolo_Bool_Exp;
};

/** columns and relationships of "incentivi.calcolati" */
export type Incentivi_Calcolati = {
  __typename?: 'incentivi_calcolati';
  aggregati: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  misure: Scalars['jsonb']['output'];
  /** An object relationship */
  ripartizione: Incentivi_Ripartizione;
  ripartizione_id: Scalars['uuid']['output'];
  /** An object relationship */
  sottoscrizione: Sottoscrizione;
  sottoscrizione_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "incentivi.calcolati" */
export type Incentivi_CalcolatiAggregatiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "incentivi.calcolati" */
export type Incentivi_CalcolatiMisureArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "incentivi.calcolati" */
export type Incentivi_Calcolati_Aggregate = {
  __typename?: 'incentivi_calcolati_aggregate';
  aggregate?: Maybe<Incentivi_Calcolati_Aggregate_Fields>;
  nodes: Array<Incentivi_Calcolati>;
};

export type Incentivi_Calcolati_Aggregate_Bool_Exp = {
  count?: InputMaybe<Incentivi_Calcolati_Aggregate_Bool_Exp_Count>;
};

export type Incentivi_Calcolati_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "incentivi.calcolati" */
export type Incentivi_Calcolati_Aggregate_Fields = {
  __typename?: 'incentivi_calcolati_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Incentivi_Calcolati_Max_Fields>;
  min?: Maybe<Incentivi_Calcolati_Min_Fields>;
};


/** aggregate fields of "incentivi.calcolati" */
export type Incentivi_Calcolati_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "incentivi.calcolati" */
export type Incentivi_Calcolati_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Incentivi_Calcolati_Max_Order_By>;
  min?: InputMaybe<Incentivi_Calcolati_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Incentivi_Calcolati_Append_Input = {
  aggregati?: InputMaybe<Scalars['jsonb']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "incentivi.calcolati" */
export type Incentivi_Calcolati_Arr_Rel_Insert_Input = {
  data: Array<Incentivi_Calcolati_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Incentivi_Calcolati_On_Conflict>;
};

/** Boolean expression to filter rows from the table "incentivi.calcolati". All fields are combined with a logical 'AND'. */
export type Incentivi_Calcolati_Bool_Exp = {
  _and?: InputMaybe<Array<Incentivi_Calcolati_Bool_Exp>>;
  _not?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
  _or?: InputMaybe<Array<Incentivi_Calcolati_Bool_Exp>>;
  aggregati?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  misure?: InputMaybe<Jsonb_Comparison_Exp>;
  ripartizione?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
  ripartizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "incentivi.calcolati" */
export enum Incentivi_Calcolati_Constraint {
  /** unique or primary key constraint on columns "id" */
  CalcolatiPkey = 'calcolati_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Incentivi_Calcolati_Delete_At_Path_Input = {
  aggregati?: InputMaybe<Array<Scalars['String']['input']>>;
  misure?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Incentivi_Calcolati_Delete_Elem_Input = {
  aggregati?: InputMaybe<Scalars['Int']['input']>;
  misure?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Incentivi_Calcolati_Delete_Key_Input = {
  aggregati?: InputMaybe<Scalars['String']['input']>;
  misure?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "incentivi.calcolati" */
export type Incentivi_Calcolati_Insert_Input = {
  aggregati?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  ripartizione?: InputMaybe<Incentivi_Ripartizione_Obj_Rel_Insert_Input>;
  ripartizione_id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Incentivi_Calcolati_Max_Fields = {
  __typename?: 'incentivi_calcolati_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ripartizione_id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "incentivi.calcolati" */
export type Incentivi_Calcolati_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ripartizione_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Incentivi_Calcolati_Min_Fields = {
  __typename?: 'incentivi_calcolati_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ripartizione_id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "incentivi.calcolati" */
export type Incentivi_Calcolati_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ripartizione_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "incentivi.calcolati" */
export type Incentivi_Calcolati_Mutation_Response = {
  __typename?: 'incentivi_calcolati_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incentivi_Calcolati>;
};

/** on_conflict condition type for table "incentivi.calcolati" */
export type Incentivi_Calcolati_On_Conflict = {
  constraint: Incentivi_Calcolati_Constraint;
  update_columns?: Array<Incentivi_Calcolati_Update_Column>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};

/** Ordering options when selecting data from "incentivi.calcolati". */
export type Incentivi_Calcolati_Order_By = {
  aggregati?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  misure?: InputMaybe<Order_By>;
  ripartizione?: InputMaybe<Incentivi_Ripartizione_Order_By>;
  ripartizione_id?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incentivi.calcolati */
export type Incentivi_Calcolati_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Incentivi_Calcolati_Prepend_Input = {
  aggregati?: InputMaybe<Scalars['jsonb']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "incentivi.calcolati" */
export enum Incentivi_Calcolati_Select_Column {
  /** column name */
  Aggregati = 'aggregati',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Misure = 'misure',
  /** column name */
  RipartizioneId = 'ripartizione_id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "incentivi.calcolati" */
export type Incentivi_Calcolati_Set_Input = {
  aggregati?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  ripartizione_id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "incentivi_calcolati" */
export type Incentivi_Calcolati_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incentivi_Calcolati_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incentivi_Calcolati_Stream_Cursor_Value_Input = {
  aggregati?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  ripartizione_id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "incentivi.calcolati" */
export enum Incentivi_Calcolati_Update_Column {
  /** column name */
  Aggregati = 'aggregati',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Misure = 'misure',
  /** column name */
  RipartizioneId = 'ripartizione_id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Incentivi_Calcolati_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Incentivi_Calcolati_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Incentivi_Calcolati_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Incentivi_Calcolati_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Incentivi_Calcolati_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Incentivi_Calcolati_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incentivi_Calcolati_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incentivi_Calcolati_Bool_Exp;
};

/** columns and relationships of "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione = {
  __typename?: 'incentivi_log_ripartizione';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ripartizione: Incentivi_Ripartizione;
  ripartizione_id: Scalars['uuid']['output'];
  testo: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione_Aggregate = {
  __typename?: 'incentivi_log_ripartizione_aggregate';
  aggregate?: Maybe<Incentivi_Log_Ripartizione_Aggregate_Fields>;
  nodes: Array<Incentivi_Log_Ripartizione>;
};

/** aggregate fields of "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione_Aggregate_Fields = {
  __typename?: 'incentivi_log_ripartizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Incentivi_Log_Ripartizione_Max_Fields>;
  min?: Maybe<Incentivi_Log_Ripartizione_Min_Fields>;
};


/** aggregate fields of "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incentivi_Log_Ripartizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "incentivi.log_ripartizione". All fields are combined with a logical 'AND'. */
export type Incentivi_Log_Ripartizione_Bool_Exp = {
  _and?: InputMaybe<Array<Incentivi_Log_Ripartizione_Bool_Exp>>;
  _not?: InputMaybe<Incentivi_Log_Ripartizione_Bool_Exp>;
  _or?: InputMaybe<Array<Incentivi_Log_Ripartizione_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ripartizione?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
  ripartizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  testo?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "incentivi.log_ripartizione" */
export enum Incentivi_Log_Ripartizione_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogRipartizionePkey = 'log_ripartizione_pkey'
}

/** input type for inserting data into table "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ripartizione?: InputMaybe<Incentivi_Ripartizione_Obj_Rel_Insert_Input>;
  ripartizione_id?: InputMaybe<Scalars['uuid']['input']>;
  testo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Incentivi_Log_Ripartizione_Max_Fields = {
  __typename?: 'incentivi_log_ripartizione_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ripartizione_id?: Maybe<Scalars['uuid']['output']>;
  testo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Incentivi_Log_Ripartizione_Min_Fields = {
  __typename?: 'incentivi_log_ripartizione_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ripartizione_id?: Maybe<Scalars['uuid']['output']>;
  testo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione_Mutation_Response = {
  __typename?: 'incentivi_log_ripartizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incentivi_Log_Ripartizione>;
};

/** on_conflict condition type for table "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione_On_Conflict = {
  constraint: Incentivi_Log_Ripartizione_Constraint;
  update_columns?: Array<Incentivi_Log_Ripartizione_Update_Column>;
  where?: InputMaybe<Incentivi_Log_Ripartizione_Bool_Exp>;
};

/** Ordering options when selecting data from "incentivi.log_ripartizione". */
export type Incentivi_Log_Ripartizione_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ripartizione?: InputMaybe<Incentivi_Ripartizione_Order_By>;
  ripartizione_id?: InputMaybe<Order_By>;
  testo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incentivi.log_ripartizione */
export type Incentivi_Log_Ripartizione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "incentivi.log_ripartizione" */
export enum Incentivi_Log_Ripartizione_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RipartizioneId = 'ripartizione_id',
  /** column name */
  Testo = 'testo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "incentivi.log_ripartizione" */
export type Incentivi_Log_Ripartizione_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ripartizione_id?: InputMaybe<Scalars['uuid']['input']>;
  testo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "incentivi_log_ripartizione" */
export type Incentivi_Log_Ripartizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incentivi_Log_Ripartizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incentivi_Log_Ripartizione_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ripartizione_id?: InputMaybe<Scalars['uuid']['input']>;
  testo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "incentivi.log_ripartizione" */
export enum Incentivi_Log_Ripartizione_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RipartizioneId = 'ripartizione_id',
  /** column name */
  Testo = 'testo',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Incentivi_Log_Ripartizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incentivi_Log_Ripartizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incentivi_Log_Ripartizione_Bool_Exp;
};

/** columns and relationships of "incentivi.ripartizione" */
export type Incentivi_Ripartizione = {
  __typename?: 'incentivi_ripartizione';
  anagrafiche?: Maybe<Scalars['jsonb']['output']>;
  calcolati?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  calcolati_singoli: Array<Incentivi_Calcolati>;
  /** An aggregate relationship */
  calcolati_singoli_aggregate: Incentivi_Calcolati_Aggregate;
  calcolo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  cer_cabina: Cer_Cabina;
  cer_cabina_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  misure?: Maybe<Scalars['jsonb']['output']>;
  parametri: Scalars['jsonb']['output'];
  stato_calcolo?: Maybe<Incentivi__Stato_Calcolo_Enum>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "incentivi.ripartizione" */
export type Incentivi_RipartizioneAnagraficheArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "incentivi.ripartizione" */
export type Incentivi_RipartizioneCalcolatiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "incentivi.ripartizione" */
export type Incentivi_RipartizioneCalcolati_SingoliArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Calcolati_Order_By>>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};


/** columns and relationships of "incentivi.ripartizione" */
export type Incentivi_RipartizioneCalcolati_Singoli_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Calcolati_Order_By>>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};


/** columns and relationships of "incentivi.ripartizione" */
export type Incentivi_RipartizioneMisureArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "incentivi.ripartizione" */
export type Incentivi_RipartizioneParametriArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "incentivi.ripartizione" */
export type Incentivi_Ripartizione_Aggregate = {
  __typename?: 'incentivi_ripartizione_aggregate';
  aggregate?: Maybe<Incentivi_Ripartizione_Aggregate_Fields>;
  nodes: Array<Incentivi_Ripartizione>;
};

/** aggregate fields of "incentivi.ripartizione" */
export type Incentivi_Ripartizione_Aggregate_Fields = {
  __typename?: 'incentivi_ripartizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Incentivi_Ripartizione_Max_Fields>;
  min?: Maybe<Incentivi_Ripartizione_Min_Fields>;
};


/** aggregate fields of "incentivi.ripartizione" */
export type Incentivi_Ripartizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incentivi_Ripartizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Incentivi_Ripartizione_Append_Input = {
  anagrafiche?: InputMaybe<Scalars['jsonb']['input']>;
  calcolati?: InputMaybe<Scalars['jsonb']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  parametri?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "incentivi.ripartizione". All fields are combined with a logical 'AND'. */
export type Incentivi_Ripartizione_Bool_Exp = {
  _and?: InputMaybe<Array<Incentivi_Ripartizione_Bool_Exp>>;
  _not?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
  _or?: InputMaybe<Array<Incentivi_Ripartizione_Bool_Exp>>;
  anagrafiche?: InputMaybe<Jsonb_Comparison_Exp>;
  calcolati?: InputMaybe<Jsonb_Comparison_Exp>;
  calcolati_singoli?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
  calcolati_singoli_aggregate?: InputMaybe<Incentivi_Calcolati_Aggregate_Bool_Exp>;
  calcolo?: InputMaybe<String_Comparison_Exp>;
  cer_cabina?: InputMaybe<Cer_Cabina_Bool_Exp>;
  cer_cabina_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  misure?: InputMaybe<Jsonb_Comparison_Exp>;
  parametri?: InputMaybe<Jsonb_Comparison_Exp>;
  stato_calcolo?: InputMaybe<Incentivi__Stato_Calcolo_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "incentivi.ripartizione" */
export enum Incentivi_Ripartizione_Constraint {
  /** unique or primary key constraint on columns "id" */
  RipartizionePkey = 'ripartizione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Incentivi_Ripartizione_Delete_At_Path_Input = {
  anagrafiche?: InputMaybe<Array<Scalars['String']['input']>>;
  calcolati?: InputMaybe<Array<Scalars['String']['input']>>;
  misure?: InputMaybe<Array<Scalars['String']['input']>>;
  parametri?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Incentivi_Ripartizione_Delete_Elem_Input = {
  anagrafiche?: InputMaybe<Scalars['Int']['input']>;
  calcolati?: InputMaybe<Scalars['Int']['input']>;
  misure?: InputMaybe<Scalars['Int']['input']>;
  parametri?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Incentivi_Ripartizione_Delete_Key_Input = {
  anagrafiche?: InputMaybe<Scalars['String']['input']>;
  calcolati?: InputMaybe<Scalars['String']['input']>;
  misure?: InputMaybe<Scalars['String']['input']>;
  parametri?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "incentivi.ripartizione" */
export type Incentivi_Ripartizione_Insert_Input = {
  anagrafiche?: InputMaybe<Scalars['jsonb']['input']>;
  calcolati?: InputMaybe<Scalars['jsonb']['input']>;
  calcolati_singoli?: InputMaybe<Incentivi_Calcolati_Arr_Rel_Insert_Input>;
  calcolo?: InputMaybe<Scalars['String']['input']>;
  cer_cabina?: InputMaybe<Cer_Cabina_Obj_Rel_Insert_Input>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  parametri?: InputMaybe<Scalars['jsonb']['input']>;
  stato_calcolo?: InputMaybe<Incentivi__Stato_Calcolo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Incentivi_Ripartizione_Max_Fields = {
  __typename?: 'incentivi_ripartizione_max_fields';
  calcolo?: Maybe<Scalars['String']['output']>;
  cer_cabina_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Incentivi_Ripartizione_Min_Fields = {
  __typename?: 'incentivi_ripartizione_min_fields';
  calcolo?: Maybe<Scalars['String']['output']>;
  cer_cabina_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "incentivi.ripartizione" */
export type Incentivi_Ripartizione_Mutation_Response = {
  __typename?: 'incentivi_ripartizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incentivi_Ripartizione>;
};

/** input type for inserting object relation for remote table "incentivi.ripartizione" */
export type Incentivi_Ripartizione_Obj_Rel_Insert_Input = {
  data: Incentivi_Ripartizione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Incentivi_Ripartizione_On_Conflict>;
};

/** on_conflict condition type for table "incentivi.ripartizione" */
export type Incentivi_Ripartizione_On_Conflict = {
  constraint: Incentivi_Ripartizione_Constraint;
  update_columns?: Array<Incentivi_Ripartizione_Update_Column>;
  where?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
};

/** Ordering options when selecting data from "incentivi.ripartizione". */
export type Incentivi_Ripartizione_Order_By = {
  anagrafiche?: InputMaybe<Order_By>;
  calcolati?: InputMaybe<Order_By>;
  calcolati_singoli_aggregate?: InputMaybe<Incentivi_Calcolati_Aggregate_Order_By>;
  calcolo?: InputMaybe<Order_By>;
  cer_cabina?: InputMaybe<Cer_Cabina_Order_By>;
  cer_cabina_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  misure?: InputMaybe<Order_By>;
  parametri?: InputMaybe<Order_By>;
  stato_calcolo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incentivi.ripartizione */
export type Incentivi_Ripartizione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Incentivi_Ripartizione_Prepend_Input = {
  anagrafiche?: InputMaybe<Scalars['jsonb']['input']>;
  calcolati?: InputMaybe<Scalars['jsonb']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  parametri?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "incentivi.ripartizione" */
export enum Incentivi_Ripartizione_Select_Column {
  /** column name */
  Anagrafiche = 'anagrafiche',
  /** column name */
  Calcolati = 'calcolati',
  /** column name */
  Calcolo = 'calcolo',
  /** column name */
  CerCabinaId = 'cer_cabina_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Misure = 'misure',
  /** column name */
  Parametri = 'parametri',
  /** column name */
  StatoCalcolo = 'stato_calcolo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "incentivi.ripartizione" */
export type Incentivi_Ripartizione_Set_Input = {
  anagrafiche?: InputMaybe<Scalars['jsonb']['input']>;
  calcolati?: InputMaybe<Scalars['jsonb']['input']>;
  calcolo?: InputMaybe<Scalars['String']['input']>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  parametri?: InputMaybe<Scalars['jsonb']['input']>;
  stato_calcolo?: InputMaybe<Incentivi__Stato_Calcolo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "incentivi_ripartizione" */
export type Incentivi_Ripartizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incentivi_Ripartizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incentivi_Ripartizione_Stream_Cursor_Value_Input = {
  anagrafiche?: InputMaybe<Scalars['jsonb']['input']>;
  calcolati?: InputMaybe<Scalars['jsonb']['input']>;
  calcolo?: InputMaybe<Scalars['String']['input']>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  misure?: InputMaybe<Scalars['jsonb']['input']>;
  parametri?: InputMaybe<Scalars['jsonb']['input']>;
  stato_calcolo?: InputMaybe<Incentivi__Stato_Calcolo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "incentivi.ripartizione" */
export enum Incentivi_Ripartizione_Update_Column {
  /** column name */
  Anagrafiche = 'anagrafiche',
  /** column name */
  Calcolati = 'calcolati',
  /** column name */
  Calcolo = 'calcolo',
  /** column name */
  CerCabinaId = 'cer_cabina_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Misure = 'misure',
  /** column name */
  Parametri = 'parametri',
  /** column name */
  StatoCalcolo = 'stato_calcolo',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Incentivi_Ripartizione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Incentivi_Ripartizione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Incentivi_Ripartizione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Incentivi_Ripartizione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Incentivi_Ripartizione_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Incentivi_Ripartizione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incentivi_Ripartizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incentivi_Ripartizione_Bool_Exp;
};

/** columns and relationships of "indirizzo" */
export type Indirizzo = {
  __typename?: 'indirizzo';
  /** An array relationship */
  asset_produzione: Array<Asset_Produzione>;
  /** An aggregate relationship */
  asset_produzione_aggregate: Asset_Produzione_Aggregate;
  /** An array relationship */
  assets: Array<Asset>;
  /** An aggregate relationship */
  assets_aggregate: Asset_Aggregate;
  cap?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  citta?: Maybe<Unita_Amministrativa_Citta>;
  citta_id?: Maybe<Scalars['bigint']['output']>;
  civico?: Maybe<Scalars['String']['output']>;
  completo?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "indirizzo_geom" */
  geom?: Maybe<Scalars['geometry']['output']>;
  geom_?: Maybe<Scalars['geometry']['output']>;
  geom_approx_?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
  manuale: Scalars['Boolean']['output'];
  /** An array relationship */
  persone: Array<Persona>;
  /** An aggregate relationship */
  persone_aggregate: Persona_Aggregate;
  toponimo?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "indirizzo" */
export type IndirizzoAsset_ProduzioneArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


/** columns and relationships of "indirizzo" */
export type IndirizzoAsset_Produzione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


/** columns and relationships of "indirizzo" */
export type IndirizzoAssetsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


/** columns and relationships of "indirizzo" */
export type IndirizzoAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


/** columns and relationships of "indirizzo" */
export type IndirizzoPersoneArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};


/** columns and relationships of "indirizzo" */
export type IndirizzoPersone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};

/** aggregated selection of "indirizzo" */
export type Indirizzo_Aggregate = {
  __typename?: 'indirizzo_aggregate';
  aggregate?: Maybe<Indirizzo_Aggregate_Fields>;
  nodes: Array<Indirizzo>;
};

/** aggregate fields of "indirizzo" */
export type Indirizzo_Aggregate_Fields = {
  __typename?: 'indirizzo_aggregate_fields';
  avg?: Maybe<Indirizzo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Indirizzo_Max_Fields>;
  min?: Maybe<Indirizzo_Min_Fields>;
  stddev?: Maybe<Indirizzo_Stddev_Fields>;
  stddev_pop?: Maybe<Indirizzo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Indirizzo_Stddev_Samp_Fields>;
  sum?: Maybe<Indirizzo_Sum_Fields>;
  var_pop?: Maybe<Indirizzo_Var_Pop_Fields>;
  var_samp?: Maybe<Indirizzo_Var_Samp_Fields>;
  variance?: Maybe<Indirizzo_Variance_Fields>;
};


/** aggregate fields of "indirizzo" */
export type Indirizzo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Indirizzo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Indirizzo_Avg_Fields = {
  __typename?: 'indirizzo_avg_fields';
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "indirizzo". All fields are combined with a logical 'AND'. */
export type Indirizzo_Bool_Exp = {
  _and?: InputMaybe<Array<Indirizzo_Bool_Exp>>;
  _not?: InputMaybe<Indirizzo_Bool_Exp>;
  _or?: InputMaybe<Array<Indirizzo_Bool_Exp>>;
  asset_produzione?: InputMaybe<Asset_Produzione_Bool_Exp>;
  asset_produzione_aggregate?: InputMaybe<Asset_Produzione_Aggregate_Bool_Exp>;
  assets?: InputMaybe<Asset_Bool_Exp>;
  assets_aggregate?: InputMaybe<Asset_Aggregate_Bool_Exp>;
  cap?: InputMaybe<String_Comparison_Exp>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  citta_id?: InputMaybe<Bigint_Comparison_Exp>;
  civico?: InputMaybe<String_Comparison_Exp>;
  completo?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  geom_?: InputMaybe<Geometry_Comparison_Exp>;
  geom_approx_?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manuale?: InputMaybe<Boolean_Comparison_Exp>;
  persone?: InputMaybe<Persona_Bool_Exp>;
  persone_aggregate?: InputMaybe<Persona_Aggregate_Bool_Exp>;
  toponimo?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "indirizzo" */
export enum Indirizzo_Constraint {
  /** unique or primary key constraint on columns "id" */
  IndirizzoPkey = 'indirizzo_pkey'
}

/** input type for incrementing numeric columns in table "indirizzo" */
export type Indirizzo_Inc_Input = {
  citta_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "indirizzo" */
export type Indirizzo_Insert_Input = {
  asset_produzione?: InputMaybe<Asset_Produzione_Arr_Rel_Insert_Input>;
  assets?: InputMaybe<Asset_Arr_Rel_Insert_Input>;
  cap?: InputMaybe<Scalars['String']['input']>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Obj_Rel_Insert_Input>;
  citta_id?: InputMaybe<Scalars['bigint']['input']>;
  civico?: InputMaybe<Scalars['String']['input']>;
  completo?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom_?: InputMaybe<Scalars['geometry']['input']>;
  geom_approx_?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manuale?: InputMaybe<Scalars['Boolean']['input']>;
  persone?: InputMaybe<Persona_Arr_Rel_Insert_Input>;
  toponimo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Indirizzo_Max_Fields = {
  __typename?: 'indirizzo_max_fields';
  cap?: Maybe<Scalars['String']['output']>;
  citta_id?: Maybe<Scalars['bigint']['output']>;
  civico?: Maybe<Scalars['String']['output']>;
  completo?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  toponimo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Indirizzo_Min_Fields = {
  __typename?: 'indirizzo_min_fields';
  cap?: Maybe<Scalars['String']['output']>;
  citta_id?: Maybe<Scalars['bigint']['output']>;
  civico?: Maybe<Scalars['String']['output']>;
  completo?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  toponimo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "indirizzo" */
export type Indirizzo_Mutation_Response = {
  __typename?: 'indirizzo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Indirizzo>;
};

/** input type for inserting object relation for remote table "indirizzo" */
export type Indirizzo_Obj_Rel_Insert_Input = {
  data: Indirizzo_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Indirizzo_On_Conflict>;
};

/** on_conflict condition type for table "indirizzo" */
export type Indirizzo_On_Conflict = {
  constraint: Indirizzo_Constraint;
  update_columns?: Array<Indirizzo_Update_Column>;
  where?: InputMaybe<Indirizzo_Bool_Exp>;
};

/** Ordering options when selecting data from "indirizzo". */
export type Indirizzo_Order_By = {
  asset_produzione_aggregate?: InputMaybe<Asset_Produzione_Aggregate_Order_By>;
  assets_aggregate?: InputMaybe<Asset_Aggregate_Order_By>;
  cap?: InputMaybe<Order_By>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Order_By>;
  citta_id?: InputMaybe<Order_By>;
  civico?: InputMaybe<Order_By>;
  completo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  geom_?: InputMaybe<Order_By>;
  geom_approx_?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manuale?: InputMaybe<Order_By>;
  persone_aggregate?: InputMaybe<Persona_Aggregate_Order_By>;
  toponimo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: indirizzo */
export type Indirizzo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "indirizzo" */
export enum Indirizzo_Select_Column {
  /** column name */
  Cap = 'cap',
  /** column name */
  CittaId = 'citta_id',
  /** column name */
  Civico = 'civico',
  /** column name */
  Completo = 'completo',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Geom = 'geom_',
  /** column name */
  GeomApprox = 'geom_approx_',
  /** column name */
  Id = 'id',
  /** column name */
  Manuale = 'manuale',
  /** column name */
  Toponimo = 'toponimo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "indirizzo" */
export type Indirizzo_Set_Input = {
  cap?: InputMaybe<Scalars['String']['input']>;
  citta_id?: InputMaybe<Scalars['bigint']['input']>;
  civico?: InputMaybe<Scalars['String']['input']>;
  completo?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom_?: InputMaybe<Scalars['geometry']['input']>;
  geom_approx_?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manuale?: InputMaybe<Scalars['Boolean']['input']>;
  toponimo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Indirizzo_Stddev_Fields = {
  __typename?: 'indirizzo_stddev_fields';
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Indirizzo_Stddev_Pop_Fields = {
  __typename?: 'indirizzo_stddev_pop_fields';
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Indirizzo_Stddev_Samp_Fields = {
  __typename?: 'indirizzo_stddev_samp_fields';
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "indirizzo" */
export type Indirizzo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indirizzo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indirizzo_Stream_Cursor_Value_Input = {
  cap?: InputMaybe<Scalars['String']['input']>;
  citta_id?: InputMaybe<Scalars['bigint']['input']>;
  civico?: InputMaybe<Scalars['String']['input']>;
  completo?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  geom_?: InputMaybe<Scalars['geometry']['input']>;
  geom_approx_?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manuale?: InputMaybe<Scalars['Boolean']['input']>;
  toponimo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Indirizzo_Sum_Fields = {
  __typename?: 'indirizzo_sum_fields';
  citta_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "indirizzo" */
export enum Indirizzo_Update_Column {
  /** column name */
  Cap = 'cap',
  /** column name */
  CittaId = 'citta_id',
  /** column name */
  Civico = 'civico',
  /** column name */
  Completo = 'completo',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Geom = 'geom_',
  /** column name */
  GeomApprox = 'geom_approx_',
  /** column name */
  Id = 'id',
  /** column name */
  Manuale = 'manuale',
  /** column name */
  Toponimo = 'toponimo',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Indirizzo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Indirizzo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Indirizzo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Indirizzo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Indirizzo_Var_Pop_Fields = {
  __typename?: 'indirizzo_var_pop_fields';
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Indirizzo_Var_Samp_Fields = {
  __typename?: 'indirizzo_var_samp_fields';
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Indirizzo_Variance_Fields = {
  __typename?: 'indirizzo_variance_fields';
  citta_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "inseritore" */
export type Inseritore = {
  __typename?: 'inseritore';
  auth_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "inseritore" */
export type Inseritore_Aggregate = {
  __typename?: 'inseritore_aggregate';
  aggregate?: Maybe<Inseritore_Aggregate_Fields>;
  nodes: Array<Inseritore>;
};

/** aggregate fields of "inseritore" */
export type Inseritore_Aggregate_Fields = {
  __typename?: 'inseritore_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Inseritore_Max_Fields>;
  min?: Maybe<Inseritore_Min_Fields>;
};


/** aggregate fields of "inseritore" */
export type Inseritore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Inseritore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "inseritore". All fields are combined with a logical 'AND'. */
export type Inseritore_Bool_Exp = {
  _and?: InputMaybe<Array<Inseritore_Bool_Exp>>;
  _not?: InputMaybe<Inseritore_Bool_Exp>;
  _or?: InputMaybe<Array<Inseritore_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "inseritore" */
export enum Inseritore_Constraint {
  /** unique or primary key constraint on columns "id" */
  InseritorePkey = 'inseritore_pkey'
}

/** input type for inserting data into table "inseritore" */
export type Inseritore_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Inseritore_Max_Fields = {
  __typename?: 'inseritore_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Inseritore_Min_Fields = {
  __typename?: 'inseritore_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "inseritore" */
export type Inseritore_Mutation_Response = {
  __typename?: 'inseritore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Inseritore>;
};

/** input type for inserting object relation for remote table "inseritore" */
export type Inseritore_Obj_Rel_Insert_Input = {
  data: Inseritore_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Inseritore_On_Conflict>;
};

/** on_conflict condition type for table "inseritore" */
export type Inseritore_On_Conflict = {
  constraint: Inseritore_Constraint;
  update_columns?: Array<Inseritore_Update_Column>;
  where?: InputMaybe<Inseritore_Bool_Exp>;
};

/** Ordering options when selecting data from "inseritore". */
export type Inseritore_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: inseritore */
export type Inseritore_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "inseritore" */
export enum Inseritore_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "inseritore" */
export type Inseritore_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "inseritore" */
export type Inseritore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Inseritore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Inseritore_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "inseritore" */
export enum Inseritore_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Inseritore_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inseritore_Set_Input>;
  /** filter the rows which have to be updated */
  where: Inseritore_Bool_Exp;
};

/** columns and relationships of "installatore" */
export type Installatore = {
  __typename?: 'installatore';
  /** An object relationship */
  contatto?: Maybe<Contatto>;
  contatto_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "installatore" */
export type Installatore_Aggregate = {
  __typename?: 'installatore_aggregate';
  aggregate?: Maybe<Installatore_Aggregate_Fields>;
  nodes: Array<Installatore>;
};

/** aggregate fields of "installatore" */
export type Installatore_Aggregate_Fields = {
  __typename?: 'installatore_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Installatore_Max_Fields>;
  min?: Maybe<Installatore_Min_Fields>;
};


/** aggregate fields of "installatore" */
export type Installatore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Installatore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "installatore". All fields are combined with a logical 'AND'. */
export type Installatore_Bool_Exp = {
  _and?: InputMaybe<Array<Installatore_Bool_Exp>>;
  _not?: InputMaybe<Installatore_Bool_Exp>;
  _or?: InputMaybe<Array<Installatore_Bool_Exp>>;
  contatto?: InputMaybe<Contatto_Bool_Exp>;
  contatto_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "installatore" */
export enum Installatore_Constraint {
  /** unique or primary key constraint on columns "id" */
  InstallatorePkey = 'installatore_pkey'
}

/** input type for inserting data into table "installatore" */
export type Installatore_Insert_Input = {
  contatto?: InputMaybe<Contatto_Obj_Rel_Insert_Input>;
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Installatore_Max_Fields = {
  __typename?: 'installatore_max_fields';
  contatto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Installatore_Min_Fields = {
  __typename?: 'installatore_min_fields';
  contatto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "installatore" */
export type Installatore_Mutation_Response = {
  __typename?: 'installatore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Installatore>;
};

/** input type for inserting object relation for remote table "installatore" */
export type Installatore_Obj_Rel_Insert_Input = {
  data: Installatore_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Installatore_On_Conflict>;
};

/** on_conflict condition type for table "installatore" */
export type Installatore_On_Conflict = {
  constraint: Installatore_Constraint;
  update_columns?: Array<Installatore_Update_Column>;
  where?: InputMaybe<Installatore_Bool_Exp>;
};

/** Ordering options when selecting data from "installatore". */
export type Installatore_Order_By = {
  contatto?: InputMaybe<Contatto_Order_By>;
  contatto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: installatore */
export type Installatore_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "installatore" */
export enum Installatore_Select_Column {
  /** column name */
  ContattoId = 'contatto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "installatore" */
export type Installatore_Set_Input = {
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "installatore" */
export type Installatore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Installatore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Installatore_Stream_Cursor_Value_Input = {
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "installatore" */
export enum Installatore_Update_Column {
  /** column name */
  ContattoId = 'contatto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Installatore_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Installatore_Set_Input>;
  /** filter the rows which have to be updated */
  where: Installatore_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "log_errori_funzioni" */
export type Log_Errori_Funzioni = {
  __typename?: 'log_errori_funzioni';
  action?: Maybe<Scalars['String']['output']>;
  data_errore?: Maybe<Scalars['timestamp']['output']>;
  dettagli_errore?: Maybe<Scalars['String']['output']>;
  feedbackaltro?: Maybe<Scalars['String']['output']>;
  feedbackid?: Maybe<Scalars['uuid']['output']>;
  funzione?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  messaggio_errore?: Maybe<Scalars['String']['output']>;
  sottoscrizioneid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "log_errori_funzioni" */
export type Log_Errori_Funzioni_Aggregate = {
  __typename?: 'log_errori_funzioni_aggregate';
  aggregate?: Maybe<Log_Errori_Funzioni_Aggregate_Fields>;
  nodes: Array<Log_Errori_Funzioni>;
};

/** aggregate fields of "log_errori_funzioni" */
export type Log_Errori_Funzioni_Aggregate_Fields = {
  __typename?: 'log_errori_funzioni_aggregate_fields';
  avg?: Maybe<Log_Errori_Funzioni_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Log_Errori_Funzioni_Max_Fields>;
  min?: Maybe<Log_Errori_Funzioni_Min_Fields>;
  stddev?: Maybe<Log_Errori_Funzioni_Stddev_Fields>;
  stddev_pop?: Maybe<Log_Errori_Funzioni_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Log_Errori_Funzioni_Stddev_Samp_Fields>;
  sum?: Maybe<Log_Errori_Funzioni_Sum_Fields>;
  var_pop?: Maybe<Log_Errori_Funzioni_Var_Pop_Fields>;
  var_samp?: Maybe<Log_Errori_Funzioni_Var_Samp_Fields>;
  variance?: Maybe<Log_Errori_Funzioni_Variance_Fields>;
};


/** aggregate fields of "log_errori_funzioni" */
export type Log_Errori_Funzioni_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Log_Errori_Funzioni_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Log_Errori_Funzioni_Avg_Fields = {
  __typename?: 'log_errori_funzioni_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "log_errori_funzioni". All fields are combined with a logical 'AND'. */
export type Log_Errori_Funzioni_Bool_Exp = {
  _and?: InputMaybe<Array<Log_Errori_Funzioni_Bool_Exp>>;
  _not?: InputMaybe<Log_Errori_Funzioni_Bool_Exp>;
  _or?: InputMaybe<Array<Log_Errori_Funzioni_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  data_errore?: InputMaybe<Timestamp_Comparison_Exp>;
  dettagli_errore?: InputMaybe<String_Comparison_Exp>;
  feedbackaltro?: InputMaybe<String_Comparison_Exp>;
  feedbackid?: InputMaybe<Uuid_Comparison_Exp>;
  funzione?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  messaggio_errore?: InputMaybe<String_Comparison_Exp>;
  sottoscrizioneid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "log_errori_funzioni" */
export enum Log_Errori_Funzioni_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogErroriFunzioniPkey = 'log_errori_funzioni_pkey'
}

/** input type for incrementing numeric columns in table "log_errori_funzioni" */
export type Log_Errori_Funzioni_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "log_errori_funzioni" */
export type Log_Errori_Funzioni_Insert_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  data_errore?: InputMaybe<Scalars['timestamp']['input']>;
  dettagli_errore?: InputMaybe<Scalars['String']['input']>;
  feedbackaltro?: InputMaybe<Scalars['String']['input']>;
  feedbackid?: InputMaybe<Scalars['uuid']['input']>;
  funzione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messaggio_errore?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Log_Errori_Funzioni_Max_Fields = {
  __typename?: 'log_errori_funzioni_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  data_errore?: Maybe<Scalars['timestamp']['output']>;
  dettagli_errore?: Maybe<Scalars['String']['output']>;
  feedbackaltro?: Maybe<Scalars['String']['output']>;
  feedbackid?: Maybe<Scalars['uuid']['output']>;
  funzione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messaggio_errore?: Maybe<Scalars['String']['output']>;
  sottoscrizioneid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Log_Errori_Funzioni_Min_Fields = {
  __typename?: 'log_errori_funzioni_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  data_errore?: Maybe<Scalars['timestamp']['output']>;
  dettagli_errore?: Maybe<Scalars['String']['output']>;
  feedbackaltro?: Maybe<Scalars['String']['output']>;
  feedbackid?: Maybe<Scalars['uuid']['output']>;
  funzione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  messaggio_errore?: Maybe<Scalars['String']['output']>;
  sottoscrizioneid?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "log_errori_funzioni" */
export type Log_Errori_Funzioni_Mutation_Response = {
  __typename?: 'log_errori_funzioni_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Log_Errori_Funzioni>;
};

/** on_conflict condition type for table "log_errori_funzioni" */
export type Log_Errori_Funzioni_On_Conflict = {
  constraint: Log_Errori_Funzioni_Constraint;
  update_columns?: Array<Log_Errori_Funzioni_Update_Column>;
  where?: InputMaybe<Log_Errori_Funzioni_Bool_Exp>;
};

/** Ordering options when selecting data from "log_errori_funzioni". */
export type Log_Errori_Funzioni_Order_By = {
  action?: InputMaybe<Order_By>;
  data_errore?: InputMaybe<Order_By>;
  dettagli_errore?: InputMaybe<Order_By>;
  feedbackaltro?: InputMaybe<Order_By>;
  feedbackid?: InputMaybe<Order_By>;
  funzione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messaggio_errore?: InputMaybe<Order_By>;
  sottoscrizioneid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: log_errori_funzioni */
export type Log_Errori_Funzioni_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "log_errori_funzioni" */
export enum Log_Errori_Funzioni_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  DataErrore = 'data_errore',
  /** column name */
  DettagliErrore = 'dettagli_errore',
  /** column name */
  Feedbackaltro = 'feedbackaltro',
  /** column name */
  Feedbackid = 'feedbackid',
  /** column name */
  Funzione = 'funzione',
  /** column name */
  Id = 'id',
  /** column name */
  MessaggioErrore = 'messaggio_errore',
  /** column name */
  Sottoscrizioneid = 'sottoscrizioneid'
}

/** input type for updating data in table "log_errori_funzioni" */
export type Log_Errori_Funzioni_Set_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  data_errore?: InputMaybe<Scalars['timestamp']['input']>;
  dettagli_errore?: InputMaybe<Scalars['String']['input']>;
  feedbackaltro?: InputMaybe<Scalars['String']['input']>;
  feedbackid?: InputMaybe<Scalars['uuid']['input']>;
  funzione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messaggio_errore?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Log_Errori_Funzioni_Stddev_Fields = {
  __typename?: 'log_errori_funzioni_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Log_Errori_Funzioni_Stddev_Pop_Fields = {
  __typename?: 'log_errori_funzioni_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Log_Errori_Funzioni_Stddev_Samp_Fields = {
  __typename?: 'log_errori_funzioni_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "log_errori_funzioni" */
export type Log_Errori_Funzioni_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Log_Errori_Funzioni_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Log_Errori_Funzioni_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  data_errore?: InputMaybe<Scalars['timestamp']['input']>;
  dettagli_errore?: InputMaybe<Scalars['String']['input']>;
  feedbackaltro?: InputMaybe<Scalars['String']['input']>;
  feedbackid?: InputMaybe<Scalars['uuid']['input']>;
  funzione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  messaggio_errore?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioneid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Log_Errori_Funzioni_Sum_Fields = {
  __typename?: 'log_errori_funzioni_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "log_errori_funzioni" */
export enum Log_Errori_Funzioni_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  DataErrore = 'data_errore',
  /** column name */
  DettagliErrore = 'dettagli_errore',
  /** column name */
  Feedbackaltro = 'feedbackaltro',
  /** column name */
  Feedbackid = 'feedbackid',
  /** column name */
  Funzione = 'funzione',
  /** column name */
  Id = 'id',
  /** column name */
  MessaggioErrore = 'messaggio_errore',
  /** column name */
  Sottoscrizioneid = 'sottoscrizioneid'
}

export type Log_Errori_Funzioni_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Log_Errori_Funzioni_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Log_Errori_Funzioni_Set_Input>;
  /** filter the rows which have to be updated */
  where: Log_Errori_Funzioni_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Log_Errori_Funzioni_Var_Pop_Fields = {
  __typename?: 'log_errori_funzioni_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Log_Errori_Funzioni_Var_Samp_Fields = {
  __typename?: 'log_errori_funzioni_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Log_Errori_Funzioni_Variance_Fields = {
  __typename?: 'log_errori_funzioni_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Mostra_Args = {
  cerid?: InputMaybe<Scalars['uuid']['input']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** execute VOLATILE function "abilita_richieste" which returns "cer" */
  abilita_richieste: Array<Cer>;
  /** execute VOLATILE function "cambia_stato_cabina" which returns "cer_cabina" */
  cambia_stato_cabina: Array<Cer_Cabina>;
  /** execute VOLATILE function "cambia_stato_founder" which returns "sottoscrizione" */
  cambia_stato_founder: Array<Sottoscrizione>;
  /** execute VOLATILE function "cambia_stato_installatore" which returns "sottoscrizione" */
  cambia_stato_installatore: Array<Sottoscrizione>;
  /** execute VOLATILE function "cambia_stato_prosumer" which returns "sottoscrizione" */
  cambia_stato_prosumer: Array<Sottoscrizione>;
  /** execute VOLATILE function "cambia_stato_tecnico" which returns "sottoscrizione" */
  cambia_stato_tecnico: Array<Sottoscrizione>;
  /** execute VOLATILE function "condivisione.accetta" which returns "condivisione.accetta_response" */
  condivisione_accetta: Array<Condivisione_Accetta_Response>;
  /** confirmo_webhook */
  confirmoWebhook?: Maybe<ConfirmoOutput>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>;
  /** delete data from the table: "_destinazione_compatibile" */
  delete__destinazione_compatibile?: Maybe<_Destinazione_Compatibile_Mutation_Response>;
  /** delete data from the table: "_pod_duplicato" */
  delete__pod_duplicato?: Maybe<_Pod_Duplicato_Mutation_Response>;
  /** delete single row from the table: "_pod_duplicato" */
  delete__pod_duplicato_by_pk?: Maybe<_Pod_Duplicato>;
  /** delete data from the table: "_sottoscrizione_tipo_richiesta" */
  delete__sottoscrizione_tipo_richiesta?: Maybe<_Sottoscrizione_Tipo_Richiesta_Mutation_Response>;
  /** delete single row from the table: "_sottoscrizione_tipo_richiesta" */
  delete__sottoscrizione_tipo_richiesta_by_pk?: Maybe<_Sottoscrizione_Tipo_Richiesta>;
  /** delete data from the table: "_superadmin_elimina_sottoscrizione_esito" */
  delete__superadmin_elimina_sottoscrizione_esito?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito_Mutation_Response>;
  /** delete single row from the table: "_superadmin_elimina_sottoscrizione_esito" */
  delete__superadmin_elimina_sottoscrizione_esito_by_pk?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** delete data from the table: "_tipo_dato_consumo" */
  delete__tipo_dato_consumo?: Maybe<_Tipo_Dato_Consumo_Mutation_Response>;
  /** delete single row from the table: "_tipo_dato_consumo" */
  delete__tipo_dato_consumo_by_pk?: Maybe<_Tipo_Dato_Consumo>;
  /** delete data from the table: "_tipologia_profilo" */
  delete__tipologia_profilo?: Maybe<_Tipologia_Profilo_Mutation_Response>;
  /** delete single row from the table: "_tipologia_profilo" */
  delete__tipologia_profilo_by_pk?: Maybe<_Tipologia_Profilo>;
  /** delete data from the table: "admin._stato_richiesta_pubblicazione" */
  delete_admin__stato_richiesta_pubblicazione?: Maybe<Admin__Stato_Richiesta_Pubblicazione_Mutation_Response>;
  /** delete single row from the table: "admin._stato_richiesta_pubblicazione" */
  delete_admin__stato_richiesta_pubblicazione_by_pk?: Maybe<Admin__Stato_Richiesta_Pubblicazione>;
  /** delete data from the table: "admin._type_referral" */
  delete_admin__type_referral?: Maybe<Admin__Type_Referral_Mutation_Response>;
  /** delete single row from the table: "admin._type_referral" */
  delete_admin__type_referral_by_pk?: Maybe<Admin__Type_Referral>;
  /** delete data from the table: "admin.consenso_privacy" */
  delete_admin_consenso_privacy?: Maybe<Admin_Consenso_Privacy_Mutation_Response>;
  /** delete single row from the table: "admin.consenso_privacy" */
  delete_admin_consenso_privacy_by_pk?: Maybe<Admin_Consenso_Privacy>;
  /** delete data from the table: "admin.parametri_algoritmo_incentivi" */
  delete_admin_parametri_algoritmo_incentivi?: Maybe<Admin_Parametri_Algoritmo_Incentivi_Mutation_Response>;
  /** delete single row from the table: "admin.parametri_algoritmo_incentivi" */
  delete_admin_parametri_algoritmo_incentivi_by_pk?: Maybe<Admin_Parametri_Algoritmo_Incentivi>;
  /** delete data from the table: "admin.referral" */
  delete_admin_referral?: Maybe<Admin_Referral_Mutation_Response>;
  /** delete single row from the table: "admin.referral" */
  delete_admin_referral_by_pk?: Maybe<Admin_Referral>;
  /** delete data from the table: "admin.richiesta_pubblicazione" */
  delete_admin_richiesta_pubblicazione?: Maybe<Admin_Richiesta_Pubblicazione_Mutation_Response>;
  /** delete single row from the table: "admin.richiesta_pubblicazione" */
  delete_admin_richiesta_pubblicazione_by_pk?: Maybe<Admin_Richiesta_Pubblicazione>;
  /** delete data from the table: "admin.utilizzo_referral" */
  delete_admin_utilizzo_referral?: Maybe<Admin_Utilizzo_Referral_Mutation_Response>;
  /** delete single row from the table: "admin.utilizzo_referral" */
  delete_admin_utilizzo_referral_by_pk?: Maybe<Admin_Utilizzo_Referral>;
  /** delete data from the table: "anagrafica.codice_ateco" */
  delete_anagrafica_codice_ateco?: Maybe<Anagrafica_Codice_Ateco_Mutation_Response>;
  /** delete single row from the table: "anagrafica.codice_ateco" */
  delete_anagrafica_codice_ateco_by_pk?: Maybe<Anagrafica_Codice_Ateco>;
  /** delete data from the table: "anagrafica.forma_giuridica" */
  delete_anagrafica_forma_giuridica?: Maybe<Anagrafica_Forma_Giuridica_Mutation_Response>;
  /** delete single row from the table: "anagrafica.forma_giuridica" */
  delete_anagrafica_forma_giuridica_by_pk?: Maybe<Anagrafica_Forma_Giuridica>;
  /** delete data from the table: "anagrafica.forma_giuridica_cer" */
  delete_anagrafica_forma_giuridica_cer?: Maybe<Anagrafica_Forma_Giuridica_Cer_Mutation_Response>;
  /** delete single row from the table: "anagrafica.forma_giuridica_cer" */
  delete_anagrafica_forma_giuridica_cer_by_pk?: Maybe<Anagrafica_Forma_Giuridica_Cer>;
  /** delete data from the table: "anagrafica.tipo_contatto" */
  delete_anagrafica_tipo_contatto?: Maybe<Anagrafica_Tipo_Contatto_Mutation_Response>;
  /** delete single row from the table: "anagrafica.tipo_contatto" */
  delete_anagrafica_tipo_contatto_by_pk?: Maybe<Anagrafica_Tipo_Contatto>;
  /** delete data from the table: "anagrafica.tipo_promotore" */
  delete_anagrafica_tipo_promotore?: Maybe<Anagrafica_Tipo_Promotore_Mutation_Response>;
  /** delete single row from the table: "anagrafica.tipo_promotore" */
  delete_anagrafica_tipo_promotore_by_pk?: Maybe<Anagrafica_Tipo_Promotore>;
  /** delete data from the table: "anagrafica.tipologia_rappresentante" */
  delete_anagrafica_tipologia_rappresentante?: Maybe<Anagrafica_Tipologia_Rappresentante_Mutation_Response>;
  /** delete single row from the table: "anagrafica.tipologia_rappresentante" */
  delete_anagrafica_tipologia_rappresentante_by_pk?: Maybe<Anagrafica_Tipologia_Rappresentante>;
  /** delete data from the table: "asset" */
  delete_asset?: Maybe<Asset_Mutation_Response>;
  /** delete single row from the table: "asset" */
  delete_asset_by_pk?: Maybe<Asset>;
  /** delete data from the table: "asset_caratteristica" */
  delete_asset_caratteristica?: Maybe<Asset_Caratteristica_Mutation_Response>;
  /** delete single row from the table: "asset_caratteristica" */
  delete_asset_caratteristica_by_pk?: Maybe<Asset_Caratteristica>;
  /** delete data from the table: "asset_consumo" */
  delete_asset_consumo?: Maybe<Asset_Consumo_Mutation_Response>;
  /** delete single row from the table: "asset_consumo" */
  delete_asset_consumo_by_pk?: Maybe<Asset_Consumo>;
  /** delete data from the table: "asset_dato_consumo" */
  delete_asset_dato_consumo?: Maybe<Asset_Dato_Consumo_Mutation_Response>;
  /** delete single row from the table: "asset_dato_consumo" */
  delete_asset_dato_consumo_by_pk?: Maybe<Asset_Dato_Consumo>;
  /** delete data from the table: "asset_energia" */
  delete_asset_energia?: Maybe<Asset_Energia_Mutation_Response>;
  /** delete single row from the table: "asset_energia" */
  delete_asset_energia_by_pk?: Maybe<Asset_Energia>;
  /** delete data from the table: "asset_founder" */
  delete_asset_founder?: Maybe<Asset_Founder_Mutation_Response>;
  /** delete single row from the table: "asset_founder" */
  delete_asset_founder_by_pk?: Maybe<Asset_Founder>;
  /** delete data from the table: "asset_gestore" */
  delete_asset_gestore?: Maybe<Asset_Gestore_Mutation_Response>;
  /** delete single row from the table: "asset_gestore" */
  delete_asset_gestore_by_pk?: Maybe<Asset_Gestore>;
  /** delete data from the table: "asset_produzione" */
  delete_asset_produzione?: Maybe<Asset_Produzione_Mutation_Response>;
  /** delete single row from the table: "asset_produzione" */
  delete_asset_produzione_by_pk?: Maybe<Asset_Produzione>;
  /** delete data from the table: "asset_produzione_unita" */
  delete_asset_produzione_unita?: Maybe<Asset_Produzione_Unita_Mutation_Response>;
  /** delete single row from the table: "asset_produzione_unita" */
  delete_asset_produzione_unita_by_pk?: Maybe<Asset_Produzione_Unita>;
  /** delete data from the table: "asset_produzione_unita_sezione" */
  delete_asset_produzione_unita_sezione?: Maybe<Asset_Produzione_Unita_Sezione_Mutation_Response>;
  /** delete single row from the table: "asset_produzione_unita_sezione" */
  delete_asset_produzione_unita_sezione_by_pk?: Maybe<Asset_Produzione_Unita_Sezione>;
  /** delete data from the table: "asset_produzione_unita_sezione_incentivi" */
  delete_asset_produzione_unita_sezione_incentivi?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Mutation_Response>;
  /** delete single row from the table: "asset_produzione_unita_sezione_incentivi" */
  delete_asset_produzione_unita_sezione_incentivi_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** delete data from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  delete_asset_produzione_unita_sezione_titolo_autorizzativo?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Mutation_Response>;
  /** delete single row from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  delete_asset_produzione_unita_sezione_titolo_autorizzativo_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** delete data from the table: "asset_spazio" */
  delete_asset_spazio?: Maybe<Asset_Spazio_Mutation_Response>;
  /** delete single row from the table: "asset_spazio" */
  delete_asset_spazio_by_pk?: Maybe<Asset_Spazio>;
  /** delete data from the table: "auth.event_entity" */
  delete_auth_event_entity?: Maybe<Auth_Event_Entity_Mutation_Response>;
  /** delete single row from the table: "auth.event_entity" */
  delete_auth_event_entity_by_pk?: Maybe<Auth_Event_Entity>;
  /** delete data from the table: "auth.federated_identity" */
  delete_auth_federated_identity?: Maybe<Auth_Federated_Identity_Mutation_Response>;
  /** delete single row from the table: "auth.federated_identity" */
  delete_auth_federated_identity_by_pk?: Maybe<Auth_Federated_Identity>;
  /** delete data from the table: "auth.role_attribute" */
  delete_auth_role_attribute?: Maybe<Auth_Role_Attribute_Mutation_Response>;
  /** delete single row from the table: "auth.role_attribute" */
  delete_auth_role_attribute_by_pk?: Maybe<Auth_Role_Attribute>;
  /** delete data from the table: "auth.user_attribute" */
  delete_auth_user_attribute?: Maybe<Auth_User_Attribute_Mutation_Response>;
  /** delete single row from the table: "auth.user_attribute" */
  delete_auth_user_attribute_by_pk?: Maybe<Auth_User_Attribute>;
  /** delete data from the table: "auth.user_entity" */
  delete_auth_user_entity?: Maybe<Auth_User_Entity_Mutation_Response>;
  /** delete single row from the table: "auth.user_entity" */
  delete_auth_user_entity_by_pk?: Maybe<Auth_User_Entity>;
  /** delete data from the table: "cer" */
  delete_cer?: Maybe<Cer_Mutation_Response>;
  /** delete single row from the table: "cer" */
  delete_cer_by_pk?: Maybe<Cer>;
  /** delete data from the table: "cer_cabina" */
  delete_cer_cabina?: Maybe<Cer_Cabina_Mutation_Response>;
  /** delete single row from the table: "cer_cabina" */
  delete_cer_cabina_by_pk?: Maybe<Cer_Cabina>;
  /** delete data from the table: "cer_cabina_snapshot" */
  delete_cer_cabina_snapshot?: Maybe<Cer_Cabina_Snapshot_Mutation_Response>;
  /** delete single row from the table: "cer_cabina_snapshot" */
  delete_cer_cabina_snapshot_by_pk?: Maybe<Cer_Cabina_Snapshot>;
  /** delete data from the table: "cer_categoria_adesione" */
  delete_cer_categoria_adesione?: Maybe<Cer_Categoria_Adesione_Mutation_Response>;
  /** delete single row from the table: "cer_categoria_adesione" */
  delete_cer_categoria_adesione_by_pk?: Maybe<Cer_Categoria_Adesione>;
  /** delete data from the table: "cer_configurazione_destinazione_contributo" */
  delete_cer_configurazione_destinazione_contributo?: Maybe<Cer_Configurazione_Destinazione_Contributo_Mutation_Response>;
  /** delete single row from the table: "cer_configurazione_destinazione_contributo" */
  delete_cer_configurazione_destinazione_contributo_by_pk?: Maybe<Cer_Configurazione_Destinazione_Contributo>;
  /** delete data from the table: "cer_contatti" */
  delete_cer_contatti?: Maybe<Cer_Contatti_Mutation_Response>;
  /** delete single row from the table: "cer_contatti" */
  delete_cer_contatti_by_pk?: Maybe<Cer_Contatti>;
  /** delete data from the table: "cer_destinazione_contributo" */
  delete_cer_destinazione_contributo?: Maybe<Cer_Destinazione_Contributo_Mutation_Response>;
  /** delete single row from the table: "cer_destinazione_contributo" */
  delete_cer_destinazione_contributo_by_pk?: Maybe<Cer_Destinazione_Contributo>;
  /** delete data from the table: "cer_geom" */
  delete_cer_geom?: Maybe<Cer_Geom_Mutation_Response>;
  /** delete single row from the table: "cer_geom" */
  delete_cer_geom_by_pk?: Maybe<Cer_Geom>;
  /** delete data from the table: "cer_gestore" */
  delete_cer_gestore?: Maybe<Cer_Gestore_Mutation_Response>;
  /** delete single row from the table: "cer_gestore" */
  delete_cer_gestore_by_pk?: Maybe<Cer_Gestore>;
  /** delete data from the table: "cer_search_index" */
  delete_cer_search_index?: Maybe<Cer_Search_Index_Mutation_Response>;
  /** delete single row from the table: "cer_search_index" */
  delete_cer_search_index_by_pk?: Maybe<Cer_Search_Index>;
  /** delete data from the table: "cer_tecnico" */
  delete_cer_tecnico?: Maybe<Cer_Tecnico_Mutation_Response>;
  /** delete single row from the table: "cer_tecnico" */
  delete_cer_tecnico_by_pk?: Maybe<Cer_Tecnico>;
  /** delete data from the table: "codice_operatore" */
  delete_codice_operatore?: Maybe<Codice_Operatore_Mutation_Response>;
  /** delete single row from the table: "codice_operatore" */
  delete_codice_operatore_by_pk?: Maybe<Codice_Operatore>;
  /** delete data from the table: "comunicazioni.email" */
  delete_comunicazioni_email?: Maybe<Comunicazioni_Email_Mutation_Response>;
  /** delete single row from the table: "comunicazioni.email" */
  delete_comunicazioni_email_by_pk?: Maybe<Comunicazioni_Email>;
  /** delete data from the table: "comunicazioni.email_template" */
  delete_comunicazioni_email_template?: Maybe<Comunicazioni_Email_Template_Mutation_Response>;
  /** delete single row from the table: "comunicazioni.email_template" */
  delete_comunicazioni_email_template_by_pk?: Maybe<Comunicazioni_Email_Template>;
  /** delete data from the table: "comunicazioni.sms" */
  delete_comunicazioni_sms?: Maybe<Comunicazioni_Sms_Mutation_Response>;
  /** delete single row from the table: "comunicazioni.sms" */
  delete_comunicazioni_sms_by_pk?: Maybe<Comunicazioni_Sms>;
  /** delete data from the table: "condivisione._stato_condivisione" */
  delete_condivisione__stato_condivisione?: Maybe<Condivisione__Stato_Condivisione_Mutation_Response>;
  /** delete single row from the table: "condivisione._stato_condivisione" */
  delete_condivisione__stato_condivisione_by_pk?: Maybe<Condivisione__Stato_Condivisione>;
  /** delete data from the table: "condivisione.accetta_response" */
  delete_condivisione_accetta_response?: Maybe<Condivisione_Accetta_Response_Mutation_Response>;
  /** delete data from the table: "condivisione.condivisione" */
  delete_condivisione_condivisione?: Maybe<Condivisione_Condivisione_Mutation_Response>;
  /** delete single row from the table: "condivisione.condivisione" */
  delete_condivisione_condivisione_by_pk?: Maybe<Condivisione_Condivisione>;
  /** delete data from the table: "condivisione.log_condivisione" */
  delete_condivisione_log_condivisione?: Maybe<Condivisione_Log_Condivisione_Mutation_Response>;
  /** delete single row from the table: "condivisione.log_condivisione" */
  delete_condivisione_log_condivisione_by_pk?: Maybe<Condivisione_Log_Condivisione>;
  /** delete data from the table: "contatto" */
  delete_contatto?: Maybe<Contatto_Mutation_Response>;
  /** delete single row from the table: "contatto" */
  delete_contatto_by_pk?: Maybe<Contatto>;
  /** delete data from the table: "crm.audit_event" */
  delete_crm_audit_event?: Maybe<Crm_Audit_Event_Mutation_Response>;
  /** delete single row from the table: "crm.audit_event" */
  delete_crm_audit_event_by_pk?: Maybe<Crm_Audit_Event>;
  /** delete data from the table: "debug.sottoscrizione_after_log" */
  delete_debug_sottoscrizione_after_log?: Maybe<Debug_Sottoscrizione_After_Log_Mutation_Response>;
  /** delete single row from the table: "debug.sottoscrizione_after_log" */
  delete_debug_sottoscrizione_after_log_by_pk?: Maybe<Debug_Sottoscrizione_After_Log>;
  /** delete data from the table: "device.device" */
  delete_device_device?: Maybe<Device_Device_Mutation_Response>;
  /** delete single row from the table: "device.device" */
  delete_device_device_by_pk?: Maybe<Device_Device>;
  /** delete data from the table: "energy_village._azioni_founder_sottoscrizione" */
  delete_energy_village__azioni_founder_sottoscrizione?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "energy_village._azioni_founder_sottoscrizione" */
  delete_energy_village__azioni_founder_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** delete data from the table: "energy_village._azioni_prosumer_sottoscrizione" */
  delete_energy_village__azioni_prosumer_sottoscrizione?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "energy_village._azioni_prosumer_sottoscrizione" */
  delete_energy_village__azioni_prosumer_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** delete data from the table: "energy_village._azioni_tecnico_sottoscrizione" */
  delete_energy_village__azioni_tecnico_sottoscrizione?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "energy_village._azioni_tecnico_sottoscrizione" */
  delete_energy_village__azioni_tecnico_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** delete data from the table: "energy_village._cer_filter_options" */
  delete_energy_village__cer_filter_options?: Maybe<Energy_Village__Cer_Filter_Options_Mutation_Response>;
  /** delete single row from the table: "energy_village._cer_filter_options" */
  delete_energy_village__cer_filter_options_by_pk?: Maybe<Energy_Village__Cer_Filter_Options>;
  /** delete data from the table: "energy_village._stato_cer" */
  delete_energy_village__stato_cer?: Maybe<Energy_Village__Stato_Cer_Mutation_Response>;
  /** delete single row from the table: "energy_village._stato_cer" */
  delete_energy_village__stato_cer_by_pk?: Maybe<Energy_Village__Stato_Cer>;
  /** delete data from the table: "energy_village._stato_sottoscrizione" */
  delete_energy_village__stato_sottoscrizione?: Maybe<Energy_Village__Stato_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "energy_village._stato_sottoscrizione" */
  delete_energy_village__stato_sottoscrizione_by_pk?: Maybe<Energy_Village__Stato_Sottoscrizione>;
  /** delete data from the table: "energy_village._tipo_domanda" */
  delete_energy_village__tipo_domanda?: Maybe<Energy_Village__Tipo_Domanda_Mutation_Response>;
  /** delete single row from the table: "energy_village._tipo_domanda" */
  delete_energy_village__tipo_domanda_by_pk?: Maybe<Energy_Village__Tipo_Domanda>;
  /** delete data from the table: "energy_village._tipo_feedback" */
  delete_energy_village__tipo_feedback?: Maybe<Energy_Village__Tipo_Feedback_Mutation_Response>;
  /** delete single row from the table: "energy_village._tipo_feedback" */
  delete_energy_village__tipo_feedback_by_pk?: Maybe<Energy_Village__Tipo_Feedback>;
  /** delete data from the table: "energy_village.area" */
  delete_energy_village_area?: Maybe<Energy_Village_Area_Mutation_Response>;
  /** delete single row from the table: "energy_village.area" */
  delete_energy_village_area_by_pk?: Maybe<Energy_Village_Area>;
  /** delete data from the table: "energy_village.area_citta" */
  delete_energy_village_area_citta?: Maybe<Energy_Village_Area_Citta_Mutation_Response>;
  /** delete single row from the table: "energy_village.area_citta" */
  delete_energy_village_area_citta_by_pk?: Maybe<Energy_Village_Area_Citta>;
  /** delete data from the table: "energy_village.area_provincia" */
  delete_energy_village_area_provincia?: Maybe<Energy_Village_Area_Provincia_Mutation_Response>;
  /** delete single row from the table: "energy_village.area_provincia" */
  delete_energy_village_area_provincia_by_pk?: Maybe<Energy_Village_Area_Provincia>;
  /** delete data from the table: "energy_village.area_regione" */
  delete_energy_village_area_regione?: Maybe<Energy_Village_Area_Regione_Mutation_Response>;
  /** delete single row from the table: "energy_village.area_regione" */
  delete_energy_village_area_regione_by_pk?: Maybe<Energy_Village_Area_Regione>;
  /** delete data from the table: "energy_village.azioni" */
  delete_energy_village_azioni?: Maybe<Energy_Village_Azioni_Mutation_Response>;
  /** delete single row from the table: "energy_village.azioni" */
  delete_energy_village_azioni_by_pk?: Maybe<Energy_Village_Azioni>;
  /** delete data from the table: "energy_village.cabina" */
  delete_energy_village_cabina?: Maybe<Energy_Village_Cabina_Mutation_Response>;
  /** delete single row from the table: "energy_village.cabina" */
  delete_energy_village_cabina_by_pk?: Maybe<Energy_Village_Cabina>;
  /** delete data from the table: "energy_village.cabina_citta" */
  delete_energy_village_cabina_citta?: Maybe<Energy_Village_Cabina_Citta_Mutation_Response>;
  /** delete single row from the table: "energy_village.cabina_citta" */
  delete_energy_village_cabina_citta_by_pk?: Maybe<Energy_Village_Cabina_Citta>;
  /** delete data from the table: "energy_village.caratteristica" */
  delete_energy_village_caratteristica?: Maybe<Energy_Village_Caratteristica_Mutation_Response>;
  /** delete single row from the table: "energy_village.caratteristica" */
  delete_energy_village_caratteristica_by_pk?: Maybe<Energy_Village_Caratteristica>;
  /** delete data from the table: "energy_village.cer_filter_options" */
  delete_energy_village_cer_filter_options?: Maybe<Energy_Village_Cer_Filter_Options_Mutation_Response>;
  /** delete single row from the table: "energy_village.cer_filter_options" */
  delete_energy_village_cer_filter_options_by_pk?: Maybe<Energy_Village_Cer_Filter_Options>;
  /** delete data from the table: "energy_village.dimensione" */
  delete_energy_village_dimensione?: Maybe<Energy_Village_Dimensione_Mutation_Response>;
  /** delete single row from the table: "energy_village.dimensione" */
  delete_energy_village_dimensione_by_pk?: Maybe<Energy_Village_Dimensione>;
  /** delete data from the table: "energy_village.feedback" */
  delete_energy_village_feedback?: Maybe<Energy_Village_Feedback_Mutation_Response>;
  /** delete single row from the table: "energy_village.feedback" */
  delete_energy_village_feedback_by_pk?: Maybe<Energy_Village_Feedback>;
  /** delete data from the table: "energy_village.incentivo_impianto" */
  delete_energy_village_incentivo_impianto?: Maybe<Energy_Village_Incentivo_Impianto_Mutation_Response>;
  /** delete single row from the table: "energy_village.incentivo_impianto" */
  delete_energy_village_incentivo_impianto_by_pk?: Maybe<Energy_Village_Incentivo_Impianto>;
  /** delete data from the table: "energy_village.orario" */
  delete_energy_village_orario?: Maybe<Energy_Village_Orario_Mutation_Response>;
  /** delete single row from the table: "energy_village.orario" */
  delete_energy_village_orario_by_pk?: Maybe<Energy_Village_Orario>;
  /** delete data from the table: "energy_village.potenza_impianto" */
  delete_energy_village_potenza_impianto?: Maybe<Energy_Village_Potenza_Impianto_Mutation_Response>;
  /** delete single row from the table: "energy_village.potenza_impianto" */
  delete_energy_village_potenza_impianto_by_pk?: Maybe<Energy_Village_Potenza_Impianto>;
  /** delete data from the table: "energy_village.potenzialita_cabina" */
  delete_energy_village_potenzialita_cabina?: Maybe<Energy_Village_Potenzialita_Cabina_Mutation_Response>;
  /** delete single row from the table: "energy_village.potenzialita_cabina" */
  delete_energy_village_potenzialita_cabina_by_pk?: Maybe<Energy_Village_Potenzialita_Cabina>;
  /** delete data from the table: "energy_village.tipo_spazio_disponibile" */
  delete_energy_village_tipo_spazio_disponibile?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Mutation_Response>;
  /** delete single row from the table: "energy_village.tipo_spazio_disponibile" */
  delete_energy_village_tipo_spazio_disponibile_by_pk?: Maybe<Energy_Village_Tipo_Spazio_Disponibile>;
  /** delete data from the table: "energy_village.tipologia_abitativa" */
  delete_energy_village_tipologia_abitativa?: Maybe<Energy_Village_Tipologia_Abitativa_Mutation_Response>;
  /** delete single row from the table: "energy_village.tipologia_abitativa" */
  delete_energy_village_tipologia_abitativa_by_pk?: Maybe<Energy_Village_Tipologia_Abitativa>;
  /** delete data from the table: "energy_village.tipologia_asset" */
  delete_energy_village_tipologia_asset?: Maybe<Energy_Village_Tipologia_Asset_Mutation_Response>;
  /** delete single row from the table: "energy_village.tipologia_asset" */
  delete_energy_village_tipologia_asset_by_pk?: Maybe<Energy_Village_Tipologia_Asset>;
  /** delete data from the table: "energy_village.titolo_autorizzativo" */
  delete_energy_village_titolo_autorizzativo?: Maybe<Energy_Village_Titolo_Autorizzativo_Mutation_Response>;
  /** delete single row from the table: "energy_village.titolo_autorizzativo" */
  delete_energy_village_titolo_autorizzativo_by_pk?: Maybe<Energy_Village_Titolo_Autorizzativo>;
  /** delete data from the table: "flussi_gse.flusso" */
  delete_flussi_gse_flusso?: Maybe<Flussi_Gse_Flusso_Mutation_Response>;
  /** delete single row from the table: "flussi_gse.flusso" */
  delete_flussi_gse_flusso_by_pk?: Maybe<Flussi_Gse_Flusso>;
  /** delete data from the table: "funzione_log" */
  delete_funzione_log?: Maybe<Funzione_Log_Mutation_Response>;
  /** delete single row from the table: "funzione_log" */
  delete_funzione_log_by_pk?: Maybe<Funzione_Log>;
  /** delete data from the table: "incentivi._stato_calcolo" */
  delete_incentivi__stato_calcolo?: Maybe<Incentivi__Stato_Calcolo_Mutation_Response>;
  /** delete single row from the table: "incentivi._stato_calcolo" */
  delete_incentivi__stato_calcolo_by_pk?: Maybe<Incentivi__Stato_Calcolo>;
  /** delete data from the table: "incentivi.calcolati" */
  delete_incentivi_calcolati?: Maybe<Incentivi_Calcolati_Mutation_Response>;
  /** delete single row from the table: "incentivi.calcolati" */
  delete_incentivi_calcolati_by_pk?: Maybe<Incentivi_Calcolati>;
  /** delete data from the table: "incentivi.log_ripartizione" */
  delete_incentivi_log_ripartizione?: Maybe<Incentivi_Log_Ripartizione_Mutation_Response>;
  /** delete single row from the table: "incentivi.log_ripartizione" */
  delete_incentivi_log_ripartizione_by_pk?: Maybe<Incentivi_Log_Ripartizione>;
  /** delete data from the table: "incentivi.ripartizione" */
  delete_incentivi_ripartizione?: Maybe<Incentivi_Ripartizione_Mutation_Response>;
  /** delete single row from the table: "incentivi.ripartizione" */
  delete_incentivi_ripartizione_by_pk?: Maybe<Incentivi_Ripartizione>;
  /** delete data from the table: "indirizzo" */
  delete_indirizzo?: Maybe<Indirizzo_Mutation_Response>;
  /** delete single row from the table: "indirizzo" */
  delete_indirizzo_by_pk?: Maybe<Indirizzo>;
  /** delete data from the table: "inseritore" */
  delete_inseritore?: Maybe<Inseritore_Mutation_Response>;
  /** delete single row from the table: "inseritore" */
  delete_inseritore_by_pk?: Maybe<Inseritore>;
  /** delete data from the table: "installatore" */
  delete_installatore?: Maybe<Installatore_Mutation_Response>;
  /** delete single row from the table: "installatore" */
  delete_installatore_by_pk?: Maybe<Installatore>;
  /** delete data from the table: "log_errori_funzioni" */
  delete_log_errori_funzioni?: Maybe<Log_Errori_Funzioni_Mutation_Response>;
  /** delete single row from the table: "log_errori_funzioni" */
  delete_log_errori_funzioni_by_pk?: Maybe<Log_Errori_Funzioni>;
  /** delete data from the table: "persona" */
  delete_persona?: Maybe<Persona_Mutation_Response>;
  /** delete single row from the table: "persona" */
  delete_persona_by_pk?: Maybe<Persona>;
  /** delete data from the table: "persona_contatto" */
  delete_persona_contatto?: Maybe<Persona_Contatto_Mutation_Response>;
  /** delete single row from the table: "persona_contatto" */
  delete_persona_contatto_by_pk?: Maybe<Persona_Contatto>;
  /** delete data from the table: "pnrr_documenti" */
  delete_pnrr_documenti?: Maybe<Pnrr_Documenti_Mutation_Response>;
  /** delete single row from the table: "pnrr_documenti" */
  delete_pnrr_documenti_by_pk?: Maybe<Pnrr_Documenti>;
  /** delete data from the table: "preset" */
  delete_preset?: Maybe<Preset_Mutation_Response>;
  /** delete single row from the table: "preset" */
  delete_preset_by_pk?: Maybe<Preset>;
  /** delete data from the table: "profilo" */
  delete_profilo?: Maybe<Profilo_Mutation_Response>;
  /** delete single row from the table: "profilo" */
  delete_profilo_by_pk?: Maybe<Profilo>;
  /** delete data from the table: "sottoscrizione" */
  delete_sottoscrizione?: Maybe<Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "sottoscrizione" */
  delete_sottoscrizione_by_pk?: Maybe<Sottoscrizione>;
  /** delete data from the table: "sottoscrizione_documenti" */
  delete_sottoscrizione_documenti?: Maybe<Sottoscrizione_Documenti_Mutation_Response>;
  /** delete single row from the table: "sottoscrizione_documenti" */
  delete_sottoscrizione_documenti_by_pk?: Maybe<Sottoscrizione_Documenti>;
  /** delete data from the table: "sottoscrizione_domande" */
  delete_sottoscrizione_domande?: Maybe<Sottoscrizione_Domande_Mutation_Response>;
  /** delete single row from the table: "sottoscrizione_domande" */
  delete_sottoscrizione_domande_by_pk?: Maybe<Sottoscrizione_Domande>;
  /** delete data from the table: "sottoscrizione_iniziativa" */
  delete_sottoscrizione_iniziativa?: Maybe<Sottoscrizione_Iniziativa_Mutation_Response>;
  /** delete single row from the table: "sottoscrizione_iniziativa" */
  delete_sottoscrizione_iniziativa_by_pk?: Maybe<Sottoscrizione_Iniziativa>;
  /** delete data from the table: "sottoscrizione_zip" */
  delete_sottoscrizione_zip?: Maybe<Sottoscrizione_Zip_Mutation_Response>;
  /** delete single row from the table: "sottoscrizione_zip" */
  delete_sottoscrizione_zip_by_pk?: Maybe<Sottoscrizione_Zip>;
  /** delete data from the table: "staging._stato_sottoscrizione" */
  delete_staging__stato_sottoscrizione?: Maybe<Staging__Stato_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "staging._stato_sottoscrizione" */
  delete_staging__stato_sottoscrizione_by_pk?: Maybe<Staging__Stato_Sottoscrizione>;
  /** delete data from the table: "staging.azione_sottoscrizione" */
  delete_staging_azione_sottoscrizione?: Maybe<Staging_Azione_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "staging.azione_sottoscrizione" */
  delete_staging_azione_sottoscrizione_by_pk?: Maybe<Staging_Azione_Sottoscrizione>;
  /** delete data from the table: "staging.gestore_lotto" */
  delete_staging_gestore_lotto?: Maybe<Staging_Gestore_Lotto_Mutation_Response>;
  /** delete single row from the table: "staging.gestore_lotto" */
  delete_staging_gestore_lotto_by_pk?: Maybe<Staging_Gestore_Lotto>;
  /** delete data from the table: "staging.gestore_sottoscrizione" */
  delete_staging_gestore_sottoscrizione?: Maybe<Staging_Gestore_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "staging.gestore_sottoscrizione" */
  delete_staging_gestore_sottoscrizione_by_pk?: Maybe<Staging_Gestore_Sottoscrizione>;
  /** delete data from the table: "staging.log" */
  delete_staging_log?: Maybe<Staging_Log_Mutation_Response>;
  /** delete single row from the table: "staging.log" */
  delete_staging_log_by_pk?: Maybe<Staging_Log>;
  /** delete data from the table: "staging.lotto" */
  delete_staging_lotto?: Maybe<Staging_Lotto_Mutation_Response>;
  /** delete single row from the table: "staging.lotto" */
  delete_staging_lotto_by_pk?: Maybe<Staging_Lotto>;
  /** delete data from the table: "staging.mv_refresh_state" */
  delete_staging_mv_refresh_state?: Maybe<Staging_Mv_Refresh_State_Mutation_Response>;
  /** delete single row from the table: "staging.mv_refresh_state" */
  delete_staging_mv_refresh_state_by_pk?: Maybe<Staging_Mv_Refresh_State>;
  /** delete data from the table: "staging.sottoscrizione" */
  delete_staging_sottoscrizione?: Maybe<Staging_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "staging.sottoscrizione" */
  delete_staging_sottoscrizione_by_pk?: Maybe<Staging_Sottoscrizione>;
  /** delete data from the table: "storage.trigger_debug_log" */
  delete_storage_trigger_debug_log?: Maybe<Storage_Trigger_Debug_Log_Mutation_Response>;
  /** delete single row from the table: "storage.trigger_debug_log" */
  delete_storage_trigger_debug_log_by_pk?: Maybe<Storage_Trigger_Debug_Log>;
  /** delete data from the table: "storage.trigger_error_log" */
  delete_storage_trigger_error_log?: Maybe<Storage_Trigger_Error_Log_Mutation_Response>;
  /** delete single row from the table: "storage.trigger_error_log" */
  delete_storage_trigger_error_log_by_pk?: Maybe<Storage_Trigger_Error_Log>;
  /** delete data from the table: "storico_sottoscrizione" */
  delete_storico_sottoscrizione?: Maybe<Storico_Sottoscrizione_Mutation_Response>;
  /** delete single row from the table: "storico_sottoscrizione" */
  delete_storico_sottoscrizione_by_pk?: Maybe<Storico_Sottoscrizione>;
  /** delete data from the table: "translate.mapper" */
  delete_translate_mapper?: Maybe<Translate_Mapper_Mutation_Response>;
  /** delete single row from the table: "translate.mapper" */
  delete_translate_mapper_by_pk?: Maybe<Translate_Mapper>;
  /** delete data from the table: "unita_amministrativa.citta" */
  delete_unita_amministrativa_citta?: Maybe<Unita_Amministrativa_Citta_Mutation_Response>;
  /** delete single row from the table: "unita_amministrativa.citta" */
  delete_unita_amministrativa_citta_by_pk?: Maybe<Unita_Amministrativa_Citta>;
  /** delete data from the table: "unita_amministrativa.nazione" */
  delete_unita_amministrativa_nazione?: Maybe<Unita_Amministrativa_Nazione_Mutation_Response>;
  /** delete single row from the table: "unita_amministrativa.nazione" */
  delete_unita_amministrativa_nazione_by_pk?: Maybe<Unita_Amministrativa_Nazione>;
  /** delete data from the table: "unita_amministrativa.provincia" */
  delete_unita_amministrativa_provincia?: Maybe<Unita_Amministrativa_Provincia_Mutation_Response>;
  /** delete single row from the table: "unita_amministrativa.provincia" */
  delete_unita_amministrativa_provincia_by_pk?: Maybe<Unita_Amministrativa_Provincia>;
  /** delete data from the table: "unita_amministrativa.regione" */
  delete_unita_amministrativa_regione?: Maybe<Unita_Amministrativa_Regione_Mutation_Response>;
  /** delete single row from the table: "unita_amministrativa.regione" */
  delete_unita_amministrativa_regione_by_pk?: Maybe<Unita_Amministrativa_Regione>;
  /** delete data from the table: "white_label.associazione" */
  delete_white_label_associazione?: Maybe<White_Label_Associazione_Mutation_Response>;
  /** delete single row from the table: "white_label.associazione" */
  delete_white_label_associazione_by_pk?: Maybe<White_Label_Associazione>;
  /** delete data from the table: "white_label.configurazione" */
  delete_white_label_configurazione?: Maybe<White_Label_Configurazione_Mutation_Response>;
  /** delete single row from the table: "white_label.configurazione" */
  delete_white_label_configurazione_by_pk?: Maybe<White_Label_Configurazione>;
  /** delete data from the table: "white_label.gestore" */
  delete_white_label_gestore?: Maybe<White_Label_Gestore_Mutation_Response>;
  /** delete single row from the table: "white_label.gestore" */
  delete_white_label_gestore_by_pk?: Maybe<White_Label_Gestore>;
  /** delete data from the table: "white_label.idp" */
  delete_white_label_idp?: Maybe<White_Label_Idp_Mutation_Response>;
  /** delete single row from the table: "white_label.idp" */
  delete_white_label_idp_by_pk?: Maybe<White_Label_Idp>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>;
  /** insert data into the table: "_destinazione_compatibile" */
  insert__destinazione_compatibile?: Maybe<_Destinazione_Compatibile_Mutation_Response>;
  /** insert a single row into the table: "_destinazione_compatibile" */
  insert__destinazione_compatibile_one?: Maybe<_Destinazione_Compatibile>;
  /** insert data into the table: "_pod_duplicato" */
  insert__pod_duplicato?: Maybe<_Pod_Duplicato_Mutation_Response>;
  /** insert a single row into the table: "_pod_duplicato" */
  insert__pod_duplicato_one?: Maybe<_Pod_Duplicato>;
  /** insert data into the table: "_sottoscrizione_tipo_richiesta" */
  insert__sottoscrizione_tipo_richiesta?: Maybe<_Sottoscrizione_Tipo_Richiesta_Mutation_Response>;
  /** insert a single row into the table: "_sottoscrizione_tipo_richiesta" */
  insert__sottoscrizione_tipo_richiesta_one?: Maybe<_Sottoscrizione_Tipo_Richiesta>;
  /** insert data into the table: "_superadmin_elimina_sottoscrizione_esito" */
  insert__superadmin_elimina_sottoscrizione_esito?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito_Mutation_Response>;
  /** insert a single row into the table: "_superadmin_elimina_sottoscrizione_esito" */
  insert__superadmin_elimina_sottoscrizione_esito_one?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** insert data into the table: "_tipo_dato_consumo" */
  insert__tipo_dato_consumo?: Maybe<_Tipo_Dato_Consumo_Mutation_Response>;
  /** insert a single row into the table: "_tipo_dato_consumo" */
  insert__tipo_dato_consumo_one?: Maybe<_Tipo_Dato_Consumo>;
  /** insert data into the table: "_tipologia_profilo" */
  insert__tipologia_profilo?: Maybe<_Tipologia_Profilo_Mutation_Response>;
  /** insert a single row into the table: "_tipologia_profilo" */
  insert__tipologia_profilo_one?: Maybe<_Tipologia_Profilo>;
  /** insert data into the table: "admin._stato_richiesta_pubblicazione" */
  insert_admin__stato_richiesta_pubblicazione?: Maybe<Admin__Stato_Richiesta_Pubblicazione_Mutation_Response>;
  /** insert a single row into the table: "admin._stato_richiesta_pubblicazione" */
  insert_admin__stato_richiesta_pubblicazione_one?: Maybe<Admin__Stato_Richiesta_Pubblicazione>;
  /** insert data into the table: "admin._type_referral" */
  insert_admin__type_referral?: Maybe<Admin__Type_Referral_Mutation_Response>;
  /** insert a single row into the table: "admin._type_referral" */
  insert_admin__type_referral_one?: Maybe<Admin__Type_Referral>;
  /** insert data into the table: "admin.consenso_privacy" */
  insert_admin_consenso_privacy?: Maybe<Admin_Consenso_Privacy_Mutation_Response>;
  /** insert a single row into the table: "admin.consenso_privacy" */
  insert_admin_consenso_privacy_one?: Maybe<Admin_Consenso_Privacy>;
  /** insert data into the table: "admin.parametri_algoritmo_incentivi" */
  insert_admin_parametri_algoritmo_incentivi?: Maybe<Admin_Parametri_Algoritmo_Incentivi_Mutation_Response>;
  /** insert a single row into the table: "admin.parametri_algoritmo_incentivi" */
  insert_admin_parametri_algoritmo_incentivi_one?: Maybe<Admin_Parametri_Algoritmo_Incentivi>;
  /** insert data into the table: "admin.referral" */
  insert_admin_referral?: Maybe<Admin_Referral_Mutation_Response>;
  /** insert a single row into the table: "admin.referral" */
  insert_admin_referral_one?: Maybe<Admin_Referral>;
  /** insert data into the table: "admin.richiesta_pubblicazione" */
  insert_admin_richiesta_pubblicazione?: Maybe<Admin_Richiesta_Pubblicazione_Mutation_Response>;
  /** insert a single row into the table: "admin.richiesta_pubblicazione" */
  insert_admin_richiesta_pubblicazione_one?: Maybe<Admin_Richiesta_Pubblicazione>;
  /** insert data into the table: "admin.utilizzo_referral" */
  insert_admin_utilizzo_referral?: Maybe<Admin_Utilizzo_Referral_Mutation_Response>;
  /** insert a single row into the table: "admin.utilizzo_referral" */
  insert_admin_utilizzo_referral_one?: Maybe<Admin_Utilizzo_Referral>;
  /** insert data into the table: "anagrafica.codice_ateco" */
  insert_anagrafica_codice_ateco?: Maybe<Anagrafica_Codice_Ateco_Mutation_Response>;
  /** insert a single row into the table: "anagrafica.codice_ateco" */
  insert_anagrafica_codice_ateco_one?: Maybe<Anagrafica_Codice_Ateco>;
  /** insert data into the table: "anagrafica.forma_giuridica" */
  insert_anagrafica_forma_giuridica?: Maybe<Anagrafica_Forma_Giuridica_Mutation_Response>;
  /** insert data into the table: "anagrafica.forma_giuridica_cer" */
  insert_anagrafica_forma_giuridica_cer?: Maybe<Anagrafica_Forma_Giuridica_Cer_Mutation_Response>;
  /** insert a single row into the table: "anagrafica.forma_giuridica_cer" */
  insert_anagrafica_forma_giuridica_cer_one?: Maybe<Anagrafica_Forma_Giuridica_Cer>;
  /** insert a single row into the table: "anagrafica.forma_giuridica" */
  insert_anagrafica_forma_giuridica_one?: Maybe<Anagrafica_Forma_Giuridica>;
  /** insert data into the table: "anagrafica.tipo_contatto" */
  insert_anagrafica_tipo_contatto?: Maybe<Anagrafica_Tipo_Contatto_Mutation_Response>;
  /** insert a single row into the table: "anagrafica.tipo_contatto" */
  insert_anagrafica_tipo_contatto_one?: Maybe<Anagrafica_Tipo_Contatto>;
  /** insert data into the table: "anagrafica.tipo_promotore" */
  insert_anagrafica_tipo_promotore?: Maybe<Anagrafica_Tipo_Promotore_Mutation_Response>;
  /** insert a single row into the table: "anagrafica.tipo_promotore" */
  insert_anagrafica_tipo_promotore_one?: Maybe<Anagrafica_Tipo_Promotore>;
  /** insert data into the table: "anagrafica.tipologia_rappresentante" */
  insert_anagrafica_tipologia_rappresentante?: Maybe<Anagrafica_Tipologia_Rappresentante_Mutation_Response>;
  /** insert a single row into the table: "anagrafica.tipologia_rappresentante" */
  insert_anagrafica_tipologia_rappresentante_one?: Maybe<Anagrafica_Tipologia_Rappresentante>;
  /** insert data into the table: "asset" */
  insert_asset?: Maybe<Asset_Mutation_Response>;
  /** insert data into the table: "asset_caratteristica" */
  insert_asset_caratteristica?: Maybe<Asset_Caratteristica_Mutation_Response>;
  /** insert a single row into the table: "asset_caratteristica" */
  insert_asset_caratteristica_one?: Maybe<Asset_Caratteristica>;
  /** insert data into the table: "asset_consumo" */
  insert_asset_consumo?: Maybe<Asset_Consumo_Mutation_Response>;
  /** insert a single row into the table: "asset_consumo" */
  insert_asset_consumo_one?: Maybe<Asset_Consumo>;
  /** insert data into the table: "asset_dato_consumo" */
  insert_asset_dato_consumo?: Maybe<Asset_Dato_Consumo_Mutation_Response>;
  /** insert a single row into the table: "asset_dato_consumo" */
  insert_asset_dato_consumo_one?: Maybe<Asset_Dato_Consumo>;
  /** insert data into the table: "asset_energia" */
  insert_asset_energia?: Maybe<Asset_Energia_Mutation_Response>;
  /** insert a single row into the table: "asset_energia" */
  insert_asset_energia_one?: Maybe<Asset_Energia>;
  /** insert data into the table: "asset_founder" */
  insert_asset_founder?: Maybe<Asset_Founder_Mutation_Response>;
  /** insert a single row into the table: "asset_founder" */
  insert_asset_founder_one?: Maybe<Asset_Founder>;
  /** insert data into the table: "asset_gestore" */
  insert_asset_gestore?: Maybe<Asset_Gestore_Mutation_Response>;
  /** insert a single row into the table: "asset_gestore" */
  insert_asset_gestore_one?: Maybe<Asset_Gestore>;
  /** insert a single row into the table: "asset" */
  insert_asset_one?: Maybe<Asset>;
  /** insert data into the table: "asset_produzione" */
  insert_asset_produzione?: Maybe<Asset_Produzione_Mutation_Response>;
  /** insert a single row into the table: "asset_produzione" */
  insert_asset_produzione_one?: Maybe<Asset_Produzione>;
  /** insert data into the table: "asset_produzione_unita" */
  insert_asset_produzione_unita?: Maybe<Asset_Produzione_Unita_Mutation_Response>;
  /** insert a single row into the table: "asset_produzione_unita" */
  insert_asset_produzione_unita_one?: Maybe<Asset_Produzione_Unita>;
  /** insert data into the table: "asset_produzione_unita_sezione" */
  insert_asset_produzione_unita_sezione?: Maybe<Asset_Produzione_Unita_Sezione_Mutation_Response>;
  /** insert data into the table: "asset_produzione_unita_sezione_incentivi" */
  insert_asset_produzione_unita_sezione_incentivi?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Mutation_Response>;
  /** insert a single row into the table: "asset_produzione_unita_sezione_incentivi" */
  insert_asset_produzione_unita_sezione_incentivi_one?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** insert a single row into the table: "asset_produzione_unita_sezione" */
  insert_asset_produzione_unita_sezione_one?: Maybe<Asset_Produzione_Unita_Sezione>;
  /** insert data into the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  insert_asset_produzione_unita_sezione_titolo_autorizzativo?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Mutation_Response>;
  /** insert a single row into the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  insert_asset_produzione_unita_sezione_titolo_autorizzativo_one?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** insert data into the table: "asset_spazio" */
  insert_asset_spazio?: Maybe<Asset_Spazio_Mutation_Response>;
  /** insert a single row into the table: "asset_spazio" */
  insert_asset_spazio_one?: Maybe<Asset_Spazio>;
  /** insert data into the table: "auth.event_entity" */
  insert_auth_event_entity?: Maybe<Auth_Event_Entity_Mutation_Response>;
  /** insert a single row into the table: "auth.event_entity" */
  insert_auth_event_entity_one?: Maybe<Auth_Event_Entity>;
  /** insert data into the table: "auth.federated_identity" */
  insert_auth_federated_identity?: Maybe<Auth_Federated_Identity_Mutation_Response>;
  /** insert a single row into the table: "auth.federated_identity" */
  insert_auth_federated_identity_one?: Maybe<Auth_Federated_Identity>;
  /** insert data into the table: "auth.role_attribute" */
  insert_auth_role_attribute?: Maybe<Auth_Role_Attribute_Mutation_Response>;
  /** insert a single row into the table: "auth.role_attribute" */
  insert_auth_role_attribute_one?: Maybe<Auth_Role_Attribute>;
  /** insert data into the table: "auth.user_attribute" */
  insert_auth_user_attribute?: Maybe<Auth_User_Attribute_Mutation_Response>;
  /** insert a single row into the table: "auth.user_attribute" */
  insert_auth_user_attribute_one?: Maybe<Auth_User_Attribute>;
  /** insert data into the table: "auth.user_entity" */
  insert_auth_user_entity?: Maybe<Auth_User_Entity_Mutation_Response>;
  /** insert a single row into the table: "auth.user_entity" */
  insert_auth_user_entity_one?: Maybe<Auth_User_Entity>;
  /** insert data into the table: "cer" */
  insert_cer?: Maybe<Cer_Mutation_Response>;
  /** insert data into the table: "cer_cabina" */
  insert_cer_cabina?: Maybe<Cer_Cabina_Mutation_Response>;
  /** insert a single row into the table: "cer_cabina" */
  insert_cer_cabina_one?: Maybe<Cer_Cabina>;
  /** insert data into the table: "cer_cabina_snapshot" */
  insert_cer_cabina_snapshot?: Maybe<Cer_Cabina_Snapshot_Mutation_Response>;
  /** insert a single row into the table: "cer_cabina_snapshot" */
  insert_cer_cabina_snapshot_one?: Maybe<Cer_Cabina_Snapshot>;
  /** insert data into the table: "cer_categoria_adesione" */
  insert_cer_categoria_adesione?: Maybe<Cer_Categoria_Adesione_Mutation_Response>;
  /** insert a single row into the table: "cer_categoria_adesione" */
  insert_cer_categoria_adesione_one?: Maybe<Cer_Categoria_Adesione>;
  /** insert data into the table: "cer_configurazione_destinazione_contributo" */
  insert_cer_configurazione_destinazione_contributo?: Maybe<Cer_Configurazione_Destinazione_Contributo_Mutation_Response>;
  /** insert a single row into the table: "cer_configurazione_destinazione_contributo" */
  insert_cer_configurazione_destinazione_contributo_one?: Maybe<Cer_Configurazione_Destinazione_Contributo>;
  /** insert data into the table: "cer_contatti" */
  insert_cer_contatti?: Maybe<Cer_Contatti_Mutation_Response>;
  /** insert a single row into the table: "cer_contatti" */
  insert_cer_contatti_one?: Maybe<Cer_Contatti>;
  /** insert data into the table: "cer_destinazione_contributo" */
  insert_cer_destinazione_contributo?: Maybe<Cer_Destinazione_Contributo_Mutation_Response>;
  /** insert a single row into the table: "cer_destinazione_contributo" */
  insert_cer_destinazione_contributo_one?: Maybe<Cer_Destinazione_Contributo>;
  /** insert data into the table: "cer_geom" */
  insert_cer_geom?: Maybe<Cer_Geom_Mutation_Response>;
  /** insert a single row into the table: "cer_geom" */
  insert_cer_geom_one?: Maybe<Cer_Geom>;
  /** insert data into the table: "cer_gestore" */
  insert_cer_gestore?: Maybe<Cer_Gestore_Mutation_Response>;
  /** insert a single row into the table: "cer_gestore" */
  insert_cer_gestore_one?: Maybe<Cer_Gestore>;
  /** insert a single row into the table: "cer" */
  insert_cer_one?: Maybe<Cer>;
  /** insert data into the table: "cer_search_index" */
  insert_cer_search_index?: Maybe<Cer_Search_Index_Mutation_Response>;
  /** insert a single row into the table: "cer_search_index" */
  insert_cer_search_index_one?: Maybe<Cer_Search_Index>;
  /** insert data into the table: "cer_tecnico" */
  insert_cer_tecnico?: Maybe<Cer_Tecnico_Mutation_Response>;
  /** insert a single row into the table: "cer_tecnico" */
  insert_cer_tecnico_one?: Maybe<Cer_Tecnico>;
  /** insert data into the table: "codice_operatore" */
  insert_codice_operatore?: Maybe<Codice_Operatore_Mutation_Response>;
  /** insert a single row into the table: "codice_operatore" */
  insert_codice_operatore_one?: Maybe<Codice_Operatore>;
  /** insert data into the table: "comunicazioni.email" */
  insert_comunicazioni_email?: Maybe<Comunicazioni_Email_Mutation_Response>;
  /** insert a single row into the table: "comunicazioni.email" */
  insert_comunicazioni_email_one?: Maybe<Comunicazioni_Email>;
  /** insert data into the table: "comunicazioni.email_template" */
  insert_comunicazioni_email_template?: Maybe<Comunicazioni_Email_Template_Mutation_Response>;
  /** insert a single row into the table: "comunicazioni.email_template" */
  insert_comunicazioni_email_template_one?: Maybe<Comunicazioni_Email_Template>;
  /** insert data into the table: "comunicazioni.sms" */
  insert_comunicazioni_sms?: Maybe<Comunicazioni_Sms_Mutation_Response>;
  /** insert a single row into the table: "comunicazioni.sms" */
  insert_comunicazioni_sms_one?: Maybe<Comunicazioni_Sms>;
  /** insert data into the table: "condivisione._stato_condivisione" */
  insert_condivisione__stato_condivisione?: Maybe<Condivisione__Stato_Condivisione_Mutation_Response>;
  /** insert a single row into the table: "condivisione._stato_condivisione" */
  insert_condivisione__stato_condivisione_one?: Maybe<Condivisione__Stato_Condivisione>;
  /** insert data into the table: "condivisione.accetta_response" */
  insert_condivisione_accetta_response?: Maybe<Condivisione_Accetta_Response_Mutation_Response>;
  /** insert a single row into the table: "condivisione.accetta_response" */
  insert_condivisione_accetta_response_one?: Maybe<Condivisione_Accetta_Response>;
  /** insert data into the table: "condivisione.condivisione" */
  insert_condivisione_condivisione?: Maybe<Condivisione_Condivisione_Mutation_Response>;
  /** insert a single row into the table: "condivisione.condivisione" */
  insert_condivisione_condivisione_one?: Maybe<Condivisione_Condivisione>;
  /** insert data into the table: "condivisione.log_condivisione" */
  insert_condivisione_log_condivisione?: Maybe<Condivisione_Log_Condivisione_Mutation_Response>;
  /** insert a single row into the table: "condivisione.log_condivisione" */
  insert_condivisione_log_condivisione_one?: Maybe<Condivisione_Log_Condivisione>;
  /** insert data into the table: "contatto" */
  insert_contatto?: Maybe<Contatto_Mutation_Response>;
  /** insert a single row into the table: "contatto" */
  insert_contatto_one?: Maybe<Contatto>;
  /** insert data into the table: "crm.audit_event" */
  insert_crm_audit_event?: Maybe<Crm_Audit_Event_Mutation_Response>;
  /** insert a single row into the table: "crm.audit_event" */
  insert_crm_audit_event_one?: Maybe<Crm_Audit_Event>;
  /** insert data into the table: "debug.sottoscrizione_after_log" */
  insert_debug_sottoscrizione_after_log?: Maybe<Debug_Sottoscrizione_After_Log_Mutation_Response>;
  /** insert a single row into the table: "debug.sottoscrizione_after_log" */
  insert_debug_sottoscrizione_after_log_one?: Maybe<Debug_Sottoscrizione_After_Log>;
  /** insert data into the table: "device.device" */
  insert_device_device?: Maybe<Device_Device_Mutation_Response>;
  /** insert a single row into the table: "device.device" */
  insert_device_device_one?: Maybe<Device_Device>;
  /** insert data into the table: "energy_village._azioni_founder_sottoscrizione" */
  insert_energy_village__azioni_founder_sottoscrizione?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "energy_village._azioni_founder_sottoscrizione" */
  insert_energy_village__azioni_founder_sottoscrizione_one?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** insert data into the table: "energy_village._azioni_prosumer_sottoscrizione" */
  insert_energy_village__azioni_prosumer_sottoscrizione?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "energy_village._azioni_prosumer_sottoscrizione" */
  insert_energy_village__azioni_prosumer_sottoscrizione_one?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** insert data into the table: "energy_village._azioni_tecnico_sottoscrizione" */
  insert_energy_village__azioni_tecnico_sottoscrizione?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "energy_village._azioni_tecnico_sottoscrizione" */
  insert_energy_village__azioni_tecnico_sottoscrizione_one?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** insert data into the table: "energy_village._cer_filter_options" */
  insert_energy_village__cer_filter_options?: Maybe<Energy_Village__Cer_Filter_Options_Mutation_Response>;
  /** insert a single row into the table: "energy_village._cer_filter_options" */
  insert_energy_village__cer_filter_options_one?: Maybe<Energy_Village__Cer_Filter_Options>;
  /** insert data into the table: "energy_village._stato_cer" */
  insert_energy_village__stato_cer?: Maybe<Energy_Village__Stato_Cer_Mutation_Response>;
  /** insert a single row into the table: "energy_village._stato_cer" */
  insert_energy_village__stato_cer_one?: Maybe<Energy_Village__Stato_Cer>;
  /** insert data into the table: "energy_village._stato_sottoscrizione" */
  insert_energy_village__stato_sottoscrizione?: Maybe<Energy_Village__Stato_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "energy_village._stato_sottoscrizione" */
  insert_energy_village__stato_sottoscrizione_one?: Maybe<Energy_Village__Stato_Sottoscrizione>;
  /** insert data into the table: "energy_village._tipo_domanda" */
  insert_energy_village__tipo_domanda?: Maybe<Energy_Village__Tipo_Domanda_Mutation_Response>;
  /** insert a single row into the table: "energy_village._tipo_domanda" */
  insert_energy_village__tipo_domanda_one?: Maybe<Energy_Village__Tipo_Domanda>;
  /** insert data into the table: "energy_village._tipo_feedback" */
  insert_energy_village__tipo_feedback?: Maybe<Energy_Village__Tipo_Feedback_Mutation_Response>;
  /** insert a single row into the table: "energy_village._tipo_feedback" */
  insert_energy_village__tipo_feedback_one?: Maybe<Energy_Village__Tipo_Feedback>;
  /** insert data into the table: "energy_village.area" */
  insert_energy_village_area?: Maybe<Energy_Village_Area_Mutation_Response>;
  /** insert data into the table: "energy_village.area_citta" */
  insert_energy_village_area_citta?: Maybe<Energy_Village_Area_Citta_Mutation_Response>;
  /** insert a single row into the table: "energy_village.area_citta" */
  insert_energy_village_area_citta_one?: Maybe<Energy_Village_Area_Citta>;
  /** insert a single row into the table: "energy_village.area" */
  insert_energy_village_area_one?: Maybe<Energy_Village_Area>;
  /** insert data into the table: "energy_village.area_provincia" */
  insert_energy_village_area_provincia?: Maybe<Energy_Village_Area_Provincia_Mutation_Response>;
  /** insert a single row into the table: "energy_village.area_provincia" */
  insert_energy_village_area_provincia_one?: Maybe<Energy_Village_Area_Provincia>;
  /** insert data into the table: "energy_village.area_regione" */
  insert_energy_village_area_regione?: Maybe<Energy_Village_Area_Regione_Mutation_Response>;
  /** insert a single row into the table: "energy_village.area_regione" */
  insert_energy_village_area_regione_one?: Maybe<Energy_Village_Area_Regione>;
  /** insert data into the table: "energy_village.azioni" */
  insert_energy_village_azioni?: Maybe<Energy_Village_Azioni_Mutation_Response>;
  /** insert a single row into the table: "energy_village.azioni" */
  insert_energy_village_azioni_one?: Maybe<Energy_Village_Azioni>;
  /** insert data into the table: "energy_village.cabina" */
  insert_energy_village_cabina?: Maybe<Energy_Village_Cabina_Mutation_Response>;
  /** insert data into the table: "energy_village.cabina_citta" */
  insert_energy_village_cabina_citta?: Maybe<Energy_Village_Cabina_Citta_Mutation_Response>;
  /** insert a single row into the table: "energy_village.cabina_citta" */
  insert_energy_village_cabina_citta_one?: Maybe<Energy_Village_Cabina_Citta>;
  /** insert a single row into the table: "energy_village.cabina" */
  insert_energy_village_cabina_one?: Maybe<Energy_Village_Cabina>;
  /** insert data into the table: "energy_village.caratteristica" */
  insert_energy_village_caratteristica?: Maybe<Energy_Village_Caratteristica_Mutation_Response>;
  /** insert a single row into the table: "energy_village.caratteristica" */
  insert_energy_village_caratteristica_one?: Maybe<Energy_Village_Caratteristica>;
  /** insert data into the table: "energy_village.cer_filter_options" */
  insert_energy_village_cer_filter_options?: Maybe<Energy_Village_Cer_Filter_Options_Mutation_Response>;
  /** insert a single row into the table: "energy_village.cer_filter_options" */
  insert_energy_village_cer_filter_options_one?: Maybe<Energy_Village_Cer_Filter_Options>;
  /** insert data into the table: "energy_village.dimensione" */
  insert_energy_village_dimensione?: Maybe<Energy_Village_Dimensione_Mutation_Response>;
  /** insert a single row into the table: "energy_village.dimensione" */
  insert_energy_village_dimensione_one?: Maybe<Energy_Village_Dimensione>;
  /** insert data into the table: "energy_village.feedback" */
  insert_energy_village_feedback?: Maybe<Energy_Village_Feedback_Mutation_Response>;
  /** insert a single row into the table: "energy_village.feedback" */
  insert_energy_village_feedback_one?: Maybe<Energy_Village_Feedback>;
  /** insert data into the table: "energy_village.incentivo_impianto" */
  insert_energy_village_incentivo_impianto?: Maybe<Energy_Village_Incentivo_Impianto_Mutation_Response>;
  /** insert a single row into the table: "energy_village.incentivo_impianto" */
  insert_energy_village_incentivo_impianto_one?: Maybe<Energy_Village_Incentivo_Impianto>;
  /** insert data into the table: "energy_village.orario" */
  insert_energy_village_orario?: Maybe<Energy_Village_Orario_Mutation_Response>;
  /** insert a single row into the table: "energy_village.orario" */
  insert_energy_village_orario_one?: Maybe<Energy_Village_Orario>;
  /** insert data into the table: "energy_village.potenza_impianto" */
  insert_energy_village_potenza_impianto?: Maybe<Energy_Village_Potenza_Impianto_Mutation_Response>;
  /** insert a single row into the table: "energy_village.potenza_impianto" */
  insert_energy_village_potenza_impianto_one?: Maybe<Energy_Village_Potenza_Impianto>;
  /** insert data into the table: "energy_village.potenzialita_cabina" */
  insert_energy_village_potenzialita_cabina?: Maybe<Energy_Village_Potenzialita_Cabina_Mutation_Response>;
  /** insert a single row into the table: "energy_village.potenzialita_cabina" */
  insert_energy_village_potenzialita_cabina_one?: Maybe<Energy_Village_Potenzialita_Cabina>;
  /** insert data into the table: "energy_village.tipo_spazio_disponibile" */
  insert_energy_village_tipo_spazio_disponibile?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Mutation_Response>;
  /** insert a single row into the table: "energy_village.tipo_spazio_disponibile" */
  insert_energy_village_tipo_spazio_disponibile_one?: Maybe<Energy_Village_Tipo_Spazio_Disponibile>;
  /** insert data into the table: "energy_village.tipologia_abitativa" */
  insert_energy_village_tipologia_abitativa?: Maybe<Energy_Village_Tipologia_Abitativa_Mutation_Response>;
  /** insert a single row into the table: "energy_village.tipologia_abitativa" */
  insert_energy_village_tipologia_abitativa_one?: Maybe<Energy_Village_Tipologia_Abitativa>;
  /** insert data into the table: "energy_village.tipologia_asset" */
  insert_energy_village_tipologia_asset?: Maybe<Energy_Village_Tipologia_Asset_Mutation_Response>;
  /** insert a single row into the table: "energy_village.tipologia_asset" */
  insert_energy_village_tipologia_asset_one?: Maybe<Energy_Village_Tipologia_Asset>;
  /** insert data into the table: "energy_village.titolo_autorizzativo" */
  insert_energy_village_titolo_autorizzativo?: Maybe<Energy_Village_Titolo_Autorizzativo_Mutation_Response>;
  /** insert a single row into the table: "energy_village.titolo_autorizzativo" */
  insert_energy_village_titolo_autorizzativo_one?: Maybe<Energy_Village_Titolo_Autorizzativo>;
  /** insert data into the table: "flussi_gse.flusso" */
  insert_flussi_gse_flusso?: Maybe<Flussi_Gse_Flusso_Mutation_Response>;
  /** insert a single row into the table: "flussi_gse.flusso" */
  insert_flussi_gse_flusso_one?: Maybe<Flussi_Gse_Flusso>;
  /** insert data into the table: "funzione_log" */
  insert_funzione_log?: Maybe<Funzione_Log_Mutation_Response>;
  /** insert a single row into the table: "funzione_log" */
  insert_funzione_log_one?: Maybe<Funzione_Log>;
  /** insert data into the table: "incentivi._stato_calcolo" */
  insert_incentivi__stato_calcolo?: Maybe<Incentivi__Stato_Calcolo_Mutation_Response>;
  /** insert a single row into the table: "incentivi._stato_calcolo" */
  insert_incentivi__stato_calcolo_one?: Maybe<Incentivi__Stato_Calcolo>;
  /** insert data into the table: "incentivi.calcolati" */
  insert_incentivi_calcolati?: Maybe<Incentivi_Calcolati_Mutation_Response>;
  /** insert a single row into the table: "incentivi.calcolati" */
  insert_incentivi_calcolati_one?: Maybe<Incentivi_Calcolati>;
  /** insert data into the table: "incentivi.log_ripartizione" */
  insert_incentivi_log_ripartizione?: Maybe<Incentivi_Log_Ripartizione_Mutation_Response>;
  /** insert a single row into the table: "incentivi.log_ripartizione" */
  insert_incentivi_log_ripartizione_one?: Maybe<Incentivi_Log_Ripartizione>;
  /** insert data into the table: "incentivi.ripartizione" */
  insert_incentivi_ripartizione?: Maybe<Incentivi_Ripartizione_Mutation_Response>;
  /** insert a single row into the table: "incentivi.ripartizione" */
  insert_incentivi_ripartizione_one?: Maybe<Incentivi_Ripartizione>;
  /** insert data into the table: "indirizzo" */
  insert_indirizzo?: Maybe<Indirizzo_Mutation_Response>;
  /** insert a single row into the table: "indirizzo" */
  insert_indirizzo_one?: Maybe<Indirizzo>;
  /** insert data into the table: "inseritore" */
  insert_inseritore?: Maybe<Inseritore_Mutation_Response>;
  /** insert a single row into the table: "inseritore" */
  insert_inseritore_one?: Maybe<Inseritore>;
  /** insert data into the table: "installatore" */
  insert_installatore?: Maybe<Installatore_Mutation_Response>;
  /** insert a single row into the table: "installatore" */
  insert_installatore_one?: Maybe<Installatore>;
  /** insert data into the table: "log_errori_funzioni" */
  insert_log_errori_funzioni?: Maybe<Log_Errori_Funzioni_Mutation_Response>;
  /** insert a single row into the table: "log_errori_funzioni" */
  insert_log_errori_funzioni_one?: Maybe<Log_Errori_Funzioni>;
  /** insert data into the table: "persona" */
  insert_persona?: Maybe<Persona_Mutation_Response>;
  /** insert data into the table: "persona_contatto" */
  insert_persona_contatto?: Maybe<Persona_Contatto_Mutation_Response>;
  /** insert a single row into the table: "persona_contatto" */
  insert_persona_contatto_one?: Maybe<Persona_Contatto>;
  /** insert a single row into the table: "persona" */
  insert_persona_one?: Maybe<Persona>;
  /** insert data into the table: "pnrr_documenti" */
  insert_pnrr_documenti?: Maybe<Pnrr_Documenti_Mutation_Response>;
  /** insert a single row into the table: "pnrr_documenti" */
  insert_pnrr_documenti_one?: Maybe<Pnrr_Documenti>;
  /** insert data into the table: "preset" */
  insert_preset?: Maybe<Preset_Mutation_Response>;
  /** insert a single row into the table: "preset" */
  insert_preset_one?: Maybe<Preset>;
  /** insert data into the table: "profilo" */
  insert_profilo?: Maybe<Profilo_Mutation_Response>;
  /** insert a single row into the table: "profilo" */
  insert_profilo_one?: Maybe<Profilo>;
  /** insert data into the table: "sottoscrizione" */
  insert_sottoscrizione?: Maybe<Sottoscrizione_Mutation_Response>;
  /** insert data into the table: "sottoscrizione_documenti" */
  insert_sottoscrizione_documenti?: Maybe<Sottoscrizione_Documenti_Mutation_Response>;
  /** insert a single row into the table: "sottoscrizione_documenti" */
  insert_sottoscrizione_documenti_one?: Maybe<Sottoscrizione_Documenti>;
  /** insert data into the table: "sottoscrizione_domande" */
  insert_sottoscrizione_domande?: Maybe<Sottoscrizione_Domande_Mutation_Response>;
  /** insert a single row into the table: "sottoscrizione_domande" */
  insert_sottoscrizione_domande_one?: Maybe<Sottoscrizione_Domande>;
  /** insert data into the table: "sottoscrizione_iniziativa" */
  insert_sottoscrizione_iniziativa?: Maybe<Sottoscrizione_Iniziativa_Mutation_Response>;
  /** insert a single row into the table: "sottoscrizione_iniziativa" */
  insert_sottoscrizione_iniziativa_one?: Maybe<Sottoscrizione_Iniziativa>;
  /** insert a single row into the table: "sottoscrizione" */
  insert_sottoscrizione_one?: Maybe<Sottoscrizione>;
  /** insert data into the table: "sottoscrizione_zip" */
  insert_sottoscrizione_zip?: Maybe<Sottoscrizione_Zip_Mutation_Response>;
  /** insert a single row into the table: "sottoscrizione_zip" */
  insert_sottoscrizione_zip_one?: Maybe<Sottoscrizione_Zip>;
  /** insert data into the table: "staging._stato_sottoscrizione" */
  insert_staging__stato_sottoscrizione?: Maybe<Staging__Stato_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "staging._stato_sottoscrizione" */
  insert_staging__stato_sottoscrizione_one?: Maybe<Staging__Stato_Sottoscrizione>;
  /** insert data into the table: "staging.azione_sottoscrizione" */
  insert_staging_azione_sottoscrizione?: Maybe<Staging_Azione_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "staging.azione_sottoscrizione" */
  insert_staging_azione_sottoscrizione_one?: Maybe<Staging_Azione_Sottoscrizione>;
  /** insert data into the table: "staging.gestore_lotto" */
  insert_staging_gestore_lotto?: Maybe<Staging_Gestore_Lotto_Mutation_Response>;
  /** insert a single row into the table: "staging.gestore_lotto" */
  insert_staging_gestore_lotto_one?: Maybe<Staging_Gestore_Lotto>;
  /** insert data into the table: "staging.gestore_sottoscrizione" */
  insert_staging_gestore_sottoscrizione?: Maybe<Staging_Gestore_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "staging.gestore_sottoscrizione" */
  insert_staging_gestore_sottoscrizione_one?: Maybe<Staging_Gestore_Sottoscrizione>;
  /** insert data into the table: "staging.log" */
  insert_staging_log?: Maybe<Staging_Log_Mutation_Response>;
  /** insert a single row into the table: "staging.log" */
  insert_staging_log_one?: Maybe<Staging_Log>;
  /** insert data into the table: "staging.lotto" */
  insert_staging_lotto?: Maybe<Staging_Lotto_Mutation_Response>;
  /** insert a single row into the table: "staging.lotto" */
  insert_staging_lotto_one?: Maybe<Staging_Lotto>;
  /** insert data into the table: "staging.mv_refresh_state" */
  insert_staging_mv_refresh_state?: Maybe<Staging_Mv_Refresh_State_Mutation_Response>;
  /** insert a single row into the table: "staging.mv_refresh_state" */
  insert_staging_mv_refresh_state_one?: Maybe<Staging_Mv_Refresh_State>;
  /** insert data into the table: "staging.sottoscrizione" */
  insert_staging_sottoscrizione?: Maybe<Staging_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "staging.sottoscrizione" */
  insert_staging_sottoscrizione_one?: Maybe<Staging_Sottoscrizione>;
  /** insert data into the table: "storage.trigger_debug_log" */
  insert_storage_trigger_debug_log?: Maybe<Storage_Trigger_Debug_Log_Mutation_Response>;
  /** insert a single row into the table: "storage.trigger_debug_log" */
  insert_storage_trigger_debug_log_one?: Maybe<Storage_Trigger_Debug_Log>;
  /** insert data into the table: "storage.trigger_error_log" */
  insert_storage_trigger_error_log?: Maybe<Storage_Trigger_Error_Log_Mutation_Response>;
  /** insert a single row into the table: "storage.trigger_error_log" */
  insert_storage_trigger_error_log_one?: Maybe<Storage_Trigger_Error_Log>;
  /** insert data into the table: "storico_sottoscrizione" */
  insert_storico_sottoscrizione?: Maybe<Storico_Sottoscrizione_Mutation_Response>;
  /** insert a single row into the table: "storico_sottoscrizione" */
  insert_storico_sottoscrizione_one?: Maybe<Storico_Sottoscrizione>;
  /** insert data into the table: "translate.mapper" */
  insert_translate_mapper?: Maybe<Translate_Mapper_Mutation_Response>;
  /** insert a single row into the table: "translate.mapper" */
  insert_translate_mapper_one?: Maybe<Translate_Mapper>;
  /** insert data into the table: "unita_amministrativa.citta" */
  insert_unita_amministrativa_citta?: Maybe<Unita_Amministrativa_Citta_Mutation_Response>;
  /** insert a single row into the table: "unita_amministrativa.citta" */
  insert_unita_amministrativa_citta_one?: Maybe<Unita_Amministrativa_Citta>;
  /** insert data into the table: "unita_amministrativa.nazione" */
  insert_unita_amministrativa_nazione?: Maybe<Unita_Amministrativa_Nazione_Mutation_Response>;
  /** insert a single row into the table: "unita_amministrativa.nazione" */
  insert_unita_amministrativa_nazione_one?: Maybe<Unita_Amministrativa_Nazione>;
  /** insert data into the table: "unita_amministrativa.provincia" */
  insert_unita_amministrativa_provincia?: Maybe<Unita_Amministrativa_Provincia_Mutation_Response>;
  /** insert a single row into the table: "unita_amministrativa.provincia" */
  insert_unita_amministrativa_provincia_one?: Maybe<Unita_Amministrativa_Provincia>;
  /** insert data into the table: "unita_amministrativa.regione" */
  insert_unita_amministrativa_regione?: Maybe<Unita_Amministrativa_Regione_Mutation_Response>;
  /** insert a single row into the table: "unita_amministrativa.regione" */
  insert_unita_amministrativa_regione_one?: Maybe<Unita_Amministrativa_Regione>;
  /** insert data into the table: "white_label.associazione" */
  insert_white_label_associazione?: Maybe<White_Label_Associazione_Mutation_Response>;
  /** insert a single row into the table: "white_label.associazione" */
  insert_white_label_associazione_one?: Maybe<White_Label_Associazione>;
  /** insert data into the table: "white_label.configurazione" */
  insert_white_label_configurazione?: Maybe<White_Label_Configurazione_Mutation_Response>;
  /** insert a single row into the table: "white_label.configurazione" */
  insert_white_label_configurazione_one?: Maybe<White_Label_Configurazione>;
  /** insert data into the table: "white_label.gestore" */
  insert_white_label_gestore?: Maybe<White_Label_Gestore_Mutation_Response>;
  /** insert a single row into the table: "white_label.gestore" */
  insert_white_label_gestore_one?: Maybe<White_Label_Gestore>;
  /** insert data into the table: "white_label.idp" */
  insert_white_label_idp?: Maybe<White_Label_Idp_Mutation_Response>;
  /** insert a single row into the table: "white_label.idp" */
  insert_white_label_idp_one?: Maybe<White_Label_Idp>;
  /** execute VOLATILE function "mostra" which returns "cer" */
  mostra: Array<Cer>;
  /** openapi_sms_webhook */
  openapiSmsWebhook?: Maybe<OpenapiSmsOutput>;
  /** parseBolletta */
  parseBolletta?: Maybe<ParseBollettaOutput>;
  preview_pdf?: Maybe<PreviewPdfOutput>;
  registerUser: RegisterUserResponse;
  /** execute VOLATILE function "staging.refresh_sottoscrizione_mv" which returns "staging.mv_refresh_state" */
  staging_refresh_sottoscrizione_mv: Array<Staging_Mv_Refresh_State>;
  /** execute VOLATILE function "superadmin_elimina_sottoscrizione" which returns "_superadmin_elimina_sottoscrizione_esito" */
  superadmin_elimina_sottoscrizione: Array<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>;
  /** update data of the table: "_destinazione_compatibile" */
  update__destinazione_compatibile?: Maybe<_Destinazione_Compatibile_Mutation_Response>;
  /** update multiples rows of table: "_destinazione_compatibile" */
  update__destinazione_compatibile_many?: Maybe<Array<Maybe<_Destinazione_Compatibile_Mutation_Response>>>;
  /** update data of the table: "_pod_duplicato" */
  update__pod_duplicato?: Maybe<_Pod_Duplicato_Mutation_Response>;
  /** update single row of the table: "_pod_duplicato" */
  update__pod_duplicato_by_pk?: Maybe<_Pod_Duplicato>;
  /** update multiples rows of table: "_pod_duplicato" */
  update__pod_duplicato_many?: Maybe<Array<Maybe<_Pod_Duplicato_Mutation_Response>>>;
  /** update data of the table: "_sottoscrizione_tipo_richiesta" */
  update__sottoscrizione_tipo_richiesta?: Maybe<_Sottoscrizione_Tipo_Richiesta_Mutation_Response>;
  /** update single row of the table: "_sottoscrizione_tipo_richiesta" */
  update__sottoscrizione_tipo_richiesta_by_pk?: Maybe<_Sottoscrizione_Tipo_Richiesta>;
  /** update multiples rows of table: "_sottoscrizione_tipo_richiesta" */
  update__sottoscrizione_tipo_richiesta_many?: Maybe<Array<Maybe<_Sottoscrizione_Tipo_Richiesta_Mutation_Response>>>;
  /** update data of the table: "_superadmin_elimina_sottoscrizione_esito" */
  update__superadmin_elimina_sottoscrizione_esito?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito_Mutation_Response>;
  /** update single row of the table: "_superadmin_elimina_sottoscrizione_esito" */
  update__superadmin_elimina_sottoscrizione_esito_by_pk?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** update multiples rows of table: "_superadmin_elimina_sottoscrizione_esito" */
  update__superadmin_elimina_sottoscrizione_esito_many?: Maybe<Array<Maybe<_Superadmin_Elimina_Sottoscrizione_Esito_Mutation_Response>>>;
  /** update data of the table: "_tipo_dato_consumo" */
  update__tipo_dato_consumo?: Maybe<_Tipo_Dato_Consumo_Mutation_Response>;
  /** update single row of the table: "_tipo_dato_consumo" */
  update__tipo_dato_consumo_by_pk?: Maybe<_Tipo_Dato_Consumo>;
  /** update multiples rows of table: "_tipo_dato_consumo" */
  update__tipo_dato_consumo_many?: Maybe<Array<Maybe<_Tipo_Dato_Consumo_Mutation_Response>>>;
  /** update data of the table: "_tipologia_profilo" */
  update__tipologia_profilo?: Maybe<_Tipologia_Profilo_Mutation_Response>;
  /** update single row of the table: "_tipologia_profilo" */
  update__tipologia_profilo_by_pk?: Maybe<_Tipologia_Profilo>;
  /** update multiples rows of table: "_tipologia_profilo" */
  update__tipologia_profilo_many?: Maybe<Array<Maybe<_Tipologia_Profilo_Mutation_Response>>>;
  /** update data of the table: "admin._stato_richiesta_pubblicazione" */
  update_admin__stato_richiesta_pubblicazione?: Maybe<Admin__Stato_Richiesta_Pubblicazione_Mutation_Response>;
  /** update single row of the table: "admin._stato_richiesta_pubblicazione" */
  update_admin__stato_richiesta_pubblicazione_by_pk?: Maybe<Admin__Stato_Richiesta_Pubblicazione>;
  /** update multiples rows of table: "admin._stato_richiesta_pubblicazione" */
  update_admin__stato_richiesta_pubblicazione_many?: Maybe<Array<Maybe<Admin__Stato_Richiesta_Pubblicazione_Mutation_Response>>>;
  /** update data of the table: "admin._type_referral" */
  update_admin__type_referral?: Maybe<Admin__Type_Referral_Mutation_Response>;
  /** update single row of the table: "admin._type_referral" */
  update_admin__type_referral_by_pk?: Maybe<Admin__Type_Referral>;
  /** update multiples rows of table: "admin._type_referral" */
  update_admin__type_referral_many?: Maybe<Array<Maybe<Admin__Type_Referral_Mutation_Response>>>;
  /** update data of the table: "admin.consenso_privacy" */
  update_admin_consenso_privacy?: Maybe<Admin_Consenso_Privacy_Mutation_Response>;
  /** update single row of the table: "admin.consenso_privacy" */
  update_admin_consenso_privacy_by_pk?: Maybe<Admin_Consenso_Privacy>;
  /** update multiples rows of table: "admin.consenso_privacy" */
  update_admin_consenso_privacy_many?: Maybe<Array<Maybe<Admin_Consenso_Privacy_Mutation_Response>>>;
  /** update data of the table: "admin.parametri_algoritmo_incentivi" */
  update_admin_parametri_algoritmo_incentivi?: Maybe<Admin_Parametri_Algoritmo_Incentivi_Mutation_Response>;
  /** update single row of the table: "admin.parametri_algoritmo_incentivi" */
  update_admin_parametri_algoritmo_incentivi_by_pk?: Maybe<Admin_Parametri_Algoritmo_Incentivi>;
  /** update multiples rows of table: "admin.parametri_algoritmo_incentivi" */
  update_admin_parametri_algoritmo_incentivi_many?: Maybe<Array<Maybe<Admin_Parametri_Algoritmo_Incentivi_Mutation_Response>>>;
  /** update data of the table: "admin.referral" */
  update_admin_referral?: Maybe<Admin_Referral_Mutation_Response>;
  /** update single row of the table: "admin.referral" */
  update_admin_referral_by_pk?: Maybe<Admin_Referral>;
  /** update multiples rows of table: "admin.referral" */
  update_admin_referral_many?: Maybe<Array<Maybe<Admin_Referral_Mutation_Response>>>;
  /** update data of the table: "admin.richiesta_pubblicazione" */
  update_admin_richiesta_pubblicazione?: Maybe<Admin_Richiesta_Pubblicazione_Mutation_Response>;
  /** update single row of the table: "admin.richiesta_pubblicazione" */
  update_admin_richiesta_pubblicazione_by_pk?: Maybe<Admin_Richiesta_Pubblicazione>;
  /** update multiples rows of table: "admin.richiesta_pubblicazione" */
  update_admin_richiesta_pubblicazione_many?: Maybe<Array<Maybe<Admin_Richiesta_Pubblicazione_Mutation_Response>>>;
  /** update data of the table: "admin.utilizzo_referral" */
  update_admin_utilizzo_referral?: Maybe<Admin_Utilizzo_Referral_Mutation_Response>;
  /** update single row of the table: "admin.utilizzo_referral" */
  update_admin_utilizzo_referral_by_pk?: Maybe<Admin_Utilizzo_Referral>;
  /** update multiples rows of table: "admin.utilizzo_referral" */
  update_admin_utilizzo_referral_many?: Maybe<Array<Maybe<Admin_Utilizzo_Referral_Mutation_Response>>>;
  /** update data of the table: "anagrafica.codice_ateco" */
  update_anagrafica_codice_ateco?: Maybe<Anagrafica_Codice_Ateco_Mutation_Response>;
  /** update single row of the table: "anagrafica.codice_ateco" */
  update_anagrafica_codice_ateco_by_pk?: Maybe<Anagrafica_Codice_Ateco>;
  /** update multiples rows of table: "anagrafica.codice_ateco" */
  update_anagrafica_codice_ateco_many?: Maybe<Array<Maybe<Anagrafica_Codice_Ateco_Mutation_Response>>>;
  /** update data of the table: "anagrafica.forma_giuridica" */
  update_anagrafica_forma_giuridica?: Maybe<Anagrafica_Forma_Giuridica_Mutation_Response>;
  /** update single row of the table: "anagrafica.forma_giuridica" */
  update_anagrafica_forma_giuridica_by_pk?: Maybe<Anagrafica_Forma_Giuridica>;
  /** update data of the table: "anagrafica.forma_giuridica_cer" */
  update_anagrafica_forma_giuridica_cer?: Maybe<Anagrafica_Forma_Giuridica_Cer_Mutation_Response>;
  /** update single row of the table: "anagrafica.forma_giuridica_cer" */
  update_anagrafica_forma_giuridica_cer_by_pk?: Maybe<Anagrafica_Forma_Giuridica_Cer>;
  /** update multiples rows of table: "anagrafica.forma_giuridica_cer" */
  update_anagrafica_forma_giuridica_cer_many?: Maybe<Array<Maybe<Anagrafica_Forma_Giuridica_Cer_Mutation_Response>>>;
  /** update multiples rows of table: "anagrafica.forma_giuridica" */
  update_anagrafica_forma_giuridica_many?: Maybe<Array<Maybe<Anagrafica_Forma_Giuridica_Mutation_Response>>>;
  /** update data of the table: "anagrafica.tipo_contatto" */
  update_anagrafica_tipo_contatto?: Maybe<Anagrafica_Tipo_Contatto_Mutation_Response>;
  /** update single row of the table: "anagrafica.tipo_contatto" */
  update_anagrafica_tipo_contatto_by_pk?: Maybe<Anagrafica_Tipo_Contatto>;
  /** update multiples rows of table: "anagrafica.tipo_contatto" */
  update_anagrafica_tipo_contatto_many?: Maybe<Array<Maybe<Anagrafica_Tipo_Contatto_Mutation_Response>>>;
  /** update data of the table: "anagrafica.tipo_promotore" */
  update_anagrafica_tipo_promotore?: Maybe<Anagrafica_Tipo_Promotore_Mutation_Response>;
  /** update single row of the table: "anagrafica.tipo_promotore" */
  update_anagrafica_tipo_promotore_by_pk?: Maybe<Anagrafica_Tipo_Promotore>;
  /** update multiples rows of table: "anagrafica.tipo_promotore" */
  update_anagrafica_tipo_promotore_many?: Maybe<Array<Maybe<Anagrafica_Tipo_Promotore_Mutation_Response>>>;
  /** update data of the table: "anagrafica.tipologia_rappresentante" */
  update_anagrafica_tipologia_rappresentante?: Maybe<Anagrafica_Tipologia_Rappresentante_Mutation_Response>;
  /** update single row of the table: "anagrafica.tipologia_rappresentante" */
  update_anagrafica_tipologia_rappresentante_by_pk?: Maybe<Anagrafica_Tipologia_Rappresentante>;
  /** update multiples rows of table: "anagrafica.tipologia_rappresentante" */
  update_anagrafica_tipologia_rappresentante_many?: Maybe<Array<Maybe<Anagrafica_Tipologia_Rappresentante_Mutation_Response>>>;
  /** update data of the table: "asset" */
  update_asset?: Maybe<Asset_Mutation_Response>;
  /** update single row of the table: "asset" */
  update_asset_by_pk?: Maybe<Asset>;
  /** update data of the table: "asset_caratteristica" */
  update_asset_caratteristica?: Maybe<Asset_Caratteristica_Mutation_Response>;
  /** update single row of the table: "asset_caratteristica" */
  update_asset_caratteristica_by_pk?: Maybe<Asset_Caratteristica>;
  /** update multiples rows of table: "asset_caratteristica" */
  update_asset_caratteristica_many?: Maybe<Array<Maybe<Asset_Caratteristica_Mutation_Response>>>;
  /** update data of the table: "asset_consumo" */
  update_asset_consumo?: Maybe<Asset_Consumo_Mutation_Response>;
  /** update single row of the table: "asset_consumo" */
  update_asset_consumo_by_pk?: Maybe<Asset_Consumo>;
  /** update multiples rows of table: "asset_consumo" */
  update_asset_consumo_many?: Maybe<Array<Maybe<Asset_Consumo_Mutation_Response>>>;
  /** update data of the table: "asset_dato_consumo" */
  update_asset_dato_consumo?: Maybe<Asset_Dato_Consumo_Mutation_Response>;
  /** update single row of the table: "asset_dato_consumo" */
  update_asset_dato_consumo_by_pk?: Maybe<Asset_Dato_Consumo>;
  /** update multiples rows of table: "asset_dato_consumo" */
  update_asset_dato_consumo_many?: Maybe<Array<Maybe<Asset_Dato_Consumo_Mutation_Response>>>;
  /** update data of the table: "asset_energia" */
  update_asset_energia?: Maybe<Asset_Energia_Mutation_Response>;
  /** update single row of the table: "asset_energia" */
  update_asset_energia_by_pk?: Maybe<Asset_Energia>;
  /** update multiples rows of table: "asset_energia" */
  update_asset_energia_many?: Maybe<Array<Maybe<Asset_Energia_Mutation_Response>>>;
  /** update data of the table: "asset_founder" */
  update_asset_founder?: Maybe<Asset_Founder_Mutation_Response>;
  /** update single row of the table: "asset_founder" */
  update_asset_founder_by_pk?: Maybe<Asset_Founder>;
  /** update multiples rows of table: "asset_founder" */
  update_asset_founder_many?: Maybe<Array<Maybe<Asset_Founder_Mutation_Response>>>;
  /** update data of the table: "asset_gestore" */
  update_asset_gestore?: Maybe<Asset_Gestore_Mutation_Response>;
  /** update single row of the table: "asset_gestore" */
  update_asset_gestore_by_pk?: Maybe<Asset_Gestore>;
  /** update multiples rows of table: "asset_gestore" */
  update_asset_gestore_many?: Maybe<Array<Maybe<Asset_Gestore_Mutation_Response>>>;
  /** update multiples rows of table: "asset" */
  update_asset_many?: Maybe<Array<Maybe<Asset_Mutation_Response>>>;
  /** update data of the table: "asset_produzione" */
  update_asset_produzione?: Maybe<Asset_Produzione_Mutation_Response>;
  /** update single row of the table: "asset_produzione" */
  update_asset_produzione_by_pk?: Maybe<Asset_Produzione>;
  /** update multiples rows of table: "asset_produzione" */
  update_asset_produzione_many?: Maybe<Array<Maybe<Asset_Produzione_Mutation_Response>>>;
  /** update data of the table: "asset_produzione_unita" */
  update_asset_produzione_unita?: Maybe<Asset_Produzione_Unita_Mutation_Response>;
  /** update single row of the table: "asset_produzione_unita" */
  update_asset_produzione_unita_by_pk?: Maybe<Asset_Produzione_Unita>;
  /** update multiples rows of table: "asset_produzione_unita" */
  update_asset_produzione_unita_many?: Maybe<Array<Maybe<Asset_Produzione_Unita_Mutation_Response>>>;
  /** update data of the table: "asset_produzione_unita_sezione" */
  update_asset_produzione_unita_sezione?: Maybe<Asset_Produzione_Unita_Sezione_Mutation_Response>;
  /** update single row of the table: "asset_produzione_unita_sezione" */
  update_asset_produzione_unita_sezione_by_pk?: Maybe<Asset_Produzione_Unita_Sezione>;
  /** update data of the table: "asset_produzione_unita_sezione_incentivi" */
  update_asset_produzione_unita_sezione_incentivi?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Mutation_Response>;
  /** update single row of the table: "asset_produzione_unita_sezione_incentivi" */
  update_asset_produzione_unita_sezione_incentivi_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** update multiples rows of table: "asset_produzione_unita_sezione_incentivi" */
  update_asset_produzione_unita_sezione_incentivi_many?: Maybe<Array<Maybe<Asset_Produzione_Unita_Sezione_Incentivi_Mutation_Response>>>;
  /** update multiples rows of table: "asset_produzione_unita_sezione" */
  update_asset_produzione_unita_sezione_many?: Maybe<Array<Maybe<Asset_Produzione_Unita_Sezione_Mutation_Response>>>;
  /** update data of the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  update_asset_produzione_unita_sezione_titolo_autorizzativo?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Mutation_Response>;
  /** update single row of the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  update_asset_produzione_unita_sezione_titolo_autorizzativo_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** update multiples rows of table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  update_asset_produzione_unita_sezione_titolo_autorizzativo_many?: Maybe<Array<Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Mutation_Response>>>;
  /** update data of the table: "asset_spazio" */
  update_asset_spazio?: Maybe<Asset_Spazio_Mutation_Response>;
  /** update single row of the table: "asset_spazio" */
  update_asset_spazio_by_pk?: Maybe<Asset_Spazio>;
  /** update multiples rows of table: "asset_spazio" */
  update_asset_spazio_many?: Maybe<Array<Maybe<Asset_Spazio_Mutation_Response>>>;
  /** update data of the table: "auth.event_entity" */
  update_auth_event_entity?: Maybe<Auth_Event_Entity_Mutation_Response>;
  /** update single row of the table: "auth.event_entity" */
  update_auth_event_entity_by_pk?: Maybe<Auth_Event_Entity>;
  /** update multiples rows of table: "auth.event_entity" */
  update_auth_event_entity_many?: Maybe<Array<Maybe<Auth_Event_Entity_Mutation_Response>>>;
  /** update data of the table: "auth.federated_identity" */
  update_auth_federated_identity?: Maybe<Auth_Federated_Identity_Mutation_Response>;
  /** update single row of the table: "auth.federated_identity" */
  update_auth_federated_identity_by_pk?: Maybe<Auth_Federated_Identity>;
  /** update multiples rows of table: "auth.federated_identity" */
  update_auth_federated_identity_many?: Maybe<Array<Maybe<Auth_Federated_Identity_Mutation_Response>>>;
  /** update data of the table: "auth.role_attribute" */
  update_auth_role_attribute?: Maybe<Auth_Role_Attribute_Mutation_Response>;
  /** update single row of the table: "auth.role_attribute" */
  update_auth_role_attribute_by_pk?: Maybe<Auth_Role_Attribute>;
  /** update multiples rows of table: "auth.role_attribute" */
  update_auth_role_attribute_many?: Maybe<Array<Maybe<Auth_Role_Attribute_Mutation_Response>>>;
  /** update data of the table: "auth.user_attribute" */
  update_auth_user_attribute?: Maybe<Auth_User_Attribute_Mutation_Response>;
  /** update single row of the table: "auth.user_attribute" */
  update_auth_user_attribute_by_pk?: Maybe<Auth_User_Attribute>;
  /** update multiples rows of table: "auth.user_attribute" */
  update_auth_user_attribute_many?: Maybe<Array<Maybe<Auth_User_Attribute_Mutation_Response>>>;
  /** update data of the table: "auth.user_entity" */
  update_auth_user_entity?: Maybe<Auth_User_Entity_Mutation_Response>;
  /** update single row of the table: "auth.user_entity" */
  update_auth_user_entity_by_pk?: Maybe<Auth_User_Entity>;
  /** update multiples rows of table: "auth.user_entity" */
  update_auth_user_entity_many?: Maybe<Array<Maybe<Auth_User_Entity_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update data of the table: "cer" */
  update_cer?: Maybe<Cer_Mutation_Response>;
  /** update single row of the table: "cer" */
  update_cer_by_pk?: Maybe<Cer>;
  /** update data of the table: "cer_cabina" */
  update_cer_cabina?: Maybe<Cer_Cabina_Mutation_Response>;
  /** update single row of the table: "cer_cabina" */
  update_cer_cabina_by_pk?: Maybe<Cer_Cabina>;
  /** update multiples rows of table: "cer_cabina" */
  update_cer_cabina_many?: Maybe<Array<Maybe<Cer_Cabina_Mutation_Response>>>;
  /** update data of the table: "cer_cabina_snapshot" */
  update_cer_cabina_snapshot?: Maybe<Cer_Cabina_Snapshot_Mutation_Response>;
  /** update single row of the table: "cer_cabina_snapshot" */
  update_cer_cabina_snapshot_by_pk?: Maybe<Cer_Cabina_Snapshot>;
  /** update multiples rows of table: "cer_cabina_snapshot" */
  update_cer_cabina_snapshot_many?: Maybe<Array<Maybe<Cer_Cabina_Snapshot_Mutation_Response>>>;
  /** update data of the table: "cer_categoria_adesione" */
  update_cer_categoria_adesione?: Maybe<Cer_Categoria_Adesione_Mutation_Response>;
  /** update single row of the table: "cer_categoria_adesione" */
  update_cer_categoria_adesione_by_pk?: Maybe<Cer_Categoria_Adesione>;
  /** update multiples rows of table: "cer_categoria_adesione" */
  update_cer_categoria_adesione_many?: Maybe<Array<Maybe<Cer_Categoria_Adesione_Mutation_Response>>>;
  /** update data of the table: "cer_configurazione_destinazione_contributo" */
  update_cer_configurazione_destinazione_contributo?: Maybe<Cer_Configurazione_Destinazione_Contributo_Mutation_Response>;
  /** update single row of the table: "cer_configurazione_destinazione_contributo" */
  update_cer_configurazione_destinazione_contributo_by_pk?: Maybe<Cer_Configurazione_Destinazione_Contributo>;
  /** update multiples rows of table: "cer_configurazione_destinazione_contributo" */
  update_cer_configurazione_destinazione_contributo_many?: Maybe<Array<Maybe<Cer_Configurazione_Destinazione_Contributo_Mutation_Response>>>;
  /** update data of the table: "cer_contatti" */
  update_cer_contatti?: Maybe<Cer_Contatti_Mutation_Response>;
  /** update single row of the table: "cer_contatti" */
  update_cer_contatti_by_pk?: Maybe<Cer_Contatti>;
  /** update multiples rows of table: "cer_contatti" */
  update_cer_contatti_many?: Maybe<Array<Maybe<Cer_Contatti_Mutation_Response>>>;
  /** update data of the table: "cer_destinazione_contributo" */
  update_cer_destinazione_contributo?: Maybe<Cer_Destinazione_Contributo_Mutation_Response>;
  /** update single row of the table: "cer_destinazione_contributo" */
  update_cer_destinazione_contributo_by_pk?: Maybe<Cer_Destinazione_Contributo>;
  /** update multiples rows of table: "cer_destinazione_contributo" */
  update_cer_destinazione_contributo_many?: Maybe<Array<Maybe<Cer_Destinazione_Contributo_Mutation_Response>>>;
  /** update data of the table: "cer_geom" */
  update_cer_geom?: Maybe<Cer_Geom_Mutation_Response>;
  /** update single row of the table: "cer_geom" */
  update_cer_geom_by_pk?: Maybe<Cer_Geom>;
  /** update multiples rows of table: "cer_geom" */
  update_cer_geom_many?: Maybe<Array<Maybe<Cer_Geom_Mutation_Response>>>;
  /** update data of the table: "cer_gestore" */
  update_cer_gestore?: Maybe<Cer_Gestore_Mutation_Response>;
  /** update single row of the table: "cer_gestore" */
  update_cer_gestore_by_pk?: Maybe<Cer_Gestore>;
  /** update multiples rows of table: "cer_gestore" */
  update_cer_gestore_many?: Maybe<Array<Maybe<Cer_Gestore_Mutation_Response>>>;
  /** update multiples rows of table: "cer" */
  update_cer_many?: Maybe<Array<Maybe<Cer_Mutation_Response>>>;
  /** update data of the table: "cer_search_index" */
  update_cer_search_index?: Maybe<Cer_Search_Index_Mutation_Response>;
  /** update single row of the table: "cer_search_index" */
  update_cer_search_index_by_pk?: Maybe<Cer_Search_Index>;
  /** update multiples rows of table: "cer_search_index" */
  update_cer_search_index_many?: Maybe<Array<Maybe<Cer_Search_Index_Mutation_Response>>>;
  /** update data of the table: "cer_tecnico" */
  update_cer_tecnico?: Maybe<Cer_Tecnico_Mutation_Response>;
  /** update single row of the table: "cer_tecnico" */
  update_cer_tecnico_by_pk?: Maybe<Cer_Tecnico>;
  /** update multiples rows of table: "cer_tecnico" */
  update_cer_tecnico_many?: Maybe<Array<Maybe<Cer_Tecnico_Mutation_Response>>>;
  /** update data of the table: "codice_operatore" */
  update_codice_operatore?: Maybe<Codice_Operatore_Mutation_Response>;
  /** update single row of the table: "codice_operatore" */
  update_codice_operatore_by_pk?: Maybe<Codice_Operatore>;
  /** update multiples rows of table: "codice_operatore" */
  update_codice_operatore_many?: Maybe<Array<Maybe<Codice_Operatore_Mutation_Response>>>;
  /** update data of the table: "comunicazioni.email" */
  update_comunicazioni_email?: Maybe<Comunicazioni_Email_Mutation_Response>;
  /** update single row of the table: "comunicazioni.email" */
  update_comunicazioni_email_by_pk?: Maybe<Comunicazioni_Email>;
  /** update multiples rows of table: "comunicazioni.email" */
  update_comunicazioni_email_many?: Maybe<Array<Maybe<Comunicazioni_Email_Mutation_Response>>>;
  /** update data of the table: "comunicazioni.email_template" */
  update_comunicazioni_email_template?: Maybe<Comunicazioni_Email_Template_Mutation_Response>;
  /** update single row of the table: "comunicazioni.email_template" */
  update_comunicazioni_email_template_by_pk?: Maybe<Comunicazioni_Email_Template>;
  /** update multiples rows of table: "comunicazioni.email_template" */
  update_comunicazioni_email_template_many?: Maybe<Array<Maybe<Comunicazioni_Email_Template_Mutation_Response>>>;
  /** update data of the table: "comunicazioni.sms" */
  update_comunicazioni_sms?: Maybe<Comunicazioni_Sms_Mutation_Response>;
  /** update single row of the table: "comunicazioni.sms" */
  update_comunicazioni_sms_by_pk?: Maybe<Comunicazioni_Sms>;
  /** update multiples rows of table: "comunicazioni.sms" */
  update_comunicazioni_sms_many?: Maybe<Array<Maybe<Comunicazioni_Sms_Mutation_Response>>>;
  /** update data of the table: "condivisione._stato_condivisione" */
  update_condivisione__stato_condivisione?: Maybe<Condivisione__Stato_Condivisione_Mutation_Response>;
  /** update single row of the table: "condivisione._stato_condivisione" */
  update_condivisione__stato_condivisione_by_pk?: Maybe<Condivisione__Stato_Condivisione>;
  /** update multiples rows of table: "condivisione._stato_condivisione" */
  update_condivisione__stato_condivisione_many?: Maybe<Array<Maybe<Condivisione__Stato_Condivisione_Mutation_Response>>>;
  /** update data of the table: "condivisione.accetta_response" */
  update_condivisione_accetta_response?: Maybe<Condivisione_Accetta_Response_Mutation_Response>;
  /** update multiples rows of table: "condivisione.accetta_response" */
  update_condivisione_accetta_response_many?: Maybe<Array<Maybe<Condivisione_Accetta_Response_Mutation_Response>>>;
  /** update data of the table: "condivisione.condivisione" */
  update_condivisione_condivisione?: Maybe<Condivisione_Condivisione_Mutation_Response>;
  /** update single row of the table: "condivisione.condivisione" */
  update_condivisione_condivisione_by_pk?: Maybe<Condivisione_Condivisione>;
  /** update multiples rows of table: "condivisione.condivisione" */
  update_condivisione_condivisione_many?: Maybe<Array<Maybe<Condivisione_Condivisione_Mutation_Response>>>;
  /** update data of the table: "condivisione.log_condivisione" */
  update_condivisione_log_condivisione?: Maybe<Condivisione_Log_Condivisione_Mutation_Response>;
  /** update single row of the table: "condivisione.log_condivisione" */
  update_condivisione_log_condivisione_by_pk?: Maybe<Condivisione_Log_Condivisione>;
  /** update multiples rows of table: "condivisione.log_condivisione" */
  update_condivisione_log_condivisione_many?: Maybe<Array<Maybe<Condivisione_Log_Condivisione_Mutation_Response>>>;
  /** update data of the table: "contatto" */
  update_contatto?: Maybe<Contatto_Mutation_Response>;
  /** update single row of the table: "contatto" */
  update_contatto_by_pk?: Maybe<Contatto>;
  /** update multiples rows of table: "contatto" */
  update_contatto_many?: Maybe<Array<Maybe<Contatto_Mutation_Response>>>;
  /** update data of the table: "crm.audit_event" */
  update_crm_audit_event?: Maybe<Crm_Audit_Event_Mutation_Response>;
  /** update single row of the table: "crm.audit_event" */
  update_crm_audit_event_by_pk?: Maybe<Crm_Audit_Event>;
  /** update multiples rows of table: "crm.audit_event" */
  update_crm_audit_event_many?: Maybe<Array<Maybe<Crm_Audit_Event_Mutation_Response>>>;
  /** update data of the table: "debug.sottoscrizione_after_log" */
  update_debug_sottoscrizione_after_log?: Maybe<Debug_Sottoscrizione_After_Log_Mutation_Response>;
  /** update single row of the table: "debug.sottoscrizione_after_log" */
  update_debug_sottoscrizione_after_log_by_pk?: Maybe<Debug_Sottoscrizione_After_Log>;
  /** update multiples rows of table: "debug.sottoscrizione_after_log" */
  update_debug_sottoscrizione_after_log_many?: Maybe<Array<Maybe<Debug_Sottoscrizione_After_Log_Mutation_Response>>>;
  /** update data of the table: "device.device" */
  update_device_device?: Maybe<Device_Device_Mutation_Response>;
  /** update single row of the table: "device.device" */
  update_device_device_by_pk?: Maybe<Device_Device>;
  /** update multiples rows of table: "device.device" */
  update_device_device_many?: Maybe<Array<Maybe<Device_Device_Mutation_Response>>>;
  /** update data of the table: "energy_village._azioni_founder_sottoscrizione" */
  update_energy_village__azioni_founder_sottoscrizione?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "energy_village._azioni_founder_sottoscrizione" */
  update_energy_village__azioni_founder_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** update multiples rows of table: "energy_village._azioni_founder_sottoscrizione" */
  update_energy_village__azioni_founder_sottoscrizione_many?: Maybe<Array<Maybe<Energy_Village__Azioni_Founder_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "energy_village._azioni_prosumer_sottoscrizione" */
  update_energy_village__azioni_prosumer_sottoscrizione?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "energy_village._azioni_prosumer_sottoscrizione" */
  update_energy_village__azioni_prosumer_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** update multiples rows of table: "energy_village._azioni_prosumer_sottoscrizione" */
  update_energy_village__azioni_prosumer_sottoscrizione_many?: Maybe<Array<Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "energy_village._azioni_tecnico_sottoscrizione" */
  update_energy_village__azioni_tecnico_sottoscrizione?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "energy_village._azioni_tecnico_sottoscrizione" */
  update_energy_village__azioni_tecnico_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** update multiples rows of table: "energy_village._azioni_tecnico_sottoscrizione" */
  update_energy_village__azioni_tecnico_sottoscrizione_many?: Maybe<Array<Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "energy_village._cer_filter_options" */
  update_energy_village__cer_filter_options?: Maybe<Energy_Village__Cer_Filter_Options_Mutation_Response>;
  /** update single row of the table: "energy_village._cer_filter_options" */
  update_energy_village__cer_filter_options_by_pk?: Maybe<Energy_Village__Cer_Filter_Options>;
  /** update multiples rows of table: "energy_village._cer_filter_options" */
  update_energy_village__cer_filter_options_many?: Maybe<Array<Maybe<Energy_Village__Cer_Filter_Options_Mutation_Response>>>;
  /** update data of the table: "energy_village._stato_cer" */
  update_energy_village__stato_cer?: Maybe<Energy_Village__Stato_Cer_Mutation_Response>;
  /** update single row of the table: "energy_village._stato_cer" */
  update_energy_village__stato_cer_by_pk?: Maybe<Energy_Village__Stato_Cer>;
  /** update multiples rows of table: "energy_village._stato_cer" */
  update_energy_village__stato_cer_many?: Maybe<Array<Maybe<Energy_Village__Stato_Cer_Mutation_Response>>>;
  /** update data of the table: "energy_village._stato_sottoscrizione" */
  update_energy_village__stato_sottoscrizione?: Maybe<Energy_Village__Stato_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "energy_village._stato_sottoscrizione" */
  update_energy_village__stato_sottoscrizione_by_pk?: Maybe<Energy_Village__Stato_Sottoscrizione>;
  /** update multiples rows of table: "energy_village._stato_sottoscrizione" */
  update_energy_village__stato_sottoscrizione_many?: Maybe<Array<Maybe<Energy_Village__Stato_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "energy_village._tipo_domanda" */
  update_energy_village__tipo_domanda?: Maybe<Energy_Village__Tipo_Domanda_Mutation_Response>;
  /** update single row of the table: "energy_village._tipo_domanda" */
  update_energy_village__tipo_domanda_by_pk?: Maybe<Energy_Village__Tipo_Domanda>;
  /** update multiples rows of table: "energy_village._tipo_domanda" */
  update_energy_village__tipo_domanda_many?: Maybe<Array<Maybe<Energy_Village__Tipo_Domanda_Mutation_Response>>>;
  /** update data of the table: "energy_village._tipo_feedback" */
  update_energy_village__tipo_feedback?: Maybe<Energy_Village__Tipo_Feedback_Mutation_Response>;
  /** update single row of the table: "energy_village._tipo_feedback" */
  update_energy_village__tipo_feedback_by_pk?: Maybe<Energy_Village__Tipo_Feedback>;
  /** update multiples rows of table: "energy_village._tipo_feedback" */
  update_energy_village__tipo_feedback_many?: Maybe<Array<Maybe<Energy_Village__Tipo_Feedback_Mutation_Response>>>;
  /** update data of the table: "energy_village.area" */
  update_energy_village_area?: Maybe<Energy_Village_Area_Mutation_Response>;
  /** update single row of the table: "energy_village.area" */
  update_energy_village_area_by_pk?: Maybe<Energy_Village_Area>;
  /** update data of the table: "energy_village.area_citta" */
  update_energy_village_area_citta?: Maybe<Energy_Village_Area_Citta_Mutation_Response>;
  /** update single row of the table: "energy_village.area_citta" */
  update_energy_village_area_citta_by_pk?: Maybe<Energy_Village_Area_Citta>;
  /** update multiples rows of table: "energy_village.area_citta" */
  update_energy_village_area_citta_many?: Maybe<Array<Maybe<Energy_Village_Area_Citta_Mutation_Response>>>;
  /** update multiples rows of table: "energy_village.area" */
  update_energy_village_area_many?: Maybe<Array<Maybe<Energy_Village_Area_Mutation_Response>>>;
  /** update data of the table: "energy_village.area_provincia" */
  update_energy_village_area_provincia?: Maybe<Energy_Village_Area_Provincia_Mutation_Response>;
  /** update single row of the table: "energy_village.area_provincia" */
  update_energy_village_area_provincia_by_pk?: Maybe<Energy_Village_Area_Provincia>;
  /** update multiples rows of table: "energy_village.area_provincia" */
  update_energy_village_area_provincia_many?: Maybe<Array<Maybe<Energy_Village_Area_Provincia_Mutation_Response>>>;
  /** update data of the table: "energy_village.area_regione" */
  update_energy_village_area_regione?: Maybe<Energy_Village_Area_Regione_Mutation_Response>;
  /** update single row of the table: "energy_village.area_regione" */
  update_energy_village_area_regione_by_pk?: Maybe<Energy_Village_Area_Regione>;
  /** update multiples rows of table: "energy_village.area_regione" */
  update_energy_village_area_regione_many?: Maybe<Array<Maybe<Energy_Village_Area_Regione_Mutation_Response>>>;
  /** update data of the table: "energy_village.azioni" */
  update_energy_village_azioni?: Maybe<Energy_Village_Azioni_Mutation_Response>;
  /** update single row of the table: "energy_village.azioni" */
  update_energy_village_azioni_by_pk?: Maybe<Energy_Village_Azioni>;
  /** update multiples rows of table: "energy_village.azioni" */
  update_energy_village_azioni_many?: Maybe<Array<Maybe<Energy_Village_Azioni_Mutation_Response>>>;
  /** update data of the table: "energy_village.cabina" */
  update_energy_village_cabina?: Maybe<Energy_Village_Cabina_Mutation_Response>;
  /** update single row of the table: "energy_village.cabina" */
  update_energy_village_cabina_by_pk?: Maybe<Energy_Village_Cabina>;
  /** update data of the table: "energy_village.cabina_citta" */
  update_energy_village_cabina_citta?: Maybe<Energy_Village_Cabina_Citta_Mutation_Response>;
  /** update single row of the table: "energy_village.cabina_citta" */
  update_energy_village_cabina_citta_by_pk?: Maybe<Energy_Village_Cabina_Citta>;
  /** update multiples rows of table: "energy_village.cabina_citta" */
  update_energy_village_cabina_citta_many?: Maybe<Array<Maybe<Energy_Village_Cabina_Citta_Mutation_Response>>>;
  /** update multiples rows of table: "energy_village.cabina" */
  update_energy_village_cabina_many?: Maybe<Array<Maybe<Energy_Village_Cabina_Mutation_Response>>>;
  /** update data of the table: "energy_village.caratteristica" */
  update_energy_village_caratteristica?: Maybe<Energy_Village_Caratteristica_Mutation_Response>;
  /** update single row of the table: "energy_village.caratteristica" */
  update_energy_village_caratteristica_by_pk?: Maybe<Energy_Village_Caratteristica>;
  /** update multiples rows of table: "energy_village.caratteristica" */
  update_energy_village_caratteristica_many?: Maybe<Array<Maybe<Energy_Village_Caratteristica_Mutation_Response>>>;
  /** update data of the table: "energy_village.cer_filter_options" */
  update_energy_village_cer_filter_options?: Maybe<Energy_Village_Cer_Filter_Options_Mutation_Response>;
  /** update single row of the table: "energy_village.cer_filter_options" */
  update_energy_village_cer_filter_options_by_pk?: Maybe<Energy_Village_Cer_Filter_Options>;
  /** update multiples rows of table: "energy_village.cer_filter_options" */
  update_energy_village_cer_filter_options_many?: Maybe<Array<Maybe<Energy_Village_Cer_Filter_Options_Mutation_Response>>>;
  /** update data of the table: "energy_village.dimensione" */
  update_energy_village_dimensione?: Maybe<Energy_Village_Dimensione_Mutation_Response>;
  /** update single row of the table: "energy_village.dimensione" */
  update_energy_village_dimensione_by_pk?: Maybe<Energy_Village_Dimensione>;
  /** update multiples rows of table: "energy_village.dimensione" */
  update_energy_village_dimensione_many?: Maybe<Array<Maybe<Energy_Village_Dimensione_Mutation_Response>>>;
  /** update data of the table: "energy_village.feedback" */
  update_energy_village_feedback?: Maybe<Energy_Village_Feedback_Mutation_Response>;
  /** update single row of the table: "energy_village.feedback" */
  update_energy_village_feedback_by_pk?: Maybe<Energy_Village_Feedback>;
  /** update multiples rows of table: "energy_village.feedback" */
  update_energy_village_feedback_many?: Maybe<Array<Maybe<Energy_Village_Feedback_Mutation_Response>>>;
  /** update data of the table: "energy_village.incentivo_impianto" */
  update_energy_village_incentivo_impianto?: Maybe<Energy_Village_Incentivo_Impianto_Mutation_Response>;
  /** update single row of the table: "energy_village.incentivo_impianto" */
  update_energy_village_incentivo_impianto_by_pk?: Maybe<Energy_Village_Incentivo_Impianto>;
  /** update multiples rows of table: "energy_village.incentivo_impianto" */
  update_energy_village_incentivo_impianto_many?: Maybe<Array<Maybe<Energy_Village_Incentivo_Impianto_Mutation_Response>>>;
  /** update data of the table: "energy_village.orario" */
  update_energy_village_orario?: Maybe<Energy_Village_Orario_Mutation_Response>;
  /** update single row of the table: "energy_village.orario" */
  update_energy_village_orario_by_pk?: Maybe<Energy_Village_Orario>;
  /** update multiples rows of table: "energy_village.orario" */
  update_energy_village_orario_many?: Maybe<Array<Maybe<Energy_Village_Orario_Mutation_Response>>>;
  /** update data of the table: "energy_village.potenza_impianto" */
  update_energy_village_potenza_impianto?: Maybe<Energy_Village_Potenza_Impianto_Mutation_Response>;
  /** update single row of the table: "energy_village.potenza_impianto" */
  update_energy_village_potenza_impianto_by_pk?: Maybe<Energy_Village_Potenza_Impianto>;
  /** update multiples rows of table: "energy_village.potenza_impianto" */
  update_energy_village_potenza_impianto_many?: Maybe<Array<Maybe<Energy_Village_Potenza_Impianto_Mutation_Response>>>;
  /** update data of the table: "energy_village.potenzialita_cabina" */
  update_energy_village_potenzialita_cabina?: Maybe<Energy_Village_Potenzialita_Cabina_Mutation_Response>;
  /** update single row of the table: "energy_village.potenzialita_cabina" */
  update_energy_village_potenzialita_cabina_by_pk?: Maybe<Energy_Village_Potenzialita_Cabina>;
  /** update multiples rows of table: "energy_village.potenzialita_cabina" */
  update_energy_village_potenzialita_cabina_many?: Maybe<Array<Maybe<Energy_Village_Potenzialita_Cabina_Mutation_Response>>>;
  /** update data of the table: "energy_village.tipo_spazio_disponibile" */
  update_energy_village_tipo_spazio_disponibile?: Maybe<Energy_Village_Tipo_Spazio_Disponibile_Mutation_Response>;
  /** update single row of the table: "energy_village.tipo_spazio_disponibile" */
  update_energy_village_tipo_spazio_disponibile_by_pk?: Maybe<Energy_Village_Tipo_Spazio_Disponibile>;
  /** update multiples rows of table: "energy_village.tipo_spazio_disponibile" */
  update_energy_village_tipo_spazio_disponibile_many?: Maybe<Array<Maybe<Energy_Village_Tipo_Spazio_Disponibile_Mutation_Response>>>;
  /** update data of the table: "energy_village.tipologia_abitativa" */
  update_energy_village_tipologia_abitativa?: Maybe<Energy_Village_Tipologia_Abitativa_Mutation_Response>;
  /** update single row of the table: "energy_village.tipologia_abitativa" */
  update_energy_village_tipologia_abitativa_by_pk?: Maybe<Energy_Village_Tipologia_Abitativa>;
  /** update multiples rows of table: "energy_village.tipologia_abitativa" */
  update_energy_village_tipologia_abitativa_many?: Maybe<Array<Maybe<Energy_Village_Tipologia_Abitativa_Mutation_Response>>>;
  /** update data of the table: "energy_village.tipologia_asset" */
  update_energy_village_tipologia_asset?: Maybe<Energy_Village_Tipologia_Asset_Mutation_Response>;
  /** update single row of the table: "energy_village.tipologia_asset" */
  update_energy_village_tipologia_asset_by_pk?: Maybe<Energy_Village_Tipologia_Asset>;
  /** update multiples rows of table: "energy_village.tipologia_asset" */
  update_energy_village_tipologia_asset_many?: Maybe<Array<Maybe<Energy_Village_Tipologia_Asset_Mutation_Response>>>;
  /** update data of the table: "energy_village.titolo_autorizzativo" */
  update_energy_village_titolo_autorizzativo?: Maybe<Energy_Village_Titolo_Autorizzativo_Mutation_Response>;
  /** update single row of the table: "energy_village.titolo_autorizzativo" */
  update_energy_village_titolo_autorizzativo_by_pk?: Maybe<Energy_Village_Titolo_Autorizzativo>;
  /** update multiples rows of table: "energy_village.titolo_autorizzativo" */
  update_energy_village_titolo_autorizzativo_many?: Maybe<Array<Maybe<Energy_Village_Titolo_Autorizzativo_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "flussi_gse.flusso" */
  update_flussi_gse_flusso?: Maybe<Flussi_Gse_Flusso_Mutation_Response>;
  /** update single row of the table: "flussi_gse.flusso" */
  update_flussi_gse_flusso_by_pk?: Maybe<Flussi_Gse_Flusso>;
  /** update multiples rows of table: "flussi_gse.flusso" */
  update_flussi_gse_flusso_many?: Maybe<Array<Maybe<Flussi_Gse_Flusso_Mutation_Response>>>;
  /** update data of the table: "funzione_log" */
  update_funzione_log?: Maybe<Funzione_Log_Mutation_Response>;
  /** update single row of the table: "funzione_log" */
  update_funzione_log_by_pk?: Maybe<Funzione_Log>;
  /** update multiples rows of table: "funzione_log" */
  update_funzione_log_many?: Maybe<Array<Maybe<Funzione_Log_Mutation_Response>>>;
  /** update data of the table: "incentivi._stato_calcolo" */
  update_incentivi__stato_calcolo?: Maybe<Incentivi__Stato_Calcolo_Mutation_Response>;
  /** update single row of the table: "incentivi._stato_calcolo" */
  update_incentivi__stato_calcolo_by_pk?: Maybe<Incentivi__Stato_Calcolo>;
  /** update multiples rows of table: "incentivi._stato_calcolo" */
  update_incentivi__stato_calcolo_many?: Maybe<Array<Maybe<Incentivi__Stato_Calcolo_Mutation_Response>>>;
  /** update data of the table: "incentivi.calcolati" */
  update_incentivi_calcolati?: Maybe<Incentivi_Calcolati_Mutation_Response>;
  /** update single row of the table: "incentivi.calcolati" */
  update_incentivi_calcolati_by_pk?: Maybe<Incentivi_Calcolati>;
  /** update multiples rows of table: "incentivi.calcolati" */
  update_incentivi_calcolati_many?: Maybe<Array<Maybe<Incentivi_Calcolati_Mutation_Response>>>;
  /** update data of the table: "incentivi.log_ripartizione" */
  update_incentivi_log_ripartizione?: Maybe<Incentivi_Log_Ripartizione_Mutation_Response>;
  /** update single row of the table: "incentivi.log_ripartizione" */
  update_incentivi_log_ripartizione_by_pk?: Maybe<Incentivi_Log_Ripartizione>;
  /** update multiples rows of table: "incentivi.log_ripartizione" */
  update_incentivi_log_ripartizione_many?: Maybe<Array<Maybe<Incentivi_Log_Ripartizione_Mutation_Response>>>;
  /** update data of the table: "incentivi.ripartizione" */
  update_incentivi_ripartizione?: Maybe<Incentivi_Ripartizione_Mutation_Response>;
  /** update single row of the table: "incentivi.ripartizione" */
  update_incentivi_ripartizione_by_pk?: Maybe<Incentivi_Ripartizione>;
  /** update multiples rows of table: "incentivi.ripartizione" */
  update_incentivi_ripartizione_many?: Maybe<Array<Maybe<Incentivi_Ripartizione_Mutation_Response>>>;
  /** update data of the table: "indirizzo" */
  update_indirizzo?: Maybe<Indirizzo_Mutation_Response>;
  /** update single row of the table: "indirizzo" */
  update_indirizzo_by_pk?: Maybe<Indirizzo>;
  /** update multiples rows of table: "indirizzo" */
  update_indirizzo_many?: Maybe<Array<Maybe<Indirizzo_Mutation_Response>>>;
  /** update data of the table: "inseritore" */
  update_inseritore?: Maybe<Inseritore_Mutation_Response>;
  /** update single row of the table: "inseritore" */
  update_inseritore_by_pk?: Maybe<Inseritore>;
  /** update multiples rows of table: "inseritore" */
  update_inseritore_many?: Maybe<Array<Maybe<Inseritore_Mutation_Response>>>;
  /** update data of the table: "installatore" */
  update_installatore?: Maybe<Installatore_Mutation_Response>;
  /** update single row of the table: "installatore" */
  update_installatore_by_pk?: Maybe<Installatore>;
  /** update multiples rows of table: "installatore" */
  update_installatore_many?: Maybe<Array<Maybe<Installatore_Mutation_Response>>>;
  /** update data of the table: "log_errori_funzioni" */
  update_log_errori_funzioni?: Maybe<Log_Errori_Funzioni_Mutation_Response>;
  /** update single row of the table: "log_errori_funzioni" */
  update_log_errori_funzioni_by_pk?: Maybe<Log_Errori_Funzioni>;
  /** update multiples rows of table: "log_errori_funzioni" */
  update_log_errori_funzioni_many?: Maybe<Array<Maybe<Log_Errori_Funzioni_Mutation_Response>>>;
  /** update data of the table: "persona" */
  update_persona?: Maybe<Persona_Mutation_Response>;
  /** update single row of the table: "persona" */
  update_persona_by_pk?: Maybe<Persona>;
  /** update data of the table: "persona_contatto" */
  update_persona_contatto?: Maybe<Persona_Contatto_Mutation_Response>;
  /** update single row of the table: "persona_contatto" */
  update_persona_contatto_by_pk?: Maybe<Persona_Contatto>;
  /** update multiples rows of table: "persona_contatto" */
  update_persona_contatto_many?: Maybe<Array<Maybe<Persona_Contatto_Mutation_Response>>>;
  /** update multiples rows of table: "persona" */
  update_persona_many?: Maybe<Array<Maybe<Persona_Mutation_Response>>>;
  /** update data of the table: "pnrr_documenti" */
  update_pnrr_documenti?: Maybe<Pnrr_Documenti_Mutation_Response>;
  /** update single row of the table: "pnrr_documenti" */
  update_pnrr_documenti_by_pk?: Maybe<Pnrr_Documenti>;
  /** update multiples rows of table: "pnrr_documenti" */
  update_pnrr_documenti_many?: Maybe<Array<Maybe<Pnrr_Documenti_Mutation_Response>>>;
  /** update data of the table: "preset" */
  update_preset?: Maybe<Preset_Mutation_Response>;
  /** update single row of the table: "preset" */
  update_preset_by_pk?: Maybe<Preset>;
  /** update multiples rows of table: "preset" */
  update_preset_many?: Maybe<Array<Maybe<Preset_Mutation_Response>>>;
  /** update data of the table: "profilo" */
  update_profilo?: Maybe<Profilo_Mutation_Response>;
  /** update single row of the table: "profilo" */
  update_profilo_by_pk?: Maybe<Profilo>;
  /** update multiples rows of table: "profilo" */
  update_profilo_many?: Maybe<Array<Maybe<Profilo_Mutation_Response>>>;
  /** update data of the table: "sottoscrizione" */
  update_sottoscrizione?: Maybe<Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "sottoscrizione" */
  update_sottoscrizione_by_pk?: Maybe<Sottoscrizione>;
  /** update data of the table: "sottoscrizione_documenti" */
  update_sottoscrizione_documenti?: Maybe<Sottoscrizione_Documenti_Mutation_Response>;
  /** update single row of the table: "sottoscrizione_documenti" */
  update_sottoscrizione_documenti_by_pk?: Maybe<Sottoscrizione_Documenti>;
  /** update multiples rows of table: "sottoscrizione_documenti" */
  update_sottoscrizione_documenti_many?: Maybe<Array<Maybe<Sottoscrizione_Documenti_Mutation_Response>>>;
  /** update data of the table: "sottoscrizione_domande" */
  update_sottoscrizione_domande?: Maybe<Sottoscrizione_Domande_Mutation_Response>;
  /** update single row of the table: "sottoscrizione_domande" */
  update_sottoscrizione_domande_by_pk?: Maybe<Sottoscrizione_Domande>;
  /** update multiples rows of table: "sottoscrizione_domande" */
  update_sottoscrizione_domande_many?: Maybe<Array<Maybe<Sottoscrizione_Domande_Mutation_Response>>>;
  /** update data of the table: "sottoscrizione_iniziativa" */
  update_sottoscrizione_iniziativa?: Maybe<Sottoscrizione_Iniziativa_Mutation_Response>;
  /** update single row of the table: "sottoscrizione_iniziativa" */
  update_sottoscrizione_iniziativa_by_pk?: Maybe<Sottoscrizione_Iniziativa>;
  /** update multiples rows of table: "sottoscrizione_iniziativa" */
  update_sottoscrizione_iniziativa_many?: Maybe<Array<Maybe<Sottoscrizione_Iniziativa_Mutation_Response>>>;
  /** update multiples rows of table: "sottoscrizione" */
  update_sottoscrizione_many?: Maybe<Array<Maybe<Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "sottoscrizione_zip" */
  update_sottoscrizione_zip?: Maybe<Sottoscrizione_Zip_Mutation_Response>;
  /** update single row of the table: "sottoscrizione_zip" */
  update_sottoscrizione_zip_by_pk?: Maybe<Sottoscrizione_Zip>;
  /** update multiples rows of table: "sottoscrizione_zip" */
  update_sottoscrizione_zip_many?: Maybe<Array<Maybe<Sottoscrizione_Zip_Mutation_Response>>>;
  /** update data of the table: "staging._stato_sottoscrizione" */
  update_staging__stato_sottoscrizione?: Maybe<Staging__Stato_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "staging._stato_sottoscrizione" */
  update_staging__stato_sottoscrizione_by_pk?: Maybe<Staging__Stato_Sottoscrizione>;
  /** update multiples rows of table: "staging._stato_sottoscrizione" */
  update_staging__stato_sottoscrizione_many?: Maybe<Array<Maybe<Staging__Stato_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "staging.azione_sottoscrizione" */
  update_staging_azione_sottoscrizione?: Maybe<Staging_Azione_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "staging.azione_sottoscrizione" */
  update_staging_azione_sottoscrizione_by_pk?: Maybe<Staging_Azione_Sottoscrizione>;
  /** update multiples rows of table: "staging.azione_sottoscrizione" */
  update_staging_azione_sottoscrizione_many?: Maybe<Array<Maybe<Staging_Azione_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "staging.gestore_lotto" */
  update_staging_gestore_lotto?: Maybe<Staging_Gestore_Lotto_Mutation_Response>;
  /** update single row of the table: "staging.gestore_lotto" */
  update_staging_gestore_lotto_by_pk?: Maybe<Staging_Gestore_Lotto>;
  /** update multiples rows of table: "staging.gestore_lotto" */
  update_staging_gestore_lotto_many?: Maybe<Array<Maybe<Staging_Gestore_Lotto_Mutation_Response>>>;
  /** update data of the table: "staging.gestore_sottoscrizione" */
  update_staging_gestore_sottoscrizione?: Maybe<Staging_Gestore_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "staging.gestore_sottoscrizione" */
  update_staging_gestore_sottoscrizione_by_pk?: Maybe<Staging_Gestore_Sottoscrizione>;
  /** update multiples rows of table: "staging.gestore_sottoscrizione" */
  update_staging_gestore_sottoscrizione_many?: Maybe<Array<Maybe<Staging_Gestore_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "staging.log" */
  update_staging_log?: Maybe<Staging_Log_Mutation_Response>;
  /** update single row of the table: "staging.log" */
  update_staging_log_by_pk?: Maybe<Staging_Log>;
  /** update multiples rows of table: "staging.log" */
  update_staging_log_many?: Maybe<Array<Maybe<Staging_Log_Mutation_Response>>>;
  /** update data of the table: "staging.lotto" */
  update_staging_lotto?: Maybe<Staging_Lotto_Mutation_Response>;
  /** update single row of the table: "staging.lotto" */
  update_staging_lotto_by_pk?: Maybe<Staging_Lotto>;
  /** update multiples rows of table: "staging.lotto" */
  update_staging_lotto_many?: Maybe<Array<Maybe<Staging_Lotto_Mutation_Response>>>;
  /** update data of the table: "staging.mv_refresh_state" */
  update_staging_mv_refresh_state?: Maybe<Staging_Mv_Refresh_State_Mutation_Response>;
  /** update single row of the table: "staging.mv_refresh_state" */
  update_staging_mv_refresh_state_by_pk?: Maybe<Staging_Mv_Refresh_State>;
  /** update multiples rows of table: "staging.mv_refresh_state" */
  update_staging_mv_refresh_state_many?: Maybe<Array<Maybe<Staging_Mv_Refresh_State_Mutation_Response>>>;
  /** update data of the table: "staging.sottoscrizione" */
  update_staging_sottoscrizione?: Maybe<Staging_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "staging.sottoscrizione" */
  update_staging_sottoscrizione_by_pk?: Maybe<Staging_Sottoscrizione>;
  /** update multiples rows of table: "staging.sottoscrizione" */
  update_staging_sottoscrizione_many?: Maybe<Array<Maybe<Staging_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "storage.trigger_debug_log" */
  update_storage_trigger_debug_log?: Maybe<Storage_Trigger_Debug_Log_Mutation_Response>;
  /** update single row of the table: "storage.trigger_debug_log" */
  update_storage_trigger_debug_log_by_pk?: Maybe<Storage_Trigger_Debug_Log>;
  /** update multiples rows of table: "storage.trigger_debug_log" */
  update_storage_trigger_debug_log_many?: Maybe<Array<Maybe<Storage_Trigger_Debug_Log_Mutation_Response>>>;
  /** update data of the table: "storage.trigger_error_log" */
  update_storage_trigger_error_log?: Maybe<Storage_Trigger_Error_Log_Mutation_Response>;
  /** update single row of the table: "storage.trigger_error_log" */
  update_storage_trigger_error_log_by_pk?: Maybe<Storage_Trigger_Error_Log>;
  /** update multiples rows of table: "storage.trigger_error_log" */
  update_storage_trigger_error_log_many?: Maybe<Array<Maybe<Storage_Trigger_Error_Log_Mutation_Response>>>;
  /** update data of the table: "storico_sottoscrizione" */
  update_storico_sottoscrizione?: Maybe<Storico_Sottoscrizione_Mutation_Response>;
  /** update single row of the table: "storico_sottoscrizione" */
  update_storico_sottoscrizione_by_pk?: Maybe<Storico_Sottoscrizione>;
  /** update multiples rows of table: "storico_sottoscrizione" */
  update_storico_sottoscrizione_many?: Maybe<Array<Maybe<Storico_Sottoscrizione_Mutation_Response>>>;
  /** update data of the table: "translate.mapper" */
  update_translate_mapper?: Maybe<Translate_Mapper_Mutation_Response>;
  /** update single row of the table: "translate.mapper" */
  update_translate_mapper_by_pk?: Maybe<Translate_Mapper>;
  /** update multiples rows of table: "translate.mapper" */
  update_translate_mapper_many?: Maybe<Array<Maybe<Translate_Mapper_Mutation_Response>>>;
  /** update data of the table: "unita_amministrativa.citta" */
  update_unita_amministrativa_citta?: Maybe<Unita_Amministrativa_Citta_Mutation_Response>;
  /** update single row of the table: "unita_amministrativa.citta" */
  update_unita_amministrativa_citta_by_pk?: Maybe<Unita_Amministrativa_Citta>;
  /** update multiples rows of table: "unita_amministrativa.citta" */
  update_unita_amministrativa_citta_many?: Maybe<Array<Maybe<Unita_Amministrativa_Citta_Mutation_Response>>>;
  /** update data of the table: "unita_amministrativa.nazione" */
  update_unita_amministrativa_nazione?: Maybe<Unita_Amministrativa_Nazione_Mutation_Response>;
  /** update single row of the table: "unita_amministrativa.nazione" */
  update_unita_amministrativa_nazione_by_pk?: Maybe<Unita_Amministrativa_Nazione>;
  /** update multiples rows of table: "unita_amministrativa.nazione" */
  update_unita_amministrativa_nazione_many?: Maybe<Array<Maybe<Unita_Amministrativa_Nazione_Mutation_Response>>>;
  /** update data of the table: "unita_amministrativa.provincia" */
  update_unita_amministrativa_provincia?: Maybe<Unita_Amministrativa_Provincia_Mutation_Response>;
  /** update single row of the table: "unita_amministrativa.provincia" */
  update_unita_amministrativa_provincia_by_pk?: Maybe<Unita_Amministrativa_Provincia>;
  /** update multiples rows of table: "unita_amministrativa.provincia" */
  update_unita_amministrativa_provincia_many?: Maybe<Array<Maybe<Unita_Amministrativa_Provincia_Mutation_Response>>>;
  /** update data of the table: "unita_amministrativa.regione" */
  update_unita_amministrativa_regione?: Maybe<Unita_Amministrativa_Regione_Mutation_Response>;
  /** update single row of the table: "unita_amministrativa.regione" */
  update_unita_amministrativa_regione_by_pk?: Maybe<Unita_Amministrativa_Regione>;
  /** update multiples rows of table: "unita_amministrativa.regione" */
  update_unita_amministrativa_regione_many?: Maybe<Array<Maybe<Unita_Amministrativa_Regione_Mutation_Response>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>;
  /** update data of the table: "white_label.associazione" */
  update_white_label_associazione?: Maybe<White_Label_Associazione_Mutation_Response>;
  /** update single row of the table: "white_label.associazione" */
  update_white_label_associazione_by_pk?: Maybe<White_Label_Associazione>;
  /** update multiples rows of table: "white_label.associazione" */
  update_white_label_associazione_many?: Maybe<Array<Maybe<White_Label_Associazione_Mutation_Response>>>;
  /** update data of the table: "white_label.configurazione" */
  update_white_label_configurazione?: Maybe<White_Label_Configurazione_Mutation_Response>;
  /** update single row of the table: "white_label.configurazione" */
  update_white_label_configurazione_by_pk?: Maybe<White_Label_Configurazione>;
  /** update multiples rows of table: "white_label.configurazione" */
  update_white_label_configurazione_many?: Maybe<Array<Maybe<White_Label_Configurazione_Mutation_Response>>>;
  /** update data of the table: "white_label.gestore" */
  update_white_label_gestore?: Maybe<White_Label_Gestore_Mutation_Response>;
  /** update single row of the table: "white_label.gestore" */
  update_white_label_gestore_by_pk?: Maybe<White_Label_Gestore>;
  /** update multiples rows of table: "white_label.gestore" */
  update_white_label_gestore_many?: Maybe<Array<Maybe<White_Label_Gestore_Mutation_Response>>>;
  /** update data of the table: "white_label.idp" */
  update_white_label_idp?: Maybe<White_Label_Idp_Mutation_Response>;
  /** update single row of the table: "white_label.idp" */
  update_white_label_idp_by_pk?: Maybe<White_Label_Idp>;
  /** update multiples rows of table: "white_label.idp" */
  update_white_label_idp_many?: Maybe<Array<Maybe<White_Label_Idp_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootAbilita_RichiesteArgs = {
  args: Abilita_Richieste_Args;
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCambia_Stato_CabinaArgs = {
  args: Cambia_Stato_Cabina_Args;
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCambia_Stato_FounderArgs = {
  args: Cambia_Stato_Founder_Args;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCambia_Stato_InstallatoreArgs = {
  args: Cambia_Stato_Installatore_Args;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCambia_Stato_ProsumerArgs = {
  args: Cambia_Stato_Prosumer_Args;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCambia_Stato_TecnicoArgs = {
  args: Cambia_Stato_Tecnico_Args;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCondivisione_AccettaArgs = {
  args: Condivisione_Accetta_Args;
  distinct_on?: InputMaybe<Array<Condivisione_Accetta_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Accetta_Response_Order_By>>;
  where?: InputMaybe<Condivisione_Accetta_Response_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootConfirmoWebhookArgs = {
  input: ConfirmoInput;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete__Destinazione_CompatibileArgs = {
  where: _Destinazione_Compatibile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete__Pod_DuplicatoArgs = {
  where: _Pod_Duplicato_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete__Pod_Duplicato_By_PkArgs = {
  pod: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete__Sottoscrizione_Tipo_RichiestaArgs = {
  where: _Sottoscrizione_Tipo_Richiesta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete__Sottoscrizione_Tipo_Richiesta_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete__Superadmin_Elimina_Sottoscrizione_EsitoArgs = {
  where: _Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete__Superadmin_Elimina_Sottoscrizione_Esito_By_PkArgs = {
  sottoscrizione_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete__Tipo_Dato_ConsumoArgs = {
  where: _Tipo_Dato_Consumo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete__Tipo_Dato_Consumo_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete__Tipologia_ProfiloArgs = {
  where: _Tipologia_Profilo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete__Tipologia_Profilo_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin__Stato_Richiesta_PubblicazioneArgs = {
  where: Admin__Stato_Richiesta_Pubblicazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin__Stato_Richiesta_Pubblicazione_By_PkArgs = {
  stato: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin__Type_ReferralArgs = {
  where: Admin__Type_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin__Type_Referral_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_Consenso_PrivacyArgs = {
  where: Admin_Consenso_Privacy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Consenso_Privacy_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_Parametri_Algoritmo_IncentiviArgs = {
  where: Admin_Parametri_Algoritmo_Incentivi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Parametri_Algoritmo_Incentivi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_ReferralArgs = {
  where: Admin_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_Richiesta_PubblicazioneArgs = {
  where: Admin_Richiesta_Pubblicazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Richiesta_Pubblicazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_Utilizzo_ReferralArgs = {
  where: Admin_Utilizzo_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Utilizzo_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Codice_AtecoArgs = {
  where: Anagrafica_Codice_Ateco_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Codice_Ateco_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Forma_GiuridicaArgs = {
  where: Anagrafica_Forma_Giuridica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Forma_Giuridica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Forma_Giuridica_CerArgs = {
  where: Anagrafica_Forma_Giuridica_Cer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Forma_Giuridica_Cer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Tipo_ContattoArgs = {
  where: Anagrafica_Tipo_Contatto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Tipo_Contatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Tipo_PromotoreArgs = {
  where: Anagrafica_Tipo_Promotore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Tipo_Promotore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Tipologia_RappresentanteArgs = {
  where: Anagrafica_Tipologia_Rappresentante_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anagrafica_Tipologia_Rappresentante_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AssetArgs = {
  where: Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_CaratteristicaArgs = {
  where: Asset_Caratteristica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Caratteristica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_ConsumoArgs = {
  where: Asset_Consumo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Consumo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Dato_ConsumoArgs = {
  where: Asset_Dato_Consumo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Dato_Consumo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_EnergiaArgs = {
  where: Asset_Energia_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Energia_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_FounderArgs = {
  where: Asset_Founder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Founder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_GestoreArgs = {
  where: Asset_Gestore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_ProduzioneArgs = {
  where: Asset_Produzione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_UnitaArgs = {
  where: Asset_Produzione_Unita_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_Unita_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_Unita_SezioneArgs = {
  where: Asset_Produzione_Unita_Sezione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_Unita_Sezione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_Unita_Sezione_IncentiviArgs = {
  where: Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_Unita_Sezione_Incentivi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_Unita_Sezione_Titolo_AutorizzativoArgs = {
  where: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_SpazioArgs = {
  where: Asset_Spazio_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Spazio_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Event_EntityArgs = {
  where: Auth_Event_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Event_Entity_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Federated_IdentityArgs = {
  where: Auth_Federated_Identity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Federated_Identity_By_PkArgs = {
  identity_provider: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Role_AttributeArgs = {
  where: Auth_Role_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Role_Attribute_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_User_AttributeArgs = {
  where: Auth_User_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_User_Attribute_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_User_EntityArgs = {
  where: Auth_User_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_User_Entity_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CerArgs = {
  where: Cer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_CabinaArgs = {
  where: Cer_Cabina_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Cabina_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_Cabina_SnapshotArgs = {
  where: Cer_Cabina_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Cabina_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_Categoria_AdesioneArgs = {
  where: Cer_Categoria_Adesione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Categoria_Adesione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_Configurazione_Destinazione_ContributoArgs = {
  where: Cer_Configurazione_Destinazione_Contributo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Configurazione_Destinazione_Contributo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_ContattiArgs = {
  where: Cer_Contatti_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Contatti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_Destinazione_ContributoArgs = {
  where: Cer_Destinazione_Contributo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Destinazione_Contributo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_GeomArgs = {
  where: Cer_Geom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Geom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_GestoreArgs = {
  where: Cer_Gestore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_Search_IndexArgs = {
  where: Cer_Search_Index_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Search_Index_By_PkArgs = {
  cer_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cer_TecnicoArgs = {
  where: Cer_Tecnico_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cer_Tecnico_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Codice_OperatoreArgs = {
  where: Codice_Operatore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Codice_Operatore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Comunicazioni_EmailArgs = {
  where: Comunicazioni_Email_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comunicazioni_Email_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Comunicazioni_Email_TemplateArgs = {
  where: Comunicazioni_Email_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comunicazioni_Email_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Comunicazioni_SmsArgs = {
  where: Comunicazioni_Sms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comunicazioni_Sms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Condivisione__Stato_CondivisioneArgs = {
  where: Condivisione__Stato_Condivisione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Condivisione__Stato_Condivisione_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Condivisione_Accetta_ResponseArgs = {
  where: Condivisione_Accetta_Response_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Condivisione_CondivisioneArgs = {
  where: Condivisione_Condivisione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Condivisione_Condivisione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Condivisione_Log_CondivisioneArgs = {
  where: Condivisione_Log_Condivisione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Condivisione_Log_Condivisione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ContattoArgs = {
  where: Contatto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Crm_Audit_EventArgs = {
  where: Crm_Audit_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crm_Audit_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Debug_Sottoscrizione_After_LogArgs = {
  where: Debug_Sottoscrizione_After_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Debug_Sottoscrizione_After_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Device_DeviceArgs = {
  where: Device_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Device_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Azioni_Founder_SottoscrizioneArgs = {
  where: Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Azioni_Founder_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Azioni_Prosumer_SottoscrizioneArgs = {
  where: Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Azioni_Prosumer_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Azioni_Tecnico_SottoscrizioneArgs = {
  where: Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Azioni_Tecnico_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Cer_Filter_OptionsArgs = {
  where: Energy_Village__Cer_Filter_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Cer_Filter_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Stato_CerArgs = {
  where: Energy_Village__Stato_Cer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Stato_Cer_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Stato_SottoscrizioneArgs = {
  where: Energy_Village__Stato_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Stato_Sottoscrizione_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Tipo_DomandaArgs = {
  where: Energy_Village__Tipo_Domanda_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Tipo_Domanda_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Tipo_FeedbackArgs = {
  where: Energy_Village__Tipo_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village__Tipo_Feedback_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_AreaArgs = {
  where: Energy_Village_Area_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Area_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Area_CittaArgs = {
  where: Energy_Village_Area_Citta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Area_Citta_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Area_ProvinciaArgs = {
  where: Energy_Village_Area_Provincia_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Area_Provincia_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Area_RegioneArgs = {
  where: Energy_Village_Area_Regione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Area_Regione_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_AzioniArgs = {
  where: Energy_Village_Azioni_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Azioni_By_PkArgs = {
  founder: Energy_Village__Azioni_Founder_Sottoscrizione_Enum;
  prosumer: Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum;
  tecnico: Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_CabinaArgs = {
  where: Energy_Village_Cabina_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Cabina_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Cabina_CittaArgs = {
  where: Energy_Village_Cabina_Citta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Cabina_Citta_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_CaratteristicaArgs = {
  where: Energy_Village_Caratteristica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Caratteristica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Cer_Filter_OptionsArgs = {
  where: Energy_Village_Cer_Filter_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Cer_Filter_Options_By_PkArgs = {
  filter: Energy_Village__Cer_Filter_Options_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_DimensioneArgs = {
  where: Energy_Village_Dimensione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Dimensione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_FeedbackArgs = {
  where: Energy_Village_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Feedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Incentivo_ImpiantoArgs = {
  where: Energy_Village_Incentivo_Impianto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Incentivo_Impianto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_OrarioArgs = {
  where: Energy_Village_Orario_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Orario_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Potenza_ImpiantoArgs = {
  where: Energy_Village_Potenza_Impianto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Potenza_Impianto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Potenzialita_CabinaArgs = {
  where: Energy_Village_Potenzialita_Cabina_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Potenzialita_Cabina_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Tipo_Spazio_DisponibileArgs = {
  where: Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Tipo_Spazio_Disponibile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Tipologia_AbitativaArgs = {
  where: Energy_Village_Tipologia_Abitativa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Tipologia_Abitativa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Tipologia_AssetArgs = {
  where: Energy_Village_Tipologia_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Tipologia_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Titolo_AutorizzativoArgs = {
  where: Energy_Village_Titolo_Autorizzativo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Village_Titolo_Autorizzativo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Flussi_Gse_FlussoArgs = {
  where: Flussi_Gse_Flusso_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flussi_Gse_Flusso_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Funzione_LogArgs = {
  where: Funzione_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funzione_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incentivi__Stato_CalcoloArgs = {
  where: Incentivi__Stato_Calcolo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incentivi__Stato_Calcolo_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incentivi_CalcolatiArgs = {
  where: Incentivi_Calcolati_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incentivi_Calcolati_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incentivi_Log_RipartizioneArgs = {
  where: Incentivi_Log_Ripartizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incentivi_Log_Ripartizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incentivi_RipartizioneArgs = {
  where: Incentivi_Ripartizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incentivi_Ripartizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndirizzoArgs = {
  where: Indirizzo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Indirizzo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InseritoreArgs = {
  where: Inseritore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Inseritore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InstallatoreArgs = {
  where: Installatore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Installatore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Log_Errori_FunzioniArgs = {
  where: Log_Errori_Funzioni_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Log_Errori_Funzioni_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PersonaArgs = {
  where: Persona_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Persona_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Persona_ContattoArgs = {
  where: Persona_Contatto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Persona_Contatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Pnrr_DocumentiArgs = {
  where: Pnrr_Documenti_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pnrr_Documenti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PresetArgs = {
  where: Preset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Preset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProfiloArgs = {
  where: Profilo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profilo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SottoscrizioneArgs = {
  where: Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_DocumentiArgs = {
  where: Sottoscrizione_Documenti_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_Documenti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_DomandeArgs = {
  where: Sottoscrizione_Domande_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_Domande_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_IniziativaArgs = {
  where: Sottoscrizione_Iniziativa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_Iniziativa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_ZipArgs = {
  where: Sottoscrizione_Zip_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sottoscrizione_Zip_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging__Stato_SottoscrizioneArgs = {
  where: Staging__Stato_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging__Stato_Sottoscrizione_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging_Azione_SottoscrizioneArgs = {
  where: Staging_Azione_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging_Azione_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging_Gestore_LottoArgs = {
  where: Staging_Gestore_Lotto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging_Gestore_Lotto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging_Gestore_SottoscrizioneArgs = {
  where: Staging_Gestore_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging_Gestore_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging_LogArgs = {
  where: Staging_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging_LottoArgs = {
  where: Staging_Lotto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging_Lotto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging_Mv_Refresh_StateArgs = {
  where: Staging_Mv_Refresh_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging_Mv_Refresh_State_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Staging_SottoscrizioneArgs = {
  where: Staging_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Staging_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Storage_Trigger_Debug_LogArgs = {
  where: Storage_Trigger_Debug_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Storage_Trigger_Debug_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Storage_Trigger_Error_LogArgs = {
  where: Storage_Trigger_Error_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Storage_Trigger_Error_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Storico_SottoscrizioneArgs = {
  where: Storico_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Storico_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Translate_MapperArgs = {
  where: Translate_Mapper_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Translate_Mapper_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_CittaArgs = {
  where: Unita_Amministrativa_Citta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_Citta_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_NazioneArgs = {
  where: Unita_Amministrativa_Nazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_Nazione_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_ProvinciaArgs = {
  where: Unita_Amministrativa_Provincia_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_Provincia_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_RegioneArgs = {
  where: Unita_Amministrativa_Regione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unita_Amministrativa_Regione_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_White_Label_AssociazioneArgs = {
  where: White_Label_Associazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_White_Label_Associazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_White_Label_ConfigurazioneArgs = {
  where: White_Label_Configurazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_White_Label_Configurazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_White_Label_GestoreArgs = {
  where: White_Label_Gestore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_White_Label_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_White_Label_IdpArgs = {
  where: White_Label_Idp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_White_Label_Idp_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: InputMaybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>;
  on_conflict?: InputMaybe<Virus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Destinazione_CompatibileArgs = {
  objects: Array<_Destinazione_Compatibile_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert__Destinazione_Compatibile_OneArgs = {
  object: _Destinazione_Compatibile_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert__Pod_DuplicatoArgs = {
  objects: Array<_Pod_Duplicato_Insert_Input>;
  on_conflict?: InputMaybe<_Pod_Duplicato_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Pod_Duplicato_OneArgs = {
  object: _Pod_Duplicato_Insert_Input;
  on_conflict?: InputMaybe<_Pod_Duplicato_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Sottoscrizione_Tipo_RichiestaArgs = {
  objects: Array<_Sottoscrizione_Tipo_Richiesta_Insert_Input>;
  on_conflict?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Sottoscrizione_Tipo_Richiesta_OneArgs = {
  object: _Sottoscrizione_Tipo_Richiesta_Insert_Input;
  on_conflict?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Superadmin_Elimina_Sottoscrizione_EsitoArgs = {
  objects: Array<_Superadmin_Elimina_Sottoscrizione_Esito_Insert_Input>;
  on_conflict?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Superadmin_Elimina_Sottoscrizione_Esito_OneArgs = {
  object: _Superadmin_Elimina_Sottoscrizione_Esito_Insert_Input;
  on_conflict?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Tipo_Dato_ConsumoArgs = {
  objects: Array<_Tipo_Dato_Consumo_Insert_Input>;
  on_conflict?: InputMaybe<_Tipo_Dato_Consumo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Tipo_Dato_Consumo_OneArgs = {
  object: _Tipo_Dato_Consumo_Insert_Input;
  on_conflict?: InputMaybe<_Tipo_Dato_Consumo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Tipologia_ProfiloArgs = {
  objects: Array<_Tipologia_Profilo_Insert_Input>;
  on_conflict?: InputMaybe<_Tipologia_Profilo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert__Tipologia_Profilo_OneArgs = {
  object: _Tipologia_Profilo_Insert_Input;
  on_conflict?: InputMaybe<_Tipologia_Profilo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin__Stato_Richiesta_PubblicazioneArgs = {
  objects: Array<Admin__Stato_Richiesta_Pubblicazione_Insert_Input>;
  on_conflict?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin__Stato_Richiesta_Pubblicazione_OneArgs = {
  object: Admin__Stato_Richiesta_Pubblicazione_Insert_Input;
  on_conflict?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin__Type_ReferralArgs = {
  objects: Array<Admin__Type_Referral_Insert_Input>;
  on_conflict?: InputMaybe<Admin__Type_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin__Type_Referral_OneArgs = {
  object: Admin__Type_Referral_Insert_Input;
  on_conflict?: InputMaybe<Admin__Type_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Consenso_PrivacyArgs = {
  objects: Array<Admin_Consenso_Privacy_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Consenso_Privacy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Consenso_Privacy_OneArgs = {
  object: Admin_Consenso_Privacy_Insert_Input;
  on_conflict?: InputMaybe<Admin_Consenso_Privacy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Parametri_Algoritmo_IncentiviArgs = {
  objects: Array<Admin_Parametri_Algoritmo_Incentivi_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Parametri_Algoritmo_Incentivi_OneArgs = {
  object: Admin_Parametri_Algoritmo_Incentivi_Insert_Input;
  on_conflict?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_ReferralArgs = {
  objects: Array<Admin_Referral_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Referral_OneArgs = {
  object: Admin_Referral_Insert_Input;
  on_conflict?: InputMaybe<Admin_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Richiesta_PubblicazioneArgs = {
  objects: Array<Admin_Richiesta_Pubblicazione_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Richiesta_Pubblicazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Richiesta_Pubblicazione_OneArgs = {
  object: Admin_Richiesta_Pubblicazione_Insert_Input;
  on_conflict?: InputMaybe<Admin_Richiesta_Pubblicazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Utilizzo_ReferralArgs = {
  objects: Array<Admin_Utilizzo_Referral_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Utilizzo_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Utilizzo_Referral_OneArgs = {
  object: Admin_Utilizzo_Referral_Insert_Input;
  on_conflict?: InputMaybe<Admin_Utilizzo_Referral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Codice_AtecoArgs = {
  objects: Array<Anagrafica_Codice_Ateco_Insert_Input>;
  on_conflict?: InputMaybe<Anagrafica_Codice_Ateco_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Codice_Ateco_OneArgs = {
  object: Anagrafica_Codice_Ateco_Insert_Input;
  on_conflict?: InputMaybe<Anagrafica_Codice_Ateco_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Forma_GiuridicaArgs = {
  objects: Array<Anagrafica_Forma_Giuridica_Insert_Input>;
  on_conflict?: InputMaybe<Anagrafica_Forma_Giuridica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Forma_Giuridica_CerArgs = {
  objects: Array<Anagrafica_Forma_Giuridica_Cer_Insert_Input>;
  on_conflict?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Forma_Giuridica_Cer_OneArgs = {
  object: Anagrafica_Forma_Giuridica_Cer_Insert_Input;
  on_conflict?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Forma_Giuridica_OneArgs = {
  object: Anagrafica_Forma_Giuridica_Insert_Input;
  on_conflict?: InputMaybe<Anagrafica_Forma_Giuridica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Tipo_ContattoArgs = {
  objects: Array<Anagrafica_Tipo_Contatto_Insert_Input>;
  on_conflict?: InputMaybe<Anagrafica_Tipo_Contatto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Tipo_Contatto_OneArgs = {
  object: Anagrafica_Tipo_Contatto_Insert_Input;
  on_conflict?: InputMaybe<Anagrafica_Tipo_Contatto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Tipo_PromotoreArgs = {
  objects: Array<Anagrafica_Tipo_Promotore_Insert_Input>;
  on_conflict?: InputMaybe<Anagrafica_Tipo_Promotore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Tipo_Promotore_OneArgs = {
  object: Anagrafica_Tipo_Promotore_Insert_Input;
  on_conflict?: InputMaybe<Anagrafica_Tipo_Promotore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Tipologia_RappresentanteArgs = {
  objects: Array<Anagrafica_Tipologia_Rappresentante_Insert_Input>;
  on_conflict?: InputMaybe<Anagrafica_Tipologia_Rappresentante_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anagrafica_Tipologia_Rappresentante_OneArgs = {
  object: Anagrafica_Tipologia_Rappresentante_Insert_Input;
  on_conflict?: InputMaybe<Anagrafica_Tipologia_Rappresentante_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AssetArgs = {
  objects: Array<Asset_Insert_Input>;
  on_conflict?: InputMaybe<Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_CaratteristicaArgs = {
  objects: Array<Asset_Caratteristica_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Caratteristica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Caratteristica_OneArgs = {
  object: Asset_Caratteristica_Insert_Input;
  on_conflict?: InputMaybe<Asset_Caratteristica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_ConsumoArgs = {
  objects: Array<Asset_Consumo_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Consumo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Consumo_OneArgs = {
  object: Asset_Consumo_Insert_Input;
  on_conflict?: InputMaybe<Asset_Consumo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Dato_ConsumoArgs = {
  objects: Array<Asset_Dato_Consumo_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Dato_Consumo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Dato_Consumo_OneArgs = {
  object: Asset_Dato_Consumo_Insert_Input;
  on_conflict?: InputMaybe<Asset_Dato_Consumo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_EnergiaArgs = {
  objects: Array<Asset_Energia_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Energia_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Energia_OneArgs = {
  object: Asset_Energia_Insert_Input;
  on_conflict?: InputMaybe<Asset_Energia_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_FounderArgs = {
  objects: Array<Asset_Founder_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Founder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Founder_OneArgs = {
  object: Asset_Founder_Insert_Input;
  on_conflict?: InputMaybe<Asset_Founder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_GestoreArgs = {
  objects: Array<Asset_Gestore_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Gestore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Gestore_OneArgs = {
  object: Asset_Gestore_Insert_Input;
  on_conflict?: InputMaybe<Asset_Gestore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_OneArgs = {
  object: Asset_Insert_Input;
  on_conflict?: InputMaybe<Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_ProduzioneArgs = {
  objects: Array<Asset_Produzione_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Produzione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_OneArgs = {
  object: Asset_Produzione_Insert_Input;
  on_conflict?: InputMaybe<Asset_Produzione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_UnitaArgs = {
  objects: Array<Asset_Produzione_Unita_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_Unita_OneArgs = {
  object: Asset_Produzione_Unita_Insert_Input;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_Unita_SezioneArgs = {
  objects: Array<Asset_Produzione_Unita_Sezione_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_Unita_Sezione_IncentiviArgs = {
  objects: Array<Asset_Produzione_Unita_Sezione_Incentivi_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_Unita_Sezione_Incentivi_OneArgs = {
  object: Asset_Produzione_Unita_Sezione_Incentivi_Insert_Input;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_Unita_Sezione_OneArgs = {
  object: Asset_Produzione_Unita_Sezione_Insert_Input;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_Unita_Sezione_Titolo_AutorizzativoArgs = {
  objects: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_OneArgs = {
  object: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Insert_Input;
  on_conflict?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_SpazioArgs = {
  objects: Array<Asset_Spazio_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Spazio_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Spazio_OneArgs = {
  object: Asset_Spazio_Insert_Input;
  on_conflict?: InputMaybe<Asset_Spazio_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Event_EntityArgs = {
  objects: Array<Auth_Event_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Event_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Event_Entity_OneArgs = {
  object: Auth_Event_Entity_Insert_Input;
  on_conflict?: InputMaybe<Auth_Event_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Federated_IdentityArgs = {
  objects: Array<Auth_Federated_Identity_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Federated_Identity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Federated_Identity_OneArgs = {
  object: Auth_Federated_Identity_Insert_Input;
  on_conflict?: InputMaybe<Auth_Federated_Identity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Role_AttributeArgs = {
  objects: Array<Auth_Role_Attribute_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Role_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Role_Attribute_OneArgs = {
  object: Auth_Role_Attribute_Insert_Input;
  on_conflict?: InputMaybe<Auth_Role_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_User_AttributeArgs = {
  objects: Array<Auth_User_Attribute_Insert_Input>;
  on_conflict?: InputMaybe<Auth_User_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_User_Attribute_OneArgs = {
  object: Auth_User_Attribute_Insert_Input;
  on_conflict?: InputMaybe<Auth_User_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_User_EntityArgs = {
  objects: Array<Auth_User_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Auth_User_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_User_Entity_OneArgs = {
  object: Auth_User_Entity_Insert_Input;
  on_conflict?: InputMaybe<Auth_User_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CerArgs = {
  objects: Array<Cer_Insert_Input>;
  on_conflict?: InputMaybe<Cer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_CabinaArgs = {
  objects: Array<Cer_Cabina_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Cabina_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Cabina_OneArgs = {
  object: Cer_Cabina_Insert_Input;
  on_conflict?: InputMaybe<Cer_Cabina_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Cabina_SnapshotArgs = {
  objects: Array<Cer_Cabina_Snapshot_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Cabina_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Cabina_Snapshot_OneArgs = {
  object: Cer_Cabina_Snapshot_Insert_Input;
  on_conflict?: InputMaybe<Cer_Cabina_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Categoria_AdesioneArgs = {
  objects: Array<Cer_Categoria_Adesione_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Categoria_Adesione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Categoria_Adesione_OneArgs = {
  object: Cer_Categoria_Adesione_Insert_Input;
  on_conflict?: InputMaybe<Cer_Categoria_Adesione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Configurazione_Destinazione_ContributoArgs = {
  objects: Array<Cer_Configurazione_Destinazione_Contributo_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Configurazione_Destinazione_Contributo_OneArgs = {
  object: Cer_Configurazione_Destinazione_Contributo_Insert_Input;
  on_conflict?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_ContattiArgs = {
  objects: Array<Cer_Contatti_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Contatti_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Contatti_OneArgs = {
  object: Cer_Contatti_Insert_Input;
  on_conflict?: InputMaybe<Cer_Contatti_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Destinazione_ContributoArgs = {
  objects: Array<Cer_Destinazione_Contributo_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Destinazione_Contributo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Destinazione_Contributo_OneArgs = {
  object: Cer_Destinazione_Contributo_Insert_Input;
  on_conflict?: InputMaybe<Cer_Destinazione_Contributo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_GeomArgs = {
  objects: Array<Cer_Geom_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Geom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Geom_OneArgs = {
  object: Cer_Geom_Insert_Input;
  on_conflict?: InputMaybe<Cer_Geom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_GestoreArgs = {
  objects: Array<Cer_Gestore_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Gestore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Gestore_OneArgs = {
  object: Cer_Gestore_Insert_Input;
  on_conflict?: InputMaybe<Cer_Gestore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_OneArgs = {
  object: Cer_Insert_Input;
  on_conflict?: InputMaybe<Cer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Search_IndexArgs = {
  objects: Array<Cer_Search_Index_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Search_Index_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Search_Index_OneArgs = {
  object: Cer_Search_Index_Insert_Input;
  on_conflict?: InputMaybe<Cer_Search_Index_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_TecnicoArgs = {
  objects: Array<Cer_Tecnico_Insert_Input>;
  on_conflict?: InputMaybe<Cer_Tecnico_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cer_Tecnico_OneArgs = {
  object: Cer_Tecnico_Insert_Input;
  on_conflict?: InputMaybe<Cer_Tecnico_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Codice_OperatoreArgs = {
  objects: Array<Codice_Operatore_Insert_Input>;
  on_conflict?: InputMaybe<Codice_Operatore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Codice_Operatore_OneArgs = {
  object: Codice_Operatore_Insert_Input;
  on_conflict?: InputMaybe<Codice_Operatore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comunicazioni_EmailArgs = {
  objects: Array<Comunicazioni_Email_Insert_Input>;
  on_conflict?: InputMaybe<Comunicazioni_Email_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comunicazioni_Email_OneArgs = {
  object: Comunicazioni_Email_Insert_Input;
  on_conflict?: InputMaybe<Comunicazioni_Email_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comunicazioni_Email_TemplateArgs = {
  objects: Array<Comunicazioni_Email_Template_Insert_Input>;
  on_conflict?: InputMaybe<Comunicazioni_Email_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comunicazioni_Email_Template_OneArgs = {
  object: Comunicazioni_Email_Template_Insert_Input;
  on_conflict?: InputMaybe<Comunicazioni_Email_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comunicazioni_SmsArgs = {
  objects: Array<Comunicazioni_Sms_Insert_Input>;
  on_conflict?: InputMaybe<Comunicazioni_Sms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comunicazioni_Sms_OneArgs = {
  object: Comunicazioni_Sms_Insert_Input;
  on_conflict?: InputMaybe<Comunicazioni_Sms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione__Stato_CondivisioneArgs = {
  objects: Array<Condivisione__Stato_Condivisione_Insert_Input>;
  on_conflict?: InputMaybe<Condivisione__Stato_Condivisione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione__Stato_Condivisione_OneArgs = {
  object: Condivisione__Stato_Condivisione_Insert_Input;
  on_conflict?: InputMaybe<Condivisione__Stato_Condivisione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione_Accetta_ResponseArgs = {
  objects: Array<Condivisione_Accetta_Response_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione_Accetta_Response_OneArgs = {
  object: Condivisione_Accetta_Response_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione_CondivisioneArgs = {
  objects: Array<Condivisione_Condivisione_Insert_Input>;
  on_conflict?: InputMaybe<Condivisione_Condivisione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione_Condivisione_OneArgs = {
  object: Condivisione_Condivisione_Insert_Input;
  on_conflict?: InputMaybe<Condivisione_Condivisione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione_Log_CondivisioneArgs = {
  objects: Array<Condivisione_Log_Condivisione_Insert_Input>;
  on_conflict?: InputMaybe<Condivisione_Log_Condivisione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Condivisione_Log_Condivisione_OneArgs = {
  object: Condivisione_Log_Condivisione_Insert_Input;
  on_conflict?: InputMaybe<Condivisione_Log_Condivisione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContattoArgs = {
  objects: Array<Contatto_Insert_Input>;
  on_conflict?: InputMaybe<Contatto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contatto_OneArgs = {
  object: Contatto_Insert_Input;
  on_conflict?: InputMaybe<Contatto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crm_Audit_EventArgs = {
  objects: Array<Crm_Audit_Event_Insert_Input>;
  on_conflict?: InputMaybe<Crm_Audit_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crm_Audit_Event_OneArgs = {
  object: Crm_Audit_Event_Insert_Input;
  on_conflict?: InputMaybe<Crm_Audit_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Debug_Sottoscrizione_After_LogArgs = {
  objects: Array<Debug_Sottoscrizione_After_Log_Insert_Input>;
  on_conflict?: InputMaybe<Debug_Sottoscrizione_After_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Debug_Sottoscrizione_After_Log_OneArgs = {
  object: Debug_Sottoscrizione_After_Log_Insert_Input;
  on_conflict?: InputMaybe<Debug_Sottoscrizione_After_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_DeviceArgs = {
  objects: Array<Device_Device_Insert_Input>;
  on_conflict?: InputMaybe<Device_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_Device_OneArgs = {
  object: Device_Device_Insert_Input;
  on_conflict?: InputMaybe<Device_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Azioni_Founder_SottoscrizioneArgs = {
  objects: Array<Energy_Village__Azioni_Founder_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Azioni_Founder_Sottoscrizione_OneArgs = {
  object: Energy_Village__Azioni_Founder_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Azioni_Prosumer_SottoscrizioneArgs = {
  objects: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Azioni_Prosumer_Sottoscrizione_OneArgs = {
  object: Energy_Village__Azioni_Prosumer_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Azioni_Tecnico_SottoscrizioneArgs = {
  objects: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Azioni_Tecnico_Sottoscrizione_OneArgs = {
  object: Energy_Village__Azioni_Tecnico_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Cer_Filter_OptionsArgs = {
  objects: Array<Energy_Village__Cer_Filter_Options_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Cer_Filter_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Cer_Filter_Options_OneArgs = {
  object: Energy_Village__Cer_Filter_Options_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Cer_Filter_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Stato_CerArgs = {
  objects: Array<Energy_Village__Stato_Cer_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Stato_Cer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Stato_Cer_OneArgs = {
  object: Energy_Village__Stato_Cer_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Stato_Cer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Stato_SottoscrizioneArgs = {
  objects: Array<Energy_Village__Stato_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Stato_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Stato_Sottoscrizione_OneArgs = {
  object: Energy_Village__Stato_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Stato_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Tipo_DomandaArgs = {
  objects: Array<Energy_Village__Tipo_Domanda_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Tipo_Domanda_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Tipo_Domanda_OneArgs = {
  object: Energy_Village__Tipo_Domanda_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Tipo_Domanda_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Tipo_FeedbackArgs = {
  objects: Array<Energy_Village__Tipo_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village__Tipo_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village__Tipo_Feedback_OneArgs = {
  object: Energy_Village__Tipo_Feedback_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village__Tipo_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_AreaArgs = {
  objects: Array<Energy_Village_Area_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Area_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Area_CittaArgs = {
  objects: Array<Energy_Village_Area_Citta_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Area_Citta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Area_Citta_OneArgs = {
  object: Energy_Village_Area_Citta_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Area_Citta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Area_OneArgs = {
  object: Energy_Village_Area_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Area_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Area_ProvinciaArgs = {
  objects: Array<Energy_Village_Area_Provincia_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Area_Provincia_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Area_Provincia_OneArgs = {
  object: Energy_Village_Area_Provincia_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Area_Provincia_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Area_RegioneArgs = {
  objects: Array<Energy_Village_Area_Regione_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Area_Regione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Area_Regione_OneArgs = {
  object: Energy_Village_Area_Regione_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Area_Regione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_AzioniArgs = {
  objects: Array<Energy_Village_Azioni_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Azioni_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Azioni_OneArgs = {
  object: Energy_Village_Azioni_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Azioni_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_CabinaArgs = {
  objects: Array<Energy_Village_Cabina_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Cabina_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Cabina_CittaArgs = {
  objects: Array<Energy_Village_Cabina_Citta_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Cabina_Citta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Cabina_Citta_OneArgs = {
  object: Energy_Village_Cabina_Citta_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Cabina_Citta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Cabina_OneArgs = {
  object: Energy_Village_Cabina_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Cabina_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_CaratteristicaArgs = {
  objects: Array<Energy_Village_Caratteristica_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Caratteristica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Caratteristica_OneArgs = {
  object: Energy_Village_Caratteristica_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Caratteristica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Cer_Filter_OptionsArgs = {
  objects: Array<Energy_Village_Cer_Filter_Options_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Cer_Filter_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Cer_Filter_Options_OneArgs = {
  object: Energy_Village_Cer_Filter_Options_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Cer_Filter_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_DimensioneArgs = {
  objects: Array<Energy_Village_Dimensione_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Dimensione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Dimensione_OneArgs = {
  object: Energy_Village_Dimensione_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Dimensione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_FeedbackArgs = {
  objects: Array<Energy_Village_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Feedback_OneArgs = {
  object: Energy_Village_Feedback_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Incentivo_ImpiantoArgs = {
  objects: Array<Energy_Village_Incentivo_Impianto_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Incentivo_Impianto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Incentivo_Impianto_OneArgs = {
  object: Energy_Village_Incentivo_Impianto_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Incentivo_Impianto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_OrarioArgs = {
  objects: Array<Energy_Village_Orario_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Orario_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Orario_OneArgs = {
  object: Energy_Village_Orario_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Orario_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Potenza_ImpiantoArgs = {
  objects: Array<Energy_Village_Potenza_Impianto_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Potenza_Impianto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Potenza_Impianto_OneArgs = {
  object: Energy_Village_Potenza_Impianto_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Potenza_Impianto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Potenzialita_CabinaArgs = {
  objects: Array<Energy_Village_Potenzialita_Cabina_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Potenzialita_Cabina_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Potenzialita_Cabina_OneArgs = {
  object: Energy_Village_Potenzialita_Cabina_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Potenzialita_Cabina_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Tipo_Spazio_DisponibileArgs = {
  objects: Array<Energy_Village_Tipo_Spazio_Disponibile_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Tipo_Spazio_Disponibile_OneArgs = {
  object: Energy_Village_Tipo_Spazio_Disponibile_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Tipologia_AbitativaArgs = {
  objects: Array<Energy_Village_Tipologia_Abitativa_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Abitativa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Tipologia_Abitativa_OneArgs = {
  object: Energy_Village_Tipologia_Abitativa_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Abitativa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Tipologia_AssetArgs = {
  objects: Array<Energy_Village_Tipologia_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Tipologia_Asset_OneArgs = {
  object: Energy_Village_Tipologia_Asset_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Tipologia_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Titolo_AutorizzativoArgs = {
  objects: Array<Energy_Village_Titolo_Autorizzativo_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Village_Titolo_Autorizzativo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Village_Titolo_Autorizzativo_OneArgs = {
  object: Energy_Village_Titolo_Autorizzativo_Insert_Input;
  on_conflict?: InputMaybe<Energy_Village_Titolo_Autorizzativo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flussi_Gse_FlussoArgs = {
  objects: Array<Flussi_Gse_Flusso_Insert_Input>;
  on_conflict?: InputMaybe<Flussi_Gse_Flusso_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flussi_Gse_Flusso_OneArgs = {
  object: Flussi_Gse_Flusso_Insert_Input;
  on_conflict?: InputMaybe<Flussi_Gse_Flusso_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funzione_LogArgs = {
  objects: Array<Funzione_Log_Insert_Input>;
  on_conflict?: InputMaybe<Funzione_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Funzione_Log_OneArgs = {
  object: Funzione_Log_Insert_Input;
  on_conflict?: InputMaybe<Funzione_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi__Stato_CalcoloArgs = {
  objects: Array<Incentivi__Stato_Calcolo_Insert_Input>;
  on_conflict?: InputMaybe<Incentivi__Stato_Calcolo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi__Stato_Calcolo_OneArgs = {
  object: Incentivi__Stato_Calcolo_Insert_Input;
  on_conflict?: InputMaybe<Incentivi__Stato_Calcolo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi_CalcolatiArgs = {
  objects: Array<Incentivi_Calcolati_Insert_Input>;
  on_conflict?: InputMaybe<Incentivi_Calcolati_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi_Calcolati_OneArgs = {
  object: Incentivi_Calcolati_Insert_Input;
  on_conflict?: InputMaybe<Incentivi_Calcolati_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi_Log_RipartizioneArgs = {
  objects: Array<Incentivi_Log_Ripartizione_Insert_Input>;
  on_conflict?: InputMaybe<Incentivi_Log_Ripartizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi_Log_Ripartizione_OneArgs = {
  object: Incentivi_Log_Ripartizione_Insert_Input;
  on_conflict?: InputMaybe<Incentivi_Log_Ripartizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi_RipartizioneArgs = {
  objects: Array<Incentivi_Ripartizione_Insert_Input>;
  on_conflict?: InputMaybe<Incentivi_Ripartizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incentivi_Ripartizione_OneArgs = {
  object: Incentivi_Ripartizione_Insert_Input;
  on_conflict?: InputMaybe<Incentivi_Ripartizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndirizzoArgs = {
  objects: Array<Indirizzo_Insert_Input>;
  on_conflict?: InputMaybe<Indirizzo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Indirizzo_OneArgs = {
  object: Indirizzo_Insert_Input;
  on_conflict?: InputMaybe<Indirizzo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InseritoreArgs = {
  objects: Array<Inseritore_Insert_Input>;
  on_conflict?: InputMaybe<Inseritore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Inseritore_OneArgs = {
  object: Inseritore_Insert_Input;
  on_conflict?: InputMaybe<Inseritore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InstallatoreArgs = {
  objects: Array<Installatore_Insert_Input>;
  on_conflict?: InputMaybe<Installatore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Installatore_OneArgs = {
  object: Installatore_Insert_Input;
  on_conflict?: InputMaybe<Installatore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Log_Errori_FunzioniArgs = {
  objects: Array<Log_Errori_Funzioni_Insert_Input>;
  on_conflict?: InputMaybe<Log_Errori_Funzioni_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Log_Errori_Funzioni_OneArgs = {
  object: Log_Errori_Funzioni_Insert_Input;
  on_conflict?: InputMaybe<Log_Errori_Funzioni_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PersonaArgs = {
  objects: Array<Persona_Insert_Input>;
  on_conflict?: InputMaybe<Persona_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Persona_ContattoArgs = {
  objects: Array<Persona_Contatto_Insert_Input>;
  on_conflict?: InputMaybe<Persona_Contatto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Persona_Contatto_OneArgs = {
  object: Persona_Contatto_Insert_Input;
  on_conflict?: InputMaybe<Persona_Contatto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Persona_OneArgs = {
  object: Persona_Insert_Input;
  on_conflict?: InputMaybe<Persona_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pnrr_DocumentiArgs = {
  objects: Array<Pnrr_Documenti_Insert_Input>;
  on_conflict?: InputMaybe<Pnrr_Documenti_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pnrr_Documenti_OneArgs = {
  object: Pnrr_Documenti_Insert_Input;
  on_conflict?: InputMaybe<Pnrr_Documenti_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PresetArgs = {
  objects: Array<Preset_Insert_Input>;
  on_conflict?: InputMaybe<Preset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Preset_OneArgs = {
  object: Preset_Insert_Input;
  on_conflict?: InputMaybe<Preset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProfiloArgs = {
  objects: Array<Profilo_Insert_Input>;
  on_conflict?: InputMaybe<Profilo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profilo_OneArgs = {
  object: Profilo_Insert_Input;
  on_conflict?: InputMaybe<Profilo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SottoscrizioneArgs = {
  objects: Array<Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_DocumentiArgs = {
  objects: Array<Sottoscrizione_Documenti_Insert_Input>;
  on_conflict?: InputMaybe<Sottoscrizione_Documenti_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_Documenti_OneArgs = {
  object: Sottoscrizione_Documenti_Insert_Input;
  on_conflict?: InputMaybe<Sottoscrizione_Documenti_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_DomandeArgs = {
  objects: Array<Sottoscrizione_Domande_Insert_Input>;
  on_conflict?: InputMaybe<Sottoscrizione_Domande_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_Domande_OneArgs = {
  object: Sottoscrizione_Domande_Insert_Input;
  on_conflict?: InputMaybe<Sottoscrizione_Domande_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_IniziativaArgs = {
  objects: Array<Sottoscrizione_Iniziativa_Insert_Input>;
  on_conflict?: InputMaybe<Sottoscrizione_Iniziativa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_Iniziativa_OneArgs = {
  object: Sottoscrizione_Iniziativa_Insert_Input;
  on_conflict?: InputMaybe<Sottoscrizione_Iniziativa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_OneArgs = {
  object: Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_ZipArgs = {
  objects: Array<Sottoscrizione_Zip_Insert_Input>;
  on_conflict?: InputMaybe<Sottoscrizione_Zip_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sottoscrizione_Zip_OneArgs = {
  object: Sottoscrizione_Zip_Insert_Input;
  on_conflict?: InputMaybe<Sottoscrizione_Zip_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging__Stato_SottoscrizioneArgs = {
  objects: Array<Staging__Stato_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Staging__Stato_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging__Stato_Sottoscrizione_OneArgs = {
  object: Staging__Stato_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Staging__Stato_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Azione_SottoscrizioneArgs = {
  objects: Array<Staging_Azione_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Azione_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Azione_Sottoscrizione_OneArgs = {
  object: Staging_Azione_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Staging_Azione_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Gestore_LottoArgs = {
  objects: Array<Staging_Gestore_Lotto_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Gestore_Lotto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Gestore_Lotto_OneArgs = {
  object: Staging_Gestore_Lotto_Insert_Input;
  on_conflict?: InputMaybe<Staging_Gestore_Lotto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Gestore_SottoscrizioneArgs = {
  objects: Array<Staging_Gestore_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Gestore_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Gestore_Sottoscrizione_OneArgs = {
  object: Staging_Gestore_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Staging_Gestore_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_LogArgs = {
  objects: Array<Staging_Log_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Log_OneArgs = {
  object: Staging_Log_Insert_Input;
  on_conflict?: InputMaybe<Staging_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_LottoArgs = {
  objects: Array<Staging_Lotto_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Lotto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Lotto_OneArgs = {
  object: Staging_Lotto_Insert_Input;
  on_conflict?: InputMaybe<Staging_Lotto_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Mv_Refresh_StateArgs = {
  objects: Array<Staging_Mv_Refresh_State_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Mv_Refresh_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Mv_Refresh_State_OneArgs = {
  object: Staging_Mv_Refresh_State_Insert_Input;
  on_conflict?: InputMaybe<Staging_Mv_Refresh_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_SottoscrizioneArgs = {
  objects: Array<Staging_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Staging_Sottoscrizione_OneArgs = {
  object: Staging_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Staging_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Storage_Trigger_Debug_LogArgs = {
  objects: Array<Storage_Trigger_Debug_Log_Insert_Input>;
  on_conflict?: InputMaybe<Storage_Trigger_Debug_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Storage_Trigger_Debug_Log_OneArgs = {
  object: Storage_Trigger_Debug_Log_Insert_Input;
  on_conflict?: InputMaybe<Storage_Trigger_Debug_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Storage_Trigger_Error_LogArgs = {
  objects: Array<Storage_Trigger_Error_Log_Insert_Input>;
  on_conflict?: InputMaybe<Storage_Trigger_Error_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Storage_Trigger_Error_Log_OneArgs = {
  object: Storage_Trigger_Error_Log_Insert_Input;
  on_conflict?: InputMaybe<Storage_Trigger_Error_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Storico_SottoscrizioneArgs = {
  objects: Array<Storico_Sottoscrizione_Insert_Input>;
  on_conflict?: InputMaybe<Storico_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Storico_Sottoscrizione_OneArgs = {
  object: Storico_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Storico_Sottoscrizione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Translate_MapperArgs = {
  objects: Array<Translate_Mapper_Insert_Input>;
  on_conflict?: InputMaybe<Translate_Mapper_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Translate_Mapper_OneArgs = {
  object: Translate_Mapper_Insert_Input;
  on_conflict?: InputMaybe<Translate_Mapper_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_CittaArgs = {
  objects: Array<Unita_Amministrativa_Citta_Insert_Input>;
  on_conflict?: InputMaybe<Unita_Amministrativa_Citta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_Citta_OneArgs = {
  object: Unita_Amministrativa_Citta_Insert_Input;
  on_conflict?: InputMaybe<Unita_Amministrativa_Citta_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_NazioneArgs = {
  objects: Array<Unita_Amministrativa_Nazione_Insert_Input>;
  on_conflict?: InputMaybe<Unita_Amministrativa_Nazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_Nazione_OneArgs = {
  object: Unita_Amministrativa_Nazione_Insert_Input;
  on_conflict?: InputMaybe<Unita_Amministrativa_Nazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_ProvinciaArgs = {
  objects: Array<Unita_Amministrativa_Provincia_Insert_Input>;
  on_conflict?: InputMaybe<Unita_Amministrativa_Provincia_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_Provincia_OneArgs = {
  object: Unita_Amministrativa_Provincia_Insert_Input;
  on_conflict?: InputMaybe<Unita_Amministrativa_Provincia_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_RegioneArgs = {
  objects: Array<Unita_Amministrativa_Regione_Insert_Input>;
  on_conflict?: InputMaybe<Unita_Amministrativa_Regione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unita_Amministrativa_Regione_OneArgs = {
  object: Unita_Amministrativa_Regione_Insert_Input;
  on_conflict?: InputMaybe<Unita_Amministrativa_Regione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_AssociazioneArgs = {
  objects: Array<White_Label_Associazione_Insert_Input>;
  on_conflict?: InputMaybe<White_Label_Associazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_Associazione_OneArgs = {
  object: White_Label_Associazione_Insert_Input;
  on_conflict?: InputMaybe<White_Label_Associazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_ConfigurazioneArgs = {
  objects: Array<White_Label_Configurazione_Insert_Input>;
  on_conflict?: InputMaybe<White_Label_Configurazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_Configurazione_OneArgs = {
  object: White_Label_Configurazione_Insert_Input;
  on_conflict?: InputMaybe<White_Label_Configurazione_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_GestoreArgs = {
  objects: Array<White_Label_Gestore_Insert_Input>;
  on_conflict?: InputMaybe<White_Label_Gestore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_Gestore_OneArgs = {
  object: White_Label_Gestore_Insert_Input;
  on_conflict?: InputMaybe<White_Label_Gestore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_IdpArgs = {
  objects: Array<White_Label_Idp_Insert_Input>;
  on_conflict?: InputMaybe<White_Label_Idp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_White_Label_Idp_OneArgs = {
  object: White_Label_Idp_Insert_Input;
  on_conflict?: InputMaybe<White_Label_Idp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootMostraArgs = {
  args: Mostra_Args;
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootOpenapiSmsWebhookArgs = {
  input: OpenapiSmsInput;
};


/** mutation root */
export type Mutation_RootParseBollettaArgs = {
  input: ParseBollettaInput;
};


/** mutation root */
export type Mutation_RootPreview_PdfArgs = {
  input: PreviewPdfInput;
};


/** mutation root */
export type Mutation_RootRegisterUserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootStaging_Refresh_Sottoscrizione_MvArgs = {
  args?: InputMaybe<Staging_Refresh_Sottoscrizione_Mv_Args>;
  distinct_on?: InputMaybe<Array<Staging_Mv_Refresh_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Mv_Refresh_State_Order_By>>;
  where?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootSuperadmin_Elimina_SottoscrizioneArgs = {
  args: Superadmin_Elimina_Sottoscrizione_Args;
  distinct_on?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Order_By>>;
  where?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>;
  _set?: InputMaybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input>;
  _inc?: InputMaybe<Files_Inc_Input>;
  _prepend?: InputMaybe<Files_Prepend_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  pk_columns: Virus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  _set?: InputMaybe<Virus_Set_Input>;
  where: Virus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate__Destinazione_CompatibileArgs = {
  _set?: InputMaybe<_Destinazione_Compatibile_Set_Input>;
  where: _Destinazione_Compatibile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate__Destinazione_Compatibile_ManyArgs = {
  updates: Array<_Destinazione_Compatibile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate__Pod_DuplicatoArgs = {
  _set?: InputMaybe<_Pod_Duplicato_Set_Input>;
  where: _Pod_Duplicato_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate__Pod_Duplicato_By_PkArgs = {
  _set?: InputMaybe<_Pod_Duplicato_Set_Input>;
  pk_columns: _Pod_Duplicato_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate__Pod_Duplicato_ManyArgs = {
  updates: Array<_Pod_Duplicato_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate__Sottoscrizione_Tipo_RichiestaArgs = {
  _set?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Set_Input>;
  where: _Sottoscrizione_Tipo_Richiesta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate__Sottoscrizione_Tipo_Richiesta_By_PkArgs = {
  _set?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Set_Input>;
  pk_columns: _Sottoscrizione_Tipo_Richiesta_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate__Sottoscrizione_Tipo_Richiesta_ManyArgs = {
  updates: Array<_Sottoscrizione_Tipo_Richiesta_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate__Superadmin_Elimina_Sottoscrizione_EsitoArgs = {
  _set?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Set_Input>;
  where: _Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate__Superadmin_Elimina_Sottoscrizione_Esito_By_PkArgs = {
  _set?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Set_Input>;
  pk_columns: _Superadmin_Elimina_Sottoscrizione_Esito_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate__Superadmin_Elimina_Sottoscrizione_Esito_ManyArgs = {
  updates: Array<_Superadmin_Elimina_Sottoscrizione_Esito_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate__Tipo_Dato_ConsumoArgs = {
  _set?: InputMaybe<_Tipo_Dato_Consumo_Set_Input>;
  where: _Tipo_Dato_Consumo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate__Tipo_Dato_Consumo_By_PkArgs = {
  _set?: InputMaybe<_Tipo_Dato_Consumo_Set_Input>;
  pk_columns: _Tipo_Dato_Consumo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate__Tipo_Dato_Consumo_ManyArgs = {
  updates: Array<_Tipo_Dato_Consumo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate__Tipologia_ProfiloArgs = {
  _set?: InputMaybe<_Tipologia_Profilo_Set_Input>;
  where: _Tipologia_Profilo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate__Tipologia_Profilo_By_PkArgs = {
  _set?: InputMaybe<_Tipologia_Profilo_Set_Input>;
  pk_columns: _Tipologia_Profilo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate__Tipologia_Profilo_ManyArgs = {
  updates: Array<_Tipologia_Profilo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin__Stato_Richiesta_PubblicazioneArgs = {
  _set?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Set_Input>;
  where: Admin__Stato_Richiesta_Pubblicazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin__Stato_Richiesta_Pubblicazione_By_PkArgs = {
  _set?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Set_Input>;
  pk_columns: Admin__Stato_Richiesta_Pubblicazione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin__Stato_Richiesta_Pubblicazione_ManyArgs = {
  updates: Array<Admin__Stato_Richiesta_Pubblicazione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin__Type_ReferralArgs = {
  _set?: InputMaybe<Admin__Type_Referral_Set_Input>;
  where: Admin__Type_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin__Type_Referral_By_PkArgs = {
  _set?: InputMaybe<Admin__Type_Referral_Set_Input>;
  pk_columns: Admin__Type_Referral_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin__Type_Referral_ManyArgs = {
  updates: Array<Admin__Type_Referral_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Consenso_PrivacyArgs = {
  _set?: InputMaybe<Admin_Consenso_Privacy_Set_Input>;
  where: Admin_Consenso_Privacy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Consenso_Privacy_By_PkArgs = {
  _set?: InputMaybe<Admin_Consenso_Privacy_Set_Input>;
  pk_columns: Admin_Consenso_Privacy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Consenso_Privacy_ManyArgs = {
  updates: Array<Admin_Consenso_Privacy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Parametri_Algoritmo_IncentiviArgs = {
  _append?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Append_Input>;
  _delete_at_path?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_Key_Input>;
  _prepend?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Prepend_Input>;
  _set?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Set_Input>;
  where: Admin_Parametri_Algoritmo_Incentivi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Parametri_Algoritmo_Incentivi_By_PkArgs = {
  _append?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Append_Input>;
  _delete_at_path?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Delete_Key_Input>;
  _prepend?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Prepend_Input>;
  _set?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Set_Input>;
  pk_columns: Admin_Parametri_Algoritmo_Incentivi_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Parametri_Algoritmo_Incentivi_ManyArgs = {
  updates: Array<Admin_Parametri_Algoritmo_Incentivi_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_ReferralArgs = {
  _set?: InputMaybe<Admin_Referral_Set_Input>;
  where: Admin_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Referral_By_PkArgs = {
  _set?: InputMaybe<Admin_Referral_Set_Input>;
  pk_columns: Admin_Referral_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Referral_ManyArgs = {
  updates: Array<Admin_Referral_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Richiesta_PubblicazioneArgs = {
  _set?: InputMaybe<Admin_Richiesta_Pubblicazione_Set_Input>;
  where: Admin_Richiesta_Pubblicazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Richiesta_Pubblicazione_By_PkArgs = {
  _set?: InputMaybe<Admin_Richiesta_Pubblicazione_Set_Input>;
  pk_columns: Admin_Richiesta_Pubblicazione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Richiesta_Pubblicazione_ManyArgs = {
  updates: Array<Admin_Richiesta_Pubblicazione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Utilizzo_ReferralArgs = {
  _set?: InputMaybe<Admin_Utilizzo_Referral_Set_Input>;
  where: Admin_Utilizzo_Referral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Utilizzo_Referral_By_PkArgs = {
  _set?: InputMaybe<Admin_Utilizzo_Referral_Set_Input>;
  pk_columns: Admin_Utilizzo_Referral_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Utilizzo_Referral_ManyArgs = {
  updates: Array<Admin_Utilizzo_Referral_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Codice_AtecoArgs = {
  _set?: InputMaybe<Anagrafica_Codice_Ateco_Set_Input>;
  where: Anagrafica_Codice_Ateco_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Codice_Ateco_By_PkArgs = {
  _set?: InputMaybe<Anagrafica_Codice_Ateco_Set_Input>;
  pk_columns: Anagrafica_Codice_Ateco_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Codice_Ateco_ManyArgs = {
  updates: Array<Anagrafica_Codice_Ateco_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Forma_GiuridicaArgs = {
  _append?: InputMaybe<Anagrafica_Forma_Giuridica_Append_Input>;
  _delete_at_path?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_Key_Input>;
  _inc?: InputMaybe<Anagrafica_Forma_Giuridica_Inc_Input>;
  _prepend?: InputMaybe<Anagrafica_Forma_Giuridica_Prepend_Input>;
  _set?: InputMaybe<Anagrafica_Forma_Giuridica_Set_Input>;
  where: Anagrafica_Forma_Giuridica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Forma_Giuridica_By_PkArgs = {
  _append?: InputMaybe<Anagrafica_Forma_Giuridica_Append_Input>;
  _delete_at_path?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anagrafica_Forma_Giuridica_Delete_Key_Input>;
  _inc?: InputMaybe<Anagrafica_Forma_Giuridica_Inc_Input>;
  _prepend?: InputMaybe<Anagrafica_Forma_Giuridica_Prepend_Input>;
  _set?: InputMaybe<Anagrafica_Forma_Giuridica_Set_Input>;
  pk_columns: Anagrafica_Forma_Giuridica_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Forma_Giuridica_CerArgs = {
  _inc?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Inc_Input>;
  _set?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Set_Input>;
  where: Anagrafica_Forma_Giuridica_Cer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Forma_Giuridica_Cer_By_PkArgs = {
  _inc?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Inc_Input>;
  _set?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Set_Input>;
  pk_columns: Anagrafica_Forma_Giuridica_Cer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Forma_Giuridica_Cer_ManyArgs = {
  updates: Array<Anagrafica_Forma_Giuridica_Cer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Forma_Giuridica_ManyArgs = {
  updates: Array<Anagrafica_Forma_Giuridica_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipo_ContattoArgs = {
  _append?: InputMaybe<Anagrafica_Tipo_Contatto_Append_Input>;
  _delete_at_path?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_Key_Input>;
  _inc?: InputMaybe<Anagrafica_Tipo_Contatto_Inc_Input>;
  _prepend?: InputMaybe<Anagrafica_Tipo_Contatto_Prepend_Input>;
  _set?: InputMaybe<Anagrafica_Tipo_Contatto_Set_Input>;
  where: Anagrafica_Tipo_Contatto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipo_Contatto_By_PkArgs = {
  _append?: InputMaybe<Anagrafica_Tipo_Contatto_Append_Input>;
  _delete_at_path?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Anagrafica_Tipo_Contatto_Delete_Key_Input>;
  _inc?: InputMaybe<Anagrafica_Tipo_Contatto_Inc_Input>;
  _prepend?: InputMaybe<Anagrafica_Tipo_Contatto_Prepend_Input>;
  _set?: InputMaybe<Anagrafica_Tipo_Contatto_Set_Input>;
  pk_columns: Anagrafica_Tipo_Contatto_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipo_Contatto_ManyArgs = {
  updates: Array<Anagrafica_Tipo_Contatto_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipo_PromotoreArgs = {
  _inc?: InputMaybe<Anagrafica_Tipo_Promotore_Inc_Input>;
  _set?: InputMaybe<Anagrafica_Tipo_Promotore_Set_Input>;
  where: Anagrafica_Tipo_Promotore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipo_Promotore_By_PkArgs = {
  _inc?: InputMaybe<Anagrafica_Tipo_Promotore_Inc_Input>;
  _set?: InputMaybe<Anagrafica_Tipo_Promotore_Set_Input>;
  pk_columns: Anagrafica_Tipo_Promotore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipo_Promotore_ManyArgs = {
  updates: Array<Anagrafica_Tipo_Promotore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipologia_RappresentanteArgs = {
  _inc?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Inc_Input>;
  _set?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Set_Input>;
  where: Anagrafica_Tipologia_Rappresentante_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipologia_Rappresentante_By_PkArgs = {
  _inc?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Inc_Input>;
  _set?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Set_Input>;
  pk_columns: Anagrafica_Tipologia_Rappresentante_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anagrafica_Tipologia_Rappresentante_ManyArgs = {
  updates: Array<Anagrafica_Tipologia_Rappresentante_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssetArgs = {
  _append?: InputMaybe<Asset_Append_Input>;
  _delete_at_path?: InputMaybe<Asset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Asset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Asset_Delete_Key_Input>;
  _inc?: InputMaybe<Asset_Inc_Input>;
  _prepend?: InputMaybe<Asset_Prepend_Input>;
  _set?: InputMaybe<Asset_Set_Input>;
  where: Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_By_PkArgs = {
  _append?: InputMaybe<Asset_Append_Input>;
  _delete_at_path?: InputMaybe<Asset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Asset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Asset_Delete_Key_Input>;
  _inc?: InputMaybe<Asset_Inc_Input>;
  _prepend?: InputMaybe<Asset_Prepend_Input>;
  _set?: InputMaybe<Asset_Set_Input>;
  pk_columns: Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_CaratteristicaArgs = {
  _set?: InputMaybe<Asset_Caratteristica_Set_Input>;
  where: Asset_Caratteristica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Caratteristica_By_PkArgs = {
  _set?: InputMaybe<Asset_Caratteristica_Set_Input>;
  pk_columns: Asset_Caratteristica_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Caratteristica_ManyArgs = {
  updates: Array<Asset_Caratteristica_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_ConsumoArgs = {
  _inc?: InputMaybe<Asset_Consumo_Inc_Input>;
  _set?: InputMaybe<Asset_Consumo_Set_Input>;
  where: Asset_Consumo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Consumo_By_PkArgs = {
  _inc?: InputMaybe<Asset_Consumo_Inc_Input>;
  _set?: InputMaybe<Asset_Consumo_Set_Input>;
  pk_columns: Asset_Consumo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Consumo_ManyArgs = {
  updates: Array<Asset_Consumo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Dato_ConsumoArgs = {
  _inc?: InputMaybe<Asset_Dato_Consumo_Inc_Input>;
  _set?: InputMaybe<Asset_Dato_Consumo_Set_Input>;
  where: Asset_Dato_Consumo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Dato_Consumo_By_PkArgs = {
  _inc?: InputMaybe<Asset_Dato_Consumo_Inc_Input>;
  _set?: InputMaybe<Asset_Dato_Consumo_Set_Input>;
  pk_columns: Asset_Dato_Consumo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Dato_Consumo_ManyArgs = {
  updates: Array<Asset_Dato_Consumo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_EnergiaArgs = {
  _inc?: InputMaybe<Asset_Energia_Inc_Input>;
  _set?: InputMaybe<Asset_Energia_Set_Input>;
  where: Asset_Energia_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Energia_By_PkArgs = {
  _inc?: InputMaybe<Asset_Energia_Inc_Input>;
  _set?: InputMaybe<Asset_Energia_Set_Input>;
  pk_columns: Asset_Energia_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Energia_ManyArgs = {
  updates: Array<Asset_Energia_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_FounderArgs = {
  _set?: InputMaybe<Asset_Founder_Set_Input>;
  where: Asset_Founder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Founder_By_PkArgs = {
  _set?: InputMaybe<Asset_Founder_Set_Input>;
  pk_columns: Asset_Founder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Founder_ManyArgs = {
  updates: Array<Asset_Founder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_GestoreArgs = {
  _set?: InputMaybe<Asset_Gestore_Set_Input>;
  where: Asset_Gestore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Gestore_By_PkArgs = {
  _set?: InputMaybe<Asset_Gestore_Set_Input>;
  pk_columns: Asset_Gestore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Gestore_ManyArgs = {
  updates: Array<Asset_Gestore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_ManyArgs = {
  updates: Array<Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_ProduzioneArgs = {
  _inc?: InputMaybe<Asset_Produzione_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Set_Input>;
  where: Asset_Produzione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_By_PkArgs = {
  _inc?: InputMaybe<Asset_Produzione_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Set_Input>;
  pk_columns: Asset_Produzione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_ManyArgs = {
  updates: Array<Asset_Produzione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_UnitaArgs = {
  _set?: InputMaybe<Asset_Produzione_Unita_Set_Input>;
  where: Asset_Produzione_Unita_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_By_PkArgs = {
  _set?: InputMaybe<Asset_Produzione_Unita_Set_Input>;
  pk_columns: Asset_Produzione_Unita_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_ManyArgs = {
  updates: Array<Asset_Produzione_Unita_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_SezioneArgs = {
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Set_Input>;
  where: Asset_Produzione_Unita_Sezione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_By_PkArgs = {
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Set_Input>;
  pk_columns: Asset_Produzione_Unita_Sezione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_IncentiviArgs = {
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Set_Input>;
  where: Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_Incentivi_By_PkArgs = {
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Set_Input>;
  pk_columns: Asset_Produzione_Unita_Sezione_Incentivi_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_Incentivi_ManyArgs = {
  updates: Array<Asset_Produzione_Unita_Sezione_Incentivi_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_ManyArgs = {
  updates: Array<Asset_Produzione_Unita_Sezione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_Titolo_AutorizzativoArgs = {
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Set_Input>;
  where: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_By_PkArgs = {
  _inc?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Inc_Input>;
  _set?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Set_Input>;
  pk_columns: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_ManyArgs = {
  updates: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_SpazioArgs = {
  _inc?: InputMaybe<Asset_Spazio_Inc_Input>;
  _set?: InputMaybe<Asset_Spazio_Set_Input>;
  where: Asset_Spazio_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Spazio_By_PkArgs = {
  _inc?: InputMaybe<Asset_Spazio_Inc_Input>;
  _set?: InputMaybe<Asset_Spazio_Set_Input>;
  pk_columns: Asset_Spazio_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Spazio_ManyArgs = {
  updates: Array<Asset_Spazio_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Event_EntityArgs = {
  _inc?: InputMaybe<Auth_Event_Entity_Inc_Input>;
  _set?: InputMaybe<Auth_Event_Entity_Set_Input>;
  where: Auth_Event_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Event_Entity_By_PkArgs = {
  _inc?: InputMaybe<Auth_Event_Entity_Inc_Input>;
  _set?: InputMaybe<Auth_Event_Entity_Set_Input>;
  pk_columns: Auth_Event_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Event_Entity_ManyArgs = {
  updates: Array<Auth_Event_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Federated_IdentityArgs = {
  _set?: InputMaybe<Auth_Federated_Identity_Set_Input>;
  where: Auth_Federated_Identity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Federated_Identity_By_PkArgs = {
  _set?: InputMaybe<Auth_Federated_Identity_Set_Input>;
  pk_columns: Auth_Federated_Identity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Federated_Identity_ManyArgs = {
  updates: Array<Auth_Federated_Identity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Role_AttributeArgs = {
  _set?: InputMaybe<Auth_Role_Attribute_Set_Input>;
  where: Auth_Role_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Role_Attribute_By_PkArgs = {
  _set?: InputMaybe<Auth_Role_Attribute_Set_Input>;
  pk_columns: Auth_Role_Attribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Role_Attribute_ManyArgs = {
  updates: Array<Auth_Role_Attribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_AttributeArgs = {
  _set?: InputMaybe<Auth_User_Attribute_Set_Input>;
  where: Auth_User_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_Attribute_By_PkArgs = {
  _set?: InputMaybe<Auth_User_Attribute_Set_Input>;
  pk_columns: Auth_User_Attribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_Attribute_ManyArgs = {
  updates: Array<Auth_User_Attribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_EntityArgs = {
  _inc?: InputMaybe<Auth_User_Entity_Inc_Input>;
  _set?: InputMaybe<Auth_User_Entity_Set_Input>;
  where: Auth_User_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_Entity_By_PkArgs = {
  _inc?: InputMaybe<Auth_User_Entity_Inc_Input>;
  _set?: InputMaybe<Auth_User_Entity_Set_Input>;
  pk_columns: Auth_User_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_Entity_ManyArgs = {
  updates: Array<Auth_User_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CerArgs = {
  _append?: InputMaybe<Cer_Append_Input>;
  _delete_at_path?: InputMaybe<Cer_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cer_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cer_Delete_Key_Input>;
  _inc?: InputMaybe<Cer_Inc_Input>;
  _prepend?: InputMaybe<Cer_Prepend_Input>;
  _set?: InputMaybe<Cer_Set_Input>;
  where: Cer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_By_PkArgs = {
  _append?: InputMaybe<Cer_Append_Input>;
  _delete_at_path?: InputMaybe<Cer_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cer_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cer_Delete_Key_Input>;
  _inc?: InputMaybe<Cer_Inc_Input>;
  _prepend?: InputMaybe<Cer_Prepend_Input>;
  _set?: InputMaybe<Cer_Set_Input>;
  pk_columns: Cer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_CabinaArgs = {
  _inc?: InputMaybe<Cer_Cabina_Inc_Input>;
  _set?: InputMaybe<Cer_Cabina_Set_Input>;
  where: Cer_Cabina_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Cabina_By_PkArgs = {
  _inc?: InputMaybe<Cer_Cabina_Inc_Input>;
  _set?: InputMaybe<Cer_Cabina_Set_Input>;
  pk_columns: Cer_Cabina_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Cabina_ManyArgs = {
  updates: Array<Cer_Cabina_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Cabina_SnapshotArgs = {
  _set?: InputMaybe<Cer_Cabina_Snapshot_Set_Input>;
  where: Cer_Cabina_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Cabina_Snapshot_By_PkArgs = {
  _set?: InputMaybe<Cer_Cabina_Snapshot_Set_Input>;
  pk_columns: Cer_Cabina_Snapshot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Cabina_Snapshot_ManyArgs = {
  updates: Array<Cer_Cabina_Snapshot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Categoria_AdesioneArgs = {
  _append?: InputMaybe<Cer_Categoria_Adesione_Append_Input>;
  _delete_at_path?: InputMaybe<Cer_Categoria_Adesione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cer_Categoria_Adesione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cer_Categoria_Adesione_Delete_Key_Input>;
  _prepend?: InputMaybe<Cer_Categoria_Adesione_Prepend_Input>;
  _set?: InputMaybe<Cer_Categoria_Adesione_Set_Input>;
  where: Cer_Categoria_Adesione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Categoria_Adesione_By_PkArgs = {
  _append?: InputMaybe<Cer_Categoria_Adesione_Append_Input>;
  _delete_at_path?: InputMaybe<Cer_Categoria_Adesione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cer_Categoria_Adesione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cer_Categoria_Adesione_Delete_Key_Input>;
  _prepend?: InputMaybe<Cer_Categoria_Adesione_Prepend_Input>;
  _set?: InputMaybe<Cer_Categoria_Adesione_Set_Input>;
  pk_columns: Cer_Categoria_Adesione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Categoria_Adesione_ManyArgs = {
  updates: Array<Cer_Categoria_Adesione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Configurazione_Destinazione_ContributoArgs = {
  _set?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Set_Input>;
  where: Cer_Configurazione_Destinazione_Contributo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Configurazione_Destinazione_Contributo_By_PkArgs = {
  _set?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Set_Input>;
  pk_columns: Cer_Configurazione_Destinazione_Contributo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Configurazione_Destinazione_Contributo_ManyArgs = {
  updates: Array<Cer_Configurazione_Destinazione_Contributo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_ContattiArgs = {
  _set?: InputMaybe<Cer_Contatti_Set_Input>;
  where: Cer_Contatti_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Contatti_By_PkArgs = {
  _set?: InputMaybe<Cer_Contatti_Set_Input>;
  pk_columns: Cer_Contatti_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Contatti_ManyArgs = {
  updates: Array<Cer_Contatti_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Destinazione_ContributoArgs = {
  _set?: InputMaybe<Cer_Destinazione_Contributo_Set_Input>;
  where: Cer_Destinazione_Contributo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Destinazione_Contributo_By_PkArgs = {
  _set?: InputMaybe<Cer_Destinazione_Contributo_Set_Input>;
  pk_columns: Cer_Destinazione_Contributo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Destinazione_Contributo_ManyArgs = {
  updates: Array<Cer_Destinazione_Contributo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_GeomArgs = {
  _append?: InputMaybe<Cer_Geom_Append_Input>;
  _delete_at_path?: InputMaybe<Cer_Geom_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cer_Geom_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cer_Geom_Delete_Key_Input>;
  _prepend?: InputMaybe<Cer_Geom_Prepend_Input>;
  _set?: InputMaybe<Cer_Geom_Set_Input>;
  where: Cer_Geom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Geom_By_PkArgs = {
  _append?: InputMaybe<Cer_Geom_Append_Input>;
  _delete_at_path?: InputMaybe<Cer_Geom_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cer_Geom_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cer_Geom_Delete_Key_Input>;
  _prepend?: InputMaybe<Cer_Geom_Prepend_Input>;
  _set?: InputMaybe<Cer_Geom_Set_Input>;
  pk_columns: Cer_Geom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Geom_ManyArgs = {
  updates: Array<Cer_Geom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_GestoreArgs = {
  _set?: InputMaybe<Cer_Gestore_Set_Input>;
  where: Cer_Gestore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Gestore_By_PkArgs = {
  _set?: InputMaybe<Cer_Gestore_Set_Input>;
  pk_columns: Cer_Gestore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Gestore_ManyArgs = {
  updates: Array<Cer_Gestore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_ManyArgs = {
  updates: Array<Cer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Search_IndexArgs = {
  _inc?: InputMaybe<Cer_Search_Index_Inc_Input>;
  _set?: InputMaybe<Cer_Search_Index_Set_Input>;
  where: Cer_Search_Index_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Search_Index_By_PkArgs = {
  _inc?: InputMaybe<Cer_Search_Index_Inc_Input>;
  _set?: InputMaybe<Cer_Search_Index_Set_Input>;
  pk_columns: Cer_Search_Index_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Search_Index_ManyArgs = {
  updates: Array<Cer_Search_Index_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_TecnicoArgs = {
  _set?: InputMaybe<Cer_Tecnico_Set_Input>;
  where: Cer_Tecnico_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Tecnico_By_PkArgs = {
  _set?: InputMaybe<Cer_Tecnico_Set_Input>;
  pk_columns: Cer_Tecnico_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cer_Tecnico_ManyArgs = {
  updates: Array<Cer_Tecnico_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Codice_OperatoreArgs = {
  _set?: InputMaybe<Codice_Operatore_Set_Input>;
  where: Codice_Operatore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Codice_Operatore_By_PkArgs = {
  _set?: InputMaybe<Codice_Operatore_Set_Input>;
  pk_columns: Codice_Operatore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Codice_Operatore_ManyArgs = {
  updates: Array<Codice_Operatore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_EmailArgs = {
  _set?: InputMaybe<Comunicazioni_Email_Set_Input>;
  where: Comunicazioni_Email_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_Email_By_PkArgs = {
  _set?: InputMaybe<Comunicazioni_Email_Set_Input>;
  pk_columns: Comunicazioni_Email_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_Email_ManyArgs = {
  updates: Array<Comunicazioni_Email_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_Email_TemplateArgs = {
  _set?: InputMaybe<Comunicazioni_Email_Template_Set_Input>;
  where: Comunicazioni_Email_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_Email_Template_By_PkArgs = {
  _set?: InputMaybe<Comunicazioni_Email_Template_Set_Input>;
  pk_columns: Comunicazioni_Email_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_Email_Template_ManyArgs = {
  updates: Array<Comunicazioni_Email_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_SmsArgs = {
  _set?: InputMaybe<Comunicazioni_Sms_Set_Input>;
  where: Comunicazioni_Sms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_Sms_By_PkArgs = {
  _set?: InputMaybe<Comunicazioni_Sms_Set_Input>;
  pk_columns: Comunicazioni_Sms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comunicazioni_Sms_ManyArgs = {
  updates: Array<Comunicazioni_Sms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione__Stato_CondivisioneArgs = {
  _set?: InputMaybe<Condivisione__Stato_Condivisione_Set_Input>;
  where: Condivisione__Stato_Condivisione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione__Stato_Condivisione_By_PkArgs = {
  _set?: InputMaybe<Condivisione__Stato_Condivisione_Set_Input>;
  pk_columns: Condivisione__Stato_Condivisione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione__Stato_Condivisione_ManyArgs = {
  updates: Array<Condivisione__Stato_Condivisione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_Accetta_ResponseArgs = {
  _set?: InputMaybe<Condivisione_Accetta_Response_Set_Input>;
  where: Condivisione_Accetta_Response_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_Accetta_Response_ManyArgs = {
  updates: Array<Condivisione_Accetta_Response_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_CondivisioneArgs = {
  _append?: InputMaybe<Condivisione_Condivisione_Append_Input>;
  _delete_at_path?: InputMaybe<Condivisione_Condivisione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Condivisione_Condivisione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Condivisione_Condivisione_Delete_Key_Input>;
  _prepend?: InputMaybe<Condivisione_Condivisione_Prepend_Input>;
  _set?: InputMaybe<Condivisione_Condivisione_Set_Input>;
  where: Condivisione_Condivisione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_Condivisione_By_PkArgs = {
  _append?: InputMaybe<Condivisione_Condivisione_Append_Input>;
  _delete_at_path?: InputMaybe<Condivisione_Condivisione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Condivisione_Condivisione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Condivisione_Condivisione_Delete_Key_Input>;
  _prepend?: InputMaybe<Condivisione_Condivisione_Prepend_Input>;
  _set?: InputMaybe<Condivisione_Condivisione_Set_Input>;
  pk_columns: Condivisione_Condivisione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_Condivisione_ManyArgs = {
  updates: Array<Condivisione_Condivisione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_Log_CondivisioneArgs = {
  _append?: InputMaybe<Condivisione_Log_Condivisione_Append_Input>;
  _delete_at_path?: InputMaybe<Condivisione_Log_Condivisione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Condivisione_Log_Condivisione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Condivisione_Log_Condivisione_Delete_Key_Input>;
  _prepend?: InputMaybe<Condivisione_Log_Condivisione_Prepend_Input>;
  _set?: InputMaybe<Condivisione_Log_Condivisione_Set_Input>;
  where: Condivisione_Log_Condivisione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_Log_Condivisione_By_PkArgs = {
  _append?: InputMaybe<Condivisione_Log_Condivisione_Append_Input>;
  _delete_at_path?: InputMaybe<Condivisione_Log_Condivisione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Condivisione_Log_Condivisione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Condivisione_Log_Condivisione_Delete_Key_Input>;
  _prepend?: InputMaybe<Condivisione_Log_Condivisione_Prepend_Input>;
  _set?: InputMaybe<Condivisione_Log_Condivisione_Set_Input>;
  pk_columns: Condivisione_Log_Condivisione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Condivisione_Log_Condivisione_ManyArgs = {
  updates: Array<Condivisione_Log_Condivisione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContattoArgs = {
  _set?: InputMaybe<Contatto_Set_Input>;
  where: Contatto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contatto_By_PkArgs = {
  _set?: InputMaybe<Contatto_Set_Input>;
  pk_columns: Contatto_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contatto_ManyArgs = {
  updates: Array<Contatto_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crm_Audit_EventArgs = {
  _append?: InputMaybe<Crm_Audit_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Crm_Audit_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Crm_Audit_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Crm_Audit_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Crm_Audit_Event_Prepend_Input>;
  _set?: InputMaybe<Crm_Audit_Event_Set_Input>;
  where: Crm_Audit_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crm_Audit_Event_By_PkArgs = {
  _append?: InputMaybe<Crm_Audit_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Crm_Audit_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Crm_Audit_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Crm_Audit_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Crm_Audit_Event_Prepend_Input>;
  _set?: InputMaybe<Crm_Audit_Event_Set_Input>;
  pk_columns: Crm_Audit_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crm_Audit_Event_ManyArgs = {
  updates: Array<Crm_Audit_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Debug_Sottoscrizione_After_LogArgs = {
  _append?: InputMaybe<Debug_Sottoscrizione_After_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Debug_Sottoscrizione_After_Log_Inc_Input>;
  _prepend?: InputMaybe<Debug_Sottoscrizione_After_Log_Prepend_Input>;
  _set?: InputMaybe<Debug_Sottoscrizione_After_Log_Set_Input>;
  where: Debug_Sottoscrizione_After_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Debug_Sottoscrizione_After_Log_By_PkArgs = {
  _append?: InputMaybe<Debug_Sottoscrizione_After_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Debug_Sottoscrizione_After_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Debug_Sottoscrizione_After_Log_Inc_Input>;
  _prepend?: InputMaybe<Debug_Sottoscrizione_After_Log_Prepend_Input>;
  _set?: InputMaybe<Debug_Sottoscrizione_After_Log_Set_Input>;
  pk_columns: Debug_Sottoscrizione_After_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Debug_Sottoscrizione_After_Log_ManyArgs = {
  updates: Array<Debug_Sottoscrizione_After_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Device_DeviceArgs = {
  _set?: InputMaybe<Device_Device_Set_Input>;
  where: Device_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Device_Device_By_PkArgs = {
  _set?: InputMaybe<Device_Device_Set_Input>;
  pk_columns: Device_Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Device_Device_ManyArgs = {
  updates: Array<Device_Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Founder_SottoscrizioneArgs = {
  _set?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Set_Input>;
  where: Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Founder_Sottoscrizione_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Set_Input>;
  pk_columns: Energy_Village__Azioni_Founder_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Founder_Sottoscrizione_ManyArgs = {
  updates: Array<Energy_Village__Azioni_Founder_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Prosumer_SottoscrizioneArgs = {
  _set?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Set_Input>;
  where: Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Prosumer_Sottoscrizione_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Set_Input>;
  pk_columns: Energy_Village__Azioni_Prosumer_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Prosumer_Sottoscrizione_ManyArgs = {
  updates: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Tecnico_SottoscrizioneArgs = {
  _set?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Set_Input>;
  where: Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Tecnico_Sottoscrizione_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Set_Input>;
  pk_columns: Energy_Village__Azioni_Tecnico_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Azioni_Tecnico_Sottoscrizione_ManyArgs = {
  updates: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Cer_Filter_OptionsArgs = {
  _set?: InputMaybe<Energy_Village__Cer_Filter_Options_Set_Input>;
  where: Energy_Village__Cer_Filter_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Cer_Filter_Options_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Cer_Filter_Options_Set_Input>;
  pk_columns: Energy_Village__Cer_Filter_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Cer_Filter_Options_ManyArgs = {
  updates: Array<Energy_Village__Cer_Filter_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Stato_CerArgs = {
  _set?: InputMaybe<Energy_Village__Stato_Cer_Set_Input>;
  where: Energy_Village__Stato_Cer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Stato_Cer_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Stato_Cer_Set_Input>;
  pk_columns: Energy_Village__Stato_Cer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Stato_Cer_ManyArgs = {
  updates: Array<Energy_Village__Stato_Cer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Stato_SottoscrizioneArgs = {
  _set?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Set_Input>;
  where: Energy_Village__Stato_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Stato_Sottoscrizione_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Set_Input>;
  pk_columns: Energy_Village__Stato_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Stato_Sottoscrizione_ManyArgs = {
  updates: Array<Energy_Village__Stato_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Tipo_DomandaArgs = {
  _set?: InputMaybe<Energy_Village__Tipo_Domanda_Set_Input>;
  where: Energy_Village__Tipo_Domanda_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Tipo_Domanda_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Tipo_Domanda_Set_Input>;
  pk_columns: Energy_Village__Tipo_Domanda_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Tipo_Domanda_ManyArgs = {
  updates: Array<Energy_Village__Tipo_Domanda_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Tipo_FeedbackArgs = {
  _set?: InputMaybe<Energy_Village__Tipo_Feedback_Set_Input>;
  where: Energy_Village__Tipo_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Tipo_Feedback_By_PkArgs = {
  _set?: InputMaybe<Energy_Village__Tipo_Feedback_Set_Input>;
  pk_columns: Energy_Village__Tipo_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village__Tipo_Feedback_ManyArgs = {
  updates: Array<Energy_Village__Tipo_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_AreaArgs = {
  _inc?: InputMaybe<Energy_Village_Area_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Area_Set_Input>;
  where: Energy_Village_Area_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Area_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Area_Set_Input>;
  pk_columns: Energy_Village_Area_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_CittaArgs = {
  _append?: InputMaybe<Energy_Village_Area_Citta_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Area_Citta_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Area_Citta_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Area_Citta_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Area_Citta_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Area_Citta_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Area_Citta_Set_Input>;
  where: Energy_Village_Area_Citta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_Citta_By_PkArgs = {
  _append?: InputMaybe<Energy_Village_Area_Citta_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Area_Citta_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Area_Citta_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Area_Citta_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Area_Citta_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Area_Citta_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Area_Citta_Set_Input>;
  pk_columns: Energy_Village_Area_Citta_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_Citta_ManyArgs = {
  updates: Array<Energy_Village_Area_Citta_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_ManyArgs = {
  updates: Array<Energy_Village_Area_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_ProvinciaArgs = {
  _append?: InputMaybe<Energy_Village_Area_Provincia_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Area_Provincia_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Area_Provincia_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Area_Provincia_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Area_Provincia_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Area_Provincia_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Area_Provincia_Set_Input>;
  where: Energy_Village_Area_Provincia_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_Provincia_By_PkArgs = {
  _append?: InputMaybe<Energy_Village_Area_Provincia_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Area_Provincia_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Area_Provincia_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Area_Provincia_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Area_Provincia_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Area_Provincia_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Area_Provincia_Set_Input>;
  pk_columns: Energy_Village_Area_Provincia_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_Provincia_ManyArgs = {
  updates: Array<Energy_Village_Area_Provincia_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_RegioneArgs = {
  _append?: InputMaybe<Energy_Village_Area_Regione_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Area_Regione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Area_Regione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Area_Regione_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Area_Regione_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Area_Regione_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Area_Regione_Set_Input>;
  where: Energy_Village_Area_Regione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_Regione_By_PkArgs = {
  _append?: InputMaybe<Energy_Village_Area_Regione_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Area_Regione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Area_Regione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Area_Regione_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Area_Regione_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Area_Regione_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Area_Regione_Set_Input>;
  pk_columns: Energy_Village_Area_Regione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Area_Regione_ManyArgs = {
  updates: Array<Energy_Village_Area_Regione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_AzioniArgs = {
  _set?: InputMaybe<Energy_Village_Azioni_Set_Input>;
  where: Energy_Village_Azioni_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Azioni_By_PkArgs = {
  _set?: InputMaybe<Energy_Village_Azioni_Set_Input>;
  pk_columns: Energy_Village_Azioni_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Azioni_ManyArgs = {
  updates: Array<Energy_Village_Azioni_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_CabinaArgs = {
  _inc?: InputMaybe<Energy_Village_Cabina_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Cabina_Set_Input>;
  where: Energy_Village_Cabina_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cabina_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Cabina_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Cabina_Set_Input>;
  pk_columns: Energy_Village_Cabina_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cabina_CittaArgs = {
  _inc?: InputMaybe<Energy_Village_Cabina_Citta_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Cabina_Citta_Set_Input>;
  where: Energy_Village_Cabina_Citta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cabina_Citta_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Cabina_Citta_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Cabina_Citta_Set_Input>;
  pk_columns: Energy_Village_Cabina_Citta_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cabina_Citta_ManyArgs = {
  updates: Array<Energy_Village_Cabina_Citta_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cabina_ManyArgs = {
  updates: Array<Energy_Village_Cabina_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_CaratteristicaArgs = {
  _inc?: InputMaybe<Energy_Village_Caratteristica_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Caratteristica_Set_Input>;
  where: Energy_Village_Caratteristica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Caratteristica_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Caratteristica_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Caratteristica_Set_Input>;
  pk_columns: Energy_Village_Caratteristica_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Caratteristica_ManyArgs = {
  updates: Array<Energy_Village_Caratteristica_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cer_Filter_OptionsArgs = {
  _set?: InputMaybe<Energy_Village_Cer_Filter_Options_Set_Input>;
  where: Energy_Village_Cer_Filter_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cer_Filter_Options_By_PkArgs = {
  _set?: InputMaybe<Energy_Village_Cer_Filter_Options_Set_Input>;
  pk_columns: Energy_Village_Cer_Filter_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Cer_Filter_Options_ManyArgs = {
  updates: Array<Energy_Village_Cer_Filter_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_DimensioneArgs = {
  _inc?: InputMaybe<Energy_Village_Dimensione_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Dimensione_Set_Input>;
  where: Energy_Village_Dimensione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Dimensione_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Dimensione_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Dimensione_Set_Input>;
  pk_columns: Energy_Village_Dimensione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Dimensione_ManyArgs = {
  updates: Array<Energy_Village_Dimensione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_FeedbackArgs = {
  _inc?: InputMaybe<Energy_Village_Feedback_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Feedback_Set_Input>;
  where: Energy_Village_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Feedback_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Feedback_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Feedback_Set_Input>;
  pk_columns: Energy_Village_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Feedback_ManyArgs = {
  updates: Array<Energy_Village_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Incentivo_ImpiantoArgs = {
  _inc?: InputMaybe<Energy_Village_Incentivo_Impianto_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Incentivo_Impianto_Set_Input>;
  where: Energy_Village_Incentivo_Impianto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Incentivo_Impianto_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Incentivo_Impianto_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Incentivo_Impianto_Set_Input>;
  pk_columns: Energy_Village_Incentivo_Impianto_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Incentivo_Impianto_ManyArgs = {
  updates: Array<Energy_Village_Incentivo_Impianto_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_OrarioArgs = {
  _inc?: InputMaybe<Energy_Village_Orario_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Orario_Set_Input>;
  where: Energy_Village_Orario_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Orario_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Orario_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Orario_Set_Input>;
  pk_columns: Energy_Village_Orario_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Orario_ManyArgs = {
  updates: Array<Energy_Village_Orario_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Potenza_ImpiantoArgs = {
  _inc?: InputMaybe<Energy_Village_Potenza_Impianto_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Potenza_Impianto_Set_Input>;
  where: Energy_Village_Potenza_Impianto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Potenza_Impianto_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Potenza_Impianto_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Potenza_Impianto_Set_Input>;
  pk_columns: Energy_Village_Potenza_Impianto_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Potenza_Impianto_ManyArgs = {
  updates: Array<Energy_Village_Potenza_Impianto_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Potenzialita_CabinaArgs = {
  _inc?: InputMaybe<Energy_Village_Potenzialita_Cabina_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Potenzialita_Cabina_Set_Input>;
  where: Energy_Village_Potenzialita_Cabina_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Potenzialita_Cabina_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Potenzialita_Cabina_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Potenzialita_Cabina_Set_Input>;
  pk_columns: Energy_Village_Potenzialita_Cabina_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Potenzialita_Cabina_ManyArgs = {
  updates: Array<Energy_Village_Potenzialita_Cabina_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipo_Spazio_DisponibileArgs = {
  _inc?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Set_Input>;
  where: Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipo_Spazio_Disponibile_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Set_Input>;
  pk_columns: Energy_Village_Tipo_Spazio_Disponibile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipo_Spazio_Disponibile_ManyArgs = {
  updates: Array<Energy_Village_Tipo_Spazio_Disponibile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipologia_AbitativaArgs = {
  _inc?: InputMaybe<Energy_Village_Tipologia_Abitativa_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Tipologia_Abitativa_Set_Input>;
  where: Energy_Village_Tipologia_Abitativa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipologia_Abitativa_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Tipologia_Abitativa_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Tipologia_Abitativa_Set_Input>;
  pk_columns: Energy_Village_Tipologia_Abitativa_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipologia_Abitativa_ManyArgs = {
  updates: Array<Energy_Village_Tipologia_Abitativa_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipologia_AssetArgs = {
  _append?: InputMaybe<Energy_Village_Tipologia_Asset_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Tipologia_Asset_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Tipologia_Asset_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Tipologia_Asset_Set_Input>;
  where: Energy_Village_Tipologia_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipologia_Asset_By_PkArgs = {
  _append?: InputMaybe<Energy_Village_Tipologia_Asset_Append_Input>;
  _delete_at_path?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Energy_Village_Tipologia_Asset_Delete_Key_Input>;
  _inc?: InputMaybe<Energy_Village_Tipologia_Asset_Inc_Input>;
  _prepend?: InputMaybe<Energy_Village_Tipologia_Asset_Prepend_Input>;
  _set?: InputMaybe<Energy_Village_Tipologia_Asset_Set_Input>;
  pk_columns: Energy_Village_Tipologia_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Tipologia_Asset_ManyArgs = {
  updates: Array<Energy_Village_Tipologia_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Titolo_AutorizzativoArgs = {
  _inc?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Set_Input>;
  where: Energy_Village_Titolo_Autorizzativo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Titolo_Autorizzativo_By_PkArgs = {
  _inc?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Inc_Input>;
  _set?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Set_Input>;
  pk_columns: Energy_Village_Titolo_Autorizzativo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Village_Titolo_Autorizzativo_ManyArgs = {
  updates: Array<Energy_Village_Titolo_Autorizzativo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Flussi_Gse_FlussoArgs = {
  _append?: InputMaybe<Flussi_Gse_Flusso_Append_Input>;
  _delete_at_path?: InputMaybe<Flussi_Gse_Flusso_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Flussi_Gse_Flusso_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Flussi_Gse_Flusso_Delete_Key_Input>;
  _inc?: InputMaybe<Flussi_Gse_Flusso_Inc_Input>;
  _prepend?: InputMaybe<Flussi_Gse_Flusso_Prepend_Input>;
  _set?: InputMaybe<Flussi_Gse_Flusso_Set_Input>;
  where: Flussi_Gse_Flusso_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flussi_Gse_Flusso_By_PkArgs = {
  _append?: InputMaybe<Flussi_Gse_Flusso_Append_Input>;
  _delete_at_path?: InputMaybe<Flussi_Gse_Flusso_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Flussi_Gse_Flusso_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Flussi_Gse_Flusso_Delete_Key_Input>;
  _inc?: InputMaybe<Flussi_Gse_Flusso_Inc_Input>;
  _prepend?: InputMaybe<Flussi_Gse_Flusso_Prepend_Input>;
  _set?: InputMaybe<Flussi_Gse_Flusso_Set_Input>;
  pk_columns: Flussi_Gse_Flusso_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flussi_Gse_Flusso_ManyArgs = {
  updates: Array<Flussi_Gse_Flusso_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funzione_LogArgs = {
  _inc?: InputMaybe<Funzione_Log_Inc_Input>;
  _set?: InputMaybe<Funzione_Log_Set_Input>;
  where: Funzione_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Funzione_Log_By_PkArgs = {
  _inc?: InputMaybe<Funzione_Log_Inc_Input>;
  _set?: InputMaybe<Funzione_Log_Set_Input>;
  pk_columns: Funzione_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funzione_Log_ManyArgs = {
  updates: Array<Funzione_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi__Stato_CalcoloArgs = {
  _set?: InputMaybe<Incentivi__Stato_Calcolo_Set_Input>;
  where: Incentivi__Stato_Calcolo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi__Stato_Calcolo_By_PkArgs = {
  _set?: InputMaybe<Incentivi__Stato_Calcolo_Set_Input>;
  pk_columns: Incentivi__Stato_Calcolo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi__Stato_Calcolo_ManyArgs = {
  updates: Array<Incentivi__Stato_Calcolo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_CalcolatiArgs = {
  _append?: InputMaybe<Incentivi_Calcolati_Append_Input>;
  _delete_at_path?: InputMaybe<Incentivi_Calcolati_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Incentivi_Calcolati_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Incentivi_Calcolati_Delete_Key_Input>;
  _prepend?: InputMaybe<Incentivi_Calcolati_Prepend_Input>;
  _set?: InputMaybe<Incentivi_Calcolati_Set_Input>;
  where: Incentivi_Calcolati_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_Calcolati_By_PkArgs = {
  _append?: InputMaybe<Incentivi_Calcolati_Append_Input>;
  _delete_at_path?: InputMaybe<Incentivi_Calcolati_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Incentivi_Calcolati_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Incentivi_Calcolati_Delete_Key_Input>;
  _prepend?: InputMaybe<Incentivi_Calcolati_Prepend_Input>;
  _set?: InputMaybe<Incentivi_Calcolati_Set_Input>;
  pk_columns: Incentivi_Calcolati_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_Calcolati_ManyArgs = {
  updates: Array<Incentivi_Calcolati_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_Log_RipartizioneArgs = {
  _set?: InputMaybe<Incentivi_Log_Ripartizione_Set_Input>;
  where: Incentivi_Log_Ripartizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_Log_Ripartizione_By_PkArgs = {
  _set?: InputMaybe<Incentivi_Log_Ripartizione_Set_Input>;
  pk_columns: Incentivi_Log_Ripartizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_Log_Ripartizione_ManyArgs = {
  updates: Array<Incentivi_Log_Ripartizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_RipartizioneArgs = {
  _append?: InputMaybe<Incentivi_Ripartizione_Append_Input>;
  _delete_at_path?: InputMaybe<Incentivi_Ripartizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Incentivi_Ripartizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Incentivi_Ripartizione_Delete_Key_Input>;
  _prepend?: InputMaybe<Incentivi_Ripartizione_Prepend_Input>;
  _set?: InputMaybe<Incentivi_Ripartizione_Set_Input>;
  where: Incentivi_Ripartizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_Ripartizione_By_PkArgs = {
  _append?: InputMaybe<Incentivi_Ripartizione_Append_Input>;
  _delete_at_path?: InputMaybe<Incentivi_Ripartizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Incentivi_Ripartizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Incentivi_Ripartizione_Delete_Key_Input>;
  _prepend?: InputMaybe<Incentivi_Ripartizione_Prepend_Input>;
  _set?: InputMaybe<Incentivi_Ripartizione_Set_Input>;
  pk_columns: Incentivi_Ripartizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incentivi_Ripartizione_ManyArgs = {
  updates: Array<Incentivi_Ripartizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IndirizzoArgs = {
  _inc?: InputMaybe<Indirizzo_Inc_Input>;
  _set?: InputMaybe<Indirizzo_Set_Input>;
  where: Indirizzo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Indirizzo_By_PkArgs = {
  _inc?: InputMaybe<Indirizzo_Inc_Input>;
  _set?: InputMaybe<Indirizzo_Set_Input>;
  pk_columns: Indirizzo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Indirizzo_ManyArgs = {
  updates: Array<Indirizzo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InseritoreArgs = {
  _set?: InputMaybe<Inseritore_Set_Input>;
  where: Inseritore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Inseritore_By_PkArgs = {
  _set?: InputMaybe<Inseritore_Set_Input>;
  pk_columns: Inseritore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Inseritore_ManyArgs = {
  updates: Array<Inseritore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InstallatoreArgs = {
  _set?: InputMaybe<Installatore_Set_Input>;
  where: Installatore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Installatore_By_PkArgs = {
  _set?: InputMaybe<Installatore_Set_Input>;
  pk_columns: Installatore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Installatore_ManyArgs = {
  updates: Array<Installatore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Log_Errori_FunzioniArgs = {
  _inc?: InputMaybe<Log_Errori_Funzioni_Inc_Input>;
  _set?: InputMaybe<Log_Errori_Funzioni_Set_Input>;
  where: Log_Errori_Funzioni_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Log_Errori_Funzioni_By_PkArgs = {
  _inc?: InputMaybe<Log_Errori_Funzioni_Inc_Input>;
  _set?: InputMaybe<Log_Errori_Funzioni_Set_Input>;
  pk_columns: Log_Errori_Funzioni_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Log_Errori_Funzioni_ManyArgs = {
  updates: Array<Log_Errori_Funzioni_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PersonaArgs = {
  _inc?: InputMaybe<Persona_Inc_Input>;
  _set?: InputMaybe<Persona_Set_Input>;
  where: Persona_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_By_PkArgs = {
  _inc?: InputMaybe<Persona_Inc_Input>;
  _set?: InputMaybe<Persona_Set_Input>;
  pk_columns: Persona_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_ContattoArgs = {
  _set?: InputMaybe<Persona_Contatto_Set_Input>;
  where: Persona_Contatto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_Contatto_By_PkArgs = {
  _set?: InputMaybe<Persona_Contatto_Set_Input>;
  pk_columns: Persona_Contatto_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_Contatto_ManyArgs = {
  updates: Array<Persona_Contatto_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_ManyArgs = {
  updates: Array<Persona_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pnrr_DocumentiArgs = {
  _append?: InputMaybe<Pnrr_Documenti_Append_Input>;
  _delete_at_path?: InputMaybe<Pnrr_Documenti_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pnrr_Documenti_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pnrr_Documenti_Delete_Key_Input>;
  _prepend?: InputMaybe<Pnrr_Documenti_Prepend_Input>;
  _set?: InputMaybe<Pnrr_Documenti_Set_Input>;
  where: Pnrr_Documenti_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pnrr_Documenti_By_PkArgs = {
  _append?: InputMaybe<Pnrr_Documenti_Append_Input>;
  _delete_at_path?: InputMaybe<Pnrr_Documenti_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pnrr_Documenti_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pnrr_Documenti_Delete_Key_Input>;
  _prepend?: InputMaybe<Pnrr_Documenti_Prepend_Input>;
  _set?: InputMaybe<Pnrr_Documenti_Set_Input>;
  pk_columns: Pnrr_Documenti_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pnrr_Documenti_ManyArgs = {
  updates: Array<Pnrr_Documenti_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PresetArgs = {
  _append?: InputMaybe<Preset_Append_Input>;
  _delete_at_path?: InputMaybe<Preset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Preset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Preset_Delete_Key_Input>;
  _prepend?: InputMaybe<Preset_Prepend_Input>;
  _set?: InputMaybe<Preset_Set_Input>;
  where: Preset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Preset_By_PkArgs = {
  _append?: InputMaybe<Preset_Append_Input>;
  _delete_at_path?: InputMaybe<Preset_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Preset_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Preset_Delete_Key_Input>;
  _prepend?: InputMaybe<Preset_Prepend_Input>;
  _set?: InputMaybe<Preset_Set_Input>;
  pk_columns: Preset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Preset_ManyArgs = {
  updates: Array<Preset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProfiloArgs = {
  _append?: InputMaybe<Profilo_Append_Input>;
  _delete_at_path?: InputMaybe<Profilo_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Profilo_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Profilo_Delete_Key_Input>;
  _inc?: InputMaybe<Profilo_Inc_Input>;
  _prepend?: InputMaybe<Profilo_Prepend_Input>;
  _set?: InputMaybe<Profilo_Set_Input>;
  where: Profilo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profilo_By_PkArgs = {
  _append?: InputMaybe<Profilo_Append_Input>;
  _delete_at_path?: InputMaybe<Profilo_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Profilo_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Profilo_Delete_Key_Input>;
  _inc?: InputMaybe<Profilo_Inc_Input>;
  _prepend?: InputMaybe<Profilo_Prepend_Input>;
  _set?: InputMaybe<Profilo_Set_Input>;
  pk_columns: Profilo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profilo_ManyArgs = {
  updates: Array<Profilo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SottoscrizioneArgs = {
  _append?: InputMaybe<Sottoscrizione_Append_Input>;
  _delete_at_path?: InputMaybe<Sottoscrizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sottoscrizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sottoscrizione_Delete_Key_Input>;
  _prepend?: InputMaybe<Sottoscrizione_Prepend_Input>;
  _set?: InputMaybe<Sottoscrizione_Set_Input>;
  where: Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_By_PkArgs = {
  _append?: InputMaybe<Sottoscrizione_Append_Input>;
  _delete_at_path?: InputMaybe<Sottoscrizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sottoscrizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sottoscrizione_Delete_Key_Input>;
  _prepend?: InputMaybe<Sottoscrizione_Prepend_Input>;
  _set?: InputMaybe<Sottoscrizione_Set_Input>;
  pk_columns: Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_DocumentiArgs = {
  _append?: InputMaybe<Sottoscrizione_Documenti_Append_Input>;
  _delete_at_path?: InputMaybe<Sottoscrizione_Documenti_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sottoscrizione_Documenti_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sottoscrizione_Documenti_Delete_Key_Input>;
  _prepend?: InputMaybe<Sottoscrizione_Documenti_Prepend_Input>;
  _set?: InputMaybe<Sottoscrizione_Documenti_Set_Input>;
  where: Sottoscrizione_Documenti_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Documenti_By_PkArgs = {
  _append?: InputMaybe<Sottoscrizione_Documenti_Append_Input>;
  _delete_at_path?: InputMaybe<Sottoscrizione_Documenti_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sottoscrizione_Documenti_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sottoscrizione_Documenti_Delete_Key_Input>;
  _prepend?: InputMaybe<Sottoscrizione_Documenti_Prepend_Input>;
  _set?: InputMaybe<Sottoscrizione_Documenti_Set_Input>;
  pk_columns: Sottoscrizione_Documenti_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Documenti_ManyArgs = {
  updates: Array<Sottoscrizione_Documenti_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_DomandeArgs = {
  _append?: InputMaybe<Sottoscrizione_Domande_Append_Input>;
  _delete_at_path?: InputMaybe<Sottoscrizione_Domande_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sottoscrizione_Domande_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sottoscrizione_Domande_Delete_Key_Input>;
  _prepend?: InputMaybe<Sottoscrizione_Domande_Prepend_Input>;
  _set?: InputMaybe<Sottoscrizione_Domande_Set_Input>;
  where: Sottoscrizione_Domande_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Domande_By_PkArgs = {
  _append?: InputMaybe<Sottoscrizione_Domande_Append_Input>;
  _delete_at_path?: InputMaybe<Sottoscrizione_Domande_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sottoscrizione_Domande_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sottoscrizione_Domande_Delete_Key_Input>;
  _prepend?: InputMaybe<Sottoscrizione_Domande_Prepend_Input>;
  _set?: InputMaybe<Sottoscrizione_Domande_Set_Input>;
  pk_columns: Sottoscrizione_Domande_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Domande_ManyArgs = {
  updates: Array<Sottoscrizione_Domande_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_IniziativaArgs = {
  _set?: InputMaybe<Sottoscrizione_Iniziativa_Set_Input>;
  where: Sottoscrizione_Iniziativa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Iniziativa_By_PkArgs = {
  _set?: InputMaybe<Sottoscrizione_Iniziativa_Set_Input>;
  pk_columns: Sottoscrizione_Iniziativa_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Iniziativa_ManyArgs = {
  updates: Array<Sottoscrizione_Iniziativa_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_ManyArgs = {
  updates: Array<Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_ZipArgs = {
  _set?: InputMaybe<Sottoscrizione_Zip_Set_Input>;
  where: Sottoscrizione_Zip_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Zip_By_PkArgs = {
  _set?: InputMaybe<Sottoscrizione_Zip_Set_Input>;
  pk_columns: Sottoscrizione_Zip_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sottoscrizione_Zip_ManyArgs = {
  updates: Array<Sottoscrizione_Zip_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging__Stato_SottoscrizioneArgs = {
  _set?: InputMaybe<Staging__Stato_Sottoscrizione_Set_Input>;
  where: Staging__Stato_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging__Stato_Sottoscrizione_By_PkArgs = {
  _set?: InputMaybe<Staging__Stato_Sottoscrizione_Set_Input>;
  pk_columns: Staging__Stato_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging__Stato_Sottoscrizione_ManyArgs = {
  updates: Array<Staging__Stato_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Azione_SottoscrizioneArgs = {
  _append?: InputMaybe<Staging_Azione_Sottoscrizione_Append_Input>;
  _delete_at_path?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_Key_Input>;
  _inc?: InputMaybe<Staging_Azione_Sottoscrizione_Inc_Input>;
  _prepend?: InputMaybe<Staging_Azione_Sottoscrizione_Prepend_Input>;
  _set?: InputMaybe<Staging_Azione_Sottoscrizione_Set_Input>;
  where: Staging_Azione_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Azione_Sottoscrizione_By_PkArgs = {
  _append?: InputMaybe<Staging_Azione_Sottoscrizione_Append_Input>;
  _delete_at_path?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_Key_Input>;
  _inc?: InputMaybe<Staging_Azione_Sottoscrizione_Inc_Input>;
  _prepend?: InputMaybe<Staging_Azione_Sottoscrizione_Prepend_Input>;
  _set?: InputMaybe<Staging_Azione_Sottoscrizione_Set_Input>;
  pk_columns: Staging_Azione_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Azione_Sottoscrizione_ManyArgs = {
  updates: Array<Staging_Azione_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Gestore_LottoArgs = {
  _set?: InputMaybe<Staging_Gestore_Lotto_Set_Input>;
  where: Staging_Gestore_Lotto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Gestore_Lotto_By_PkArgs = {
  _set?: InputMaybe<Staging_Gestore_Lotto_Set_Input>;
  pk_columns: Staging_Gestore_Lotto_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Gestore_Lotto_ManyArgs = {
  updates: Array<Staging_Gestore_Lotto_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Gestore_SottoscrizioneArgs = {
  _set?: InputMaybe<Staging_Gestore_Sottoscrizione_Set_Input>;
  where: Staging_Gestore_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Gestore_Sottoscrizione_By_PkArgs = {
  _set?: InputMaybe<Staging_Gestore_Sottoscrizione_Set_Input>;
  pk_columns: Staging_Gestore_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Gestore_Sottoscrizione_ManyArgs = {
  updates: Array<Staging_Gestore_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_LogArgs = {
  _append?: InputMaybe<Staging_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Staging_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Staging_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Staging_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Staging_Log_Prepend_Input>;
  _set?: InputMaybe<Staging_Log_Set_Input>;
  where: Staging_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Log_By_PkArgs = {
  _append?: InputMaybe<Staging_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Staging_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Staging_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Staging_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Staging_Log_Prepend_Input>;
  _set?: InputMaybe<Staging_Log_Set_Input>;
  pk_columns: Staging_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Log_ManyArgs = {
  updates: Array<Staging_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_LottoArgs = {
  _set?: InputMaybe<Staging_Lotto_Set_Input>;
  where: Staging_Lotto_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Lotto_By_PkArgs = {
  _set?: InputMaybe<Staging_Lotto_Set_Input>;
  pk_columns: Staging_Lotto_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Lotto_ManyArgs = {
  updates: Array<Staging_Lotto_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Mv_Refresh_StateArgs = {
  _set?: InputMaybe<Staging_Mv_Refresh_State_Set_Input>;
  where: Staging_Mv_Refresh_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Mv_Refresh_State_By_PkArgs = {
  _set?: InputMaybe<Staging_Mv_Refresh_State_Set_Input>;
  pk_columns: Staging_Mv_Refresh_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Mv_Refresh_State_ManyArgs = {
  updates: Array<Staging_Mv_Refresh_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_SottoscrizioneArgs = {
  _append?: InputMaybe<Staging_Sottoscrizione_Append_Input>;
  _delete_at_path?: InputMaybe<Staging_Sottoscrizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Staging_Sottoscrizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Staging_Sottoscrizione_Delete_Key_Input>;
  _prepend?: InputMaybe<Staging_Sottoscrizione_Prepend_Input>;
  _set?: InputMaybe<Staging_Sottoscrizione_Set_Input>;
  where: Staging_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Sottoscrizione_By_PkArgs = {
  _append?: InputMaybe<Staging_Sottoscrizione_Append_Input>;
  _delete_at_path?: InputMaybe<Staging_Sottoscrizione_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Staging_Sottoscrizione_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Staging_Sottoscrizione_Delete_Key_Input>;
  _prepend?: InputMaybe<Staging_Sottoscrizione_Prepend_Input>;
  _set?: InputMaybe<Staging_Sottoscrizione_Set_Input>;
  pk_columns: Staging_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Staging_Sottoscrizione_ManyArgs = {
  updates: Array<Staging_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Storage_Trigger_Debug_LogArgs = {
  _append?: InputMaybe<Storage_Trigger_Debug_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Storage_Trigger_Debug_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Storage_Trigger_Debug_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Storage_Trigger_Debug_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Storage_Trigger_Debug_Log_Inc_Input>;
  _prepend?: InputMaybe<Storage_Trigger_Debug_Log_Prepend_Input>;
  _set?: InputMaybe<Storage_Trigger_Debug_Log_Set_Input>;
  where: Storage_Trigger_Debug_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Storage_Trigger_Debug_Log_By_PkArgs = {
  _append?: InputMaybe<Storage_Trigger_Debug_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Storage_Trigger_Debug_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Storage_Trigger_Debug_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Storage_Trigger_Debug_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Storage_Trigger_Debug_Log_Inc_Input>;
  _prepend?: InputMaybe<Storage_Trigger_Debug_Log_Prepend_Input>;
  _set?: InputMaybe<Storage_Trigger_Debug_Log_Set_Input>;
  pk_columns: Storage_Trigger_Debug_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Storage_Trigger_Debug_Log_ManyArgs = {
  updates: Array<Storage_Trigger_Debug_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Storage_Trigger_Error_LogArgs = {
  _append?: InputMaybe<Storage_Trigger_Error_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Storage_Trigger_Error_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Storage_Trigger_Error_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Storage_Trigger_Error_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Storage_Trigger_Error_Log_Inc_Input>;
  _prepend?: InputMaybe<Storage_Trigger_Error_Log_Prepend_Input>;
  _set?: InputMaybe<Storage_Trigger_Error_Log_Set_Input>;
  where: Storage_Trigger_Error_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Storage_Trigger_Error_Log_By_PkArgs = {
  _append?: InputMaybe<Storage_Trigger_Error_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Storage_Trigger_Error_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Storage_Trigger_Error_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Storage_Trigger_Error_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Storage_Trigger_Error_Log_Inc_Input>;
  _prepend?: InputMaybe<Storage_Trigger_Error_Log_Prepend_Input>;
  _set?: InputMaybe<Storage_Trigger_Error_Log_Set_Input>;
  pk_columns: Storage_Trigger_Error_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Storage_Trigger_Error_Log_ManyArgs = {
  updates: Array<Storage_Trigger_Error_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Storico_SottoscrizioneArgs = {
  _set?: InputMaybe<Storico_Sottoscrizione_Set_Input>;
  where: Storico_Sottoscrizione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Storico_Sottoscrizione_By_PkArgs = {
  _set?: InputMaybe<Storico_Sottoscrizione_Set_Input>;
  pk_columns: Storico_Sottoscrizione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Storico_Sottoscrizione_ManyArgs = {
  updates: Array<Storico_Sottoscrizione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Translate_MapperArgs = {
  _set?: InputMaybe<Translate_Mapper_Set_Input>;
  where: Translate_Mapper_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Translate_Mapper_By_PkArgs = {
  _set?: InputMaybe<Translate_Mapper_Set_Input>;
  pk_columns: Translate_Mapper_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Translate_Mapper_ManyArgs = {
  updates: Array<Translate_Mapper_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_CittaArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Citta_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Citta_Set_Input>;
  where: Unita_Amministrativa_Citta_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Citta_By_PkArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Citta_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Citta_Set_Input>;
  pk_columns: Unita_Amministrativa_Citta_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Citta_ManyArgs = {
  updates: Array<Unita_Amministrativa_Citta_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_NazioneArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Nazione_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Nazione_Set_Input>;
  where: Unita_Amministrativa_Nazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Nazione_By_PkArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Nazione_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Nazione_Set_Input>;
  pk_columns: Unita_Amministrativa_Nazione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Nazione_ManyArgs = {
  updates: Array<Unita_Amministrativa_Nazione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_ProvinciaArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Provincia_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Provincia_Set_Input>;
  where: Unita_Amministrativa_Provincia_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Provincia_By_PkArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Provincia_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Provincia_Set_Input>;
  pk_columns: Unita_Amministrativa_Provincia_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Provincia_ManyArgs = {
  updates: Array<Unita_Amministrativa_Provincia_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_RegioneArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Regione_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Regione_Set_Input>;
  where: Unita_Amministrativa_Regione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Regione_By_PkArgs = {
  _inc?: InputMaybe<Unita_Amministrativa_Regione_Inc_Input>;
  _set?: InputMaybe<Unita_Amministrativa_Regione_Set_Input>;
  pk_columns: Unita_Amministrativa_Regione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unita_Amministrativa_Regione_ManyArgs = {
  updates: Array<Unita_Amministrativa_Regione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_AssociazioneArgs = {
  _set?: InputMaybe<White_Label_Associazione_Set_Input>;
  where: White_Label_Associazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Associazione_By_PkArgs = {
  _set?: InputMaybe<White_Label_Associazione_Set_Input>;
  pk_columns: White_Label_Associazione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Associazione_ManyArgs = {
  updates: Array<White_Label_Associazione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_ConfigurazioneArgs = {
  _set?: InputMaybe<White_Label_Configurazione_Set_Input>;
  where: White_Label_Configurazione_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Configurazione_By_PkArgs = {
  _set?: InputMaybe<White_Label_Configurazione_Set_Input>;
  pk_columns: White_Label_Configurazione_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Configurazione_ManyArgs = {
  updates: Array<White_Label_Configurazione_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_GestoreArgs = {
  _set?: InputMaybe<White_Label_Gestore_Set_Input>;
  where: White_Label_Gestore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Gestore_By_PkArgs = {
  _set?: InputMaybe<White_Label_Gestore_Set_Input>;
  pk_columns: White_Label_Gestore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Gestore_ManyArgs = {
  updates: Array<White_Label_Gestore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_IdpArgs = {
  _set?: InputMaybe<White_Label_Idp_Set_Input>;
  where: White_Label_Idp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Idp_By_PkArgs = {
  _set?: InputMaybe<White_Label_Idp_Set_Input>;
  pk_columns: White_Label_Idp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_White_Label_Idp_ManyArgs = {
  updates: Array<White_Label_Idp_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "persona" */
export type Persona = {
  __typename?: 'persona';
  /** An array relationship */
  cer_destinazioni_contributi: Array<Cer_Destinazione_Contributo>;
  /** An aggregate relationship */
  cer_destinazioni_contributi_aggregate: Cer_Destinazione_Contributo_Aggregate;
  /** An array relationship */
  cers_promotore: Array<Cer>;
  /** An aggregate relationship */
  cers_promotore_aggregate: Cer_Aggregate;
  /** An array relationship */
  cers_societa: Array<Cer>;
  /** An aggregate relationship */
  cers_societa_aggregate: Cer_Aggregate;
  /** An object relationship */
  citta_nascita?: Maybe<Unita_Amministrativa_Citta>;
  citta_nascita_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  codice_ateco?: Maybe<Anagrafica_Codice_Ateco>;
  codice_ateco_id?: Maybe<Scalars['String']['output']>;
  codice_fiscale?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  contatti: Array<Persona_Contatto>;
  /** An aggregate relationship */
  contatti_aggregate: Persona_Contatto_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  data_nascita?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  forma_giuridica?: Maybe<Anagrafica_Forma_Giuridica>;
  /** An object relationship */
  forma_giuridica_cer?: Maybe<Anagrafica_Forma_Giuridica_Cer>;
  forma_giuridica_cer_id?: Maybe<Scalars['uuid']['output']>;
  forma_giuridica_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indirizzo?: Maybe<Indirizzo>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  intestatario_consumi: Array<Asset_Consumo>;
  /** An aggregate relationship */
  intestatario_consumi_aggregate: Asset_Consumo_Aggregate;
  /** An array relationship */
  intestatario_produzioni: Array<Asset_Produzione>;
  /** An aggregate relationship */
  intestatario_produzioni_aggregate: Asset_Produzione_Aggregate;
  /** An object relationship */
  nazione_nascita?: Maybe<Unita_Amministrativa_Nazione>;
  nazione_nascita_id?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  partita_iva?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  profili: Array<Profilo>;
  /** An aggregate relationship */
  profili_aggregate: Profilo_Aggregate;
  ragione_sociale?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  rappresentante_legale?: Maybe<Persona>;
  rappresentante_legale_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  rappresentate: Array<Persona>;
  /** An aggregate relationship */
  rappresentate_aggregate: Persona_Aggregate;
  sesso?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tipo_promotore?: Maybe<Anagrafica_Tipo_Promotore>;
  tipo_promotore_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tipologia_rappresentante?: Maybe<Anagrafica_Tipologia_Rappresentante>;
  tipologia_rappresentante_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "persona" */
export type PersonaCer_Destinazioni_ContributiArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaCer_Destinazioni_Contributi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaCers_PromotoreArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaCers_Promotore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaCers_SocietaArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaCers_Societa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaContattiArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaContatti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaIntestatario_ConsumiArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaIntestatario_Consumi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaIntestatario_ProduzioniArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaIntestatario_Produzioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaProfiliArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaProfili_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaRappresentateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};


/** columns and relationships of "persona" */
export type PersonaRappresentate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};

/** aggregated selection of "persona" */
export type Persona_Aggregate = {
  __typename?: 'persona_aggregate';
  aggregate?: Maybe<Persona_Aggregate_Fields>;
  nodes: Array<Persona>;
};

export type Persona_Aggregate_Bool_Exp = {
  count?: InputMaybe<Persona_Aggregate_Bool_Exp_Count>;
};

export type Persona_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Persona_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Persona_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "persona" */
export type Persona_Aggregate_Fields = {
  __typename?: 'persona_aggregate_fields';
  avg?: Maybe<Persona_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Persona_Max_Fields>;
  min?: Maybe<Persona_Min_Fields>;
  stddev?: Maybe<Persona_Stddev_Fields>;
  stddev_pop?: Maybe<Persona_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Persona_Stddev_Samp_Fields>;
  sum?: Maybe<Persona_Sum_Fields>;
  var_pop?: Maybe<Persona_Var_Pop_Fields>;
  var_samp?: Maybe<Persona_Var_Samp_Fields>;
  variance?: Maybe<Persona_Variance_Fields>;
};


/** aggregate fields of "persona" */
export type Persona_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Persona_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "persona" */
export type Persona_Aggregate_Order_By = {
  avg?: InputMaybe<Persona_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Persona_Max_Order_By>;
  min?: InputMaybe<Persona_Min_Order_By>;
  stddev?: InputMaybe<Persona_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Persona_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Persona_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Persona_Sum_Order_By>;
  var_pop?: InputMaybe<Persona_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Persona_Var_Samp_Order_By>;
  variance?: InputMaybe<Persona_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "persona" */
export type Persona_Arr_Rel_Insert_Input = {
  data: Array<Persona_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Persona_On_Conflict>;
};

/** aggregate avg on columns */
export type Persona_Avg_Fields = {
  __typename?: 'persona_avg_fields';
  citta_nascita_id?: Maybe<Scalars['Float']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "persona" */
export type Persona_Avg_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "persona". All fields are combined with a logical 'AND'. */
export type Persona_Bool_Exp = {
  _and?: InputMaybe<Array<Persona_Bool_Exp>>;
  _not?: InputMaybe<Persona_Bool_Exp>;
  _or?: InputMaybe<Array<Persona_Bool_Exp>>;
  cer_destinazioni_contributi?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  cer_destinazioni_contributi_aggregate?: InputMaybe<Cer_Destinazione_Contributo_Aggregate_Bool_Exp>;
  cers_promotore?: InputMaybe<Cer_Bool_Exp>;
  cers_promotore_aggregate?: InputMaybe<Cer_Aggregate_Bool_Exp>;
  cers_societa?: InputMaybe<Cer_Bool_Exp>;
  cers_societa_aggregate?: InputMaybe<Cer_Aggregate_Bool_Exp>;
  citta_nascita?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  citta_nascita_id?: InputMaybe<Bigint_Comparison_Exp>;
  codice_ateco?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
  codice_ateco_id?: InputMaybe<String_Comparison_Exp>;
  codice_fiscale?: InputMaybe<String_Comparison_Exp>;
  cognome?: InputMaybe<String_Comparison_Exp>;
  contatti?: InputMaybe<Persona_Contatto_Bool_Exp>;
  contatti_aggregate?: InputMaybe<Persona_Contatto_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_nascita?: InputMaybe<Timestamptz_Comparison_Exp>;
  forma_giuridica?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
  forma_giuridica_cer?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
  forma_giuridica_cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  forma_giuridica_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indirizzo?: InputMaybe<Indirizzo_Bool_Exp>;
  indirizzo_id?: InputMaybe<Uuid_Comparison_Exp>;
  intestatario_consumi?: InputMaybe<Asset_Consumo_Bool_Exp>;
  intestatario_consumi_aggregate?: InputMaybe<Asset_Consumo_Aggregate_Bool_Exp>;
  intestatario_produzioni?: InputMaybe<Asset_Produzione_Bool_Exp>;
  intestatario_produzioni_aggregate?: InputMaybe<Asset_Produzione_Aggregate_Bool_Exp>;
  nazione_nascita?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
  nazione_nascita_id?: InputMaybe<Int_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  partita_iva?: InputMaybe<String_Comparison_Exp>;
  profili?: InputMaybe<Profilo_Bool_Exp>;
  profili_aggregate?: InputMaybe<Profilo_Aggregate_Bool_Exp>;
  ragione_sociale?: InputMaybe<String_Comparison_Exp>;
  rappresentante_legale?: InputMaybe<Persona_Bool_Exp>;
  rappresentante_legale_id?: InputMaybe<Uuid_Comparison_Exp>;
  rappresentate?: InputMaybe<Persona_Bool_Exp>;
  rappresentate_aggregate?: InputMaybe<Persona_Aggregate_Bool_Exp>;
  sesso?: InputMaybe<String_Comparison_Exp>;
  tipo_promotore?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
  tipo_promotore_id?: InputMaybe<Uuid_Comparison_Exp>;
  tipologia_rappresentante?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
  tipologia_rappresentante_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "persona" */
export enum Persona_Constraint {
  /** unique or primary key constraint on columns "id" */
  PersonaPkey = 'persona_pkey'
}

/** columns and relationships of "persona_contatto" */
export type Persona_Contatto = {
  __typename?: 'persona_contatto';
  /** An object relationship */
  contatto: Contatto;
  contatto_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  persona: Persona;
  persona_id: Scalars['uuid']['output'];
  principale: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "persona_contatto" */
export type Persona_Contatto_Aggregate = {
  __typename?: 'persona_contatto_aggregate';
  aggregate?: Maybe<Persona_Contatto_Aggregate_Fields>;
  nodes: Array<Persona_Contatto>;
};

export type Persona_Contatto_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Persona_Contatto_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Persona_Contatto_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Persona_Contatto_Aggregate_Bool_Exp_Count>;
};

export type Persona_Contatto_Aggregate_Bool_Exp_Bool_And = {
  arguments: Persona_Contatto_Select_Column_Persona_Contatto_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Persona_Contatto_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Persona_Contatto_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Persona_Contatto_Select_Column_Persona_Contatto_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Persona_Contatto_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Persona_Contatto_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Persona_Contatto_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "persona_contatto" */
export type Persona_Contatto_Aggregate_Fields = {
  __typename?: 'persona_contatto_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Persona_Contatto_Max_Fields>;
  min?: Maybe<Persona_Contatto_Min_Fields>;
};


/** aggregate fields of "persona_contatto" */
export type Persona_Contatto_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "persona_contatto" */
export type Persona_Contatto_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Persona_Contatto_Max_Order_By>;
  min?: InputMaybe<Persona_Contatto_Min_Order_By>;
};

/** input type for inserting array relation for remote table "persona_contatto" */
export type Persona_Contatto_Arr_Rel_Insert_Input = {
  data: Array<Persona_Contatto_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Persona_Contatto_On_Conflict>;
};

/** Boolean expression to filter rows from the table "persona_contatto". All fields are combined with a logical 'AND'. */
export type Persona_Contatto_Bool_Exp = {
  _and?: InputMaybe<Array<Persona_Contatto_Bool_Exp>>;
  _not?: InputMaybe<Persona_Contatto_Bool_Exp>;
  _or?: InputMaybe<Array<Persona_Contatto_Bool_Exp>>;
  contatto?: InputMaybe<Contatto_Bool_Exp>;
  contatto_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  persona?: InputMaybe<Persona_Bool_Exp>;
  persona_id?: InputMaybe<Uuid_Comparison_Exp>;
  principale?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "persona_contatto" */
export enum Persona_Contatto_Constraint {
  /** unique or primary key constraint on columns "id" */
  PersonaContattoPkey = 'persona_contatto_pkey'
}

/** input type for inserting data into table "persona_contatto" */
export type Persona_Contatto_Insert_Input = {
  contatto?: InputMaybe<Contatto_Obj_Rel_Insert_Input>;
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  persona?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  principale?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Persona_Contatto_Max_Fields = {
  __typename?: 'persona_contatto_max_fields';
  contatto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "persona_contatto" */
export type Persona_Contatto_Max_Order_By = {
  contatto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  persona_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Persona_Contatto_Min_Fields = {
  __typename?: 'persona_contatto_min_fields';
  contatto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "persona_contatto" */
export type Persona_Contatto_Min_Order_By = {
  contatto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  persona_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "persona_contatto" */
export type Persona_Contatto_Mutation_Response = {
  __typename?: 'persona_contatto_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Persona_Contatto>;
};

/** on_conflict condition type for table "persona_contatto" */
export type Persona_Contatto_On_Conflict = {
  constraint: Persona_Contatto_Constraint;
  update_columns?: Array<Persona_Contatto_Update_Column>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};

/** Ordering options when selecting data from "persona_contatto". */
export type Persona_Contatto_Order_By = {
  contatto?: InputMaybe<Contatto_Order_By>;
  contatto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  persona?: InputMaybe<Persona_Order_By>;
  persona_id?: InputMaybe<Order_By>;
  principale?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: persona_contatto */
export type Persona_Contatto_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "persona_contatto" */
export enum Persona_Contatto_Select_Column {
  /** column name */
  ContattoId = 'contatto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PersonaId = 'persona_id',
  /** column name */
  Principale = 'principale',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "persona_contatto_aggregate_bool_exp_bool_and_arguments_columns" columns of table "persona_contatto" */
export enum Persona_Contatto_Select_Column_Persona_Contatto_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Principale = 'principale'
}

/** select "persona_contatto_aggregate_bool_exp_bool_or_arguments_columns" columns of table "persona_contatto" */
export enum Persona_Contatto_Select_Column_Persona_Contatto_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Principale = 'principale'
}

/** input type for updating data in table "persona_contatto" */
export type Persona_Contatto_Set_Input = {
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  principale?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "persona_contatto" */
export type Persona_Contatto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Persona_Contatto_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Persona_Contatto_Stream_Cursor_Value_Input = {
  contatto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  principale?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "persona_contatto" */
export enum Persona_Contatto_Update_Column {
  /** column name */
  ContattoId = 'contatto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PersonaId = 'persona_id',
  /** column name */
  Principale = 'principale',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Persona_Contatto_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Persona_Contatto_Set_Input>;
  /** filter the rows which have to be updated */
  where: Persona_Contatto_Bool_Exp;
};

/** input type for incrementing numeric columns in table "persona" */
export type Persona_Inc_Input = {
  citta_nascita_id?: InputMaybe<Scalars['bigint']['input']>;
  nazione_nascita_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "persona" */
export type Persona_Insert_Input = {
  cer_destinazioni_contributi?: InputMaybe<Cer_Destinazione_Contributo_Arr_Rel_Insert_Input>;
  cers_promotore?: InputMaybe<Cer_Arr_Rel_Insert_Input>;
  cers_societa?: InputMaybe<Cer_Arr_Rel_Insert_Input>;
  citta_nascita?: InputMaybe<Unita_Amministrativa_Citta_Obj_Rel_Insert_Input>;
  citta_nascita_id?: InputMaybe<Scalars['bigint']['input']>;
  codice_ateco?: InputMaybe<Anagrafica_Codice_Ateco_Obj_Rel_Insert_Input>;
  codice_ateco_id?: InputMaybe<Scalars['String']['input']>;
  codice_fiscale?: InputMaybe<Scalars['String']['input']>;
  cognome?: InputMaybe<Scalars['String']['input']>;
  contatti?: InputMaybe<Persona_Contatto_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_nascita?: InputMaybe<Scalars['timestamptz']['input']>;
  forma_giuridica?: InputMaybe<Anagrafica_Forma_Giuridica_Obj_Rel_Insert_Input>;
  forma_giuridica_cer?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Obj_Rel_Insert_Input>;
  forma_giuridica_cer_id?: InputMaybe<Scalars['uuid']['input']>;
  forma_giuridica_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indirizzo?: InputMaybe<Indirizzo_Obj_Rel_Insert_Input>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario_consumi?: InputMaybe<Asset_Consumo_Arr_Rel_Insert_Input>;
  intestatario_produzioni?: InputMaybe<Asset_Produzione_Arr_Rel_Insert_Input>;
  nazione_nascita?: InputMaybe<Unita_Amministrativa_Nazione_Obj_Rel_Insert_Input>;
  nazione_nascita_id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  partita_iva?: InputMaybe<Scalars['String']['input']>;
  profili?: InputMaybe<Profilo_Arr_Rel_Insert_Input>;
  ragione_sociale?: InputMaybe<Scalars['String']['input']>;
  rappresentante_legale?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  rappresentante_legale_id?: InputMaybe<Scalars['uuid']['input']>;
  rappresentate?: InputMaybe<Persona_Arr_Rel_Insert_Input>;
  sesso?: InputMaybe<Scalars['String']['input']>;
  tipo_promotore?: InputMaybe<Anagrafica_Tipo_Promotore_Obj_Rel_Insert_Input>;
  tipo_promotore_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_rappresentante?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Obj_Rel_Insert_Input>;
  tipologia_rappresentante_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Persona_Max_Fields = {
  __typename?: 'persona_max_fields';
  citta_nascita_id?: Maybe<Scalars['bigint']['output']>;
  codice_ateco_id?: Maybe<Scalars['String']['output']>;
  codice_fiscale?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_nascita?: Maybe<Scalars['timestamptz']['output']>;
  forma_giuridica_cer_id?: Maybe<Scalars['uuid']['output']>;
  forma_giuridica_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  partita_iva?: Maybe<Scalars['String']['output']>;
  ragione_sociale?: Maybe<Scalars['String']['output']>;
  rappresentante_legale_id?: Maybe<Scalars['uuid']['output']>;
  sesso?: Maybe<Scalars['String']['output']>;
  tipo_promotore_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_rappresentante_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "persona" */
export type Persona_Max_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  codice_ateco_id?: InputMaybe<Order_By>;
  codice_fiscale?: InputMaybe<Order_By>;
  cognome?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_nascita?: InputMaybe<Order_By>;
  forma_giuridica_cer_id?: InputMaybe<Order_By>;
  forma_giuridica_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  partita_iva?: InputMaybe<Order_By>;
  ragione_sociale?: InputMaybe<Order_By>;
  rappresentante_legale_id?: InputMaybe<Order_By>;
  sesso?: InputMaybe<Order_By>;
  tipo_promotore_id?: InputMaybe<Order_By>;
  tipologia_rappresentante_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Persona_Min_Fields = {
  __typename?: 'persona_min_fields';
  citta_nascita_id?: Maybe<Scalars['bigint']['output']>;
  codice_ateco_id?: Maybe<Scalars['String']['output']>;
  codice_fiscale?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_nascita?: Maybe<Scalars['timestamptz']['output']>;
  forma_giuridica_cer_id?: Maybe<Scalars['uuid']['output']>;
  forma_giuridica_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indirizzo_id?: Maybe<Scalars['uuid']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  partita_iva?: Maybe<Scalars['String']['output']>;
  ragione_sociale?: Maybe<Scalars['String']['output']>;
  rappresentante_legale_id?: Maybe<Scalars['uuid']['output']>;
  sesso?: Maybe<Scalars['String']['output']>;
  tipo_promotore_id?: Maybe<Scalars['uuid']['output']>;
  tipologia_rappresentante_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "persona" */
export type Persona_Min_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  codice_ateco_id?: InputMaybe<Order_By>;
  codice_fiscale?: InputMaybe<Order_By>;
  cognome?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_nascita?: InputMaybe<Order_By>;
  forma_giuridica_cer_id?: InputMaybe<Order_By>;
  forma_giuridica_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  partita_iva?: InputMaybe<Order_By>;
  ragione_sociale?: InputMaybe<Order_By>;
  rappresentante_legale_id?: InputMaybe<Order_By>;
  sesso?: InputMaybe<Order_By>;
  tipo_promotore_id?: InputMaybe<Order_By>;
  tipologia_rappresentante_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "persona" */
export type Persona_Mutation_Response = {
  __typename?: 'persona_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Persona>;
};

/** input type for inserting object relation for remote table "persona" */
export type Persona_Obj_Rel_Insert_Input = {
  data: Persona_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Persona_On_Conflict>;
};

/** on_conflict condition type for table "persona" */
export type Persona_On_Conflict = {
  constraint: Persona_Constraint;
  update_columns?: Array<Persona_Update_Column>;
  where?: InputMaybe<Persona_Bool_Exp>;
};

/** Ordering options when selecting data from "persona". */
export type Persona_Order_By = {
  cer_destinazioni_contributi_aggregate?: InputMaybe<Cer_Destinazione_Contributo_Aggregate_Order_By>;
  cers_promotore_aggregate?: InputMaybe<Cer_Aggregate_Order_By>;
  cers_societa_aggregate?: InputMaybe<Cer_Aggregate_Order_By>;
  citta_nascita?: InputMaybe<Unita_Amministrativa_Citta_Order_By>;
  citta_nascita_id?: InputMaybe<Order_By>;
  codice_ateco?: InputMaybe<Anagrafica_Codice_Ateco_Order_By>;
  codice_ateco_id?: InputMaybe<Order_By>;
  codice_fiscale?: InputMaybe<Order_By>;
  cognome?: InputMaybe<Order_By>;
  contatti_aggregate?: InputMaybe<Persona_Contatto_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_nascita?: InputMaybe<Order_By>;
  forma_giuridica?: InputMaybe<Anagrafica_Forma_Giuridica_Order_By>;
  forma_giuridica_cer?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Order_By>;
  forma_giuridica_cer_id?: InputMaybe<Order_By>;
  forma_giuridica_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indirizzo?: InputMaybe<Indirizzo_Order_By>;
  indirizzo_id?: InputMaybe<Order_By>;
  intestatario_consumi_aggregate?: InputMaybe<Asset_Consumo_Aggregate_Order_By>;
  intestatario_produzioni_aggregate?: InputMaybe<Asset_Produzione_Aggregate_Order_By>;
  nazione_nascita?: InputMaybe<Unita_Amministrativa_Nazione_Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  partita_iva?: InputMaybe<Order_By>;
  profili_aggregate?: InputMaybe<Profilo_Aggregate_Order_By>;
  ragione_sociale?: InputMaybe<Order_By>;
  rappresentante_legale?: InputMaybe<Persona_Order_By>;
  rappresentante_legale_id?: InputMaybe<Order_By>;
  rappresentate_aggregate?: InputMaybe<Persona_Aggregate_Order_By>;
  sesso?: InputMaybe<Order_By>;
  tipo_promotore?: InputMaybe<Anagrafica_Tipo_Promotore_Order_By>;
  tipo_promotore_id?: InputMaybe<Order_By>;
  tipologia_rappresentante?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Order_By>;
  tipologia_rappresentante_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: persona */
export type Persona_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "persona" */
export enum Persona_Select_Column {
  /** column name */
  CittaNascitaId = 'citta_nascita_id',
  /** column name */
  CodiceAtecoId = 'codice_ateco_id',
  /** column name */
  CodiceFiscale = 'codice_fiscale',
  /** column name */
  Cognome = 'cognome',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataNascita = 'data_nascita',
  /** column name */
  FormaGiuridicaCerId = 'forma_giuridica_cer_id',
  /** column name */
  FormaGiuridicaId = 'forma_giuridica_id',
  /** column name */
  Id = 'id',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  NazioneNascitaId = 'nazione_nascita_id',
  /** column name */
  Nome = 'nome',
  /** column name */
  PartitaIva = 'partita_iva',
  /** column name */
  RagioneSociale = 'ragione_sociale',
  /** column name */
  RappresentanteLegaleId = 'rappresentante_legale_id',
  /** column name */
  Sesso = 'sesso',
  /** column name */
  TipoPromotoreId = 'tipo_promotore_id',
  /** column name */
  TipologiaRappresentanteId = 'tipologia_rappresentante_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "persona" */
export type Persona_Set_Input = {
  citta_nascita_id?: InputMaybe<Scalars['bigint']['input']>;
  codice_ateco_id?: InputMaybe<Scalars['String']['input']>;
  codice_fiscale?: InputMaybe<Scalars['String']['input']>;
  cognome?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_nascita?: InputMaybe<Scalars['timestamptz']['input']>;
  forma_giuridica_cer_id?: InputMaybe<Scalars['uuid']['input']>;
  forma_giuridica_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  nazione_nascita_id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  partita_iva?: InputMaybe<Scalars['String']['input']>;
  ragione_sociale?: InputMaybe<Scalars['String']['input']>;
  rappresentante_legale_id?: InputMaybe<Scalars['uuid']['input']>;
  sesso?: InputMaybe<Scalars['String']['input']>;
  tipo_promotore_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_rappresentante_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Persona_Stddev_Fields = {
  __typename?: 'persona_stddev_fields';
  citta_nascita_id?: Maybe<Scalars['Float']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "persona" */
export type Persona_Stddev_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Persona_Stddev_Pop_Fields = {
  __typename?: 'persona_stddev_pop_fields';
  citta_nascita_id?: Maybe<Scalars['Float']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "persona" */
export type Persona_Stddev_Pop_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Persona_Stddev_Samp_Fields = {
  __typename?: 'persona_stddev_samp_fields';
  citta_nascita_id?: Maybe<Scalars['Float']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "persona" */
export type Persona_Stddev_Samp_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "persona" */
export type Persona_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Persona_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Persona_Stream_Cursor_Value_Input = {
  citta_nascita_id?: InputMaybe<Scalars['bigint']['input']>;
  codice_ateco_id?: InputMaybe<Scalars['String']['input']>;
  codice_fiscale?: InputMaybe<Scalars['String']['input']>;
  cognome?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_nascita?: InputMaybe<Scalars['timestamptz']['input']>;
  forma_giuridica_cer_id?: InputMaybe<Scalars['uuid']['input']>;
  forma_giuridica_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indirizzo_id?: InputMaybe<Scalars['uuid']['input']>;
  nazione_nascita_id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  partita_iva?: InputMaybe<Scalars['String']['input']>;
  ragione_sociale?: InputMaybe<Scalars['String']['input']>;
  rappresentante_legale_id?: InputMaybe<Scalars['uuid']['input']>;
  sesso?: InputMaybe<Scalars['String']['input']>;
  tipo_promotore_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_rappresentante_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Persona_Sum_Fields = {
  __typename?: 'persona_sum_fields';
  citta_nascita_id?: Maybe<Scalars['bigint']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "persona" */
export type Persona_Sum_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** update columns of table "persona" */
export enum Persona_Update_Column {
  /** column name */
  CittaNascitaId = 'citta_nascita_id',
  /** column name */
  CodiceAtecoId = 'codice_ateco_id',
  /** column name */
  CodiceFiscale = 'codice_fiscale',
  /** column name */
  Cognome = 'cognome',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataNascita = 'data_nascita',
  /** column name */
  FormaGiuridicaCerId = 'forma_giuridica_cer_id',
  /** column name */
  FormaGiuridicaId = 'forma_giuridica_id',
  /** column name */
  Id = 'id',
  /** column name */
  IndirizzoId = 'indirizzo_id',
  /** column name */
  NazioneNascitaId = 'nazione_nascita_id',
  /** column name */
  Nome = 'nome',
  /** column name */
  PartitaIva = 'partita_iva',
  /** column name */
  RagioneSociale = 'ragione_sociale',
  /** column name */
  RappresentanteLegaleId = 'rappresentante_legale_id',
  /** column name */
  Sesso = 'sesso',
  /** column name */
  TipoPromotoreId = 'tipo_promotore_id',
  /** column name */
  TipologiaRappresentanteId = 'tipologia_rappresentante_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Persona_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Persona_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Persona_Set_Input>;
  /** filter the rows which have to be updated */
  where: Persona_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Persona_Var_Pop_Fields = {
  __typename?: 'persona_var_pop_fields';
  citta_nascita_id?: Maybe<Scalars['Float']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "persona" */
export type Persona_Var_Pop_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Persona_Var_Samp_Fields = {
  __typename?: 'persona_var_samp_fields';
  citta_nascita_id?: Maybe<Scalars['Float']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "persona" */
export type Persona_Var_Samp_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Persona_Variance_Fields = {
  __typename?: 'persona_variance_fields';
  citta_nascita_id?: Maybe<Scalars['Float']['output']>;
  nazione_nascita_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "persona" */
export type Persona_Variance_Order_By = {
  citta_nascita_id?: InputMaybe<Order_By>;
  nazione_nascita_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "pnrr_documenti" */
export type Pnrr_Documenti = {
  __typename?: 'pnrr_documenti';
  /** An object relationship */
  asset_produzione: Asset_Produzione;
  asset_produzione_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  tipologia_documento?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "pnrr_documenti" */
export type Pnrr_DocumentiTipologia_DocumentoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "pnrr_documenti" */
export type Pnrr_Documenti_Aggregate = {
  __typename?: 'pnrr_documenti_aggregate';
  aggregate?: Maybe<Pnrr_Documenti_Aggregate_Fields>;
  nodes: Array<Pnrr_Documenti>;
};

export type Pnrr_Documenti_Aggregate_Bool_Exp = {
  count?: InputMaybe<Pnrr_Documenti_Aggregate_Bool_Exp_Count>;
};

export type Pnrr_Documenti_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pnrr_documenti" */
export type Pnrr_Documenti_Aggregate_Fields = {
  __typename?: 'pnrr_documenti_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Pnrr_Documenti_Max_Fields>;
  min?: Maybe<Pnrr_Documenti_Min_Fields>;
};


/** aggregate fields of "pnrr_documenti" */
export type Pnrr_Documenti_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pnrr_documenti" */
export type Pnrr_Documenti_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pnrr_Documenti_Max_Order_By>;
  min?: InputMaybe<Pnrr_Documenti_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Pnrr_Documenti_Append_Input = {
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "pnrr_documenti" */
export type Pnrr_Documenti_Arr_Rel_Insert_Input = {
  data: Array<Pnrr_Documenti_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pnrr_Documenti_On_Conflict>;
};

/** Boolean expression to filter rows from the table "pnrr_documenti". All fields are combined with a logical 'AND'. */
export type Pnrr_Documenti_Bool_Exp = {
  _and?: InputMaybe<Array<Pnrr_Documenti_Bool_Exp>>;
  _not?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
  _or?: InputMaybe<Array<Pnrr_Documenti_Bool_Exp>>;
  asset_produzione?: InputMaybe<Asset_Produzione_Bool_Exp>;
  asset_produzione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  tipologia_documento?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pnrr_documenti" */
export enum Pnrr_Documenti_Constraint {
  /** unique or primary key constraint on columns "id" */
  PnrrDocumentiPkey = 'pnrr_documenti_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Pnrr_Documenti_Delete_At_Path_Input = {
  tipologia_documento?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Pnrr_Documenti_Delete_Elem_Input = {
  tipologia_documento?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Pnrr_Documenti_Delete_Key_Input = {
  tipologia_documento?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "pnrr_documenti" */
export type Pnrr_Documenti_Insert_Input = {
  asset_produzione?: InputMaybe<Asset_Produzione_Obj_Rel_Insert_Input>;
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Pnrr_Documenti_Max_Fields = {
  __typename?: 'pnrr_documenti_max_fields';
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "pnrr_documenti" */
export type Pnrr_Documenti_Max_Order_By = {
  asset_produzione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pnrr_Documenti_Min_Fields = {
  __typename?: 'pnrr_documenti_min_fields';
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "pnrr_documenti" */
export type Pnrr_Documenti_Min_Order_By = {
  asset_produzione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pnrr_documenti" */
export type Pnrr_Documenti_Mutation_Response = {
  __typename?: 'pnrr_documenti_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pnrr_Documenti>;
};

/** on_conflict condition type for table "pnrr_documenti" */
export type Pnrr_Documenti_On_Conflict = {
  constraint: Pnrr_Documenti_Constraint;
  update_columns?: Array<Pnrr_Documenti_Update_Column>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};

/** Ordering options when selecting data from "pnrr_documenti". */
export type Pnrr_Documenti_Order_By = {
  asset_produzione?: InputMaybe<Asset_Produzione_Order_By>;
  asset_produzione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipologia_documento?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pnrr_documenti */
export type Pnrr_Documenti_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Pnrr_Documenti_Prepend_Input = {
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "pnrr_documenti" */
export enum Pnrr_Documenti_Select_Column {
  /** column name */
  AssetProduzioneId = 'asset_produzione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  TipologiaDocumento = 'tipologia_documento',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pnrr_documenti" */
export type Pnrr_Documenti_Set_Input = {
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "pnrr_documenti" */
export type Pnrr_Documenti_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pnrr_Documenti_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pnrr_Documenti_Stream_Cursor_Value_Input = {
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "pnrr_documenti" */
export enum Pnrr_Documenti_Update_Column {
  /** column name */
  AssetProduzioneId = 'asset_produzione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  TipologiaDocumento = 'tipologia_documento',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pnrr_Documenti_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Pnrr_Documenti_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Pnrr_Documenti_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Pnrr_Documenti_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Pnrr_Documenti_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Pnrr_Documenti_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pnrr_Documenti_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pnrr_Documenti_Bool_Exp;
};

/** columns and relationships of "preset" */
export type Preset = {
  __typename?: 'preset';
  auth_id?: Maybe<Scalars['String']['output']>;
  colonne: Scalars['jsonb']['output'];
  /** An object relationship */
  configurazione?: Maybe<White_Label_Configurazione>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  filtro?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  nome: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "preset" */
export type PresetColonneArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "preset" */
export type PresetFiltroArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "preset" */
export type Preset_Aggregate = {
  __typename?: 'preset_aggregate';
  aggregate?: Maybe<Preset_Aggregate_Fields>;
  nodes: Array<Preset>;
};

/** aggregate fields of "preset" */
export type Preset_Aggregate_Fields = {
  __typename?: 'preset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Preset_Max_Fields>;
  min?: Maybe<Preset_Min_Fields>;
};


/** aggregate fields of "preset" */
export type Preset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Preset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Preset_Append_Input = {
  colonne?: InputMaybe<Scalars['jsonb']['input']>;
  filtro?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "preset". All fields are combined with a logical 'AND'. */
export type Preset_Bool_Exp = {
  _and?: InputMaybe<Array<Preset_Bool_Exp>>;
  _not?: InputMaybe<Preset_Bool_Exp>;
  _or?: InputMaybe<Array<Preset_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  colonne?: InputMaybe<Jsonb_Comparison_Exp>;
  configurazione?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
  configurazione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  filtro?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "preset" */
export enum Preset_Constraint {
  /** unique or primary key constraint on columns "nome", "auth_id" */
  PresetAuthNomeKey = 'preset_auth_nome_key',
  /** unique or primary key constraint on columns "nome", "configurazione_id" */
  PresetConfigurazioneNomeKey = 'preset_configurazione_nome_key',
  /** unique or primary key constraint on columns "id" */
  PresetPkey = 'preset_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Preset_Delete_At_Path_Input = {
  colonne?: InputMaybe<Array<Scalars['String']['input']>>;
  filtro?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Preset_Delete_Elem_Input = {
  colonne?: InputMaybe<Scalars['Int']['input']>;
  filtro?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Preset_Delete_Key_Input = {
  colonne?: InputMaybe<Scalars['String']['input']>;
  filtro?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "preset" */
export type Preset_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  colonne?: InputMaybe<Scalars['jsonb']['input']>;
  configurazione?: InputMaybe<White_Label_Configurazione_Obj_Rel_Insert_Input>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filtro?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Preset_Max_Fields = {
  __typename?: 'preset_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Preset_Min_Fields = {
  __typename?: 'preset_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "preset" */
export type Preset_Mutation_Response = {
  __typename?: 'preset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Preset>;
};

/** on_conflict condition type for table "preset" */
export type Preset_On_Conflict = {
  constraint: Preset_Constraint;
  update_columns?: Array<Preset_Update_Column>;
  where?: InputMaybe<Preset_Bool_Exp>;
};

/** Ordering options when selecting data from "preset". */
export type Preset_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  colonne?: InputMaybe<Order_By>;
  configurazione?: InputMaybe<White_Label_Configurazione_Order_By>;
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  filtro?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: preset */
export type Preset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Preset_Prepend_Input = {
  colonne?: InputMaybe<Scalars['jsonb']['input']>;
  filtro?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "preset" */
export enum Preset_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  Colonne = 'colonne',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filtro = 'filtro',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "preset" */
export type Preset_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  colonne?: InputMaybe<Scalars['jsonb']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filtro?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "preset" */
export type Preset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Preset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Preset_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  colonne?: InputMaybe<Scalars['jsonb']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  filtro?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "preset" */
export enum Preset_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  Colonne = 'colonne',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filtro = 'filtro',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Preset_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Preset_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Preset_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Preset_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Preset_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Preset_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Preset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Preset_Bool_Exp;
};

/** columns and relationships of "profilo" */
export type Profilo = {
  __typename?: 'profilo';
  accetto_condizioni?: Maybe<Scalars['Boolean']['output']>;
  ambiti_attivita?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  amico_presentatore?: Maybe<Codice_Operatore>;
  anno_fondazione?: Maybe<Scalars['timestamptz']['output']>;
  area_geografica_operativa?: Maybe<Scalars['jsonb']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  certificazioni?: Maybe<Scalars['String']['output']>;
  codice_amico?: Maybe<Scalars['String']['output']>;
  codice_univoco: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  interessi_specifici?: Maybe<Scalars['jsonb']['output']>;
  numero_dipendenti?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  persona?: Maybe<Persona>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  referente_principale?: Maybe<Scalars['String']['output']>;
  ruolo_referente?: Maybe<Scalars['String']['output']>;
  show_accesso_pro?: Maybe<Scalars['Boolean']['output']>;
  sito_web?: Maybe<Scalars['String']['output']>;
  target_clienti?: Maybe<Scalars['jsonb']['output']>;
  tipologia?: Maybe<_Tipologia_Profilo_Enum>;
  /** An object relationship */
  tipologia_profilo?: Maybe<_Tipologia_Profilo>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  utente?: Maybe<Auth_User_Entity>;
};


/** columns and relationships of "profilo" */
export type ProfiloAmbiti_AttivitaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "profilo" */
export type ProfiloArea_Geografica_OperativaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "profilo" */
export type ProfiloInteressi_SpecificiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "profilo" */
export type ProfiloTarget_ClientiArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "profilo" */
export type Profilo_Aggregate = {
  __typename?: 'profilo_aggregate';
  aggregate?: Maybe<Profilo_Aggregate_Fields>;
  nodes: Array<Profilo>;
};

export type Profilo_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Profilo_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Profilo_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Profilo_Aggregate_Bool_Exp_Count>;
};

export type Profilo_Aggregate_Bool_Exp_Bool_And = {
  arguments: Profilo_Select_Column_Profilo_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Profilo_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Profilo_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Profilo_Select_Column_Profilo_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Profilo_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Profilo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Profilo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Profilo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "profilo" */
export type Profilo_Aggregate_Fields = {
  __typename?: 'profilo_aggregate_fields';
  avg?: Maybe<Profilo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Profilo_Max_Fields>;
  min?: Maybe<Profilo_Min_Fields>;
  stddev?: Maybe<Profilo_Stddev_Fields>;
  stddev_pop?: Maybe<Profilo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profilo_Stddev_Samp_Fields>;
  sum?: Maybe<Profilo_Sum_Fields>;
  var_pop?: Maybe<Profilo_Var_Pop_Fields>;
  var_samp?: Maybe<Profilo_Var_Samp_Fields>;
  variance?: Maybe<Profilo_Variance_Fields>;
};


/** aggregate fields of "profilo" */
export type Profilo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profilo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "profilo" */
export type Profilo_Aggregate_Order_By = {
  avg?: InputMaybe<Profilo_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Profilo_Max_Order_By>;
  min?: InputMaybe<Profilo_Min_Order_By>;
  stddev?: InputMaybe<Profilo_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Profilo_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Profilo_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Profilo_Sum_Order_By>;
  var_pop?: InputMaybe<Profilo_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Profilo_Var_Samp_Order_By>;
  variance?: InputMaybe<Profilo_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Profilo_Append_Input = {
  ambiti_attivita?: InputMaybe<Scalars['jsonb']['input']>;
  area_geografica_operativa?: InputMaybe<Scalars['jsonb']['input']>;
  interessi_specifici?: InputMaybe<Scalars['jsonb']['input']>;
  target_clienti?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "profilo" */
export type Profilo_Arr_Rel_Insert_Input = {
  data: Array<Profilo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Profilo_On_Conflict>;
};

/** aggregate avg on columns */
export type Profilo_Avg_Fields = {
  __typename?: 'profilo_avg_fields';
  numero_dipendenti?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "profilo" */
export type Profilo_Avg_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "profilo". All fields are combined with a logical 'AND'. */
export type Profilo_Bool_Exp = {
  _and?: InputMaybe<Array<Profilo_Bool_Exp>>;
  _not?: InputMaybe<Profilo_Bool_Exp>;
  _or?: InputMaybe<Array<Profilo_Bool_Exp>>;
  accetto_condizioni?: InputMaybe<Boolean_Comparison_Exp>;
  ambiti_attivita?: InputMaybe<Jsonb_Comparison_Exp>;
  amico_presentatore?: InputMaybe<Codice_Operatore_Bool_Exp>;
  anno_fondazione?: InputMaybe<Timestamptz_Comparison_Exp>;
  area_geografica_operativa?: InputMaybe<Jsonb_Comparison_Exp>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  certificazioni?: InputMaybe<String_Comparison_Exp>;
  codice_amico?: InputMaybe<String_Comparison_Exp>;
  codice_univoco?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interessi_specifici?: InputMaybe<Jsonb_Comparison_Exp>;
  numero_dipendenti?: InputMaybe<Int_Comparison_Exp>;
  persona?: InputMaybe<Persona_Bool_Exp>;
  persona_id?: InputMaybe<Uuid_Comparison_Exp>;
  referente_principale?: InputMaybe<String_Comparison_Exp>;
  ruolo_referente?: InputMaybe<String_Comparison_Exp>;
  show_accesso_pro?: InputMaybe<Boolean_Comparison_Exp>;
  sito_web?: InputMaybe<String_Comparison_Exp>;
  target_clienti?: InputMaybe<Jsonb_Comparison_Exp>;
  tipologia?: InputMaybe<_Tipologia_Profilo_Enum_Comparison_Exp>;
  tipologia_profilo?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utente?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};

/** unique or primary key constraints on table "profilo" */
export enum Profilo_Constraint {
  /** unique or primary key constraint on columns "codice_univoco" */
  ProfiloCodiceUnivocoKey = 'profilo_codice_univoco_key',
  /** unique or primary key constraint on columns "id" */
  ProfiloPkey = 'profilo_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Profilo_Delete_At_Path_Input = {
  ambiti_attivita?: InputMaybe<Array<Scalars['String']['input']>>;
  area_geografica_operativa?: InputMaybe<Array<Scalars['String']['input']>>;
  interessi_specifici?: InputMaybe<Array<Scalars['String']['input']>>;
  target_clienti?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Profilo_Delete_Elem_Input = {
  ambiti_attivita?: InputMaybe<Scalars['Int']['input']>;
  area_geografica_operativa?: InputMaybe<Scalars['Int']['input']>;
  interessi_specifici?: InputMaybe<Scalars['Int']['input']>;
  target_clienti?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Profilo_Delete_Key_Input = {
  ambiti_attivita?: InputMaybe<Scalars['String']['input']>;
  area_geografica_operativa?: InputMaybe<Scalars['String']['input']>;
  interessi_specifici?: InputMaybe<Scalars['String']['input']>;
  target_clienti?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "profilo" */
export type Profilo_Inc_Input = {
  numero_dipendenti?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "profilo" */
export type Profilo_Insert_Input = {
  accetto_condizioni?: InputMaybe<Scalars['Boolean']['input']>;
  ambiti_attivita?: InputMaybe<Scalars['jsonb']['input']>;
  amico_presentatore?: InputMaybe<Codice_Operatore_Obj_Rel_Insert_Input>;
  anno_fondazione?: InputMaybe<Scalars['timestamptz']['input']>;
  area_geografica_operativa?: InputMaybe<Scalars['jsonb']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  certificazioni?: InputMaybe<Scalars['String']['input']>;
  codice_amico?: InputMaybe<Scalars['String']['input']>;
  codice_univoco?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interessi_specifici?: InputMaybe<Scalars['jsonb']['input']>;
  numero_dipendenti?: InputMaybe<Scalars['Int']['input']>;
  persona?: InputMaybe<Persona_Obj_Rel_Insert_Input>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  referente_principale?: InputMaybe<Scalars['String']['input']>;
  ruolo_referente?: InputMaybe<Scalars['String']['input']>;
  show_accesso_pro?: InputMaybe<Scalars['Boolean']['input']>;
  sito_web?: InputMaybe<Scalars['String']['input']>;
  target_clienti?: InputMaybe<Scalars['jsonb']['input']>;
  tipologia?: InputMaybe<_Tipologia_Profilo_Enum>;
  tipologia_profilo?: InputMaybe<_Tipologia_Profilo_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utente?: InputMaybe<Auth_User_Entity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Profilo_Max_Fields = {
  __typename?: 'profilo_max_fields';
  anno_fondazione?: Maybe<Scalars['timestamptz']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  certificazioni?: Maybe<Scalars['String']['output']>;
  codice_amico?: Maybe<Scalars['String']['output']>;
  codice_univoco?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  numero_dipendenti?: Maybe<Scalars['Int']['output']>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  referente_principale?: Maybe<Scalars['String']['output']>;
  ruolo_referente?: Maybe<Scalars['String']['output']>;
  sito_web?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "profilo" */
export type Profilo_Max_Order_By = {
  anno_fondazione?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  certificazioni?: InputMaybe<Order_By>;
  codice_amico?: InputMaybe<Order_By>;
  codice_univoco?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numero_dipendenti?: InputMaybe<Order_By>;
  persona_id?: InputMaybe<Order_By>;
  referente_principale?: InputMaybe<Order_By>;
  ruolo_referente?: InputMaybe<Order_By>;
  sito_web?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Profilo_Min_Fields = {
  __typename?: 'profilo_min_fields';
  anno_fondazione?: Maybe<Scalars['timestamptz']['output']>;
  auth_id?: Maybe<Scalars['String']['output']>;
  certificazioni?: Maybe<Scalars['String']['output']>;
  codice_amico?: Maybe<Scalars['String']['output']>;
  codice_univoco?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  numero_dipendenti?: Maybe<Scalars['Int']['output']>;
  persona_id?: Maybe<Scalars['uuid']['output']>;
  referente_principale?: Maybe<Scalars['String']['output']>;
  ruolo_referente?: Maybe<Scalars['String']['output']>;
  sito_web?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "profilo" */
export type Profilo_Min_Order_By = {
  anno_fondazione?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  certificazioni?: InputMaybe<Order_By>;
  codice_amico?: InputMaybe<Order_By>;
  codice_univoco?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numero_dipendenti?: InputMaybe<Order_By>;
  persona_id?: InputMaybe<Order_By>;
  referente_principale?: InputMaybe<Order_By>;
  ruolo_referente?: InputMaybe<Order_By>;
  sito_web?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "profilo" */
export type Profilo_Mutation_Response = {
  __typename?: 'profilo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Profilo>;
};

/** on_conflict condition type for table "profilo" */
export type Profilo_On_Conflict = {
  constraint: Profilo_Constraint;
  update_columns?: Array<Profilo_Update_Column>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};

/** Ordering options when selecting data from "profilo". */
export type Profilo_Order_By = {
  accetto_condizioni?: InputMaybe<Order_By>;
  ambiti_attivita?: InputMaybe<Order_By>;
  amico_presentatore?: InputMaybe<Codice_Operatore_Order_By>;
  anno_fondazione?: InputMaybe<Order_By>;
  area_geografica_operativa?: InputMaybe<Order_By>;
  auth_id?: InputMaybe<Order_By>;
  certificazioni?: InputMaybe<Order_By>;
  codice_amico?: InputMaybe<Order_By>;
  codice_univoco?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interessi_specifici?: InputMaybe<Order_By>;
  numero_dipendenti?: InputMaybe<Order_By>;
  persona?: InputMaybe<Persona_Order_By>;
  persona_id?: InputMaybe<Order_By>;
  referente_principale?: InputMaybe<Order_By>;
  ruolo_referente?: InputMaybe<Order_By>;
  show_accesso_pro?: InputMaybe<Order_By>;
  sito_web?: InputMaybe<Order_By>;
  target_clienti?: InputMaybe<Order_By>;
  tipologia?: InputMaybe<Order_By>;
  tipologia_profilo?: InputMaybe<_Tipologia_Profilo_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utente?: InputMaybe<Auth_User_Entity_Order_By>;
};

/** primary key columns input for table: profilo */
export type Profilo_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Profilo_Prepend_Input = {
  ambiti_attivita?: InputMaybe<Scalars['jsonb']['input']>;
  area_geografica_operativa?: InputMaybe<Scalars['jsonb']['input']>;
  interessi_specifici?: InputMaybe<Scalars['jsonb']['input']>;
  target_clienti?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "profilo" */
export enum Profilo_Select_Column {
  /** column name */
  AccettoCondizioni = 'accetto_condizioni',
  /** column name */
  AmbitiAttivita = 'ambiti_attivita',
  /** column name */
  AnnoFondazione = 'anno_fondazione',
  /** column name */
  AreaGeograficaOperativa = 'area_geografica_operativa',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  Certificazioni = 'certificazioni',
  /** column name */
  CodiceAmico = 'codice_amico',
  /** column name */
  CodiceUnivoco = 'codice_univoco',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InteressiSpecifici = 'interessi_specifici',
  /** column name */
  NumeroDipendenti = 'numero_dipendenti',
  /** column name */
  PersonaId = 'persona_id',
  /** column name */
  ReferentePrincipale = 'referente_principale',
  /** column name */
  RuoloReferente = 'ruolo_referente',
  /** column name */
  ShowAccessoPro = 'show_accesso_pro',
  /** column name */
  SitoWeb = 'sito_web',
  /** column name */
  TargetClienti = 'target_clienti',
  /** column name */
  Tipologia = 'tipologia',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "profilo_aggregate_bool_exp_bool_and_arguments_columns" columns of table "profilo" */
export enum Profilo_Select_Column_Profilo_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AccettoCondizioni = 'accetto_condizioni',
  /** column name */
  ShowAccessoPro = 'show_accesso_pro'
}

/** select "profilo_aggregate_bool_exp_bool_or_arguments_columns" columns of table "profilo" */
export enum Profilo_Select_Column_Profilo_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AccettoCondizioni = 'accetto_condizioni',
  /** column name */
  ShowAccessoPro = 'show_accesso_pro'
}

/** input type for updating data in table "profilo" */
export type Profilo_Set_Input = {
  accetto_condizioni?: InputMaybe<Scalars['Boolean']['input']>;
  ambiti_attivita?: InputMaybe<Scalars['jsonb']['input']>;
  anno_fondazione?: InputMaybe<Scalars['timestamptz']['input']>;
  area_geografica_operativa?: InputMaybe<Scalars['jsonb']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  certificazioni?: InputMaybe<Scalars['String']['input']>;
  codice_amico?: InputMaybe<Scalars['String']['input']>;
  codice_univoco?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interessi_specifici?: InputMaybe<Scalars['jsonb']['input']>;
  numero_dipendenti?: InputMaybe<Scalars['Int']['input']>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  referente_principale?: InputMaybe<Scalars['String']['input']>;
  ruolo_referente?: InputMaybe<Scalars['String']['input']>;
  show_accesso_pro?: InputMaybe<Scalars['Boolean']['input']>;
  sito_web?: InputMaybe<Scalars['String']['input']>;
  target_clienti?: InputMaybe<Scalars['jsonb']['input']>;
  tipologia?: InputMaybe<_Tipologia_Profilo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Profilo_Stddev_Fields = {
  __typename?: 'profilo_stddev_fields';
  numero_dipendenti?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "profilo" */
export type Profilo_Stddev_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Profilo_Stddev_Pop_Fields = {
  __typename?: 'profilo_stddev_pop_fields';
  numero_dipendenti?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "profilo" */
export type Profilo_Stddev_Pop_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Profilo_Stddev_Samp_Fields = {
  __typename?: 'profilo_stddev_samp_fields';
  numero_dipendenti?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "profilo" */
export type Profilo_Stddev_Samp_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "profilo" */
export type Profilo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profilo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profilo_Stream_Cursor_Value_Input = {
  accetto_condizioni?: InputMaybe<Scalars['Boolean']['input']>;
  ambiti_attivita?: InputMaybe<Scalars['jsonb']['input']>;
  anno_fondazione?: InputMaybe<Scalars['timestamptz']['input']>;
  area_geografica_operativa?: InputMaybe<Scalars['jsonb']['input']>;
  auth_id?: InputMaybe<Scalars['String']['input']>;
  certificazioni?: InputMaybe<Scalars['String']['input']>;
  codice_amico?: InputMaybe<Scalars['String']['input']>;
  codice_univoco?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interessi_specifici?: InputMaybe<Scalars['jsonb']['input']>;
  numero_dipendenti?: InputMaybe<Scalars['Int']['input']>;
  persona_id?: InputMaybe<Scalars['uuid']['input']>;
  referente_principale?: InputMaybe<Scalars['String']['input']>;
  ruolo_referente?: InputMaybe<Scalars['String']['input']>;
  show_accesso_pro?: InputMaybe<Scalars['Boolean']['input']>;
  sito_web?: InputMaybe<Scalars['String']['input']>;
  target_clienti?: InputMaybe<Scalars['jsonb']['input']>;
  tipologia?: InputMaybe<_Tipologia_Profilo_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Profilo_Sum_Fields = {
  __typename?: 'profilo_sum_fields';
  numero_dipendenti?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "profilo" */
export type Profilo_Sum_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

/** update columns of table "profilo" */
export enum Profilo_Update_Column {
  /** column name */
  AccettoCondizioni = 'accetto_condizioni',
  /** column name */
  AmbitiAttivita = 'ambiti_attivita',
  /** column name */
  AnnoFondazione = 'anno_fondazione',
  /** column name */
  AreaGeograficaOperativa = 'area_geografica_operativa',
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  Certificazioni = 'certificazioni',
  /** column name */
  CodiceAmico = 'codice_amico',
  /** column name */
  CodiceUnivoco = 'codice_univoco',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InteressiSpecifici = 'interessi_specifici',
  /** column name */
  NumeroDipendenti = 'numero_dipendenti',
  /** column name */
  PersonaId = 'persona_id',
  /** column name */
  ReferentePrincipale = 'referente_principale',
  /** column name */
  RuoloReferente = 'ruolo_referente',
  /** column name */
  ShowAccessoPro = 'show_accesso_pro',
  /** column name */
  SitoWeb = 'sito_web',
  /** column name */
  TargetClienti = 'target_clienti',
  /** column name */
  Tipologia = 'tipologia',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Profilo_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Profilo_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Profilo_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Profilo_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Profilo_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Profilo_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Profilo_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profilo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profilo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Profilo_Var_Pop_Fields = {
  __typename?: 'profilo_var_pop_fields';
  numero_dipendenti?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "profilo" */
export type Profilo_Var_Pop_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Profilo_Var_Samp_Fields = {
  __typename?: 'profilo_var_samp_fields';
  numero_dipendenti?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "profilo" */
export type Profilo_Var_Samp_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Profilo_Variance_Fields = {
  __typename?: 'profilo_variance_fields';
  numero_dipendenti?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "profilo" */
export type Profilo_Variance_Order_By = {
  numero_dipendenti?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "_destinazione_compatibile" */
  _destinazione_compatibile: Array<_Destinazione_Compatibile>;
  /** fetch aggregated fields from the table: "_destinazione_compatibile" */
  _destinazione_compatibile_aggregate: _Destinazione_Compatibile_Aggregate;
  /** fetch data from the table: "_pod_duplicato" */
  _pod_duplicato: Array<_Pod_Duplicato>;
  /** fetch aggregated fields from the table: "_pod_duplicato" */
  _pod_duplicato_aggregate: _Pod_Duplicato_Aggregate;
  /** fetch data from the table: "_pod_duplicato" using primary key columns */
  _pod_duplicato_by_pk?: Maybe<_Pod_Duplicato>;
  /** fetch data from the table: "_sottoscrizione_tipo_richiesta" */
  _sottoscrizione_tipo_richiesta: Array<_Sottoscrizione_Tipo_Richiesta>;
  /** fetch aggregated fields from the table: "_sottoscrizione_tipo_richiesta" */
  _sottoscrizione_tipo_richiesta_aggregate: _Sottoscrizione_Tipo_Richiesta_Aggregate;
  /** fetch data from the table: "_sottoscrizione_tipo_richiesta" using primary key columns */
  _sottoscrizione_tipo_richiesta_by_pk?: Maybe<_Sottoscrizione_Tipo_Richiesta>;
  /** fetch data from the table: "_superadmin_elimina_sottoscrizione_esito" */
  _superadmin_elimina_sottoscrizione_esito: Array<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** fetch aggregated fields from the table: "_superadmin_elimina_sottoscrizione_esito" */
  _superadmin_elimina_sottoscrizione_esito_aggregate: _Superadmin_Elimina_Sottoscrizione_Esito_Aggregate;
  /** fetch data from the table: "_superadmin_elimina_sottoscrizione_esito" using primary key columns */
  _superadmin_elimina_sottoscrizione_esito_by_pk?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** fetch data from the table: "_tipo_dato_consumo" */
  _tipo_dato_consumo: Array<_Tipo_Dato_Consumo>;
  /** fetch aggregated fields from the table: "_tipo_dato_consumo" */
  _tipo_dato_consumo_aggregate: _Tipo_Dato_Consumo_Aggregate;
  /** fetch data from the table: "_tipo_dato_consumo" using primary key columns */
  _tipo_dato_consumo_by_pk?: Maybe<_Tipo_Dato_Consumo>;
  /** fetch data from the table: "_tipologia_profilo" */
  _tipologia_profilo: Array<_Tipologia_Profilo>;
  /** fetch aggregated fields from the table: "_tipologia_profilo" */
  _tipologia_profilo_aggregate: _Tipologia_Profilo_Aggregate;
  /** fetch data from the table: "_tipologia_profilo" using primary key columns */
  _tipologia_profilo_by_pk?: Maybe<_Tipologia_Profilo>;
  /** fetch data from the table: "admin._stato_richiesta_pubblicazione" */
  admin__stato_richiesta_pubblicazione: Array<Admin__Stato_Richiesta_Pubblicazione>;
  /** fetch aggregated fields from the table: "admin._stato_richiesta_pubblicazione" */
  admin__stato_richiesta_pubblicazione_aggregate: Admin__Stato_Richiesta_Pubblicazione_Aggregate;
  /** fetch data from the table: "admin._stato_richiesta_pubblicazione" using primary key columns */
  admin__stato_richiesta_pubblicazione_by_pk?: Maybe<Admin__Stato_Richiesta_Pubblicazione>;
  /** fetch data from the table: "admin._type_referral" */
  admin__type_referral: Array<Admin__Type_Referral>;
  /** fetch aggregated fields from the table: "admin._type_referral" */
  admin__type_referral_aggregate: Admin__Type_Referral_Aggregate;
  /** fetch data from the table: "admin._type_referral" using primary key columns */
  admin__type_referral_by_pk?: Maybe<Admin__Type_Referral>;
  /** fetch data from the table: "admin.consenso_privacy" */
  admin_consenso_privacy: Array<Admin_Consenso_Privacy>;
  /** fetch aggregated fields from the table: "admin.consenso_privacy" */
  admin_consenso_privacy_aggregate: Admin_Consenso_Privacy_Aggregate;
  /** fetch data from the table: "admin.consenso_privacy" using primary key columns */
  admin_consenso_privacy_by_pk?: Maybe<Admin_Consenso_Privacy>;
  /** fetch data from the table: "admin.parametri_algoritmo_incentivi" */
  admin_parametri_algoritmo_incentivi: Array<Admin_Parametri_Algoritmo_Incentivi>;
  /** fetch aggregated fields from the table: "admin.parametri_algoritmo_incentivi" */
  admin_parametri_algoritmo_incentivi_aggregate: Admin_Parametri_Algoritmo_Incentivi_Aggregate;
  /** fetch data from the table: "admin.parametri_algoritmo_incentivi" using primary key columns */
  admin_parametri_algoritmo_incentivi_by_pk?: Maybe<Admin_Parametri_Algoritmo_Incentivi>;
  /** fetch data from the table: "admin.referral" */
  admin_referral: Array<Admin_Referral>;
  /** fetch aggregated fields from the table: "admin.referral" */
  admin_referral_aggregate: Admin_Referral_Aggregate;
  /** fetch data from the table: "admin.referral" using primary key columns */
  admin_referral_by_pk?: Maybe<Admin_Referral>;
  /** fetch data from the table: "admin.richiesta_pubblicazione" */
  admin_richiesta_pubblicazione: Array<Admin_Richiesta_Pubblicazione>;
  /** fetch aggregated fields from the table: "admin.richiesta_pubblicazione" */
  admin_richiesta_pubblicazione_aggregate: Admin_Richiesta_Pubblicazione_Aggregate;
  /** fetch data from the table: "admin.richiesta_pubblicazione" using primary key columns */
  admin_richiesta_pubblicazione_by_pk?: Maybe<Admin_Richiesta_Pubblicazione>;
  /** fetch data from the table: "admin.utilizzo_referral" */
  admin_utilizzo_referral: Array<Admin_Utilizzo_Referral>;
  /** fetch aggregated fields from the table: "admin.utilizzo_referral" */
  admin_utilizzo_referral_aggregate: Admin_Utilizzo_Referral_Aggregate;
  /** fetch data from the table: "admin.utilizzo_referral" using primary key columns */
  admin_utilizzo_referral_by_pk?: Maybe<Admin_Utilizzo_Referral>;
  /** fetch data from the table: "anagrafica.codice_ateco" */
  anagrafica_codice_ateco: Array<Anagrafica_Codice_Ateco>;
  /** fetch aggregated fields from the table: "anagrafica.codice_ateco" */
  anagrafica_codice_ateco_aggregate: Anagrafica_Codice_Ateco_Aggregate;
  /** fetch data from the table: "anagrafica.codice_ateco" using primary key columns */
  anagrafica_codice_ateco_by_pk?: Maybe<Anagrafica_Codice_Ateco>;
  /** fetch data from the table: "anagrafica.forma_giuridica" */
  anagrafica_forma_giuridica: Array<Anagrafica_Forma_Giuridica>;
  /** fetch aggregated fields from the table: "anagrafica.forma_giuridica" */
  anagrafica_forma_giuridica_aggregate: Anagrafica_Forma_Giuridica_Aggregate;
  /** fetch data from the table: "anagrafica.forma_giuridica" using primary key columns */
  anagrafica_forma_giuridica_by_pk?: Maybe<Anagrafica_Forma_Giuridica>;
  /** fetch data from the table: "anagrafica.forma_giuridica_cer" */
  anagrafica_forma_giuridica_cer: Array<Anagrafica_Forma_Giuridica_Cer>;
  /** fetch aggregated fields from the table: "anagrafica.forma_giuridica_cer" */
  anagrafica_forma_giuridica_cer_aggregate: Anagrafica_Forma_Giuridica_Cer_Aggregate;
  /** fetch data from the table: "anagrafica.forma_giuridica_cer" using primary key columns */
  anagrafica_forma_giuridica_cer_by_pk?: Maybe<Anagrafica_Forma_Giuridica_Cer>;
  /** fetch data from the table: "anagrafica.tipo_contatto" */
  anagrafica_tipo_contatto: Array<Anagrafica_Tipo_Contatto>;
  /** fetch aggregated fields from the table: "anagrafica.tipo_contatto" */
  anagrafica_tipo_contatto_aggregate: Anagrafica_Tipo_Contatto_Aggregate;
  /** fetch data from the table: "anagrafica.tipo_contatto" using primary key columns */
  anagrafica_tipo_contatto_by_pk?: Maybe<Anagrafica_Tipo_Contatto>;
  /** fetch data from the table: "anagrafica.tipo_promotore" */
  anagrafica_tipo_promotore: Array<Anagrafica_Tipo_Promotore>;
  /** fetch aggregated fields from the table: "anagrafica.tipo_promotore" */
  anagrafica_tipo_promotore_aggregate: Anagrafica_Tipo_Promotore_Aggregate;
  /** fetch data from the table: "anagrafica.tipo_promotore" using primary key columns */
  anagrafica_tipo_promotore_by_pk?: Maybe<Anagrafica_Tipo_Promotore>;
  /** fetch data from the table: "anagrafica.tipologia_rappresentante" */
  anagrafica_tipologia_rappresentante: Array<Anagrafica_Tipologia_Rappresentante>;
  /** fetch aggregated fields from the table: "anagrafica.tipologia_rappresentante" */
  anagrafica_tipologia_rappresentante_aggregate: Anagrafica_Tipologia_Rappresentante_Aggregate;
  /** fetch data from the table: "anagrafica.tipologia_rappresentante" using primary key columns */
  anagrafica_tipologia_rappresentante_by_pk?: Maybe<Anagrafica_Tipologia_Rappresentante>;
  /** fetch data from the table: "asset" */
  asset: Array<Asset>;
  /** fetch aggregated fields from the table: "asset" */
  asset_aggregate: Asset_Aggregate;
  /** fetch data from the table: "asset" using primary key columns */
  asset_by_pk?: Maybe<Asset>;
  /** fetch data from the table: "asset_caratteristica" */
  asset_caratteristica: Array<Asset_Caratteristica>;
  /** fetch aggregated fields from the table: "asset_caratteristica" */
  asset_caratteristica_aggregate: Asset_Caratteristica_Aggregate;
  /** fetch data from the table: "asset_caratteristica" using primary key columns */
  asset_caratteristica_by_pk?: Maybe<Asset_Caratteristica>;
  /** fetch data from the table: "asset_consumo" */
  asset_consumo: Array<Asset_Consumo>;
  /** fetch aggregated fields from the table: "asset_consumo" */
  asset_consumo_aggregate: Asset_Consumo_Aggregate;
  /** fetch data from the table: "asset_consumo" using primary key columns */
  asset_consumo_by_pk?: Maybe<Asset_Consumo>;
  /** fetch data from the table: "asset_dato_consumo" */
  asset_dato_consumo: Array<Asset_Dato_Consumo>;
  /** fetch aggregated fields from the table: "asset_dato_consumo" */
  asset_dato_consumo_aggregate: Asset_Dato_Consumo_Aggregate;
  /** fetch data from the table: "asset_dato_consumo" using primary key columns */
  asset_dato_consumo_by_pk?: Maybe<Asset_Dato_Consumo>;
  /** fetch data from the table: "asset_energia" */
  asset_energia: Array<Asset_Energia>;
  /** fetch aggregated fields from the table: "asset_energia" */
  asset_energia_aggregate: Asset_Energia_Aggregate;
  /** fetch data from the table: "asset_energia" using primary key columns */
  asset_energia_by_pk?: Maybe<Asset_Energia>;
  /** fetch data from the table: "asset_founder" */
  asset_founder: Array<Asset_Founder>;
  /** fetch aggregated fields from the table: "asset_founder" */
  asset_founder_aggregate: Asset_Founder_Aggregate;
  /** fetch data from the table: "asset_founder" using primary key columns */
  asset_founder_by_pk?: Maybe<Asset_Founder>;
  /** fetch data from the table: "asset_gestore" */
  asset_gestore: Array<Asset_Gestore>;
  /** fetch aggregated fields from the table: "asset_gestore" */
  asset_gestore_aggregate: Asset_Gestore_Aggregate;
  /** fetch data from the table: "asset_gestore" using primary key columns */
  asset_gestore_by_pk?: Maybe<Asset_Gestore>;
  /** An array relationship */
  asset_produzione: Array<Asset_Produzione>;
  /** An aggregate relationship */
  asset_produzione_aggregate: Asset_Produzione_Aggregate;
  /** fetch data from the table: "asset_produzione" using primary key columns */
  asset_produzione_by_pk?: Maybe<Asset_Produzione>;
  /** fetch data from the table: "asset_produzione_unita" */
  asset_produzione_unita: Array<Asset_Produzione_Unita>;
  /** fetch aggregated fields from the table: "asset_produzione_unita" */
  asset_produzione_unita_aggregate: Asset_Produzione_Unita_Aggregate;
  /** fetch data from the table: "asset_produzione_unita" using primary key columns */
  asset_produzione_unita_by_pk?: Maybe<Asset_Produzione_Unita>;
  /** fetch data from the table: "asset_produzione_unita_sezione" */
  asset_produzione_unita_sezione: Array<Asset_Produzione_Unita_Sezione>;
  /** fetch aggregated fields from the table: "asset_produzione_unita_sezione" */
  asset_produzione_unita_sezione_aggregate: Asset_Produzione_Unita_Sezione_Aggregate;
  /** fetch data from the table: "asset_produzione_unita_sezione" using primary key columns */
  asset_produzione_unita_sezione_by_pk?: Maybe<Asset_Produzione_Unita_Sezione>;
  /** fetch data from the table: "asset_produzione_unita_sezione_incentivi" */
  asset_produzione_unita_sezione_incentivi: Array<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** fetch aggregated fields from the table: "asset_produzione_unita_sezione_incentivi" */
  asset_produzione_unita_sezione_incentivi_aggregate: Asset_Produzione_Unita_Sezione_Incentivi_Aggregate;
  /** fetch data from the table: "asset_produzione_unita_sezione_incentivi" using primary key columns */
  asset_produzione_unita_sezione_incentivi_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** fetch data from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  asset_produzione_unita_sezione_titolo_autorizzativo: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** fetch aggregated fields from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  asset_produzione_unita_sezione_titolo_autorizzativo_aggregate: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate;
  /** fetch data from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" using primary key columns */
  asset_produzione_unita_sezione_titolo_autorizzativo_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** fetch data from the table: "asset_spazio" */
  asset_spazio: Array<Asset_Spazio>;
  /** fetch aggregated fields from the table: "asset_spazio" */
  asset_spazio_aggregate: Asset_Spazio_Aggregate;
  /** fetch data from the table: "asset_spazio" using primary key columns */
  asset_spazio_by_pk?: Maybe<Asset_Spazio>;
  /** fetch data from the table: "auth.event_entity" */
  auth_event_entity: Array<Auth_Event_Entity>;
  /** fetch aggregated fields from the table: "auth.event_entity" */
  auth_event_entity_aggregate: Auth_Event_Entity_Aggregate;
  /** fetch data from the table: "auth.event_entity" using primary key columns */
  auth_event_entity_by_pk?: Maybe<Auth_Event_Entity>;
  /** fetch data from the table: "auth.federated_identity" */
  auth_federated_identity: Array<Auth_Federated_Identity>;
  /** fetch aggregated fields from the table: "auth.federated_identity" */
  auth_federated_identity_aggregate: Auth_Federated_Identity_Aggregate;
  /** fetch data from the table: "auth.federated_identity" using primary key columns */
  auth_federated_identity_by_pk?: Maybe<Auth_Federated_Identity>;
  /** fetch data from the table: "auth.role_attribute" */
  auth_role_attribute: Array<Auth_Role_Attribute>;
  /** fetch aggregated fields from the table: "auth.role_attribute" */
  auth_role_attribute_aggregate: Auth_Role_Attribute_Aggregate;
  /** fetch data from the table: "auth.role_attribute" using primary key columns */
  auth_role_attribute_by_pk?: Maybe<Auth_Role_Attribute>;
  /** fetch data from the table: "auth.user_attribute" */
  auth_user_attribute: Array<Auth_User_Attribute>;
  /** fetch aggregated fields from the table: "auth.user_attribute" */
  auth_user_attribute_aggregate: Auth_User_Attribute_Aggregate;
  /** fetch data from the table: "auth.user_attribute" using primary key columns */
  auth_user_attribute_by_pk?: Maybe<Auth_User_Attribute>;
  /** fetch data from the table: "auth.user_entity" */
  auth_user_entity: Array<Auth_User_Entity>;
  /** fetch aggregated fields from the table: "auth.user_entity" */
  auth_user_entity_aggregate: Auth_User_Entity_Aggregate;
  /** fetch data from the table: "auth.user_entity" using primary key columns */
  auth_user_entity_by_pk?: Maybe<Auth_User_Entity>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table: "cer" */
  cer: Array<Cer>;
  /** fetch aggregated fields from the table: "cer" */
  cer_aggregate: Cer_Aggregate;
  /** fetch data from the table: "cer" using primary key columns */
  cer_by_pk?: Maybe<Cer>;
  /** An array relationship */
  cer_cabina: Array<Cer_Cabina>;
  /** An aggregate relationship */
  cer_cabina_aggregate: Cer_Cabina_Aggregate;
  /** fetch data from the table: "cer_cabina" using primary key columns */
  cer_cabina_by_pk?: Maybe<Cer_Cabina>;
  /** fetch data from the table: "cer_cabina_snapshot" */
  cer_cabina_snapshot: Array<Cer_Cabina_Snapshot>;
  /** fetch aggregated fields from the table: "cer_cabina_snapshot" */
  cer_cabina_snapshot_aggregate: Cer_Cabina_Snapshot_Aggregate;
  /** fetch data from the table: "cer_cabina_snapshot" using primary key columns */
  cer_cabina_snapshot_by_pk?: Maybe<Cer_Cabina_Snapshot>;
  /** fetch data from the table: "cer_categoria_adesione" */
  cer_categoria_adesione: Array<Cer_Categoria_Adesione>;
  /** fetch aggregated fields from the table: "cer_categoria_adesione" */
  cer_categoria_adesione_aggregate: Cer_Categoria_Adesione_Aggregate;
  /** fetch data from the table: "cer_categoria_adesione" using primary key columns */
  cer_categoria_adesione_by_pk?: Maybe<Cer_Categoria_Adesione>;
  /** fetch data from the table: "cer_configurazione_destinazione_contributo" */
  cer_configurazione_destinazione_contributo: Array<Cer_Configurazione_Destinazione_Contributo>;
  /** fetch aggregated fields from the table: "cer_configurazione_destinazione_contributo" */
  cer_configurazione_destinazione_contributo_aggregate: Cer_Configurazione_Destinazione_Contributo_Aggregate;
  /** fetch data from the table: "cer_configurazione_destinazione_contributo" using primary key columns */
  cer_configurazione_destinazione_contributo_by_pk?: Maybe<Cer_Configurazione_Destinazione_Contributo>;
  /** An array relationship */
  cer_contatti: Array<Cer_Contatti>;
  /** An aggregate relationship */
  cer_contatti_aggregate: Cer_Contatti_Aggregate;
  /** fetch data from the table: "cer_contatti" using primary key columns */
  cer_contatti_by_pk?: Maybe<Cer_Contatti>;
  /** fetch data from the table: "cer_destinazione_contributo" */
  cer_destinazione_contributo: Array<Cer_Destinazione_Contributo>;
  /** fetch aggregated fields from the table: "cer_destinazione_contributo" */
  cer_destinazione_contributo_aggregate: Cer_Destinazione_Contributo_Aggregate;
  /** fetch data from the table: "cer_destinazione_contributo" using primary key columns */
  cer_destinazione_contributo_by_pk?: Maybe<Cer_Destinazione_Contributo>;
  /** fetch data from the table: "cer_geom" */
  cer_geom: Array<Cer_Geom>;
  /** fetch aggregated fields from the table: "cer_geom" */
  cer_geom_aggregate: Cer_Geom_Aggregate;
  /** fetch data from the table: "cer_geom" using primary key columns */
  cer_geom_by_pk?: Maybe<Cer_Geom>;
  /** fetch data from the table: "cer_gestore" */
  cer_gestore: Array<Cer_Gestore>;
  /** fetch aggregated fields from the table: "cer_gestore" */
  cer_gestore_aggregate: Cer_Gestore_Aggregate;
  /** fetch data from the table: "cer_gestore" using primary key columns */
  cer_gestore_by_pk?: Maybe<Cer_Gestore>;
  /** fetch data from the table: "cer_search_index" */
  cer_search_index: Array<Cer_Search_Index>;
  /** fetch aggregated fields from the table: "cer_search_index" */
  cer_search_index_aggregate: Cer_Search_Index_Aggregate;
  /** fetch data from the table: "cer_search_index" using primary key columns */
  cer_search_index_by_pk?: Maybe<Cer_Search_Index>;
  /** fetch data from the table: "cer_tecnico" */
  cer_tecnico: Array<Cer_Tecnico>;
  /** fetch aggregated fields from the table: "cer_tecnico" */
  cer_tecnico_aggregate: Cer_Tecnico_Aggregate;
  /** fetch data from the table: "cer_tecnico" using primary key columns */
  cer_tecnico_by_pk?: Maybe<Cer_Tecnico>;
  /** execute function "check_pod_duplicato" which returns "_pod_duplicato" */
  check_pod_duplicato: Array<_Pod_Duplicato>;
  /** execute function "check_pod_duplicato" and query aggregates on result of table type "_pod_duplicato" */
  check_pod_duplicato_aggregate: _Pod_Duplicato_Aggregate;
  /** fetch data from the table: "codice_operatore" */
  codice_operatore: Array<Codice_Operatore>;
  /** fetch aggregated fields from the table: "codice_operatore" */
  codice_operatore_aggregate: Codice_Operatore_Aggregate;
  /** fetch data from the table: "codice_operatore" using primary key columns */
  codice_operatore_by_pk?: Maybe<Codice_Operatore>;
  /** fetch data from the table: "comunicazioni.email" */
  comunicazioni_email: Array<Comunicazioni_Email>;
  /** fetch aggregated fields from the table: "comunicazioni.email" */
  comunicazioni_email_aggregate: Comunicazioni_Email_Aggregate;
  /** fetch data from the table: "comunicazioni.email" using primary key columns */
  comunicazioni_email_by_pk?: Maybe<Comunicazioni_Email>;
  /** fetch data from the table: "comunicazioni.email_template" */
  comunicazioni_email_template: Array<Comunicazioni_Email_Template>;
  /** fetch aggregated fields from the table: "comunicazioni.email_template" */
  comunicazioni_email_template_aggregate: Comunicazioni_Email_Template_Aggregate;
  /** fetch data from the table: "comunicazioni.email_template" using primary key columns */
  comunicazioni_email_template_by_pk?: Maybe<Comunicazioni_Email_Template>;
  /** fetch data from the table: "comunicazioni.sms" */
  comunicazioni_sms: Array<Comunicazioni_Sms>;
  /** fetch aggregated fields from the table: "comunicazioni.sms" */
  comunicazioni_sms_aggregate: Comunicazioni_Sms_Aggregate;
  /** fetch data from the table: "comunicazioni.sms" using primary key columns */
  comunicazioni_sms_by_pk?: Maybe<Comunicazioni_Sms>;
  /** fetch data from the table: "condivisione._stato_condivisione" */
  condivisione__stato_condivisione: Array<Condivisione__Stato_Condivisione>;
  /** fetch aggregated fields from the table: "condivisione._stato_condivisione" */
  condivisione__stato_condivisione_aggregate: Condivisione__Stato_Condivisione_Aggregate;
  /** fetch data from the table: "condivisione._stato_condivisione" using primary key columns */
  condivisione__stato_condivisione_by_pk?: Maybe<Condivisione__Stato_Condivisione>;
  /** fetch data from the table: "condivisione.accetta_response" */
  condivisione_accetta_response: Array<Condivisione_Accetta_Response>;
  /** fetch aggregated fields from the table: "condivisione.accetta_response" */
  condivisione_accetta_response_aggregate: Condivisione_Accetta_Response_Aggregate;
  /** fetch data from the table: "condivisione.condivisione" */
  condivisione_condivisione: Array<Condivisione_Condivisione>;
  /** fetch aggregated fields from the table: "condivisione.condivisione" */
  condivisione_condivisione_aggregate: Condivisione_Condivisione_Aggregate;
  /** fetch data from the table: "condivisione.condivisione" using primary key columns */
  condivisione_condivisione_by_pk?: Maybe<Condivisione_Condivisione>;
  /** fetch data from the table: "condivisione.log_condivisione" */
  condivisione_log_condivisione: Array<Condivisione_Log_Condivisione>;
  /** fetch aggregated fields from the table: "condivisione.log_condivisione" */
  condivisione_log_condivisione_aggregate: Condivisione_Log_Condivisione_Aggregate;
  /** fetch data from the table: "condivisione.log_condivisione" using primary key columns */
  condivisione_log_condivisione_by_pk?: Maybe<Condivisione_Log_Condivisione>;
  /** confirmo_get */
  confirmoGet?: Maybe<ConfirmoGetOutput>;
  /** confirmo_get_firma */
  confirmoGetFirma?: Maybe<ConfirmoGetFirmaOutput>;
  /** fetch data from the table: "contatto" */
  contatto: Array<Contatto>;
  /** fetch aggregated fields from the table: "contatto" */
  contatto_aggregate: Contatto_Aggregate;
  /** fetch data from the table: "contatto" using primary key columns */
  contatto_by_pk?: Maybe<Contatto>;
  /** fetch data from the table: "crm.audit_event" */
  crm_audit_event: Array<Crm_Audit_Event>;
  /** fetch aggregated fields from the table: "crm.audit_event" */
  crm_audit_event_aggregate: Crm_Audit_Event_Aggregate;
  /** fetch data from the table: "crm.audit_event" using primary key columns */
  crm_audit_event_by_pk?: Maybe<Crm_Audit_Event>;
  /** fetch data from the table: "debug.sottoscrizione_after_log" */
  debug_sottoscrizione_after_log: Array<Debug_Sottoscrizione_After_Log>;
  /** fetch aggregated fields from the table: "debug.sottoscrizione_after_log" */
  debug_sottoscrizione_after_log_aggregate: Debug_Sottoscrizione_After_Log_Aggregate;
  /** fetch data from the table: "debug.sottoscrizione_after_log" using primary key columns */
  debug_sottoscrizione_after_log_by_pk?: Maybe<Debug_Sottoscrizione_After_Log>;
  /** execute function "destinazioni_compatibili" which returns "_destinazione_compatibile" */
  destinazioni_compatibili: Array<_Destinazione_Compatibile>;
  /** execute function "destinazioni_compatibili" and query aggregates on result of table type "_destinazione_compatibile" */
  destinazioni_compatibili_aggregate: _Destinazione_Compatibile_Aggregate;
  /** fetch data from the table: "device.device" */
  device_device: Array<Device_Device>;
  /** fetch aggregated fields from the table: "device.device" */
  device_device_aggregate: Device_Device_Aggregate;
  /** fetch data from the table: "device.device" using primary key columns */
  device_device_by_pk?: Maybe<Device_Device>;
  /** fetch data from the table: "energy_village._azioni_founder_sottoscrizione" */
  energy_village__azioni_founder_sottoscrizione: Array<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._azioni_founder_sottoscrizione" */
  energy_village__azioni_founder_sottoscrizione_aggregate: Energy_Village__Azioni_Founder_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._azioni_founder_sottoscrizione" using primary key columns */
  energy_village__azioni_founder_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** fetch data from the table: "energy_village._azioni_prosumer_sottoscrizione" */
  energy_village__azioni_prosumer_sottoscrizione: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._azioni_prosumer_sottoscrizione" */
  energy_village__azioni_prosumer_sottoscrizione_aggregate: Energy_Village__Azioni_Prosumer_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._azioni_prosumer_sottoscrizione" using primary key columns */
  energy_village__azioni_prosumer_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** fetch data from the table: "energy_village._azioni_tecnico_sottoscrizione" */
  energy_village__azioni_tecnico_sottoscrizione: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._azioni_tecnico_sottoscrizione" */
  energy_village__azioni_tecnico_sottoscrizione_aggregate: Energy_Village__Azioni_Tecnico_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._azioni_tecnico_sottoscrizione" using primary key columns */
  energy_village__azioni_tecnico_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** fetch data from the table: "energy_village._cer_filter_options" */
  energy_village__cer_filter_options: Array<Energy_Village__Cer_Filter_Options>;
  /** fetch aggregated fields from the table: "energy_village._cer_filter_options" */
  energy_village__cer_filter_options_aggregate: Energy_Village__Cer_Filter_Options_Aggregate;
  /** fetch data from the table: "energy_village._cer_filter_options" using primary key columns */
  energy_village__cer_filter_options_by_pk?: Maybe<Energy_Village__Cer_Filter_Options>;
  /** fetch data from the table: "energy_village._stato_cer" */
  energy_village__stato_cer: Array<Energy_Village__Stato_Cer>;
  /** fetch aggregated fields from the table: "energy_village._stato_cer" */
  energy_village__stato_cer_aggregate: Energy_Village__Stato_Cer_Aggregate;
  /** fetch data from the table: "energy_village._stato_cer" using primary key columns */
  energy_village__stato_cer_by_pk?: Maybe<Energy_Village__Stato_Cer>;
  /** fetch data from the table: "energy_village._stato_sottoscrizione" */
  energy_village__stato_sottoscrizione: Array<Energy_Village__Stato_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._stato_sottoscrizione" */
  energy_village__stato_sottoscrizione_aggregate: Energy_Village__Stato_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._stato_sottoscrizione" using primary key columns */
  energy_village__stato_sottoscrizione_by_pk?: Maybe<Energy_Village__Stato_Sottoscrizione>;
  /** fetch data from the table: "energy_village._tipo_domanda" */
  energy_village__tipo_domanda: Array<Energy_Village__Tipo_Domanda>;
  /** fetch aggregated fields from the table: "energy_village._tipo_domanda" */
  energy_village__tipo_domanda_aggregate: Energy_Village__Tipo_Domanda_Aggregate;
  /** fetch data from the table: "energy_village._tipo_domanda" using primary key columns */
  energy_village__tipo_domanda_by_pk?: Maybe<Energy_Village__Tipo_Domanda>;
  /** fetch data from the table: "energy_village._tipo_feedback" */
  energy_village__tipo_feedback: Array<Energy_Village__Tipo_Feedback>;
  /** fetch aggregated fields from the table: "energy_village._tipo_feedback" */
  energy_village__tipo_feedback_aggregate: Energy_Village__Tipo_Feedback_Aggregate;
  /** fetch data from the table: "energy_village._tipo_feedback" using primary key columns */
  energy_village__tipo_feedback_by_pk?: Maybe<Energy_Village__Tipo_Feedback>;
  /** fetch data from the table: "energy_village.area" */
  energy_village_area: Array<Energy_Village_Area>;
  /** fetch aggregated fields from the table: "energy_village.area" */
  energy_village_area_aggregate: Energy_Village_Area_Aggregate;
  /** fetch data from the table: "energy_village.area" using primary key columns */
  energy_village_area_by_pk?: Maybe<Energy_Village_Area>;
  /** fetch data from the table: "energy_village.area_citta" */
  energy_village_area_citta: Array<Energy_Village_Area_Citta>;
  /** fetch aggregated fields from the table: "energy_village.area_citta" */
  energy_village_area_citta_aggregate: Energy_Village_Area_Citta_Aggregate;
  /** fetch data from the table: "energy_village.area_citta" using primary key columns */
  energy_village_area_citta_by_pk?: Maybe<Energy_Village_Area_Citta>;
  /** fetch data from the table: "energy_village.area_provincia" */
  energy_village_area_provincia: Array<Energy_Village_Area_Provincia>;
  /** fetch aggregated fields from the table: "energy_village.area_provincia" */
  energy_village_area_provincia_aggregate: Energy_Village_Area_Provincia_Aggregate;
  /** fetch data from the table: "energy_village.area_provincia" using primary key columns */
  energy_village_area_provincia_by_pk?: Maybe<Energy_Village_Area_Provincia>;
  /** fetch data from the table: "energy_village.area_regione" */
  energy_village_area_regione: Array<Energy_Village_Area_Regione>;
  /** fetch aggregated fields from the table: "energy_village.area_regione" */
  energy_village_area_regione_aggregate: Energy_Village_Area_Regione_Aggregate;
  /** fetch data from the table: "energy_village.area_regione" using primary key columns */
  energy_village_area_regione_by_pk?: Maybe<Energy_Village_Area_Regione>;
  /** fetch data from the table: "energy_village.azioni" */
  energy_village_azioni: Array<Energy_Village_Azioni>;
  /** fetch aggregated fields from the table: "energy_village.azioni" */
  energy_village_azioni_aggregate: Energy_Village_Azioni_Aggregate;
  /** fetch data from the table: "energy_village.azioni" using primary key columns */
  energy_village_azioni_by_pk?: Maybe<Energy_Village_Azioni>;
  /** fetch data from the table: "energy_village.cabina" */
  energy_village_cabina: Array<Energy_Village_Cabina>;
  /** fetch aggregated fields from the table: "energy_village.cabina" */
  energy_village_cabina_aggregate: Energy_Village_Cabina_Aggregate;
  /** fetch data from the table: "energy_village.cabina" using primary key columns */
  energy_village_cabina_by_pk?: Maybe<Energy_Village_Cabina>;
  /** fetch data from the table: "energy_village.cabina_citta" */
  energy_village_cabina_citta: Array<Energy_Village_Cabina_Citta>;
  /** fetch aggregated fields from the table: "energy_village.cabina_citta" */
  energy_village_cabina_citta_aggregate: Energy_Village_Cabina_Citta_Aggregate;
  /** fetch data from the table: "energy_village.cabina_citta" using primary key columns */
  energy_village_cabina_citta_by_pk?: Maybe<Energy_Village_Cabina_Citta>;
  /** fetch data from the table: "energy_village.caratteristica" */
  energy_village_caratteristica: Array<Energy_Village_Caratteristica>;
  /** fetch aggregated fields from the table: "energy_village.caratteristica" */
  energy_village_caratteristica_aggregate: Energy_Village_Caratteristica_Aggregate;
  /** fetch data from the table: "energy_village.caratteristica" using primary key columns */
  energy_village_caratteristica_by_pk?: Maybe<Energy_Village_Caratteristica>;
  /** fetch data from the table: "energy_village.cer_filter_options" */
  energy_village_cer_filter_options: Array<Energy_Village_Cer_Filter_Options>;
  /** fetch aggregated fields from the table: "energy_village.cer_filter_options" */
  energy_village_cer_filter_options_aggregate: Energy_Village_Cer_Filter_Options_Aggregate;
  /** fetch data from the table: "energy_village.cer_filter_options" using primary key columns */
  energy_village_cer_filter_options_by_pk?: Maybe<Energy_Village_Cer_Filter_Options>;
  /** fetch data from the table: "energy_village.dimensione" */
  energy_village_dimensione: Array<Energy_Village_Dimensione>;
  /** fetch aggregated fields from the table: "energy_village.dimensione" */
  energy_village_dimensione_aggregate: Energy_Village_Dimensione_Aggregate;
  /** fetch data from the table: "energy_village.dimensione" using primary key columns */
  energy_village_dimensione_by_pk?: Maybe<Energy_Village_Dimensione>;
  /** fetch data from the table: "energy_village.feedback" */
  energy_village_feedback: Array<Energy_Village_Feedback>;
  /** fetch aggregated fields from the table: "energy_village.feedback" */
  energy_village_feedback_aggregate: Energy_Village_Feedback_Aggregate;
  /** fetch data from the table: "energy_village.feedback" using primary key columns */
  energy_village_feedback_by_pk?: Maybe<Energy_Village_Feedback>;
  /** fetch data from the table: "energy_village.incentivo_impianto" */
  energy_village_incentivo_impianto: Array<Energy_Village_Incentivo_Impianto>;
  /** fetch aggregated fields from the table: "energy_village.incentivo_impianto" */
  energy_village_incentivo_impianto_aggregate: Energy_Village_Incentivo_Impianto_Aggregate;
  /** fetch data from the table: "energy_village.incentivo_impianto" using primary key columns */
  energy_village_incentivo_impianto_by_pk?: Maybe<Energy_Village_Incentivo_Impianto>;
  /** fetch data from the table: "energy_village.orario" */
  energy_village_orario: Array<Energy_Village_Orario>;
  /** fetch aggregated fields from the table: "energy_village.orario" */
  energy_village_orario_aggregate: Energy_Village_Orario_Aggregate;
  /** fetch data from the table: "energy_village.orario" using primary key columns */
  energy_village_orario_by_pk?: Maybe<Energy_Village_Orario>;
  /** fetch data from the table: "energy_village.potenza_impianto" */
  energy_village_potenza_impianto: Array<Energy_Village_Potenza_Impianto>;
  /** fetch aggregated fields from the table: "energy_village.potenza_impianto" */
  energy_village_potenza_impianto_aggregate: Energy_Village_Potenza_Impianto_Aggregate;
  /** fetch data from the table: "energy_village.potenza_impianto" using primary key columns */
  energy_village_potenza_impianto_by_pk?: Maybe<Energy_Village_Potenza_Impianto>;
  /** fetch data from the table: "energy_village.potenzialita_cabina" */
  energy_village_potenzialita_cabina: Array<Energy_Village_Potenzialita_Cabina>;
  /** fetch aggregated fields from the table: "energy_village.potenzialita_cabina" */
  energy_village_potenzialita_cabina_aggregate: Energy_Village_Potenzialita_Cabina_Aggregate;
  /** fetch data from the table: "energy_village.potenzialita_cabina" using primary key columns */
  energy_village_potenzialita_cabina_by_pk?: Maybe<Energy_Village_Potenzialita_Cabina>;
  /** fetch data from the table: "energy_village.tipo_spazio_disponibile" */
  energy_village_tipo_spazio_disponibile: Array<Energy_Village_Tipo_Spazio_Disponibile>;
  /** fetch aggregated fields from the table: "energy_village.tipo_spazio_disponibile" */
  energy_village_tipo_spazio_disponibile_aggregate: Energy_Village_Tipo_Spazio_Disponibile_Aggregate;
  /** fetch data from the table: "energy_village.tipo_spazio_disponibile" using primary key columns */
  energy_village_tipo_spazio_disponibile_by_pk?: Maybe<Energy_Village_Tipo_Spazio_Disponibile>;
  /** fetch data from the table: "energy_village.tipologia_abitativa" */
  energy_village_tipologia_abitativa: Array<Energy_Village_Tipologia_Abitativa>;
  /** fetch aggregated fields from the table: "energy_village.tipologia_abitativa" */
  energy_village_tipologia_abitativa_aggregate: Energy_Village_Tipologia_Abitativa_Aggregate;
  /** fetch data from the table: "energy_village.tipologia_abitativa" using primary key columns */
  energy_village_tipologia_abitativa_by_pk?: Maybe<Energy_Village_Tipologia_Abitativa>;
  /** fetch data from the table: "energy_village.tipologia_asset" */
  energy_village_tipologia_asset: Array<Energy_Village_Tipologia_Asset>;
  /** fetch aggregated fields from the table: "energy_village.tipologia_asset" */
  energy_village_tipologia_asset_aggregate: Energy_Village_Tipologia_Asset_Aggregate;
  /** fetch data from the table: "energy_village.tipologia_asset" using primary key columns */
  energy_village_tipologia_asset_by_pk?: Maybe<Energy_Village_Tipologia_Asset>;
  /** fetch data from the table: "energy_village.titolo_autorizzativo" */
  energy_village_titolo_autorizzativo: Array<Energy_Village_Titolo_Autorizzativo>;
  /** fetch aggregated fields from the table: "energy_village.titolo_autorizzativo" */
  energy_village_titolo_autorizzativo_aggregate: Energy_Village_Titolo_Autorizzativo_Aggregate;
  /** fetch data from the table: "energy_village.titolo_autorizzativo" using primary key columns */
  energy_village_titolo_autorizzativo_by_pk?: Maybe<Energy_Village_Titolo_Autorizzativo>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table: "flussi_gse.flusso" */
  flussi_gse_flusso: Array<Flussi_Gse_Flusso>;
  /** fetch aggregated fields from the table: "flussi_gse.flusso" */
  flussi_gse_flusso_aggregate: Flussi_Gse_Flusso_Aggregate;
  /** fetch data from the table: "flussi_gse.flusso" using primary key columns */
  flussi_gse_flusso_by_pk?: Maybe<Flussi_Gse_Flusso>;
  /** fetch data from the table: "funzione_log" */
  funzione_log: Array<Funzione_Log>;
  /** fetch aggregated fields from the table: "funzione_log" */
  funzione_log_aggregate: Funzione_Log_Aggregate;
  /** fetch data from the table: "funzione_log" using primary key columns */
  funzione_log_by_pk?: Maybe<Funzione_Log>;
  /** fetch data from the table: "incentivi._stato_calcolo" */
  incentivi__stato_calcolo: Array<Incentivi__Stato_Calcolo>;
  /** fetch aggregated fields from the table: "incentivi._stato_calcolo" */
  incentivi__stato_calcolo_aggregate: Incentivi__Stato_Calcolo_Aggregate;
  /** fetch data from the table: "incentivi._stato_calcolo" using primary key columns */
  incentivi__stato_calcolo_by_pk?: Maybe<Incentivi__Stato_Calcolo>;
  /** fetch data from the table: "incentivi.calcolati" */
  incentivi_calcolati: Array<Incentivi_Calcolati>;
  /** fetch aggregated fields from the table: "incentivi.calcolati" */
  incentivi_calcolati_aggregate: Incentivi_Calcolati_Aggregate;
  /** fetch data from the table: "incentivi.calcolati" using primary key columns */
  incentivi_calcolati_by_pk?: Maybe<Incentivi_Calcolati>;
  /** fetch data from the table: "incentivi.log_ripartizione" */
  incentivi_log_ripartizione: Array<Incentivi_Log_Ripartizione>;
  /** fetch aggregated fields from the table: "incentivi.log_ripartizione" */
  incentivi_log_ripartizione_aggregate: Incentivi_Log_Ripartizione_Aggregate;
  /** fetch data from the table: "incentivi.log_ripartizione" using primary key columns */
  incentivi_log_ripartizione_by_pk?: Maybe<Incentivi_Log_Ripartizione>;
  /** fetch data from the table: "incentivi.ripartizione" */
  incentivi_ripartizione: Array<Incentivi_Ripartizione>;
  /** fetch aggregated fields from the table: "incentivi.ripartizione" */
  incentivi_ripartizione_aggregate: Incentivi_Ripartizione_Aggregate;
  /** fetch data from the table: "incentivi.ripartizione" using primary key columns */
  incentivi_ripartizione_by_pk?: Maybe<Incentivi_Ripartizione>;
  /** fetch data from the table: "indirizzo" */
  indirizzo: Array<Indirizzo>;
  /** fetch aggregated fields from the table: "indirizzo" */
  indirizzo_aggregate: Indirizzo_Aggregate;
  /** fetch data from the table: "indirizzo" using primary key columns */
  indirizzo_by_pk?: Maybe<Indirizzo>;
  /** fetch data from the table: "inseritore" */
  inseritore: Array<Inseritore>;
  /** fetch aggregated fields from the table: "inseritore" */
  inseritore_aggregate: Inseritore_Aggregate;
  /** fetch data from the table: "inseritore" using primary key columns */
  inseritore_by_pk?: Maybe<Inseritore>;
  /** fetch data from the table: "installatore" */
  installatore: Array<Installatore>;
  /** fetch aggregated fields from the table: "installatore" */
  installatore_aggregate: Installatore_Aggregate;
  /** fetch data from the table: "installatore" using primary key columns */
  installatore_by_pk?: Maybe<Installatore>;
  /** fetch data from the table: "log_errori_funzioni" */
  log_errori_funzioni: Array<Log_Errori_Funzioni>;
  /** fetch aggregated fields from the table: "log_errori_funzioni" */
  log_errori_funzioni_aggregate: Log_Errori_Funzioni_Aggregate;
  /** fetch data from the table: "log_errori_funzioni" using primary key columns */
  log_errori_funzioni_by_pk?: Maybe<Log_Errori_Funzioni>;
  /** fetch data from the table: "persona" */
  persona: Array<Persona>;
  /** fetch aggregated fields from the table: "persona" */
  persona_aggregate: Persona_Aggregate;
  /** fetch data from the table: "persona" using primary key columns */
  persona_by_pk?: Maybe<Persona>;
  /** fetch data from the table: "persona_contatto" */
  persona_contatto: Array<Persona_Contatto>;
  /** fetch aggregated fields from the table: "persona_contatto" */
  persona_contatto_aggregate: Persona_Contatto_Aggregate;
  /** fetch data from the table: "persona_contatto" using primary key columns */
  persona_contatto_by_pk?: Maybe<Persona_Contatto>;
  /** fetch data from the table: "pnrr_documenti" */
  pnrr_documenti: Array<Pnrr_Documenti>;
  /** fetch aggregated fields from the table: "pnrr_documenti" */
  pnrr_documenti_aggregate: Pnrr_Documenti_Aggregate;
  /** fetch data from the table: "pnrr_documenti" using primary key columns */
  pnrr_documenti_by_pk?: Maybe<Pnrr_Documenti>;
  /** fetch data from the table: "preset" */
  preset: Array<Preset>;
  /** fetch aggregated fields from the table: "preset" */
  preset_aggregate: Preset_Aggregate;
  /** fetch data from the table: "preset" using primary key columns */
  preset_by_pk?: Maybe<Preset>;
  /** fetch data from the table: "profilo" */
  profilo: Array<Profilo>;
  /** fetch aggregated fields from the table: "profilo" */
  profilo_aggregate: Profilo_Aggregate;
  /** fetch data from the table: "profilo" using primary key columns */
  profilo_by_pk?: Maybe<Profilo>;
  /** execute function "search_asset" which returns "asset" */
  search_asset: Array<Asset>;
  /** execute function "search_asset" and query aggregates on result of table type "asset" */
  search_asset_aggregate: Asset_Aggregate;
  /** execute function "search_cer" which returns "cer" */
  search_cer: Array<Cer>;
  /** execute function "search_cer" and query aggregates on result of table type "cer" */
  search_cer_aggregate: Cer_Aggregate;
  /** execute function "search_sottoscrizioni" which returns "sottoscrizione" */
  search_sottoscrizioni: Array<Sottoscrizione>;
  /** execute function "search_sottoscrizioni" and query aggregates on result of table type "sottoscrizione" */
  search_sottoscrizioni_aggregate: Sottoscrizione_Aggregate;
  /** execute function "search_user_entity" which returns "auth.user_entity" */
  search_user_entity: Array<Auth_User_Entity>;
  /** execute function "search_user_entity" and query aggregates on result of table type "auth.user_entity" */
  search_user_entity_aggregate: Auth_User_Entity_Aggregate;
  /** fetch data from the table: "sottoscrizione" */
  sottoscrizione: Array<Sottoscrizione>;
  /** fetch aggregated fields from the table: "sottoscrizione" */
  sottoscrizione_aggregate: Sottoscrizione_Aggregate;
  /** fetch data from the table: "sottoscrizione" using primary key columns */
  sottoscrizione_by_pk?: Maybe<Sottoscrizione>;
  /** fetch data from the table: "sottoscrizione_documenti" */
  sottoscrizione_documenti: Array<Sottoscrizione_Documenti>;
  /** fetch aggregated fields from the table: "sottoscrizione_documenti" */
  sottoscrizione_documenti_aggregate: Sottoscrizione_Documenti_Aggregate;
  /** fetch data from the table: "sottoscrizione_documenti" using primary key columns */
  sottoscrizione_documenti_by_pk?: Maybe<Sottoscrizione_Documenti>;
  /** fetch data from the table: "sottoscrizione_domande" */
  sottoscrizione_domande: Array<Sottoscrizione_Domande>;
  /** fetch aggregated fields from the table: "sottoscrizione_domande" */
  sottoscrizione_domande_aggregate: Sottoscrizione_Domande_Aggregate;
  /** fetch data from the table: "sottoscrizione_domande" using primary key columns */
  sottoscrizione_domande_by_pk?: Maybe<Sottoscrizione_Domande>;
  /** fetch data from the table: "sottoscrizione_iniziativa" */
  sottoscrizione_iniziativa: Array<Sottoscrizione_Iniziativa>;
  /** fetch aggregated fields from the table: "sottoscrizione_iniziativa" */
  sottoscrizione_iniziativa_aggregate: Sottoscrizione_Iniziativa_Aggregate;
  /** fetch data from the table: "sottoscrizione_iniziativa" using primary key columns */
  sottoscrizione_iniziativa_by_pk?: Maybe<Sottoscrizione_Iniziativa>;
  /** fetch data from the table: "sottoscrizione_zip" */
  sottoscrizione_zip: Array<Sottoscrizione_Zip>;
  /** fetch aggregated fields from the table: "sottoscrizione_zip" */
  sottoscrizione_zip_aggregate: Sottoscrizione_Zip_Aggregate;
  /** fetch data from the table: "sottoscrizione_zip" using primary key columns */
  sottoscrizione_zip_by_pk?: Maybe<Sottoscrizione_Zip>;
  /** fetch data from the table: "staging._stato_sottoscrizione" */
  staging__stato_sottoscrizione: Array<Staging__Stato_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging._stato_sottoscrizione" */
  staging__stato_sottoscrizione_aggregate: Staging__Stato_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging._stato_sottoscrizione" using primary key columns */
  staging__stato_sottoscrizione_by_pk?: Maybe<Staging__Stato_Sottoscrizione>;
  /** fetch data from the table: "staging.azione_sottoscrizione" */
  staging_azione_sottoscrizione: Array<Staging_Azione_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging.azione_sottoscrizione" */
  staging_azione_sottoscrizione_aggregate: Staging_Azione_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging.azione_sottoscrizione" using primary key columns */
  staging_azione_sottoscrizione_by_pk?: Maybe<Staging_Azione_Sottoscrizione>;
  /** fetch data from the table: "staging.gestore_lotto" */
  staging_gestore_lotto: Array<Staging_Gestore_Lotto>;
  /** fetch aggregated fields from the table: "staging.gestore_lotto" */
  staging_gestore_lotto_aggregate: Staging_Gestore_Lotto_Aggregate;
  /** fetch data from the table: "staging.gestore_lotto" using primary key columns */
  staging_gestore_lotto_by_pk?: Maybe<Staging_Gestore_Lotto>;
  /** fetch data from the table: "staging.gestore_sottoscrizione" */
  staging_gestore_sottoscrizione: Array<Staging_Gestore_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging.gestore_sottoscrizione" */
  staging_gestore_sottoscrizione_aggregate: Staging_Gestore_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging.gestore_sottoscrizione" using primary key columns */
  staging_gestore_sottoscrizione_by_pk?: Maybe<Staging_Gestore_Sottoscrizione>;
  /** fetch data from the table: "staging.log" */
  staging_log: Array<Staging_Log>;
  /** fetch aggregated fields from the table: "staging.log" */
  staging_log_aggregate: Staging_Log_Aggregate;
  /** fetch data from the table: "staging.log" using primary key columns */
  staging_log_by_pk?: Maybe<Staging_Log>;
  /** fetch data from the table: "staging.lotto" */
  staging_lotto: Array<Staging_Lotto>;
  /** fetch aggregated fields from the table: "staging.lotto" */
  staging_lotto_aggregate: Staging_Lotto_Aggregate;
  /** fetch data from the table: "staging.lotto" using primary key columns */
  staging_lotto_by_pk?: Maybe<Staging_Lotto>;
  /** fetch data from the table: "staging.mv_refresh_state" */
  staging_mv_refresh_state: Array<Staging_Mv_Refresh_State>;
  /** fetch aggregated fields from the table: "staging.mv_refresh_state" */
  staging_mv_refresh_state_aggregate: Staging_Mv_Refresh_State_Aggregate;
  /** fetch data from the table: "staging.mv_refresh_state" using primary key columns */
  staging_mv_refresh_state_by_pk?: Maybe<Staging_Mv_Refresh_State>;
  /** fetch data from the table: "staging.sottoscrizione" */
  staging_sottoscrizione: Array<Staging_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging.sottoscrizione" */
  staging_sottoscrizione_aggregate: Staging_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging.sottoscrizione" using primary key columns */
  staging_sottoscrizione_by_pk?: Maybe<Staging_Sottoscrizione>;
  /** fetch data from the table: "staging.sottoscrizione_list_mv" */
  staging_sottoscrizione_list_mv: Array<Staging_Sottoscrizione_List_Mv>;
  /** fetch aggregated fields from the table: "staging.sottoscrizione_list_mv" */
  staging_sottoscrizione_list_mv_aggregate: Staging_Sottoscrizione_List_Mv_Aggregate;
  /** fetch data from the table: "staging.sottoscrizione_list_v" */
  staging_sottoscrizione_list_v: Array<Staging_Sottoscrizione_List_V>;
  /** fetch aggregated fields from the table: "staging.sottoscrizione_list_v" */
  staging_sottoscrizione_list_v_aggregate: Staging_Sottoscrizione_List_V_Aggregate;
  /** fetch data from the table: "storage.trigger_debug_log" */
  storage_trigger_debug_log: Array<Storage_Trigger_Debug_Log>;
  /** fetch aggregated fields from the table: "storage.trigger_debug_log" */
  storage_trigger_debug_log_aggregate: Storage_Trigger_Debug_Log_Aggregate;
  /** fetch data from the table: "storage.trigger_debug_log" using primary key columns */
  storage_trigger_debug_log_by_pk?: Maybe<Storage_Trigger_Debug_Log>;
  /** fetch data from the table: "storage.trigger_error_log" */
  storage_trigger_error_log: Array<Storage_Trigger_Error_Log>;
  /** fetch aggregated fields from the table: "storage.trigger_error_log" */
  storage_trigger_error_log_aggregate: Storage_Trigger_Error_Log_Aggregate;
  /** fetch data from the table: "storage.trigger_error_log" using primary key columns */
  storage_trigger_error_log_by_pk?: Maybe<Storage_Trigger_Error_Log>;
  /** fetch data from the table: "storico_sottoscrizione" */
  storico_sottoscrizione: Array<Storico_Sottoscrizione>;
  /** fetch aggregated fields from the table: "storico_sottoscrizione" */
  storico_sottoscrizione_aggregate: Storico_Sottoscrizione_Aggregate;
  /** fetch data from the table: "storico_sottoscrizione" using primary key columns */
  storico_sottoscrizione_by_pk?: Maybe<Storico_Sottoscrizione>;
  /** fetch data from the table: "translate.mapper" */
  translate_mapper: Array<Translate_Mapper>;
  /** fetch aggregated fields from the table: "translate.mapper" */
  translate_mapper_aggregate: Translate_Mapper_Aggregate;
  /** fetch data from the table: "translate.mapper" using primary key columns */
  translate_mapper_by_pk?: Maybe<Translate_Mapper>;
  /** fetch data from the table: "unita_amministrativa.citta" */
  unita_amministrativa_citta: Array<Unita_Amministrativa_Citta>;
  /** fetch aggregated fields from the table: "unita_amministrativa.citta" */
  unita_amministrativa_citta_aggregate: Unita_Amministrativa_Citta_Aggregate;
  /** fetch data from the table: "unita_amministrativa.citta" using primary key columns */
  unita_amministrativa_citta_by_pk?: Maybe<Unita_Amministrativa_Citta>;
  /** fetch data from the table: "unita_amministrativa.nazione" */
  unita_amministrativa_nazione: Array<Unita_Amministrativa_Nazione>;
  /** fetch aggregated fields from the table: "unita_amministrativa.nazione" */
  unita_amministrativa_nazione_aggregate: Unita_Amministrativa_Nazione_Aggregate;
  /** fetch data from the table: "unita_amministrativa.nazione" using primary key columns */
  unita_amministrativa_nazione_by_pk?: Maybe<Unita_Amministrativa_Nazione>;
  /** fetch data from the table: "unita_amministrativa.provincia" */
  unita_amministrativa_provincia: Array<Unita_Amministrativa_Provincia>;
  /** fetch aggregated fields from the table: "unita_amministrativa.provincia" */
  unita_amministrativa_provincia_aggregate: Unita_Amministrativa_Provincia_Aggregate;
  /** fetch data from the table: "unita_amministrativa.provincia" using primary key columns */
  unita_amministrativa_provincia_by_pk?: Maybe<Unita_Amministrativa_Provincia>;
  /** fetch data from the table: "unita_amministrativa.regione" */
  unita_amministrativa_regione: Array<Unita_Amministrativa_Regione>;
  /** fetch aggregated fields from the table: "unita_amministrativa.regione" */
  unita_amministrativa_regione_aggregate: Unita_Amministrativa_Regione_Aggregate;
  /** fetch data from the table: "unita_amministrativa.regione" using primary key columns */
  unita_amministrativa_regione_by_pk?: Maybe<Unita_Amministrativa_Regione>;
  /** fetch data from the table: "v_superadmin_sottoscrizioni" */
  v_superadmin_sottoscrizioni: Array<V_Superadmin_Sottoscrizioni>;
  /** fetch aggregated fields from the table: "v_superadmin_sottoscrizioni" */
  v_superadmin_sottoscrizioni_aggregate: V_Superadmin_Sottoscrizioni_Aggregate;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "white_label.associazione" */
  white_label_associazione: Array<White_Label_Associazione>;
  /** fetch aggregated fields from the table: "white_label.associazione" */
  white_label_associazione_aggregate: White_Label_Associazione_Aggregate;
  /** fetch data from the table: "white_label.associazione" using primary key columns */
  white_label_associazione_by_pk?: Maybe<White_Label_Associazione>;
  /** fetch data from the table: "white_label.configurazione" */
  white_label_configurazione: Array<White_Label_Configurazione>;
  /** fetch aggregated fields from the table: "white_label.configurazione" */
  white_label_configurazione_aggregate: White_Label_Configurazione_Aggregate;
  /** fetch data from the table: "white_label.configurazione" using primary key columns */
  white_label_configurazione_by_pk?: Maybe<White_Label_Configurazione>;
  /** fetch data from the table: "white_label.gestore" */
  white_label_gestore: Array<White_Label_Gestore>;
  /** fetch aggregated fields from the table: "white_label.gestore" */
  white_label_gestore_aggregate: White_Label_Gestore_Aggregate;
  /** fetch data from the table: "white_label.gestore" using primary key columns */
  white_label_gestore_by_pk?: Maybe<White_Label_Gestore>;
  /** fetch data from the table: "white_label.idp" */
  white_label_idp: Array<White_Label_Idp>;
  /** fetch aggregated fields from the table: "white_label.idp" */
  white_label_idp_aggregate: White_Label_Idp_Aggregate;
  /** fetch data from the table: "white_label.idp" using primary key columns */
  white_label_idp_by_pk?: Maybe<White_Label_Idp>;
};


export type Query_Root_Destinazione_CompatibileArgs = {
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Query_Root_Destinazione_Compatibile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Query_Root_Pod_DuplicatoArgs = {
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Query_Root_Pod_Duplicato_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Query_Root_Pod_Duplicato_By_PkArgs = {
  pod: Scalars['String']['input'];
};


export type Query_Root_Sottoscrizione_Tipo_RichiestaArgs = {
  distinct_on?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Order_By>>;
  where?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>;
};


export type Query_Root_Sottoscrizione_Tipo_Richiesta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Order_By>>;
  where?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>;
};


export type Query_Root_Sottoscrizione_Tipo_Richiesta_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_Root_Superadmin_Elimina_Sottoscrizione_EsitoArgs = {
  distinct_on?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Order_By>>;
  where?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
};


export type Query_Root_Superadmin_Elimina_Sottoscrizione_Esito_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Order_By>>;
  where?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
};


export type Query_Root_Superadmin_Elimina_Sottoscrizione_Esito_By_PkArgs = {
  sottoscrizione_id: Scalars['uuid']['input'];
};


export type Query_Root_Tipo_Dato_ConsumoArgs = {
  distinct_on?: InputMaybe<Array<_Tipo_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipo_Dato_Consumo_Order_By>>;
  where?: InputMaybe<_Tipo_Dato_Consumo_Bool_Exp>;
};


export type Query_Root_Tipo_Dato_Consumo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Tipo_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipo_Dato_Consumo_Order_By>>;
  where?: InputMaybe<_Tipo_Dato_Consumo_Bool_Exp>;
};


export type Query_Root_Tipo_Dato_Consumo_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_Root_Tipologia_ProfiloArgs = {
  distinct_on?: InputMaybe<Array<_Tipologia_Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipologia_Profilo_Order_By>>;
  where?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
};


export type Query_Root_Tipologia_Profilo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Tipologia_Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipologia_Profilo_Order_By>>;
  where?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
};


export type Query_Root_Tipologia_Profilo_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAdmin__Stato_Richiesta_PubblicazioneArgs = {
  distinct_on?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Query_RootAdmin__Stato_Richiesta_Pubblicazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Query_RootAdmin__Stato_Richiesta_Pubblicazione_By_PkArgs = {
  stato: Scalars['String']['input'];
};


export type Query_RootAdmin__Type_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Admin__Type_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Type_Referral_Order_By>>;
  where?: InputMaybe<Admin__Type_Referral_Bool_Exp>;
};


export type Query_RootAdmin__Type_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin__Type_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Type_Referral_Order_By>>;
  where?: InputMaybe<Admin__Type_Referral_Bool_Exp>;
};


export type Query_RootAdmin__Type_Referral_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_RootAdmin_Consenso_PrivacyArgs = {
  distinct_on?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Consenso_Privacy_Order_By>>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};


export type Query_RootAdmin_Consenso_Privacy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Consenso_Privacy_Order_By>>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};


export type Query_RootAdmin_Consenso_Privacy_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_Parametri_Algoritmo_IncentiviArgs = {
  distinct_on?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Order_By>>;
  where?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>;
};


export type Query_RootAdmin_Parametri_Algoritmo_Incentivi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Order_By>>;
  where?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>;
};


export type Query_RootAdmin_Parametri_Algoritmo_Incentivi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Admin_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Referral_Order_By>>;
  where?: InputMaybe<Admin_Referral_Bool_Exp>;
};


export type Query_RootAdmin_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Referral_Order_By>>;
  where?: InputMaybe<Admin_Referral_Bool_Exp>;
};


export type Query_RootAdmin_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_Richiesta_PubblicazioneArgs = {
  distinct_on?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Query_RootAdmin_Richiesta_Pubblicazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Query_RootAdmin_Richiesta_Pubblicazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_Utilizzo_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Admin_Utilizzo_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Utilizzo_Referral_Order_By>>;
  where?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
};


export type Query_RootAdmin_Utilizzo_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Utilizzo_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Utilizzo_Referral_Order_By>>;
  where?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
};


export type Query_RootAdmin_Utilizzo_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnagrafica_Codice_AtecoArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Codice_Ateco_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Codice_Ateco_Order_By>>;
  where?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
};


export type Query_RootAnagrafica_Codice_Ateco_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Codice_Ateco_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Codice_Ateco_Order_By>>;
  where?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
};


export type Query_RootAnagrafica_Codice_Ateco_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAnagrafica_Forma_GiuridicaArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
};


export type Query_RootAnagrafica_Forma_Giuridica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
};


export type Query_RootAnagrafica_Forma_Giuridica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnagrafica_Forma_Giuridica_CerArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
};


export type Query_RootAnagrafica_Forma_Giuridica_Cer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
};


export type Query_RootAnagrafica_Forma_Giuridica_Cer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnagrafica_Tipo_ContattoArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
};


export type Query_RootAnagrafica_Tipo_Contatto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
};


export type Query_RootAnagrafica_Tipo_Contatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnagrafica_Tipo_PromotoreArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
};


export type Query_RootAnagrafica_Tipo_Promotore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
};


export type Query_RootAnagrafica_Tipo_Promotore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnagrafica_Tipologia_RappresentanteArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
};


export type Query_RootAnagrafica_Tipologia_Rappresentante_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
};


export type Query_RootAnagrafica_Tipologia_Rappresentante_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssetArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Query_RootAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Query_RootAsset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_CaratteristicaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Caratteristica_Order_By>>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};


export type Query_RootAsset_Caratteristica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Caratteristica_Order_By>>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};


export type Query_RootAsset_Caratteristica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_ConsumoArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


export type Query_RootAsset_Consumo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


export type Query_RootAsset_Consumo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Dato_ConsumoArgs = {
  distinct_on?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Dato_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};


export type Query_RootAsset_Dato_Consumo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Dato_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};


export type Query_RootAsset_Dato_Consumo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_EnergiaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Energia_Order_By>>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};


export type Query_RootAsset_Energia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Energia_Order_By>>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};


export type Query_RootAsset_Energia_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_FounderArgs = {
  distinct_on?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Founder_Order_By>>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};


export type Query_RootAsset_Founder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Founder_Order_By>>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};


export type Query_RootAsset_Founder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_GestoreArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


export type Query_RootAsset_Gestore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


export type Query_RootAsset_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_ProduzioneArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


export type Query_RootAsset_Produzione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


export type Query_RootAsset_Produzione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Produzione_UnitaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Produzione_Unita_SezioneArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_Sezione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_Sezione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Produzione_Unita_Sezione_IncentiviArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_Sezione_Incentivi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_Sezione_Incentivi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_Produzione_Unita_Sezione_Titolo_AutorizzativoArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_Sezione_Titolo_Autorizzativo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};


export type Query_RootAsset_Produzione_Unita_Sezione_Titolo_Autorizzativo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAsset_SpazioArgs = {
  distinct_on?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Spazio_Order_By>>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};


export type Query_RootAsset_Spazio_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Spazio_Order_By>>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};


export type Query_RootAsset_Spazio_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuth_Event_EntityArgs = {
  distinct_on?: InputMaybe<Array<Auth_Event_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Event_Entity_Order_By>>;
  where?: InputMaybe<Auth_Event_Entity_Bool_Exp>;
};


export type Query_RootAuth_Event_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Event_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Event_Entity_Order_By>>;
  where?: InputMaybe<Auth_Event_Entity_Bool_Exp>;
};


export type Query_RootAuth_Event_Entity_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuth_Federated_IdentityArgs = {
  distinct_on?: InputMaybe<Array<Auth_Federated_Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Federated_Identity_Order_By>>;
  where?: InputMaybe<Auth_Federated_Identity_Bool_Exp>;
};


export type Query_RootAuth_Federated_Identity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Federated_Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Federated_Identity_Order_By>>;
  where?: InputMaybe<Auth_Federated_Identity_Bool_Exp>;
};


export type Query_RootAuth_Federated_Identity_By_PkArgs = {
  identity_provider: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type Query_RootAuth_Role_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Attribute_Order_By>>;
  where?: InputMaybe<Auth_Role_Attribute_Bool_Exp>;
};


export type Query_RootAuth_Role_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Attribute_Order_By>>;
  where?: InputMaybe<Auth_Role_Attribute_Bool_Exp>;
};


export type Query_RootAuth_Role_Attribute_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuth_User_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Attribute_Order_By>>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};


export type Query_RootAuth_User_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Attribute_Order_By>>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};


export type Query_RootAuth_User_Attribute_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuth_User_EntityArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Query_RootAuth_User_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Query_RootAuth_User_Entity_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Query_RootCerArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Query_RootCer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Query_RootCer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_CabinaArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


export type Query_RootCer_Cabina_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


export type Query_RootCer_Cabina_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_Cabina_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Snapshot_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};


export type Query_RootCer_Cabina_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Snapshot_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};


export type Query_RootCer_Cabina_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_Categoria_AdesioneArgs = {
  distinct_on?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Categoria_Adesione_Order_By>>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};


export type Query_RootCer_Categoria_Adesione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Categoria_Adesione_Order_By>>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};


export type Query_RootCer_Categoria_Adesione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_Configurazione_Destinazione_ContributoArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


export type Query_RootCer_Configurazione_Destinazione_Contributo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


export type Query_RootCer_Configurazione_Destinazione_Contributo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_ContattiArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


export type Query_RootCer_Contatti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


export type Query_RootCer_Contatti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_Destinazione_ContributoArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


export type Query_RootCer_Destinazione_Contributo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


export type Query_RootCer_Destinazione_Contributo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_GeomArgs = {
  distinct_on?: InputMaybe<Array<Cer_Geom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Geom_Order_By>>;
  where?: InputMaybe<Cer_Geom_Bool_Exp>;
};


export type Query_RootCer_Geom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Geom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Geom_Order_By>>;
  where?: InputMaybe<Cer_Geom_Bool_Exp>;
};


export type Query_RootCer_Geom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_GestoreArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


export type Query_RootCer_Gestore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


export type Query_RootCer_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCer_Search_IndexArgs = {
  distinct_on?: InputMaybe<Array<Cer_Search_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Search_Index_Order_By>>;
  where?: InputMaybe<Cer_Search_Index_Bool_Exp>;
};


export type Query_RootCer_Search_Index_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Search_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Search_Index_Order_By>>;
  where?: InputMaybe<Cer_Search_Index_Bool_Exp>;
};


export type Query_RootCer_Search_Index_By_PkArgs = {
  cer_id: Scalars['uuid']['input'];
};


export type Query_RootCer_TecnicoArgs = {
  distinct_on?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Tecnico_Order_By>>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};


export type Query_RootCer_Tecnico_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Tecnico_Order_By>>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};


export type Query_RootCer_Tecnico_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCheck_Pod_DuplicatoArgs = {
  args: Check_Pod_Duplicato_Args;
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Query_RootCheck_Pod_Duplicato_AggregateArgs = {
  args: Check_Pod_Duplicato_Args;
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Query_RootCodice_OperatoreArgs = {
  distinct_on?: InputMaybe<Array<Codice_Operatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Codice_Operatore_Order_By>>;
  where?: InputMaybe<Codice_Operatore_Bool_Exp>;
};


export type Query_RootCodice_Operatore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Codice_Operatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Codice_Operatore_Order_By>>;
  where?: InputMaybe<Codice_Operatore_Bool_Exp>;
};


export type Query_RootCodice_Operatore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootComunicazioni_EmailArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
};


export type Query_RootComunicazioni_Email_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
};


export type Query_RootComunicazioni_Email_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootComunicazioni_Email_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Template_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
};


export type Query_RootComunicazioni_Email_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Template_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
};


export type Query_RootComunicazioni_Email_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootComunicazioni_SmsArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Sms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Sms_Order_By>>;
  where?: InputMaybe<Comunicazioni_Sms_Bool_Exp>;
};


export type Query_RootComunicazioni_Sms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Sms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Sms_Order_By>>;
  where?: InputMaybe<Comunicazioni_Sms_Bool_Exp>;
};


export type Query_RootComunicazioni_Sms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCondivisione__Stato_CondivisioneArgs = {
  distinct_on?: InputMaybe<Array<Condivisione__Stato_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione__Stato_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione__Stato_Condivisione_Bool_Exp>;
};


export type Query_RootCondivisione__Stato_Condivisione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione__Stato_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione__Stato_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione__Stato_Condivisione_Bool_Exp>;
};


export type Query_RootCondivisione__Stato_Condivisione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_RootCondivisione_Accetta_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Accetta_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Accetta_Response_Order_By>>;
  where?: InputMaybe<Condivisione_Accetta_Response_Bool_Exp>;
};


export type Query_RootCondivisione_Accetta_Response_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Accetta_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Accetta_Response_Order_By>>;
  where?: InputMaybe<Condivisione_Accetta_Response_Bool_Exp>;
};


export type Query_RootCondivisione_CondivisioneArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};


export type Query_RootCondivisione_Condivisione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};


export type Query_RootCondivisione_Condivisione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCondivisione_Log_CondivisioneArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Log_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Log_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Log_Condivisione_Bool_Exp>;
};


export type Query_RootCondivisione_Log_Condivisione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Log_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Log_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Log_Condivisione_Bool_Exp>;
};


export type Query_RootCondivisione_Log_Condivisione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConfirmoGetArgs = {
  input: ConfirmoGetInput;
};


export type Query_RootConfirmoGetFirmaArgs = {
  input: ConfirmoGetFirmaInput;
};


export type Query_RootContattoArgs = {
  distinct_on?: InputMaybe<Array<Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contatto_Order_By>>;
  where?: InputMaybe<Contatto_Bool_Exp>;
};


export type Query_RootContatto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contatto_Order_By>>;
  where?: InputMaybe<Contatto_Bool_Exp>;
};


export type Query_RootContatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCrm_Audit_EventArgs = {
  distinct_on?: InputMaybe<Array<Crm_Audit_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Audit_Event_Order_By>>;
  where?: InputMaybe<Crm_Audit_Event_Bool_Exp>;
};


export type Query_RootCrm_Audit_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Audit_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Audit_Event_Order_By>>;
  where?: InputMaybe<Crm_Audit_Event_Bool_Exp>;
};


export type Query_RootCrm_Audit_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDebug_Sottoscrizione_After_LogArgs = {
  distinct_on?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Order_By>>;
  where?: InputMaybe<Debug_Sottoscrizione_After_Log_Bool_Exp>;
};


export type Query_RootDebug_Sottoscrizione_After_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Order_By>>;
  where?: InputMaybe<Debug_Sottoscrizione_After_Log_Bool_Exp>;
};


export type Query_RootDebug_Sottoscrizione_After_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDestinazioni_CompatibiliArgs = {
  args: Destinazioni_Compatibili_Args;
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Query_RootDestinazioni_Compatibili_AggregateArgs = {
  args: Destinazioni_Compatibili_Args;
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Query_RootDevice_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Device_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Device_Order_By>>;
  where?: InputMaybe<Device_Device_Bool_Exp>;
};


export type Query_RootDevice_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Device_Order_By>>;
  where?: InputMaybe<Device_Device_Bool_Exp>;
};


export type Query_RootDevice_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village__Azioni_Founder_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Azioni_Founder_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Azioni_Founder_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_RootEnergy_Village__Azioni_Prosumer_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Azioni_Prosumer_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Azioni_Prosumer_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_RootEnergy_Village__Azioni_Tecnico_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Azioni_Tecnico_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Azioni_Tecnico_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_RootEnergy_Village__Cer_Filter_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village__Cer_Filter_Options_Bool_Exp>;
};


export type Query_RootEnergy_Village__Cer_Filter_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village__Cer_Filter_Options_Bool_Exp>;
};


export type Query_RootEnergy_Village__Cer_Filter_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnergy_Village__Stato_CerArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Cer_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Cer_Bool_Exp>;
};


export type Query_RootEnergy_Village__Stato_Cer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Cer_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Cer_Bool_Exp>;
};


export type Query_RootEnergy_Village__Stato_Cer_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnergy_Village__Stato_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Stato_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Bool_Exp>;
};


export type Query_RootEnergy_Village__Stato_Sottoscrizione_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnergy_Village__Tipo_DomandaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Domanda_Bool_Exp>;
};


export type Query_RootEnergy_Village__Tipo_Domanda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Domanda_Bool_Exp>;
};


export type Query_RootEnergy_Village__Tipo_Domanda_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnergy_Village__Tipo_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Feedback_Bool_Exp>;
};


export type Query_RootEnergy_Village__Tipo_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Feedback_Bool_Exp>;
};


export type Query_RootEnergy_Village__Tipo_Feedback_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnergy_Village_AreaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEnergy_Village_Area_CittaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Citta_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_Citta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Citta_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_Citta_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEnergy_Village_Area_ProvinciaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Provincia_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Provincia_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_Provincia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Provincia_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Provincia_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_Provincia_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEnergy_Village_Area_RegioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Regione_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Regione_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_Regione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Regione_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Regione_Bool_Exp>;
};


export type Query_RootEnergy_Village_Area_Regione_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEnergy_Village_AzioniArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Azioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Azioni_Order_By>>;
  where?: InputMaybe<Energy_Village_Azioni_Bool_Exp>;
};


export type Query_RootEnergy_Village_Azioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Azioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Azioni_Order_By>>;
  where?: InputMaybe<Energy_Village_Azioni_Bool_Exp>;
};


export type Query_RootEnergy_Village_Azioni_By_PkArgs = {
  founder: Energy_Village__Azioni_Founder_Sottoscrizione_Enum;
  prosumer: Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum;
  tecnico: Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum;
};


export type Query_RootEnergy_Village_CabinaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
};


export type Query_RootEnergy_Village_Cabina_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
};


export type Query_RootEnergy_Village_Cabina_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEnergy_Village_Cabina_CittaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};


export type Query_RootEnergy_Village_Cabina_Citta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};


export type Query_RootEnergy_Village_Cabina_Citta_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_CaratteristicaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Caratteristica_Order_By>>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};


export type Query_RootEnergy_Village_Caratteristica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Caratteristica_Order_By>>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};


export type Query_RootEnergy_Village_Caratteristica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_Cer_Filter_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village_Cer_Filter_Options_Bool_Exp>;
};


export type Query_RootEnergy_Village_Cer_Filter_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village_Cer_Filter_Options_Bool_Exp>;
};


export type Query_RootEnergy_Village_Cer_Filter_Options_By_PkArgs = {
  filter: Energy_Village__Cer_Filter_Options_Enum;
};


export type Query_RootEnergy_Village_DimensioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Dimensione_Order_By>>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};


export type Query_RootEnergy_Village_Dimensione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Dimensione_Order_By>>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};


export type Query_RootEnergy_Village_Dimensione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
};


export type Query_RootEnergy_Village_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
};


export type Query_RootEnergy_Village_Feedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_Incentivo_ImpiantoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};


export type Query_RootEnergy_Village_Incentivo_Impianto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};


export type Query_RootEnergy_Village_Incentivo_Impianto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_OrarioArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Orario_Order_By>>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};


export type Query_RootEnergy_Village_Orario_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Orario_Order_By>>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};


export type Query_RootEnergy_Village_Orario_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_Potenza_ImpiantoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};


export type Query_RootEnergy_Village_Potenza_Impianto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};


export type Query_RootEnergy_Village_Potenza_Impianto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_Potenzialita_CabinaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
};


export type Query_RootEnergy_Village_Potenzialita_Cabina_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
};


export type Query_RootEnergy_Village_Potenzialita_Cabina_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEnergy_Village_Tipo_Spazio_DisponibileArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
};


export type Query_RootEnergy_Village_Tipo_Spazio_Disponibile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
};


export type Query_RootEnergy_Village_Tipo_Spazio_Disponibile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_Tipologia_AbitativaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};


export type Query_RootEnergy_Village_Tipologia_Abitativa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};


export type Query_RootEnergy_Village_Tipologia_Abitativa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_Tipologia_AssetArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};


export type Query_RootEnergy_Village_Tipologia_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};


export type Query_RootEnergy_Village_Tipologia_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnergy_Village_Titolo_AutorizzativoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Bool_Exp>;
};


export type Query_RootEnergy_Village_Titolo_Autorizzativo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Bool_Exp>;
};


export type Query_RootEnergy_Village_Titolo_Autorizzativo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFlussi_Gse_FlussoArgs = {
  distinct_on?: InputMaybe<Array<Flussi_Gse_Flusso_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flussi_Gse_Flusso_Order_By>>;
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
};


export type Query_RootFlussi_Gse_Flusso_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flussi_Gse_Flusso_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flussi_Gse_Flusso_Order_By>>;
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
};


export type Query_RootFlussi_Gse_Flusso_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFunzione_LogArgs = {
  distinct_on?: InputMaybe<Array<Funzione_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funzione_Log_Order_By>>;
  where?: InputMaybe<Funzione_Log_Bool_Exp>;
};


export type Query_RootFunzione_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funzione_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funzione_Log_Order_By>>;
  where?: InputMaybe<Funzione_Log_Bool_Exp>;
};


export type Query_RootFunzione_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootIncentivi__Stato_CalcoloArgs = {
  distinct_on?: InputMaybe<Array<Incentivi__Stato_Calcolo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi__Stato_Calcolo_Order_By>>;
  where?: InputMaybe<Incentivi__Stato_Calcolo_Bool_Exp>;
};


export type Query_RootIncentivi__Stato_Calcolo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi__Stato_Calcolo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi__Stato_Calcolo_Order_By>>;
  where?: InputMaybe<Incentivi__Stato_Calcolo_Bool_Exp>;
};


export type Query_RootIncentivi__Stato_Calcolo_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_RootIncentivi_CalcolatiArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Calcolati_Order_By>>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};


export type Query_RootIncentivi_Calcolati_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Calcolati_Order_By>>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};


export type Query_RootIncentivi_Calcolati_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIncentivi_Log_RipartizioneArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Log_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Log_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Log_Ripartizione_Bool_Exp>;
};


export type Query_RootIncentivi_Log_Ripartizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Log_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Log_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Log_Ripartizione_Bool_Exp>;
};


export type Query_RootIncentivi_Log_Ripartizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIncentivi_RipartizioneArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
};


export type Query_RootIncentivi_Ripartizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
};


export type Query_RootIncentivi_Ripartizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIndirizzoArgs = {
  distinct_on?: InputMaybe<Array<Indirizzo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indirizzo_Order_By>>;
  where?: InputMaybe<Indirizzo_Bool_Exp>;
};


export type Query_RootIndirizzo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indirizzo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indirizzo_Order_By>>;
  where?: InputMaybe<Indirizzo_Bool_Exp>;
};


export type Query_RootIndirizzo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInseritoreArgs = {
  distinct_on?: InputMaybe<Array<Inseritore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inseritore_Order_By>>;
  where?: InputMaybe<Inseritore_Bool_Exp>;
};


export type Query_RootInseritore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inseritore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inseritore_Order_By>>;
  where?: InputMaybe<Inseritore_Bool_Exp>;
};


export type Query_RootInseritore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInstallatoreArgs = {
  distinct_on?: InputMaybe<Array<Installatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installatore_Order_By>>;
  where?: InputMaybe<Installatore_Bool_Exp>;
};


export type Query_RootInstallatore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installatore_Order_By>>;
  where?: InputMaybe<Installatore_Bool_Exp>;
};


export type Query_RootInstallatore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLog_Errori_FunzioniArgs = {
  distinct_on?: InputMaybe<Array<Log_Errori_Funzioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Log_Errori_Funzioni_Order_By>>;
  where?: InputMaybe<Log_Errori_Funzioni_Bool_Exp>;
};


export type Query_RootLog_Errori_Funzioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Log_Errori_Funzioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Log_Errori_Funzioni_Order_By>>;
  where?: InputMaybe<Log_Errori_Funzioni_Bool_Exp>;
};


export type Query_RootLog_Errori_Funzioni_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPersonaArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};


export type Query_RootPersona_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};


export type Query_RootPersona_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPersona_ContattoArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


export type Query_RootPersona_Contatto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


export type Query_RootPersona_Contatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPnrr_DocumentiArgs = {
  distinct_on?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pnrr_Documenti_Order_By>>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};


export type Query_RootPnrr_Documenti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pnrr_Documenti_Order_By>>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};


export type Query_RootPnrr_Documenti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPresetArgs = {
  distinct_on?: InputMaybe<Array<Preset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Preset_Order_By>>;
  where?: InputMaybe<Preset_Bool_Exp>;
};


export type Query_RootPreset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Preset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Preset_Order_By>>;
  where?: InputMaybe<Preset_Bool_Exp>;
};


export type Query_RootPreset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProfiloArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


export type Query_RootProfilo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


export type Query_RootProfilo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSearch_AssetArgs = {
  args?: InputMaybe<Search_Asset_Args>;
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Query_RootSearch_Asset_AggregateArgs = {
  args?: InputMaybe<Search_Asset_Args>;
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Query_RootSearch_CerArgs = {
  args?: InputMaybe<Search_Cer_Args>;
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Query_RootSearch_Cer_AggregateArgs = {
  args?: InputMaybe<Search_Cer_Args>;
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Query_RootSearch_SottoscrizioniArgs = {
  args?: InputMaybe<Search_Sottoscrizioni_Args>;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Query_RootSearch_Sottoscrizioni_AggregateArgs = {
  args?: InputMaybe<Search_Sottoscrizioni_Args>;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Query_RootSearch_User_EntityArgs = {
  args?: InputMaybe<Search_User_Entity_Args>;
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Query_RootSearch_User_Entity_AggregateArgs = {
  args?: InputMaybe<Search_User_Entity_Args>;
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Query_RootSottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Query_RootSottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Query_RootSottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSottoscrizione_DocumentiArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Documenti_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};


export type Query_RootSottoscrizione_Documenti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Documenti_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};


export type Query_RootSottoscrizione_Documenti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSottoscrizione_DomandeArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Domande_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};


export type Query_RootSottoscrizione_Domande_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Domande_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};


export type Query_RootSottoscrizione_Domande_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSottoscrizione_IniziativaArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


export type Query_RootSottoscrizione_Iniziativa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


export type Query_RootSottoscrizione_Iniziativa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSottoscrizione_ZipArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Zip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Zip_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
};


export type Query_RootSottoscrizione_Zip_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Zip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Zip_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
};


export type Query_RootSottoscrizione_Zip_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStaging__Stato_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging__Stato_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging__Stato_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging__Stato_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging__Stato_Sottoscrizione_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStaging_Azione_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging_Azione_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging_Azione_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStaging_Gestore_LottoArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};


export type Query_RootStaging_Gestore_Lotto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};


export type Query_RootStaging_Gestore_Lotto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStaging_Gestore_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging_Gestore_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging_Gestore_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStaging_LogArgs = {
  distinct_on?: InputMaybe<Array<Staging_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Log_Order_By>>;
  where?: InputMaybe<Staging_Log_Bool_Exp>;
};


export type Query_RootStaging_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Log_Order_By>>;
  where?: InputMaybe<Staging_Log_Bool_Exp>;
};


export type Query_RootStaging_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStaging_LottoArgs = {
  distinct_on?: InputMaybe<Array<Staging_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
};


export type Query_RootStaging_Lotto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
};


export type Query_RootStaging_Lotto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStaging_Mv_Refresh_StateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Mv_Refresh_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Mv_Refresh_State_Order_By>>;
  where?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
};


export type Query_RootStaging_Mv_Refresh_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Mv_Refresh_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Mv_Refresh_State_Order_By>>;
  where?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
};


export type Query_RootStaging_Mv_Refresh_State_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootStaging_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStaging_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStaging_Sottoscrizione_List_MvArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_Mv_Bool_Exp>;
};


export type Query_RootStaging_Sottoscrizione_List_Mv_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_Mv_Bool_Exp>;
};


export type Query_RootStaging_Sottoscrizione_List_VArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_V_Bool_Exp>;
};


export type Query_RootStaging_Sottoscrizione_List_V_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_V_Bool_Exp>;
};


export type Query_RootStorage_Trigger_Debug_LogArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Debug_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Debug_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Debug_Log_Bool_Exp>;
};


export type Query_RootStorage_Trigger_Debug_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Debug_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Debug_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Debug_Log_Bool_Exp>;
};


export type Query_RootStorage_Trigger_Debug_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootStorage_Trigger_Error_LogArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Error_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Error_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Error_Log_Bool_Exp>;
};


export type Query_RootStorage_Trigger_Error_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Error_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Error_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Error_Log_Bool_Exp>;
};


export type Query_RootStorage_Trigger_Error_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootStorico_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStorico_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};


export type Query_RootStorico_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTranslate_MapperArgs = {
  distinct_on?: InputMaybe<Array<Translate_Mapper_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translate_Mapper_Order_By>>;
  where?: InputMaybe<Translate_Mapper_Bool_Exp>;
};


export type Query_RootTranslate_Mapper_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Translate_Mapper_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translate_Mapper_Order_By>>;
  where?: InputMaybe<Translate_Mapper_Bool_Exp>;
};


export type Query_RootTranslate_Mapper_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUnita_Amministrativa_CittaArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Citta_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Citta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Citta_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Citta_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUnita_Amministrativa_NazioneArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Nazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Nazione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Nazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Nazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Nazione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Nazione_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUnita_Amministrativa_ProvinciaArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Provincia_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Provincia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Provincia_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Provincia_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUnita_Amministrativa_RegioneArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Regione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Regione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Regione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
};


export type Query_RootUnita_Amministrativa_Regione_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootV_Superadmin_SottoscrizioniArgs = {
  distinct_on?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Order_By>>;
  where?: InputMaybe<V_Superadmin_Sottoscrizioni_Bool_Exp>;
};


export type Query_RootV_Superadmin_Sottoscrizioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Order_By>>;
  where?: InputMaybe<V_Superadmin_Sottoscrizioni_Bool_Exp>;
};


export type Query_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Query_RootWhite_Label_AssociazioneArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


export type Query_RootWhite_Label_Associazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


export type Query_RootWhite_Label_Associazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWhite_Label_ConfigurazioneArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Configurazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Configurazione_Order_By>>;
  where?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
};


export type Query_RootWhite_Label_Configurazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Configurazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Configurazione_Order_By>>;
  where?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
};


export type Query_RootWhite_Label_Configurazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWhite_Label_GestoreArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Gestore_Order_By>>;
  where?: InputMaybe<White_Label_Gestore_Bool_Exp>;
};


export type Query_RootWhite_Label_Gestore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Gestore_Order_By>>;
  where?: InputMaybe<White_Label_Gestore_Bool_Exp>;
};


export type Query_RootWhite_Label_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWhite_Label_IdpArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Idp_Order_By>>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};


export type Query_RootWhite_Label_Idp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Idp_Order_By>>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};


export type Query_RootWhite_Label_Idp_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Search_Asset_Args = {
  p_search?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Cer_Args = {
  p_abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  p_only_root?: InputMaybe<Scalars['Boolean']['input']>;
  p_richieste_gt_zero?: InputMaybe<Scalars['Boolean']['input']>;
  p_root_id?: InputMaybe<Scalars['uuid']['input']>;
  p_search?: InputMaybe<Scalars['String']['input']>;
  p_stato?: InputMaybe<Scalars['_text']['input']>;
};

export type Search_Sottoscrizioni_Args = {
  p_cabina?: InputMaybe<Scalars['_int4']['input']>;
  p_codice_personale?: InputMaybe<Scalars['String']['input']>;
  p_codice_presentatore?: InputMaybe<Scalars['String']['input']>;
  p_configurazioni?: InputMaybe<Scalars['_uuid']['input']>;
  p_data_a?: InputMaybe<Scalars['date']['input']>;
  p_data_da?: InputMaybe<Scalars['date']['input']>;
  p_richiesta?: InputMaybe<Scalars['_text']['input']>;
  p_search?: InputMaybe<Scalars['String']['input']>;
  p_stato?: InputMaybe<Scalars['_text']['input']>;
};

export type Search_User_Entity_Args = {
  p_search?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "sottoscrizione" */
export type Sottoscrizione = {
  __typename?: 'sottoscrizione';
  altro_fascicolo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  asset_consumo?: Maybe<Asset_Consumo>;
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  asset_produzione?: Maybe<Asset_Produzione>;
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  categoria_adesione?: Maybe<Scalars['jsonb']['output']>;
  categoria_adesione_id?: Maybe<Scalars['uuid']['output']>;
  categoria_adesione_produttore_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cer_cabina?: Maybe<Cer_Cabina>;
  cer_cabina_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cer_categoria_adesione?: Maybe<Cer_Categoria_Adesione>;
  /** An object relationship */
  cer_categoria_adesione_produttore?: Maybe<Cer_Categoria_Adesione>;
  codice_univico_promotore?: Maybe<Scalars['String']['output']>;
  confirmo_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  contratto?: Maybe<Files>;
  contratto_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  data_ammissione?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_associazione" */
  data_associazione?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_opzionata" */
  data_opzione?: Maybe<Scalars['timestamptz']['output']>;
  data_recesso?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_scadenza" */
  data_scadenza?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  documenti: Array<Sottoscrizione_Documenti>;
  /** An aggregate relationship */
  documenti_aggregate: Sottoscrizione_Documenti_Aggregate;
  /** An array relationship */
  domande: Array<Sottoscrizione_Domande>;
  /** An aggregate relationship */
  domande_aggregate: Sottoscrizione_Domande_Aggregate;
  /** An object relationship */
  fascicolo?: Maybe<Files>;
  fascicolo_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  feedback?: Maybe<Energy_Village_Feedback>;
  feedback_altro?: Maybe<Scalars['String']['output']>;
  feedback_id?: Maybe<Scalars['uuid']['output']>;
  iban_accredito_incentivi?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  idoneo_pnrr?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  iniziative: Array<Sottoscrizione_Iniziativa>;
  /** An aggregate relationship */
  iniziative_aggregate: Sottoscrizione_Iniziativa_Aggregate;
  intestatario_conto_corrente?: Maybe<Scalars['String']['output']>;
  link_fascicolo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  segnalatore?: Maybe<Codice_Operatore>;
  stato: Scalars['String']['output'];
  /** An array relationship */
  storico: Array<Storico_Sottoscrizione>;
  /** An aggregate relationship */
  storico_aggregate: Storico_Sottoscrizione_Aggregate;
  tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum;
  update_domande: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  zip?: Maybe<Sottoscrizione_Zip>;
  zip_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneCategoria_AdesioneArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneDocumentiArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Documenti_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneDocumenti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Documenti_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneDomandeArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Domande_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneDomande_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Domande_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneIniziativeArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneIniziative_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneStoricoArgs = {
  distinct_on?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "sottoscrizione" */
export type SottoscrizioneStorico_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};

/** aggregated selection of "sottoscrizione" */
export type Sottoscrizione_Aggregate = {
  __typename?: 'sottoscrizione_aggregate';
  aggregate?: Maybe<Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Sottoscrizione>;
};

export type Sottoscrizione_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sottoscrizione_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sottoscrizione_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sottoscrizione_Aggregate_Bool_Exp_Count>;
};

export type Sottoscrizione_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sottoscrizione_Select_Column_Sottoscrizione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sottoscrizione_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sottoscrizione_Select_Column_Sottoscrizione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sottoscrizione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sottoscrizione" */
export type Sottoscrizione_Aggregate_Fields = {
  __typename?: 'sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sottoscrizione_Max_Fields>;
  min?: Maybe<Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "sottoscrizione" */
export type Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sottoscrizione" */
export type Sottoscrizione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sottoscrizione_Max_Order_By>;
  min?: InputMaybe<Sottoscrizione_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sottoscrizione_Append_Input = {
  categoria_adesione?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "sottoscrizione" */
export type Sottoscrizione_Arr_Rel_Insert_Input = {
  data: Array<Sottoscrizione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sottoscrizione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sottoscrizione". All fields are combined with a logical 'AND'. */
export type Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Sottoscrizione_Bool_Exp>>;
  altro_fascicolo?: InputMaybe<String_Comparison_Exp>;
  asset_consumo?: InputMaybe<Asset_Consumo_Bool_Exp>;
  asset_consumo_id?: InputMaybe<Uuid_Comparison_Exp>;
  asset_produzione?: InputMaybe<Asset_Produzione_Bool_Exp>;
  asset_produzione_id?: InputMaybe<Uuid_Comparison_Exp>;
  categoria_adesione?: InputMaybe<Jsonb_Comparison_Exp>;
  categoria_adesione_id?: InputMaybe<Uuid_Comparison_Exp>;
  categoria_adesione_produttore_id?: InputMaybe<Uuid_Comparison_Exp>;
  cer_cabina?: InputMaybe<Cer_Cabina_Bool_Exp>;
  cer_cabina_id?: InputMaybe<Uuid_Comparison_Exp>;
  cer_categoria_adesione?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
  cer_categoria_adesione_produttore?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
  codice_univico_promotore?: InputMaybe<String_Comparison_Exp>;
  confirmo_id?: InputMaybe<String_Comparison_Exp>;
  contratto?: InputMaybe<Files_Bool_Exp>;
  contratto_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_ammissione?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_associazione?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_opzione?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_recesso?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_scadenza?: InputMaybe<Timestamptz_Comparison_Exp>;
  documenti?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
  documenti_aggregate?: InputMaybe<Sottoscrizione_Documenti_Aggregate_Bool_Exp>;
  domande?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
  domande_aggregate?: InputMaybe<Sottoscrizione_Domande_Aggregate_Bool_Exp>;
  fascicolo?: InputMaybe<Files_Bool_Exp>;
  fascicolo_id?: InputMaybe<Uuid_Comparison_Exp>;
  feedback?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
  feedback_altro?: InputMaybe<String_Comparison_Exp>;
  feedback_id?: InputMaybe<Uuid_Comparison_Exp>;
  iban_accredito_incentivi?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idoneo_pnrr?: InputMaybe<Boolean_Comparison_Exp>;
  iniziative?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
  iniziative_aggregate?: InputMaybe<Sottoscrizione_Iniziativa_Aggregate_Bool_Exp>;
  intestatario_conto_corrente?: InputMaybe<String_Comparison_Exp>;
  link_fascicolo?: InputMaybe<String_Comparison_Exp>;
  segnalatore?: InputMaybe<Codice_Operatore_Bool_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  storico?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
  storico_aggregate?: InputMaybe<Storico_Sottoscrizione_Aggregate_Bool_Exp>;
  tipologia_richiesta?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Enum_Comparison_Exp>;
  update_domande?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zip?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
  zip_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "sottoscrizione" */
export enum Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "id" */
  SottoscrizionePkey = 'sottoscrizione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sottoscrizione_Delete_At_Path_Input = {
  categoria_adesione?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sottoscrizione_Delete_Elem_Input = {
  categoria_adesione?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sottoscrizione_Delete_Key_Input = {
  categoria_adesione?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti = {
  __typename?: 'sottoscrizione_documenti';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  sottoscrizione: Sottoscrizione;
  sottoscrizione_id: Scalars['uuid']['output'];
  tipologia_documento?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "sottoscrizione_documenti" */
export type Sottoscrizione_DocumentiTipologia_DocumentoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Aggregate = {
  __typename?: 'sottoscrizione_documenti_aggregate';
  aggregate?: Maybe<Sottoscrizione_Documenti_Aggregate_Fields>;
  nodes: Array<Sottoscrizione_Documenti>;
};

export type Sottoscrizione_Documenti_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sottoscrizione_Documenti_Aggregate_Bool_Exp_Count>;
};

export type Sottoscrizione_Documenti_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Aggregate_Fields = {
  __typename?: 'sottoscrizione_documenti_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sottoscrizione_Documenti_Max_Fields>;
  min?: Maybe<Sottoscrizione_Documenti_Min_Fields>;
};


/** aggregate fields of "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sottoscrizione_Documenti_Max_Order_By>;
  min?: InputMaybe<Sottoscrizione_Documenti_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sottoscrizione_Documenti_Append_Input = {
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Arr_Rel_Insert_Input = {
  data: Array<Sottoscrizione_Documenti_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sottoscrizione_Documenti_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sottoscrizione_documenti". All fields are combined with a logical 'AND'. */
export type Sottoscrizione_Documenti_Bool_Exp = {
  _and?: InputMaybe<Array<Sottoscrizione_Documenti_Bool_Exp>>;
  _not?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
  _or?: InputMaybe<Array<Sottoscrizione_Documenti_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  tipologia_documento?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sottoscrizione_documenti" */
export enum Sottoscrizione_Documenti_Constraint {
  /** unique or primary key constraint on columns "id" */
  SottoscrizioneDocumentiPkey = 'sottoscrizione_documenti_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sottoscrizione_Documenti_Delete_At_Path_Input = {
  tipologia_documento?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sottoscrizione_Documenti_Delete_Elem_Input = {
  tipologia_documento?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sottoscrizione_Documenti_Delete_Key_Input = {
  tipologia_documento?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sottoscrizione_Documenti_Max_Fields = {
  __typename?: 'sottoscrizione_documenti_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sottoscrizione_Documenti_Min_Fields = {
  __typename?: 'sottoscrizione_documenti_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Mutation_Response = {
  __typename?: 'sottoscrizione_documenti_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sottoscrizione_Documenti>;
};

/** on_conflict condition type for table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_On_Conflict = {
  constraint: Sottoscrizione_Documenti_Constraint;
  update_columns?: Array<Sottoscrizione_Documenti_Update_Column>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};

/** Ordering options when selecting data from "sottoscrizione_documenti". */
export type Sottoscrizione_Documenti_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  tipologia_documento?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sottoscrizione_documenti */
export type Sottoscrizione_Documenti_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sottoscrizione_Documenti_Prepend_Input = {
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sottoscrizione_documenti" */
export enum Sottoscrizione_Documenti_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  TipologiaDocumento = 'tipologia_documento',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "sottoscrizione_documenti" */
export type Sottoscrizione_Documenti_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sottoscrizione_Documenti_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sottoscrizione_Documenti_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_documento?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "sottoscrizione_documenti" */
export enum Sottoscrizione_Documenti_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  TipologiaDocumento = 'tipologia_documento',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sottoscrizione_Documenti_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sottoscrizione_Documenti_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sottoscrizione_Documenti_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sottoscrizione_Documenti_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sottoscrizione_Documenti_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sottoscrizione_Documenti_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sottoscrizione_Documenti_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sottoscrizione_Documenti_Bool_Exp;
};

/** columns and relationships of "sottoscrizione_domande" */
export type Sottoscrizione_Domande = {
  __typename?: 'sottoscrizione_domande';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  risposta: Scalars['Boolean']['output'];
  /** An object relationship */
  sottoscrizione: Sottoscrizione;
  sottoscrizione_id: Scalars['uuid']['output'];
  tipologia_domanda?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "sottoscrizione_domande" */
export type Sottoscrizione_DomandeTipologia_DomandaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Aggregate = {
  __typename?: 'sottoscrizione_domande_aggregate';
  aggregate?: Maybe<Sottoscrizione_Domande_Aggregate_Fields>;
  nodes: Array<Sottoscrizione_Domande>;
};

export type Sottoscrizione_Domande_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sottoscrizione_Domande_Aggregate_Bool_Exp_Count>;
};

export type Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sottoscrizione_Domande_Select_Column_Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sottoscrizione_Domande_Select_Column_Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sottoscrizione_Domande_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Aggregate_Fields = {
  __typename?: 'sottoscrizione_domande_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sottoscrizione_Domande_Max_Fields>;
  min?: Maybe<Sottoscrizione_Domande_Min_Fields>;
};


/** aggregate fields of "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sottoscrizione_Domande_Max_Order_By>;
  min?: InputMaybe<Sottoscrizione_Domande_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sottoscrizione_Domande_Append_Input = {
  tipologia_domanda?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Arr_Rel_Insert_Input = {
  data: Array<Sottoscrizione_Domande_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sottoscrizione_Domande_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sottoscrizione_domande". All fields are combined with a logical 'AND'. */
export type Sottoscrizione_Domande_Bool_Exp = {
  _and?: InputMaybe<Array<Sottoscrizione_Domande_Bool_Exp>>;
  _not?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
  _or?: InputMaybe<Array<Sottoscrizione_Domande_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  risposta?: InputMaybe<Boolean_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  tipologia_domanda?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sottoscrizione_domande" */
export enum Sottoscrizione_Domande_Constraint {
  /** unique or primary key constraint on columns "id" */
  SottoscrizioneDomandePkey = 'sottoscrizione_domande_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sottoscrizione_Domande_Delete_At_Path_Input = {
  tipologia_domanda?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sottoscrizione_Domande_Delete_Elem_Input = {
  tipologia_domanda?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sottoscrizione_Domande_Delete_Key_Input = {
  tipologia_domanda?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risposta?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_domanda?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sottoscrizione_Domande_Max_Fields = {
  __typename?: 'sottoscrizione_domande_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sottoscrizione_Domande_Min_Fields = {
  __typename?: 'sottoscrizione_domande_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Mutation_Response = {
  __typename?: 'sottoscrizione_domande_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sottoscrizione_Domande>;
};

/** on_conflict condition type for table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_On_Conflict = {
  constraint: Sottoscrizione_Domande_Constraint;
  update_columns?: Array<Sottoscrizione_Domande_Update_Column>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};

/** Ordering options when selecting data from "sottoscrizione_domande". */
export type Sottoscrizione_Domande_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risposta?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  tipologia_domanda?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sottoscrizione_domande */
export type Sottoscrizione_Domande_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sottoscrizione_Domande_Prepend_Input = {
  tipologia_domanda?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sottoscrizione_domande" */
export enum Sottoscrizione_Domande_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Risposta = 'risposta',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  TipologiaDomanda = 'tipologia_domanda',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "sottoscrizione_domande_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sottoscrizione_domande" */
export enum Sottoscrizione_Domande_Select_Column_Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Risposta = 'risposta'
}

/** select "sottoscrizione_domande_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sottoscrizione_domande" */
export enum Sottoscrizione_Domande_Select_Column_Sottoscrizione_Domande_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Risposta = 'risposta'
}

/** input type for updating data in table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risposta?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_domanda?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "sottoscrizione_domande" */
export type Sottoscrizione_Domande_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sottoscrizione_Domande_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sottoscrizione_Domande_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risposta?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  tipologia_domanda?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "sottoscrizione_domande" */
export enum Sottoscrizione_Domande_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Risposta = 'risposta',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  TipologiaDomanda = 'tipologia_domanda',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sottoscrizione_Domande_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sottoscrizione_Domande_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sottoscrizione_Domande_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sottoscrizione_Domande_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sottoscrizione_Domande_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sottoscrizione_Domande_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sottoscrizione_Domande_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sottoscrizione_Domande_Bool_Exp;
};

/** columns and relationships of "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa = {
  __typename?: 'sottoscrizione_iniziativa';
  /** An object relationship */
  cer_destinazione_contributo: Cer_Destinazione_Contributo;
  created_at: Scalars['timestamptz']['output'];
  data_fine?: Maybe<Scalars['timestamptz']['output']>;
  data_inizio: Scalars['timestamptz']['output'];
  destinazione_contributo_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  sottoscrizione: Sottoscrizione;
  sottoscrizione_id: Scalars['uuid']['output'];
};

/** aggregated selection of "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Aggregate = {
  __typename?: 'sottoscrizione_iniziativa_aggregate';
  aggregate?: Maybe<Sottoscrizione_Iniziativa_Aggregate_Fields>;
  nodes: Array<Sottoscrizione_Iniziativa>;
};

export type Sottoscrizione_Iniziativa_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sottoscrizione_Iniziativa_Aggregate_Bool_Exp_Count>;
};

export type Sottoscrizione_Iniziativa_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Aggregate_Fields = {
  __typename?: 'sottoscrizione_iniziativa_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sottoscrizione_Iniziativa_Max_Fields>;
  min?: Maybe<Sottoscrizione_Iniziativa_Min_Fields>;
};


/** aggregate fields of "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sottoscrizione_Iniziativa_Max_Order_By>;
  min?: InputMaybe<Sottoscrizione_Iniziativa_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Arr_Rel_Insert_Input = {
  data: Array<Sottoscrizione_Iniziativa_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sottoscrizione_Iniziativa_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sottoscrizione_iniziativa". All fields are combined with a logical 'AND'. */
export type Sottoscrizione_Iniziativa_Bool_Exp = {
  _and?: InputMaybe<Array<Sottoscrizione_Iniziativa_Bool_Exp>>;
  _not?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
  _or?: InputMaybe<Array<Sottoscrizione_Iniziativa_Bool_Exp>>;
  cer_destinazione_contributo?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_fine?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_inizio?: InputMaybe<Timestamptz_Comparison_Exp>;
  destinazione_contributo_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "sottoscrizione_iniziativa" */
export enum Sottoscrizione_Iniziativa_Constraint {
  /** unique or primary key constraint on columns "sottoscrizione_id" */
  SottoscrizioneIniziativaApertaUidx = 'sottoscrizione_iniziativa_aperta_uidx',
  /** unique or primary key constraint on columns "id" */
  SottoscrizioneIniziativaPkey = 'sottoscrizione_iniziativa_pkey'
}

/** input type for inserting data into table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Insert_Input = {
  cer_destinazione_contributo?: InputMaybe<Cer_Destinazione_Contributo_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_fine?: InputMaybe<Scalars['timestamptz']['input']>;
  data_inizio?: InputMaybe<Scalars['timestamptz']['input']>;
  destinazione_contributo_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Sottoscrizione_Iniziativa_Max_Fields = {
  __typename?: 'sottoscrizione_iniziativa_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_fine?: Maybe<Scalars['timestamptz']['output']>;
  data_inizio?: Maybe<Scalars['timestamptz']['output']>;
  destinazione_contributo_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_fine?: InputMaybe<Order_By>;
  data_inizio?: InputMaybe<Order_By>;
  destinazione_contributo_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sottoscrizione_Iniziativa_Min_Fields = {
  __typename?: 'sottoscrizione_iniziativa_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_fine?: Maybe<Scalars['timestamptz']['output']>;
  data_inizio?: Maybe<Scalars['timestamptz']['output']>;
  destinazione_contributo_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_fine?: InputMaybe<Order_By>;
  data_inizio?: InputMaybe<Order_By>;
  destinazione_contributo_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Mutation_Response = {
  __typename?: 'sottoscrizione_iniziativa_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sottoscrizione_Iniziativa>;
};

/** on_conflict condition type for table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_On_Conflict = {
  constraint: Sottoscrizione_Iniziativa_Constraint;
  update_columns?: Array<Sottoscrizione_Iniziativa_Update_Column>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};

/** Ordering options when selecting data from "sottoscrizione_iniziativa". */
export type Sottoscrizione_Iniziativa_Order_By = {
  cer_destinazione_contributo?: InputMaybe<Cer_Destinazione_Contributo_Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_fine?: InputMaybe<Order_By>;
  data_inizio?: InputMaybe<Order_By>;
  destinazione_contributo_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sottoscrizione_iniziativa */
export type Sottoscrizione_Iniziativa_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "sottoscrizione_iniziativa" */
export enum Sottoscrizione_Iniziativa_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFine = 'data_fine',
  /** column name */
  DataInizio = 'data_inizio',
  /** column name */
  DestinazioneContributoId = 'destinazione_contributo_id',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id'
}

/** input type for updating data in table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_fine?: InputMaybe<Scalars['timestamptz']['input']>;
  data_inizio?: InputMaybe<Scalars['timestamptz']['input']>;
  destinazione_contributo_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "sottoscrizione_iniziativa" */
export type Sottoscrizione_Iniziativa_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sottoscrizione_Iniziativa_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sottoscrizione_Iniziativa_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_fine?: InputMaybe<Scalars['timestamptz']['input']>;
  data_inizio?: InputMaybe<Scalars['timestamptz']['input']>;
  destinazione_contributo_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "sottoscrizione_iniziativa" */
export enum Sottoscrizione_Iniziativa_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFine = 'data_fine',
  /** column name */
  DataInizio = 'data_inizio',
  /** column name */
  DestinazioneContributoId = 'destinazione_contributo_id',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id'
}

export type Sottoscrizione_Iniziativa_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sottoscrizione_Iniziativa_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sottoscrizione_Iniziativa_Bool_Exp;
};

/** input type for inserting data into table "sottoscrizione" */
export type Sottoscrizione_Insert_Input = {
  altro_fascicolo?: InputMaybe<Scalars['String']['input']>;
  asset_consumo?: InputMaybe<Asset_Consumo_Obj_Rel_Insert_Input>;
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_produzione?: InputMaybe<Asset_Produzione_Obj_Rel_Insert_Input>;
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  categoria_adesione?: InputMaybe<Scalars['jsonb']['input']>;
  categoria_adesione_id?: InputMaybe<Scalars['uuid']['input']>;
  categoria_adesione_produttore_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_cabina?: InputMaybe<Cer_Cabina_Obj_Rel_Insert_Input>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_categoria_adesione?: InputMaybe<Cer_Categoria_Adesione_Obj_Rel_Insert_Input>;
  cer_categoria_adesione_produttore?: InputMaybe<Cer_Categoria_Adesione_Obj_Rel_Insert_Input>;
  codice_univico_promotore?: InputMaybe<Scalars['String']['input']>;
  confirmo_id?: InputMaybe<Scalars['String']['input']>;
  contratto?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  contratto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_ammissione?: InputMaybe<Scalars['timestamptz']['input']>;
  data_recesso?: InputMaybe<Scalars['timestamptz']['input']>;
  documenti?: InputMaybe<Sottoscrizione_Documenti_Arr_Rel_Insert_Input>;
  domande?: InputMaybe<Sottoscrizione_Domande_Arr_Rel_Insert_Input>;
  fascicolo?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fascicolo_id?: InputMaybe<Scalars['uuid']['input']>;
  feedback?: InputMaybe<Energy_Village_Feedback_Obj_Rel_Insert_Input>;
  feedback_altro?: InputMaybe<Scalars['String']['input']>;
  feedback_id?: InputMaybe<Scalars['uuid']['input']>;
  iban_accredito_incentivi?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idoneo_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  iniziative?: InputMaybe<Sottoscrizione_Iniziativa_Arr_Rel_Insert_Input>;
  intestatario_conto_corrente?: InputMaybe<Scalars['String']['input']>;
  link_fascicolo?: InputMaybe<Scalars['String']['input']>;
  segnalatore?: InputMaybe<Codice_Operatore_Obj_Rel_Insert_Input>;
  stato?: InputMaybe<Scalars['String']['input']>;
  storico?: InputMaybe<Storico_Sottoscrizione_Arr_Rel_Insert_Input>;
  tipologia_richiesta?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Enum>;
  update_domande?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zip?: InputMaybe<Sottoscrizione_Zip_Obj_Rel_Insert_Input>;
  zip_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Sottoscrizione_Max_Fields = {
  __typename?: 'sottoscrizione_max_fields';
  altro_fascicolo?: Maybe<Scalars['String']['output']>;
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  categoria_adesione_id?: Maybe<Scalars['uuid']['output']>;
  categoria_adesione_produttore_id?: Maybe<Scalars['uuid']['output']>;
  cer_cabina_id?: Maybe<Scalars['uuid']['output']>;
  codice_univico_promotore?: Maybe<Scalars['String']['output']>;
  confirmo_id?: Maybe<Scalars['String']['output']>;
  contratto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_ammissione?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_associazione" */
  data_associazione?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_opzionata" */
  data_opzione?: Maybe<Scalars['timestamptz']['output']>;
  data_recesso?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_scadenza" */
  data_scadenza?: Maybe<Scalars['timestamptz']['output']>;
  fascicolo_id?: Maybe<Scalars['uuid']['output']>;
  feedback_altro?: Maybe<Scalars['String']['output']>;
  feedback_id?: Maybe<Scalars['uuid']['output']>;
  iban_accredito_incentivi?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_conto_corrente?: Maybe<Scalars['String']['output']>;
  link_fascicolo?: Maybe<Scalars['String']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zip_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "sottoscrizione" */
export type Sottoscrizione_Max_Order_By = {
  altro_fascicolo?: InputMaybe<Order_By>;
  asset_consumo_id?: InputMaybe<Order_By>;
  asset_produzione_id?: InputMaybe<Order_By>;
  categoria_adesione_id?: InputMaybe<Order_By>;
  categoria_adesione_produttore_id?: InputMaybe<Order_By>;
  cer_cabina_id?: InputMaybe<Order_By>;
  codice_univico_promotore?: InputMaybe<Order_By>;
  confirmo_id?: InputMaybe<Order_By>;
  contratto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_ammissione?: InputMaybe<Order_By>;
  data_recesso?: InputMaybe<Order_By>;
  fascicolo_id?: InputMaybe<Order_By>;
  feedback_altro?: InputMaybe<Order_By>;
  feedback_id?: InputMaybe<Order_By>;
  iban_accredito_incentivi?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intestatario_conto_corrente?: InputMaybe<Order_By>;
  link_fascicolo?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sottoscrizione_Min_Fields = {
  __typename?: 'sottoscrizione_min_fields';
  altro_fascicolo?: Maybe<Scalars['String']['output']>;
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  categoria_adesione_id?: Maybe<Scalars['uuid']['output']>;
  categoria_adesione_produttore_id?: Maybe<Scalars['uuid']['output']>;
  cer_cabina_id?: Maybe<Scalars['uuid']['output']>;
  codice_univico_promotore?: Maybe<Scalars['String']['output']>;
  confirmo_id?: Maybe<Scalars['String']['output']>;
  contratto_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  data_ammissione?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_associazione" */
  data_associazione?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_opzionata" */
  data_opzione?: Maybe<Scalars['timestamptz']['output']>;
  data_recesso?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "data_scadenza" */
  data_scadenza?: Maybe<Scalars['timestamptz']['output']>;
  fascicolo_id?: Maybe<Scalars['uuid']['output']>;
  feedback_altro?: Maybe<Scalars['String']['output']>;
  feedback_id?: Maybe<Scalars['uuid']['output']>;
  iban_accredito_incentivi?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_conto_corrente?: Maybe<Scalars['String']['output']>;
  link_fascicolo?: Maybe<Scalars['String']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  zip_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "sottoscrizione" */
export type Sottoscrizione_Min_Order_By = {
  altro_fascicolo?: InputMaybe<Order_By>;
  asset_consumo_id?: InputMaybe<Order_By>;
  asset_produzione_id?: InputMaybe<Order_By>;
  categoria_adesione_id?: InputMaybe<Order_By>;
  categoria_adesione_produttore_id?: InputMaybe<Order_By>;
  cer_cabina_id?: InputMaybe<Order_By>;
  codice_univico_promotore?: InputMaybe<Order_By>;
  confirmo_id?: InputMaybe<Order_By>;
  contratto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_ammissione?: InputMaybe<Order_By>;
  data_recesso?: InputMaybe<Order_By>;
  fascicolo_id?: InputMaybe<Order_By>;
  feedback_altro?: InputMaybe<Order_By>;
  feedback_id?: InputMaybe<Order_By>;
  iban_accredito_incentivi?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intestatario_conto_corrente?: InputMaybe<Order_By>;
  link_fascicolo?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sottoscrizione" */
export type Sottoscrizione_Mutation_Response = {
  __typename?: 'sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sottoscrizione>;
};

/** input type for inserting object relation for remote table "sottoscrizione" */
export type Sottoscrizione_Obj_Rel_Insert_Input = {
  data: Sottoscrizione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sottoscrizione_On_Conflict>;
};

/** on_conflict condition type for table "sottoscrizione" */
export type Sottoscrizione_On_Conflict = {
  constraint: Sottoscrizione_Constraint;
  update_columns?: Array<Sottoscrizione_Update_Column>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "sottoscrizione". */
export type Sottoscrizione_Order_By = {
  altro_fascicolo?: InputMaybe<Order_By>;
  asset_consumo?: InputMaybe<Asset_Consumo_Order_By>;
  asset_consumo_id?: InputMaybe<Order_By>;
  asset_produzione?: InputMaybe<Asset_Produzione_Order_By>;
  asset_produzione_id?: InputMaybe<Order_By>;
  categoria_adesione?: InputMaybe<Order_By>;
  categoria_adesione_id?: InputMaybe<Order_By>;
  categoria_adesione_produttore_id?: InputMaybe<Order_By>;
  cer_cabina?: InputMaybe<Cer_Cabina_Order_By>;
  cer_cabina_id?: InputMaybe<Order_By>;
  cer_categoria_adesione?: InputMaybe<Cer_Categoria_Adesione_Order_By>;
  cer_categoria_adesione_produttore?: InputMaybe<Cer_Categoria_Adesione_Order_By>;
  codice_univico_promotore?: InputMaybe<Order_By>;
  confirmo_id?: InputMaybe<Order_By>;
  contratto?: InputMaybe<Files_Order_By>;
  contratto_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_ammissione?: InputMaybe<Order_By>;
  data_associazione?: InputMaybe<Order_By>;
  data_opzione?: InputMaybe<Order_By>;
  data_recesso?: InputMaybe<Order_By>;
  data_scadenza?: InputMaybe<Order_By>;
  documenti_aggregate?: InputMaybe<Sottoscrizione_Documenti_Aggregate_Order_By>;
  domande_aggregate?: InputMaybe<Sottoscrizione_Domande_Aggregate_Order_By>;
  fascicolo?: InputMaybe<Files_Order_By>;
  fascicolo_id?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Energy_Village_Feedback_Order_By>;
  feedback_altro?: InputMaybe<Order_By>;
  feedback_id?: InputMaybe<Order_By>;
  iban_accredito_incentivi?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idoneo_pnrr?: InputMaybe<Order_By>;
  iniziative_aggregate?: InputMaybe<Sottoscrizione_Iniziativa_Aggregate_Order_By>;
  intestatario_conto_corrente?: InputMaybe<Order_By>;
  link_fascicolo?: InputMaybe<Order_By>;
  segnalatore?: InputMaybe<Codice_Operatore_Order_By>;
  stato?: InputMaybe<Order_By>;
  storico_aggregate?: InputMaybe<Storico_Sottoscrizione_Aggregate_Order_By>;
  tipologia_richiesta?: InputMaybe<Order_By>;
  update_domande?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip?: InputMaybe<Sottoscrizione_Zip_Order_By>;
  zip_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sottoscrizione */
export type Sottoscrizione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sottoscrizione_Prepend_Input = {
  categoria_adesione?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sottoscrizione" */
export enum Sottoscrizione_Select_Column {
  /** column name */
  AltroFascicolo = 'altro_fascicolo',
  /** column name */
  AssetConsumoId = 'asset_consumo_id',
  /** column name */
  AssetProduzioneId = 'asset_produzione_id',
  /** column name */
  CategoriaAdesione = 'categoria_adesione',
  /** column name */
  CategoriaAdesioneId = 'categoria_adesione_id',
  /** column name */
  CategoriaAdesioneProduttoreId = 'categoria_adesione_produttore_id',
  /** column name */
  CerCabinaId = 'cer_cabina_id',
  /** column name */
  CodiceUnivicoPromotore = 'codice_univico_promotore',
  /** column name */
  ConfirmoId = 'confirmo_id',
  /** column name */
  ContrattoId = 'contratto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataAmmissione = 'data_ammissione',
  /** column name */
  DataRecesso = 'data_recesso',
  /** column name */
  FascicoloId = 'fascicolo_id',
  /** column name */
  FeedbackAltro = 'feedback_altro',
  /** column name */
  FeedbackId = 'feedback_id',
  /** column name */
  IbanAccreditoIncentivi = 'iban_accredito_incentivi',
  /** column name */
  Id = 'id',
  /** column name */
  IdoneoPnrr = 'idoneo_pnrr',
  /** column name */
  IntestatarioContoCorrente = 'intestatario_conto_corrente',
  /** column name */
  LinkFascicolo = 'link_fascicolo',
  /** column name */
  Stato = 'stato',
  /** column name */
  TipologiaRichiesta = 'tipologia_richiesta',
  /** column name */
  UpdateDomande = 'update_domande',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipId = 'zip_id'
}

/** select "sottoscrizione_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sottoscrizione" */
export enum Sottoscrizione_Select_Column_Sottoscrizione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IdoneoPnrr = 'idoneo_pnrr',
  /** column name */
  UpdateDomande = 'update_domande'
}

/** select "sottoscrizione_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sottoscrizione" */
export enum Sottoscrizione_Select_Column_Sottoscrizione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IdoneoPnrr = 'idoneo_pnrr',
  /** column name */
  UpdateDomande = 'update_domande'
}

/** input type for updating data in table "sottoscrizione" */
export type Sottoscrizione_Set_Input = {
  altro_fascicolo?: InputMaybe<Scalars['String']['input']>;
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  categoria_adesione?: InputMaybe<Scalars['jsonb']['input']>;
  categoria_adesione_id?: InputMaybe<Scalars['uuid']['input']>;
  categoria_adesione_produttore_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_univico_promotore?: InputMaybe<Scalars['String']['input']>;
  confirmo_id?: InputMaybe<Scalars['String']['input']>;
  contratto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_ammissione?: InputMaybe<Scalars['timestamptz']['input']>;
  data_recesso?: InputMaybe<Scalars['timestamptz']['input']>;
  fascicolo_id?: InputMaybe<Scalars['uuid']['input']>;
  feedback_altro?: InputMaybe<Scalars['String']['input']>;
  feedback_id?: InputMaybe<Scalars['uuid']['input']>;
  iban_accredito_incentivi?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idoneo_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  intestatario_conto_corrente?: InputMaybe<Scalars['String']['input']>;
  link_fascicolo?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  tipologia_richiesta?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Enum>;
  update_domande?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zip_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "sottoscrizione" */
export type Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sottoscrizione_Stream_Cursor_Value_Input = {
  altro_fascicolo?: InputMaybe<Scalars['String']['input']>;
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  categoria_adesione?: InputMaybe<Scalars['jsonb']['input']>;
  categoria_adesione_id?: InputMaybe<Scalars['uuid']['input']>;
  categoria_adesione_produttore_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_cabina_id?: InputMaybe<Scalars['uuid']['input']>;
  codice_univico_promotore?: InputMaybe<Scalars['String']['input']>;
  confirmo_id?: InputMaybe<Scalars['String']['input']>;
  contratto_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data_ammissione?: InputMaybe<Scalars['timestamptz']['input']>;
  data_recesso?: InputMaybe<Scalars['timestamptz']['input']>;
  fascicolo_id?: InputMaybe<Scalars['uuid']['input']>;
  feedback_altro?: InputMaybe<Scalars['String']['input']>;
  feedback_id?: InputMaybe<Scalars['uuid']['input']>;
  iban_accredito_incentivi?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idoneo_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  intestatario_conto_corrente?: InputMaybe<Scalars['String']['input']>;
  link_fascicolo?: InputMaybe<Scalars['String']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  tipologia_richiesta?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Enum>;
  update_domande?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  zip_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "sottoscrizione" */
export enum Sottoscrizione_Update_Column {
  /** column name */
  AltroFascicolo = 'altro_fascicolo',
  /** column name */
  AssetConsumoId = 'asset_consumo_id',
  /** column name */
  AssetProduzioneId = 'asset_produzione_id',
  /** column name */
  CategoriaAdesione = 'categoria_adesione',
  /** column name */
  CategoriaAdesioneId = 'categoria_adesione_id',
  /** column name */
  CategoriaAdesioneProduttoreId = 'categoria_adesione_produttore_id',
  /** column name */
  CerCabinaId = 'cer_cabina_id',
  /** column name */
  CodiceUnivicoPromotore = 'codice_univico_promotore',
  /** column name */
  ConfirmoId = 'confirmo_id',
  /** column name */
  ContrattoId = 'contratto_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataAmmissione = 'data_ammissione',
  /** column name */
  DataRecesso = 'data_recesso',
  /** column name */
  FascicoloId = 'fascicolo_id',
  /** column name */
  FeedbackAltro = 'feedback_altro',
  /** column name */
  FeedbackId = 'feedback_id',
  /** column name */
  IbanAccreditoIncentivi = 'iban_accredito_incentivi',
  /** column name */
  Id = 'id',
  /** column name */
  IdoneoPnrr = 'idoneo_pnrr',
  /** column name */
  IntestatarioContoCorrente = 'intestatario_conto_corrente',
  /** column name */
  LinkFascicolo = 'link_fascicolo',
  /** column name */
  Stato = 'stato',
  /** column name */
  TipologiaRichiesta = 'tipologia_richiesta',
  /** column name */
  UpdateDomande = 'update_domande',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipId = 'zip_id'
}

export type Sottoscrizione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sottoscrizione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sottoscrizione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sottoscrizione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sottoscrizione_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sottoscrizione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "sottoscrizione_zip" */
export type Sottoscrizione_Zip = {
  __typename?: 'sottoscrizione_zip';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  stato?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Aggregate = {
  __typename?: 'sottoscrizione_zip_aggregate';
  aggregate?: Maybe<Sottoscrizione_Zip_Aggregate_Fields>;
  nodes: Array<Sottoscrizione_Zip>;
};

/** aggregate fields of "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Aggregate_Fields = {
  __typename?: 'sottoscrizione_zip_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sottoscrizione_Zip_Max_Fields>;
  min?: Maybe<Sottoscrizione_Zip_Min_Fields>;
};


/** aggregate fields of "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sottoscrizione_Zip_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sottoscrizione_zip". All fields are combined with a logical 'AND'. */
export type Sottoscrizione_Zip_Bool_Exp = {
  _and?: InputMaybe<Array<Sottoscrizione_Zip_Bool_Exp>>;
  _not?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
  _or?: InputMaybe<Array<Sottoscrizione_Zip_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sottoscrizione_zip" */
export enum Sottoscrizione_Zip_Constraint {
  /** unique or primary key constraint on columns "id" */
  SottoscrizioneZipPkey = 'sottoscrizione_zip_pkey'
}

/** input type for inserting data into table "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Sottoscrizione_Zip_Max_Fields = {
  __typename?: 'sottoscrizione_zip_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Sottoscrizione_Zip_Min_Fields = {
  __typename?: 'sottoscrizione_zip_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Mutation_Response = {
  __typename?: 'sottoscrizione_zip_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sottoscrizione_Zip>;
};

/** input type for inserting object relation for remote table "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Obj_Rel_Insert_Input = {
  data: Sottoscrizione_Zip_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sottoscrizione_Zip_On_Conflict>;
};

/** on_conflict condition type for table "sottoscrizione_zip" */
export type Sottoscrizione_Zip_On_Conflict = {
  constraint: Sottoscrizione_Zip_Constraint;
  update_columns?: Array<Sottoscrizione_Zip_Update_Column>;
  where?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
};

/** Ordering options when selecting data from "sottoscrizione_zip". */
export type Sottoscrizione_Zip_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sottoscrizione_zip */
export type Sottoscrizione_Zip_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "sottoscrizione_zip" */
export enum Sottoscrizione_Zip_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "sottoscrizione_zip" */
export type Sottoscrizione_Zip_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sottoscrizione_Zip_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sottoscrizione_Zip_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "sottoscrizione_zip" */
export enum Sottoscrizione_Zip_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sottoscrizione_Zip_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sottoscrizione_Zip_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sottoscrizione_Zip_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

/** columns and relationships of "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione = {
  __typename?: 'staging__stato_sottoscrizione';
  value: Scalars['String']['output'];
};

/** aggregated selection of "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_Aggregate = {
  __typename?: 'staging__stato_sottoscrizione_aggregate';
  aggregate?: Maybe<Staging__Stato_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Staging__Stato_Sottoscrizione>;
};

/** aggregate fields of "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'staging__stato_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging__Stato_Sottoscrizione_Max_Fields>;
  min?: Maybe<Staging__Stato_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "staging._stato_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Staging__Stato_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Staging__Stato_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging._stato_sottoscrizione" */
export enum Staging__Stato_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "value" */
  _StatoSottoscrizionePkey = '_stato_sottoscrizione_pkey'
}

export enum Staging__Stato_Sottoscrizione_Enum {
  Completata = 'completata',
  Inserita = 'inserita',
  Inviata = 'inviata'
}

/** Boolean expression to compare columns of type "staging__stato_sottoscrizione_enum". All fields are combined with logical 'AND'. */
export type Staging__Stato_Sottoscrizione_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Staging__Stato_Sottoscrizione_Enum>;
  _in?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Staging__Stato_Sottoscrizione_Enum>;
  _nin?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Enum>>;
};

/** input type for inserting data into table "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Staging__Stato_Sottoscrizione_Max_Fields = {
  __typename?: 'staging__stato_sottoscrizione_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Staging__Stato_Sottoscrizione_Min_Fields = {
  __typename?: 'staging__stato_sottoscrizione_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_Mutation_Response = {
  __typename?: 'staging__stato_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging__Stato_Sottoscrizione>;
};

/** on_conflict condition type for table "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_On_Conflict = {
  constraint: Staging__Stato_Sottoscrizione_Constraint;
  update_columns?: Array<Staging__Stato_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Staging__Stato_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "staging._stato_sottoscrizione". */
export type Staging__Stato_Sottoscrizione_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging._stato_sottoscrizione */
export type Staging__Stato_Sottoscrizione_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "staging._stato_sottoscrizione" */
export enum Staging__Stato_Sottoscrizione_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "staging._stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "staging__stato_sottoscrizione" */
export type Staging__Stato_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging__Stato_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging__Stato_Sottoscrizione_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "staging._stato_sottoscrizione" */
export enum Staging__Stato_Sottoscrizione_Update_Column {
  /** column name */
  Value = 'value'
}

export type Staging__Stato_Sottoscrizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging__Stato_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging__Stato_Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione = {
  __typename?: 'staging_azione_sottoscrizione';
  attivo: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  gruppo?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  order: Scalars['numeric']['output'];
  regole?: Maybe<Scalars['jsonb']['output']>;
  stato_di_arrivo?: Maybe<Scalars['String']['output']>;
  tipo: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "staging.azione_sottoscrizione" */
export type Staging_Azione_SottoscrizioneRegoleArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Aggregate = {
  __typename?: 'staging_azione_sottoscrizione_aggregate';
  aggregate?: Maybe<Staging_Azione_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Staging_Azione_Sottoscrizione>;
};

/** aggregate fields of "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'staging_azione_sottoscrizione_aggregate_fields';
  avg?: Maybe<Staging_Azione_Sottoscrizione_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Azione_Sottoscrizione_Max_Fields>;
  min?: Maybe<Staging_Azione_Sottoscrizione_Min_Fields>;
  stddev?: Maybe<Staging_Azione_Sottoscrizione_Stddev_Fields>;
  stddev_pop?: Maybe<Staging_Azione_Sottoscrizione_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Staging_Azione_Sottoscrizione_Stddev_Samp_Fields>;
  sum?: Maybe<Staging_Azione_Sottoscrizione_Sum_Fields>;
  var_pop?: Maybe<Staging_Azione_Sottoscrizione_Var_Pop_Fields>;
  var_samp?: Maybe<Staging_Azione_Sottoscrizione_Var_Samp_Fields>;
  variance?: Maybe<Staging_Azione_Sottoscrizione_Variance_Fields>;
};


/** aggregate fields of "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Staging_Azione_Sottoscrizione_Append_Input = {
  regole?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Staging_Azione_Sottoscrizione_Avg_Fields = {
  __typename?: 'staging_azione_sottoscrizione_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "staging.azione_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Staging_Azione_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Bool_Exp>>;
  attivo?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gruppo?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Numeric_Comparison_Exp>;
  regole?: InputMaybe<Jsonb_Comparison_Exp>;
  stato_di_arrivo?: InputMaybe<String_Comparison_Exp>;
  tipo?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging.azione_sottoscrizione" */
export enum Staging_Azione_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "id" */
  AzioneSottoscrizionePkey = 'azione_sottoscrizione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Staging_Azione_Sottoscrizione_Delete_At_Path_Input = {
  regole?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Staging_Azione_Sottoscrizione_Delete_Elem_Input = {
  regole?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Staging_Azione_Sottoscrizione_Delete_Key_Input = {
  regole?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Inc_Input = {
  order?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Insert_Input = {
  attivo?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gruppo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  regole?: InputMaybe<Scalars['jsonb']['input']>;
  stato_di_arrivo?: InputMaybe<Scalars['String']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Staging_Azione_Sottoscrizione_Max_Fields = {
  __typename?: 'staging_azione_sottoscrizione_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gruppo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  stato_di_arrivo?: Maybe<Scalars['String']['output']>;
  tipo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Staging_Azione_Sottoscrizione_Min_Fields = {
  __typename?: 'staging_azione_sottoscrizione_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gruppo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  stato_di_arrivo?: Maybe<Scalars['String']['output']>;
  tipo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Mutation_Response = {
  __typename?: 'staging_azione_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging_Azione_Sottoscrizione>;
};

/** input type for inserting object relation for remote table "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Obj_Rel_Insert_Input = {
  data: Staging_Azione_Sottoscrizione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Staging_Azione_Sottoscrizione_On_Conflict>;
};

/** on_conflict condition type for table "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_On_Conflict = {
  constraint: Staging_Azione_Sottoscrizione_Constraint;
  update_columns?: Array<Staging_Azione_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "staging.azione_sottoscrizione". */
export type Staging_Azione_Sottoscrizione_Order_By = {
  attivo?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gruppo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  regole?: InputMaybe<Order_By>;
  stato_di_arrivo?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging.azione_sottoscrizione */
export type Staging_Azione_Sottoscrizione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Staging_Azione_Sottoscrizione_Prepend_Input = {
  regole?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "staging.azione_sottoscrizione" */
export enum Staging_Azione_Sottoscrizione_Select_Column {
  /** column name */
  Attivo = 'attivo',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Gruppo = 'gruppo',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Order = 'order',
  /** column name */
  Regole = 'regole',
  /** column name */
  StatoDiArrivo = 'stato_di_arrivo',
  /** column name */
  Tipo = 'tipo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "staging.azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Set_Input = {
  attivo?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gruppo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  regole?: InputMaybe<Scalars['jsonb']['input']>;
  stato_di_arrivo?: InputMaybe<Scalars['String']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Staging_Azione_Sottoscrizione_Stddev_Fields = {
  __typename?: 'staging_azione_sottoscrizione_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Staging_Azione_Sottoscrizione_Stddev_Pop_Fields = {
  __typename?: 'staging_azione_sottoscrizione_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Staging_Azione_Sottoscrizione_Stddev_Samp_Fields = {
  __typename?: 'staging_azione_sottoscrizione_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "staging_azione_sottoscrizione" */
export type Staging_Azione_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Azione_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Azione_Sottoscrizione_Stream_Cursor_Value_Input = {
  attivo?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gruppo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  regole?: InputMaybe<Scalars['jsonb']['input']>;
  stato_di_arrivo?: InputMaybe<Scalars['String']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Staging_Azione_Sottoscrizione_Sum_Fields = {
  __typename?: 'staging_azione_sottoscrizione_sum_fields';
  order?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "staging.azione_sottoscrizione" */
export enum Staging_Azione_Sottoscrizione_Update_Column {
  /** column name */
  Attivo = 'attivo',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Gruppo = 'gruppo',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Order = 'order',
  /** column name */
  Regole = 'regole',
  /** column name */
  StatoDiArrivo = 'stato_di_arrivo',
  /** column name */
  Tipo = 'tipo',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Staging_Azione_Sottoscrizione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Staging_Azione_Sottoscrizione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Staging_Azione_Sottoscrizione_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Staging_Azione_Sottoscrizione_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Staging_Azione_Sottoscrizione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging_Azione_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging_Azione_Sottoscrizione_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Staging_Azione_Sottoscrizione_Var_Pop_Fields = {
  __typename?: 'staging_azione_sottoscrizione_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Staging_Azione_Sottoscrizione_Var_Samp_Fields = {
  __typename?: 'staging_azione_sottoscrizione_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Staging_Azione_Sottoscrizione_Variance_Fields = {
  __typename?: 'staging_azione_sottoscrizione_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "staging.gestore_lotto" */
export type Staging_Gestore_Lotto = {
  __typename?: 'staging_gestore_lotto';
  auth_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lotto: Staging_Lotto;
  lotto_id: Scalars['uuid']['output'];
  ruolo?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Aggregate = {
  __typename?: 'staging_gestore_lotto_aggregate';
  aggregate?: Maybe<Staging_Gestore_Lotto_Aggregate_Fields>;
  nodes: Array<Staging_Gestore_Lotto>;
};

export type Staging_Gestore_Lotto_Aggregate_Bool_Exp = {
  count?: InputMaybe<Staging_Gestore_Lotto_Aggregate_Bool_Exp_Count>;
};

export type Staging_Gestore_Lotto_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Aggregate_Fields = {
  __typename?: 'staging_gestore_lotto_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Gestore_Lotto_Max_Fields>;
  min?: Maybe<Staging_Gestore_Lotto_Min_Fields>;
};


/** aggregate fields of "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Staging_Gestore_Lotto_Max_Order_By>;
  min?: InputMaybe<Staging_Gestore_Lotto_Min_Order_By>;
};

/** input type for inserting array relation for remote table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Arr_Rel_Insert_Input = {
  data: Array<Staging_Gestore_Lotto_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Staging_Gestore_Lotto_On_Conflict>;
};

/** Boolean expression to filter rows from the table "staging.gestore_lotto". All fields are combined with a logical 'AND'. */
export type Staging_Gestore_Lotto_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Gestore_Lotto_Bool_Exp>>;
  _not?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Gestore_Lotto_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lotto?: InputMaybe<Staging_Lotto_Bool_Exp>;
  lotto_id?: InputMaybe<Uuid_Comparison_Exp>;
  ruolo?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging.gestore_lotto" */
export enum Staging_Gestore_Lotto_Constraint {
  /** unique or primary key constraint on columns "id" */
  GestoreLottoPkey = 'gestore_lotto_pkey'
}

/** input type for inserting data into table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lotto?: InputMaybe<Staging_Lotto_Obj_Rel_Insert_Input>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  ruolo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Staging_Gestore_Lotto_Max_Fields = {
  __typename?: 'staging_gestore_lotto_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  ruolo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Max_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  ruolo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Staging_Gestore_Lotto_Min_Fields = {
  __typename?: 'staging_gestore_lotto_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  ruolo?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Min_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  ruolo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Mutation_Response = {
  __typename?: 'staging_gestore_lotto_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging_Gestore_Lotto>;
};

/** on_conflict condition type for table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_On_Conflict = {
  constraint: Staging_Gestore_Lotto_Constraint;
  update_columns?: Array<Staging_Gestore_Lotto_Update_Column>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};

/** Ordering options when selecting data from "staging.gestore_lotto". */
export type Staging_Gestore_Lotto_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotto?: InputMaybe<Staging_Lotto_Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  ruolo?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging.gestore_lotto */
export type Staging_Gestore_Lotto_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "staging.gestore_lotto" */
export enum Staging_Gestore_Lotto_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LottoId = 'lotto_id',
  /** column name */
  Ruolo = 'ruolo',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "staging.gestore_lotto" */
export type Staging_Gestore_Lotto_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  ruolo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "staging_gestore_lotto" */
export type Staging_Gestore_Lotto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Gestore_Lotto_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Gestore_Lotto_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  ruolo?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "staging.gestore_lotto" */
export enum Staging_Gestore_Lotto_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LottoId = 'lotto_id',
  /** column name */
  Ruolo = 'ruolo',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Staging_Gestore_Lotto_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging_Gestore_Lotto_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging_Gestore_Lotto_Bool_Exp;
};

/** columns and relationships of "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione = {
  __typename?: 'staging_gestore_sottoscrizione';
  auth_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  ruolo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sottoscrizione: Staging_Sottoscrizione;
  sottoscrizione_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Aggregate = {
  __typename?: 'staging_gestore_sottoscrizione_aggregate';
  aggregate?: Maybe<Staging_Gestore_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Staging_Gestore_Sottoscrizione>;
};

export type Staging_Gestore_Sottoscrizione_Aggregate_Bool_Exp = {
  count?: InputMaybe<Staging_Gestore_Sottoscrizione_Aggregate_Bool_Exp_Count>;
};

export type Staging_Gestore_Sottoscrizione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'staging_gestore_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Gestore_Sottoscrizione_Max_Fields>;
  min?: Maybe<Staging_Gestore_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Staging_Gestore_Sottoscrizione_Max_Order_By>;
  min?: InputMaybe<Staging_Gestore_Sottoscrizione_Min_Order_By>;
};

/** input type for inserting array relation for remote table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Arr_Rel_Insert_Input = {
  data: Array<Staging_Gestore_Sottoscrizione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Staging_Gestore_Sottoscrizione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "staging.gestore_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Staging_Gestore_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ruolo?: InputMaybe<String_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging.gestore_sottoscrizione" */
export enum Staging_Gestore_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "id" */
  GestoreSottoscrizionePkey = 'gestore_sottoscrizione_pkey'
}

/** input type for inserting data into table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ruolo?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione?: InputMaybe<Staging_Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Staging_Gestore_Sottoscrizione_Max_Fields = {
  __typename?: 'staging_gestore_sottoscrizione_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ruolo?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Max_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruolo?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Staging_Gestore_Sottoscrizione_Min_Fields = {
  __typename?: 'staging_gestore_sottoscrizione_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ruolo?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Min_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruolo?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Mutation_Response = {
  __typename?: 'staging_gestore_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging_Gestore_Sottoscrizione>;
};

/** on_conflict condition type for table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_On_Conflict = {
  constraint: Staging_Gestore_Sottoscrizione_Constraint;
  update_columns?: Array<Staging_Gestore_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "staging.gestore_sottoscrizione". */
export type Staging_Gestore_Sottoscrizione_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruolo?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Staging_Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging.gestore_sottoscrizione */
export type Staging_Gestore_Sottoscrizione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "staging.gestore_sottoscrizione" */
export enum Staging_Gestore_Sottoscrizione_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Ruolo = 'ruolo',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "staging.gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ruolo?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "staging_gestore_sottoscrizione" */
export type Staging_Gestore_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Gestore_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Gestore_Sottoscrizione_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ruolo?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "staging.gestore_sottoscrizione" */
export enum Staging_Gestore_Sottoscrizione_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Ruolo = 'ruolo',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Staging_Gestore_Sottoscrizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging_Gestore_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging_Gestore_Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "staging.log" */
export type Staging_Log = {
  __typename?: 'staging_log';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dettaglio?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  livello?: Maybe<Scalars['String']['output']>;
  messaggio?: Maybe<Scalars['String']['output']>;
  sorgente?: Maybe<Scalars['String']['output']>;
  stacktrace?: Maybe<Scalars['String']['output']>;
  staging_sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Staging__Stato_Sottoscrizione_Enum>;
};


/** columns and relationships of "staging.log" */
export type Staging_LogDettaglioArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "staging.log" */
export type Staging_Log_Aggregate = {
  __typename?: 'staging_log_aggregate';
  aggregate?: Maybe<Staging_Log_Aggregate_Fields>;
  nodes: Array<Staging_Log>;
};

/** aggregate fields of "staging.log" */
export type Staging_Log_Aggregate_Fields = {
  __typename?: 'staging_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Log_Max_Fields>;
  min?: Maybe<Staging_Log_Min_Fields>;
};


/** aggregate fields of "staging.log" */
export type Staging_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Staging_Log_Append_Input = {
  dettaglio?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "staging.log". All fields are combined with a logical 'AND'. */
export type Staging_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Log_Bool_Exp>>;
  _not?: InputMaybe<Staging_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dettaglio?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  livello?: InputMaybe<String_Comparison_Exp>;
  messaggio?: InputMaybe<String_Comparison_Exp>;
  sorgente?: InputMaybe<String_Comparison_Exp>;
  stacktrace?: InputMaybe<String_Comparison_Exp>;
  staging_sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<Staging__Stato_Sottoscrizione_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging.log" */
export enum Staging_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogPkey = 'log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Staging_Log_Delete_At_Path_Input = {
  dettaglio?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Staging_Log_Delete_Elem_Input = {
  dettaglio?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Staging_Log_Delete_Key_Input = {
  dettaglio?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "staging.log" */
export type Staging_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dettaglio?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  livello?: InputMaybe<Scalars['String']['input']>;
  messaggio?: InputMaybe<Scalars['String']['input']>;
  sorgente?: InputMaybe<Scalars['String']['input']>;
  stacktrace?: InputMaybe<Scalars['String']['input']>;
  staging_sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Staging__Stato_Sottoscrizione_Enum>;
};

/** aggregate max on columns */
export type Staging_Log_Max_Fields = {
  __typename?: 'staging_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  livello?: Maybe<Scalars['String']['output']>;
  messaggio?: Maybe<Scalars['String']['output']>;
  sorgente?: Maybe<Scalars['String']['output']>;
  stacktrace?: Maybe<Scalars['String']['output']>;
  staging_sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Staging_Log_Min_Fields = {
  __typename?: 'staging_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  livello?: Maybe<Scalars['String']['output']>;
  messaggio?: Maybe<Scalars['String']['output']>;
  sorgente?: Maybe<Scalars['String']['output']>;
  stacktrace?: Maybe<Scalars['String']['output']>;
  staging_sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "staging.log" */
export type Staging_Log_Mutation_Response = {
  __typename?: 'staging_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging_Log>;
};

/** on_conflict condition type for table "staging.log" */
export type Staging_Log_On_Conflict = {
  constraint: Staging_Log_Constraint;
  update_columns?: Array<Staging_Log_Update_Column>;
  where?: InputMaybe<Staging_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "staging.log". */
export type Staging_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dettaglio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livello?: InputMaybe<Order_By>;
  messaggio?: InputMaybe<Order_By>;
  sorgente?: InputMaybe<Order_By>;
  stacktrace?: InputMaybe<Order_By>;
  staging_sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging.log */
export type Staging_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Staging_Log_Prepend_Input = {
  dettaglio?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "staging.log" */
export enum Staging_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dettaglio = 'dettaglio',
  /** column name */
  Id = 'id',
  /** column name */
  Livello = 'livello',
  /** column name */
  Messaggio = 'messaggio',
  /** column name */
  Sorgente = 'sorgente',
  /** column name */
  Stacktrace = 'stacktrace',
  /** column name */
  StagingSottoscrizioneId = 'staging_sottoscrizione_id',
  /** column name */
  Stato = 'stato'
}

/** input type for updating data in table "staging.log" */
export type Staging_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dettaglio?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  livello?: InputMaybe<Scalars['String']['input']>;
  messaggio?: InputMaybe<Scalars['String']['input']>;
  sorgente?: InputMaybe<Scalars['String']['input']>;
  stacktrace?: InputMaybe<Scalars['String']['input']>;
  staging_sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Staging__Stato_Sottoscrizione_Enum>;
};

/** Streaming cursor of the table "staging_log" */
export type Staging_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dettaglio?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  livello?: InputMaybe<Scalars['String']['input']>;
  messaggio?: InputMaybe<Scalars['String']['input']>;
  sorgente?: InputMaybe<Scalars['String']['input']>;
  stacktrace?: InputMaybe<Scalars['String']['input']>;
  staging_sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Staging__Stato_Sottoscrizione_Enum>;
};

/** update columns of table "staging.log" */
export enum Staging_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dettaglio = 'dettaglio',
  /** column name */
  Id = 'id',
  /** column name */
  Livello = 'livello',
  /** column name */
  Messaggio = 'messaggio',
  /** column name */
  Sorgente = 'sorgente',
  /** column name */
  Stacktrace = 'stacktrace',
  /** column name */
  StagingSottoscrizioneId = 'staging_sottoscrizione_id',
  /** column name */
  Stato = 'stato'
}

export type Staging_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Staging_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Staging_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Staging_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Staging_Log_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Staging_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging_Log_Bool_Exp;
};

/** columns and relationships of "staging.lotto" */
export type Staging_Lotto = {
  __typename?: 'staging_lotto';
  created_at: Scalars['timestamptz']['output'];
  file_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  gestori: Array<Staging_Gestore_Lotto>;
  /** An aggregate relationship */
  gestori_aggregate: Staging_Gestore_Lotto_Aggregate;
  id: Scalars['uuid']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sottoscrizioni: Array<Staging_Sottoscrizione>;
  /** An aggregate relationship */
  sottoscrizioni_aggregate: Staging_Sottoscrizione_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "staging.lotto" */
export type Staging_LottoGestoriArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};


/** columns and relationships of "staging.lotto" */
export type Staging_LottoGestori_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};


/** columns and relationships of "staging.lotto" */
export type Staging_LottoSottoscrizioniArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "staging.lotto" */
export type Staging_LottoSottoscrizioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};

/** aggregated selection of "staging.lotto" */
export type Staging_Lotto_Aggregate = {
  __typename?: 'staging_lotto_aggregate';
  aggregate?: Maybe<Staging_Lotto_Aggregate_Fields>;
  nodes: Array<Staging_Lotto>;
};

/** aggregate fields of "staging.lotto" */
export type Staging_Lotto_Aggregate_Fields = {
  __typename?: 'staging_lotto_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Lotto_Max_Fields>;
  min?: Maybe<Staging_Lotto_Min_Fields>;
};


/** aggregate fields of "staging.lotto" */
export type Staging_Lotto_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Lotto_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "staging.lotto". All fields are combined with a logical 'AND'. */
export type Staging_Lotto_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Lotto_Bool_Exp>>;
  _not?: InputMaybe<Staging_Lotto_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Lotto_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  gestori?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Lotto_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  sottoscrizioni?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
  sottoscrizioni_aggregate?: InputMaybe<Staging_Sottoscrizione_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging.lotto" */
export enum Staging_Lotto_Constraint {
  /** unique or primary key constraint on columns "id" */
  LottoPkey = 'lotto_pkey'
}

/** input type for inserting data into table "staging.lotto" */
export type Staging_Lotto_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  gestori?: InputMaybe<Staging_Gestore_Lotto_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  sottoscrizioni?: InputMaybe<Staging_Sottoscrizione_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Staging_Lotto_Max_Fields = {
  __typename?: 'staging_lotto_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Staging_Lotto_Min_Fields = {
  __typename?: 'staging_lotto_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "staging.lotto" */
export type Staging_Lotto_Mutation_Response = {
  __typename?: 'staging_lotto_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging_Lotto>;
};

/** input type for inserting object relation for remote table "staging.lotto" */
export type Staging_Lotto_Obj_Rel_Insert_Input = {
  data: Staging_Lotto_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Staging_Lotto_On_Conflict>;
};

/** on_conflict condition type for table "staging.lotto" */
export type Staging_Lotto_On_Conflict = {
  constraint: Staging_Lotto_Constraint;
  update_columns?: Array<Staging_Lotto_Update_Column>;
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
};

/** Ordering options when selecting data from "staging.lotto". */
export type Staging_Lotto_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Lotto_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  sottoscrizioni_aggregate?: InputMaybe<Staging_Sottoscrizione_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging.lotto */
export type Staging_Lotto_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "staging.lotto" */
export enum Staging_Lotto_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "staging.lotto" */
export type Staging_Lotto_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "staging_lotto" */
export type Staging_Lotto_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Lotto_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Lotto_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "staging.lotto" */
export enum Staging_Lotto_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Staging_Lotto_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging_Lotto_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging_Lotto_Bool_Exp;
};

/** columns and relationships of "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State = {
  __typename?: 'staging_mv_refresh_state';
  dirty: Scalars['Boolean']['output'];
  last_refresh_at?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State_Aggregate = {
  __typename?: 'staging_mv_refresh_state_aggregate';
  aggregate?: Maybe<Staging_Mv_Refresh_State_Aggregate_Fields>;
  nodes: Array<Staging_Mv_Refresh_State>;
};

/** aggregate fields of "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State_Aggregate_Fields = {
  __typename?: 'staging_mv_refresh_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Mv_Refresh_State_Max_Fields>;
  min?: Maybe<Staging_Mv_Refresh_State_Min_Fields>;
};


/** aggregate fields of "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Mv_Refresh_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "staging.mv_refresh_state". All fields are combined with a logical 'AND'. */
export type Staging_Mv_Refresh_State_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Mv_Refresh_State_Bool_Exp>>;
  _not?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Mv_Refresh_State_Bool_Exp>>;
  dirty?: InputMaybe<Boolean_Comparison_Exp>;
  last_refresh_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging.mv_refresh_state" */
export enum Staging_Mv_Refresh_State_Constraint {
  /** unique or primary key constraint on columns "name" */
  MvRefreshStatePkey = 'mv_refresh_state_pkey'
}

/** input type for inserting data into table "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State_Insert_Input = {
  dirty?: InputMaybe<Scalars['Boolean']['input']>;
  last_refresh_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Staging_Mv_Refresh_State_Max_Fields = {
  __typename?: 'staging_mv_refresh_state_max_fields';
  last_refresh_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Staging_Mv_Refresh_State_Min_Fields = {
  __typename?: 'staging_mv_refresh_state_min_fields';
  last_refresh_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State_Mutation_Response = {
  __typename?: 'staging_mv_refresh_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging_Mv_Refresh_State>;
};

/** on_conflict condition type for table "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State_On_Conflict = {
  constraint: Staging_Mv_Refresh_State_Constraint;
  update_columns?: Array<Staging_Mv_Refresh_State_Update_Column>;
  where?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
};

/** Ordering options when selecting data from "staging.mv_refresh_state". */
export type Staging_Mv_Refresh_State_Order_By = {
  dirty?: InputMaybe<Order_By>;
  last_refresh_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging.mv_refresh_state */
export type Staging_Mv_Refresh_State_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "staging.mv_refresh_state" */
export enum Staging_Mv_Refresh_State_Select_Column {
  /** column name */
  Dirty = 'dirty',
  /** column name */
  LastRefreshAt = 'last_refresh_at',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "staging.mv_refresh_state" */
export type Staging_Mv_Refresh_State_Set_Input = {
  dirty?: InputMaybe<Scalars['Boolean']['input']>;
  last_refresh_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "staging_mv_refresh_state" */
export type Staging_Mv_Refresh_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Mv_Refresh_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Mv_Refresh_State_Stream_Cursor_Value_Input = {
  dirty?: InputMaybe<Scalars['Boolean']['input']>;
  last_refresh_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "staging.mv_refresh_state" */
export enum Staging_Mv_Refresh_State_Update_Column {
  /** column name */
  Dirty = 'dirty',
  /** column name */
  LastRefreshAt = 'last_refresh_at',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Staging_Mv_Refresh_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging_Mv_Refresh_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging_Mv_Refresh_State_Bool_Exp;
};

export type Staging_Refresh_Sottoscrizione_Mv_Args = {
  p_force?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "staging.sottoscrizione" */
export type Staging_Sottoscrizione = {
  __typename?: 'staging_sottoscrizione';
  azione?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  azione_sottoscrizione?: Maybe<Staging_Azione_Sottoscrizione>;
  created_at: Scalars['timestamptz']['output'];
  data?: Maybe<Scalars['jsonb']['output']>;
  errore?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  gestori: Array<Staging_Gestore_Sottoscrizione>;
  /** An aggregate relationship */
  gestori_aggregate: Staging_Gestore_Sottoscrizione_Aggregate;
  id: Scalars['uuid']['output'];
  invalid_controls?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  lotto?: Maybe<Staging_Lotto>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sottoscrizione?: Maybe<Sottoscrizione>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_info?: Maybe<Scalars['jsonb']['output']>;
  valido: Scalars['Boolean']['output'];
};


/** columns and relationships of "staging.sottoscrizione" */
export type Staging_SottoscrizioneDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "staging.sottoscrizione" */
export type Staging_SottoscrizioneErroreArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "staging.sottoscrizione" */
export type Staging_SottoscrizioneGestoriArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "staging.sottoscrizione" */
export type Staging_SottoscrizioneGestori_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "staging.sottoscrizione" */
export type Staging_SottoscrizioneInvalid_ControlsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "staging.sottoscrizione" */
export type Staging_SottoscrizioneUser_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Aggregate = {
  __typename?: 'staging_sottoscrizione_aggregate';
  aggregate?: Maybe<Staging_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Staging_Sottoscrizione>;
};

export type Staging_Sottoscrizione_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Staging_Sottoscrizione_Aggregate_Bool_Exp_Count>;
};

export type Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_And = {
  arguments: Staging_Sottoscrizione_Select_Column_Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Staging_Sottoscrizione_Select_Column_Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Staging_Sottoscrizione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'staging_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Sottoscrizione_Max_Fields>;
  min?: Maybe<Staging_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Staging_Sottoscrizione_Max_Order_By>;
  min?: InputMaybe<Staging_Sottoscrizione_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Staging_Sottoscrizione_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  errore?: InputMaybe<Scalars['jsonb']['input']>;
  invalid_controls?: InputMaybe<Scalars['jsonb']['input']>;
  user_info?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Arr_Rel_Insert_Input = {
  data: Array<Staging_Sottoscrizione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Staging_Sottoscrizione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "staging.sottoscrizione". All fields are combined with a logical 'AND'. */
export type Staging_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Sottoscrizione_Bool_Exp>>;
  azione?: InputMaybe<Uuid_Comparison_Exp>;
  azione_sottoscrizione?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  errore?: InputMaybe<Jsonb_Comparison_Exp>;
  gestori?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Sottoscrizione_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalid_controls?: InputMaybe<Jsonb_Comparison_Exp>;
  lotto?: InputMaybe<Staging_Lotto_Bool_Exp>;
  lotto_id?: InputMaybe<Uuid_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_info?: InputMaybe<Jsonb_Comparison_Exp>;
  valido?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "staging.sottoscrizione" */
export enum Staging_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "id" */
  SottoscrizionePkey = 'sottoscrizione_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Staging_Sottoscrizione_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  errore?: InputMaybe<Array<Scalars['String']['input']>>;
  invalid_controls?: InputMaybe<Array<Scalars['String']['input']>>;
  user_info?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Staging_Sottoscrizione_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
  errore?: InputMaybe<Scalars['Int']['input']>;
  invalid_controls?: InputMaybe<Scalars['Int']['input']>;
  user_info?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Staging_Sottoscrizione_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
  errore?: InputMaybe<Scalars['String']['input']>;
  invalid_controls?: InputMaybe<Scalars['String']['input']>;
  user_info?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Insert_Input = {
  azione?: InputMaybe<Scalars['uuid']['input']>;
  azione_sottoscrizione?: InputMaybe<Staging_Azione_Sottoscrizione_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  errore?: InputMaybe<Scalars['jsonb']['input']>;
  gestori?: InputMaybe<Staging_Gestore_Sottoscrizione_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_controls?: InputMaybe<Scalars['jsonb']['input']>;
  lotto?: InputMaybe<Staging_Lotto_Obj_Rel_Insert_Input>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_info?: InputMaybe<Scalars['jsonb']['input']>;
  valido?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_Mv = {
  __typename?: 'staging_sottoscrizione_list_mv';
  azione?: Maybe<Scalars['uuid']['output']>;
  azione_gruppo?: Maybe<Scalars['String']['output']>;
  azione_label?: Maybe<Scalars['String']['output']>;
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errore?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  gestori: Array<Staging_Gestore_Sottoscrizione>;
  /** An aggregate relationship */
  gestori_aggregate: Staging_Gestore_Sottoscrizione_Aggregate;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_email?: Maybe<Scalars['String']['output']>;
  invalid_controls?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  lotto?: Maybe<Staging_Lotto>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  lotto_nome?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  valido?: Maybe<Scalars['Boolean']['output']>;
  warning?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_MvErroreArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_MvGestoriArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_MvGestori_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_MvInvalid_ControlsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_Mv_Aggregate = {
  __typename?: 'staging_sottoscrizione_list_mv_aggregate';
  aggregate?: Maybe<Staging_Sottoscrizione_List_Mv_Aggregate_Fields>;
  nodes: Array<Staging_Sottoscrizione_List_Mv>;
};

/** aggregate fields of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_Mv_Aggregate_Fields = {
  __typename?: 'staging_sottoscrizione_list_mv_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Sottoscrizione_List_Mv_Max_Fields>;
  min?: Maybe<Staging_Sottoscrizione_List_Mv_Min_Fields>;
};


/** aggregate fields of "staging.sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_Mv_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "staging.sottoscrizione_list_mv". All fields are combined with a logical 'AND'. */
export type Staging_Sottoscrizione_List_Mv_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Bool_Exp>>;
  _not?: InputMaybe<Staging_Sottoscrizione_List_Mv_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Bool_Exp>>;
  azione?: InputMaybe<Uuid_Comparison_Exp>;
  azione_gruppo?: InputMaybe<String_Comparison_Exp>;
  azione_label?: InputMaybe<String_Comparison_Exp>;
  cellulare?: InputMaybe<String_Comparison_Exp>;
  cer_alias?: InputMaybe<String_Comparison_Exp>;
  cer_padre_alias?: InputMaybe<String_Comparison_Exp>;
  cognome?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  errore?: InputMaybe<Jsonb_Comparison_Exp>;
  gestori?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Sottoscrizione_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intestatario_email?: InputMaybe<String_Comparison_Exp>;
  invalid_controls?: InputMaybe<Jsonb_Comparison_Exp>;
  lotto?: InputMaybe<Staging_Lotto_Bool_Exp>;
  lotto_id?: InputMaybe<Uuid_Comparison_Exp>;
  lotto_nome?: InputMaybe<String_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  pod?: InputMaybe<String_Comparison_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valido?: InputMaybe<Boolean_Comparison_Exp>;
  warning?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Staging_Sottoscrizione_List_Mv_Max_Fields = {
  __typename?: 'staging_sottoscrizione_list_mv_max_fields';
  azione?: Maybe<Scalars['uuid']['output']>;
  azione_gruppo?: Maybe<Scalars['String']['output']>;
  azione_label?: Maybe<Scalars['String']['output']>;
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_email?: Maybe<Scalars['String']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  lotto_nome?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Staging_Sottoscrizione_List_Mv_Min_Fields = {
  __typename?: 'staging_sottoscrizione_list_mv_min_fields';
  azione?: Maybe<Scalars['uuid']['output']>;
  azione_gruppo?: Maybe<Scalars['String']['output']>;
  azione_label?: Maybe<Scalars['String']['output']>;
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_email?: Maybe<Scalars['String']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  lotto_nome?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "staging.sottoscrizione_list_mv". */
export type Staging_Sottoscrizione_List_Mv_Order_By = {
  azione?: InputMaybe<Order_By>;
  azione_gruppo?: InputMaybe<Order_By>;
  azione_label?: InputMaybe<Order_By>;
  cellulare?: InputMaybe<Order_By>;
  cer_alias?: InputMaybe<Order_By>;
  cer_padre_alias?: InputMaybe<Order_By>;
  cognome?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  errore?: InputMaybe<Order_By>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Sottoscrizione_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  intestatario_email?: InputMaybe<Order_By>;
  invalid_controls?: InputMaybe<Order_By>;
  lotto?: InputMaybe<Staging_Lotto_Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  lotto_nome?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valido?: InputMaybe<Order_By>;
  warning?: InputMaybe<Order_By>;
};

/** select columns of table "staging.sottoscrizione_list_mv" */
export enum Staging_Sottoscrizione_List_Mv_Select_Column {
  /** column name */
  Azione = 'azione',
  /** column name */
  AzioneGruppo = 'azione_gruppo',
  /** column name */
  AzioneLabel = 'azione_label',
  /** column name */
  Cellulare = 'cellulare',
  /** column name */
  CerAlias = 'cer_alias',
  /** column name */
  CerPadreAlias = 'cer_padre_alias',
  /** column name */
  Cognome = 'cognome',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Errore = 'errore',
  /** column name */
  Id = 'id',
  /** column name */
  IntestatarioEmail = 'intestatario_email',
  /** column name */
  InvalidControls = 'invalid_controls',
  /** column name */
  LottoId = 'lotto_id',
  /** column name */
  LottoNome = 'lotto_nome',
  /** column name */
  Nome = 'nome',
  /** column name */
  Pod = 'pod',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Valido = 'valido',
  /** column name */
  Warning = 'warning'
}

/** Streaming cursor of the table "staging_sottoscrizione_list_mv" */
export type Staging_Sottoscrizione_List_Mv_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Sottoscrizione_List_Mv_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Sottoscrizione_List_Mv_Stream_Cursor_Value_Input = {
  azione?: InputMaybe<Scalars['uuid']['input']>;
  azione_gruppo?: InputMaybe<Scalars['String']['input']>;
  azione_label?: InputMaybe<Scalars['String']['input']>;
  cellulare?: InputMaybe<Scalars['String']['input']>;
  cer_alias?: InputMaybe<Scalars['String']['input']>;
  cer_padre_alias?: InputMaybe<Scalars['String']['input']>;
  cognome?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  errore?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario_email?: InputMaybe<Scalars['String']['input']>;
  invalid_controls?: InputMaybe<Scalars['jsonb']['input']>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  lotto_nome?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valido?: InputMaybe<Scalars['Boolean']['input']>;
  warning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_V = {
  __typename?: 'staging_sottoscrizione_list_v';
  azione?: Maybe<Scalars['uuid']['output']>;
  azione_gruppo?: Maybe<Scalars['String']['output']>;
  azione_label?: Maybe<Scalars['String']['output']>;
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errore?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  gestori: Array<Staging_Gestore_Sottoscrizione>;
  /** An aggregate relationship */
  gestori_aggregate: Staging_Gestore_Sottoscrizione_Aggregate;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_email?: Maybe<Scalars['String']['output']>;
  invalid_controls?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  lotto?: Maybe<Staging_Lotto>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  lotto_nome?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  valido?: Maybe<Scalars['Boolean']['output']>;
  warning?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_VErroreArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_VGestoriArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_VGestori_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


/** columns and relationships of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_VInvalid_ControlsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_V_Aggregate = {
  __typename?: 'staging_sottoscrizione_list_v_aggregate';
  aggregate?: Maybe<Staging_Sottoscrizione_List_V_Aggregate_Fields>;
  nodes: Array<Staging_Sottoscrizione_List_V>;
};

/** aggregate fields of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_V_Aggregate_Fields = {
  __typename?: 'staging_sottoscrizione_list_v_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Staging_Sottoscrizione_List_V_Max_Fields>;
  min?: Maybe<Staging_Sottoscrizione_List_V_Min_Fields>;
};


/** aggregate fields of "staging.sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_V_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "staging.sottoscrizione_list_v". All fields are combined with a logical 'AND'. */
export type Staging_Sottoscrizione_List_V_Bool_Exp = {
  _and?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Bool_Exp>>;
  _not?: InputMaybe<Staging_Sottoscrizione_List_V_Bool_Exp>;
  _or?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Bool_Exp>>;
  azione?: InputMaybe<Uuid_Comparison_Exp>;
  azione_gruppo?: InputMaybe<String_Comparison_Exp>;
  azione_label?: InputMaybe<String_Comparison_Exp>;
  cellulare?: InputMaybe<String_Comparison_Exp>;
  cer_alias?: InputMaybe<String_Comparison_Exp>;
  cer_padre_alias?: InputMaybe<String_Comparison_Exp>;
  cognome?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  errore?: InputMaybe<Jsonb_Comparison_Exp>;
  gestori?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Sottoscrizione_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intestatario_email?: InputMaybe<String_Comparison_Exp>;
  invalid_controls?: InputMaybe<Jsonb_Comparison_Exp>;
  lotto?: InputMaybe<Staging_Lotto_Bool_Exp>;
  lotto_id?: InputMaybe<Uuid_Comparison_Exp>;
  lotto_nome?: InputMaybe<String_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  pod?: InputMaybe<String_Comparison_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valido?: InputMaybe<Boolean_Comparison_Exp>;
  warning?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Staging_Sottoscrizione_List_V_Max_Fields = {
  __typename?: 'staging_sottoscrizione_list_v_max_fields';
  azione?: Maybe<Scalars['uuid']['output']>;
  azione_gruppo?: Maybe<Scalars['String']['output']>;
  azione_label?: Maybe<Scalars['String']['output']>;
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_email?: Maybe<Scalars['String']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  lotto_nome?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Staging_Sottoscrizione_List_V_Min_Fields = {
  __typename?: 'staging_sottoscrizione_list_v_min_fields';
  azione?: Maybe<Scalars['uuid']['output']>;
  azione_gruppo?: Maybe<Scalars['String']['output']>;
  azione_label?: Maybe<Scalars['String']['output']>;
  cellulare?: Maybe<Scalars['String']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intestatario_email?: Maybe<Scalars['String']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  lotto_nome?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "staging.sottoscrizione_list_v". */
export type Staging_Sottoscrizione_List_V_Order_By = {
  azione?: InputMaybe<Order_By>;
  azione_gruppo?: InputMaybe<Order_By>;
  azione_label?: InputMaybe<Order_By>;
  cellulare?: InputMaybe<Order_By>;
  cer_alias?: InputMaybe<Order_By>;
  cer_padre_alias?: InputMaybe<Order_By>;
  cognome?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  errore?: InputMaybe<Order_By>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Sottoscrizione_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  intestatario_email?: InputMaybe<Order_By>;
  invalid_controls?: InputMaybe<Order_By>;
  lotto?: InputMaybe<Staging_Lotto_Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  lotto_nome?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valido?: InputMaybe<Order_By>;
  warning?: InputMaybe<Order_By>;
};

/** select columns of table "staging.sottoscrizione_list_v" */
export enum Staging_Sottoscrizione_List_V_Select_Column {
  /** column name */
  Azione = 'azione',
  /** column name */
  AzioneGruppo = 'azione_gruppo',
  /** column name */
  AzioneLabel = 'azione_label',
  /** column name */
  Cellulare = 'cellulare',
  /** column name */
  CerAlias = 'cer_alias',
  /** column name */
  CerPadreAlias = 'cer_padre_alias',
  /** column name */
  Cognome = 'cognome',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Errore = 'errore',
  /** column name */
  Id = 'id',
  /** column name */
  IntestatarioEmail = 'intestatario_email',
  /** column name */
  InvalidControls = 'invalid_controls',
  /** column name */
  LottoId = 'lotto_id',
  /** column name */
  LottoNome = 'lotto_nome',
  /** column name */
  Nome = 'nome',
  /** column name */
  Pod = 'pod',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Valido = 'valido',
  /** column name */
  Warning = 'warning'
}

/** Streaming cursor of the table "staging_sottoscrizione_list_v" */
export type Staging_Sottoscrizione_List_V_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Sottoscrizione_List_V_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Sottoscrizione_List_V_Stream_Cursor_Value_Input = {
  azione?: InputMaybe<Scalars['uuid']['input']>;
  azione_gruppo?: InputMaybe<Scalars['String']['input']>;
  azione_label?: InputMaybe<Scalars['String']['input']>;
  cellulare?: InputMaybe<Scalars['String']['input']>;
  cer_alias?: InputMaybe<Scalars['String']['input']>;
  cer_padre_alias?: InputMaybe<Scalars['String']['input']>;
  cognome?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  errore?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  intestatario_email?: InputMaybe<Scalars['String']['input']>;
  invalid_controls?: InputMaybe<Scalars['jsonb']['input']>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  lotto_nome?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valido?: InputMaybe<Scalars['Boolean']['input']>;
  warning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Staging_Sottoscrizione_Max_Fields = {
  __typename?: 'staging_sottoscrizione_max_fields';
  azione?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Max_Order_By = {
  azione?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Staging_Sottoscrizione_Min_Fields = {
  __typename?: 'staging_sottoscrizione_min_fields';
  azione?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lotto_id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Min_Order_By = {
  azione?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Mutation_Response = {
  __typename?: 'staging_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Staging_Sottoscrizione>;
};

/** input type for inserting object relation for remote table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Obj_Rel_Insert_Input = {
  data: Staging_Sottoscrizione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Staging_Sottoscrizione_On_Conflict>;
};

/** on_conflict condition type for table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_On_Conflict = {
  constraint: Staging_Sottoscrizione_Constraint;
  update_columns?: Array<Staging_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "staging.sottoscrizione". */
export type Staging_Sottoscrizione_Order_By = {
  azione?: InputMaybe<Order_By>;
  azione_sottoscrizione?: InputMaybe<Staging_Azione_Sottoscrizione_Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  errore?: InputMaybe<Order_By>;
  gestori_aggregate?: InputMaybe<Staging_Gestore_Sottoscrizione_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invalid_controls?: InputMaybe<Order_By>;
  lotto?: InputMaybe<Staging_Lotto_Order_By>;
  lotto_id?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_info?: InputMaybe<Order_By>;
  valido?: InputMaybe<Order_By>;
};

/** primary key columns input for table: staging.sottoscrizione */
export type Staging_Sottoscrizione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Staging_Sottoscrizione_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  errore?: InputMaybe<Scalars['jsonb']['input']>;
  invalid_controls?: InputMaybe<Scalars['jsonb']['input']>;
  user_info?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "staging.sottoscrizione" */
export enum Staging_Sottoscrizione_Select_Column {
  /** column name */
  Azione = 'azione',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Errore = 'errore',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidControls = 'invalid_controls',
  /** column name */
  LottoId = 'lotto_id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserInfo = 'user_info',
  /** column name */
  Valido = 'valido'
}

/** select "staging_sottoscrizione_aggregate_bool_exp_bool_and_arguments_columns" columns of table "staging.sottoscrizione" */
export enum Staging_Sottoscrizione_Select_Column_Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Valido = 'valido'
}

/** select "staging_sottoscrizione_aggregate_bool_exp_bool_or_arguments_columns" columns of table "staging.sottoscrizione" */
export enum Staging_Sottoscrizione_Select_Column_Staging_Sottoscrizione_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Valido = 'valido'
}

/** input type for updating data in table "staging.sottoscrizione" */
export type Staging_Sottoscrizione_Set_Input = {
  azione?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  errore?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_controls?: InputMaybe<Scalars['jsonb']['input']>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_info?: InputMaybe<Scalars['jsonb']['input']>;
  valido?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "staging_sottoscrizione" */
export type Staging_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Staging_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Staging_Sottoscrizione_Stream_Cursor_Value_Input = {
  azione?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  errore?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid_controls?: InputMaybe<Scalars['jsonb']['input']>;
  lotto_id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_info?: InputMaybe<Scalars['jsonb']['input']>;
  valido?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "staging.sottoscrizione" */
export enum Staging_Sottoscrizione_Update_Column {
  /** column name */
  Azione = 'azione',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Errore = 'errore',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidControls = 'invalid_controls',
  /** column name */
  LottoId = 'lotto_id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserInfo = 'user_info',
  /** column name */
  Valido = 'valido'
}

export type Staging_Sottoscrizione_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Staging_Sottoscrizione_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Staging_Sottoscrizione_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Staging_Sottoscrizione_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Staging_Sottoscrizione_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Staging_Sottoscrizione_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Staging_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Staging_Sottoscrizione_Bool_Exp;
};

/** columns and relationships of "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log = {
  __typename?: 'storage_trigger_debug_log';
  context?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_LogMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Aggregate = {
  __typename?: 'storage_trigger_debug_log_aggregate';
  aggregate?: Maybe<Storage_Trigger_Debug_Log_Aggregate_Fields>;
  nodes: Array<Storage_Trigger_Debug_Log>;
};

/** aggregate fields of "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Aggregate_Fields = {
  __typename?: 'storage_trigger_debug_log_aggregate_fields';
  avg?: Maybe<Storage_Trigger_Debug_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Storage_Trigger_Debug_Log_Max_Fields>;
  min?: Maybe<Storage_Trigger_Debug_Log_Min_Fields>;
  stddev?: Maybe<Storage_Trigger_Debug_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Trigger_Debug_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Trigger_Debug_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Trigger_Debug_Log_Sum_Fields>;
  var_pop?: Maybe<Storage_Trigger_Debug_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Trigger_Debug_Log_Var_Samp_Fields>;
  variance?: Maybe<Storage_Trigger_Debug_Log_Variance_Fields>;
};


/** aggregate fields of "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Trigger_Debug_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Storage_Trigger_Debug_Log_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Storage_Trigger_Debug_Log_Avg_Fields = {
  __typename?: 'storage_trigger_debug_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.trigger_debug_log". All fields are combined with a logical 'AND'. */
export type Storage_Trigger_Debug_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Trigger_Debug_Log_Bool_Exp>>;
  _not?: InputMaybe<Storage_Trigger_Debug_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Trigger_Debug_Log_Bool_Exp>>;
  context?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.trigger_debug_log" */
export enum Storage_Trigger_Debug_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  TriggerDebugLogPkey = 'trigger_debug_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Storage_Trigger_Debug_Log_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Storage_Trigger_Debug_Log_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Storage_Trigger_Debug_Log_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Insert_Input = {
  context?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Storage_Trigger_Debug_Log_Max_Fields = {
  __typename?: 'storage_trigger_debug_log_max_fields';
  context?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Storage_Trigger_Debug_Log_Min_Fields = {
  __typename?: 'storage_trigger_debug_log_min_fields';
  context?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Mutation_Response = {
  __typename?: 'storage_trigger_debug_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Storage_Trigger_Debug_Log>;
};

/** on_conflict condition type for table "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_On_Conflict = {
  constraint: Storage_Trigger_Debug_Log_Constraint;
  update_columns?: Array<Storage_Trigger_Debug_Log_Update_Column>;
  where?: InputMaybe<Storage_Trigger_Debug_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.trigger_debug_log". */
export type Storage_Trigger_Debug_Log_Order_By = {
  context?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.trigger_debug_log */
export type Storage_Trigger_Debug_Log_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Storage_Trigger_Debug_Log_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.trigger_debug_log" */
export enum Storage_Trigger_Debug_Log_Select_Column {
  /** column name */
  Context = 'context',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Metadata = 'metadata'
}

/** input type for updating data in table "storage.trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Set_Input = {
  context?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Storage_Trigger_Debug_Log_Stddev_Fields = {
  __typename?: 'storage_trigger_debug_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Storage_Trigger_Debug_Log_Stddev_Pop_Fields = {
  __typename?: 'storage_trigger_debug_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Storage_Trigger_Debug_Log_Stddev_Samp_Fields = {
  __typename?: 'storage_trigger_debug_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "storage_trigger_debug_log" */
export type Storage_Trigger_Debug_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Trigger_Debug_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Trigger_Debug_Log_Stream_Cursor_Value_Input = {
  context?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Storage_Trigger_Debug_Log_Sum_Fields = {
  __typename?: 'storage_trigger_debug_log_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "storage.trigger_debug_log" */
export enum Storage_Trigger_Debug_Log_Update_Column {
  /** column name */
  Context = 'context',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Metadata = 'metadata'
}

export type Storage_Trigger_Debug_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Storage_Trigger_Debug_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Storage_Trigger_Debug_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Storage_Trigger_Debug_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Storage_Trigger_Debug_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Storage_Trigger_Debug_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Storage_Trigger_Debug_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Storage_Trigger_Debug_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Storage_Trigger_Debug_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Storage_Trigger_Debug_Log_Var_Pop_Fields = {
  __typename?: 'storage_trigger_debug_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Storage_Trigger_Debug_Log_Var_Samp_Fields = {
  __typename?: 'storage_trigger_debug_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Storage_Trigger_Debug_Log_Variance_Fields = {
  __typename?: 'storage_trigger_debug_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log = {
  __typename?: 'storage_trigger_error_log';
  context?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "storage.trigger_error_log" */
export type Storage_Trigger_Error_LogMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_Aggregate = {
  __typename?: 'storage_trigger_error_log_aggregate';
  aggregate?: Maybe<Storage_Trigger_Error_Log_Aggregate_Fields>;
  nodes: Array<Storage_Trigger_Error_Log>;
};

/** aggregate fields of "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_Aggregate_Fields = {
  __typename?: 'storage_trigger_error_log_aggregate_fields';
  avg?: Maybe<Storage_Trigger_Error_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Storage_Trigger_Error_Log_Max_Fields>;
  min?: Maybe<Storage_Trigger_Error_Log_Min_Fields>;
  stddev?: Maybe<Storage_Trigger_Error_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Trigger_Error_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Trigger_Error_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Trigger_Error_Log_Sum_Fields>;
  var_pop?: Maybe<Storage_Trigger_Error_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Trigger_Error_Log_Var_Samp_Fields>;
  variance?: Maybe<Storage_Trigger_Error_Log_Variance_Fields>;
};


/** aggregate fields of "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Trigger_Error_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Storage_Trigger_Error_Log_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Storage_Trigger_Error_Log_Avg_Fields = {
  __typename?: 'storage_trigger_error_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.trigger_error_log". All fields are combined with a logical 'AND'. */
export type Storage_Trigger_Error_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Trigger_Error_Log_Bool_Exp>>;
  _not?: InputMaybe<Storage_Trigger_Error_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Trigger_Error_Log_Bool_Exp>>;
  context?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.trigger_error_log" */
export enum Storage_Trigger_Error_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  TriggerErrorLogPkey = 'trigger_error_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Storage_Trigger_Error_Log_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Storage_Trigger_Error_Log_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Storage_Trigger_Error_Log_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_Insert_Input = {
  context?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Storage_Trigger_Error_Log_Max_Fields = {
  __typename?: 'storage_trigger_error_log_max_fields';
  context?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Storage_Trigger_Error_Log_Min_Fields = {
  __typename?: 'storage_trigger_error_log_min_fields';
  context?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_Mutation_Response = {
  __typename?: 'storage_trigger_error_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Storage_Trigger_Error_Log>;
};

/** on_conflict condition type for table "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_On_Conflict = {
  constraint: Storage_Trigger_Error_Log_Constraint;
  update_columns?: Array<Storage_Trigger_Error_Log_Update_Column>;
  where?: InputMaybe<Storage_Trigger_Error_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.trigger_error_log". */
export type Storage_Trigger_Error_Log_Order_By = {
  context?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.trigger_error_log */
export type Storage_Trigger_Error_Log_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Storage_Trigger_Error_Log_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.trigger_error_log" */
export enum Storage_Trigger_Error_Log_Select_Column {
  /** column name */
  Context = 'context',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata'
}

/** input type for updating data in table "storage.trigger_error_log" */
export type Storage_Trigger_Error_Log_Set_Input = {
  context?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Storage_Trigger_Error_Log_Stddev_Fields = {
  __typename?: 'storage_trigger_error_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Storage_Trigger_Error_Log_Stddev_Pop_Fields = {
  __typename?: 'storage_trigger_error_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Storage_Trigger_Error_Log_Stddev_Samp_Fields = {
  __typename?: 'storage_trigger_error_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "storage_trigger_error_log" */
export type Storage_Trigger_Error_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Trigger_Error_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Trigger_Error_Log_Stream_Cursor_Value_Input = {
  context?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Storage_Trigger_Error_Log_Sum_Fields = {
  __typename?: 'storage_trigger_error_log_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.trigger_error_log" */
export enum Storage_Trigger_Error_Log_Update_Column {
  /** column name */
  Context = 'context',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata'
}

export type Storage_Trigger_Error_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Storage_Trigger_Error_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Storage_Trigger_Error_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Storage_Trigger_Error_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Storage_Trigger_Error_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Storage_Trigger_Error_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Storage_Trigger_Error_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Storage_Trigger_Error_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Storage_Trigger_Error_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Storage_Trigger_Error_Log_Var_Pop_Fields = {
  __typename?: 'storage_trigger_error_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Storage_Trigger_Error_Log_Var_Samp_Fields = {
  __typename?: 'storage_trigger_error_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Storage_Trigger_Error_Log_Variance_Fields = {
  __typename?: 'storage_trigger_error_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "storico_sottoscrizione" */
export type Storico_Sottoscrizione = {
  __typename?: 'storico_sottoscrizione';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  feedback?: Maybe<Energy_Village_Feedback>;
  feedback_altro?: Maybe<Scalars['String']['output']>;
  feedback_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  sottoscrizione: Sottoscrizione;
  sottoscrizione_id: Scalars['uuid']['output'];
  stato: Energy_Village__Stato_Sottoscrizione_Enum;
};

/** aggregated selection of "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Aggregate = {
  __typename?: 'storico_sottoscrizione_aggregate';
  aggregate?: Maybe<Storico_Sottoscrizione_Aggregate_Fields>;
  nodes: Array<Storico_Sottoscrizione>;
};

export type Storico_Sottoscrizione_Aggregate_Bool_Exp = {
  count?: InputMaybe<Storico_Sottoscrizione_Aggregate_Bool_Exp_Count>;
};

export type Storico_Sottoscrizione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Aggregate_Fields = {
  __typename?: 'storico_sottoscrizione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Storico_Sottoscrizione_Max_Fields>;
  min?: Maybe<Storico_Sottoscrizione_Min_Fields>;
};


/** aggregate fields of "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Storico_Sottoscrizione_Max_Order_By>;
  min?: InputMaybe<Storico_Sottoscrizione_Min_Order_By>;
};

/** input type for inserting array relation for remote table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Arr_Rel_Insert_Input = {
  data: Array<Storico_Sottoscrizione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Storico_Sottoscrizione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "storico_sottoscrizione". All fields are combined with a logical 'AND'. */
export type Storico_Sottoscrizione_Bool_Exp = {
  _and?: InputMaybe<Array<Storico_Sottoscrizione_Bool_Exp>>;
  _not?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
  _or?: InputMaybe<Array<Storico_Sottoscrizione_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
  feedback_altro?: InputMaybe<String_Comparison_Exp>;
  feedback_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Bool_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "storico_sottoscrizione" */
export enum Storico_Sottoscrizione_Constraint {
  /** unique or primary key constraint on columns "id" */
  StoricoSottoscrizionePkey = 'storico_sottoscrizione_pkey'
}

/** input type for inserting data into table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback?: InputMaybe<Energy_Village_Feedback_Obj_Rel_Insert_Input>;
  feedback_altro?: InputMaybe<Scalars['String']['input']>;
  feedback_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Obj_Rel_Insert_Input>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Enum>;
};

/** aggregate max on columns */
export type Storico_Sottoscrizione_Max_Fields = {
  __typename?: 'storico_sottoscrizione_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback_altro?: Maybe<Scalars['String']['output']>;
  feedback_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feedback_altro?: InputMaybe<Order_By>;
  feedback_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Storico_Sottoscrizione_Min_Fields = {
  __typename?: 'storico_sottoscrizione_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  feedback_altro?: Maybe<Scalars['String']['output']>;
  feedback_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feedback_altro?: InputMaybe<Order_By>;
  feedback_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Mutation_Response = {
  __typename?: 'storico_sottoscrizione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Storico_Sottoscrizione>;
};

/** on_conflict condition type for table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_On_Conflict = {
  constraint: Storico_Sottoscrizione_Constraint;
  update_columns?: Array<Storico_Sottoscrizione_Update_Column>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};

/** Ordering options when selecting data from "storico_sottoscrizione". */
export type Storico_Sottoscrizione_Order_By = {
  created_at?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Energy_Village_Feedback_Order_By>;
  feedback_altro?: InputMaybe<Order_By>;
  feedback_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sottoscrizione?: InputMaybe<Sottoscrizione_Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storico_sottoscrizione */
export type Storico_Sottoscrizione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "storico_sottoscrizione" */
export enum Storico_Sottoscrizione_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeedbackAltro = 'feedback_altro',
  /** column name */
  FeedbackId = 'feedback_id',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato'
}

/** input type for updating data in table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback_altro?: InputMaybe<Scalars['String']['input']>;
  feedback_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Enum>;
};

/** Streaming cursor of the table "storico_sottoscrizione" */
export type Storico_Sottoscrizione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storico_Sottoscrizione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storico_Sottoscrizione_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  feedback_altro?: InputMaybe<Scalars['String']['input']>;
  feedback_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Enum>;
};

/** update columns of table "storico_sottoscrizione" */
export enum Storico_Sottoscrizione_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FeedbackAltro = 'feedback_altro',
  /** column name */
  FeedbackId = 'feedback_id',
  /** column name */
  Id = 'id',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato'
}

export type Storico_Sottoscrizione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Storico_Sottoscrizione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Storico_Sottoscrizione_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "_destinazione_compatibile" */
  _destinazione_compatibile: Array<_Destinazione_Compatibile>;
  /** fetch aggregated fields from the table: "_destinazione_compatibile" */
  _destinazione_compatibile_aggregate: _Destinazione_Compatibile_Aggregate;
  /** fetch data from the table in a streaming manner: "_destinazione_compatibile" */
  _destinazione_compatibile_stream: Array<_Destinazione_Compatibile>;
  /** fetch data from the table: "_pod_duplicato" */
  _pod_duplicato: Array<_Pod_Duplicato>;
  /** fetch aggregated fields from the table: "_pod_duplicato" */
  _pod_duplicato_aggregate: _Pod_Duplicato_Aggregate;
  /** fetch data from the table: "_pod_duplicato" using primary key columns */
  _pod_duplicato_by_pk?: Maybe<_Pod_Duplicato>;
  /** fetch data from the table in a streaming manner: "_pod_duplicato" */
  _pod_duplicato_stream: Array<_Pod_Duplicato>;
  /** fetch data from the table: "_sottoscrizione_tipo_richiesta" */
  _sottoscrizione_tipo_richiesta: Array<_Sottoscrizione_Tipo_Richiesta>;
  /** fetch aggregated fields from the table: "_sottoscrizione_tipo_richiesta" */
  _sottoscrizione_tipo_richiesta_aggregate: _Sottoscrizione_Tipo_Richiesta_Aggregate;
  /** fetch data from the table: "_sottoscrizione_tipo_richiesta" using primary key columns */
  _sottoscrizione_tipo_richiesta_by_pk?: Maybe<_Sottoscrizione_Tipo_Richiesta>;
  /** fetch data from the table in a streaming manner: "_sottoscrizione_tipo_richiesta" */
  _sottoscrizione_tipo_richiesta_stream: Array<_Sottoscrizione_Tipo_Richiesta>;
  /** fetch data from the table: "_superadmin_elimina_sottoscrizione_esito" */
  _superadmin_elimina_sottoscrizione_esito: Array<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** fetch aggregated fields from the table: "_superadmin_elimina_sottoscrizione_esito" */
  _superadmin_elimina_sottoscrizione_esito_aggregate: _Superadmin_Elimina_Sottoscrizione_Esito_Aggregate;
  /** fetch data from the table: "_superadmin_elimina_sottoscrizione_esito" using primary key columns */
  _superadmin_elimina_sottoscrizione_esito_by_pk?: Maybe<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** fetch data from the table in a streaming manner: "_superadmin_elimina_sottoscrizione_esito" */
  _superadmin_elimina_sottoscrizione_esito_stream: Array<_Superadmin_Elimina_Sottoscrizione_Esito>;
  /** fetch data from the table: "_tipo_dato_consumo" */
  _tipo_dato_consumo: Array<_Tipo_Dato_Consumo>;
  /** fetch aggregated fields from the table: "_tipo_dato_consumo" */
  _tipo_dato_consumo_aggregate: _Tipo_Dato_Consumo_Aggregate;
  /** fetch data from the table: "_tipo_dato_consumo" using primary key columns */
  _tipo_dato_consumo_by_pk?: Maybe<_Tipo_Dato_Consumo>;
  /** fetch data from the table in a streaming manner: "_tipo_dato_consumo" */
  _tipo_dato_consumo_stream: Array<_Tipo_Dato_Consumo>;
  /** fetch data from the table: "_tipologia_profilo" */
  _tipologia_profilo: Array<_Tipologia_Profilo>;
  /** fetch aggregated fields from the table: "_tipologia_profilo" */
  _tipologia_profilo_aggregate: _Tipologia_Profilo_Aggregate;
  /** fetch data from the table: "_tipologia_profilo" using primary key columns */
  _tipologia_profilo_by_pk?: Maybe<_Tipologia_Profilo>;
  /** fetch data from the table in a streaming manner: "_tipologia_profilo" */
  _tipologia_profilo_stream: Array<_Tipologia_Profilo>;
  /** fetch data from the table: "admin._stato_richiesta_pubblicazione" */
  admin__stato_richiesta_pubblicazione: Array<Admin__Stato_Richiesta_Pubblicazione>;
  /** fetch aggregated fields from the table: "admin._stato_richiesta_pubblicazione" */
  admin__stato_richiesta_pubblicazione_aggregate: Admin__Stato_Richiesta_Pubblicazione_Aggregate;
  /** fetch data from the table: "admin._stato_richiesta_pubblicazione" using primary key columns */
  admin__stato_richiesta_pubblicazione_by_pk?: Maybe<Admin__Stato_Richiesta_Pubblicazione>;
  /** fetch data from the table in a streaming manner: "admin._stato_richiesta_pubblicazione" */
  admin__stato_richiesta_pubblicazione_stream: Array<Admin__Stato_Richiesta_Pubblicazione>;
  /** fetch data from the table: "admin._type_referral" */
  admin__type_referral: Array<Admin__Type_Referral>;
  /** fetch aggregated fields from the table: "admin._type_referral" */
  admin__type_referral_aggregate: Admin__Type_Referral_Aggregate;
  /** fetch data from the table: "admin._type_referral" using primary key columns */
  admin__type_referral_by_pk?: Maybe<Admin__Type_Referral>;
  /** fetch data from the table in a streaming manner: "admin._type_referral" */
  admin__type_referral_stream: Array<Admin__Type_Referral>;
  /** fetch data from the table: "admin.consenso_privacy" */
  admin_consenso_privacy: Array<Admin_Consenso_Privacy>;
  /** fetch aggregated fields from the table: "admin.consenso_privacy" */
  admin_consenso_privacy_aggregate: Admin_Consenso_Privacy_Aggregate;
  /** fetch data from the table: "admin.consenso_privacy" using primary key columns */
  admin_consenso_privacy_by_pk?: Maybe<Admin_Consenso_Privacy>;
  /** fetch data from the table in a streaming manner: "admin.consenso_privacy" */
  admin_consenso_privacy_stream: Array<Admin_Consenso_Privacy>;
  /** fetch data from the table: "admin.parametri_algoritmo_incentivi" */
  admin_parametri_algoritmo_incentivi: Array<Admin_Parametri_Algoritmo_Incentivi>;
  /** fetch aggregated fields from the table: "admin.parametri_algoritmo_incentivi" */
  admin_parametri_algoritmo_incentivi_aggregate: Admin_Parametri_Algoritmo_Incentivi_Aggregate;
  /** fetch data from the table: "admin.parametri_algoritmo_incentivi" using primary key columns */
  admin_parametri_algoritmo_incentivi_by_pk?: Maybe<Admin_Parametri_Algoritmo_Incentivi>;
  /** fetch data from the table in a streaming manner: "admin.parametri_algoritmo_incentivi" */
  admin_parametri_algoritmo_incentivi_stream: Array<Admin_Parametri_Algoritmo_Incentivi>;
  /** fetch data from the table: "admin.referral" */
  admin_referral: Array<Admin_Referral>;
  /** fetch aggregated fields from the table: "admin.referral" */
  admin_referral_aggregate: Admin_Referral_Aggregate;
  /** fetch data from the table: "admin.referral" using primary key columns */
  admin_referral_by_pk?: Maybe<Admin_Referral>;
  /** fetch data from the table in a streaming manner: "admin.referral" */
  admin_referral_stream: Array<Admin_Referral>;
  /** fetch data from the table: "admin.richiesta_pubblicazione" */
  admin_richiesta_pubblicazione: Array<Admin_Richiesta_Pubblicazione>;
  /** fetch aggregated fields from the table: "admin.richiesta_pubblicazione" */
  admin_richiesta_pubblicazione_aggregate: Admin_Richiesta_Pubblicazione_Aggregate;
  /** fetch data from the table: "admin.richiesta_pubblicazione" using primary key columns */
  admin_richiesta_pubblicazione_by_pk?: Maybe<Admin_Richiesta_Pubblicazione>;
  /** fetch data from the table in a streaming manner: "admin.richiesta_pubblicazione" */
  admin_richiesta_pubblicazione_stream: Array<Admin_Richiesta_Pubblicazione>;
  /** fetch data from the table: "admin.utilizzo_referral" */
  admin_utilizzo_referral: Array<Admin_Utilizzo_Referral>;
  /** fetch aggregated fields from the table: "admin.utilizzo_referral" */
  admin_utilizzo_referral_aggregate: Admin_Utilizzo_Referral_Aggregate;
  /** fetch data from the table: "admin.utilizzo_referral" using primary key columns */
  admin_utilizzo_referral_by_pk?: Maybe<Admin_Utilizzo_Referral>;
  /** fetch data from the table in a streaming manner: "admin.utilizzo_referral" */
  admin_utilizzo_referral_stream: Array<Admin_Utilizzo_Referral>;
  /** fetch data from the table: "anagrafica.codice_ateco" */
  anagrafica_codice_ateco: Array<Anagrafica_Codice_Ateco>;
  /** fetch aggregated fields from the table: "anagrafica.codice_ateco" */
  anagrafica_codice_ateco_aggregate: Anagrafica_Codice_Ateco_Aggregate;
  /** fetch data from the table: "anagrafica.codice_ateco" using primary key columns */
  anagrafica_codice_ateco_by_pk?: Maybe<Anagrafica_Codice_Ateco>;
  /** fetch data from the table in a streaming manner: "anagrafica.codice_ateco" */
  anagrafica_codice_ateco_stream: Array<Anagrafica_Codice_Ateco>;
  /** fetch data from the table: "anagrafica.forma_giuridica" */
  anagrafica_forma_giuridica: Array<Anagrafica_Forma_Giuridica>;
  /** fetch aggregated fields from the table: "anagrafica.forma_giuridica" */
  anagrafica_forma_giuridica_aggregate: Anagrafica_Forma_Giuridica_Aggregate;
  /** fetch data from the table: "anagrafica.forma_giuridica" using primary key columns */
  anagrafica_forma_giuridica_by_pk?: Maybe<Anagrafica_Forma_Giuridica>;
  /** fetch data from the table: "anagrafica.forma_giuridica_cer" */
  anagrafica_forma_giuridica_cer: Array<Anagrafica_Forma_Giuridica_Cer>;
  /** fetch aggregated fields from the table: "anagrafica.forma_giuridica_cer" */
  anagrafica_forma_giuridica_cer_aggregate: Anagrafica_Forma_Giuridica_Cer_Aggregate;
  /** fetch data from the table: "anagrafica.forma_giuridica_cer" using primary key columns */
  anagrafica_forma_giuridica_cer_by_pk?: Maybe<Anagrafica_Forma_Giuridica_Cer>;
  /** fetch data from the table in a streaming manner: "anagrafica.forma_giuridica_cer" */
  anagrafica_forma_giuridica_cer_stream: Array<Anagrafica_Forma_Giuridica_Cer>;
  /** fetch data from the table in a streaming manner: "anagrafica.forma_giuridica" */
  anagrafica_forma_giuridica_stream: Array<Anagrafica_Forma_Giuridica>;
  /** fetch data from the table: "anagrafica.tipo_contatto" */
  anagrafica_tipo_contatto: Array<Anagrafica_Tipo_Contatto>;
  /** fetch aggregated fields from the table: "anagrafica.tipo_contatto" */
  anagrafica_tipo_contatto_aggregate: Anagrafica_Tipo_Contatto_Aggregate;
  /** fetch data from the table: "anagrafica.tipo_contatto" using primary key columns */
  anagrafica_tipo_contatto_by_pk?: Maybe<Anagrafica_Tipo_Contatto>;
  /** fetch data from the table in a streaming manner: "anagrafica.tipo_contatto" */
  anagrafica_tipo_contatto_stream: Array<Anagrafica_Tipo_Contatto>;
  /** fetch data from the table: "anagrafica.tipo_promotore" */
  anagrafica_tipo_promotore: Array<Anagrafica_Tipo_Promotore>;
  /** fetch aggregated fields from the table: "anagrafica.tipo_promotore" */
  anagrafica_tipo_promotore_aggregate: Anagrafica_Tipo_Promotore_Aggregate;
  /** fetch data from the table: "anagrafica.tipo_promotore" using primary key columns */
  anagrafica_tipo_promotore_by_pk?: Maybe<Anagrafica_Tipo_Promotore>;
  /** fetch data from the table in a streaming manner: "anagrafica.tipo_promotore" */
  anagrafica_tipo_promotore_stream: Array<Anagrafica_Tipo_Promotore>;
  /** fetch data from the table: "anagrafica.tipologia_rappresentante" */
  anagrafica_tipologia_rappresentante: Array<Anagrafica_Tipologia_Rappresentante>;
  /** fetch aggregated fields from the table: "anagrafica.tipologia_rappresentante" */
  anagrafica_tipologia_rappresentante_aggregate: Anagrafica_Tipologia_Rappresentante_Aggregate;
  /** fetch data from the table: "anagrafica.tipologia_rappresentante" using primary key columns */
  anagrafica_tipologia_rappresentante_by_pk?: Maybe<Anagrafica_Tipologia_Rappresentante>;
  /** fetch data from the table in a streaming manner: "anagrafica.tipologia_rappresentante" */
  anagrafica_tipologia_rappresentante_stream: Array<Anagrafica_Tipologia_Rappresentante>;
  /** fetch data from the table: "asset" */
  asset: Array<Asset>;
  /** fetch aggregated fields from the table: "asset" */
  asset_aggregate: Asset_Aggregate;
  /** fetch data from the table: "asset" using primary key columns */
  asset_by_pk?: Maybe<Asset>;
  /** fetch data from the table: "asset_caratteristica" */
  asset_caratteristica: Array<Asset_Caratteristica>;
  /** fetch aggregated fields from the table: "asset_caratteristica" */
  asset_caratteristica_aggregate: Asset_Caratteristica_Aggregate;
  /** fetch data from the table: "asset_caratteristica" using primary key columns */
  asset_caratteristica_by_pk?: Maybe<Asset_Caratteristica>;
  /** fetch data from the table in a streaming manner: "asset_caratteristica" */
  asset_caratteristica_stream: Array<Asset_Caratteristica>;
  /** fetch data from the table: "asset_consumo" */
  asset_consumo: Array<Asset_Consumo>;
  /** fetch aggregated fields from the table: "asset_consumo" */
  asset_consumo_aggregate: Asset_Consumo_Aggregate;
  /** fetch data from the table: "asset_consumo" using primary key columns */
  asset_consumo_by_pk?: Maybe<Asset_Consumo>;
  /** fetch data from the table in a streaming manner: "asset_consumo" */
  asset_consumo_stream: Array<Asset_Consumo>;
  /** fetch data from the table: "asset_dato_consumo" */
  asset_dato_consumo: Array<Asset_Dato_Consumo>;
  /** fetch aggregated fields from the table: "asset_dato_consumo" */
  asset_dato_consumo_aggregate: Asset_Dato_Consumo_Aggregate;
  /** fetch data from the table: "asset_dato_consumo" using primary key columns */
  asset_dato_consumo_by_pk?: Maybe<Asset_Dato_Consumo>;
  /** fetch data from the table in a streaming manner: "asset_dato_consumo" */
  asset_dato_consumo_stream: Array<Asset_Dato_Consumo>;
  /** fetch data from the table: "asset_energia" */
  asset_energia: Array<Asset_Energia>;
  /** fetch aggregated fields from the table: "asset_energia" */
  asset_energia_aggregate: Asset_Energia_Aggregate;
  /** fetch data from the table: "asset_energia" using primary key columns */
  asset_energia_by_pk?: Maybe<Asset_Energia>;
  /** fetch data from the table in a streaming manner: "asset_energia" */
  asset_energia_stream: Array<Asset_Energia>;
  /** fetch data from the table: "asset_founder" */
  asset_founder: Array<Asset_Founder>;
  /** fetch aggregated fields from the table: "asset_founder" */
  asset_founder_aggregate: Asset_Founder_Aggregate;
  /** fetch data from the table: "asset_founder" using primary key columns */
  asset_founder_by_pk?: Maybe<Asset_Founder>;
  /** fetch data from the table in a streaming manner: "asset_founder" */
  asset_founder_stream: Array<Asset_Founder>;
  /** fetch data from the table: "asset_gestore" */
  asset_gestore: Array<Asset_Gestore>;
  /** fetch aggregated fields from the table: "asset_gestore" */
  asset_gestore_aggregate: Asset_Gestore_Aggregate;
  /** fetch data from the table: "asset_gestore" using primary key columns */
  asset_gestore_by_pk?: Maybe<Asset_Gestore>;
  /** fetch data from the table in a streaming manner: "asset_gestore" */
  asset_gestore_stream: Array<Asset_Gestore>;
  /** An array relationship */
  asset_produzione: Array<Asset_Produzione>;
  /** An aggregate relationship */
  asset_produzione_aggregate: Asset_Produzione_Aggregate;
  /** fetch data from the table: "asset_produzione" using primary key columns */
  asset_produzione_by_pk?: Maybe<Asset_Produzione>;
  /** fetch data from the table in a streaming manner: "asset_produzione" */
  asset_produzione_stream: Array<Asset_Produzione>;
  /** fetch data from the table: "asset_produzione_unita" */
  asset_produzione_unita: Array<Asset_Produzione_Unita>;
  /** fetch aggregated fields from the table: "asset_produzione_unita" */
  asset_produzione_unita_aggregate: Asset_Produzione_Unita_Aggregate;
  /** fetch data from the table: "asset_produzione_unita" using primary key columns */
  asset_produzione_unita_by_pk?: Maybe<Asset_Produzione_Unita>;
  /** fetch data from the table: "asset_produzione_unita_sezione" */
  asset_produzione_unita_sezione: Array<Asset_Produzione_Unita_Sezione>;
  /** fetch aggregated fields from the table: "asset_produzione_unita_sezione" */
  asset_produzione_unita_sezione_aggregate: Asset_Produzione_Unita_Sezione_Aggregate;
  /** fetch data from the table: "asset_produzione_unita_sezione" using primary key columns */
  asset_produzione_unita_sezione_by_pk?: Maybe<Asset_Produzione_Unita_Sezione>;
  /** fetch data from the table: "asset_produzione_unita_sezione_incentivi" */
  asset_produzione_unita_sezione_incentivi: Array<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** fetch aggregated fields from the table: "asset_produzione_unita_sezione_incentivi" */
  asset_produzione_unita_sezione_incentivi_aggregate: Asset_Produzione_Unita_Sezione_Incentivi_Aggregate;
  /** fetch data from the table: "asset_produzione_unita_sezione_incentivi" using primary key columns */
  asset_produzione_unita_sezione_incentivi_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** fetch data from the table in a streaming manner: "asset_produzione_unita_sezione_incentivi" */
  asset_produzione_unita_sezione_incentivi_stream: Array<Asset_Produzione_Unita_Sezione_Incentivi>;
  /** fetch data from the table in a streaming manner: "asset_produzione_unita_sezione" */
  asset_produzione_unita_sezione_stream: Array<Asset_Produzione_Unita_Sezione>;
  /** fetch data from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  asset_produzione_unita_sezione_titolo_autorizzativo: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** fetch aggregated fields from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  asset_produzione_unita_sezione_titolo_autorizzativo_aggregate: Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Aggregate;
  /** fetch data from the table: "asset_produzione_unita_sezione_titolo_autorizzativo" using primary key columns */
  asset_produzione_unita_sezione_titolo_autorizzativo_by_pk?: Maybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** fetch data from the table in a streaming manner: "asset_produzione_unita_sezione_titolo_autorizzativo" */
  asset_produzione_unita_sezione_titolo_autorizzativo_stream: Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo>;
  /** fetch data from the table in a streaming manner: "asset_produzione_unita" */
  asset_produzione_unita_stream: Array<Asset_Produzione_Unita>;
  /** fetch data from the table: "asset_spazio" */
  asset_spazio: Array<Asset_Spazio>;
  /** fetch aggregated fields from the table: "asset_spazio" */
  asset_spazio_aggregate: Asset_Spazio_Aggregate;
  /** fetch data from the table: "asset_spazio" using primary key columns */
  asset_spazio_by_pk?: Maybe<Asset_Spazio>;
  /** fetch data from the table in a streaming manner: "asset_spazio" */
  asset_spazio_stream: Array<Asset_Spazio>;
  /** fetch data from the table in a streaming manner: "asset" */
  asset_stream: Array<Asset>;
  /** fetch data from the table: "auth.event_entity" */
  auth_event_entity: Array<Auth_Event_Entity>;
  /** fetch aggregated fields from the table: "auth.event_entity" */
  auth_event_entity_aggregate: Auth_Event_Entity_Aggregate;
  /** fetch data from the table: "auth.event_entity" using primary key columns */
  auth_event_entity_by_pk?: Maybe<Auth_Event_Entity>;
  /** fetch data from the table in a streaming manner: "auth.event_entity" */
  auth_event_entity_stream: Array<Auth_Event_Entity>;
  /** fetch data from the table: "auth.federated_identity" */
  auth_federated_identity: Array<Auth_Federated_Identity>;
  /** fetch aggregated fields from the table: "auth.federated_identity" */
  auth_federated_identity_aggregate: Auth_Federated_Identity_Aggregate;
  /** fetch data from the table: "auth.federated_identity" using primary key columns */
  auth_federated_identity_by_pk?: Maybe<Auth_Federated_Identity>;
  /** fetch data from the table in a streaming manner: "auth.federated_identity" */
  auth_federated_identity_stream: Array<Auth_Federated_Identity>;
  /** fetch data from the table: "auth.role_attribute" */
  auth_role_attribute: Array<Auth_Role_Attribute>;
  /** fetch aggregated fields from the table: "auth.role_attribute" */
  auth_role_attribute_aggregate: Auth_Role_Attribute_Aggregate;
  /** fetch data from the table: "auth.role_attribute" using primary key columns */
  auth_role_attribute_by_pk?: Maybe<Auth_Role_Attribute>;
  /** fetch data from the table in a streaming manner: "auth.role_attribute" */
  auth_role_attribute_stream: Array<Auth_Role_Attribute>;
  /** fetch data from the table: "auth.user_attribute" */
  auth_user_attribute: Array<Auth_User_Attribute>;
  /** fetch aggregated fields from the table: "auth.user_attribute" */
  auth_user_attribute_aggregate: Auth_User_Attribute_Aggregate;
  /** fetch data from the table: "auth.user_attribute" using primary key columns */
  auth_user_attribute_by_pk?: Maybe<Auth_User_Attribute>;
  /** fetch data from the table in a streaming manner: "auth.user_attribute" */
  auth_user_attribute_stream: Array<Auth_User_Attribute>;
  /** fetch data from the table: "auth.user_entity" */
  auth_user_entity: Array<Auth_User_Entity>;
  /** fetch aggregated fields from the table: "auth.user_entity" */
  auth_user_entity_aggregate: Auth_User_Entity_Aggregate;
  /** fetch data from the table: "auth.user_entity" using primary key columns */
  auth_user_entity_by_pk?: Maybe<Auth_User_Entity>;
  /** fetch data from the table in a streaming manner: "auth.user_entity" */
  auth_user_entity_stream: Array<Auth_User_Entity>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "cer" */
  cer: Array<Cer>;
  /** fetch aggregated fields from the table: "cer" */
  cer_aggregate: Cer_Aggregate;
  /** fetch data from the table: "cer" using primary key columns */
  cer_by_pk?: Maybe<Cer>;
  /** An array relationship */
  cer_cabina: Array<Cer_Cabina>;
  /** An aggregate relationship */
  cer_cabina_aggregate: Cer_Cabina_Aggregate;
  /** fetch data from the table: "cer_cabina" using primary key columns */
  cer_cabina_by_pk?: Maybe<Cer_Cabina>;
  /** fetch data from the table: "cer_cabina_snapshot" */
  cer_cabina_snapshot: Array<Cer_Cabina_Snapshot>;
  /** fetch aggregated fields from the table: "cer_cabina_snapshot" */
  cer_cabina_snapshot_aggregate: Cer_Cabina_Snapshot_Aggregate;
  /** fetch data from the table: "cer_cabina_snapshot" using primary key columns */
  cer_cabina_snapshot_by_pk?: Maybe<Cer_Cabina_Snapshot>;
  /** fetch data from the table in a streaming manner: "cer_cabina_snapshot" */
  cer_cabina_snapshot_stream: Array<Cer_Cabina_Snapshot>;
  /** fetch data from the table in a streaming manner: "cer_cabina" */
  cer_cabina_stream: Array<Cer_Cabina>;
  /** fetch data from the table: "cer_categoria_adesione" */
  cer_categoria_adesione: Array<Cer_Categoria_Adesione>;
  /** fetch aggregated fields from the table: "cer_categoria_adesione" */
  cer_categoria_adesione_aggregate: Cer_Categoria_Adesione_Aggregate;
  /** fetch data from the table: "cer_categoria_adesione" using primary key columns */
  cer_categoria_adesione_by_pk?: Maybe<Cer_Categoria_Adesione>;
  /** fetch data from the table in a streaming manner: "cer_categoria_adesione" */
  cer_categoria_adesione_stream: Array<Cer_Categoria_Adesione>;
  /** fetch data from the table: "cer_configurazione_destinazione_contributo" */
  cer_configurazione_destinazione_contributo: Array<Cer_Configurazione_Destinazione_Contributo>;
  /** fetch aggregated fields from the table: "cer_configurazione_destinazione_contributo" */
  cer_configurazione_destinazione_contributo_aggregate: Cer_Configurazione_Destinazione_Contributo_Aggregate;
  /** fetch data from the table: "cer_configurazione_destinazione_contributo" using primary key columns */
  cer_configurazione_destinazione_contributo_by_pk?: Maybe<Cer_Configurazione_Destinazione_Contributo>;
  /** fetch data from the table in a streaming manner: "cer_configurazione_destinazione_contributo" */
  cer_configurazione_destinazione_contributo_stream: Array<Cer_Configurazione_Destinazione_Contributo>;
  /** An array relationship */
  cer_contatti: Array<Cer_Contatti>;
  /** An aggregate relationship */
  cer_contatti_aggregate: Cer_Contatti_Aggregate;
  /** fetch data from the table: "cer_contatti" using primary key columns */
  cer_contatti_by_pk?: Maybe<Cer_Contatti>;
  /** fetch data from the table in a streaming manner: "cer_contatti" */
  cer_contatti_stream: Array<Cer_Contatti>;
  /** fetch data from the table: "cer_destinazione_contributo" */
  cer_destinazione_contributo: Array<Cer_Destinazione_Contributo>;
  /** fetch aggregated fields from the table: "cer_destinazione_contributo" */
  cer_destinazione_contributo_aggregate: Cer_Destinazione_Contributo_Aggregate;
  /** fetch data from the table: "cer_destinazione_contributo" using primary key columns */
  cer_destinazione_contributo_by_pk?: Maybe<Cer_Destinazione_Contributo>;
  /** fetch data from the table in a streaming manner: "cer_destinazione_contributo" */
  cer_destinazione_contributo_stream: Array<Cer_Destinazione_Contributo>;
  /** fetch data from the table: "cer_geom" */
  cer_geom: Array<Cer_Geom>;
  /** fetch aggregated fields from the table: "cer_geom" */
  cer_geom_aggregate: Cer_Geom_Aggregate;
  /** fetch data from the table: "cer_geom" using primary key columns */
  cer_geom_by_pk?: Maybe<Cer_Geom>;
  /** fetch data from the table in a streaming manner: "cer_geom" */
  cer_geom_stream: Array<Cer_Geom>;
  /** fetch data from the table: "cer_gestore" */
  cer_gestore: Array<Cer_Gestore>;
  /** fetch aggregated fields from the table: "cer_gestore" */
  cer_gestore_aggregate: Cer_Gestore_Aggregate;
  /** fetch data from the table: "cer_gestore" using primary key columns */
  cer_gestore_by_pk?: Maybe<Cer_Gestore>;
  /** fetch data from the table in a streaming manner: "cer_gestore" */
  cer_gestore_stream: Array<Cer_Gestore>;
  /** fetch data from the table: "cer_search_index" */
  cer_search_index: Array<Cer_Search_Index>;
  /** fetch aggregated fields from the table: "cer_search_index" */
  cer_search_index_aggregate: Cer_Search_Index_Aggregate;
  /** fetch data from the table: "cer_search_index" using primary key columns */
  cer_search_index_by_pk?: Maybe<Cer_Search_Index>;
  /** fetch data from the table in a streaming manner: "cer_search_index" */
  cer_search_index_stream: Array<Cer_Search_Index>;
  /** fetch data from the table in a streaming manner: "cer" */
  cer_stream: Array<Cer>;
  /** fetch data from the table: "cer_tecnico" */
  cer_tecnico: Array<Cer_Tecnico>;
  /** fetch aggregated fields from the table: "cer_tecnico" */
  cer_tecnico_aggregate: Cer_Tecnico_Aggregate;
  /** fetch data from the table: "cer_tecnico" using primary key columns */
  cer_tecnico_by_pk?: Maybe<Cer_Tecnico>;
  /** fetch data from the table in a streaming manner: "cer_tecnico" */
  cer_tecnico_stream: Array<Cer_Tecnico>;
  /** execute function "check_pod_duplicato" which returns "_pod_duplicato" */
  check_pod_duplicato: Array<_Pod_Duplicato>;
  /** execute function "check_pod_duplicato" and query aggregates on result of table type "_pod_duplicato" */
  check_pod_duplicato_aggregate: _Pod_Duplicato_Aggregate;
  /** fetch data from the table: "codice_operatore" */
  codice_operatore: Array<Codice_Operatore>;
  /** fetch aggregated fields from the table: "codice_operatore" */
  codice_operatore_aggregate: Codice_Operatore_Aggregate;
  /** fetch data from the table: "codice_operatore" using primary key columns */
  codice_operatore_by_pk?: Maybe<Codice_Operatore>;
  /** fetch data from the table in a streaming manner: "codice_operatore" */
  codice_operatore_stream: Array<Codice_Operatore>;
  /** fetch data from the table: "comunicazioni.email" */
  comunicazioni_email: Array<Comunicazioni_Email>;
  /** fetch aggregated fields from the table: "comunicazioni.email" */
  comunicazioni_email_aggregate: Comunicazioni_Email_Aggregate;
  /** fetch data from the table: "comunicazioni.email" using primary key columns */
  comunicazioni_email_by_pk?: Maybe<Comunicazioni_Email>;
  /** fetch data from the table in a streaming manner: "comunicazioni.email" */
  comunicazioni_email_stream: Array<Comunicazioni_Email>;
  /** fetch data from the table: "comunicazioni.email_template" */
  comunicazioni_email_template: Array<Comunicazioni_Email_Template>;
  /** fetch aggregated fields from the table: "comunicazioni.email_template" */
  comunicazioni_email_template_aggregate: Comunicazioni_Email_Template_Aggregate;
  /** fetch data from the table: "comunicazioni.email_template" using primary key columns */
  comunicazioni_email_template_by_pk?: Maybe<Comunicazioni_Email_Template>;
  /** fetch data from the table in a streaming manner: "comunicazioni.email_template" */
  comunicazioni_email_template_stream: Array<Comunicazioni_Email_Template>;
  /** fetch data from the table: "comunicazioni.sms" */
  comunicazioni_sms: Array<Comunicazioni_Sms>;
  /** fetch aggregated fields from the table: "comunicazioni.sms" */
  comunicazioni_sms_aggregate: Comunicazioni_Sms_Aggregate;
  /** fetch data from the table: "comunicazioni.sms" using primary key columns */
  comunicazioni_sms_by_pk?: Maybe<Comunicazioni_Sms>;
  /** fetch data from the table in a streaming manner: "comunicazioni.sms" */
  comunicazioni_sms_stream: Array<Comunicazioni_Sms>;
  /** fetch data from the table: "condivisione._stato_condivisione" */
  condivisione__stato_condivisione: Array<Condivisione__Stato_Condivisione>;
  /** fetch aggregated fields from the table: "condivisione._stato_condivisione" */
  condivisione__stato_condivisione_aggregate: Condivisione__Stato_Condivisione_Aggregate;
  /** fetch data from the table: "condivisione._stato_condivisione" using primary key columns */
  condivisione__stato_condivisione_by_pk?: Maybe<Condivisione__Stato_Condivisione>;
  /** fetch data from the table in a streaming manner: "condivisione._stato_condivisione" */
  condivisione__stato_condivisione_stream: Array<Condivisione__Stato_Condivisione>;
  /** fetch data from the table: "condivisione.accetta_response" */
  condivisione_accetta_response: Array<Condivisione_Accetta_Response>;
  /** fetch aggregated fields from the table: "condivisione.accetta_response" */
  condivisione_accetta_response_aggregate: Condivisione_Accetta_Response_Aggregate;
  /** fetch data from the table in a streaming manner: "condivisione.accetta_response" */
  condivisione_accetta_response_stream: Array<Condivisione_Accetta_Response>;
  /** fetch data from the table: "condivisione.condivisione" */
  condivisione_condivisione: Array<Condivisione_Condivisione>;
  /** fetch aggregated fields from the table: "condivisione.condivisione" */
  condivisione_condivisione_aggregate: Condivisione_Condivisione_Aggregate;
  /** fetch data from the table: "condivisione.condivisione" using primary key columns */
  condivisione_condivisione_by_pk?: Maybe<Condivisione_Condivisione>;
  /** fetch data from the table in a streaming manner: "condivisione.condivisione" */
  condivisione_condivisione_stream: Array<Condivisione_Condivisione>;
  /** fetch data from the table: "condivisione.log_condivisione" */
  condivisione_log_condivisione: Array<Condivisione_Log_Condivisione>;
  /** fetch aggregated fields from the table: "condivisione.log_condivisione" */
  condivisione_log_condivisione_aggregate: Condivisione_Log_Condivisione_Aggregate;
  /** fetch data from the table: "condivisione.log_condivisione" using primary key columns */
  condivisione_log_condivisione_by_pk?: Maybe<Condivisione_Log_Condivisione>;
  /** fetch data from the table in a streaming manner: "condivisione.log_condivisione" */
  condivisione_log_condivisione_stream: Array<Condivisione_Log_Condivisione>;
  /** fetch data from the table: "contatto" */
  contatto: Array<Contatto>;
  /** fetch aggregated fields from the table: "contatto" */
  contatto_aggregate: Contatto_Aggregate;
  /** fetch data from the table: "contatto" using primary key columns */
  contatto_by_pk?: Maybe<Contatto>;
  /** fetch data from the table in a streaming manner: "contatto" */
  contatto_stream: Array<Contatto>;
  /** fetch data from the table: "crm.audit_event" */
  crm_audit_event: Array<Crm_Audit_Event>;
  /** fetch aggregated fields from the table: "crm.audit_event" */
  crm_audit_event_aggregate: Crm_Audit_Event_Aggregate;
  /** fetch data from the table: "crm.audit_event" using primary key columns */
  crm_audit_event_by_pk?: Maybe<Crm_Audit_Event>;
  /** fetch data from the table in a streaming manner: "crm.audit_event" */
  crm_audit_event_stream: Array<Crm_Audit_Event>;
  /** fetch data from the table: "debug.sottoscrizione_after_log" */
  debug_sottoscrizione_after_log: Array<Debug_Sottoscrizione_After_Log>;
  /** fetch aggregated fields from the table: "debug.sottoscrizione_after_log" */
  debug_sottoscrizione_after_log_aggregate: Debug_Sottoscrizione_After_Log_Aggregate;
  /** fetch data from the table: "debug.sottoscrizione_after_log" using primary key columns */
  debug_sottoscrizione_after_log_by_pk?: Maybe<Debug_Sottoscrizione_After_Log>;
  /** fetch data from the table in a streaming manner: "debug.sottoscrizione_after_log" */
  debug_sottoscrizione_after_log_stream: Array<Debug_Sottoscrizione_After_Log>;
  /** execute function "destinazioni_compatibili" which returns "_destinazione_compatibile" */
  destinazioni_compatibili: Array<_Destinazione_Compatibile>;
  /** execute function "destinazioni_compatibili" and query aggregates on result of table type "_destinazione_compatibile" */
  destinazioni_compatibili_aggregate: _Destinazione_Compatibile_Aggregate;
  /** fetch data from the table: "device.device" */
  device_device: Array<Device_Device>;
  /** fetch aggregated fields from the table: "device.device" */
  device_device_aggregate: Device_Device_Aggregate;
  /** fetch data from the table: "device.device" using primary key columns */
  device_device_by_pk?: Maybe<Device_Device>;
  /** fetch data from the table in a streaming manner: "device.device" */
  device_device_stream: Array<Device_Device>;
  /** fetch data from the table: "energy_village._azioni_founder_sottoscrizione" */
  energy_village__azioni_founder_sottoscrizione: Array<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._azioni_founder_sottoscrizione" */
  energy_village__azioni_founder_sottoscrizione_aggregate: Energy_Village__Azioni_Founder_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._azioni_founder_sottoscrizione" using primary key columns */
  energy_village__azioni_founder_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "energy_village._azioni_founder_sottoscrizione" */
  energy_village__azioni_founder_sottoscrizione_stream: Array<Energy_Village__Azioni_Founder_Sottoscrizione>;
  /** fetch data from the table: "energy_village._azioni_prosumer_sottoscrizione" */
  energy_village__azioni_prosumer_sottoscrizione: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._azioni_prosumer_sottoscrizione" */
  energy_village__azioni_prosumer_sottoscrizione_aggregate: Energy_Village__Azioni_Prosumer_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._azioni_prosumer_sottoscrizione" using primary key columns */
  energy_village__azioni_prosumer_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "energy_village._azioni_prosumer_sottoscrizione" */
  energy_village__azioni_prosumer_sottoscrizione_stream: Array<Energy_Village__Azioni_Prosumer_Sottoscrizione>;
  /** fetch data from the table: "energy_village._azioni_tecnico_sottoscrizione" */
  energy_village__azioni_tecnico_sottoscrizione: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._azioni_tecnico_sottoscrizione" */
  energy_village__azioni_tecnico_sottoscrizione_aggregate: Energy_Village__Azioni_Tecnico_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._azioni_tecnico_sottoscrizione" using primary key columns */
  energy_village__azioni_tecnico_sottoscrizione_by_pk?: Maybe<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "energy_village._azioni_tecnico_sottoscrizione" */
  energy_village__azioni_tecnico_sottoscrizione_stream: Array<Energy_Village__Azioni_Tecnico_Sottoscrizione>;
  /** fetch data from the table: "energy_village._cer_filter_options" */
  energy_village__cer_filter_options: Array<Energy_Village__Cer_Filter_Options>;
  /** fetch aggregated fields from the table: "energy_village._cer_filter_options" */
  energy_village__cer_filter_options_aggregate: Energy_Village__Cer_Filter_Options_Aggregate;
  /** fetch data from the table: "energy_village._cer_filter_options" using primary key columns */
  energy_village__cer_filter_options_by_pk?: Maybe<Energy_Village__Cer_Filter_Options>;
  /** fetch data from the table in a streaming manner: "energy_village._cer_filter_options" */
  energy_village__cer_filter_options_stream: Array<Energy_Village__Cer_Filter_Options>;
  /** fetch data from the table: "energy_village._stato_cer" */
  energy_village__stato_cer: Array<Energy_Village__Stato_Cer>;
  /** fetch aggregated fields from the table: "energy_village._stato_cer" */
  energy_village__stato_cer_aggregate: Energy_Village__Stato_Cer_Aggregate;
  /** fetch data from the table: "energy_village._stato_cer" using primary key columns */
  energy_village__stato_cer_by_pk?: Maybe<Energy_Village__Stato_Cer>;
  /** fetch data from the table in a streaming manner: "energy_village._stato_cer" */
  energy_village__stato_cer_stream: Array<Energy_Village__Stato_Cer>;
  /** fetch data from the table: "energy_village._stato_sottoscrizione" */
  energy_village__stato_sottoscrizione: Array<Energy_Village__Stato_Sottoscrizione>;
  /** fetch aggregated fields from the table: "energy_village._stato_sottoscrizione" */
  energy_village__stato_sottoscrizione_aggregate: Energy_Village__Stato_Sottoscrizione_Aggregate;
  /** fetch data from the table: "energy_village._stato_sottoscrizione" using primary key columns */
  energy_village__stato_sottoscrizione_by_pk?: Maybe<Energy_Village__Stato_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "energy_village._stato_sottoscrizione" */
  energy_village__stato_sottoscrizione_stream: Array<Energy_Village__Stato_Sottoscrizione>;
  /** fetch data from the table: "energy_village._tipo_domanda" */
  energy_village__tipo_domanda: Array<Energy_Village__Tipo_Domanda>;
  /** fetch aggregated fields from the table: "energy_village._tipo_domanda" */
  energy_village__tipo_domanda_aggregate: Energy_Village__Tipo_Domanda_Aggregate;
  /** fetch data from the table: "energy_village._tipo_domanda" using primary key columns */
  energy_village__tipo_domanda_by_pk?: Maybe<Energy_Village__Tipo_Domanda>;
  /** fetch data from the table in a streaming manner: "energy_village._tipo_domanda" */
  energy_village__tipo_domanda_stream: Array<Energy_Village__Tipo_Domanda>;
  /** fetch data from the table: "energy_village._tipo_feedback" */
  energy_village__tipo_feedback: Array<Energy_Village__Tipo_Feedback>;
  /** fetch aggregated fields from the table: "energy_village._tipo_feedback" */
  energy_village__tipo_feedback_aggregate: Energy_Village__Tipo_Feedback_Aggregate;
  /** fetch data from the table: "energy_village._tipo_feedback" using primary key columns */
  energy_village__tipo_feedback_by_pk?: Maybe<Energy_Village__Tipo_Feedback>;
  /** fetch data from the table in a streaming manner: "energy_village._tipo_feedback" */
  energy_village__tipo_feedback_stream: Array<Energy_Village__Tipo_Feedback>;
  /** fetch data from the table: "energy_village.area" */
  energy_village_area: Array<Energy_Village_Area>;
  /** fetch aggregated fields from the table: "energy_village.area" */
  energy_village_area_aggregate: Energy_Village_Area_Aggregate;
  /** fetch data from the table: "energy_village.area" using primary key columns */
  energy_village_area_by_pk?: Maybe<Energy_Village_Area>;
  /** fetch data from the table: "energy_village.area_citta" */
  energy_village_area_citta: Array<Energy_Village_Area_Citta>;
  /** fetch aggregated fields from the table: "energy_village.area_citta" */
  energy_village_area_citta_aggregate: Energy_Village_Area_Citta_Aggregate;
  /** fetch data from the table: "energy_village.area_citta" using primary key columns */
  energy_village_area_citta_by_pk?: Maybe<Energy_Village_Area_Citta>;
  /** fetch data from the table in a streaming manner: "energy_village.area_citta" */
  energy_village_area_citta_stream: Array<Energy_Village_Area_Citta>;
  /** fetch data from the table: "energy_village.area_provincia" */
  energy_village_area_provincia: Array<Energy_Village_Area_Provincia>;
  /** fetch aggregated fields from the table: "energy_village.area_provincia" */
  energy_village_area_provincia_aggregate: Energy_Village_Area_Provincia_Aggregate;
  /** fetch data from the table: "energy_village.area_provincia" using primary key columns */
  energy_village_area_provincia_by_pk?: Maybe<Energy_Village_Area_Provincia>;
  /** fetch data from the table in a streaming manner: "energy_village.area_provincia" */
  energy_village_area_provincia_stream: Array<Energy_Village_Area_Provincia>;
  /** fetch data from the table: "energy_village.area_regione" */
  energy_village_area_regione: Array<Energy_Village_Area_Regione>;
  /** fetch aggregated fields from the table: "energy_village.area_regione" */
  energy_village_area_regione_aggregate: Energy_Village_Area_Regione_Aggregate;
  /** fetch data from the table: "energy_village.area_regione" using primary key columns */
  energy_village_area_regione_by_pk?: Maybe<Energy_Village_Area_Regione>;
  /** fetch data from the table in a streaming manner: "energy_village.area_regione" */
  energy_village_area_regione_stream: Array<Energy_Village_Area_Regione>;
  /** fetch data from the table in a streaming manner: "energy_village.area" */
  energy_village_area_stream: Array<Energy_Village_Area>;
  /** fetch data from the table: "energy_village.azioni" */
  energy_village_azioni: Array<Energy_Village_Azioni>;
  /** fetch aggregated fields from the table: "energy_village.azioni" */
  energy_village_azioni_aggregate: Energy_Village_Azioni_Aggregate;
  /** fetch data from the table: "energy_village.azioni" using primary key columns */
  energy_village_azioni_by_pk?: Maybe<Energy_Village_Azioni>;
  /** fetch data from the table in a streaming manner: "energy_village.azioni" */
  energy_village_azioni_stream: Array<Energy_Village_Azioni>;
  /** fetch data from the table: "energy_village.cabina" */
  energy_village_cabina: Array<Energy_Village_Cabina>;
  /** fetch aggregated fields from the table: "energy_village.cabina" */
  energy_village_cabina_aggregate: Energy_Village_Cabina_Aggregate;
  /** fetch data from the table: "energy_village.cabina" using primary key columns */
  energy_village_cabina_by_pk?: Maybe<Energy_Village_Cabina>;
  /** fetch data from the table: "energy_village.cabina_citta" */
  energy_village_cabina_citta: Array<Energy_Village_Cabina_Citta>;
  /** fetch aggregated fields from the table: "energy_village.cabina_citta" */
  energy_village_cabina_citta_aggregate: Energy_Village_Cabina_Citta_Aggregate;
  /** fetch data from the table: "energy_village.cabina_citta" using primary key columns */
  energy_village_cabina_citta_by_pk?: Maybe<Energy_Village_Cabina_Citta>;
  /** fetch data from the table in a streaming manner: "energy_village.cabina_citta" */
  energy_village_cabina_citta_stream: Array<Energy_Village_Cabina_Citta>;
  /** fetch data from the table in a streaming manner: "energy_village.cabina" */
  energy_village_cabina_stream: Array<Energy_Village_Cabina>;
  /** fetch data from the table: "energy_village.caratteristica" */
  energy_village_caratteristica: Array<Energy_Village_Caratteristica>;
  /** fetch aggregated fields from the table: "energy_village.caratteristica" */
  energy_village_caratteristica_aggregate: Energy_Village_Caratteristica_Aggregate;
  /** fetch data from the table: "energy_village.caratteristica" using primary key columns */
  energy_village_caratteristica_by_pk?: Maybe<Energy_Village_Caratteristica>;
  /** fetch data from the table in a streaming manner: "energy_village.caratteristica" */
  energy_village_caratteristica_stream: Array<Energy_Village_Caratteristica>;
  /** fetch data from the table: "energy_village.cer_filter_options" */
  energy_village_cer_filter_options: Array<Energy_Village_Cer_Filter_Options>;
  /** fetch aggregated fields from the table: "energy_village.cer_filter_options" */
  energy_village_cer_filter_options_aggregate: Energy_Village_Cer_Filter_Options_Aggregate;
  /** fetch data from the table: "energy_village.cer_filter_options" using primary key columns */
  energy_village_cer_filter_options_by_pk?: Maybe<Energy_Village_Cer_Filter_Options>;
  /** fetch data from the table in a streaming manner: "energy_village.cer_filter_options" */
  energy_village_cer_filter_options_stream: Array<Energy_Village_Cer_Filter_Options>;
  /** fetch data from the table: "energy_village.dimensione" */
  energy_village_dimensione: Array<Energy_Village_Dimensione>;
  /** fetch aggregated fields from the table: "energy_village.dimensione" */
  energy_village_dimensione_aggregate: Energy_Village_Dimensione_Aggregate;
  /** fetch data from the table: "energy_village.dimensione" using primary key columns */
  energy_village_dimensione_by_pk?: Maybe<Energy_Village_Dimensione>;
  /** fetch data from the table in a streaming manner: "energy_village.dimensione" */
  energy_village_dimensione_stream: Array<Energy_Village_Dimensione>;
  /** fetch data from the table: "energy_village.feedback" */
  energy_village_feedback: Array<Energy_Village_Feedback>;
  /** fetch aggregated fields from the table: "energy_village.feedback" */
  energy_village_feedback_aggregate: Energy_Village_Feedback_Aggregate;
  /** fetch data from the table: "energy_village.feedback" using primary key columns */
  energy_village_feedback_by_pk?: Maybe<Energy_Village_Feedback>;
  /** fetch data from the table in a streaming manner: "energy_village.feedback" */
  energy_village_feedback_stream: Array<Energy_Village_Feedback>;
  /** fetch data from the table: "energy_village.incentivo_impianto" */
  energy_village_incentivo_impianto: Array<Energy_Village_Incentivo_Impianto>;
  /** fetch aggregated fields from the table: "energy_village.incentivo_impianto" */
  energy_village_incentivo_impianto_aggregate: Energy_Village_Incentivo_Impianto_Aggregate;
  /** fetch data from the table: "energy_village.incentivo_impianto" using primary key columns */
  energy_village_incentivo_impianto_by_pk?: Maybe<Energy_Village_Incentivo_Impianto>;
  /** fetch data from the table in a streaming manner: "energy_village.incentivo_impianto" */
  energy_village_incentivo_impianto_stream: Array<Energy_Village_Incentivo_Impianto>;
  /** fetch data from the table: "energy_village.orario" */
  energy_village_orario: Array<Energy_Village_Orario>;
  /** fetch aggregated fields from the table: "energy_village.orario" */
  energy_village_orario_aggregate: Energy_Village_Orario_Aggregate;
  /** fetch data from the table: "energy_village.orario" using primary key columns */
  energy_village_orario_by_pk?: Maybe<Energy_Village_Orario>;
  /** fetch data from the table in a streaming manner: "energy_village.orario" */
  energy_village_orario_stream: Array<Energy_Village_Orario>;
  /** fetch data from the table: "energy_village.potenza_impianto" */
  energy_village_potenza_impianto: Array<Energy_Village_Potenza_Impianto>;
  /** fetch aggregated fields from the table: "energy_village.potenza_impianto" */
  energy_village_potenza_impianto_aggregate: Energy_Village_Potenza_Impianto_Aggregate;
  /** fetch data from the table: "energy_village.potenza_impianto" using primary key columns */
  energy_village_potenza_impianto_by_pk?: Maybe<Energy_Village_Potenza_Impianto>;
  /** fetch data from the table in a streaming manner: "energy_village.potenza_impianto" */
  energy_village_potenza_impianto_stream: Array<Energy_Village_Potenza_Impianto>;
  /** fetch data from the table: "energy_village.potenzialita_cabina" */
  energy_village_potenzialita_cabina: Array<Energy_Village_Potenzialita_Cabina>;
  /** fetch aggregated fields from the table: "energy_village.potenzialita_cabina" */
  energy_village_potenzialita_cabina_aggregate: Energy_Village_Potenzialita_Cabina_Aggregate;
  /** fetch data from the table: "energy_village.potenzialita_cabina" using primary key columns */
  energy_village_potenzialita_cabina_by_pk?: Maybe<Energy_Village_Potenzialita_Cabina>;
  /** fetch data from the table in a streaming manner: "energy_village.potenzialita_cabina" */
  energy_village_potenzialita_cabina_stream: Array<Energy_Village_Potenzialita_Cabina>;
  /** fetch data from the table: "energy_village.tipo_spazio_disponibile" */
  energy_village_tipo_spazio_disponibile: Array<Energy_Village_Tipo_Spazio_Disponibile>;
  /** fetch aggregated fields from the table: "energy_village.tipo_spazio_disponibile" */
  energy_village_tipo_spazio_disponibile_aggregate: Energy_Village_Tipo_Spazio_Disponibile_Aggregate;
  /** fetch data from the table: "energy_village.tipo_spazio_disponibile" using primary key columns */
  energy_village_tipo_spazio_disponibile_by_pk?: Maybe<Energy_Village_Tipo_Spazio_Disponibile>;
  /** fetch data from the table in a streaming manner: "energy_village.tipo_spazio_disponibile" */
  energy_village_tipo_spazio_disponibile_stream: Array<Energy_Village_Tipo_Spazio_Disponibile>;
  /** fetch data from the table: "energy_village.tipologia_abitativa" */
  energy_village_tipologia_abitativa: Array<Energy_Village_Tipologia_Abitativa>;
  /** fetch aggregated fields from the table: "energy_village.tipologia_abitativa" */
  energy_village_tipologia_abitativa_aggregate: Energy_Village_Tipologia_Abitativa_Aggregate;
  /** fetch data from the table: "energy_village.tipologia_abitativa" using primary key columns */
  energy_village_tipologia_abitativa_by_pk?: Maybe<Energy_Village_Tipologia_Abitativa>;
  /** fetch data from the table in a streaming manner: "energy_village.tipologia_abitativa" */
  energy_village_tipologia_abitativa_stream: Array<Energy_Village_Tipologia_Abitativa>;
  /** fetch data from the table: "energy_village.tipologia_asset" */
  energy_village_tipologia_asset: Array<Energy_Village_Tipologia_Asset>;
  /** fetch aggregated fields from the table: "energy_village.tipologia_asset" */
  energy_village_tipologia_asset_aggregate: Energy_Village_Tipologia_Asset_Aggregate;
  /** fetch data from the table: "energy_village.tipologia_asset" using primary key columns */
  energy_village_tipologia_asset_by_pk?: Maybe<Energy_Village_Tipologia_Asset>;
  /** fetch data from the table in a streaming manner: "energy_village.tipologia_asset" */
  energy_village_tipologia_asset_stream: Array<Energy_Village_Tipologia_Asset>;
  /** fetch data from the table: "energy_village.titolo_autorizzativo" */
  energy_village_titolo_autorizzativo: Array<Energy_Village_Titolo_Autorizzativo>;
  /** fetch aggregated fields from the table: "energy_village.titolo_autorizzativo" */
  energy_village_titolo_autorizzativo_aggregate: Energy_Village_Titolo_Autorizzativo_Aggregate;
  /** fetch data from the table: "energy_village.titolo_autorizzativo" using primary key columns */
  energy_village_titolo_autorizzativo_by_pk?: Maybe<Energy_Village_Titolo_Autorizzativo>;
  /** fetch data from the table in a streaming manner: "energy_village.titolo_autorizzativo" */
  energy_village_titolo_autorizzativo_stream: Array<Energy_Village_Titolo_Autorizzativo>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "flussi_gse.flusso" */
  flussi_gse_flusso: Array<Flussi_Gse_Flusso>;
  /** fetch aggregated fields from the table: "flussi_gse.flusso" */
  flussi_gse_flusso_aggregate: Flussi_Gse_Flusso_Aggregate;
  /** fetch data from the table: "flussi_gse.flusso" using primary key columns */
  flussi_gse_flusso_by_pk?: Maybe<Flussi_Gse_Flusso>;
  /** fetch data from the table in a streaming manner: "flussi_gse.flusso" */
  flussi_gse_flusso_stream: Array<Flussi_Gse_Flusso>;
  /** fetch data from the table: "funzione_log" */
  funzione_log: Array<Funzione_Log>;
  /** fetch aggregated fields from the table: "funzione_log" */
  funzione_log_aggregate: Funzione_Log_Aggregate;
  /** fetch data from the table: "funzione_log" using primary key columns */
  funzione_log_by_pk?: Maybe<Funzione_Log>;
  /** fetch data from the table in a streaming manner: "funzione_log" */
  funzione_log_stream: Array<Funzione_Log>;
  /** fetch data from the table: "incentivi._stato_calcolo" */
  incentivi__stato_calcolo: Array<Incentivi__Stato_Calcolo>;
  /** fetch aggregated fields from the table: "incentivi._stato_calcolo" */
  incentivi__stato_calcolo_aggregate: Incentivi__Stato_Calcolo_Aggregate;
  /** fetch data from the table: "incentivi._stato_calcolo" using primary key columns */
  incentivi__stato_calcolo_by_pk?: Maybe<Incentivi__Stato_Calcolo>;
  /** fetch data from the table in a streaming manner: "incentivi._stato_calcolo" */
  incentivi__stato_calcolo_stream: Array<Incentivi__Stato_Calcolo>;
  /** fetch data from the table: "incentivi.calcolati" */
  incentivi_calcolati: Array<Incentivi_Calcolati>;
  /** fetch aggregated fields from the table: "incentivi.calcolati" */
  incentivi_calcolati_aggregate: Incentivi_Calcolati_Aggregate;
  /** fetch data from the table: "incentivi.calcolati" using primary key columns */
  incentivi_calcolati_by_pk?: Maybe<Incentivi_Calcolati>;
  /** fetch data from the table in a streaming manner: "incentivi.calcolati" */
  incentivi_calcolati_stream: Array<Incentivi_Calcolati>;
  /** fetch data from the table: "incentivi.log_ripartizione" */
  incentivi_log_ripartizione: Array<Incentivi_Log_Ripartizione>;
  /** fetch aggregated fields from the table: "incentivi.log_ripartizione" */
  incentivi_log_ripartizione_aggregate: Incentivi_Log_Ripartizione_Aggregate;
  /** fetch data from the table: "incentivi.log_ripartizione" using primary key columns */
  incentivi_log_ripartizione_by_pk?: Maybe<Incentivi_Log_Ripartizione>;
  /** fetch data from the table in a streaming manner: "incentivi.log_ripartizione" */
  incentivi_log_ripartizione_stream: Array<Incentivi_Log_Ripartizione>;
  /** fetch data from the table: "incentivi.ripartizione" */
  incentivi_ripartizione: Array<Incentivi_Ripartizione>;
  /** fetch aggregated fields from the table: "incentivi.ripartizione" */
  incentivi_ripartizione_aggregate: Incentivi_Ripartizione_Aggregate;
  /** fetch data from the table: "incentivi.ripartizione" using primary key columns */
  incentivi_ripartizione_by_pk?: Maybe<Incentivi_Ripartizione>;
  /** fetch data from the table in a streaming manner: "incentivi.ripartizione" */
  incentivi_ripartizione_stream: Array<Incentivi_Ripartizione>;
  /** fetch data from the table: "indirizzo" */
  indirizzo: Array<Indirizzo>;
  /** fetch aggregated fields from the table: "indirizzo" */
  indirizzo_aggregate: Indirizzo_Aggregate;
  /** fetch data from the table: "indirizzo" using primary key columns */
  indirizzo_by_pk?: Maybe<Indirizzo>;
  /** fetch data from the table in a streaming manner: "indirizzo" */
  indirizzo_stream: Array<Indirizzo>;
  /** fetch data from the table: "inseritore" */
  inseritore: Array<Inseritore>;
  /** fetch aggregated fields from the table: "inseritore" */
  inseritore_aggregate: Inseritore_Aggregate;
  /** fetch data from the table: "inseritore" using primary key columns */
  inseritore_by_pk?: Maybe<Inseritore>;
  /** fetch data from the table in a streaming manner: "inseritore" */
  inseritore_stream: Array<Inseritore>;
  /** fetch data from the table: "installatore" */
  installatore: Array<Installatore>;
  /** fetch aggregated fields from the table: "installatore" */
  installatore_aggregate: Installatore_Aggregate;
  /** fetch data from the table: "installatore" using primary key columns */
  installatore_by_pk?: Maybe<Installatore>;
  /** fetch data from the table in a streaming manner: "installatore" */
  installatore_stream: Array<Installatore>;
  /** fetch data from the table: "log_errori_funzioni" */
  log_errori_funzioni: Array<Log_Errori_Funzioni>;
  /** fetch aggregated fields from the table: "log_errori_funzioni" */
  log_errori_funzioni_aggregate: Log_Errori_Funzioni_Aggregate;
  /** fetch data from the table: "log_errori_funzioni" using primary key columns */
  log_errori_funzioni_by_pk?: Maybe<Log_Errori_Funzioni>;
  /** fetch data from the table in a streaming manner: "log_errori_funzioni" */
  log_errori_funzioni_stream: Array<Log_Errori_Funzioni>;
  /** fetch data from the table: "persona" */
  persona: Array<Persona>;
  /** fetch aggregated fields from the table: "persona" */
  persona_aggregate: Persona_Aggregate;
  /** fetch data from the table: "persona" using primary key columns */
  persona_by_pk?: Maybe<Persona>;
  /** fetch data from the table: "persona_contatto" */
  persona_contatto: Array<Persona_Contatto>;
  /** fetch aggregated fields from the table: "persona_contatto" */
  persona_contatto_aggregate: Persona_Contatto_Aggregate;
  /** fetch data from the table: "persona_contatto" using primary key columns */
  persona_contatto_by_pk?: Maybe<Persona_Contatto>;
  /** fetch data from the table in a streaming manner: "persona_contatto" */
  persona_contatto_stream: Array<Persona_Contatto>;
  /** fetch data from the table in a streaming manner: "persona" */
  persona_stream: Array<Persona>;
  /** fetch data from the table: "pnrr_documenti" */
  pnrr_documenti: Array<Pnrr_Documenti>;
  /** fetch aggregated fields from the table: "pnrr_documenti" */
  pnrr_documenti_aggregate: Pnrr_Documenti_Aggregate;
  /** fetch data from the table: "pnrr_documenti" using primary key columns */
  pnrr_documenti_by_pk?: Maybe<Pnrr_Documenti>;
  /** fetch data from the table in a streaming manner: "pnrr_documenti" */
  pnrr_documenti_stream: Array<Pnrr_Documenti>;
  /** fetch data from the table: "preset" */
  preset: Array<Preset>;
  /** fetch aggregated fields from the table: "preset" */
  preset_aggregate: Preset_Aggregate;
  /** fetch data from the table: "preset" using primary key columns */
  preset_by_pk?: Maybe<Preset>;
  /** fetch data from the table in a streaming manner: "preset" */
  preset_stream: Array<Preset>;
  /** fetch data from the table: "profilo" */
  profilo: Array<Profilo>;
  /** fetch aggregated fields from the table: "profilo" */
  profilo_aggregate: Profilo_Aggregate;
  /** fetch data from the table: "profilo" using primary key columns */
  profilo_by_pk?: Maybe<Profilo>;
  /** fetch data from the table in a streaming manner: "profilo" */
  profilo_stream: Array<Profilo>;
  /** execute function "search_asset" which returns "asset" */
  search_asset: Array<Asset>;
  /** execute function "search_asset" and query aggregates on result of table type "asset" */
  search_asset_aggregate: Asset_Aggregate;
  /** execute function "search_cer" which returns "cer" */
  search_cer: Array<Cer>;
  /** execute function "search_cer" and query aggregates on result of table type "cer" */
  search_cer_aggregate: Cer_Aggregate;
  /** execute function "search_sottoscrizioni" which returns "sottoscrizione" */
  search_sottoscrizioni: Array<Sottoscrizione>;
  /** execute function "search_sottoscrizioni" and query aggregates on result of table type "sottoscrizione" */
  search_sottoscrizioni_aggregate: Sottoscrizione_Aggregate;
  /** execute function "search_user_entity" which returns "auth.user_entity" */
  search_user_entity: Array<Auth_User_Entity>;
  /** execute function "search_user_entity" and query aggregates on result of table type "auth.user_entity" */
  search_user_entity_aggregate: Auth_User_Entity_Aggregate;
  /** fetch data from the table: "sottoscrizione" */
  sottoscrizione: Array<Sottoscrizione>;
  /** fetch aggregated fields from the table: "sottoscrizione" */
  sottoscrizione_aggregate: Sottoscrizione_Aggregate;
  /** fetch data from the table: "sottoscrizione" using primary key columns */
  sottoscrizione_by_pk?: Maybe<Sottoscrizione>;
  /** fetch data from the table: "sottoscrizione_documenti" */
  sottoscrizione_documenti: Array<Sottoscrizione_Documenti>;
  /** fetch aggregated fields from the table: "sottoscrizione_documenti" */
  sottoscrizione_documenti_aggregate: Sottoscrizione_Documenti_Aggregate;
  /** fetch data from the table: "sottoscrizione_documenti" using primary key columns */
  sottoscrizione_documenti_by_pk?: Maybe<Sottoscrizione_Documenti>;
  /** fetch data from the table in a streaming manner: "sottoscrizione_documenti" */
  sottoscrizione_documenti_stream: Array<Sottoscrizione_Documenti>;
  /** fetch data from the table: "sottoscrizione_domande" */
  sottoscrizione_domande: Array<Sottoscrizione_Domande>;
  /** fetch aggregated fields from the table: "sottoscrizione_domande" */
  sottoscrizione_domande_aggregate: Sottoscrizione_Domande_Aggregate;
  /** fetch data from the table: "sottoscrizione_domande" using primary key columns */
  sottoscrizione_domande_by_pk?: Maybe<Sottoscrizione_Domande>;
  /** fetch data from the table in a streaming manner: "sottoscrizione_domande" */
  sottoscrizione_domande_stream: Array<Sottoscrizione_Domande>;
  /** fetch data from the table: "sottoscrizione_iniziativa" */
  sottoscrizione_iniziativa: Array<Sottoscrizione_Iniziativa>;
  /** fetch aggregated fields from the table: "sottoscrizione_iniziativa" */
  sottoscrizione_iniziativa_aggregate: Sottoscrizione_Iniziativa_Aggregate;
  /** fetch data from the table: "sottoscrizione_iniziativa" using primary key columns */
  sottoscrizione_iniziativa_by_pk?: Maybe<Sottoscrizione_Iniziativa>;
  /** fetch data from the table in a streaming manner: "sottoscrizione_iniziativa" */
  sottoscrizione_iniziativa_stream: Array<Sottoscrizione_Iniziativa>;
  /** fetch data from the table in a streaming manner: "sottoscrizione" */
  sottoscrizione_stream: Array<Sottoscrizione>;
  /** fetch data from the table: "sottoscrizione_zip" */
  sottoscrizione_zip: Array<Sottoscrizione_Zip>;
  /** fetch aggregated fields from the table: "sottoscrizione_zip" */
  sottoscrizione_zip_aggregate: Sottoscrizione_Zip_Aggregate;
  /** fetch data from the table: "sottoscrizione_zip" using primary key columns */
  sottoscrizione_zip_by_pk?: Maybe<Sottoscrizione_Zip>;
  /** fetch data from the table in a streaming manner: "sottoscrizione_zip" */
  sottoscrizione_zip_stream: Array<Sottoscrizione_Zip>;
  /** fetch data from the table: "staging._stato_sottoscrizione" */
  staging__stato_sottoscrizione: Array<Staging__Stato_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging._stato_sottoscrizione" */
  staging__stato_sottoscrizione_aggregate: Staging__Stato_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging._stato_sottoscrizione" using primary key columns */
  staging__stato_sottoscrizione_by_pk?: Maybe<Staging__Stato_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "staging._stato_sottoscrizione" */
  staging__stato_sottoscrizione_stream: Array<Staging__Stato_Sottoscrizione>;
  /** fetch data from the table: "staging.azione_sottoscrizione" */
  staging_azione_sottoscrizione: Array<Staging_Azione_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging.azione_sottoscrizione" */
  staging_azione_sottoscrizione_aggregate: Staging_Azione_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging.azione_sottoscrizione" using primary key columns */
  staging_azione_sottoscrizione_by_pk?: Maybe<Staging_Azione_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "staging.azione_sottoscrizione" */
  staging_azione_sottoscrizione_stream: Array<Staging_Azione_Sottoscrizione>;
  /** fetch data from the table: "staging.gestore_lotto" */
  staging_gestore_lotto: Array<Staging_Gestore_Lotto>;
  /** fetch aggregated fields from the table: "staging.gestore_lotto" */
  staging_gestore_lotto_aggregate: Staging_Gestore_Lotto_Aggregate;
  /** fetch data from the table: "staging.gestore_lotto" using primary key columns */
  staging_gestore_lotto_by_pk?: Maybe<Staging_Gestore_Lotto>;
  /** fetch data from the table in a streaming manner: "staging.gestore_lotto" */
  staging_gestore_lotto_stream: Array<Staging_Gestore_Lotto>;
  /** fetch data from the table: "staging.gestore_sottoscrizione" */
  staging_gestore_sottoscrizione: Array<Staging_Gestore_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging.gestore_sottoscrizione" */
  staging_gestore_sottoscrizione_aggregate: Staging_Gestore_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging.gestore_sottoscrizione" using primary key columns */
  staging_gestore_sottoscrizione_by_pk?: Maybe<Staging_Gestore_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "staging.gestore_sottoscrizione" */
  staging_gestore_sottoscrizione_stream: Array<Staging_Gestore_Sottoscrizione>;
  /** fetch data from the table: "staging.log" */
  staging_log: Array<Staging_Log>;
  /** fetch aggregated fields from the table: "staging.log" */
  staging_log_aggregate: Staging_Log_Aggregate;
  /** fetch data from the table: "staging.log" using primary key columns */
  staging_log_by_pk?: Maybe<Staging_Log>;
  /** fetch data from the table in a streaming manner: "staging.log" */
  staging_log_stream: Array<Staging_Log>;
  /** fetch data from the table: "staging.lotto" */
  staging_lotto: Array<Staging_Lotto>;
  /** fetch aggregated fields from the table: "staging.lotto" */
  staging_lotto_aggregate: Staging_Lotto_Aggregate;
  /** fetch data from the table: "staging.lotto" using primary key columns */
  staging_lotto_by_pk?: Maybe<Staging_Lotto>;
  /** fetch data from the table in a streaming manner: "staging.lotto" */
  staging_lotto_stream: Array<Staging_Lotto>;
  /** fetch data from the table: "staging.mv_refresh_state" */
  staging_mv_refresh_state: Array<Staging_Mv_Refresh_State>;
  /** fetch aggregated fields from the table: "staging.mv_refresh_state" */
  staging_mv_refresh_state_aggregate: Staging_Mv_Refresh_State_Aggregate;
  /** fetch data from the table: "staging.mv_refresh_state" using primary key columns */
  staging_mv_refresh_state_by_pk?: Maybe<Staging_Mv_Refresh_State>;
  /** fetch data from the table in a streaming manner: "staging.mv_refresh_state" */
  staging_mv_refresh_state_stream: Array<Staging_Mv_Refresh_State>;
  /** fetch data from the table: "staging.sottoscrizione" */
  staging_sottoscrizione: Array<Staging_Sottoscrizione>;
  /** fetch aggregated fields from the table: "staging.sottoscrizione" */
  staging_sottoscrizione_aggregate: Staging_Sottoscrizione_Aggregate;
  /** fetch data from the table: "staging.sottoscrizione" using primary key columns */
  staging_sottoscrizione_by_pk?: Maybe<Staging_Sottoscrizione>;
  /** fetch data from the table: "staging.sottoscrizione_list_mv" */
  staging_sottoscrizione_list_mv: Array<Staging_Sottoscrizione_List_Mv>;
  /** fetch aggregated fields from the table: "staging.sottoscrizione_list_mv" */
  staging_sottoscrizione_list_mv_aggregate: Staging_Sottoscrizione_List_Mv_Aggregate;
  /** fetch data from the table in a streaming manner: "staging.sottoscrizione_list_mv" */
  staging_sottoscrizione_list_mv_stream: Array<Staging_Sottoscrizione_List_Mv>;
  /** fetch data from the table: "staging.sottoscrizione_list_v" */
  staging_sottoscrizione_list_v: Array<Staging_Sottoscrizione_List_V>;
  /** fetch aggregated fields from the table: "staging.sottoscrizione_list_v" */
  staging_sottoscrizione_list_v_aggregate: Staging_Sottoscrizione_List_V_Aggregate;
  /** fetch data from the table in a streaming manner: "staging.sottoscrizione_list_v" */
  staging_sottoscrizione_list_v_stream: Array<Staging_Sottoscrizione_List_V>;
  /** fetch data from the table in a streaming manner: "staging.sottoscrizione" */
  staging_sottoscrizione_stream: Array<Staging_Sottoscrizione>;
  /** fetch data from the table: "storage.trigger_debug_log" */
  storage_trigger_debug_log: Array<Storage_Trigger_Debug_Log>;
  /** fetch aggregated fields from the table: "storage.trigger_debug_log" */
  storage_trigger_debug_log_aggregate: Storage_Trigger_Debug_Log_Aggregate;
  /** fetch data from the table: "storage.trigger_debug_log" using primary key columns */
  storage_trigger_debug_log_by_pk?: Maybe<Storage_Trigger_Debug_Log>;
  /** fetch data from the table in a streaming manner: "storage.trigger_debug_log" */
  storage_trigger_debug_log_stream: Array<Storage_Trigger_Debug_Log>;
  /** fetch data from the table: "storage.trigger_error_log" */
  storage_trigger_error_log: Array<Storage_Trigger_Error_Log>;
  /** fetch aggregated fields from the table: "storage.trigger_error_log" */
  storage_trigger_error_log_aggregate: Storage_Trigger_Error_Log_Aggregate;
  /** fetch data from the table: "storage.trigger_error_log" using primary key columns */
  storage_trigger_error_log_by_pk?: Maybe<Storage_Trigger_Error_Log>;
  /** fetch data from the table in a streaming manner: "storage.trigger_error_log" */
  storage_trigger_error_log_stream: Array<Storage_Trigger_Error_Log>;
  /** fetch data from the table: "storico_sottoscrizione" */
  storico_sottoscrizione: Array<Storico_Sottoscrizione>;
  /** fetch aggregated fields from the table: "storico_sottoscrizione" */
  storico_sottoscrizione_aggregate: Storico_Sottoscrizione_Aggregate;
  /** fetch data from the table: "storico_sottoscrizione" using primary key columns */
  storico_sottoscrizione_by_pk?: Maybe<Storico_Sottoscrizione>;
  /** fetch data from the table in a streaming manner: "storico_sottoscrizione" */
  storico_sottoscrizione_stream: Array<Storico_Sottoscrizione>;
  /** fetch data from the table: "translate.mapper" */
  translate_mapper: Array<Translate_Mapper>;
  /** fetch aggregated fields from the table: "translate.mapper" */
  translate_mapper_aggregate: Translate_Mapper_Aggregate;
  /** fetch data from the table: "translate.mapper" using primary key columns */
  translate_mapper_by_pk?: Maybe<Translate_Mapper>;
  /** fetch data from the table in a streaming manner: "translate.mapper" */
  translate_mapper_stream: Array<Translate_Mapper>;
  /** fetch data from the table: "unita_amministrativa.citta" */
  unita_amministrativa_citta: Array<Unita_Amministrativa_Citta>;
  /** fetch aggregated fields from the table: "unita_amministrativa.citta" */
  unita_amministrativa_citta_aggregate: Unita_Amministrativa_Citta_Aggregate;
  /** fetch data from the table: "unita_amministrativa.citta" using primary key columns */
  unita_amministrativa_citta_by_pk?: Maybe<Unita_Amministrativa_Citta>;
  /** fetch data from the table in a streaming manner: "unita_amministrativa.citta" */
  unita_amministrativa_citta_stream: Array<Unita_Amministrativa_Citta>;
  /** fetch data from the table: "unita_amministrativa.nazione" */
  unita_amministrativa_nazione: Array<Unita_Amministrativa_Nazione>;
  /** fetch aggregated fields from the table: "unita_amministrativa.nazione" */
  unita_amministrativa_nazione_aggregate: Unita_Amministrativa_Nazione_Aggregate;
  /** fetch data from the table: "unita_amministrativa.nazione" using primary key columns */
  unita_amministrativa_nazione_by_pk?: Maybe<Unita_Amministrativa_Nazione>;
  /** fetch data from the table in a streaming manner: "unita_amministrativa.nazione" */
  unita_amministrativa_nazione_stream: Array<Unita_Amministrativa_Nazione>;
  /** fetch data from the table: "unita_amministrativa.provincia" */
  unita_amministrativa_provincia: Array<Unita_Amministrativa_Provincia>;
  /** fetch aggregated fields from the table: "unita_amministrativa.provincia" */
  unita_amministrativa_provincia_aggregate: Unita_Amministrativa_Provincia_Aggregate;
  /** fetch data from the table: "unita_amministrativa.provincia" using primary key columns */
  unita_amministrativa_provincia_by_pk?: Maybe<Unita_Amministrativa_Provincia>;
  /** fetch data from the table in a streaming manner: "unita_amministrativa.provincia" */
  unita_amministrativa_provincia_stream: Array<Unita_Amministrativa_Provincia>;
  /** fetch data from the table: "unita_amministrativa.regione" */
  unita_amministrativa_regione: Array<Unita_Amministrativa_Regione>;
  /** fetch aggregated fields from the table: "unita_amministrativa.regione" */
  unita_amministrativa_regione_aggregate: Unita_Amministrativa_Regione_Aggregate;
  /** fetch data from the table: "unita_amministrativa.regione" using primary key columns */
  unita_amministrativa_regione_by_pk?: Maybe<Unita_Amministrativa_Regione>;
  /** fetch data from the table in a streaming manner: "unita_amministrativa.regione" */
  unita_amministrativa_regione_stream: Array<Unita_Amministrativa_Regione>;
  /** fetch data from the table: "v_superadmin_sottoscrizioni" */
  v_superadmin_sottoscrizioni: Array<V_Superadmin_Sottoscrizioni>;
  /** fetch aggregated fields from the table: "v_superadmin_sottoscrizioni" */
  v_superadmin_sottoscrizioni_aggregate: V_Superadmin_Sottoscrizioni_Aggregate;
  /** fetch data from the table in a streaming manner: "v_superadmin_sottoscrizioni" */
  v_superadmin_sottoscrizioni_stream: Array<V_Superadmin_Sottoscrizioni>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate;
  /** fetch data from the table: "white_label.associazione" */
  white_label_associazione: Array<White_Label_Associazione>;
  /** fetch aggregated fields from the table: "white_label.associazione" */
  white_label_associazione_aggregate: White_Label_Associazione_Aggregate;
  /** fetch data from the table: "white_label.associazione" using primary key columns */
  white_label_associazione_by_pk?: Maybe<White_Label_Associazione>;
  /** fetch data from the table in a streaming manner: "white_label.associazione" */
  white_label_associazione_stream: Array<White_Label_Associazione>;
  /** fetch data from the table: "white_label.configurazione" */
  white_label_configurazione: Array<White_Label_Configurazione>;
  /** fetch aggregated fields from the table: "white_label.configurazione" */
  white_label_configurazione_aggregate: White_Label_Configurazione_Aggregate;
  /** fetch data from the table: "white_label.configurazione" using primary key columns */
  white_label_configurazione_by_pk?: Maybe<White_Label_Configurazione>;
  /** fetch data from the table in a streaming manner: "white_label.configurazione" */
  white_label_configurazione_stream: Array<White_Label_Configurazione>;
  /** fetch data from the table: "white_label.gestore" */
  white_label_gestore: Array<White_Label_Gestore>;
  /** fetch aggregated fields from the table: "white_label.gestore" */
  white_label_gestore_aggregate: White_Label_Gestore_Aggregate;
  /** fetch data from the table: "white_label.gestore" using primary key columns */
  white_label_gestore_by_pk?: Maybe<White_Label_Gestore>;
  /** fetch data from the table in a streaming manner: "white_label.gestore" */
  white_label_gestore_stream: Array<White_Label_Gestore>;
  /** fetch data from the table: "white_label.idp" */
  white_label_idp: Array<White_Label_Idp>;
  /** fetch aggregated fields from the table: "white_label.idp" */
  white_label_idp_aggregate: White_Label_Idp_Aggregate;
  /** fetch data from the table: "white_label.idp" using primary key columns */
  white_label_idp_by_pk?: Maybe<White_Label_Idp>;
  /** fetch data from the table in a streaming manner: "white_label.idp" */
  white_label_idp_stream: Array<White_Label_Idp>;
};


export type Subscription_Root_Destinazione_CompatibileArgs = {
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Subscription_Root_Destinazione_Compatibile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Subscription_Root_Destinazione_Compatibile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<_Destinazione_Compatibile_Stream_Cursor_Input>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Subscription_Root_Pod_DuplicatoArgs = {
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Subscription_Root_Pod_Duplicato_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Subscription_Root_Pod_Duplicato_By_PkArgs = {
  pod: Scalars['String']['input'];
};


export type Subscription_Root_Pod_Duplicato_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<_Pod_Duplicato_Stream_Cursor_Input>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Subscription_Root_Sottoscrizione_Tipo_RichiestaArgs = {
  distinct_on?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Order_By>>;
  where?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>;
};


export type Subscription_Root_Sottoscrizione_Tipo_Richiesta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Sottoscrizione_Tipo_Richiesta_Order_By>>;
  where?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>;
};


export type Subscription_Root_Sottoscrizione_Tipo_Richiesta_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_Root_Sottoscrizione_Tipo_Richiesta_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<_Sottoscrizione_Tipo_Richiesta_Stream_Cursor_Input>>;
  where?: InputMaybe<_Sottoscrizione_Tipo_Richiesta_Bool_Exp>;
};


export type Subscription_Root_Superadmin_Elimina_Sottoscrizione_EsitoArgs = {
  distinct_on?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Order_By>>;
  where?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
};


export type Subscription_Root_Superadmin_Elimina_Sottoscrizione_Esito_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Superadmin_Elimina_Sottoscrizione_Esito_Order_By>>;
  where?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
};


export type Subscription_Root_Superadmin_Elimina_Sottoscrizione_Esito_By_PkArgs = {
  sottoscrizione_id: Scalars['uuid']['input'];
};


export type Subscription_Root_Superadmin_Elimina_Sottoscrizione_Esito_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Stream_Cursor_Input>>;
  where?: InputMaybe<_Superadmin_Elimina_Sottoscrizione_Esito_Bool_Exp>;
};


export type Subscription_Root_Tipo_Dato_ConsumoArgs = {
  distinct_on?: InputMaybe<Array<_Tipo_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipo_Dato_Consumo_Order_By>>;
  where?: InputMaybe<_Tipo_Dato_Consumo_Bool_Exp>;
};


export type Subscription_Root_Tipo_Dato_Consumo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Tipo_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipo_Dato_Consumo_Order_By>>;
  where?: InputMaybe<_Tipo_Dato_Consumo_Bool_Exp>;
};


export type Subscription_Root_Tipo_Dato_Consumo_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_Root_Tipo_Dato_Consumo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<_Tipo_Dato_Consumo_Stream_Cursor_Input>>;
  where?: InputMaybe<_Tipo_Dato_Consumo_Bool_Exp>;
};


export type Subscription_Root_Tipologia_ProfiloArgs = {
  distinct_on?: InputMaybe<Array<_Tipologia_Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipologia_Profilo_Order_By>>;
  where?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
};


export type Subscription_Root_Tipologia_Profilo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<_Tipologia_Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Tipologia_Profilo_Order_By>>;
  where?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
};


export type Subscription_Root_Tipologia_Profilo_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_Root_Tipologia_Profilo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<_Tipologia_Profilo_Stream_Cursor_Input>>;
  where?: InputMaybe<_Tipologia_Profilo_Bool_Exp>;
};


export type Subscription_RootAdmin__Stato_Richiesta_PubblicazioneArgs = {
  distinct_on?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Subscription_RootAdmin__Stato_Richiesta_Pubblicazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Stato_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Subscription_RootAdmin__Stato_Richiesta_Pubblicazione_By_PkArgs = {
  stato: Scalars['String']['input'];
};


export type Subscription_RootAdmin__Stato_Richiesta_Pubblicazione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin__Stato_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Subscription_RootAdmin__Type_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Admin__Type_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Type_Referral_Order_By>>;
  where?: InputMaybe<Admin__Type_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin__Type_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin__Type_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin__Type_Referral_Order_By>>;
  where?: InputMaybe<Admin__Type_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin__Type_Referral_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_RootAdmin__Type_Referral_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin__Type_Referral_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin__Type_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin_Consenso_PrivacyArgs = {
  distinct_on?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Consenso_Privacy_Order_By>>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};


export type Subscription_RootAdmin_Consenso_Privacy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Consenso_Privacy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Consenso_Privacy_Order_By>>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};


export type Subscription_RootAdmin_Consenso_Privacy_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_Consenso_Privacy_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Consenso_Privacy_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Consenso_Privacy_Bool_Exp>;
};


export type Subscription_RootAdmin_Parametri_Algoritmo_IncentiviArgs = {
  distinct_on?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Order_By>>;
  where?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>;
};


export type Subscription_RootAdmin_Parametri_Algoritmo_Incentivi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Parametri_Algoritmo_Incentivi_Order_By>>;
  where?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>;
};


export type Subscription_RootAdmin_Parametri_Algoritmo_Incentivi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_Parametri_Algoritmo_Incentivi_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Parametri_Algoritmo_Incentivi_Bool_Exp>;
};


export type Subscription_RootAdmin_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Admin_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Referral_Order_By>>;
  where?: InputMaybe<Admin_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Referral_Order_By>>;
  where?: InputMaybe<Admin_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_Referral_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Referral_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin_Richiesta_PubblicazioneArgs = {
  distinct_on?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Subscription_RootAdmin_Richiesta_Pubblicazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Richiesta_Pubblicazione_Order_By>>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Subscription_RootAdmin_Richiesta_Pubblicazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_Richiesta_Pubblicazione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Richiesta_Pubblicazione_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Richiesta_Pubblicazione_Bool_Exp>;
};


export type Subscription_RootAdmin_Utilizzo_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Admin_Utilizzo_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Utilizzo_Referral_Order_By>>;
  where?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin_Utilizzo_Referral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Utilizzo_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_Utilizzo_Referral_Order_By>>;
  where?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
};


export type Subscription_RootAdmin_Utilizzo_Referral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_Utilizzo_Referral_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_Utilizzo_Referral_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Codice_AtecoArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Codice_Ateco_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Codice_Ateco_Order_By>>;
  where?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Codice_Ateco_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Codice_Ateco_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Codice_Ateco_Order_By>>;
  where?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Codice_Ateco_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAnagrafica_Codice_Ateco_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anagrafica_Codice_Ateco_Stream_Cursor_Input>>;
  where?: InputMaybe<Anagrafica_Codice_Ateco_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Forma_GiuridicaArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Forma_Giuridica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Forma_Giuridica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnagrafica_Forma_Giuridica_CerArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Forma_Giuridica_Cer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Forma_Giuridica_Cer_Order_By>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Forma_Giuridica_Cer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnagrafica_Forma_Giuridica_Cer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anagrafica_Forma_Giuridica_Cer_Stream_Cursor_Input>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Cer_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Forma_Giuridica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anagrafica_Forma_Giuridica_Stream_Cursor_Input>>;
  where?: InputMaybe<Anagrafica_Forma_Giuridica_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipo_ContattoArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipo_Contatto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Contatto_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipo_Contatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnagrafica_Tipo_Contatto_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anagrafica_Tipo_Contatto_Stream_Cursor_Input>>;
  where?: InputMaybe<Anagrafica_Tipo_Contatto_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipo_PromotoreArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipo_Promotore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipo_Promotore_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipo_Promotore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnagrafica_Tipo_Promotore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anagrafica_Tipo_Promotore_Stream_Cursor_Input>>;
  where?: InputMaybe<Anagrafica_Tipo_Promotore_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipologia_RappresentanteArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipologia_Rappresentante_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anagrafica_Tipologia_Rappresentante_Order_By>>;
  where?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
};


export type Subscription_RootAnagrafica_Tipologia_Rappresentante_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnagrafica_Tipologia_Rappresentante_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anagrafica_Tipologia_Rappresentante_Stream_Cursor_Input>>;
  where?: InputMaybe<Anagrafica_Tipologia_Rappresentante_Bool_Exp>;
};


export type Subscription_RootAssetArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Subscription_RootAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Subscription_RootAsset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_CaratteristicaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Caratteristica_Order_By>>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};


export type Subscription_RootAsset_Caratteristica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Caratteristica_Order_By>>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};


export type Subscription_RootAsset_Caratteristica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Caratteristica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Caratteristica_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Caratteristica_Bool_Exp>;
};


export type Subscription_RootAsset_ConsumoArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


export type Subscription_RootAsset_Consumo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


export type Subscription_RootAsset_Consumo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Consumo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Consumo_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Consumo_Bool_Exp>;
};


export type Subscription_RootAsset_Dato_ConsumoArgs = {
  distinct_on?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Dato_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};


export type Subscription_RootAsset_Dato_Consumo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Dato_Consumo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Dato_Consumo_Order_By>>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};


export type Subscription_RootAsset_Dato_Consumo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Dato_Consumo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Dato_Consumo_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Dato_Consumo_Bool_Exp>;
};


export type Subscription_RootAsset_EnergiaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Energia_Order_By>>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};


export type Subscription_RootAsset_Energia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Energia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Energia_Order_By>>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};


export type Subscription_RootAsset_Energia_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Energia_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Energia_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Energia_Bool_Exp>;
};


export type Subscription_RootAsset_FounderArgs = {
  distinct_on?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Founder_Order_By>>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};


export type Subscription_RootAsset_Founder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Founder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Founder_Order_By>>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};


export type Subscription_RootAsset_Founder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Founder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Founder_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Founder_Bool_Exp>;
};


export type Subscription_RootAsset_GestoreArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


export type Subscription_RootAsset_Gestore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


export type Subscription_RootAsset_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Gestore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Gestore_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Gestore_Bool_Exp>;
};


export type Subscription_RootAsset_ProduzioneArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Produzione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Produzione_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Produzione_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_UnitaArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Produzione_Unita_SezioneArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_IncentiviArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_Incentivi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Incentivi_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_Incentivi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_Incentivi_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Incentivi_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Produzione_Unita_Sezione_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_Titolo_AutorizzativoArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_Titolo_Autorizzativo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_Titolo_Autorizzativo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Produzione_Unita_Sezione_Titolo_Autorizzativo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Produzione_Unita_Sezione_Titolo_Autorizzativo_Bool_Exp>;
};


export type Subscription_RootAsset_Produzione_Unita_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Produzione_Unita_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Produzione_Unita_Bool_Exp>;
};


export type Subscription_RootAsset_SpazioArgs = {
  distinct_on?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Spazio_Order_By>>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};


export type Subscription_RootAsset_Spazio_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Spazio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Spazio_Order_By>>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};


export type Subscription_RootAsset_Spazio_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAsset_Spazio_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Spazio_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Spazio_Bool_Exp>;
};


export type Subscription_RootAsset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Subscription_RootAuth_Event_EntityArgs = {
  distinct_on?: InputMaybe<Array<Auth_Event_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Event_Entity_Order_By>>;
  where?: InputMaybe<Auth_Event_Entity_Bool_Exp>;
};


export type Subscription_RootAuth_Event_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Event_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Event_Entity_Order_By>>;
  where?: InputMaybe<Auth_Event_Entity_Bool_Exp>;
};


export type Subscription_RootAuth_Event_Entity_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuth_Event_Entity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Event_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Event_Entity_Bool_Exp>;
};


export type Subscription_RootAuth_Federated_IdentityArgs = {
  distinct_on?: InputMaybe<Array<Auth_Federated_Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Federated_Identity_Order_By>>;
  where?: InputMaybe<Auth_Federated_Identity_Bool_Exp>;
};


export type Subscription_RootAuth_Federated_Identity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Federated_Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Federated_Identity_Order_By>>;
  where?: InputMaybe<Auth_Federated_Identity_Bool_Exp>;
};


export type Subscription_RootAuth_Federated_Identity_By_PkArgs = {
  identity_provider: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};


export type Subscription_RootAuth_Federated_Identity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Federated_Identity_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Federated_Identity_Bool_Exp>;
};


export type Subscription_RootAuth_Role_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Attribute_Order_By>>;
  where?: InputMaybe<Auth_Role_Attribute_Bool_Exp>;
};


export type Subscription_RootAuth_Role_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Attribute_Order_By>>;
  where?: InputMaybe<Auth_Role_Attribute_Bool_Exp>;
};


export type Subscription_RootAuth_Role_Attribute_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuth_Role_Attribute_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Role_Attribute_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Role_Attribute_Bool_Exp>;
};


export type Subscription_RootAuth_User_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Attribute_Order_By>>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};


export type Subscription_RootAuth_User_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Attribute_Order_By>>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};


export type Subscription_RootAuth_User_Attribute_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuth_User_Attribute_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_User_Attribute_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_User_Attribute_Bool_Exp>;
};


export type Subscription_RootAuth_User_EntityArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Subscription_RootAuth_User_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Subscription_RootAuth_User_Entity_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuth_User_Entity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_User_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>;
  where?: InputMaybe<Buckets_Bool_Exp>;
};


export type Subscription_RootCerArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Subscription_RootCer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Subscription_RootCer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_CabinaArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


export type Subscription_RootCer_Cabina_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


export type Subscription_RootCer_Cabina_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Cabina_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Snapshot_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};


export type Subscription_RootCer_Cabina_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Cabina_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Cabina_Snapshot_Order_By>>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};


export type Subscription_RootCer_Cabina_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Cabina_Snapshot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Cabina_Snapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Cabina_Snapshot_Bool_Exp>;
};


export type Subscription_RootCer_Cabina_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Cabina_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Cabina_Bool_Exp>;
};


export type Subscription_RootCer_Categoria_AdesioneArgs = {
  distinct_on?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Categoria_Adesione_Order_By>>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};


export type Subscription_RootCer_Categoria_Adesione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Categoria_Adesione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Categoria_Adesione_Order_By>>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};


export type Subscription_RootCer_Categoria_Adesione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Categoria_Adesione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Categoria_Adesione_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Categoria_Adesione_Bool_Exp>;
};


export type Subscription_RootCer_Configurazione_Destinazione_ContributoArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


export type Subscription_RootCer_Configurazione_Destinazione_Contributo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Configurazione_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


export type Subscription_RootCer_Configurazione_Destinazione_Contributo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Configurazione_Destinazione_Contributo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Configurazione_Destinazione_Contributo_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Configurazione_Destinazione_Contributo_Bool_Exp>;
};


export type Subscription_RootCer_ContattiArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


export type Subscription_RootCer_Contatti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Contatti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Contatti_Order_By>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


export type Subscription_RootCer_Contatti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Contatti_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Contatti_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Contatti_Bool_Exp>;
};


export type Subscription_RootCer_Destinazione_ContributoArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


export type Subscription_RootCer_Destinazione_Contributo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Destinazione_Contributo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Destinazione_Contributo_Order_By>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


export type Subscription_RootCer_Destinazione_Contributo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Destinazione_Contributo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Destinazione_Contributo_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Destinazione_Contributo_Bool_Exp>;
};


export type Subscription_RootCer_GeomArgs = {
  distinct_on?: InputMaybe<Array<Cer_Geom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Geom_Order_By>>;
  where?: InputMaybe<Cer_Geom_Bool_Exp>;
};


export type Subscription_RootCer_Geom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Geom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Geom_Order_By>>;
  where?: InputMaybe<Cer_Geom_Bool_Exp>;
};


export type Subscription_RootCer_Geom_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Geom_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Geom_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Geom_Bool_Exp>;
};


export type Subscription_RootCer_GestoreArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


export type Subscription_RootCer_Gestore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Gestore_Order_By>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


export type Subscription_RootCer_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Gestore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Gestore_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Gestore_Bool_Exp>;
};


export type Subscription_RootCer_Search_IndexArgs = {
  distinct_on?: InputMaybe<Array<Cer_Search_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Search_Index_Order_By>>;
  where?: InputMaybe<Cer_Search_Index_Bool_Exp>;
};


export type Subscription_RootCer_Search_Index_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Search_Index_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Search_Index_Order_By>>;
  where?: InputMaybe<Cer_Search_Index_Bool_Exp>;
};


export type Subscription_RootCer_Search_Index_By_PkArgs = {
  cer_id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Search_Index_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Search_Index_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Search_Index_Bool_Exp>;
};


export type Subscription_RootCer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Subscription_RootCer_TecnicoArgs = {
  distinct_on?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Tecnico_Order_By>>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};


export type Subscription_RootCer_Tecnico_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cer_Tecnico_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Tecnico_Order_By>>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};


export type Subscription_RootCer_Tecnico_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCer_Tecnico_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cer_Tecnico_Stream_Cursor_Input>>;
  where?: InputMaybe<Cer_Tecnico_Bool_Exp>;
};


export type Subscription_RootCheck_Pod_DuplicatoArgs = {
  args: Check_Pod_Duplicato_Args;
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Subscription_RootCheck_Pod_Duplicato_AggregateArgs = {
  args: Check_Pod_Duplicato_Args;
  distinct_on?: InputMaybe<Array<_Pod_Duplicato_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Pod_Duplicato_Order_By>>;
  where?: InputMaybe<_Pod_Duplicato_Bool_Exp>;
};


export type Subscription_RootCodice_OperatoreArgs = {
  distinct_on?: InputMaybe<Array<Codice_Operatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Codice_Operatore_Order_By>>;
  where?: InputMaybe<Codice_Operatore_Bool_Exp>;
};


export type Subscription_RootCodice_Operatore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Codice_Operatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Codice_Operatore_Order_By>>;
  where?: InputMaybe<Codice_Operatore_Bool_Exp>;
};


export type Subscription_RootCodice_Operatore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCodice_Operatore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Codice_Operatore_Stream_Cursor_Input>>;
  where?: InputMaybe<Codice_Operatore_Bool_Exp>;
};


export type Subscription_RootComunicazioni_EmailArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
};


export type Subscription_RootComunicazioni_Email_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
};


export type Subscription_RootComunicazioni_Email_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootComunicazioni_Email_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comunicazioni_Email_Stream_Cursor_Input>>;
  where?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
};


export type Subscription_RootComunicazioni_Email_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Template_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
};


export type Subscription_RootComunicazioni_Email_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Email_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Template_Order_By>>;
  where?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
};


export type Subscription_RootComunicazioni_Email_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootComunicazioni_Email_Template_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comunicazioni_Email_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
};


export type Subscription_RootComunicazioni_SmsArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Sms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Sms_Order_By>>;
  where?: InputMaybe<Comunicazioni_Sms_Bool_Exp>;
};


export type Subscription_RootComunicazioni_Sms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comunicazioni_Sms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comunicazioni_Sms_Order_By>>;
  where?: InputMaybe<Comunicazioni_Sms_Bool_Exp>;
};


export type Subscription_RootComunicazioni_Sms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootComunicazioni_Sms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comunicazioni_Sms_Stream_Cursor_Input>>;
  where?: InputMaybe<Comunicazioni_Sms_Bool_Exp>;
};


export type Subscription_RootCondivisione__Stato_CondivisioneArgs = {
  distinct_on?: InputMaybe<Array<Condivisione__Stato_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione__Stato_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione__Stato_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione__Stato_Condivisione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione__Stato_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione__Stato_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione__Stato_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione__Stato_Condivisione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_RootCondivisione__Stato_Condivisione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Condivisione__Stato_Condivisione_Stream_Cursor_Input>>;
  where?: InputMaybe<Condivisione__Stato_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione_Accetta_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Accetta_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Accetta_Response_Order_By>>;
  where?: InputMaybe<Condivisione_Accetta_Response_Bool_Exp>;
};


export type Subscription_RootCondivisione_Accetta_Response_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Accetta_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Accetta_Response_Order_By>>;
  where?: InputMaybe<Condivisione_Accetta_Response_Bool_Exp>;
};


export type Subscription_RootCondivisione_Accetta_Response_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Condivisione_Accetta_Response_Stream_Cursor_Input>>;
  where?: InputMaybe<Condivisione_Accetta_Response_Bool_Exp>;
};


export type Subscription_RootCondivisione_CondivisioneArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione_Condivisione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione_Condivisione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCondivisione_Condivisione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Condivisione_Condivisione_Stream_Cursor_Input>>;
  where?: InputMaybe<Condivisione_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione_Log_CondivisioneArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Log_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Log_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Log_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione_Log_Condivisione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Condivisione_Log_Condivisione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Condivisione_Log_Condivisione_Order_By>>;
  where?: InputMaybe<Condivisione_Log_Condivisione_Bool_Exp>;
};


export type Subscription_RootCondivisione_Log_Condivisione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCondivisione_Log_Condivisione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Condivisione_Log_Condivisione_Stream_Cursor_Input>>;
  where?: InputMaybe<Condivisione_Log_Condivisione_Bool_Exp>;
};


export type Subscription_RootContattoArgs = {
  distinct_on?: InputMaybe<Array<Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contatto_Order_By>>;
  where?: InputMaybe<Contatto_Bool_Exp>;
};


export type Subscription_RootContatto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contatto_Order_By>>;
  where?: InputMaybe<Contatto_Bool_Exp>;
};


export type Subscription_RootContatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootContatto_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contatto_Stream_Cursor_Input>>;
  where?: InputMaybe<Contatto_Bool_Exp>;
};


export type Subscription_RootCrm_Audit_EventArgs = {
  distinct_on?: InputMaybe<Array<Crm_Audit_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Audit_Event_Order_By>>;
  where?: InputMaybe<Crm_Audit_Event_Bool_Exp>;
};


export type Subscription_RootCrm_Audit_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Audit_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Audit_Event_Order_By>>;
  where?: InputMaybe<Crm_Audit_Event_Bool_Exp>;
};


export type Subscription_RootCrm_Audit_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCrm_Audit_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Crm_Audit_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Crm_Audit_Event_Bool_Exp>;
};


export type Subscription_RootDebug_Sottoscrizione_After_LogArgs = {
  distinct_on?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Order_By>>;
  where?: InputMaybe<Debug_Sottoscrizione_After_Log_Bool_Exp>;
};


export type Subscription_RootDebug_Sottoscrizione_After_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Debug_Sottoscrizione_After_Log_Order_By>>;
  where?: InputMaybe<Debug_Sottoscrizione_After_Log_Bool_Exp>;
};


export type Subscription_RootDebug_Sottoscrizione_After_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootDebug_Sottoscrizione_After_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Debug_Sottoscrizione_After_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Debug_Sottoscrizione_After_Log_Bool_Exp>;
};


export type Subscription_RootDestinazioni_CompatibiliArgs = {
  args: Destinazioni_Compatibili_Args;
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Subscription_RootDestinazioni_Compatibili_AggregateArgs = {
  args: Destinazioni_Compatibili_Args;
  distinct_on?: InputMaybe<Array<_Destinazione_Compatibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<_Destinazione_Compatibile_Order_By>>;
  where?: InputMaybe<_Destinazione_Compatibile_Bool_Exp>;
};


export type Subscription_RootDevice_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Device_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Device_Order_By>>;
  where?: InputMaybe<Device_Device_Bool_Exp>;
};


export type Subscription_RootDevice_Device_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Device_Device_Order_By>>;
  where?: InputMaybe<Device_Device_Bool_Exp>;
};


export type Subscription_RootDevice_Device_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevice_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Device_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Device_Device_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Founder_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Founder_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Founder_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Founder_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Azioni_Founder_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Azioni_Founder_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Prosumer_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Prosumer_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Prosumer_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Prosumer_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Azioni_Prosumer_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Azioni_Prosumer_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Tecnico_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Tecnico_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Azioni_Tecnico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Azioni_Tecnico_Sottoscrizione_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Azioni_Tecnico_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Azioni_Tecnico_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Cer_Filter_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village__Cer_Filter_Options_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Cer_Filter_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village__Cer_Filter_Options_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Cer_Filter_Options_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Cer_Filter_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Cer_Filter_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Cer_Filter_Options_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Stato_CerArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Cer_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Cer_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Stato_Cer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Cer_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Cer_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Stato_Cer_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Stato_Cer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Stato_Cer_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Stato_Cer_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Stato_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Stato_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Stato_Sottoscrizione_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Stato_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Stato_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Stato_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Tipo_DomandaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Domanda_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Tipo_Domanda_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Domanda_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Domanda_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Tipo_Domanda_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Tipo_Domanda_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Tipo_Domanda_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Tipo_Domanda_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Tipo_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Feedback_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Tipo_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village__Tipo_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village__Tipo_Feedback_Bool_Exp>;
};


export type Subscription_RootEnergy_Village__Tipo_Feedback_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Village__Tipo_Feedback_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village__Tipo_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village__Tipo_Feedback_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_AreaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEnergy_Village_Area_CittaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Citta_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_Citta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Citta_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_Citta_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEnergy_Village_Area_Citta_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Area_Citta_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Area_Citta_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_ProvinciaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Provincia_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Provincia_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_Provincia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Provincia_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Provincia_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_Provincia_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEnergy_Village_Area_Provincia_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Area_Provincia_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Area_Provincia_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_RegioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Regione_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Regione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_Regione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Area_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Area_Regione_Order_By>>;
  where?: InputMaybe<Energy_Village_Area_Regione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_Regione_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEnergy_Village_Area_Regione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Area_Regione_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Area_Regione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Area_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Area_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Area_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_AzioniArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Azioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Azioni_Order_By>>;
  where?: InputMaybe<Energy_Village_Azioni_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Azioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Azioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Azioni_Order_By>>;
  where?: InputMaybe<Energy_Village_Azioni_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Azioni_By_PkArgs = {
  founder: Energy_Village__Azioni_Founder_Sottoscrizione_Enum;
  prosumer: Energy_Village__Azioni_Prosumer_Sottoscrizione_Enum;
  tecnico: Energy_Village__Azioni_Tecnico_Sottoscrizione_Enum;
};


export type Subscription_RootEnergy_Village_Azioni_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Azioni_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Azioni_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_CabinaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cabina_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cabina_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEnergy_Village_Cabina_CittaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cabina_Citta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cabina_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cabina_Citta_Order_By>>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cabina_Citta_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Cabina_Citta_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Cabina_Citta_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Cabina_Citta_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cabina_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Cabina_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_CaratteristicaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Caratteristica_Order_By>>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Caratteristica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Caratteristica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Caratteristica_Order_By>>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Caratteristica_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Caratteristica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Caratteristica_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Caratteristica_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cer_Filter_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village_Cer_Filter_Options_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cer_Filter_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Cer_Filter_Options_Order_By>>;
  where?: InputMaybe<Energy_Village_Cer_Filter_Options_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Cer_Filter_Options_By_PkArgs = {
  filter: Energy_Village__Cer_Filter_Options_Enum;
};


export type Subscription_RootEnergy_Village_Cer_Filter_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Cer_Filter_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Cer_Filter_Options_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_DimensioneArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Dimensione_Order_By>>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Dimensione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Dimensione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Dimensione_Order_By>>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Dimensione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Dimensione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Dimensione_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Dimensione_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Feedback_Order_By>>;
  where?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Feedback_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Feedback_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Feedback_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Incentivo_ImpiantoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Incentivo_Impianto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Incentivo_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Incentivo_Impianto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Incentivo_Impianto_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Incentivo_Impianto_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Incentivo_Impianto_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_OrarioArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Orario_Order_By>>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Orario_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Orario_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Orario_Order_By>>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Orario_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Orario_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Orario_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Orario_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Potenza_ImpiantoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Potenza_Impianto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenza_Impianto_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Potenza_Impianto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Potenza_Impianto_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Potenza_Impianto_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Potenza_Impianto_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Potenzialita_CabinaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Potenzialita_Cabina_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Potenzialita_Cabina_Order_By>>;
  where?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Potenzialita_Cabina_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEnergy_Village_Potenzialita_Cabina_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Potenzialita_Cabina_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Potenzialita_Cabina_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipo_Spazio_DisponibileArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipo_Spazio_Disponibile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipo_Spazio_Disponibile_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipo_Spazio_Disponibile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Tipo_Spazio_Disponibile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Tipo_Spazio_Disponibile_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipologia_AbitativaArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipologia_Abitativa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Abitativa_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipologia_Abitativa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Tipologia_Abitativa_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Tipologia_Abitativa_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Tipologia_Abitativa_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipologia_AssetArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipologia_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Tipologia_Asset_Order_By>>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Tipologia_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Tipologia_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Tipologia_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Tipologia_Asset_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Titolo_AutorizzativoArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Titolo_Autorizzativo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Village_Titolo_Autorizzativo_Order_By>>;
  where?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Bool_Exp>;
};


export type Subscription_RootEnergy_Village_Titolo_Autorizzativo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnergy_Village_Titolo_Autorizzativo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Village_Titolo_Autorizzativo_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Village_Titolo_Autorizzativo_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFlussi_Gse_FlussoArgs = {
  distinct_on?: InputMaybe<Array<Flussi_Gse_Flusso_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flussi_Gse_Flusso_Order_By>>;
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
};


export type Subscription_RootFlussi_Gse_Flusso_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flussi_Gse_Flusso_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flussi_Gse_Flusso_Order_By>>;
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
};


export type Subscription_RootFlussi_Gse_Flusso_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFlussi_Gse_Flusso_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Flussi_Gse_Flusso_Stream_Cursor_Input>>;
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
};


export type Subscription_RootFunzione_LogArgs = {
  distinct_on?: InputMaybe<Array<Funzione_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funzione_Log_Order_By>>;
  where?: InputMaybe<Funzione_Log_Bool_Exp>;
};


export type Subscription_RootFunzione_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funzione_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Funzione_Log_Order_By>>;
  where?: InputMaybe<Funzione_Log_Bool_Exp>;
};


export type Subscription_RootFunzione_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFunzione_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Funzione_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Funzione_Log_Bool_Exp>;
};


export type Subscription_RootIncentivi__Stato_CalcoloArgs = {
  distinct_on?: InputMaybe<Array<Incentivi__Stato_Calcolo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi__Stato_Calcolo_Order_By>>;
  where?: InputMaybe<Incentivi__Stato_Calcolo_Bool_Exp>;
};


export type Subscription_RootIncentivi__Stato_Calcolo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi__Stato_Calcolo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi__Stato_Calcolo_Order_By>>;
  where?: InputMaybe<Incentivi__Stato_Calcolo_Bool_Exp>;
};


export type Subscription_RootIncentivi__Stato_Calcolo_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_RootIncentivi__Stato_Calcolo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incentivi__Stato_Calcolo_Stream_Cursor_Input>>;
  where?: InputMaybe<Incentivi__Stato_Calcolo_Bool_Exp>;
};


export type Subscription_RootIncentivi_CalcolatiArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Calcolati_Order_By>>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};


export type Subscription_RootIncentivi_Calcolati_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Calcolati_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Calcolati_Order_By>>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};


export type Subscription_RootIncentivi_Calcolati_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIncentivi_Calcolati_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incentivi_Calcolati_Stream_Cursor_Input>>;
  where?: InputMaybe<Incentivi_Calcolati_Bool_Exp>;
};


export type Subscription_RootIncentivi_Log_RipartizioneArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Log_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Log_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Log_Ripartizione_Bool_Exp>;
};


export type Subscription_RootIncentivi_Log_Ripartizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Log_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Log_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Log_Ripartizione_Bool_Exp>;
};


export type Subscription_RootIncentivi_Log_Ripartizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIncentivi_Log_Ripartizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incentivi_Log_Ripartizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Incentivi_Log_Ripartizione_Bool_Exp>;
};


export type Subscription_RootIncentivi_RipartizioneArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
};


export type Subscription_RootIncentivi_Ripartizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incentivi_Ripartizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incentivi_Ripartizione_Order_By>>;
  where?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
};


export type Subscription_RootIncentivi_Ripartizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIncentivi_Ripartizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incentivi_Ripartizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Incentivi_Ripartizione_Bool_Exp>;
};


export type Subscription_RootIndirizzoArgs = {
  distinct_on?: InputMaybe<Array<Indirizzo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indirizzo_Order_By>>;
  where?: InputMaybe<Indirizzo_Bool_Exp>;
};


export type Subscription_RootIndirizzo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indirizzo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indirizzo_Order_By>>;
  where?: InputMaybe<Indirizzo_Bool_Exp>;
};


export type Subscription_RootIndirizzo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIndirizzo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indirizzo_Stream_Cursor_Input>>;
  where?: InputMaybe<Indirizzo_Bool_Exp>;
};


export type Subscription_RootInseritoreArgs = {
  distinct_on?: InputMaybe<Array<Inseritore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inseritore_Order_By>>;
  where?: InputMaybe<Inseritore_Bool_Exp>;
};


export type Subscription_RootInseritore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inseritore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Inseritore_Order_By>>;
  where?: InputMaybe<Inseritore_Bool_Exp>;
};


export type Subscription_RootInseritore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInseritore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Inseritore_Stream_Cursor_Input>>;
  where?: InputMaybe<Inseritore_Bool_Exp>;
};


export type Subscription_RootInstallatoreArgs = {
  distinct_on?: InputMaybe<Array<Installatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installatore_Order_By>>;
  where?: InputMaybe<Installatore_Bool_Exp>;
};


export type Subscription_RootInstallatore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Installatore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Installatore_Order_By>>;
  where?: InputMaybe<Installatore_Bool_Exp>;
};


export type Subscription_RootInstallatore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInstallatore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Installatore_Stream_Cursor_Input>>;
  where?: InputMaybe<Installatore_Bool_Exp>;
};


export type Subscription_RootLog_Errori_FunzioniArgs = {
  distinct_on?: InputMaybe<Array<Log_Errori_Funzioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Log_Errori_Funzioni_Order_By>>;
  where?: InputMaybe<Log_Errori_Funzioni_Bool_Exp>;
};


export type Subscription_RootLog_Errori_Funzioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Log_Errori_Funzioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Log_Errori_Funzioni_Order_By>>;
  where?: InputMaybe<Log_Errori_Funzioni_Bool_Exp>;
};


export type Subscription_RootLog_Errori_Funzioni_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLog_Errori_Funzioni_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Log_Errori_Funzioni_Stream_Cursor_Input>>;
  where?: InputMaybe<Log_Errori_Funzioni_Bool_Exp>;
};


export type Subscription_RootPersonaArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};


export type Subscription_RootPersona_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Order_By>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};


export type Subscription_RootPersona_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPersona_ContattoArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


export type Subscription_RootPersona_Contatto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Contatto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Persona_Contatto_Order_By>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


export type Subscription_RootPersona_Contatto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPersona_Contatto_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Persona_Contatto_Stream_Cursor_Input>>;
  where?: InputMaybe<Persona_Contatto_Bool_Exp>;
};


export type Subscription_RootPersona_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Persona_Stream_Cursor_Input>>;
  where?: InputMaybe<Persona_Bool_Exp>;
};


export type Subscription_RootPnrr_DocumentiArgs = {
  distinct_on?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pnrr_Documenti_Order_By>>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};


export type Subscription_RootPnrr_Documenti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pnrr_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pnrr_Documenti_Order_By>>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};


export type Subscription_RootPnrr_Documenti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPnrr_Documenti_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pnrr_Documenti_Stream_Cursor_Input>>;
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
};


export type Subscription_RootPresetArgs = {
  distinct_on?: InputMaybe<Array<Preset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Preset_Order_By>>;
  where?: InputMaybe<Preset_Bool_Exp>;
};


export type Subscription_RootPreset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Preset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Preset_Order_By>>;
  where?: InputMaybe<Preset_Bool_Exp>;
};


export type Subscription_RootPreset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPreset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Preset_Stream_Cursor_Input>>;
  where?: InputMaybe<Preset_Bool_Exp>;
};


export type Subscription_RootProfiloArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


export type Subscription_RootProfilo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profilo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Profilo_Order_By>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


export type Subscription_RootProfilo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProfilo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Profilo_Stream_Cursor_Input>>;
  where?: InputMaybe<Profilo_Bool_Exp>;
};


export type Subscription_RootSearch_AssetArgs = {
  args?: InputMaybe<Search_Asset_Args>;
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Subscription_RootSearch_Asset_AggregateArgs = {
  args?: InputMaybe<Search_Asset_Args>;
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By>>;
  where?: InputMaybe<Asset_Bool_Exp>;
};


export type Subscription_RootSearch_CerArgs = {
  args?: InputMaybe<Search_Cer_Args>;
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Subscription_RootSearch_Cer_AggregateArgs = {
  args?: InputMaybe<Search_Cer_Args>;
  distinct_on?: InputMaybe<Array<Cer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By>>;
  where?: InputMaybe<Cer_Bool_Exp>;
};


export type Subscription_RootSearch_SottoscrizioniArgs = {
  args?: InputMaybe<Search_Sottoscrizioni_Args>;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootSearch_Sottoscrizioni_AggregateArgs = {
  args?: InputMaybe<Search_Sottoscrizioni_Args>;
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootSearch_User_EntityArgs = {
  args?: InputMaybe<Search_User_Entity_Args>;
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Subscription_RootSearch_User_Entity_AggregateArgs = {
  args?: InputMaybe<Search_User_Entity_Args>;
  distinct_on?: InputMaybe<Array<Auth_User_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By>>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
};


export type Subscription_RootSottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSottoscrizione_DocumentiArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Documenti_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Documenti_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Documenti_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Documenti_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Documenti_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSottoscrizione_Documenti_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sottoscrizione_Documenti_Stream_Cursor_Input>>;
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_DomandeArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Domande_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Domande_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Domande_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Domande_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Domande_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSottoscrizione_Domande_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sottoscrizione_Domande_Stream_Cursor_Input>>;
  where?: InputMaybe<Sottoscrizione_Domande_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_IniziativaArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Iniziativa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Iniziativa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Iniziativa_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Iniziativa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSottoscrizione_Iniziativa_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sottoscrizione_Iniziativa_Stream_Cursor_Input>>;
  where?: InputMaybe<Sottoscrizione_Iniziativa_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_ZipArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Zip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Zip_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Zip_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sottoscrizione_Zip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Zip_Order_By>>;
  where?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
};


export type Subscription_RootSottoscrizione_Zip_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSottoscrizione_Zip_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sottoscrizione_Zip_Stream_Cursor_Input>>;
  where?: InputMaybe<Sottoscrizione_Zip_Bool_Exp>;
};


export type Subscription_RootStaging__Stato_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging__Stato_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging__Stato_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging__Stato_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging__Stato_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging__Stato_Sottoscrizione_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStaging__Stato_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging__Stato_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging__Stato_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Azione_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Azione_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Azione_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Azione_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStaging_Azione_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Azione_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Azione_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Gestore_LottoArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};


export type Subscription_RootStaging_Gestore_Lotto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};


export type Subscription_RootStaging_Gestore_Lotto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStaging_Gestore_Lotto_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Gestore_Lotto_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Gestore_Lotto_Bool_Exp>;
};


export type Subscription_RootStaging_Gestore_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Gestore_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Gestore_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Gestore_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStaging_Gestore_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Gestore_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Gestore_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_LogArgs = {
  distinct_on?: InputMaybe<Array<Staging_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Log_Order_By>>;
  where?: InputMaybe<Staging_Log_Bool_Exp>;
};


export type Subscription_RootStaging_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Log_Order_By>>;
  where?: InputMaybe<Staging_Log_Bool_Exp>;
};


export type Subscription_RootStaging_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStaging_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Log_Bool_Exp>;
};


export type Subscription_RootStaging_LottoArgs = {
  distinct_on?: InputMaybe<Array<Staging_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
};


export type Subscription_RootStaging_Lotto_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Lotto_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Lotto_Order_By>>;
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
};


export type Subscription_RootStaging_Lotto_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStaging_Lotto_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Lotto_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
};


export type Subscription_RootStaging_Mv_Refresh_StateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Mv_Refresh_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Mv_Refresh_State_Order_By>>;
  where?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
};


export type Subscription_RootStaging_Mv_Refresh_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Mv_Refresh_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Mv_Refresh_State_Order_By>>;
  where?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
};


export type Subscription_RootStaging_Mv_Refresh_State_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootStaging_Mv_Refresh_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Mv_Refresh_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Mv_Refresh_State_Bool_Exp>;
};


export type Subscription_RootStaging_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStaging_Sottoscrizione_List_MvArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_Mv_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_List_Mv_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_Mv_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_Mv_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_List_Mv_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Sottoscrizione_List_Mv_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_Mv_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_List_VArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_V_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_List_V_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Staging_Sottoscrizione_List_V_Order_By>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_V_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_List_V_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Sottoscrizione_List_V_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Sottoscrizione_List_V_Bool_Exp>;
};


export type Subscription_RootStaging_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Staging_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Staging_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStorage_Trigger_Debug_LogArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Debug_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Debug_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Debug_Log_Bool_Exp>;
};


export type Subscription_RootStorage_Trigger_Debug_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Debug_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Debug_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Debug_Log_Bool_Exp>;
};


export type Subscription_RootStorage_Trigger_Debug_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootStorage_Trigger_Debug_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Storage_Trigger_Debug_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Trigger_Debug_Log_Bool_Exp>;
};


export type Subscription_RootStorage_Trigger_Error_LogArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Error_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Error_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Error_Log_Bool_Exp>;
};


export type Subscription_RootStorage_Trigger_Error_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Trigger_Error_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Trigger_Error_Log_Order_By>>;
  where?: InputMaybe<Storage_Trigger_Error_Log_Bool_Exp>;
};


export type Subscription_RootStorage_Trigger_Error_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootStorage_Trigger_Error_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Storage_Trigger_Error_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Trigger_Error_Log_Bool_Exp>;
};


export type Subscription_RootStorico_SottoscrizioneArgs = {
  distinct_on?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStorico_Sottoscrizione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storico_Sottoscrizione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storico_Sottoscrizione_Order_By>>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootStorico_Sottoscrizione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStorico_Sottoscrizione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Storico_Sottoscrizione_Stream_Cursor_Input>>;
  where?: InputMaybe<Storico_Sottoscrizione_Bool_Exp>;
};


export type Subscription_RootTranslate_MapperArgs = {
  distinct_on?: InputMaybe<Array<Translate_Mapper_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translate_Mapper_Order_By>>;
  where?: InputMaybe<Translate_Mapper_Bool_Exp>;
};


export type Subscription_RootTranslate_Mapper_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Translate_Mapper_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translate_Mapper_Order_By>>;
  where?: InputMaybe<Translate_Mapper_Bool_Exp>;
};


export type Subscription_RootTranslate_Mapper_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTranslate_Mapper_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Translate_Mapper_Stream_Cursor_Input>>;
  where?: InputMaybe<Translate_Mapper_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_CittaArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Citta_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Citta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Citta_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Citta_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUnita_Amministrativa_Citta_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unita_Amministrativa_Citta_Stream_Cursor_Input>>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_NazioneArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Nazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Nazione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Nazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Nazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Nazione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Nazione_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUnita_Amministrativa_Nazione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unita_Amministrativa_Nazione_Stream_Cursor_Input>>;
  where?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_ProvinciaArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Provincia_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Provincia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Provincia_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Provincia_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUnita_Amministrativa_Provincia_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unita_Amministrativa_Provincia_Stream_Cursor_Input>>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_RegioneArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Regione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Regione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Regione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Regione_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
};


export type Subscription_RootUnita_Amministrativa_Regione_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUnita_Amministrativa_Regione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unita_Amministrativa_Regione_Stream_Cursor_Input>>;
  where?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
};


export type Subscription_RootV_Superadmin_SottoscrizioniArgs = {
  distinct_on?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Order_By>>;
  where?: InputMaybe<V_Superadmin_Sottoscrizioni_Bool_Exp>;
};


export type Subscription_RootV_Superadmin_Sottoscrizioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Order_By>>;
  where?: InputMaybe<V_Superadmin_Sottoscrizioni_Bool_Exp>;
};


export type Subscription_RootV_Superadmin_Sottoscrizioni_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<V_Superadmin_Sottoscrizioni_Stream_Cursor_Input>>;
  where?: InputMaybe<V_Superadmin_Sottoscrizioni_Bool_Exp>;
};


export type Subscription_RootVirusArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By>>;
  where?: InputMaybe<Virus_Bool_Exp>;
};


export type Subscription_RootWhite_Label_AssociazioneArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Associazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Associazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhite_Label_Associazione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<White_Label_Associazione_Stream_Cursor_Input>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


export type Subscription_RootWhite_Label_ConfigurazioneArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Configurazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Configurazione_Order_By>>;
  where?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Configurazione_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Configurazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Configurazione_Order_By>>;
  where?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Configurazione_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhite_Label_Configurazione_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<White_Label_Configurazione_Stream_Cursor_Input>>;
  where?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
};


export type Subscription_RootWhite_Label_GestoreArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Gestore_Order_By>>;
  where?: InputMaybe<White_Label_Gestore_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Gestore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Gestore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Gestore_Order_By>>;
  where?: InputMaybe<White_Label_Gestore_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Gestore_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhite_Label_Gestore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<White_Label_Gestore_Stream_Cursor_Input>>;
  where?: InputMaybe<White_Label_Gestore_Bool_Exp>;
};


export type Subscription_RootWhite_Label_IdpArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Idp_Order_By>>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Idp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Idp_Order_By>>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};


export type Subscription_RootWhite_Label_Idp_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWhite_Label_Idp_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<White_Label_Idp_Stream_Cursor_Input>>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};

export type Superadmin_Elimina_Sottoscrizione_Args = {
  p_sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "translate.mapper" */
export type Translate_Mapper = {
  __typename?: 'translate_mapper';
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  table: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "translate.mapper" */
export type Translate_Mapper_Aggregate = {
  __typename?: 'translate_mapper_aggregate';
  aggregate?: Maybe<Translate_Mapper_Aggregate_Fields>;
  nodes: Array<Translate_Mapper>;
};

/** aggregate fields of "translate.mapper" */
export type Translate_Mapper_Aggregate_Fields = {
  __typename?: 'translate_mapper_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Translate_Mapper_Max_Fields>;
  min?: Maybe<Translate_Mapper_Min_Fields>;
};


/** aggregate fields of "translate.mapper" */
export type Translate_Mapper_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Translate_Mapper_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "translate.mapper". All fields are combined with a logical 'AND'. */
export type Translate_Mapper_Bool_Exp = {
  _and?: InputMaybe<Array<Translate_Mapper_Bool_Exp>>;
  _not?: InputMaybe<Translate_Mapper_Bool_Exp>;
  _or?: InputMaybe<Array<Translate_Mapper_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  lang?: InputMaybe<String_Comparison_Exp>;
  table?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "translate.mapper" */
export enum Translate_Mapper_Constraint {
  /** unique or primary key constraint on columns "key", "table" */
  MapperKeyTableKey = 'mapper_key_table_key',
  /** unique or primary key constraint on columns "id" */
  MapperPkey = 'mapper_pkey'
}

/** input type for inserting data into table "translate.mapper" */
export type Translate_Mapper_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Translate_Mapper_Max_Fields = {
  __typename?: 'translate_mapper_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Translate_Mapper_Min_Fields = {
  __typename?: 'translate_mapper_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "translate.mapper" */
export type Translate_Mapper_Mutation_Response = {
  __typename?: 'translate_mapper_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Translate_Mapper>;
};

/** on_conflict condition type for table "translate.mapper" */
export type Translate_Mapper_On_Conflict = {
  constraint: Translate_Mapper_Constraint;
  update_columns?: Array<Translate_Mapper_Update_Column>;
  where?: InputMaybe<Translate_Mapper_Bool_Exp>;
};

/** Ordering options when selecting data from "translate.mapper". */
export type Translate_Mapper_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  lang?: InputMaybe<Order_By>;
  table?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: translate.mapper */
export type Translate_Mapper_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "translate.mapper" */
export enum Translate_Mapper_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Lang = 'lang',
  /** column name */
  Table = 'table',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "translate.mapper" */
export type Translate_Mapper_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "translate_mapper" */
export type Translate_Mapper_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Translate_Mapper_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Translate_Mapper_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "translate.mapper" */
export enum Translate_Mapper_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Lang = 'lang',
  /** column name */
  Table = 'table',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Translate_Mapper_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Translate_Mapper_Set_Input>;
  /** filter the rows which have to be updated */
  where: Translate_Mapper_Bool_Exp;
};

/** columns and relationships of "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta = {
  __typename?: 'unita_amministrativa_citta';
  abitanti?: Maybe<Scalars['numeric']['output']>;
  codice_belfiore?: Maybe<Scalars['String']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "unita_amministrativa.denominazione_citta" */
  denominazione_completa?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  provincia?: Maybe<Unita_Amministrativa_Provincia>;
  provincia_id?: Maybe<Scalars['bigint']['output']>;
  soppresso: Scalars['Boolean']['output'];
};

/** aggregated selection of "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Aggregate = {
  __typename?: 'unita_amministrativa_citta_aggregate';
  aggregate?: Maybe<Unita_Amministrativa_Citta_Aggregate_Fields>;
  nodes: Array<Unita_Amministrativa_Citta>;
};

export type Unita_Amministrativa_Citta_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Count>;
};

export type Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_And = {
  arguments: Unita_Amministrativa_Citta_Select_Column_Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Unita_Amministrativa_Citta_Select_Column_Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Aggregate_Fields = {
  __typename?: 'unita_amministrativa_citta_aggregate_fields';
  avg?: Maybe<Unita_Amministrativa_Citta_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Unita_Amministrativa_Citta_Max_Fields>;
  min?: Maybe<Unita_Amministrativa_Citta_Min_Fields>;
  stddev?: Maybe<Unita_Amministrativa_Citta_Stddev_Fields>;
  stddev_pop?: Maybe<Unita_Amministrativa_Citta_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unita_Amministrativa_Citta_Stddev_Samp_Fields>;
  sum?: Maybe<Unita_Amministrativa_Citta_Sum_Fields>;
  var_pop?: Maybe<Unita_Amministrativa_Citta_Var_Pop_Fields>;
  var_samp?: Maybe<Unita_Amministrativa_Citta_Var_Samp_Fields>;
  variance?: Maybe<Unita_Amministrativa_Citta_Variance_Fields>;
};


/** aggregate fields of "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Aggregate_Order_By = {
  avg?: InputMaybe<Unita_Amministrativa_Citta_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unita_Amministrativa_Citta_Max_Order_By>;
  min?: InputMaybe<Unita_Amministrativa_Citta_Min_Order_By>;
  stddev?: InputMaybe<Unita_Amministrativa_Citta_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unita_Amministrativa_Citta_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unita_Amministrativa_Citta_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unita_Amministrativa_Citta_Sum_Order_By>;
  var_pop?: InputMaybe<Unita_Amministrativa_Citta_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unita_Amministrativa_Citta_Var_Samp_Order_By>;
  variance?: InputMaybe<Unita_Amministrativa_Citta_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Arr_Rel_Insert_Input = {
  data: Array<Unita_Amministrativa_Citta_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unita_Amministrativa_Citta_On_Conflict>;
};

/** aggregate avg on columns */
export type Unita_Amministrativa_Citta_Avg_Fields = {
  __typename?: 'unita_amministrativa_citta_avg_fields';
  abitanti?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  provincia_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Avg_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unita_amministrativa.citta". All fields are combined with a logical 'AND'. */
export type Unita_Amministrativa_Citta_Bool_Exp = {
  _and?: InputMaybe<Array<Unita_Amministrativa_Citta_Bool_Exp>>;
  _not?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  _or?: InputMaybe<Array<Unita_Amministrativa_Citta_Bool_Exp>>;
  abitanti?: InputMaybe<Numeric_Comparison_Exp>;
  codice_belfiore?: InputMaybe<String_Comparison_Exp>;
  denominazione?: InputMaybe<String_Comparison_Exp>;
  denominazione_completa?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
  provincia_id?: InputMaybe<Bigint_Comparison_Exp>;
  soppresso?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "unita_amministrativa.citta" */
export enum Unita_Amministrativa_Citta_Constraint {
  /** unique or primary key constraint on columns "id" */
  CittaPkey = 'citta_pkey'
}

/** input type for incrementing numeric columns in table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Inc_Input = {
  abitanti?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Insert_Input = {
  abitanti?: InputMaybe<Scalars['numeric']['input']>;
  codice_belfiore?: InputMaybe<Scalars['String']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Obj_Rel_Insert_Input>;
  provincia_id?: InputMaybe<Scalars['bigint']['input']>;
  soppresso?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Unita_Amministrativa_Citta_Max_Fields = {
  __typename?: 'unita_amministrativa_citta_max_fields';
  abitanti?: Maybe<Scalars['numeric']['output']>;
  codice_belfiore?: Maybe<Scalars['String']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "unita_amministrativa.denominazione_citta" */
  denominazione_completa?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  provincia_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Max_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  codice_belfiore?: InputMaybe<Order_By>;
  denominazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unita_Amministrativa_Citta_Min_Fields = {
  __typename?: 'unita_amministrativa_citta_min_fields';
  abitanti?: Maybe<Scalars['numeric']['output']>;
  codice_belfiore?: Maybe<Scalars['String']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "unita_amministrativa.denominazione_citta" */
  denominazione_completa?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  provincia_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Min_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  codice_belfiore?: InputMaybe<Order_By>;
  denominazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Mutation_Response = {
  __typename?: 'unita_amministrativa_citta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unita_Amministrativa_Citta>;
};

/** input type for inserting object relation for remote table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Obj_Rel_Insert_Input = {
  data: Unita_Amministrativa_Citta_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unita_Amministrativa_Citta_On_Conflict>;
};

/** on_conflict condition type for table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_On_Conflict = {
  constraint: Unita_Amministrativa_Citta_Constraint;
  update_columns?: Array<Unita_Amministrativa_Citta_Update_Column>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};

/** Ordering options when selecting data from "unita_amministrativa.citta". */
export type Unita_Amministrativa_Citta_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  codice_belfiore?: InputMaybe<Order_By>;
  denominazione?: InputMaybe<Order_By>;
  denominazione_completa?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Order_By>;
  provincia_id?: InputMaybe<Order_By>;
  soppresso?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unita_amministrativa.citta */
export type Unita_Amministrativa_Citta_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "unita_amministrativa.citta" */
export enum Unita_Amministrativa_Citta_Select_Column {
  /** column name */
  Abitanti = 'abitanti',
  /** column name */
  CodiceBelfiore = 'codice_belfiore',
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  ProvinciaId = 'provincia_id',
  /** column name */
  Soppresso = 'soppresso'
}

/** select "unita_amministrativa_citta_aggregate_bool_exp_bool_and_arguments_columns" columns of table "unita_amministrativa.citta" */
export enum Unita_Amministrativa_Citta_Select_Column_Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Soppresso = 'soppresso'
}

/** select "unita_amministrativa_citta_aggregate_bool_exp_bool_or_arguments_columns" columns of table "unita_amministrativa.citta" */
export enum Unita_Amministrativa_Citta_Select_Column_Unita_Amministrativa_Citta_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Soppresso = 'soppresso'
}

/** input type for updating data in table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Set_Input = {
  abitanti?: InputMaybe<Scalars['numeric']['input']>;
  codice_belfiore?: InputMaybe<Scalars['String']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia_id?: InputMaybe<Scalars['bigint']['input']>;
  soppresso?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Unita_Amministrativa_Citta_Stddev_Fields = {
  __typename?: 'unita_amministrativa_citta_stddev_fields';
  abitanti?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  provincia_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Stddev_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unita_Amministrativa_Citta_Stddev_Pop_Fields = {
  __typename?: 'unita_amministrativa_citta_stddev_pop_fields';
  abitanti?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  provincia_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Stddev_Pop_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unita_Amministrativa_Citta_Stddev_Samp_Fields = {
  __typename?: 'unita_amministrativa_citta_stddev_samp_fields';
  abitanti?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  provincia_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Stddev_Samp_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unita_amministrativa_citta" */
export type Unita_Amministrativa_Citta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unita_Amministrativa_Citta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unita_Amministrativa_Citta_Stream_Cursor_Value_Input = {
  abitanti?: InputMaybe<Scalars['numeric']['input']>;
  codice_belfiore?: InputMaybe<Scalars['String']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia_id?: InputMaybe<Scalars['bigint']['input']>;
  soppresso?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Unita_Amministrativa_Citta_Sum_Fields = {
  __typename?: 'unita_amministrativa_citta_sum_fields';
  abitanti?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  provincia_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Sum_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** update columns of table "unita_amministrativa.citta" */
export enum Unita_Amministrativa_Citta_Update_Column {
  /** column name */
  Abitanti = 'abitanti',
  /** column name */
  CodiceBelfiore = 'codice_belfiore',
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  ProvinciaId = 'provincia_id',
  /** column name */
  Soppresso = 'soppresso'
}

export type Unita_Amministrativa_Citta_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unita_Amministrativa_Citta_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unita_Amministrativa_Citta_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unita_Amministrativa_Citta_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unita_Amministrativa_Citta_Var_Pop_Fields = {
  __typename?: 'unita_amministrativa_citta_var_pop_fields';
  abitanti?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  provincia_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Var_Pop_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unita_Amministrativa_Citta_Var_Samp_Fields = {
  __typename?: 'unita_amministrativa_citta_var_samp_fields';
  abitanti?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  provincia_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Var_Samp_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unita_Amministrativa_Citta_Variance_Fields = {
  __typename?: 'unita_amministrativa_citta_variance_fields';
  abitanti?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  provincia_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "unita_amministrativa.citta" */
export type Unita_Amministrativa_Citta_Variance_Order_By = {
  abitanti?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione = {
  __typename?: 'unita_amministrativa_nazione';
  codice_belfiore?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  order: Scalars['numeric']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Aggregate = {
  __typename?: 'unita_amministrativa_nazione_aggregate';
  aggregate?: Maybe<Unita_Amministrativa_Nazione_Aggregate_Fields>;
  nodes: Array<Unita_Amministrativa_Nazione>;
};

/** aggregate fields of "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Aggregate_Fields = {
  __typename?: 'unita_amministrativa_nazione_aggregate_fields';
  avg?: Maybe<Unita_Amministrativa_Nazione_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Unita_Amministrativa_Nazione_Max_Fields>;
  min?: Maybe<Unita_Amministrativa_Nazione_Min_Fields>;
  stddev?: Maybe<Unita_Amministrativa_Nazione_Stddev_Fields>;
  stddev_pop?: Maybe<Unita_Amministrativa_Nazione_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unita_Amministrativa_Nazione_Stddev_Samp_Fields>;
  sum?: Maybe<Unita_Amministrativa_Nazione_Sum_Fields>;
  var_pop?: Maybe<Unita_Amministrativa_Nazione_Var_Pop_Fields>;
  var_samp?: Maybe<Unita_Amministrativa_Nazione_Var_Samp_Fields>;
  variance?: Maybe<Unita_Amministrativa_Nazione_Variance_Fields>;
};


/** aggregate fields of "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unita_Amministrativa_Nazione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Unita_Amministrativa_Nazione_Avg_Fields = {
  __typename?: 'unita_amministrativa_nazione_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "unita_amministrativa.nazione". All fields are combined with a logical 'AND'. */
export type Unita_Amministrativa_Nazione_Bool_Exp = {
  _and?: InputMaybe<Array<Unita_Amministrativa_Nazione_Bool_Exp>>;
  _not?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
  _or?: InputMaybe<Array<Unita_Amministrativa_Nazione_Bool_Exp>>;
  codice_belfiore?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  denominazione?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "unita_amministrativa.nazione" */
export enum Unita_Amministrativa_Nazione_Constraint {
  /** unique or primary key constraint on columns "id" */
  NazionePkey = 'nazione_pkey'
}

/** input type for incrementing numeric columns in table "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Insert_Input = {
  codice_belfiore?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Unita_Amministrativa_Nazione_Max_Fields = {
  __typename?: 'unita_amministrativa_nazione_max_fields';
  codice_belfiore?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Unita_Amministrativa_Nazione_Min_Fields = {
  __typename?: 'unita_amministrativa_nazione_min_fields';
  codice_belfiore?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Mutation_Response = {
  __typename?: 'unita_amministrativa_nazione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unita_Amministrativa_Nazione>;
};

/** input type for inserting object relation for remote table "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Obj_Rel_Insert_Input = {
  data: Unita_Amministrativa_Nazione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unita_Amministrativa_Nazione_On_Conflict>;
};

/** on_conflict condition type for table "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_On_Conflict = {
  constraint: Unita_Amministrativa_Nazione_Constraint;
  update_columns?: Array<Unita_Amministrativa_Nazione_Update_Column>;
  where?: InputMaybe<Unita_Amministrativa_Nazione_Bool_Exp>;
};

/** Ordering options when selecting data from "unita_amministrativa.nazione". */
export type Unita_Amministrativa_Nazione_Order_By = {
  codice_belfiore?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  denominazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unita_amministrativa.nazione */
export type Unita_Amministrativa_Nazione_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "unita_amministrativa.nazione" */
export enum Unita_Amministrativa_Nazione_Select_Column {
  /** column name */
  CodiceBelfiore = 'codice_belfiore',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "unita_amministrativa.nazione" */
export type Unita_Amministrativa_Nazione_Set_Input = {
  codice_belfiore?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Unita_Amministrativa_Nazione_Stddev_Fields = {
  __typename?: 'unita_amministrativa_nazione_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Unita_Amministrativa_Nazione_Stddev_Pop_Fields = {
  __typename?: 'unita_amministrativa_nazione_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Unita_Amministrativa_Nazione_Stddev_Samp_Fields = {
  __typename?: 'unita_amministrativa_nazione_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "unita_amministrativa_nazione" */
export type Unita_Amministrativa_Nazione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unita_Amministrativa_Nazione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unita_Amministrativa_Nazione_Stream_Cursor_Value_Input = {
  codice_belfiore?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Unita_Amministrativa_Nazione_Sum_Fields = {
  __typename?: 'unita_amministrativa_nazione_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "unita_amministrativa.nazione" */
export enum Unita_Amministrativa_Nazione_Update_Column {
  /** column name */
  CodiceBelfiore = 'codice_belfiore',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Unita_Amministrativa_Nazione_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unita_Amministrativa_Nazione_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unita_Amministrativa_Nazione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unita_Amministrativa_Nazione_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unita_Amministrativa_Nazione_Var_Pop_Fields = {
  __typename?: 'unita_amministrativa_nazione_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Unita_Amministrativa_Nazione_Var_Samp_Fields = {
  __typename?: 'unita_amministrativa_nazione_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Unita_Amministrativa_Nazione_Variance_Fields = {
  __typename?: 'unita_amministrativa_nazione_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia = {
  __typename?: 'unita_amministrativa_provincia';
  area: Scalars['String']['output'];
  /** An array relationship */
  citta: Array<Unita_Amministrativa_Citta>;
  /** An aggregate relationship */
  citta_aggregate: Unita_Amministrativa_Citta_Aggregate;
  denominazione?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['bigint']['output'];
  point?: Maybe<Scalars['geometry']['output']>;
  /** An object relationship */
  regione?: Maybe<Unita_Amministrativa_Regione>;
  regione_id?: Maybe<Scalars['bigint']['output']>;
  sigla?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "unita_amministrativa.provincia" */
export type Unita_Amministrativa_ProvinciaCittaArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Citta_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};


/** columns and relationships of "unita_amministrativa.provincia" */
export type Unita_Amministrativa_ProvinciaCitta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Citta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Citta_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
};

/** aggregated selection of "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Aggregate = {
  __typename?: 'unita_amministrativa_provincia_aggregate';
  aggregate?: Maybe<Unita_Amministrativa_Provincia_Aggregate_Fields>;
  nodes: Array<Unita_Amministrativa_Provincia>;
};

export type Unita_Amministrativa_Provincia_Aggregate_Bool_Exp = {
  count?: InputMaybe<Unita_Amministrativa_Provincia_Aggregate_Bool_Exp_Count>;
};

export type Unita_Amministrativa_Provincia_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Aggregate_Fields = {
  __typename?: 'unita_amministrativa_provincia_aggregate_fields';
  avg?: Maybe<Unita_Amministrativa_Provincia_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Unita_Amministrativa_Provincia_Max_Fields>;
  min?: Maybe<Unita_Amministrativa_Provincia_Min_Fields>;
  stddev?: Maybe<Unita_Amministrativa_Provincia_Stddev_Fields>;
  stddev_pop?: Maybe<Unita_Amministrativa_Provincia_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unita_Amministrativa_Provincia_Stddev_Samp_Fields>;
  sum?: Maybe<Unita_Amministrativa_Provincia_Sum_Fields>;
  var_pop?: Maybe<Unita_Amministrativa_Provincia_Var_Pop_Fields>;
  var_samp?: Maybe<Unita_Amministrativa_Provincia_Var_Samp_Fields>;
  variance?: Maybe<Unita_Amministrativa_Provincia_Variance_Fields>;
};


/** aggregate fields of "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Aggregate_Order_By = {
  avg?: InputMaybe<Unita_Amministrativa_Provincia_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unita_Amministrativa_Provincia_Max_Order_By>;
  min?: InputMaybe<Unita_Amministrativa_Provincia_Min_Order_By>;
  stddev?: InputMaybe<Unita_Amministrativa_Provincia_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unita_Amministrativa_Provincia_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unita_Amministrativa_Provincia_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unita_Amministrativa_Provincia_Sum_Order_By>;
  var_pop?: InputMaybe<Unita_Amministrativa_Provincia_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unita_Amministrativa_Provincia_Var_Samp_Order_By>;
  variance?: InputMaybe<Unita_Amministrativa_Provincia_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Arr_Rel_Insert_Input = {
  data: Array<Unita_Amministrativa_Provincia_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unita_Amministrativa_Provincia_On_Conflict>;
};

/** aggregate avg on columns */
export type Unita_Amministrativa_Provincia_Avg_Fields = {
  __typename?: 'unita_amministrativa_provincia_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  regione_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unita_amministrativa.provincia". All fields are combined with a logical 'AND'. */
export type Unita_Amministrativa_Provincia_Bool_Exp = {
  _and?: InputMaybe<Array<Unita_Amministrativa_Provincia_Bool_Exp>>;
  _not?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
  _or?: InputMaybe<Array<Unita_Amministrativa_Provincia_Bool_Exp>>;
  area?: InputMaybe<String_Comparison_Exp>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Bool_Exp>;
  citta_aggregate?: InputMaybe<Unita_Amministrativa_Citta_Aggregate_Bool_Exp>;
  denominazione?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  point?: InputMaybe<Geometry_Comparison_Exp>;
  regione?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
  regione_id?: InputMaybe<Bigint_Comparison_Exp>;
  sigla?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unita_amministrativa.provincia" */
export enum Unita_Amministrativa_Provincia_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvinciaPkey = 'provincia_pkey'
}

/** input type for incrementing numeric columns in table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  regione_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Insert_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  citta?: InputMaybe<Unita_Amministrativa_Citta_Arr_Rel_Insert_Input>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  point?: InputMaybe<Scalars['geometry']['input']>;
  regione?: InputMaybe<Unita_Amministrativa_Regione_Obj_Rel_Insert_Input>;
  regione_id?: InputMaybe<Scalars['bigint']['input']>;
  sigla?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Unita_Amministrativa_Provincia_Max_Fields = {
  __typename?: 'unita_amministrativa_provincia_max_fields';
  area?: Maybe<Scalars['String']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  regione_id?: Maybe<Scalars['bigint']['output']>;
  sigla?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  denominazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
  sigla?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unita_Amministrativa_Provincia_Min_Fields = {
  __typename?: 'unita_amministrativa_provincia_min_fields';
  area?: Maybe<Scalars['String']['output']>;
  denominazione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  regione_id?: Maybe<Scalars['bigint']['output']>;
  sigla?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  denominazione?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
  sigla?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Mutation_Response = {
  __typename?: 'unita_amministrativa_provincia_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unita_Amministrativa_Provincia>;
};

/** input type for inserting object relation for remote table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Obj_Rel_Insert_Input = {
  data: Unita_Amministrativa_Provincia_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unita_Amministrativa_Provincia_On_Conflict>;
};

/** on_conflict condition type for table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_On_Conflict = {
  constraint: Unita_Amministrativa_Provincia_Constraint;
  update_columns?: Array<Unita_Amministrativa_Provincia_Update_Column>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};

/** Ordering options when selecting data from "unita_amministrativa.provincia". */
export type Unita_Amministrativa_Provincia_Order_By = {
  area?: InputMaybe<Order_By>;
  citta_aggregate?: InputMaybe<Unita_Amministrativa_Citta_Aggregate_Order_By>;
  denominazione?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point?: InputMaybe<Order_By>;
  regione?: InputMaybe<Unita_Amministrativa_Regione_Order_By>;
  regione_id?: InputMaybe<Order_By>;
  sigla?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unita_amministrativa.provincia */
export type Unita_Amministrativa_Provincia_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "unita_amministrativa.provincia" */
export enum Unita_Amministrativa_Provincia_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Point = 'point',
  /** column name */
  RegioneId = 'regione_id',
  /** column name */
  Sigla = 'sigla'
}

/** input type for updating data in table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Set_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  point?: InputMaybe<Scalars['geometry']['input']>;
  regione_id?: InputMaybe<Scalars['bigint']['input']>;
  sigla?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Unita_Amministrativa_Provincia_Stddev_Fields = {
  __typename?: 'unita_amministrativa_provincia_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  regione_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unita_Amministrativa_Provincia_Stddev_Pop_Fields = {
  __typename?: 'unita_amministrativa_provincia_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  regione_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unita_Amministrativa_Provincia_Stddev_Samp_Fields = {
  __typename?: 'unita_amministrativa_provincia_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  regione_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unita_amministrativa_provincia" */
export type Unita_Amministrativa_Provincia_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unita_Amministrativa_Provincia_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unita_Amministrativa_Provincia_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  point?: InputMaybe<Scalars['geometry']['input']>;
  regione_id?: InputMaybe<Scalars['bigint']['input']>;
  sigla?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Unita_Amministrativa_Provincia_Sum_Fields = {
  __typename?: 'unita_amministrativa_provincia_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  regione_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** update columns of table "unita_amministrativa.provincia" */
export enum Unita_Amministrativa_Provincia_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Point = 'point',
  /** column name */
  RegioneId = 'regione_id',
  /** column name */
  Sigla = 'sigla'
}

export type Unita_Amministrativa_Provincia_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unita_Amministrativa_Provincia_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unita_Amministrativa_Provincia_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unita_Amministrativa_Provincia_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unita_Amministrativa_Provincia_Var_Pop_Fields = {
  __typename?: 'unita_amministrativa_provincia_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  regione_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unita_Amministrativa_Provincia_Var_Samp_Fields = {
  __typename?: 'unita_amministrativa_provincia_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  regione_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unita_Amministrativa_Provincia_Variance_Fields = {
  __typename?: 'unita_amministrativa_provincia_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  regione_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "unita_amministrativa.provincia" */
export type Unita_Amministrativa_Provincia_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  regione_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione = {
  __typename?: 'unita_amministrativa_regione';
  denominazione?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  provincia: Array<Unita_Amministrativa_Provincia>;
  /** An aggregate relationship */
  provincia_aggregate: Unita_Amministrativa_Provincia_Aggregate;
};


/** columns and relationships of "unita_amministrativa.regione" */
export type Unita_Amministrativa_RegioneProvinciaArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Provincia_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};


/** columns and relationships of "unita_amministrativa.regione" */
export type Unita_Amministrativa_RegioneProvincia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unita_Amministrativa_Provincia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unita_Amministrativa_Provincia_Order_By>>;
  where?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
};

/** aggregated selection of "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Aggregate = {
  __typename?: 'unita_amministrativa_regione_aggregate';
  aggregate?: Maybe<Unita_Amministrativa_Regione_Aggregate_Fields>;
  nodes: Array<Unita_Amministrativa_Regione>;
};

/** aggregate fields of "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Aggregate_Fields = {
  __typename?: 'unita_amministrativa_regione_aggregate_fields';
  avg?: Maybe<Unita_Amministrativa_Regione_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Unita_Amministrativa_Regione_Max_Fields>;
  min?: Maybe<Unita_Amministrativa_Regione_Min_Fields>;
  stddev?: Maybe<Unita_Amministrativa_Regione_Stddev_Fields>;
  stddev_pop?: Maybe<Unita_Amministrativa_Regione_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unita_Amministrativa_Regione_Stddev_Samp_Fields>;
  sum?: Maybe<Unita_Amministrativa_Regione_Sum_Fields>;
  var_pop?: Maybe<Unita_Amministrativa_Regione_Var_Pop_Fields>;
  var_samp?: Maybe<Unita_Amministrativa_Regione_Var_Samp_Fields>;
  variance?: Maybe<Unita_Amministrativa_Regione_Variance_Fields>;
};


/** aggregate fields of "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unita_Amministrativa_Regione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Unita_Amministrativa_Regione_Avg_Fields = {
  __typename?: 'unita_amministrativa_regione_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "unita_amministrativa.regione". All fields are combined with a logical 'AND'. */
export type Unita_Amministrativa_Regione_Bool_Exp = {
  _and?: InputMaybe<Array<Unita_Amministrativa_Regione_Bool_Exp>>;
  _not?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
  _or?: InputMaybe<Array<Unita_Amministrativa_Regione_Bool_Exp>>;
  denominazione?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Bool_Exp>;
  provincia_aggregate?: InputMaybe<Unita_Amministrativa_Provincia_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "unita_amministrativa.regione" */
export enum Unita_Amministrativa_Regione_Constraint {
  /** unique or primary key constraint on columns "id" */
  RegionePkey = 'regione_pkey'
}

/** input type for incrementing numeric columns in table "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Insert_Input = {
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  provincia?: InputMaybe<Unita_Amministrativa_Provincia_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Unita_Amministrativa_Regione_Max_Fields = {
  __typename?: 'unita_amministrativa_regione_max_fields';
  denominazione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Unita_Amministrativa_Regione_Min_Fields = {
  __typename?: 'unita_amministrativa_regione_min_fields';
  denominazione?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Mutation_Response = {
  __typename?: 'unita_amministrativa_regione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unita_Amministrativa_Regione>;
};

/** input type for inserting object relation for remote table "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Obj_Rel_Insert_Input = {
  data: Unita_Amministrativa_Regione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unita_Amministrativa_Regione_On_Conflict>;
};

/** on_conflict condition type for table "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_On_Conflict = {
  constraint: Unita_Amministrativa_Regione_Constraint;
  update_columns?: Array<Unita_Amministrativa_Regione_Update_Column>;
  where?: InputMaybe<Unita_Amministrativa_Regione_Bool_Exp>;
};

/** Ordering options when selecting data from "unita_amministrativa.regione". */
export type Unita_Amministrativa_Regione_Order_By = {
  denominazione?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provincia_aggregate?: InputMaybe<Unita_Amministrativa_Provincia_Aggregate_Order_By>;
};

/** primary key columns input for table: unita_amministrativa.regione */
export type Unita_Amministrativa_Regione_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "unita_amministrativa.regione" */
export enum Unita_Amministrativa_Regione_Select_Column {
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "unita_amministrativa.regione" */
export type Unita_Amministrativa_Regione_Set_Input = {
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Unita_Amministrativa_Regione_Stddev_Fields = {
  __typename?: 'unita_amministrativa_regione_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Unita_Amministrativa_Regione_Stddev_Pop_Fields = {
  __typename?: 'unita_amministrativa_regione_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Unita_Amministrativa_Regione_Stddev_Samp_Fields = {
  __typename?: 'unita_amministrativa_regione_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "unita_amministrativa_regione" */
export type Unita_Amministrativa_Regione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unita_Amministrativa_Regione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unita_Amministrativa_Regione_Stream_Cursor_Value_Input = {
  denominazione?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Unita_Amministrativa_Regione_Sum_Fields = {
  __typename?: 'unita_amministrativa_regione_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "unita_amministrativa.regione" */
export enum Unita_Amministrativa_Regione_Update_Column {
  /** column name */
  Denominazione = 'denominazione',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

export type Unita_Amministrativa_Regione_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unita_Amministrativa_Regione_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unita_Amministrativa_Regione_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unita_Amministrativa_Regione_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unita_Amministrativa_Regione_Var_Pop_Fields = {
  __typename?: 'unita_amministrativa_regione_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Unita_Amministrativa_Regione_Var_Samp_Fields = {
  __typename?: 'unita_amministrativa_regione_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Unita_Amministrativa_Regione_Variance_Fields = {
  __typename?: 'unita_amministrativa_regione_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "v_superadmin_sottoscrizioni" */
export type V_Superadmin_Sottoscrizioni = {
  __typename?: 'v_superadmin_sottoscrizioni';
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  cabina_cod_ac?: Maybe<Scalars['String']['output']>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  codice_promotore?: Maybe<Scalars['String']['output']>;
  codici_amico_gestore?: Maybe<Array<Scalars['String']['output']>>;
  codici_amico_gestore_txt?: Maybe<Scalars['String']['output']>;
  condivisione_account_email?: Maybe<Scalars['String']['output']>;
  condivisione_account_nome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gestore_first_name?: Maybe<Scalars['String']['output']>;
  gestore_last_name?: Maybe<Scalars['String']['output']>;
  gestore_username?: Maybe<Scalars['String']['output']>;
  installatori?: Maybe<Scalars['jsonb']['output']>;
  intestatario_codice_fiscale?: Maybe<Scalars['String']['output']>;
  intestatario_cognome?: Maybe<Scalars['String']['output']>;
  intestatario_nome?: Maybe<Scalars['String']['output']>;
  intestatario_partita_iva?: Maybe<Scalars['String']['output']>;
  intestatario_ragione_sociale?: Maybe<Scalars['String']['output']>;
  is_duplicato?: Maybe<Scalars['Boolean']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['bigint']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['bigint']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  search_text?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  tipologia_richiesta?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "v_superadmin_sottoscrizioni" */
export type V_Superadmin_SottoscrizioniInstallatoriArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "v_superadmin_sottoscrizioni" */
export type V_Superadmin_Sottoscrizioni_Aggregate = {
  __typename?: 'v_superadmin_sottoscrizioni_aggregate';
  aggregate?: Maybe<V_Superadmin_Sottoscrizioni_Aggregate_Fields>;
  nodes: Array<V_Superadmin_Sottoscrizioni>;
};

/** aggregate fields of "v_superadmin_sottoscrizioni" */
export type V_Superadmin_Sottoscrizioni_Aggregate_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_aggregate_fields';
  avg?: Maybe<V_Superadmin_Sottoscrizioni_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<V_Superadmin_Sottoscrizioni_Max_Fields>;
  min?: Maybe<V_Superadmin_Sottoscrizioni_Min_Fields>;
  stddev?: Maybe<V_Superadmin_Sottoscrizioni_Stddev_Fields>;
  stddev_pop?: Maybe<V_Superadmin_Sottoscrizioni_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<V_Superadmin_Sottoscrizioni_Stddev_Samp_Fields>;
  sum?: Maybe<V_Superadmin_Sottoscrizioni_Sum_Fields>;
  var_pop?: Maybe<V_Superadmin_Sottoscrizioni_Var_Pop_Fields>;
  var_samp?: Maybe<V_Superadmin_Sottoscrizioni_Var_Samp_Fields>;
  variance?: Maybe<V_Superadmin_Sottoscrizioni_Variance_Fields>;
};


/** aggregate fields of "v_superadmin_sottoscrizioni" */
export type V_Superadmin_Sottoscrizioni_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type V_Superadmin_Sottoscrizioni_Avg_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_avg_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['Float']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "v_superadmin_sottoscrizioni". All fields are combined with a logical 'AND'. */
export type V_Superadmin_Sottoscrizioni_Bool_Exp = {
  _and?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Bool_Exp>>;
  _not?: InputMaybe<V_Superadmin_Sottoscrizioni_Bool_Exp>;
  _or?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Bool_Exp>>;
  asset_consumo_id?: InputMaybe<Uuid_Comparison_Exp>;
  asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  asset_produzione_id?: InputMaybe<Uuid_Comparison_Exp>;
  cabina_cod_ac?: InputMaybe<String_Comparison_Exp>;
  cabina_id?: InputMaybe<Int_Comparison_Exp>;
  cer_alias?: InputMaybe<String_Comparison_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  cer_padre_alias?: InputMaybe<String_Comparison_Exp>;
  codice_promotore?: InputMaybe<String_Comparison_Exp>;
  codici_amico_gestore?: InputMaybe<String_Array_Comparison_Exp>;
  codici_amico_gestore_txt?: InputMaybe<String_Comparison_Exp>;
  condivisione_account_email?: InputMaybe<String_Comparison_Exp>;
  condivisione_account_nome?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gestore_first_name?: InputMaybe<String_Comparison_Exp>;
  gestore_last_name?: InputMaybe<String_Comparison_Exp>;
  gestore_username?: InputMaybe<String_Comparison_Exp>;
  installatori?: InputMaybe<Jsonb_Comparison_Exp>;
  intestatario_codice_fiscale?: InputMaybe<String_Comparison_Exp>;
  intestatario_cognome?: InputMaybe<String_Comparison_Exp>;
  intestatario_nome?: InputMaybe<String_Comparison_Exp>;
  intestatario_partita_iva?: InputMaybe<String_Comparison_Exp>;
  intestatario_ragione_sociale?: InputMaybe<String_Comparison_Exp>;
  is_duplicato?: InputMaybe<Boolean_Comparison_Exp>;
  n_asset_stesso_pod?: InputMaybe<Bigint_Comparison_Exp>;
  n_sottoscrizioni_stesso_pod?: InputMaybe<Bigint_Comparison_Exp>;
  pod?: InputMaybe<String_Comparison_Exp>;
  search_text?: InputMaybe<String_Comparison_Exp>;
  sottoscrizione_id?: InputMaybe<Uuid_Comparison_Exp>;
  stato?: InputMaybe<String_Comparison_Exp>;
  tipologia_richiesta?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type V_Superadmin_Sottoscrizioni_Max_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_max_fields';
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  cabina_cod_ac?: Maybe<Scalars['String']['output']>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  codice_promotore?: Maybe<Scalars['String']['output']>;
  codici_amico_gestore?: Maybe<Array<Scalars['String']['output']>>;
  codici_amico_gestore_txt?: Maybe<Scalars['String']['output']>;
  condivisione_account_email?: Maybe<Scalars['String']['output']>;
  condivisione_account_nome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gestore_first_name?: Maybe<Scalars['String']['output']>;
  gestore_last_name?: Maybe<Scalars['String']['output']>;
  gestore_username?: Maybe<Scalars['String']['output']>;
  intestatario_codice_fiscale?: Maybe<Scalars['String']['output']>;
  intestatario_cognome?: Maybe<Scalars['String']['output']>;
  intestatario_nome?: Maybe<Scalars['String']['output']>;
  intestatario_partita_iva?: Maybe<Scalars['String']['output']>;
  intestatario_ragione_sociale?: Maybe<Scalars['String']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['bigint']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['bigint']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  search_text?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  tipologia_richiesta?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type V_Superadmin_Sottoscrizioni_Min_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_min_fields';
  asset_consumo_id?: Maybe<Scalars['uuid']['output']>;
  asset_id?: Maybe<Scalars['uuid']['output']>;
  asset_produzione_id?: Maybe<Scalars['uuid']['output']>;
  cabina_cod_ac?: Maybe<Scalars['String']['output']>;
  cabina_id?: Maybe<Scalars['Int']['output']>;
  cer_alias?: Maybe<Scalars['String']['output']>;
  cer_id?: Maybe<Scalars['uuid']['output']>;
  cer_padre_alias?: Maybe<Scalars['String']['output']>;
  codice_promotore?: Maybe<Scalars['String']['output']>;
  codici_amico_gestore?: Maybe<Array<Scalars['String']['output']>>;
  codici_amico_gestore_txt?: Maybe<Scalars['String']['output']>;
  condivisione_account_email?: Maybe<Scalars['String']['output']>;
  condivisione_account_nome?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gestore_first_name?: Maybe<Scalars['String']['output']>;
  gestore_last_name?: Maybe<Scalars['String']['output']>;
  gestore_username?: Maybe<Scalars['String']['output']>;
  intestatario_codice_fiscale?: Maybe<Scalars['String']['output']>;
  intestatario_cognome?: Maybe<Scalars['String']['output']>;
  intestatario_nome?: Maybe<Scalars['String']['output']>;
  intestatario_partita_iva?: Maybe<Scalars['String']['output']>;
  intestatario_ragione_sociale?: Maybe<Scalars['String']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['bigint']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['bigint']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  search_text?: Maybe<Scalars['String']['output']>;
  sottoscrizione_id?: Maybe<Scalars['uuid']['output']>;
  stato?: Maybe<Scalars['String']['output']>;
  tipologia_richiesta?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "v_superadmin_sottoscrizioni". */
export type V_Superadmin_Sottoscrizioni_Order_By = {
  asset_consumo_id?: InputMaybe<Order_By>;
  asset_id?: InputMaybe<Order_By>;
  asset_produzione_id?: InputMaybe<Order_By>;
  cabina_cod_ac?: InputMaybe<Order_By>;
  cabina_id?: InputMaybe<Order_By>;
  cer_alias?: InputMaybe<Order_By>;
  cer_id?: InputMaybe<Order_By>;
  cer_padre_alias?: InputMaybe<Order_By>;
  codice_promotore?: InputMaybe<Order_By>;
  codici_amico_gestore?: InputMaybe<Order_By>;
  codici_amico_gestore_txt?: InputMaybe<Order_By>;
  condivisione_account_email?: InputMaybe<Order_By>;
  condivisione_account_nome?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gestore_first_name?: InputMaybe<Order_By>;
  gestore_last_name?: InputMaybe<Order_By>;
  gestore_username?: InputMaybe<Order_By>;
  installatori?: InputMaybe<Order_By>;
  intestatario_codice_fiscale?: InputMaybe<Order_By>;
  intestatario_cognome?: InputMaybe<Order_By>;
  intestatario_nome?: InputMaybe<Order_By>;
  intestatario_partita_iva?: InputMaybe<Order_By>;
  intestatario_ragione_sociale?: InputMaybe<Order_By>;
  is_duplicato?: InputMaybe<Order_By>;
  n_asset_stesso_pod?: InputMaybe<Order_By>;
  n_sottoscrizioni_stesso_pod?: InputMaybe<Order_By>;
  pod?: InputMaybe<Order_By>;
  search_text?: InputMaybe<Order_By>;
  sottoscrizione_id?: InputMaybe<Order_By>;
  stato?: InputMaybe<Order_By>;
  tipologia_richiesta?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "v_superadmin_sottoscrizioni" */
export enum V_Superadmin_Sottoscrizioni_Select_Column {
  /** column name */
  AssetConsumoId = 'asset_consumo_id',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AssetProduzioneId = 'asset_produzione_id',
  /** column name */
  CabinaCodAc = 'cabina_cod_ac',
  /** column name */
  CabinaId = 'cabina_id',
  /** column name */
  CerAlias = 'cer_alias',
  /** column name */
  CerId = 'cer_id',
  /** column name */
  CerPadreAlias = 'cer_padre_alias',
  /** column name */
  CodicePromotore = 'codice_promotore',
  /** column name */
  CodiciAmicoGestore = 'codici_amico_gestore',
  /** column name */
  CodiciAmicoGestoreTxt = 'codici_amico_gestore_txt',
  /** column name */
  CondivisioneAccountEmail = 'condivisione_account_email',
  /** column name */
  CondivisioneAccountNome = 'condivisione_account_nome',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GestoreFirstName = 'gestore_first_name',
  /** column name */
  GestoreLastName = 'gestore_last_name',
  /** column name */
  GestoreUsername = 'gestore_username',
  /** column name */
  Installatori = 'installatori',
  /** column name */
  IntestatarioCodiceFiscale = 'intestatario_codice_fiscale',
  /** column name */
  IntestatarioCognome = 'intestatario_cognome',
  /** column name */
  IntestatarioNome = 'intestatario_nome',
  /** column name */
  IntestatarioPartitaIva = 'intestatario_partita_iva',
  /** column name */
  IntestatarioRagioneSociale = 'intestatario_ragione_sociale',
  /** column name */
  IsDuplicato = 'is_duplicato',
  /** column name */
  NAssetStessoPod = 'n_asset_stesso_pod',
  /** column name */
  NSottoscrizioniStessoPod = 'n_sottoscrizioni_stesso_pod',
  /** column name */
  Pod = 'pod',
  /** column name */
  SearchText = 'search_text',
  /** column name */
  SottoscrizioneId = 'sottoscrizione_id',
  /** column name */
  Stato = 'stato',
  /** column name */
  TipologiaRichiesta = 'tipologia_richiesta',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type V_Superadmin_Sottoscrizioni_Stddev_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_stddev_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['Float']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type V_Superadmin_Sottoscrizioni_Stddev_Pop_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_stddev_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['Float']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type V_Superadmin_Sottoscrizioni_Stddev_Samp_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_stddev_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['Float']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "v_superadmin_sottoscrizioni" */
export type V_Superadmin_Sottoscrizioni_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V_Superadmin_Sottoscrizioni_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type V_Superadmin_Sottoscrizioni_Stream_Cursor_Value_Input = {
  asset_consumo_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_produzione_id?: InputMaybe<Scalars['uuid']['input']>;
  cabina_cod_ac?: InputMaybe<Scalars['String']['input']>;
  cabina_id?: InputMaybe<Scalars['Int']['input']>;
  cer_alias?: InputMaybe<Scalars['String']['input']>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  cer_padre_alias?: InputMaybe<Scalars['String']['input']>;
  codice_promotore?: InputMaybe<Scalars['String']['input']>;
  codici_amico_gestore?: InputMaybe<Array<Scalars['String']['input']>>;
  codici_amico_gestore_txt?: InputMaybe<Scalars['String']['input']>;
  condivisione_account_email?: InputMaybe<Scalars['String']['input']>;
  condivisione_account_nome?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  gestore_first_name?: InputMaybe<Scalars['String']['input']>;
  gestore_last_name?: InputMaybe<Scalars['String']['input']>;
  gestore_username?: InputMaybe<Scalars['String']['input']>;
  installatori?: InputMaybe<Scalars['jsonb']['input']>;
  intestatario_codice_fiscale?: InputMaybe<Scalars['String']['input']>;
  intestatario_cognome?: InputMaybe<Scalars['String']['input']>;
  intestatario_nome?: InputMaybe<Scalars['String']['input']>;
  intestatario_partita_iva?: InputMaybe<Scalars['String']['input']>;
  intestatario_ragione_sociale?: InputMaybe<Scalars['String']['input']>;
  is_duplicato?: InputMaybe<Scalars['Boolean']['input']>;
  n_asset_stesso_pod?: InputMaybe<Scalars['bigint']['input']>;
  n_sottoscrizioni_stesso_pod?: InputMaybe<Scalars['bigint']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['uuid']['input']>;
  stato?: InputMaybe<Scalars['String']['input']>;
  tipologia_richiesta?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type V_Superadmin_Sottoscrizioni_Sum_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_sum_fields';
  cabina_id?: Maybe<Scalars['Int']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['bigint']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type V_Superadmin_Sottoscrizioni_Var_Pop_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_var_pop_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['Float']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type V_Superadmin_Sottoscrizioni_Var_Samp_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_var_samp_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['Float']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type V_Superadmin_Sottoscrizioni_Variance_Fields = {
  __typename?: 'v_superadmin_sottoscrizioni_variance_fields';
  cabina_id?: Maybe<Scalars['Float']['output']>;
  n_asset_stesso_pod?: Maybe<Scalars['Float']['output']>;
  n_sottoscrizioni_stesso_pod?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userSession: Scalars['jsonb']['output'];
  virus: Scalars['String']['output'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields>;
  nodes: Array<Virus>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Virus_Max_Fields>;
  min?: Maybe<Virus_Min_Fields>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>;
  _not?: InputMaybe<Virus_Bool_Exp>;
  _or?: InputMaybe<Array<Virus_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp>;
  virus?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint;
  update_columns?: Array<Virus_Update_Column>;
  where?: InputMaybe<Virus_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userSession?: InputMaybe<Order_By>;
  virus?: InputMaybe<Order_By>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus'
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp;
};

/** columns and relationships of "white_label.associazione" */
export type White_Label_Associazione = {
  __typename?: 'white_label_associazione';
  /** An object relationship */
  cer: Cer;
  cer_id: Scalars['uuid']['output'];
  /** An object relationship */
  configurazione: White_Label_Configurazione;
  configurazione_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "white_label.associazione" */
export type White_Label_Associazione_Aggregate = {
  __typename?: 'white_label_associazione_aggregate';
  aggregate?: Maybe<White_Label_Associazione_Aggregate_Fields>;
  nodes: Array<White_Label_Associazione>;
};

export type White_Label_Associazione_Aggregate_Bool_Exp = {
  count?: InputMaybe<White_Label_Associazione_Aggregate_Bool_Exp_Count>;
};

export type White_Label_Associazione_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<White_Label_Associazione_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "white_label.associazione" */
export type White_Label_Associazione_Aggregate_Fields = {
  __typename?: 'white_label_associazione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<White_Label_Associazione_Max_Fields>;
  min?: Maybe<White_Label_Associazione_Min_Fields>;
};


/** aggregate fields of "white_label.associazione" */
export type White_Label_Associazione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "white_label.associazione" */
export type White_Label_Associazione_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<White_Label_Associazione_Max_Order_By>;
  min?: InputMaybe<White_Label_Associazione_Min_Order_By>;
};

/** input type for inserting array relation for remote table "white_label.associazione" */
export type White_Label_Associazione_Arr_Rel_Insert_Input = {
  data: Array<White_Label_Associazione_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<White_Label_Associazione_On_Conflict>;
};

/** Boolean expression to filter rows from the table "white_label.associazione". All fields are combined with a logical 'AND'. */
export type White_Label_Associazione_Bool_Exp = {
  _and?: InputMaybe<Array<White_Label_Associazione_Bool_Exp>>;
  _not?: InputMaybe<White_Label_Associazione_Bool_Exp>;
  _or?: InputMaybe<Array<White_Label_Associazione_Bool_Exp>>;
  cer?: InputMaybe<Cer_Bool_Exp>;
  cer_id?: InputMaybe<Uuid_Comparison_Exp>;
  configurazione?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
  configurazione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "white_label.associazione" */
export enum White_Label_Associazione_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssociazionePkey = 'associazione_pkey'
}

/** input type for inserting data into table "white_label.associazione" */
export type White_Label_Associazione_Insert_Input = {
  cer?: InputMaybe<Cer_Obj_Rel_Insert_Input>;
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  configurazione?: InputMaybe<White_Label_Configurazione_Obj_Rel_Insert_Input>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type White_Label_Associazione_Max_Fields = {
  __typename?: 'white_label_associazione_max_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "white_label.associazione" */
export type White_Label_Associazione_Max_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type White_Label_Associazione_Min_Fields = {
  __typename?: 'white_label_associazione_min_fields';
  cer_id?: Maybe<Scalars['uuid']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "white_label.associazione" */
export type White_Label_Associazione_Min_Order_By = {
  cer_id?: InputMaybe<Order_By>;
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "white_label.associazione" */
export type White_Label_Associazione_Mutation_Response = {
  __typename?: 'white_label_associazione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<White_Label_Associazione>;
};

/** on_conflict condition type for table "white_label.associazione" */
export type White_Label_Associazione_On_Conflict = {
  constraint: White_Label_Associazione_Constraint;
  update_columns?: Array<White_Label_Associazione_Update_Column>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};

/** Ordering options when selecting data from "white_label.associazione". */
export type White_Label_Associazione_Order_By = {
  cer?: InputMaybe<Cer_Order_By>;
  cer_id?: InputMaybe<Order_By>;
  configurazione?: InputMaybe<White_Label_Configurazione_Order_By>;
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: white_label.associazione */
export type White_Label_Associazione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "white_label.associazione" */
export enum White_Label_Associazione_Select_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "white_label.associazione" */
export type White_Label_Associazione_Set_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "white_label_associazione" */
export type White_Label_Associazione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: White_Label_Associazione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type White_Label_Associazione_Stream_Cursor_Value_Input = {
  cer_id?: InputMaybe<Scalars['uuid']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "white_label.associazione" */
export enum White_Label_Associazione_Update_Column {
  /** column name */
  CerId = 'cer_id',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type White_Label_Associazione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<White_Label_Associazione_Set_Input>;
  /** filter the rows which have to be updated */
  where: White_Label_Associazione_Bool_Exp;
};

/** columns and relationships of "white_label.configurazione" */
export type White_Label_Configurazione = {
  __typename?: 'white_label_configurazione';
  /** An array relationship */
  associazioni: Array<White_Label_Associazione>;
  /** An aggregate relationship */
  associazioni_aggregate: White_Label_Associazione_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  idps: Array<White_Label_Idp>;
  /** An aggregate relationship */
  idps_aggregate: White_Label_Idp_Aggregate;
  /** An object relationship */
  logo_chiaro?: Maybe<Files>;
  logo_chiaro_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  logo_scuro?: Maybe<Files>;
  logo_scuro_id?: Maybe<Scalars['uuid']['output']>;
  referral: Scalars['String']['output'];
  standard_login: Scalars['Boolean']['output'];
  /** An object relationship */
  terms?: Maybe<Files>;
  terms_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "white_label.configurazione" */
export type White_Label_ConfigurazioneAssociazioniArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


/** columns and relationships of "white_label.configurazione" */
export type White_Label_ConfigurazioneAssociazioni_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Associazione_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Associazione_Order_By>>;
  where?: InputMaybe<White_Label_Associazione_Bool_Exp>;
};


/** columns and relationships of "white_label.configurazione" */
export type White_Label_ConfigurazioneIdpsArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Idp_Order_By>>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};


/** columns and relationships of "white_label.configurazione" */
export type White_Label_ConfigurazioneIdps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<White_Label_Idp_Order_By>>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};

/** aggregated selection of "white_label.configurazione" */
export type White_Label_Configurazione_Aggregate = {
  __typename?: 'white_label_configurazione_aggregate';
  aggregate?: Maybe<White_Label_Configurazione_Aggregate_Fields>;
  nodes: Array<White_Label_Configurazione>;
};

/** aggregate fields of "white_label.configurazione" */
export type White_Label_Configurazione_Aggregate_Fields = {
  __typename?: 'white_label_configurazione_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<White_Label_Configurazione_Max_Fields>;
  min?: Maybe<White_Label_Configurazione_Min_Fields>;
};


/** aggregate fields of "white_label.configurazione" */
export type White_Label_Configurazione_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<White_Label_Configurazione_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "white_label.configurazione". All fields are combined with a logical 'AND'. */
export type White_Label_Configurazione_Bool_Exp = {
  _and?: InputMaybe<Array<White_Label_Configurazione_Bool_Exp>>;
  _not?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
  _or?: InputMaybe<Array<White_Label_Configurazione_Bool_Exp>>;
  associazioni?: InputMaybe<White_Label_Associazione_Bool_Exp>;
  associazioni_aggregate?: InputMaybe<White_Label_Associazione_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idps?: InputMaybe<White_Label_Idp_Bool_Exp>;
  idps_aggregate?: InputMaybe<White_Label_Idp_Aggregate_Bool_Exp>;
  logo_chiaro?: InputMaybe<Files_Bool_Exp>;
  logo_chiaro_id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_scuro?: InputMaybe<Files_Bool_Exp>;
  logo_scuro_id?: InputMaybe<Uuid_Comparison_Exp>;
  referral?: InputMaybe<String_Comparison_Exp>;
  standard_login?: InputMaybe<Boolean_Comparison_Exp>;
  terms?: InputMaybe<Files_Bool_Exp>;
  terms_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "white_label.configurazione" */
export enum White_Label_Configurazione_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConfigurazionePkey = 'configurazione_pkey'
}

/** input type for inserting data into table "white_label.configurazione" */
export type White_Label_Configurazione_Insert_Input = {
  associazioni?: InputMaybe<White_Label_Associazione_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idps?: InputMaybe<White_Label_Idp_Arr_Rel_Insert_Input>;
  logo_chiaro?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  logo_chiaro_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_scuro?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  logo_scuro_id?: InputMaybe<Scalars['uuid']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  standard_login?: InputMaybe<Scalars['Boolean']['input']>;
  terms?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  terms_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type White_Label_Configurazione_Max_Fields = {
  __typename?: 'white_label_configurazione_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logo_chiaro_id?: Maybe<Scalars['uuid']['output']>;
  logo_scuro_id?: Maybe<Scalars['uuid']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  terms_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type White_Label_Configurazione_Min_Fields = {
  __typename?: 'white_label_configurazione_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logo_chiaro_id?: Maybe<Scalars['uuid']['output']>;
  logo_scuro_id?: Maybe<Scalars['uuid']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  terms_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "white_label.configurazione" */
export type White_Label_Configurazione_Mutation_Response = {
  __typename?: 'white_label_configurazione_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<White_Label_Configurazione>;
};

/** input type for inserting object relation for remote table "white_label.configurazione" */
export type White_Label_Configurazione_Obj_Rel_Insert_Input = {
  data: White_Label_Configurazione_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<White_Label_Configurazione_On_Conflict>;
};

/** on_conflict condition type for table "white_label.configurazione" */
export type White_Label_Configurazione_On_Conflict = {
  constraint: White_Label_Configurazione_Constraint;
  update_columns?: Array<White_Label_Configurazione_Update_Column>;
  where?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
};

/** Ordering options when selecting data from "white_label.configurazione". */
export type White_Label_Configurazione_Order_By = {
  associazioni_aggregate?: InputMaybe<White_Label_Associazione_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idps_aggregate?: InputMaybe<White_Label_Idp_Aggregate_Order_By>;
  logo_chiaro?: InputMaybe<Files_Order_By>;
  logo_chiaro_id?: InputMaybe<Order_By>;
  logo_scuro?: InputMaybe<Files_Order_By>;
  logo_scuro_id?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  standard_login?: InputMaybe<Order_By>;
  terms?: InputMaybe<Files_Order_By>;
  terms_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: white_label.configurazione */
export type White_Label_Configurazione_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "white_label.configurazione" */
export enum White_Label_Configurazione_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogoChiaroId = 'logo_chiaro_id',
  /** column name */
  LogoScuroId = 'logo_scuro_id',
  /** column name */
  Referral = 'referral',
  /** column name */
  StandardLogin = 'standard_login',
  /** column name */
  TermsId = 'terms_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "white_label.configurazione" */
export type White_Label_Configurazione_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo_chiaro_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_scuro_id?: InputMaybe<Scalars['uuid']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  standard_login?: InputMaybe<Scalars['Boolean']['input']>;
  terms_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "white_label_configurazione" */
export type White_Label_Configurazione_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: White_Label_Configurazione_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type White_Label_Configurazione_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo_chiaro_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_scuro_id?: InputMaybe<Scalars['uuid']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  standard_login?: InputMaybe<Scalars['Boolean']['input']>;
  terms_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "white_label.configurazione" */
export enum White_Label_Configurazione_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogoChiaroId = 'logo_chiaro_id',
  /** column name */
  LogoScuroId = 'logo_scuro_id',
  /** column name */
  Referral = 'referral',
  /** column name */
  StandardLogin = 'standard_login',
  /** column name */
  TermsId = 'terms_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type White_Label_Configurazione_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<White_Label_Configurazione_Set_Input>;
  /** filter the rows which have to be updated */
  where: White_Label_Configurazione_Bool_Exp;
};

/** columns and relationships of "white_label.gestore" */
export type White_Label_Gestore = {
  __typename?: 'white_label_gestore';
  auth_id: Scalars['String']['output'];
  configurazione_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "white_label.gestore" */
export type White_Label_Gestore_Aggregate = {
  __typename?: 'white_label_gestore_aggregate';
  aggregate?: Maybe<White_Label_Gestore_Aggregate_Fields>;
  nodes: Array<White_Label_Gestore>;
};

/** aggregate fields of "white_label.gestore" */
export type White_Label_Gestore_Aggregate_Fields = {
  __typename?: 'white_label_gestore_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<White_Label_Gestore_Max_Fields>;
  min?: Maybe<White_Label_Gestore_Min_Fields>;
};


/** aggregate fields of "white_label.gestore" */
export type White_Label_Gestore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<White_Label_Gestore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "white_label.gestore". All fields are combined with a logical 'AND'. */
export type White_Label_Gestore_Bool_Exp = {
  _and?: InputMaybe<Array<White_Label_Gestore_Bool_Exp>>;
  _not?: InputMaybe<White_Label_Gestore_Bool_Exp>;
  _or?: InputMaybe<Array<White_Label_Gestore_Bool_Exp>>;
  auth_id?: InputMaybe<String_Comparison_Exp>;
  configurazione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "white_label.gestore" */
export enum White_Label_Gestore_Constraint {
  /** unique or primary key constraint on columns "id" */
  GestorePkey = 'gestore_pkey'
}

/** input type for inserting data into table "white_label.gestore" */
export type White_Label_Gestore_Insert_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type White_Label_Gestore_Max_Fields = {
  __typename?: 'white_label_gestore_max_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type White_Label_Gestore_Min_Fields = {
  __typename?: 'white_label_gestore_min_fields';
  auth_id?: Maybe<Scalars['String']['output']>;
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "white_label.gestore" */
export type White_Label_Gestore_Mutation_Response = {
  __typename?: 'white_label_gestore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<White_Label_Gestore>;
};

/** on_conflict condition type for table "white_label.gestore" */
export type White_Label_Gestore_On_Conflict = {
  constraint: White_Label_Gestore_Constraint;
  update_columns?: Array<White_Label_Gestore_Update_Column>;
  where?: InputMaybe<White_Label_Gestore_Bool_Exp>;
};

/** Ordering options when selecting data from "white_label.gestore". */
export type White_Label_Gestore_Order_By = {
  auth_id?: InputMaybe<Order_By>;
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: white_label.gestore */
export type White_Label_Gestore_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "white_label.gestore" */
export enum White_Label_Gestore_Select_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "white_label.gestore" */
export type White_Label_Gestore_Set_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "white_label_gestore" */
export type White_Label_Gestore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: White_Label_Gestore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type White_Label_Gestore_Stream_Cursor_Value_Input = {
  auth_id?: InputMaybe<Scalars['String']['input']>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "white_label.gestore" */
export enum White_Label_Gestore_Update_Column {
  /** column name */
  AuthId = 'auth_id',
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type White_Label_Gestore_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<White_Label_Gestore_Set_Input>;
  /** filter the rows which have to be updated */
  where: White_Label_Gestore_Bool_Exp;
};

/** columns and relationships of "white_label.idp" */
export type White_Label_Idp = {
  __typename?: 'white_label_idp';
  /** An object relationship */
  configurazione: White_Label_Configurazione;
  configurazione_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "white_label.idp" */
export type White_Label_Idp_Aggregate = {
  __typename?: 'white_label_idp_aggregate';
  aggregate?: Maybe<White_Label_Idp_Aggregate_Fields>;
  nodes: Array<White_Label_Idp>;
};

export type White_Label_Idp_Aggregate_Bool_Exp = {
  count?: InputMaybe<White_Label_Idp_Aggregate_Bool_Exp_Count>;
};

export type White_Label_Idp_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<White_Label_Idp_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "white_label.idp" */
export type White_Label_Idp_Aggregate_Fields = {
  __typename?: 'white_label_idp_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<White_Label_Idp_Max_Fields>;
  min?: Maybe<White_Label_Idp_Min_Fields>;
};


/** aggregate fields of "white_label.idp" */
export type White_Label_Idp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<White_Label_Idp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "white_label.idp" */
export type White_Label_Idp_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<White_Label_Idp_Max_Order_By>;
  min?: InputMaybe<White_Label_Idp_Min_Order_By>;
};

/** input type for inserting array relation for remote table "white_label.idp" */
export type White_Label_Idp_Arr_Rel_Insert_Input = {
  data: Array<White_Label_Idp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<White_Label_Idp_On_Conflict>;
};

/** Boolean expression to filter rows from the table "white_label.idp". All fields are combined with a logical 'AND'. */
export type White_Label_Idp_Bool_Exp = {
  _and?: InputMaybe<Array<White_Label_Idp_Bool_Exp>>;
  _not?: InputMaybe<White_Label_Idp_Bool_Exp>;
  _or?: InputMaybe<Array<White_Label_Idp_Bool_Exp>>;
  configurazione?: InputMaybe<White_Label_Configurazione_Bool_Exp>;
  configurazione_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "white_label.idp" */
export enum White_Label_Idp_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdpPkey = 'idp_pkey'
}

/** input type for inserting data into table "white_label.idp" */
export type White_Label_Idp_Insert_Input = {
  configurazione?: InputMaybe<White_Label_Configurazione_Obj_Rel_Insert_Input>;
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type White_Label_Idp_Max_Fields = {
  __typename?: 'white_label_idp_max_fields';
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "white_label.idp" */
export type White_Label_Idp_Max_Order_By = {
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type White_Label_Idp_Min_Fields = {
  __typename?: 'white_label_idp_min_fields';
  configurazione_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "white_label.idp" */
export type White_Label_Idp_Min_Order_By = {
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "white_label.idp" */
export type White_Label_Idp_Mutation_Response = {
  __typename?: 'white_label_idp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<White_Label_Idp>;
};

/** on_conflict condition type for table "white_label.idp" */
export type White_Label_Idp_On_Conflict = {
  constraint: White_Label_Idp_Constraint;
  update_columns?: Array<White_Label_Idp_Update_Column>;
  where?: InputMaybe<White_Label_Idp_Bool_Exp>;
};

/** Ordering options when selecting data from "white_label.idp". */
export type White_Label_Idp_Order_By = {
  configurazione?: InputMaybe<White_Label_Configurazione_Order_By>;
  configurazione_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: white_label.idp */
export type White_Label_Idp_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "white_label.idp" */
export enum White_Label_Idp_Select_Column {
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "white_label.idp" */
export type White_Label_Idp_Set_Input = {
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "white_label_idp" */
export type White_Label_Idp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: White_Label_Idp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type White_Label_Idp_Stream_Cursor_Value_Input = {
  configurazione_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "white_label.idp" */
export enum White_Label_Idp_Update_Column {
  /** column name */
  ConfigurazioneId = 'configurazione_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type White_Label_Idp_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<White_Label_Idp_Set_Input>;
  /** filter the rows which have to be updated */
  where: White_Label_Idp_Bool_Exp;
};

export type CheckPodDuplicatoQueryVariables = Exact<{
  pods: Scalars['_text']['input'];
  tipologia: Scalars['String']['input'];
  exclude_id?: InputMaybe<Scalars['uuid']['input']>;
  include_staging?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_staging_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CheckPodDuplicatoQuery = { __typename?: 'query_root', check_pod_duplicato: Array<{ __typename?: '_pod_duplicato', pod: string }> };

export type PreviewPdfMutationVariables = Exact<{
  input: PreviewPdfInput;
}>;


export type PreviewPdfMutation = { __typename?: 'mutation_root', preview_pdf?: { __typename?: 'PreviewPdfOutput', base64_pdf: string } | null };

export type GetCabinaQueryVariables = Exact<{
  where?: InputMaybe<Energy_Village_Cabina_Bool_Exp>;
}>;


export type GetCabinaQuery = { __typename?: 'query_root', energy_village_cabina: Array<{ __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null, elenco_citta?: string | null }> };

export type GetCittaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCittaQuery = { __typename?: 'query_root', unita_amministrativa_citta: Array<{ __typename?: 'unita_amministrativa_citta', id: any, codice_belfiore?: string | null, denominazione_completa?: string | null, denominazione?: string | null }> };

export type GetCittaGeometryQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetCittaGeometryQuery = { __typename?: 'query_root', unita_amministrativa_citta_by_pk?: { __typename?: 'unita_amministrativa_citta', geom?: any | null } | null };

export type GetCodiceAtecoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCodiceAtecoQuery = { __typename?: 'query_root', anagrafica_codice_ateco: Array<{ __typename?: 'anagrafica_codice_ateco', id: string, label: string }> };

export type FeedbackQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedbackQuery = { __typename?: 'query_root', energy_village_feedback: Array<{ __typename?: 'energy_village_feedback', id: any, label?: string | null, type: Energy_Village__Tipo_Feedback_Enum }> };

export type GetFormaGiuridicaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFormaGiuridicaQuery = { __typename?: 'query_root', anagrafica_forma_giuridica: Array<{ __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null }> };

export type GetFormaGiuridicaCerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFormaGiuridicaCerQuery = { __typename?: 'query_root', anagrafica_forma_giuridica_cer: Array<{ __typename?: 'anagrafica_forma_giuridica_cer', id: any, label?: string | null }> };

export type GetIncentivoImpiantoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIncentivoImpiantoQuery = { __typename?: 'query_root', energy_village_incentivo_impianto: Array<{ __typename?: 'energy_village_incentivo_impianto', id: any, label?: string | null }> };

export type GetNazioneQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNazioneQuery = { __typename?: 'query_root', unita_amministrativa_nazione: Array<{ __typename?: 'unita_amministrativa_nazione', id: number, codice_belfiore?: string | null, denominazione?: string | null, order: any }> };

export type GetProvinciaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvinciaQuery = { __typename?: 'query_root', unita_amministrativa_provincia: Array<{ __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null }> };

export type GetRegioneQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegioneQuery = { __typename?: 'query_root', unita_amministrativa_regione: Array<{ __typename?: 'unita_amministrativa_regione', id: any, denominazione?: string | null }> };

export type GetTipoContattoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipoContattoQuery = { __typename?: 'query_root', anagrafica_tipo_contatto: Array<{ __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, validation?: any | null, icon?: string | null }> };

export type GetTipoPromotoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipoPromotoreQuery = { __typename?: 'query_root', anagrafica_tipo_promotore: Array<{ __typename?: 'anagrafica_tipo_promotore', id: any, label?: string | null }> };

export type GetTipoSpazioDisponibileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipoSpazioDisponibileQuery = { __typename?: 'query_root', energy_village_tipo_spazio_disponibile: Array<{ __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null }> };

export type GetTipologieAssetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipologieAssetQuery = { __typename?: 'query_root', energy_village_tipologia_asset: Array<{ __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null, img?: string | null, label?: string | null, card_impianto: boolean, tipologia: string, order: number, profilo_consumo?: any | null, tipologia_asset_figli: Array<{ __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, profilo_consumo?: any | null, order: number, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null } | null }>, orari: Array<{ __typename?: 'energy_village_orario', id: any, label?: string | null, order: number }>, tipologie_abitativa: Array<{ __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null, order: number }>, dimensioni: Array<{ __typename?: 'energy_village_dimensione', id: any, label?: string | null, order: number }>, caratteristiche: Array<{ __typename?: 'energy_village_caratteristica', id: any, label?: string | null, description?: string | null, icon: string, order: number }> }> };

export type GetTipologiaRappresentanteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipologiaRappresentanteQuery = { __typename?: 'query_root', anagrafica_tipologia_rappresentante: Array<{ __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null }> };

export type GetTitoloAutorizzativoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTitoloAutorizzativoQuery = { __typename?: 'query_root', energy_village_titolo_autorizzativo: Array<{ __typename?: 'energy_village_titolo_autorizzativo', id: any, label?: string | null }> };

export type GetAreaCittaByPkQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetAreaCittaByPkQuery = { __typename?: 'query_root', energy_village_area_citta_by_pk?: { __typename?: 'energy_village_area_citta', id: any, geom?: any | null, cabina_ids?: any | null, citta: { __typename?: 'unita_amministrativa_citta', geom?: any | null } } | null };

export type GetAreaProvinciaByPkQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetAreaProvinciaByPkQuery = { __typename?: 'query_root', energy_village_area_provincia_by_pk?: { __typename?: 'energy_village_area_provincia', id: any, geom: any, cabina_ids: any, provincia: { __typename?: 'unita_amministrativa_provincia', geom?: any | null } } | null };

export type GetAreaRegioneByPkQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetAreaRegioneByPkQuery = { __typename?: 'query_root', energy_village_area_regione_by_pk?: { __typename?: 'energy_village_area_regione', id: any, geom: any, cabina_ids: any, regione: { __typename?: 'unita_amministrativa_regione', geom?: any | null } } | null };

export type GetAreaByPkQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAreaByPkQuery = { __typename?: 'query_root', energy_village_area_by_pk?: { __typename?: 'energy_village_area', id: number, geom?: any | null } | null };

export type GetCabinaIdByPointQueryVariables = Exact<{
  point: Scalars['geometry']['input'];
}>;


export type GetCabinaIdByPointQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null, elenco_citta?: string | null } }> };

export type GetCabinaByPointQueryVariables = Exact<{
  point: Scalars['geometry']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCabinaByPointQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, geom?: any | null, cabina: { __typename?: 'energy_village_cabina', id: number } }> };

export type GetAreaCerByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAreaCerByPkQuery = { __typename?: 'query_root', cer_geom_by_pk?: { __typename?: 'cer_geom', id: any, geom?: any | null } | null };

export type GetAssetInCabinaIdsSubscriptionVariables = Exact<{
  cabina_ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetAssetInCabinaIdsSubscription = { __typename?: 'subscription_root', asset: Array<{ __typename?: 'asset', alias?: string | null, visibilita_nome: boolean, cabina_id?: number | null, impianto?: boolean | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null, label?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, geom?: any | null, completo?: string | null, toponimo?: string | null, civico?: string | null, cap?: string | null, manuale: boolean, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', sigla?: string | null } | null } | null } | null }> };

export type DownloadConfirmoDocumentQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DownloadConfirmoDocumentQuery = { __typename?: 'query_root', confirmoGet?: { __typename?: 'ConfirmoGetOutput', data?: string | null, success: boolean, error?: string | null } | null };

export type GetConfirmoFirmaLinkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetConfirmoFirmaLinkQuery = { __typename?: 'query_root', confirmoGetFirma?: { __typename?: 'ConfirmoGetFirmaOutput', data?: string | null, success: boolean, error?: string | null } | null };

export type GetCittaByPointQueryVariables = Exact<{
  point: Scalars['geometry']['input'];
}>;


export type GetCittaByPointQuery = { __typename?: 'query_root', unita_amministrativa_citta: Array<{ __typename?: 'unita_amministrativa_citta', id: any, denominazione_completa?: string | null, abitanti?: any | null }> };

export type GetLogoByTagQueryVariables = Exact<{
  tag: Scalars['String']['input'];
}>;


export type GetLogoByTagQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', whitelabel: Array<{ __typename?: 'white_label_associazione', configurazione: { __typename?: 'white_label_configurazione', logo_chiaro?: { __typename?: 'files', id: any } | null, logo_scuro?: { __typename?: 'files', id: any } | null } }> }> };

export type GetWhiteLabelByTagQueryVariables = Exact<{
  tag: Scalars['String']['input'];
}>;


export type GetWhiteLabelByTagQuery = { __typename?: 'query_root', white_label_configurazione: Array<{ __typename?: 'white_label_configurazione', standard_login: boolean, idps: Array<{ __typename?: 'white_label_idp', tag: string, label: string, icon: string }> }> };

export type GetTermsByTagQueryVariables = Exact<{
  tag: Scalars['String']['input'];
}>;


export type GetTermsByTagQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', alias?: string | null, whitelabel: Array<{ __typename?: 'white_label_associazione', configurazione: { __typename?: 'white_label_configurazione', terms?: { __typename?: 'files', id: any, name?: string | null } | null } }> }> };

export type ParseBollettaMutationVariables = Exact<{
  input: ParseBollettaInput;
}>;


export type ParseBollettaMutation = { __typename?: 'mutation_root', parseBolletta?: { __typename?: 'ParseBollettaOutput', success: boolean, data?: any | null, sottoscrizione?: { __typename?: 'staging_sottoscrizione', id: any, data?: any | null } | null } | null };

export type GetConfigurazioniFastSubscriptionVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
  where1?: InputMaybe<Cer_Cabina_Bool_Exp>;
}>;


export type GetConfigurazioniFastSubscription = { __typename?: 'subscription_root', cer: Array<{ __typename?: 'cer', id: any, abilita_richieste: boolean, documenti_richiesti?: any | null, domande_richieste?: any | null, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, alias?: string | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, richieste: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, cer_padre?: { __typename?: 'cer', alias?: string | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, logo?: { __typename?: 'files', id: any } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null } | null, logo?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', id: any, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } }>, contatti: Array<{ __typename?: 'cer_contatti', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, icon?: string | null } } }> }> };

export type GetCerConfigurazioniSelectQueryVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
  configurazioni?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCerConfigurazioniSelectQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any, alias?: string | null, configurazioni?: Array<{ __typename?: 'cer', id: any, alias?: string | null }> }> };

export type GetDestinazioniCompatibiliQueryVariables = Exact<{
  cer_id: Scalars['uuid']['input'];
  lng?: InputMaybe<Scalars['float8']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
}>;


export type GetDestinazioniCompatibiliQuery = { __typename?: 'query_root', destinazioni_compatibili: Array<{ __typename?: '_destinazione_compatibile', id?: any | null, descrizione?: string | null, predefinita?: boolean | null }> };

export type GetCerQueryVariables = Exact<{
  referral: Scalars['String']['input'];
}>;


export type GetCerQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any, stato_cer?: Energy_Village__Stato_Cer_Enum | null, alias?: string | null, descrizione?: string | null, referral?: string | null, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null }> };

export type GetConfigurazioniSubscriptionVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
}>;


export type GetConfigurazioniSubscription = { __typename?: 'subscription_root', cer: Array<{ __typename?: 'cer', id: any, abilita_richieste: boolean, alias?: string | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, richieste: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, cer_padre?: { __typename?: 'cer', alias?: string | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, logo?: { __typename?: 'files', id: any } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null } | null, logo?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } }>, contatti: Array<{ __typename?: 'cer_contatti', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, icon?: string | null } } }> }> };

export type GetGeomCabinaQueryVariables = Exact<{
  _in?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetGeomCabinaQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, geom?: any | null }> };

export type GetCabinePointsQueryVariables = Exact<{
  cabina_ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetCabinePointsQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, point?: any | null, cabina: { __typename?: 'energy_village_cabina', id: number } }> };

export type GetCabinaGeomQueryVariables = Exact<{
  cabina_id: Scalars['Int']['input'];
}>;


export type GetCabinaGeomQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, geom?: any | null, cabina: { __typename?: 'energy_village_cabina', id: number } }> };

export type GetBilancioCabineQueryVariables = Exact<{
  cabina_ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetBilancioCabineQuery = { __typename?: 'query_root', asset: Array<{ __typename?: 'asset', id: any, cabina?: { __typename?: 'energy_village_cabina', id: number } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any } | null } | null, energia: Array<{ __typename?: 'asset_energia', immessa?: any | null, prelevata?: any | null }> }> };

export type GetAssetByCabinaIdSubscriptionVariables = Exact<{
  cabina_id: Scalars['Int']['input'];
}>;


export type GetAssetByCabinaIdSubscription = { __typename?: 'subscription_root', asset: Array<{ __typename?: 'asset', alias?: string | null, visibilita_nome: boolean, impianto?: boolean | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null, label?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', geom?: any | null } | null }> };

export type GetGeomConfigurazioniQueryVariables = Exact<{
  _in: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetGeomConfigurazioniQuery = { __typename?: 'query_root', cer_geom: Array<{ __typename?: 'cer_geom', id: any, geom?: any | null, cer?: { __typename?: 'cer', alias?: string | null } | null }> };

export type GetCabineOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCabineOverviewQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, point?: any | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } }> };

export type GetPartecipantiCabineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartecipantiCabineQuery = { __typename?: 'query_root', cer_cabina: Array<{ __typename?: 'cer_cabina', cabina_id: number, cer: { __typename?: 'cer', partecipanti: number } }> };

export type GetCabineByBboxQueryVariables = Exact<{
  bbox: Scalars['geometry']['input'];
}>;


export type GetCabineByBboxQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, geom?: any | null }> };

export type GetBilancioGlobaleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBilancioGlobaleQuery = { __typename?: 'query_root', asset: Array<{ __typename?: 'asset', id: any, cabina_id?: number | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any } | null } | null, energia: Array<{ __typename?: 'asset_energia', immessa?: any | null, prelevata?: any | null }> }> };

export type GetConfigurazioniLocaliSubscriptionVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
}>;


export type GetConfigurazioniLocaliSubscription = { __typename?: 'subscription_root', cer: Array<{ __typename?: 'cer', id: any, alias?: string | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, richieste: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, contatti: Array<{ __typename?: 'cer_contatti', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, icon?: string | null } } }>, cer_padre?: { __typename?: 'cer', referral?: string | null, alias?: string | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null } | null, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } }> }> };

export type GetCondivisioneCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCondivisioneCheckQuery = { __typename?: 'query_root', condivisione_condivisione: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, asset_alias?: string | null, asset_indirizzo?: string | null, proprietario?: { __typename?: 'auth_user_entity', last_name?: string | null, first_name?: string | null, username?: string | null } | null }> };

export type AggiornaStatoCondivisioniMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  stato: Condivisione__Stato_Condivisione_Enum;
  utilizzatore_id: Scalars['String']['input'];
}>;


export type AggiornaStatoCondivisioniMutation = { __typename?: 'mutation_root', update_condivisione_condivisione?: { __typename?: 'condivisione_condivisione_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum }> } | null };

export type RefreshMvNowMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshMvNowMutation = { __typename?: 'mutation_root', staging_refresh_sottoscrizione_mv: Array<{ __typename?: 'staging_mv_refresh_state', name: string, dirty: boolean, updated_at: any, last_refresh_at?: any | null }> };

export type GetStagingSottoscrizioniQueryVariables = Exact<{
  where?: InputMaybe<Staging_Sottoscrizione_List_Mv_Bool_Exp>;
}>;


export type GetStagingSottoscrizioniQuery = { __typename?: 'query_root', staging_sottoscrizione_list_mv: Array<{ __typename?: 'staging_sottoscrizione_list_mv', id?: any | null, stato?: string | null, valido?: boolean | null, errore?: any | null, invalid_controls?: any | null, warning?: boolean | null, created_at?: any | null, updated_at?: any | null, lotto_id?: any | null, sottoscrizione_id?: any | null, azione?: any | null, lotto_nome?: string | null, azione_label?: string | null, azione_gruppo?: string | null, nome?: string | null, cognome?: string | null, email?: string | null, cellulare?: string | null, intestatario_email?: string | null, pod?: string | null, cer_alias?: string | null, cer_padre_alias?: string | null }> };

export type GetStagingLottiSubscriptionVariables = Exact<{
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
}>;


export type GetStagingLottiSubscription = { __typename?: 'subscription_root', staging_lotto: Array<{ __typename?: 'staging_lotto', id: any, nome?: string | null, created_at: any }> };

export type DeleteStagingSottoscrizioneMutationVariables = Exact<{
  where: Staging_Sottoscrizione_Bool_Exp;
}>;


export type DeleteStagingSottoscrizioneMutation = { __typename?: 'mutation_root', delete_staging_sottoscrizione?: { __typename?: 'staging_sottoscrizione_mutation_response', affected_rows: number } | null };

export type InsertOrUpdateStagingSottoscrizioneMutationVariables = Exact<{
  objects: Array<Staging_Sottoscrizione_Insert_Input> | Staging_Sottoscrizione_Insert_Input;
  on_conflict?: InputMaybe<Staging_Sottoscrizione_On_Conflict>;
}>;


export type InsertOrUpdateStagingSottoscrizioneMutation = { __typename?: 'mutation_root', insert_staging_sottoscrizione?: { __typename?: 'staging_sottoscrizione_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'staging_sottoscrizione', id: any }> } | null };

export type GetAzioniStagingSottoscrizioniQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAzioniStagingSottoscrizioniQuery = { __typename?: 'query_root', staging_azione_sottoscrizione: Array<{ __typename?: 'staging_azione_sottoscrizione', gruppo?: string | null, id: any, label: string, regole?: any | null, stato_di_arrivo?: string | null, attivo: boolean }> };

export type GetCersPerStagingQueryVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
  where1?: InputMaybe<Cer_Cabina_Bool_Exp>;
}>;


export type GetCersPerStagingQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any, alias?: string | null, documenti_richiesti?: any | null, domande_richieste?: any | null, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', id: any, cabina: { __typename?: 'energy_village_cabina', cod_ac?: string | null } }> }> };

export type GetLottiPerStagingQueryVariables = Exact<{
  where?: InputMaybe<Staging_Lotto_Bool_Exp>;
}>;


export type GetLottiPerStagingQuery = { __typename?: 'query_root', staging_lotto: Array<{ __typename?: 'staging_lotto', id: any, nome?: string | null, created_at: any }> };

export type GetStagingSottoscrizioneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetStagingSottoscrizioneQuery = { __typename?: 'query_root', staging_sottoscrizione_by_pk?: { __typename?: 'staging_sottoscrizione', azione?: any | null, stato?: string | null, data?: any | null, id: any, errore?: any | null, sottoscrizione_id?: any | null, lotto?: { __typename?: 'staging_lotto', id: any, nome?: string | null, created_at: any } | null } | null };

export type InsertOrUpdateStagingLottoMutationVariables = Exact<{
  objects?: InputMaybe<Array<Staging_Gestore_Lotto_Insert_Input> | Staging_Gestore_Lotto_Insert_Input>;
  on_conflict?: InputMaybe<Staging_Gestore_Lotto_On_Conflict>;
}>;


export type InsertOrUpdateStagingLottoMutation = { __typename?: 'mutation_root', insert_staging_gestore_lotto?: { __typename?: 'staging_gestore_lotto_mutation_response', returning: Array<{ __typename?: 'staging_gestore_lotto', id: any, lotto: { __typename?: 'staging_lotto', sottoscrizioni: Array<{ __typename?: 'staging_sottoscrizione', id: any }> } }> } | null };

export type SetOrUpdatePrivacyMutationVariables = Exact<{
  objects: Array<Admin_Consenso_Privacy_Insert_Input> | Admin_Consenso_Privacy_Insert_Input;
  on_conflict: Admin_Consenso_Privacy_On_Conflict;
}>;


export type SetOrUpdatePrivacyMutation = { __typename?: 'mutation_root', insert_admin_consenso_privacy?: { __typename?: 'admin_consenso_privacy_mutation_response', returning: Array<{ __typename?: 'admin_consenso_privacy', newsletter?: boolean | null, sondaggi_statistici?: boolean | null, comunicazioni_commerciali?: boolean | null, created_at: any, updated_at: any, id: any }> } | null };

export type GetPrivacyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrivacyQuery = { __typename?: 'query_root', admin_consenso_privacy: Array<{ __typename?: 'admin_consenso_privacy', newsletter?: boolean | null, sondaggi_statistici?: boolean | null, comunicazioni_commerciali?: boolean | null, created_at: any, updated_at: any, id: any }> };

export type GetReferralMutationVariables = Exact<{
  type?: InputMaybe<Admin__Type_Referral_Enum>;
}>;


export type GetReferralMutation = { __typename?: 'mutation_root', insert_admin_referral_one?: { __typename?: 'admin_referral', id: any } | null };

export type UseReferralMutationVariables = Exact<{
  referral_id: Scalars['uuid']['input'];
}>;


export type UseReferralMutation = { __typename?: 'mutation_root', insert_admin_utilizzo_referral_one?: { __typename?: 'admin_utilizzo_referral', id: any } | null };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'query_root', profilo: Array<{ __typename?: 'profilo', ambiti_attivita?: any | null, anno_fondazione?: any | null, area_geografica_operativa?: any | null, certificazioni?: string | null, created_at: any, id: any, interessi_specifici?: any | null, numero_dipendenti?: number | null, show_accesso_pro?: boolean | null, codice_amico?: string | null, referente_principale?: string | null, ruolo_referente?: string | null, sito_web?: string | null, target_clienti?: any | null, tipologia?: _Tipologia_Profilo_Enum | null, persona?: { __typename?: 'persona', id: any, codice_fiscale?: string | null, cognome?: string | null, nome?: string | null, partita_iva?: string | null, ragione_sociale?: string | null, data_nascita?: any | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string } }>, indirizzo?: { __typename?: 'indirizzo', id: any, geom_?: any | null, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', sigla?: string | null } | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number } | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any } | null } | null }> };

export type GetCodiceOperatoreQueryVariables = Exact<{
  where?: InputMaybe<Codice_Operatore_Bool_Exp>;
}>;


export type GetCodiceOperatoreQuery = { __typename?: 'query_root', codice_operatore: Array<{ __typename?: 'codice_operatore', codice: string }> };

export type GetNomeByAmicoCodeQueryVariables = Exact<{
  codice: Scalars['String']['input'];
}>;


export type GetNomeByAmicoCodeQuery = { __typename?: 'query_root', codice_operatore: Array<{ __typename?: 'codice_operatore', codice: string, user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } }> };

export type InsertOrUpdateProfileMutationVariables = Exact<{
  objects?: InputMaybe<Array<Profilo_Insert_Input> | Profilo_Insert_Input>;
  on_conflict?: InputMaybe<Profilo_On_Conflict>;
}>;


export type InsertOrUpdateProfileMutation = { __typename?: 'mutation_root', insert_profilo?: { __typename?: 'profilo_mutation_response', returning: Array<{ __typename?: 'profilo', ambiti_attivita?: any | null, anno_fondazione?: any | null, area_geografica_operativa?: any | null, certificazioni?: string | null, created_at: any, id: any, interessi_specifici?: any | null, numero_dipendenti?: number | null, show_accesso_pro?: boolean | null, codice_amico?: string | null, referente_principale?: string | null, ruolo_referente?: string | null, sito_web?: string | null, target_clienti?: any | null, tipologia?: _Tipologia_Profilo_Enum | null, persona?: { __typename?: 'persona', id: any, codice_fiscale?: string | null, cognome?: string | null, nome?: string | null, partita_iva?: string | null, ragione_sociale?: string | null, data_nascita?: any | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string } }>, indirizzo?: { __typename?: 'indirizzo', id: any, geom_?: any | null, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', sigla?: string | null } | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number } | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any } | null } | null }> } | null };

export type AccettaCondivisioneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AccettaCondivisioneMutation = { __typename?: 'mutation_root', condivisione_accetta: Array<{ __typename?: 'condivisione_accetta_response', success: boolean, message?: string | null, stato?: string | null, title?: string | null }> };

export type SearchSottoscrizioniSegnalatoreSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By> | Sottoscrizione_Order_By>;
}>;


export type SearchSottoscrizioniSegnalatoreSubscription = { __typename?: 'subscription_root', search_sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, cer_cabina?: { __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', alias?: string | null, logo?: { __typename?: 'files', id: any } | null } | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null, asset?: { __typename?: 'asset', alias?: string | null, potenza_effettiva: any, consumo?: any | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', icon: string } }>, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', label?: string | null, percentuale_autoconsumo?: any | null, icon?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null } | null } | null, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } }> } | null } | null }> };

export type SearchSottoscrizioniSegnalatoreCountSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
}>;


export type SearchSottoscrizioniSegnalatoreCountSubscription = { __typename?: 'subscription_root', search_sottoscrizioni_aggregate: { __typename?: 'sottoscrizione_aggregate', aggregate?: { __typename?: 'sottoscrizione_aggregate_fields', count: number } | null } };

export type SearchSottoscrizioniAmicoSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
}>;


export type SearchSottoscrizioniAmicoSubscription = { __typename?: 'subscription_root', search_sottoscrizioni: Array<{ __typename?: 'sottoscrizione', cer_cabina?: { __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', alias?: string | null, logo?: { __typename?: 'files', id: any } | null } | null } } | null }> };

export type GetAdminUtilizzoReferralSubscriptionVariables = Exact<{
  where?: InputMaybe<Admin_Utilizzo_Referral_Bool_Exp>;
}>;


export type GetAdminUtilizzoReferralSubscription = { __typename?: 'subscription_root', admin_utilizzo_referral: Array<{ __typename?: 'admin_utilizzo_referral', nuovo_utente?: { __typename?: 'auth_user_entity', last_name?: string | null, email?: string | null, first_name?: string | null, created_timestamp?: any | null } | null }> };

export type GetAmiciPresentatiQueryVariables = Exact<{
  args: Search_User_Entity_Args;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By> | Auth_User_Entity_Order_By>;
}>;


export type GetAmiciPresentatiQuery = { __typename?: 'query_root', search_user_entity: Array<{ __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, email?: string | null, created_timestamp?: any | null }> };

export type GetAmiciPresentatiCountQueryVariables = Exact<{
  args: Search_User_Entity_Args;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
}>;


export type GetAmiciPresentatiCountQuery = { __typename?: 'query_root', search_user_entity_aggregate: { __typename?: 'auth_user_entity_aggregate', aggregate?: { __typename?: 'auth_user_entity_aggregate_fields', count: number } | null } };

export type GetAmiciPresentatiCountSubscriptionSubscriptionVariables = Exact<{
  args: Search_User_Entity_Args;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
}>;


export type GetAmiciPresentatiCountSubscriptionSubscription = { __typename?: 'subscription_root', search_user_entity_aggregate: { __typename?: 'auth_user_entity_aggregate', aggregate?: { __typename?: 'auth_user_entity_aggregate_fields', count: number } | null } };

export type CheckPodAdesioniQueryVariables = Exact<{
  pods: Array<Scalars['String']['input']> | Scalars['String']['input'];
  codice_gse: Scalars['String']['input'];
}>;


export type CheckPodAdesioniQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', id: any, data_recesso?: any | null, data_ammissione?: any | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, regole?: any | null } | null, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null } | null }>, altriPods: Array<{ __typename?: 'sottoscrizione', id: any, data_recesso?: any | null, data_ammissione?: any | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, regole?: any | null } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null } | null }> };

export type GetCersSettingsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetCersSettingsSubscription = { __typename?: 'subscription_root', cer: Array<{ __typename?: 'cer', alias?: string | null, configurazioni: Array<{ __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }> }> }> };

export type SearchSottoscrizioniSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By> | Sottoscrizione_Order_By>;
}>;


export type SearchSottoscrizioniSubscription = { __typename?: 'subscription_root', search_sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, cer_cabina?: { __typename?: 'cer_cabina', stato?: string | null, codice_richiesta?: string | null, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, abilita_richieste: boolean, logo?: { __typename?: 'files', id: any } | null, whitelabel: Array<{ __typename?: 'white_label_associazione', configurazione: { __typename?: 'white_label_configurazione', referral: string } }>, cer_padre?: { __typename?: 'cer', alias?: string | null, logo?: { __typename?: 'files', id: any } | null } | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', tipo_contatto_id: any, value: string } }> } | null, asset?: { __typename?: 'asset', associato: boolean, opzionato: boolean, alias?: string | null, potenza_effettiva: any, consumo?: any | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', icon: string } }>, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', label?: string | null, percentuale_autoconsumo?: any | null, icon?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', geom_?: any | null } | null, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, username?: string | null } }>, condivisioni: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }> } | null } | null }> };

export type SearchSottoscrizioniCountSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
}>;


export type SearchSottoscrizioniCountSubscription = { __typename?: 'subscription_root', search_sottoscrizioni_aggregate: { __typename?: 'sottoscrizione_aggregate', aggregate?: { __typename?: 'sottoscrizione_aggregate_fields', count: number } | null } };

export type SearchSottoscrizioniStatiSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
}>;


export type SearchSottoscrizioniStatiSubscription = { __typename?: 'subscription_root', search_sottoscrizioni: Array<{ __typename?: 'sottoscrizione', stato: string }> };

export type GetSottoscrizioniFounderStatiSubscriptionVariables = Exact<{
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
}>;


export type GetSottoscrizioniFounderStatiSubscription = { __typename?: 'subscription_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', stato: string }> };

export type GetSottoscrizioneFounderSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSottoscrizioneFounderSubscription = { __typename?: 'subscription_root', sottoscrizione_by_pk?: { __typename?: 'sottoscrizione', id: any, stato: string, categoria_adesione?: any | null, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, iniziative: Array<{ __typename?: 'sottoscrizione_iniziativa', id: any, data_inizio: any, data_fine?: any | null, destinazione_contributo_id: any, cer_destinazione_contributo: { __typename?: 'cer_destinazione_contributo', id: any, descrizione: string } }>, cer_cabina?: { __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, domande: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id: any, name?: string | null } | null, documenti: Array<{ __typename?: 'sottoscrizione_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, referente_gse_nome?: string | null, referente_gse_email?: string | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null } | null };

export type CambiaStatoFounderMutationVariables = Exact<{
  args?: InputMaybe<Cambia_Stato_Founder_Args>;
}>;


export type CambiaStatoFounderMutation = { __typename?: 'mutation_root', cambia_stato_founder: Array<{ __typename?: 'sottoscrizione', stato: string }> };

export type GetCersSubscriptionVariables = Exact<{
  args?: Search_Cer_Args;
  where?: InputMaybe<Cer_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By> | Cer_Order_By>;
}>;


export type GetCersSubscription = { __typename?: 'subscription_root', cer: Array<{ __typename?: 'cer', id: any, stato_cer?: Energy_Village__Stato_Cer_Enum | null, alias?: string | null, attive: number, iniziative: number, produttori_dichiarati: number, impianti: number, potenza_dichiarata: number, potenza: number, consumatori_dichiarati: number, partecipanti: number, richieste: number, notifiche: number, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, logo?: { __typename?: 'files', id: any } | null }> };

export type GetCersCountSubscriptionVariables = Exact<{
  args?: Search_Cer_Args;
  where?: InputMaybe<Cer_Bool_Exp>;
}>;


export type GetCersCountSubscription = { __typename?: 'subscription_root', cer_aggregate: { __typename?: 'cer_aggregate', aggregate?: { __typename?: 'cer_aggregate_fields', count: number } | null } };

export type AddCerMutationVariables = Exact<{
  objects: Array<Cer_Gestore_Insert_Input> | Cer_Gestore_Insert_Input;
}>;


export type AddCerMutation = { __typename?: 'mutation_root', insert_cer_gestore?: { __typename?: 'cer_gestore_mutation_response', returning: Array<{ __typename?: 'cer_gestore', cer_id: any }> } | null };

export type InsertOrUpdateCerMutationVariables = Exact<{
  objects?: InputMaybe<Array<Cer_Insert_Input> | Cer_Insert_Input>;
  on_conflict?: InputMaybe<Cer_On_Conflict>;
  delete_destinazioni?: Cer_Destinazione_Contributo_Bool_Exp;
}>;


export type InsertOrUpdateCerMutation = { __typename?: 'mutation_root', delete_cer_destinazione_contributo?: { __typename?: 'cer_destinazione_contributo_mutation_response', affected_rows: number } | null, insert_cer?: { __typename?: 'cer_mutation_response', returning: Array<{ __typename?: 'cer', id: any, alias?: string | null, root_id?: any | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, soggetto_referente_gse?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, destinazioni_contributi: Array<{ __typename?: 'cer_destinazione_contributo', id: any, descrizione: string, iban?: string | null, ambito: string, persona?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, sesso?: string | null, data_nascita?: any | null, nazione_nascita_id?: number | null, citta_nascita_id?: any | null, ragione_sociale?: string | null, partita_iva?: string | null, codice_fiscale?: string | null, codice_ateco_id?: string | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null } | null } | null }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null }> } | null };

export type GetConfigurazioniCerSubscriptionVariables = Exact<{
  args?: Search_Cer_Args;
  where?: InputMaybe<Cer_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cer_Order_By> | Cer_Order_By>;
}>;


export type GetConfigurazioniCerSubscription = { __typename?: 'subscription_root', cer: Array<{ __typename?: 'cer', id: any, alias?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, mostra: boolean, abilita_richieste: boolean, impianti: number, potenza: number, partecipanti: number, richieste: number, notifiche: number, logo?: { __typename?: 'files', id: any } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, cer_cabina: Array<{ __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', cod_ac?: string | null } }> }> };

export type GetConfigurazioniCerCountSubscriptionVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
}>;


export type GetConfigurazioniCerCountSubscription = { __typename?: 'subscription_root', cer_aggregate: { __typename?: 'cer_aggregate', aggregate?: { __typename?: 'cer_aggregate_fields', count: number } | null } };

export type GetConfigurazioneFounderSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetConfigurazioneFounderSubscription = { __typename?: 'subscription_root', cer_by_pk?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, destinazioni_contributi_collegate: Array<{ __typename?: 'cer_configurazione_destinazione_contributo', id: any, destinazione_contributo_id: any }>, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, destinazioni_contributi: Array<{ __typename?: 'cer_destinazione_contributo', id: any, descrizione: string, persona?: { __typename?: 'persona', id: any, ragione_sociale?: string | null, nome?: string | null, cognome?: string | null } | null }>, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', id: any, stato?: string | null, codice_gse?: string | null, codice_richiesta?: string | null, codice_modifica?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, snapshot: Array<{ __typename?: 'cer_cabina_snapshot', id: any, tipo: string, sottoscrizione_id: any, created_at: any, sottoscrizione: { __typename?: 'sottoscrizione', id: any, stato: string, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null } }>, aderenti: Array<{ __typename?: 'sottoscrizione', id: any }>, pratiche_pod: Array<{ __typename?: 'sottoscrizione', id: any, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null } | null }>, pronte: Array<{ __typename?: 'sottoscrizione', id: any, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null }>, sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, updated_at: any, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null }> }> } | null };

export type InsertOrUpdateConfigurazioneMutationVariables = Exact<{
  objects?: InputMaybe<Array<Cer_Insert_Input> | Cer_Insert_Input>;
  on_conflict?: InputMaybe<Cer_On_Conflict>;
}>;


export type InsertOrUpdateConfigurazioneMutation = { __typename?: 'mutation_root', insert_cer?: { __typename?: 'cer_mutation_response', returning: Array<{ __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, destinazioni_contributi_collegate: Array<{ __typename?: 'cer_configurazione_destinazione_contributo', id: any, destinazione_contributo_id: any }>, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, destinazioni_contributi: Array<{ __typename?: 'cer_destinazione_contributo', id: any, descrizione: string, persona?: { __typename?: 'persona', id: any, ragione_sociale?: string | null, nome?: string | null, cognome?: string | null } | null }>, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', id: any, stato?: string | null, codice_gse?: string | null, codice_richiesta?: string | null, codice_modifica?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, snapshot: Array<{ __typename?: 'cer_cabina_snapshot', id: any, tipo: string, sottoscrizione_id: any, created_at: any, sottoscrizione: { __typename?: 'sottoscrizione', id: any, stato: string, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null } }>, aderenti: Array<{ __typename?: 'sottoscrizione', id: any }>, pratiche_pod: Array<{ __typename?: 'sottoscrizione', id: any, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null } | null }>, pronte: Array<{ __typename?: 'sottoscrizione', id: any, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null }>, sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, updated_at: any, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null } | null }> }> }> } | null };

export type ChiediPubblicazioneMutationVariables = Exact<{
  cer_id: Scalars['uuid']['input'];
}>;


export type ChiediPubblicazioneMutation = { __typename?: 'mutation_root', insert_admin_richiesta_pubblicazione?: { __typename?: 'admin_richiesta_pubblicazione_mutation_response', affected_rows: number } | null };

export type MostraMutationVariables = Exact<{
  cerid: Scalars['uuid']['input'];
}>;


export type MostraMutation = { __typename?: 'mutation_root', mostra: Array<{ __typename?: 'cer', id: any }> };

export type AbilitaRichiesteMutationVariables = Exact<{
  cerid: Scalars['uuid']['input'];
}>;


export type AbilitaRichiesteMutation = { __typename?: 'mutation_root', abilita_richieste: Array<{ __typename?: 'cer', id: any }> };

export type GetLogRipartizioneSubscriptionVariables = Exact<{
  ripartizione_id: Scalars['uuid']['input'];
}>;


export type GetLogRipartizioneSubscription = { __typename?: 'subscription_root', incentivi_log_ripartizione: Array<{ __typename?: 'incentivi_log_ripartizione', created_at: any, testo: string }> };

export type CalcoloRipartizioneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  calcolo: Scalars['String']['input'];
}>;


export type CalcoloRipartizioneMutation = { __typename?: 'mutation_root', update_incentivi_ripartizione_by_pk?: { __typename?: 'incentivi_ripartizione', id: any } | null };

export type InsertOrUpdateIncentivoMutationVariables = Exact<{
  objects?: InputMaybe<Array<Incentivi_Ripartizione_Insert_Input> | Incentivi_Ripartizione_Insert_Input>;
  on_conflict?: InputMaybe<Incentivi_Ripartizione_On_Conflict>;
}>;


export type InsertOrUpdateIncentivoMutation = { __typename?: 'mutation_root', insert_incentivi_ripartizione?: { __typename?: 'incentivi_ripartizione_mutation_response', affected_rows: number } | null };

export type UpdateCodiceGseMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  codice_gse: Scalars['String']['input'];
}>;


export type UpdateCodiceGseMutation = { __typename?: 'mutation_root', update_cer_cabina_by_pk?: { __typename?: 'cer_cabina', updated_at: any } | null };

export type InsertOrUpdatePersonaFounderMutationVariables = Exact<{
  objects?: InputMaybe<Array<Persona_Insert_Input> | Persona_Insert_Input>;
  on_conflict?: InputMaybe<Persona_On_Conflict>;
}>;


export type InsertOrUpdatePersonaFounderMutation = { __typename?: 'mutation_root', insert_persona?: { __typename?: 'persona_mutation_response', returning: Array<{ __typename?: 'persona', id: any, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null } | null }> } | null };

export type UpdatePersonaFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Persona_Set_Input;
}>;


export type UpdatePersonaFounderMutation = { __typename?: 'mutation_root', update_persona_by_pk?: { __typename?: 'persona', id: any } | null };

export type UpdateContattoFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Contatto_Set_Input;
}>;


export type UpdateContattoFounderMutation = { __typename?: 'mutation_root', update_contatto_by_pk?: { __typename?: 'contatto', id: any } | null };

export type UpdateAssetFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Asset_Set_Input;
}>;


export type UpdateAssetFounderMutation = { __typename?: 'mutation_root', update_asset_by_pk?: { __typename?: 'asset', id: any } | null };

export type UpdateAssetProduzioneFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Asset_Produzione_Set_Input;
}>;


export type UpdateAssetProduzioneFounderMutation = { __typename?: 'mutation_root', update_asset_produzione_by_pk?: { __typename?: 'asset_produzione', id: any } | null };

export type UpdateAssetProduzioneUnitaFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Asset_Produzione_Unita_Set_Input;
}>;


export type UpdateAssetProduzioneUnitaFounderMutation = { __typename?: 'mutation_root', update_asset_produzione_unita_by_pk?: { __typename?: 'asset_produzione_unita', id: any } | null };

export type UpdateAssetConsumoFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Asset_Consumo_Set_Input;
}>;


export type UpdateAssetConsumoFounderMutation = { __typename?: 'mutation_root', update_asset_consumo_by_pk?: { __typename?: 'asset_consumo', id: any } | null };

export type UpdateCondivisioneFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Condivisione_Condivisione_Set_Input;
}>;


export type UpdateCondivisioneFounderMutation = { __typename?: 'mutation_root', update_condivisione_condivisione_by_pk?: { __typename?: 'condivisione_condivisione', id: any } | null };

export type InsertIndirizzoFounderMutationVariables = Exact<{
  object: Indirizzo_Insert_Input;
  on_conflict?: InputMaybe<Indirizzo_On_Conflict>;
}>;


export type InsertIndirizzoFounderMutation = { __typename?: 'mutation_root', insert_indirizzo_one?: { __typename?: 'indirizzo', id: any, completo?: string | null, toponimo?: string | null, civico?: string | null, cap?: string | null, manuale: boolean, geom_?: any | null } | null };

export type UpdateIndirizzoFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Indirizzo_Set_Input;
}>;


export type UpdateIndirizzoFounderMutation = { __typename?: 'mutation_root', update_indirizzo_by_pk?: { __typename?: 'indirizzo', id: any, completo?: string | null, toponimo?: string | null, civico?: string | null, cap?: string | null, manuale: boolean, geom_?: any | null } | null };

export type GetCerFounderSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCerFounderSubscription = { __typename?: 'subscription_root', cer_by_pk?: { __typename?: 'cer', id: any, alias?: string | null, root_id?: any | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, soggetto_referente_gse?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, destinazioni_contributi: Array<{ __typename?: 'cer_destinazione_contributo', id: any, descrizione: string, iban?: string | null, ambito: string, persona?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, sesso?: string | null, data_nascita?: any | null, nazione_nascita_id?: number | null, citta_nascita_id?: any | null, ragione_sociale?: string | null, partita_iva?: string | null, codice_fiscale?: string | null, codice_ateco_id?: string | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null } | null } | null }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, referral: string, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } | null };

export type GetElencoDatiProduttoreFounderQueryVariables = Exact<{
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
}>;


export type GetElencoDatiProduttoreFounderQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, categoria_adesione?: any | null, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, cer_cabina?: { __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, domande: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id: any, name?: string | null } | null, documenti: Array<{ __typename?: 'sottoscrizione_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null }> };

export type GetExportElencoRichiesteFounderQueryVariables = Exact<{
  where: Sottoscrizione_Bool_Exp;
  abilita_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  accumulo_standalone?: InputMaybe<Scalars['Boolean']['input']>;
  aderenza_delibera_autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  aiuto?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['Boolean']['input']>;
  asset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_consumo?: InputMaybe<Scalars['Boolean']['input']>;
  asset_produzione?: InputMaybe<Scalars['Boolean']['input']>;
  associato?: InputMaybe<Scalars['Boolean']['input']>;
  attive?: InputMaybe<Scalars['Boolean']['input']>;
  auth?: InputMaybe<Scalars['Boolean']['input']>;
  autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  cabina?: InputMaybe<Scalars['Boolean']['input']>;
  cabina_ids?: InputMaybe<Scalars['Boolean']['input']>;
  cap?: InputMaybe<Scalars['Boolean']['input']>;
  capacita_batteria_prevista?: InputMaybe<Scalars['Boolean']['input']>;
  caratteristica?: InputMaybe<Scalars['Boolean']['input']>;
  caratteristiche?: InputMaybe<Scalars['Boolean']['input']>;
  categoria?: InputMaybe<Scalars['Boolean']['input']>;
  categoria_adesione?: InputMaybe<Scalars['Boolean']['input']>;
  categorie_adesione?: InputMaybe<Scalars['Boolean']['input']>;
  cer?: InputMaybe<Scalars['Boolean']['input']>;
  cer_cabina?: InputMaybe<Scalars['Boolean']['input']>;
  cer_categoria_adesione?: InputMaybe<Scalars['Boolean']['input']>;
  cer_categoria_adesione_produttore?: InputMaybe<Scalars['Boolean']['input']>;
  cer_padre?: InputMaybe<Scalars['Boolean']['input']>;
  chiesto?: InputMaybe<Scalars['Boolean']['input']>;
  citta?: InputMaybe<Scalars['Boolean']['input']>;
  citta_nascita?: InputMaybe<Scalars['Boolean']['input']>;
  civico?: InputMaybe<Scalars['Boolean']['input']>;
  cod_ac?: InputMaybe<Scalars['Boolean']['input']>;
  cod_censimp?: InputMaybe<Scalars['Boolean']['input']>;
  cod_richiesta_terna?: InputMaybe<Scalars['Boolean']['input']>;
  cod_up?: InputMaybe<Scalars['Boolean']['input']>;
  codice_ateco?: InputMaybe<Scalars['Boolean']['input']>;
  codice_ateco_id?: InputMaybe<Scalars['Boolean']['input']>;
  codice_fatturato_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  codice_fiscale?: InputMaybe<Scalars['Boolean']['input']>;
  codice_gse?: InputMaybe<Scalars['Boolean']['input']>;
  codice_sezione?: InputMaybe<Scalars['Boolean']['input']>;
  codice_univico_promotore?: InputMaybe<Scalars['Boolean']['input']>;
  cognome?: InputMaybe<Scalars['Boolean']['input']>;
  completo?: InputMaybe<Scalars['Boolean']['input']>;
  condivisioneInstallatore?: InputMaybe<Scalars['Boolean']['input']>;
  condivisioneProsumer?: InputMaybe<Scalars['Boolean']['input']>;
  condivisioneRecente?: InputMaybe<Scalars['Boolean']['input']>;
  configurazione?: InputMaybe<Scalars['Boolean']['input']>;
  configurazione_accumulo_id?: InputMaybe<Scalars['Boolean']['input']>;
  confirmo_id?: InputMaybe<Scalars['Boolean']['input']>;
  consumatori_dichiarati?: InputMaybe<Scalars['Boolean']['input']>;
  consumo?: InputMaybe<Scalars['Boolean']['input']>;
  contatti?: InputMaybe<Scalars['Boolean']['input']>;
  contatto?: InputMaybe<Scalars['Boolean']['input']>;
  contratto?: InputMaybe<Scalars['Boolean']['input']>;
  contributi_id?: InputMaybe<Scalars['Boolean']['input']>;
  costi?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['Boolean']['input']>;
  data_adesione_autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  data_allaccio_prevista?: InputMaybe<Scalars['Boolean']['input']>;
  data_ammissione?: InputMaybe<Scalars['Boolean']['input']>;
  data_associazione?: InputMaybe<Scalars['Boolean']['input']>;
  data_attivazione?: InputMaybe<Scalars['Boolean']['input']>;
  data_costituzione?: InputMaybe<Scalars['Boolean']['input']>;
  data_decorrenza_autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  data_disattivazione?: InputMaybe<Scalars['Boolean']['input']>;
  data_fine?: InputMaybe<Scalars['Boolean']['input']>;
  data_inizio?: InputMaybe<Scalars['Boolean']['input']>;
  data_installazione_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  data_nascita?: InputMaybe<Scalars['Boolean']['input']>;
  data_opzione?: InputMaybe<Scalars['Boolean']['input']>;
  data_recesso?: InputMaybe<Scalars['Boolean']['input']>;
  data_scadenza?: InputMaybe<Scalars['Boolean']['input']>;
  dati_consumo?: InputMaybe<Scalars['Boolean']['input']>;
  delibera_gse_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  denominazione?: InputMaybe<Scalars['Boolean']['input']>;
  descrizione?: InputMaybe<Scalars['Boolean']['input']>;
  dimensione?: InputMaybe<Scalars['Boolean']['input']>;
  dimensione_id?: InputMaybe<Scalars['Boolean']['input']>;
  dispositivo_inseguimento_solare?: InputMaybe<Scalars['Boolean']['input']>;
  documenti?: InputMaybe<Scalars['Boolean']['input']>;
  documenti_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  documenti_richiesti?: InputMaybe<Scalars['Boolean']['input']>;
  domande?: InputMaybe<Scalars['Boolean']['input']>;
  domande_richieste?: InputMaybe<Scalars['Boolean']['input']>;
  domenica_id?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  email_template?: InputMaybe<Scalars['Boolean']['input']>;
  energia_immessa?: InputMaybe<Scalars['Boolean']['input']>;
  ente?: InputMaybe<Scalars['Boolean']['input']>;
  esito_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  esposizione_prevalente_id?: InputMaybe<Scalars['Boolean']['input']>;
  f1?: InputMaybe<Scalars['Boolean']['input']>;
  f2?: InputMaybe<Scalars['Boolean']['input']>;
  f3?: InputMaybe<Scalars['Boolean']['input']>;
  feedback?: InputMaybe<Scalars['Boolean']['input']>;
  feedback_altro?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['Boolean']['input']>;
  foglio?: InputMaybe<Scalars['Boolean']['input']>;
  forma_giuridica?: InputMaybe<Scalars['Boolean']['input']>;
  forma_giuridica_cer_id?: InputMaybe<Scalars['Boolean']['input']>;
  geom?: InputMaybe<Scalars['Boolean']['input']>;
  geom_?: InputMaybe<Scalars['Boolean']['input']>;
  geom_obj?: InputMaybe<Scalars['Boolean']['input']>;
  gestori?: InputMaybe<Scalars['Boolean']['input']>;
  giovedi_id?: InputMaybe<Scalars['Boolean']['input']>;
  iban_accredito_incentivi?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  id_asset?: InputMaybe<Scalars['Boolean']['input']>;
  id_asset_consumo?: InputMaybe<Scalars['Boolean']['input']>;
  id_asset_produzione?: InputMaybe<Scalars['Boolean']['input']>;
  id_cabina?: InputMaybe<Scalars['Boolean']['input']>;
  id_caratteristica?: InputMaybe<Scalars['Boolean']['input']>;
  id_categoria_adesione?: InputMaybe<Scalars['Boolean']['input']>;
  id_cer?: InputMaybe<Scalars['Boolean']['input']>;
  id_cer_cabina?: InputMaybe<Scalars['Boolean']['input']>;
  id_cer_categoria_adesione?: InputMaybe<Scalars['Boolean']['input']>;
  id_cer_categoria_adesione_produttore?: InputMaybe<Scalars['Boolean']['input']>;
  id_cer_contatto?: InputMaybe<Scalars['Boolean']['input']>;
  id_citta?: InputMaybe<Scalars['Boolean']['input']>;
  id_codice_ateco?: InputMaybe<Scalars['Boolean']['input']>;
  id_condivisione?: InputMaybe<Scalars['Boolean']['input']>;
  id_configurazione?: InputMaybe<Scalars['Boolean']['input']>;
  id_contatto?: InputMaybe<Scalars['Boolean']['input']>;
  id_dati_consumo?: InputMaybe<Scalars['Boolean']['input']>;
  id_documenti_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  id_documento?: InputMaybe<Scalars['Boolean']['input']>;
  id_file?: InputMaybe<Scalars['Boolean']['input']>;
  id_forma_giuridica?: InputMaybe<Scalars['Boolean']['input']>;
  id_geom?: InputMaybe<Scalars['Boolean']['input']>;
  id_incentivo?: InputMaybe<Scalars['Boolean']['input']>;
  id_indirizzo?: InputMaybe<Scalars['Boolean']['input']>;
  id_nazione?: InputMaybe<Scalars['Boolean']['input']>;
  id_persona?: InputMaybe<Scalars['Boolean']['input']>;
  id_persona_contatto?: InputMaybe<Scalars['Boolean']['input']>;
  id_provincia?: InputMaybe<Scalars['Boolean']['input']>;
  id_sezione?: InputMaybe<Scalars['Boolean']['input']>;
  id_sottoscrizione?: InputMaybe<Scalars['Boolean']['input']>;
  id_spazi_disponibili?: InputMaybe<Scalars['Boolean']['input']>;
  id_tipo_area?: InputMaybe<Scalars['Boolean']['input']>;
  id_tipo_contatto?: InputMaybe<Scalars['Boolean']['input']>;
  id_tipologia_abitativa?: InputMaybe<Scalars['Boolean']['input']>;
  id_tipologia_asset?: InputMaybe<Scalars['Boolean']['input']>;
  id_tipologia_rappresentante?: InputMaybe<Scalars['Boolean']['input']>;
  id_titolo_autorizzativo?: InputMaybe<Scalars['Boolean']['input']>;
  id_unita?: InputMaybe<Scalars['Boolean']['input']>;
  id_user_entity?: InputMaybe<Scalars['Boolean']['input']>;
  id_whitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  impianti?: InputMaybe<Scalars['Boolean']['input']>;
  impianto?: InputMaybe<Scalars['Boolean']['input']>;
  incentivi?: InputMaybe<Scalars['Boolean']['input']>;
  incentivi_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  inclinazione_prevalente?: InputMaybe<Scalars['Boolean']['input']>;
  incompatibilita_incentivi_altro?: InputMaybe<Scalars['Boolean']['input']>;
  incompatibilita_incentivi_id?: InputMaybe<Scalars['Boolean']['input']>;
  indirizzo?: InputMaybe<Scalars['Boolean']['input']>;
  iniziative?: InputMaybe<Scalars['Boolean']['input']>;
  intestatario?: InputMaybe<Scalars['Boolean']['input']>;
  intestatario_conto_corrente?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['Boolean']['input']>;
  link_fascicolo?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Boolean']['input']>;
  logo_chiaro?: InputMaybe<Scalars['Boolean']['input']>;
  logo_scuro?: InputMaybe<Scalars['Boolean']['input']>;
  lunedi_id?: InputMaybe<Scalars['Boolean']['input']>;
  manuale?: InputMaybe<Scalars['Boolean']['input']>;
  martedi_id?: InputMaybe<Scalars['Boolean']['input']>;
  mercoledi_id?: InputMaybe<Scalars['Boolean']['input']>;
  modulo_richiesta?: InputMaybe<Scalars['Boolean']['input']>;
  mostra?: InputMaybe<Scalars['Boolean']['input']>;
  motivanzione_no_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  nazione_nascita?: InputMaybe<Scalars['Boolean']['input']>;
  nome?: InputMaybe<Scalars['Boolean']['input']>;
  notifiche?: InputMaybe<Scalars['Boolean']['input']>;
  opzionato?: InputMaybe<Scalars['Boolean']['input']>;
  pannelli_bifacciali?: InputMaybe<Scalars['Boolean']['input']>;
  partecipanti?: InputMaybe<Scalars['Boolean']['input']>;
  particella?: InputMaybe<Scalars['Boolean']['input']>;
  partita_iva?: InputMaybe<Scalars['Boolean']['input']>;
  percentuale_autoconsumo?: InputMaybe<Scalars['Boolean']['input']>;
  persona?: InputMaybe<Scalars['Boolean']['input']>;
  pod?: InputMaybe<Scalars['Boolean']['input']>;
  posizione_esatta?: InputMaybe<Scalars['Boolean']['input']>;
  potenza?: InputMaybe<Scalars['Boolean']['input']>;
  potenza_batteria?: InputMaybe<Scalars['Boolean']['input']>;
  potenza_dichiarata?: InputMaybe<Scalars['Boolean']['input']>;
  potenza_effettiva?: InputMaybe<Scalars['Boolean']['input']>;
  potenza_impianto_prevista?: InputMaybe<Scalars['Boolean']['input']>;
  prelievi_non_ausiliari?: InputMaybe<Scalars['Boolean']['input']>;
  presenza_accumulo?: InputMaybe<Scalars['Boolean']['input']>;
  produttori_dichiarati?: InputMaybe<Scalars['Boolean']['input']>;
  profiloInstallatore?: InputMaybe<Scalars['Boolean']['input']>;
  promotore?: InputMaybe<Scalars['Boolean']['input']>;
  protocollo?: InputMaybe<Scalars['Boolean']['input']>;
  provincia?: InputMaybe<Scalars['Boolean']['input']>;
  pubblicata?: InputMaybe<Scalars['Boolean']['input']>;
  quota_incentivo?: InputMaybe<Scalars['Boolean']['input']>;
  quota_potenza_rinnovabili_obbligo?: InputMaybe<Scalars['Boolean']['input']>;
  ragione_sociale?: InputMaybe<Scalars['Boolean']['input']>;
  rappresentante_legale?: InputMaybe<Scalars['Boolean']['input']>;
  realizzando_impianto?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['Boolean']['input']>;
  regolamento?: InputMaybe<Scalars['Boolean']['input']>;
  regole?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_iban?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_modello_unico?: InputMaybe<Scalars['Boolean']['input']>;
  richiesta_pnrr?: InputMaybe<Scalars['Boolean']['input']>;
  richieste?: InputMaybe<Scalars['Boolean']['input']>;
  richieste_pubblicazione?: InputMaybe<Scalars['Boolean']['input']>;
  rispetto_principio_dns?: InputMaybe<Scalars['Boolean']['input']>;
  risposta?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Scalars['Boolean']['input']>;
  sabato_id?: InputMaybe<Scalars['Boolean']['input']>;
  scambio_su_posto?: InputMaybe<Scalars['Boolean']['input']>;
  segnalatore?: InputMaybe<Scalars['Boolean']['input']>;
  sesso?: InputMaybe<Scalars['Boolean']['input']>;
  sezione_catastale?: InputMaybe<Scalars['Boolean']['input']>;
  sezioni?: InputMaybe<Scalars['Boolean']['input']>;
  sigla?: InputMaybe<Scalars['Boolean']['input']>;
  societa?: InputMaybe<Scalars['Boolean']['input']>;
  sottoscrizione_id?: InputMaybe<Scalars['Boolean']['input']>;
  spazi_disponibili?: InputMaybe<Scalars['Boolean']['input']>;
  spazio_disponibile?: InputMaybe<Scalars['Boolean']['input']>;
  stato?: InputMaybe<Scalars['Boolean']['input']>;
  stato_cer?: InputMaybe<Scalars['Boolean']['input']>;
  statuto?: InputMaybe<Scalars['Boolean']['input']>;
  subalterno?: InputMaybe<Scalars['Boolean']['input']>;
  terms?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_area?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_contatto?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_contatto_id?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_pod_id?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_promotore_id?: InputMaybe<Scalars['Boolean']['input']>;
  tipo_titolo_id?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_abitativa?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_asset?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_asset_padre?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_documento?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_domanda?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_impianto_id?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_prosumer?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_rappresentante?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_rappresentante_id?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_richiesta?: InputMaybe<Scalars['Boolean']['input']>;
  tipologia_sito_impianto_id?: InputMaybe<Scalars['Boolean']['input']>;
  titoli_autorizzativi?: InputMaybe<Scalars['Boolean']['input']>;
  toponimo?: InputMaybe<Scalars['Boolean']['input']>;
  ubicazione_impianto_aderente?: InputMaybe<Scalars['Boolean']['input']>;
  unita?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Boolean']['input']>;
  user_entity?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['Boolean']['input']>;
  usufruito_incentivi_rilancio?: InputMaybe<Scalars['Boolean']['input']>;
  utente?: InputMaybe<Scalars['Boolean']['input']>;
  validation?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
  venerdi_id?: InputMaybe<Scalars['Boolean']['input']>;
  visibilita_nome?: InputMaybe<Scalars['Boolean']['input']>;
  volantino?: InputMaybe<Scalars['Boolean']['input']>;
  white_label?: InputMaybe<Scalars['Boolean']['input']>;
  whitelabel?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetExportElencoRichiesteFounderQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', id?: any, stato?: string, categoria_adesione?: any | null, tipologia_richiesta?: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at?: any, updated_at?: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, cer_cabina?: { __typename?: 'cer_cabina', id?: any, codice_gse?: string | null, cabina?: { __typename?: 'energy_village_cabina', id?: number, cod_ac?: string | null }, cer?: { __typename?: 'cer', id?: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template?: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti?: number, consumatori_dichiarati?: number, impianti?: number, produttori_dichiarati?: number, potenza?: number, potenza_dichiarata?: number, data_costituzione?: any | null, referral?: string | null, pubblicata?: boolean, mostra?: boolean, abilita_richieste?: boolean, attive?: number, iniziative?: number, richieste?: number, notifiche?: number, white_label?: boolean, categorie_adesione?: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id?: any, regole?: any | null }>, geom_obj?: { __typename?: 'cer_geom', id?: any, cabina_ids?: any | null } | null, richieste_pubblicazione?: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato?: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at?: any }>, contatti?: Array<{ __typename?: 'cer_contatti', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel?: Array<{ __typename?: 'white_label_associazione', id?: any, configurazione?: { __typename?: 'white_label_configurazione', id?: any, terms?: { __typename?: 'files', id?: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id?: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id?: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id?: any, name?: string | null } | null, volantino?: { __typename?: 'files', id?: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id?: any, name?: string | null } | null, statuto?: { __typename?: 'files', id?: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id?: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template?: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti?: number, consumatori_dichiarati?: number, impianti?: number, produttori_dichiarati?: number, potenza?: number, potenza_dichiarata?: number, data_costituzione?: any | null, referral?: string | null, pubblicata?: boolean, mostra?: boolean, abilita_richieste?: boolean, attive?: number, iniziative?: number, richieste?: number, notifiche?: number, white_label?: boolean, categorie_adesione?: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id?: any, regole?: any | null }>, geom_obj?: { __typename?: 'cer_geom', id?: any, cabina_ids?: any | null } | null, richieste_pubblicazione?: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato?: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at?: any }>, contatti?: Array<{ __typename?: 'cer_contatti', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel?: Array<{ __typename?: 'white_label_associazione', id?: any, configurazione?: { __typename?: 'white_label_configurazione', id?: any, terms?: { __typename?: 'files', id?: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id?: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id?: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id?: any, name?: string | null } | null, volantino?: { __typename?: 'files', id?: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id?: any, name?: string | null } | null, statuto?: { __typename?: 'files', id?: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id?: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id?: any, categoria?: string | null } | null, domande?: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta?: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id?: any, name?: string | null } | null, documenti?: Array<{ __typename?: 'sottoscrizione_documenti', id?: any, tipologia_documento?: any | null, file?: { __typename?: 'files', id?: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity?: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id?: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo?: Array<{ __typename?: 'asset_dato_consumo', id?: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id?: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva?: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato?: boolean, sottoscrizione_id?: any | null, opzionato?: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista?: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche?: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome?: boolean, posizione_esatta?: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id?: number, cod_ac?: string | null } | null, condivisioneInstallatore?: Array<{ __typename?: 'condivisione_condivisione', id?: any, stato?: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore?: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti?: Array<{ __typename?: 'persona_contatto', contatto?: { __typename?: 'contatto', value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer?: Array<{ __typename?: 'condivisione_condivisione', id?: any, stato?: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente?: Array<{ __typename?: 'condivisione_condivisione', id?: any, nome?: string | null, email?: string | null }>, gestori?: Array<{ __typename?: 'asset_gestore', utente?: { __typename?: 'auth_user_entity', id?: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id?: any, label?: string | null } | null, spazi_disponibili?: Array<{ __typename?: 'asset_spazio', id?: any, dimensione?: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id?: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id?: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id?: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche?: Array<{ __typename?: 'asset_caratteristica', caratteristica?: { __typename?: 'energy_village_caratteristica', id?: any, label?: string | null, icon?: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id?: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id?: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id?: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id?: string, label?: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id?: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id?: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti?: Array<{ __typename?: 'persona_contatto', id?: any, contatto?: { __typename?: 'contatto', id?: any, tipo_contatto_id?: any, value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id?: any, name?: string | null } | null, documenti_pnrr?: Array<{ __typename?: 'pnrr_documenti', id?: any, tipologia_documento?: any | null, file?: { __typename?: 'files', id?: any, name?: string | null } }>, unita?: Array<{ __typename?: 'asset_produzione_unita', id?: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni?: Array<{ __typename?: 'asset_produzione_unita_sezione', id?: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi?: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id?: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi?: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id?: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id?: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva?: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato?: boolean, sottoscrizione_id?: any | null, opzionato?: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista?: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche?: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome?: boolean, posizione_esatta?: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id?: number, cod_ac?: string | null } | null, condivisioneInstallatore?: Array<{ __typename?: 'condivisione_condivisione', id?: any, stato?: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore?: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti?: Array<{ __typename?: 'persona_contatto', contatto?: { __typename?: 'contatto', value?: string, tipo_contatto?: { __typename?: 'anagrafica_tipo_contatto', id?: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer?: Array<{ __typename?: 'condivisione_condivisione', id?: any, stato?: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente?: Array<{ __typename?: 'condivisione_condivisione', id?: any, nome?: string | null, email?: string | null }>, gestori?: Array<{ __typename?: 'asset_gestore', utente?: { __typename?: 'auth_user_entity', id?: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id?: any, label?: string | null } | null, spazi_disponibili?: Array<{ __typename?: 'asset_spazio', id?: any, dimensione?: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id?: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id?: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id?: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id?: any, completo?: string | null, manuale?: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id?: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id?: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche?: Array<{ __typename?: 'asset_caratteristica', caratteristica?: { __typename?: 'energy_village_caratteristica', id?: any, label?: string | null, icon?: string } }> } | null } | null }> };

export type GetExportFlussoConsumatori2026FounderQueryVariables = Exact<{
  where: Sottoscrizione_Bool_Exp;
}>;


export type GetExportFlussoConsumatori2026FounderQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, codice_fiscale?: string | null, partita_iva?: string | null, ragione_sociale?: string | null, codice_ateco_id?: string | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string } | null, rappresentante_legale?: { __typename?: 'persona', partita_iva?: string | null } | null } | null } | null }> };

export type GetExportFlussoProduttoriGseFounderQueryVariables = Exact<{
  where?: InputMaybe<Sottoscrizione_Bool_Exp>;
}>;


export type GetExportFlussoProduttoriGseFounderQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null } | null, asset_produzione?: { __typename?: 'asset_produzione', cod_censimp?: string | null, data_adesione_autoconsumo?: any | null, aderenza_delibera_autoconsumo?: boolean | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, configurazione_accumulo_id?: any | null, ubicazione_impianto_aderente?: boolean | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, prelievi_non_ausiliari?: boolean | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null } | null } | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, partita_iva?: string | null, rappresentante_legale?: { __typename?: 'persona', partita_iva?: string | null } | null } | null, unita: Array<{ __typename?: 'asset_produzione_unita', cod_up?: string | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', rispetto_principio_dns?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, usufruito_incentivi_rilancio?: boolean | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }> } | null }> };

export type GetExportCustomFounderQueryVariables = Exact<{
  where: Sottoscrizione_Bool_Exp;
}>;


export type GetExportCustomFounderQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, data_recesso?: any | null, codice_univico_promotore?: string | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, cer_cabina?: { __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', cod_ac?: string | null }, cer: { __typename?: 'cer', alias?: string | null, cer_padre?: { __typename?: 'cer', alias?: string | null } | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, accumulo_standalone?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, partita_iva?: string | null, sesso?: string | null, data_nascita?: any | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', denominazione?: string | null } | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', sigla?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', tipo_contatto_id: any, value: string } }>, rappresentante_legale?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, codice_fiscale?: string | null, data_nascita?: any | null, sesso?: string | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', denominazione?: string | null } | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', sigla?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', tipo_contatto_id: any, value: string } }> } | null } | null, asset?: { __typename?: 'asset', alias?: string | null, consumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, data_installazione_impianto?: any | null, incentivi_impianto?: any | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null } | null } | null, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, email?: string | null } }>, condivisioni: Array<{ __typename?: 'condivisione_condivisione', nome?: string | null, email?: string | null }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, potenza_batteria?: any | null, cod_censimp?: string | null, cod_richiesta_terna?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null } | null } | null, asset?: { __typename?: 'asset', condivisioni: Array<{ __typename?: 'condivisione_condivisione', nome?: string | null, email?: string | null }> } | null, unita: Array<{ __typename?: 'asset_produzione_unita', cod_up?: string | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', codice_sezione?: string | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', rispetto_principio_dns?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, usufruito_incentivi_rilancio?: boolean | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }> } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', categoria?: string | null } | null, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null }> };

export type ClearCerNotificationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ClearCerNotificationMutation = { __typename?: 'mutation_root', update_cer?: { __typename?: 'cer_mutation_response', affected_rows: number } | null };

export type GetElencoIncentiviByCerCabinaIdSubscriptionVariables = Exact<{
  cer_cabina_id: Scalars['uuid']['input'];
}>;


export type GetElencoIncentiviByCerCabinaIdSubscription = { __typename?: 'subscription_root', incentivi_ripartizione: Array<{ __typename?: 'incentivi_ripartizione', id: any, parametri: any, stato_calcolo?: Incentivi__Stato_Calcolo_Enum | null, data: any, misure?: any | null, calcolati?: any | null }> };

export type GetContrattoRidcQueryVariables = Exact<{
  cer_cabina_id: Scalars['uuid']['input'];
}>;


export type GetContrattoRidcQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', asset_produzione?: { __typename?: 'asset_produzione', asset_id?: any | null, contratto_ridc?: string | null } | null }> };

export type UpdateCerGeomMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Cer_Geom_Set_Input;
}>;


export type UpdateCerGeomMutation = { __typename?: 'mutation_root', update_cer_geom_by_pk?: { __typename?: 'cer_geom', id: any } | null };

export type GetConfigurazioneGeomQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetConfigurazioneGeomQuery = { __typename?: 'query_root', cer_geom_by_pk?: { __typename?: 'cer_geom', geom?: any | null } | null };

export type GetConfigurazioniCerListQueryVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
}>;


export type GetConfigurazioniCerListQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', alias?: string | null, configurazioni: Array<{ __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } }> }> }> };

export type ValidateReferralQueryVariables = Exact<{
  referral: Scalars['String']['input'];
}>;


export type ValidateReferralQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any }> };

export type ValidateReferralEditQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  referral: Scalars['String']['input'];
}>;


export type ValidateReferralEditQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any }> };

export type InsertEmailMutationVariables = Exact<{
  destinatario: Scalars['String']['input'];
  oggetto: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type InsertEmailMutation = { __typename?: 'mutation_root', insert_comunicazioni_email_one?: { __typename?: 'comunicazioni_email', id: any } | null };

export type GetEmailTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Comunicazioni_Email_Template_Bool_Exp>;
}>;


export type GetEmailTemplatesQuery = { __typename?: 'query_root', comunicazioni_email_template: Array<{ __typename?: 'comunicazioni_email_template', id: any, nome: string, oggetto: string, message: string }> };

export type InsertEmailTemplateMutationVariables = Exact<{
  object: Comunicazioni_Email_Template_Insert_Input;
}>;


export type InsertEmailTemplateMutation = { __typename?: 'mutation_root', insert_comunicazioni_email_template_one?: { __typename?: 'comunicazioni_email_template', id: any, nome: string, oggetto: string, message: string } | null };

export type UpdateEmailTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  nome: Scalars['String']['input'];
  oggetto: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type UpdateEmailTemplateMutation = { __typename?: 'mutation_root', update_comunicazioni_email_template_by_pk?: { __typename?: 'comunicazioni_email_template', id: any, nome: string, oggetto: string, message: string } | null };

export type DeleteEmailTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'mutation_root', delete_comunicazioni_email_template_by_pk?: { __typename?: 'comunicazioni_email_template', id: any } | null };

export type GetEmailInviateQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<Comunicazioni_Email_Bool_Exp>;
  order_by?: InputMaybe<Array<Comunicazioni_Email_Order_By> | Comunicazioni_Email_Order_By>;
}>;


export type GetEmailInviateQuery = { __typename?: 'query_root', comunicazioni_email_aggregate: { __typename?: 'comunicazioni_email_aggregate', aggregate?: { __typename?: 'comunicazioni_email_aggregate_fields', count: number } | null }, comunicazioni_email: Array<{ __typename?: 'comunicazioni_email', id: any, created_at: any, destinatario: string, oggetto: string, message: string, stato: string }> };

export type InsertSmsMutationVariables = Exact<{
  cer_id: Scalars['uuid']['input'];
  cellulare: Scalars['String']['input'];
  message: Scalars['String']['input'];
  stato: Scalars['String']['input'];
}>;


export type InsertSmsMutation = { __typename?: 'mutation_root', insert_comunicazioni_sms_one?: { __typename?: 'comunicazioni_sms', id: any } | null };

export type GetListaUtentiFounderQueryVariables = Exact<{
  args: Search_User_Entity_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By> | Auth_User_Entity_Order_By>;
}>;


export type GetListaUtentiFounderQuery = { __typename?: 'query_root', search_user_entity: Array<{ __typename?: 'auth_user_entity', email?: string | null, first_name?: string | null, last_name?: string | null, user_attributes: Array<{ __typename?: 'auth_user_attribute', white_label?: { __typename?: 'white_label_configurazione', referral: string } | null }>, profili: Array<{ __typename?: 'profilo', tipologia?: _Tipologia_Profilo_Enum | null }>, profilo_prosumer: Array<{ __typename?: 'profilo', codice_amico?: string | null }>, codice_operatore?: { __typename?: 'codice_operatore', codice: string } | null, consenso_privacy: Array<{ __typename?: 'admin_consenso_privacy', newsletter?: boolean | null, sondaggi_statistici?: boolean | null, comunicazioni_commerciali?: boolean | null }> }> };

export type GetListaUtentiFounderCountQueryVariables = Exact<{
  args: Search_User_Entity_Args;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
}>;


export type GetListaUtentiFounderCountQuery = { __typename?: 'query_root', search_user_entity_aggregate: { __typename?: 'auth_user_entity_aggregate', aggregate?: { __typename?: 'auth_user_entity_aggregate_fields', count: number } | null } };

export type GetWhiteLabelsListaUtentiFounderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhiteLabelsListaUtentiFounderQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', whitelabel: Array<{ __typename?: 'white_label_associazione', configurazione: { __typename?: 'white_label_configurazione', referral: string } }> }> };

export type GetCerSelectFounderQueryVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
  configurazioni?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCerSelectFounderQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any, alias?: string | null, configurazioni?: Array<{ __typename?: 'cer', id: any, alias?: string | null }> }> };

export type GetConfigurazioneIdFounderQueryVariables = Exact<{
  referral: Scalars['String']['input'];
}>;


export type GetConfigurazioneIdFounderQuery = { __typename?: 'query_root', white_label_configurazione: Array<{ __typename?: 'white_label_configurazione', id: any }> };

export type GetPresetFounderQueryVariables = Exact<{
  where?: InputMaybe<Preset_Bool_Exp>;
}>;


export type GetPresetFounderQuery = { __typename?: 'query_root', preset: Array<{ __typename?: 'preset', id: any, nome: string, colonne: any, filtro?: any | null, created_at: any }> };

export type InsertOrUpdatePresetFounderMutationVariables = Exact<{
  object: Preset_Insert_Input;
  on_conflict?: InputMaybe<Preset_On_Conflict>;
}>;


export type InsertOrUpdatePresetFounderMutation = { __typename?: 'mutation_root', insert_preset_one?: { __typename?: 'preset', id: any, nome: string, colonne: any, filtro?: any | null, created_at: any } | null };

export type DeletePresetFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePresetFounderMutation = { __typename?: 'mutation_root', delete_preset_by_pk?: { __typename?: 'preset', id: any } | null };

export type SetDestinazioniConfigurazioneMutationVariables = Exact<{
  cer_id: Scalars['uuid']['input'];
  keep_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  objects: Array<Cer_Configurazione_Destinazione_Contributo_Insert_Input> | Cer_Configurazione_Destinazione_Contributo_Insert_Input;
}>;


export type SetDestinazioniConfigurazioneMutation = { __typename?: 'mutation_root', delete_cer_configurazione_destinazione_contributo?: { __typename?: 'cer_configurazione_destinazione_contributo_mutation_response', affected_rows: number } | null, insert_cer_configurazione_destinazione_contributo?: { __typename?: 'cer_configurazione_destinazione_contributo_mutation_response', affected_rows: number } | null };

export type CambiaStatoCabinaFounderMutationVariables = Exact<{
  cercabinaid: Scalars['uuid']['input'];
  action: Scalars['String']['input'];
  codice?: InputMaybe<Scalars['String']['input']>;
}>;


export type CambiaStatoCabinaFounderMutation = { __typename?: 'mutation_root', cambia_stato_cabina: Array<{ __typename?: 'cer_cabina', id: any, stato?: string | null, codice_gse?: string | null, codice_richiesta?: string | null, codice_modifica?: string | null }> };

export type SalvaSnapshotCabinaFounderMutationVariables = Exact<{
  cer_cabina_id: Scalars['uuid']['input'];
  tipo: Scalars['String']['input'];
  objects: Array<Cer_Cabina_Snapshot_Insert_Input> | Cer_Cabina_Snapshot_Insert_Input;
}>;


export type SalvaSnapshotCabinaFounderMutation = { __typename?: 'mutation_root', delete_cer_cabina_snapshot?: { __typename?: 'cer_cabina_snapshot_mutation_response', affected_rows: number } | null, insert_cer_cabina_snapshot?: { __typename?: 'cer_cabina_snapshot_mutation_response', affected_rows: number } | null };

export type EliminaCabinaFounderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EliminaCabinaFounderMutation = { __typename?: 'mutation_root', update_cer_cabina?: { __typename?: 'cer_cabina_mutation_response', affected_rows: number } | null };

export type GetBilancioAssetSubscriptionVariables = Exact<{
  root_id: Scalars['uuid']['input'];
}>;


export type GetBilancioAssetSubscription = { __typename?: 'subscription_root', asset: Array<{ __typename?: 'asset', id: any, sottoscrizione_id?: any | null, alias?: string | null, impianto?: boolean | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null } | null } | null, energia: Array<{ __typename?: 'asset_energia', immessa?: any | null, prelevata?: any | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } }>, condivisioni: Array<{ __typename?: 'condivisione_condivisione', nome?: string | null, email?: string | null }>, indirizzo?: { __typename?: 'indirizzo', geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', provincia?: { __typename?: 'unita_amministrativa_provincia', area: string } | null } | null } | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, consumi: Array<{ __typename?: 'asset_consumo', pod?: string | null, sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, cer_cabina?: { __typename?: 'cer_cabina', cer: { __typename?: 'cer', id: any } } | null }> }> }> };

export type GetBilancioCabinePointsQueryVariables = Exact<{
  cabina_ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetBilancioCabinePointsQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, point?: any | null, cabina: { __typename?: 'energy_village_cabina', id: number } }> };

export type GetBilancioCabinaGeomQueryVariables = Exact<{
  cabina_id: Scalars['Int']['input'];
}>;


export type GetBilancioCabinaGeomQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', id: number, geom?: any | null, cabina: { __typename?: 'energy_village_cabina', id: number } }> };

export type GetFlussiGseQueryVariables = Exact<{
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Flussi_Gse_Flusso_Order_By> | Flussi_Gse_Flusso_Order_By>;
}>;


export type GetFlussiGseQuery = { __typename?: 'query_root', flussi_gse_flusso: Array<{ __typename?: 'flussi_gse_flusso', id: any, created_at: any, anno?: number | null, mese?: number | null, importo?: any | null, tipo_corrispettivo?: string | null, contratto_acc_cer?: string | null, soggetto_referente?: string | null, tipologia_calcolo_id?: any | null }> };

export type GetFlussiGseCountQueryVariables = Exact<{
  where?: InputMaybe<Flussi_Gse_Flusso_Bool_Exp>;
}>;


export type GetFlussiGseCountQuery = { __typename?: 'query_root', flussi_gse_flusso_aggregate: { __typename?: 'flussi_gse_flusso_aggregate', aggregate?: { __typename?: 'flussi_gse_flusso_aggregate_fields', count: number } | null } };

export type GetStatiFatturaGseQueryVariables = Exact<{
  where: Flussi_Gse_Flusso_Bool_Exp;
}>;


export type GetStatiFatturaGseQuery = { __typename?: 'query_root', flussi_gse_flusso: Array<{ __typename?: 'flussi_gse_flusso', stato_fattura?: string | null }> };

export type GetFlussoGseExpansionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFlussoGseExpansionQuery = { __typename?: 'query_root', flussi_gse_flusso_by_pk?: { __typename?: 'flussi_gse_flusso', id: any, nome: string, contratto_ridc?: string | null, data_pubblicazione?: any | null, stato_fattura?: string | null, data_fatturazione?: any | null, numero_fattura?: string | null, data_pagamento?: any | null, data_incasso?: any | null } | null };

export type GetFlussoGseQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFlussoGseQuery = { __typename?: 'query_root', flussi_gse_flusso_by_pk?: { __typename?: 'flussi_gse_flusso', id: any, nome: string, created_at: any, file_id: any, data: any } | null };

export type GetFlussiGseExportQueryVariables = Exact<{
  where: Flussi_Gse_Flusso_Bool_Exp;
  order_by?: InputMaybe<Array<Flussi_Gse_Flusso_Order_By> | Flussi_Gse_Flusso_Order_By>;
}>;


export type GetFlussiGseExportQuery = { __typename?: 'query_root', flussi_gse_flusso: Array<{ __typename?: 'flussi_gse_flusso', id: any, nome: string, created_at: any, anno?: number | null, mese?: number | null, importo?: any | null, tipo_corrispettivo?: string | null, contratto_acc_cer?: string | null, contratto_ridc?: string | null, soggetto_referente?: string | null, tipologia_calcolo_id?: any | null, data_pubblicazione?: any | null, stato_fattura?: string | null, data_fatturazione?: any | null, numero_fattura?: string | null, data_pagamento?: any | null, data_incasso?: any | null }>, flussi_gse_flusso_aggregate: { __typename?: 'flussi_gse_flusso_aggregate', aggregate?: { __typename?: 'flussi_gse_flusso_aggregate_fields', count: number } | null } };

export type FindFlussiGseDuplicatiQueryVariables = Exact<{
  where: Flussi_Gse_Flusso_Bool_Exp;
}>;


export type FindFlussiGseDuplicatiQuery = { __typename?: 'query_root', flussi_gse_flusso: Array<{ __typename?: 'flussi_gse_flusso', id: any, nome: string, data_pubblicazione?: any | null }> };

export type InsertFlussoGseMutationVariables = Exact<{
  object: Flussi_Gse_Flusso_Insert_Input;
}>;


export type InsertFlussoGseMutation = { __typename?: 'mutation_root', insert_flussi_gse_flusso_one?: { __typename?: 'flussi_gse_flusso', id: any, nome: string, created_at: any } | null };

export type DeleteFlussiGseMutationVariables = Exact<{
  where: Flussi_Gse_Flusso_Bool_Exp;
}>;


export type DeleteFlussiGseMutation = { __typename?: 'mutation_root', delete_flussi_gse_flusso?: { __typename?: 'flussi_gse_flusso_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'flussi_gse_flusso', id: any, file_id: any }> } | null };

export type GetSoggettiReferentiGseCerQueryVariables = Exact<{
  auth_id: Scalars['String']['input'];
}>;


export type GetSoggettiReferentiGseCerQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any, soggetto_referente_gse?: string | null }> };

export type GetGeomarketingConfigurazioniCerListQueryVariables = Exact<{
  where: Cer_Bool_Exp;
}>;


export type GetGeomarketingConfigurazioniCerListQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', alias?: string | null, configurazioni: Array<{ __typename?: 'cer', alias?: string | null, cer_cabina: Array<{ __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null, elenco_citta?: string | null } }> }> }> };

export type GetGeomarketingCabinaGeomQueryVariables = Exact<{
  _in?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetGeomarketingCabinaGeomQuery = { __typename?: 'query_root', energy_village_area: Array<{ __typename?: 'energy_village_area', geom?: any | null }> };

export type GetGeomarketingCitiesByCabinaGeomQueryVariables = Exact<{
  geom: Scalars['geometry']['input'];
}>;


export type GetGeomarketingCitiesByCabinaGeomQuery = { __typename?: 'query_root', unita_amministrativa_citta: Array<{ __typename?: 'unita_amministrativa_citta', denominazione?: string | null, geom?: any | null, provincia?: { __typename?: 'unita_amministrativa_provincia', sigla?: string | null } | null }> };

export type GetGeomarketingAssetsWithoutSubscriptionInCabinaQueryVariables = Exact<{
  where: Asset_Bool_Exp;
}>;


export type GetGeomarketingAssetsWithoutSubscriptionInCabinaQuery = { __typename?: 'query_root', asset: Array<{ __typename?: 'asset', alias?: string | null, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, email?: string | null, username?: string | null } }>, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null, toponimo?: string | null, civico?: string | null, cap?: string | null, manuale: boolean, geom?: any | null, geom_?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null } | null } | null }> };

export type CambiaStatoInstallatoreMutationVariables = Exact<{
  args?: InputMaybe<Cambia_Stato_Installatore_Args>;
}>;


export type CambiaStatoInstallatoreMutation = { __typename?: 'mutation_root', cambia_stato_installatore: Array<{ __typename?: 'sottoscrizione', stato: string }> };

export type GetSottoscrizioneInstallatoreSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSottoscrizioneInstallatoreSubscription = { __typename?: 'subscription_root', sottoscrizione_by_pk?: { __typename?: 'sottoscrizione', id: any, stato: string, categoria_adesione?: any | null, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, iniziative: Array<{ __typename?: 'sottoscrizione_iniziativa', id: any, data_inizio: any, data_fine?: any | null, destinazione_contributo_id: any, cer_destinazione_contributo: { __typename?: 'cer_destinazione_contributo', id: any, descrizione: string } }>, cer_cabina?: { __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, domande: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id: any, name?: string | null } | null, documenti: Array<{ __typename?: 'sottoscrizione_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, referente_gse_nome?: string | null, referente_gse_email?: string | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null } | null };

export type GetCerFilterOptionsInstallatoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCerFilterOptionsInstallatoreQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', cer_cabina?: { __typename?: 'cer_cabina', cer: { __typename?: 'cer', id: any, alias?: string | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null } | null } } | null }> };

export type GetSottoscrizioniInstallatoreCountSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
}>;


export type GetSottoscrizioniInstallatoreCountSubscription = { __typename?: 'subscription_root', search_sottoscrizioni_aggregate: { __typename?: 'sottoscrizione_aggregate', aggregate?: { __typename?: 'sottoscrizione_aggregate_fields', count: number } | null } };

export type GetSottoscrizioniInstallatoreSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By> | Sottoscrizione_Order_By>;
}>;


export type GetSottoscrizioniInstallatoreSubscription = { __typename?: 'subscription_root', search_sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, updated_at: any, cer_cabina?: { __typename?: 'cer_cabina', stato?: string | null, codice_richiesta?: string | null, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', cod_ac?: string | null }, cer: { __typename?: 'cer', alias?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, abilita_richieste: boolean, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', alias?: string | null, logo?: { __typename?: 'files', id: any } | null } | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null, asset?: { __typename?: 'asset', associato: boolean, opzionato: boolean, potenza_effettiva: any, alias?: string | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', icon: string } }>, indirizzo?: { __typename?: 'indirizzo', geom_?: any | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null } | null } | null, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, username?: string | null } }>, condivisioni: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }> } | null } | null }> };

export type GetAssetsSubscriptionVariables = Exact<{
  args: Search_Asset_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Order_By> | Asset_Order_By>;
}>;


export type GetAssetsSubscription = { __typename?: 'subscription_root', search_asset: Array<{ __typename?: 'asset', id: any, notifiche: number, has_sottoscrizioni_attive: boolean, alias?: string | null, autoconsumo?: any | null, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null, label?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null, label?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null, citta?: { __typename?: 'unita_amministrativa_citta', denominazione?: string | null } | null } | null, consumi: Array<{ __typename?: 'asset_consumo', sottoscrizioniAttive: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, confirmo_id?: string | null, cer_cabina?: { __typename?: 'cer_cabina', cer: { __typename?: 'cer', id: any, alias?: string | null, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', alias?: string | null, logo?: { __typename?: 'files', id: any } | null } | null } } | null }> }>, produzioni: Array<{ __typename?: 'asset_produzione', sottoscrizioniAttive: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, confirmo_id?: string | null, cer_cabina?: { __typename?: 'cer_cabina', cer: { __typename?: 'cer', id: any, alias?: string | null, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', alias?: string | null, logo?: { __typename?: 'files', id: any } | null } | null } } | null }> }> }> };

export type GetAssetsCountSubscriptionVariables = Exact<{
  args: Search_Asset_Args;
}>;


export type GetAssetsCountSubscription = { __typename?: 'subscription_root', search_asset_aggregate: { __typename?: 'asset_aggregate', aggregate?: { __typename?: 'asset_aggregate_fields', count: number } | null } };

export type GetAssetSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAssetSubscription = { __typename?: 'subscription_root', asset_by_pk?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any } }> } | null };

export type AddAssetMutationVariables = Exact<{
  objects: Array<Asset_Gestore_Insert_Input> | Asset_Gestore_Insert_Input;
}>;


export type AddAssetMutation = { __typename?: 'mutation_root', insert_asset_gestore?: { __typename?: 'asset_gestore_mutation_response', returning: Array<{ __typename?: 'asset_gestore', asset_id: any }> } | null };

export type InsertOrUpdateAssetsMutationVariables = Exact<{
  objects?: InputMaybe<Array<Asset_Insert_Input> | Asset_Insert_Input>;
  on_conflict?: InputMaybe<Asset_On_Conflict>;
}>;


export type InsertOrUpdateAssetsMutation = { __typename?: 'mutation_root', insert_asset?: { __typename?: 'asset_mutation_response', returning: Array<{ __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }>, consumi: Array<{ __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }> }>, produzioni: Array<{ __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }> }> }> } | null };

export type DeleteAssetMutationVariables = Exact<{
  where?: InputMaybe<Asset_Bool_Exp>;
}>;


export type DeleteAssetMutation = { __typename?: 'mutation_root', delete_asset?: { __typename?: 'asset_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'asset', id: any }> } | null };

export type ClearAssetNotificationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ClearAssetNotificationMutation = { __typename?: 'mutation_root', update_asset?: { __typename?: 'asset_mutation_response', affected_rows: number } | null };

export type GetSottoscrizioniProsumerSubscriptionVariables = Exact<{
  where: Sottoscrizione_Bool_Exp;
}>;


export type GetSottoscrizioniProsumerSubscription = { __typename?: 'subscription_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', id: any, cer_cabina?: { __typename?: 'cer_cabina', cer: { __typename?: 'cer', id: any, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', logo?: { __typename?: 'files', id: any } | null } | null } } | null }> };

export type GetCerDisponibiliProsumerSubscriptionVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
  where_cer_cabina?: InputMaybe<Cer_Cabina_Bool_Exp>;
  where_sottoscrizioni?: InputMaybe<Sottoscrizione_Bool_Exp>;
}>;


export type GetCerDisponibiliProsumerSubscription = { __typename?: 'subscription_root', cer: Array<{ __typename?: 'cer', id: any, abilita_richieste: boolean, alias?: string | null, partecipanti: number, richieste: number, consumatori_dichiarati: number, produttori_dichiarati: number, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', alias?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, logo?: { __typename?: 'files', id: any } | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', id: any, sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string }> }> }> };

export type GetSottoscrizioneProsumerSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSottoscrizioneProsumerSubscription = { __typename?: 'subscription_root', sottoscrizione_by_pk?: { __typename?: 'sottoscrizione', id: any, stato: string, categoria_adesione?: any | null, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, iniziative: Array<{ __typename?: 'sottoscrizione_iniziativa', id: any, data_inizio: any, data_fine?: any | null, destinazione_contributo_id: any, cer_destinazione_contributo: { __typename?: 'cer_destinazione_contributo', id: any, descrizione: string } }>, cer_cabina?: { __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, domande: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id: any, name?: string | null } | null, documenti: Array<{ __typename?: 'sottoscrizione_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, referente_gse_nome?: string | null, referente_gse_email?: string | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null } | null };

export type GetConfigurazioneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  cabina_id?: InputMaybe<Int_Comparison_Exp>;
}>;


export type GetConfigurazioneQuery = { __typename?: 'query_root', cer_by_pk?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null, cer_cabina: Array<{ __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } }> } | null };

export type CambiaStatoProsumerMutationVariables = Exact<{
  args?: InputMaybe<Cambia_Stato_Prosumer_Args>;
}>;


export type CambiaStatoProsumerMutation = { __typename?: 'mutation_root', cambia_stato_prosumer: Array<{ __typename?: 'sottoscrizione', stato: string }> };

export type InsertSottoscrizioneMutationVariables = Exact<{
  object: Sottoscrizione_Insert_Input;
}>;


export type InsertSottoscrizioneMutation = { __typename?: 'mutation_root', insert_sottoscrizione_one?: { __typename?: 'sottoscrizione', id: any, stato: string, categoria_adesione?: any | null, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, iniziative: Array<{ __typename?: 'sottoscrizione_iniziativa', id: any, data_inizio: any, data_fine?: any | null, destinazione_contributo_id: any, cer_destinazione_contributo: { __typename?: 'cer_destinazione_contributo', id: any, descrizione: string } }>, cer_cabina?: { __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, domande: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id: any, name?: string | null } | null, documenti: Array<{ __typename?: 'sottoscrizione_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null } | null };

export type InsertOrUpdateSottoscrizioneMutationVariables = Exact<{
  on_conflict: Sottoscrizione_On_Conflict;
  objects: Array<Sottoscrizione_Insert_Input> | Sottoscrizione_Insert_Input;
}>;


export type InsertOrUpdateSottoscrizioneMutation = { __typename?: 'mutation_root', insert_sottoscrizione?: { __typename?: 'sottoscrizione_mutation_response', returning: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, categoria_adesione?: any | null, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, iniziative: Array<{ __typename?: 'sottoscrizione_iniziativa', id: any, data_inizio: any, data_fine?: any | null, destinazione_contributo_id: any, cer_destinazione_contributo: { __typename?: 'cer_destinazione_contributo', id: any, descrizione: string } }>, cer_cabina?: { __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, domande: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id: any, name?: string | null } | null, documenti: Array<{ __typename?: 'sottoscrizione_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null }> } | null };

export type DeleteSottoscrizioneDocumentiMutationVariables = Exact<{
  where?: InputMaybe<Sottoscrizione_Documenti_Bool_Exp>;
}>;


export type DeleteSottoscrizioneDocumentiMutation = { __typename?: 'mutation_root', delete_sottoscrizione_documenti?: { __typename?: 'sottoscrizione_documenti_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'sottoscrizione_documenti', id: any }> } | null };

export type DeletePnrrDocumentiMutationVariables = Exact<{
  where?: InputMaybe<Pnrr_Documenti_Bool_Exp>;
}>;


export type DeletePnrrDocumentiMutation = { __typename?: 'mutation_root', delete_pnrr_documenti?: { __typename?: 'pnrr_documenti_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'pnrr_documenti', id: any }> } | null };

export type GetRipartizioniSubscriptionVariables = Exact<{
  cer_id: Scalars['uuid']['input'];
  sottoscrizione_id: Scalars['uuid']['input'];
}>;


export type GetRipartizioniSubscription = { __typename?: 'subscription_root', incentivi_calcolati: Array<{ __typename?: 'incentivi_calcolati', misure: any, aggregati: any, ripartizione: { __typename?: 'incentivi_ripartizione', data: any } }> };

export type GetRipartizioniTotaliSubscriptionVariables = Exact<{
  sottoscrizione_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetRipartizioniTotaliSubscription = { __typename?: 'subscription_root', incentivi_calcolati: Array<{ __typename?: 'incentivi_calcolati', sottoscrizione_id: any, aggregati: any }> };

export type CondividiAssetMutationVariables = Exact<{
  object: Condivisione_Condivisione_Insert_Input;
}>;


export type CondividiAssetMutation = { __typename?: 'mutation_root', insert_condivisione_condivisione_one?: { __typename?: 'condivisione_condivisione', id: any } | null };

export type CancellaCondivisioneAssetMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CancellaCondivisioneAssetMutation = { __typename?: 'mutation_root', update_condivisione_condivisione_by_pk?: { __typename?: 'condivisione_condivisione', id: any } | null };

export type GetAssetForSuperadminSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAssetForSuperadminSubscription = { __typename?: 'subscription_root', asset_by_pk?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, associato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_installazione_impianto?: any | null, data_allaccio_prevista?: any | null, spazio_disponibile?: boolean | null, incentivi_impianto?: any | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null };

export type GetListaUtentiSuperadminQueryVariables = Exact<{
  args: Search_User_Entity_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
  order_by?: InputMaybe<Array<Auth_User_Entity_Order_By> | Auth_User_Entity_Order_By>;
}>;


export type GetListaUtentiSuperadminQuery = { __typename?: 'query_root', search_user_entity: Array<{ __typename?: 'auth_user_entity', id: string, email?: string | null, first_name?: string | null, last_name?: string | null, user_attributes: Array<{ __typename?: 'auth_user_attribute', white_label?: { __typename?: 'white_label_configurazione', referral: string } | null }>, profili: Array<{ __typename?: 'profilo', tipologia?: _Tipologia_Profilo_Enum | null }>, profilo_prosumer: Array<{ __typename?: 'profilo', codice_amico?: string | null }>, codice_operatore?: { __typename?: 'codice_operatore', codice: string } | null, assets_aggregate: { __typename?: 'asset_gestore_aggregate', aggregate?: { __typename?: 'asset_gestore_aggregate_fields', count: number } | null }, consenso_privacy: Array<{ __typename?: 'admin_consenso_privacy', newsletter?: boolean | null, sondaggi_statistici?: boolean | null, comunicazioni_commerciali?: boolean | null }> }> };

export type GetListaUtentiSuperadminCountQueryVariables = Exact<{
  args: Search_User_Entity_Args;
  where?: InputMaybe<Auth_User_Entity_Bool_Exp>;
}>;


export type GetListaUtentiSuperadminCountQuery = { __typename?: 'query_root', search_user_entity_aggregate: { __typename?: 'auth_user_entity_aggregate', aggregate?: { __typename?: 'auth_user_entity_aggregate_fields', count: number } | null } };

export type GetListaCerSuperadminQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Cer_Bool_Exp>;
  order_by?: InputMaybe<Array<Cer_Order_By> | Cer_Order_By>;
}>;


export type GetListaCerSuperadminQuery = { __typename?: 'query_root', cer: Array<{ __typename?: 'cer', id: any, alias?: string | null, mostra: boolean, abilita_richieste: boolean, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum }>, gestori_aggregate: { __typename?: 'cer_gestore_aggregate', aggregate?: { __typename?: 'cer_gestore_aggregate_fields', count: number } | null }, gestori: Array<{ __typename?: 'cer_gestore', id: any, gestore: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, email?: string | null, id: string } }>, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, mostra: boolean, whitelabel: Array<{ __typename?: 'white_label_associazione', configurazione: { __typename?: 'white_label_configurazione', referral: string } }>, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum }>, gestori_aggregate: { __typename?: 'cer_gestore_aggregate', aggregate?: { __typename?: 'cer_gestore_aggregate_fields', count: number } | null }, gestori: Array<{ __typename?: 'cer_gestore', id: any, gestore: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, email?: string | null, id: string } }> } | null }> };

export type DeleteCerGestoreManyMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteCerGestoreManyMutation = { __typename?: 'mutation_root', delete_cer_gestore?: { __typename?: 'cer_gestore_mutation_response', affected_rows: number } | null };

export type AccettaPubblicazioneSuperadminMutationVariables = Exact<{
  cer_id: Scalars['uuid']['input'];
}>;


export type AccettaPubblicazioneSuperadminMutation = { __typename?: 'mutation_root', update_admin_richiesta_pubblicazione?: { __typename?: 'admin_richiesta_pubblicazione_mutation_response', affected_rows: number } | null };

export type UpdateCerFieldMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Cer_Set_Input;
}>;


export type UpdateCerFieldMutation = { __typename?: 'mutation_root', update_cer_by_pk?: { __typename?: 'cer', id: any, mostra: boolean, abilita_richieste: boolean } | null };

export type GetUtentiForGestoriQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUtentiForGestoriQuery = { __typename?: 'query_root', auth_user_entity: Array<{ __typename?: 'auth_user_entity', id: string, email?: string | null, first_name?: string | null, last_name?: string | null }> };

export type InsertCerGestoriMutationVariables = Exact<{
  objects: Array<Cer_Gestore_Insert_Input> | Cer_Gestore_Insert_Input;
}>;


export type InsertCerGestoriMutation = { __typename?: 'mutation_root', insert_cer_gestore?: { __typename?: 'cer_gestore_mutation_response', returning: Array<{ __typename?: 'cer_gestore', id: any }> } | null };

export type GetListaCerSuperadminCountQueryVariables = Exact<{
  where?: InputMaybe<Cer_Bool_Exp>;
}>;


export type GetListaCerSuperadminCountQuery = { __typename?: 'query_root', cer_aggregate: { __typename?: 'cer_aggregate', aggregate?: { __typename?: 'cer_aggregate_fields', count: number } | null } };

export type GetWhiteLabelsListaUtentiSuperadminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhiteLabelsListaUtentiSuperadminQuery = { __typename?: 'query_root', white_label_configurazione: Array<{ __typename?: 'white_label_configurazione', referral: string }> };

export type GetAssetsForUtenteSuperadminQueryVariables = Exact<{
  user_id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Asset_Gestore_Order_By> | Asset_Gestore_Order_By>;
}>;


export type GetAssetsForUtenteSuperadminQuery = { __typename?: 'query_root', auth_user_entity_by_pk?: { __typename?: 'auth_user_entity', assets: Array<{ __typename?: 'asset_gestore', asset: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, indirizzo?: { __typename?: 'indirizzo', completo?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null, label?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, icon?: string | null, label?: string | null } | null } | null } }> } | null, asset_gestore_aggregate: { __typename?: 'asset_gestore_aggregate', aggregate?: { __typename?: 'asset_gestore_aggregate_fields', count: number } | null } };

export type GetSottoscrizioniSuperadminQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<V_Superadmin_Sottoscrizioni_Bool_Exp>;
  order_by?: InputMaybe<Array<V_Superadmin_Sottoscrizioni_Order_By> | V_Superadmin_Sottoscrizioni_Order_By>;
}>;


export type GetSottoscrizioniSuperadminQuery = { __typename?: 'query_root', v_superadmin_sottoscrizioni: Array<{ __typename?: 'v_superadmin_sottoscrizioni', sottoscrizione_id?: any | null, created_at?: any | null, stato?: string | null, tipologia_richiesta?: string | null, pod?: string | null, asset_id?: any | null, intestatario_nome?: string | null, intestatario_cognome?: string | null, intestatario_ragione_sociale?: string | null, intestatario_codice_fiscale?: string | null, intestatario_partita_iva?: string | null, n_sottoscrizioni_stesso_pod?: any | null, n_asset_stesso_pod?: any | null, is_duplicato?: boolean | null, updated_at?: any | null, cer_alias?: string | null, cer_padre_alias?: string | null, cabina_cod_ac?: string | null, gestore_first_name?: string | null, gestore_last_name?: string | null, gestore_username?: string | null, condivisione_account_nome?: string | null, condivisione_account_email?: string | null, installatori?: any | null }>, v_superadmin_sottoscrizioni_aggregate: { __typename?: 'v_superadmin_sottoscrizioni_aggregate', aggregate?: { __typename?: 'v_superadmin_sottoscrizioni_aggregate_fields', count: number } | null } };

export type EliminaSottoscrizioneSuperadminMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EliminaSottoscrizioneSuperadminMutation = { __typename?: 'mutation_root', superadmin_elimina_sottoscrizione: Array<{ __typename?: '_superadmin_elimina_sottoscrizione_esito', sottoscrizione_id: any, modalita: string, asset_id?: any | null }> };

export type CambiaStatoTecnicoMutationVariables = Exact<{
  args?: InputMaybe<Cambia_Stato_Tecnico_Args>;
}>;


export type CambiaStatoTecnicoMutation = { __typename?: 'mutation_root', cambia_stato_tecnico: Array<{ __typename?: 'sottoscrizione', stato: string }> };

export type GetSottoscrizioneTecnicoSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSottoscrizioneTecnicoSubscription = { __typename?: 'subscription_root', sottoscrizione_by_pk?: { __typename?: 'sottoscrizione', id: any, stato: string, categoria_adesione?: any | null, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, data_ammissione?: any | null, created_at: any, updated_at: any, data_associazione?: any | null, data_opzione?: any | null, data_scadenza?: any | null, data_recesso?: any | null, iban_accredito_incentivi?: string | null, intestatario_conto_corrente?: string | null, codice_univico_promotore?: string | null, link_fascicolo?: string | null, confirmo_id?: string | null, feedback_altro?: string | null, iniziative: Array<{ __typename?: 'sottoscrizione_iniziativa', id: any, data_inizio: any, data_fine?: any | null, destinazione_contributo_id: any, cer_destinazione_contributo: { __typename?: 'cer_destinazione_contributo', id: any, descrizione: string } }>, cer_cabina?: { __typename?: 'cer_cabina', id: any, codice_gse?: string | null, cabina: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null }, cer: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null, domande_richieste?: any | null, documenti_richiesti?: any | null, costi?: any | null, modulo_richiesta?: any | null, email_template: any, richiesta_iban?: boolean | null, richiesta_iniziativa_sociale?: boolean | null, descrizione?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, partecipanti: number, consumatori_dichiarati: number, impianti: number, produttori_dichiarati: number, potenza: number, potenza_dichiarata: number, data_costituzione?: any | null, referral?: string | null, pubblicata: boolean, mostra: boolean, abilita_richieste: boolean, attive: number, iniziative: number, richieste: number, notifiche: number, white_label: boolean, categorie_adesione: Array<{ __typename?: 'cer_categoria_adesione', categoria?: string | null, tipologia?: any | null, tipologia_richiesta?: Array<string> | null, chiesto?: boolean | null, id: any, regole?: any | null }>, geom?: { __typename?: 'cer_geom', id: any, cabina_ids?: any | null } | null, richieste_pubblicazione: Array<{ __typename?: 'admin_richiesta_pubblicazione', stato: Admin__Stato_Richiesta_Pubblicazione_Enum, updated_at: any }>, contatti: Array<{ __typename?: 'cer_contatti', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, whitelabel: Array<{ __typename?: 'white_label_associazione', id: any, configurazione: { __typename?: 'white_label_configurazione', id: any, terms?: { __typename?: 'files', id: any, name?: string | null } | null, logo_chiaro?: { __typename?: 'files', id: any, name?: string | null } | null, logo_scuro?: { __typename?: 'files', id: any, name?: string | null } | null } }>, logo?: { __typename?: 'files', id: any, name?: string | null } | null, volantino?: { __typename?: 'files', id: any, name?: string | null } | null, regolamento?: { __typename?: 'files', id: any, name?: string | null } | null, statuto?: { __typename?: 'files', id: any, name?: string | null } | null, promotore?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, societa?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null } | null } } | null, cer_categoria_adesione?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, cer_categoria_adesione_produttore?: { __typename?: 'cer_categoria_adesione', id: any, categoria?: string | null } | null, domande: Array<{ __typename?: 'sottoscrizione_domande', tipologia_domanda?: any | null, risposta: boolean }>, feedback?: { __typename?: 'energy_village_feedback', label?: string | null } | null, contratto?: { __typename?: 'files', id: any, name?: string | null } | null, documenti: Array<{ __typename?: 'sottoscrizione_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, segnalatore?: { __typename?: 'codice_operatore', user_entity: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', id: any, pod?: string | null, tipo_pod_id?: any | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, sezione_catastale?: string | null, accumulo_standalone?: any | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, dati_consumo: Array<{ __typename?: 'asset_dato_consumo', id: any, f1?: any | null, f2?: any | null, f3?: any | null, data_inizio?: any | null, data_fine?: any | null }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null, asset_produzione?: { __typename?: 'asset_produzione', id: any, pod?: string | null, potenza_effettiva?: any | null, energia_immessa?: any | null, referente_gse_nome?: string | null, referente_gse_email?: string | null, richiesta_pnrr?: boolean | null, cod_richiesta_terna?: string | null, cod_censimp?: string | null, tipologia_impianto_id?: any | null, richiesta_modello_unico?: boolean | null, presenza_accumulo?: boolean | null, potenza_batteria?: any | null, sezione_catastale?: string | null, foglio?: string | null, particella?: string | null, subalterno?: string | null, ubicazione_impianto_aderente?: boolean | null, data_installazione_impianto?: any | null, configurazione_accumulo_id?: any | null, aderenza_delibera_autoconsumo?: boolean | null, data_adesione_autoconsumo?: any | null, prelievi_non_ausiliari?: boolean | null, codice_fatturato_pnrr?: string | null, motivanzione_no_pnrr?: string | null, esito_pnrr?: boolean | null, intestatario?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }>, rappresentante_legale?: { __typename?: 'persona', id: any, nome?: string | null, cognome?: string | null, ragione_sociale?: string | null, codice_fiscale?: string | null, sesso?: string | null, data_nascita?: any | null, forma_giuridica_cer_id?: any | null, tipo_promotore_id?: any | null, tipologia_rappresentante_id?: any | null, partita_iva?: string | null, codice_ateco_id?: string | null, citta_nascita?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null, nazione_nascita?: { __typename?: 'unita_amministrativa_nazione', id: number, denominazione?: string | null } | null, codice_ateco?: { __typename?: 'anagrafica_codice_ateco', id: string, label: string } | null, forma_giuridica?: { __typename?: 'anagrafica_forma_giuridica', id: any, label?: string | null, rules?: any | null } | null, tipologia_rappresentante?: { __typename?: 'anagrafica_tipologia_rappresentante', id: any, label?: string | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, contatti: Array<{ __typename?: 'persona_contatto', id: any, contatto: { __typename?: 'contatto', id: any, tipo_contatto_id: any, value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null, icon?: string | null, validation?: any | null } } }> } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, delibera_gse_pnrr?: { __typename?: 'files', id: any, name?: string | null } | null, documenti_pnrr: Array<{ __typename?: 'pnrr_documenti', id: any, tipologia_documento?: any | null, file: { __typename?: 'files', id: any, name?: string | null } }>, unita: Array<{ __typename?: 'asset_produzione_unita', id: any, cod_up?: string | null, data_attivazione?: any | null, data_disattivazione?: any | null, sezioni: Array<{ __typename?: 'asset_produzione_unita_sezione', id: any, codice_sezione?: string | null, data_decorrenza_autoconsumo?: any | null, incompatibilita_incentivi_id?: any | null, incompatibilita_incentivi_altro?: string | null, tipologia_sito_impianto_id?: any | null, dispositivo_inseguimento_solare?: boolean | null, pannelli_bifacciali?: boolean | null, esposizione_prevalente_id?: any | null, inclinazione_prevalente?: number | null, incentivi: Array<{ __typename?: 'asset_produzione_unita_sezione_incentivi', id: any, rispetto_principio_dns?: boolean | null, usufruito_incentivi_rilancio?: boolean | null, quota_potenza_rinnovabili_obbligo?: any | null, contributi_id?: any | null, quota_incentivo?: number | null }>, titoli_autorizzativi: Array<{ __typename?: 'asset_produzione_unita_sezione_titolo_autorizzativo', id: any, tipo_titolo_id?: any | null, ente?: string | null, protocollo?: any | null, data?: any | null }> }> }>, asset?: { __typename?: 'asset', id: any, alias?: string | null, consumo?: any | null, autoconsumo?: any | null, potenza_effettiva: any, potenza_batteria?: any | null, dimensione_id?: any | null, data_installazione_impianto?: any | null, associato: boolean, sottoscrizione_id?: any | null, opzionato: boolean, impianto?: boolean | null, realizzando_impianto?: boolean | null, aiuto?: boolean | null, potenza_impianto_prevista: any, capacita_batteria_prevista?: any | null, data_allaccio_prevista?: any | null, notifiche: number, spazio_disponibile?: boolean | null, lunedi_id?: any | null, martedi_id?: any | null, mercoledi_id?: any | null, giovedi_id?: any | null, venerdi_id?: any | null, sabato_id?: any | null, domenica_id?: any | null, visibilita_nome: boolean, posizione_esatta: boolean, scambio_su_posto?: boolean | null, incentivi_impianto?: any | null, cabina?: { __typename?: 'energy_village_cabina', id: number, cod_ac?: string | null } | null, condivisioneInstallatore: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null, auth?: { __typename?: 'auth_user_entity', profiloInstallatore: Array<{ __typename?: 'profilo', persona?: { __typename?: 'persona', nome?: string | null, ragione_sociale?: string | null, contatti: Array<{ __typename?: 'persona_contatto', contatto: { __typename?: 'contatto', value: string, tipo_contatto: { __typename?: 'anagrafica_tipo_contatto', id: any, label?: string | null } } }> } | null }> } | null }>, condivisioneProsumer: Array<{ __typename?: 'condivisione_condivisione', id: any, stato: Condivisione__Stato_Condivisione_Enum, nome?: string | null, email?: string | null }>, condivisioneRecente: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }>, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', id: string, first_name?: string | null, last_name?: string | null, username?: string | null, email?: string | null } }>, tipologia_abitativa?: { __typename?: 'energy_village_tipologia_abitativa', id: any, label?: string | null } | null, spazi_disponibili: Array<{ __typename?: 'asset_spazio', id: any, dimensione: any, tipo_area?: { __typename?: 'energy_village_tipo_spazio_disponibile', id: any, label?: string | null } | null }>, dimensione?: { __typename?: 'energy_village_dimensione', label?: string | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', id: any, label?: string | null, icon?: string | null, percentuale_autoconsumo?: any | null, tipologia_prosumer?: string | null } | null } | null, indirizzo?: { __typename?: 'indirizzo', id: any, completo?: string | null, manuale: boolean, toponimo?: string | null, civico?: string | null, cap?: string | null, geom_?: any | null, geom?: any | null, citta?: { __typename?: 'unita_amministrativa_citta', id: any, denominazione?: string | null, provincia?: { __typename?: 'unita_amministrativa_provincia', id: any, denominazione?: string | null, sigla?: string | null } | null } | null } | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', id: any, label?: string | null, icon: string } }> } | null } | null } | null };

export type GetCerFilterOptionsTecnicoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCerFilterOptionsTecnicoQuery = { __typename?: 'query_root', sottoscrizione: Array<{ __typename?: 'sottoscrizione', cer_cabina?: { __typename?: 'cer_cabina', cer: { __typename?: 'cer', id: any, alias?: string | null, cer_padre?: { __typename?: 'cer', id: any, alias?: string | null } | null } } | null }> };

export type GetSottoscrizioniTecnicoCountSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
}>;


export type GetSottoscrizioniTecnicoCountSubscription = { __typename?: 'subscription_root', search_sottoscrizioni_aggregate: { __typename?: 'sottoscrizione_aggregate', aggregate?: { __typename?: 'sottoscrizione_aggregate_fields', count: number } | null } };

export type GetSottoscrizioniTecnicoSubscriptionVariables = Exact<{
  args: Search_Sottoscrizioni_Args;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sottoscrizione_Order_By> | Sottoscrizione_Order_By>;
}>;


export type GetSottoscrizioniTecnicoSubscription = { __typename?: 'subscription_root', search_sottoscrizioni: Array<{ __typename?: 'sottoscrizione', id: any, stato: string, tipologia_richiesta: _Sottoscrizione_Tipo_Richiesta_Enum, updated_at: any, cer_cabina?: { __typename?: 'cer_cabina', cabina: { __typename?: 'energy_village_cabina', cod_ac?: string | null }, cer: { __typename?: 'cer', alias?: string | null, stato_cer?: Energy_Village__Stato_Cer_Enum | null, abilita_richieste: boolean, logo?: { __typename?: 'files', id: any } | null, cer_padre?: { __typename?: 'cer', alias?: string | null, logo?: { __typename?: 'files', id: any } | null } | null } } | null, asset_consumo?: { __typename?: 'asset_consumo', pod?: string | null, intestatario?: { __typename?: 'persona', nome?: string | null, cognome?: string | null, ragione_sociale?: string | null } | null, asset?: { __typename?: 'asset', associato: boolean, opzionato: boolean, potenza_effettiva: any, alias?: string | null, caratteristiche: Array<{ __typename?: 'asset_caratteristica', caratteristica: { __typename?: 'energy_village_caratteristica', icon: string } }>, indirizzo?: { __typename?: 'indirizzo', geom_?: any | null } | null, tipologia_asset?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null, tipologia_asset_padre?: { __typename?: 'energy_village_tipologia_asset', icon?: string | null } | null } | null, gestori: Array<{ __typename?: 'asset_gestore', utente: { __typename?: 'auth_user_entity', first_name?: string | null, last_name?: string | null, username?: string | null } }>, condivisioni: Array<{ __typename?: 'condivisione_condivisione', id: any, nome?: string | null, email?: string | null }> } | null } | null }> };

export const CheckPodDuplicatoDocument = gql`
    query CheckPodDuplicato($pods: _text!, $tipologia: String!, $exclude_id: uuid, $include_staging: Boolean, $exclude_staging_id: uuid) {
  check_pod_duplicato(
    args: {p_pods: $pods, p_tipologia: $tipologia, p_exclude_id: $exclude_id, p_include_staging: $include_staging, p_exclude_staging_id: $exclude_staging_id}
  ) {
    pod
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckPodDuplicatoGQL extends Apollo.Query<CheckPodDuplicatoQuery, CheckPodDuplicatoQueryVariables> {
    document = CheckPodDuplicatoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PreviewPdfDocument = gql`
    mutation PreviewPdf($input: PreviewPdfInput!) {
  preview_pdf(input: $input) {
    base64_pdf
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PreviewPdfGQL extends Apollo.Mutation<PreviewPdfMutation, PreviewPdfMutationVariables> {
    document = PreviewPdfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCabinaDocument = gql`
    query GetCabina($where: energy_village_cabina_bool_exp = {}) {
  energy_village_cabina(where: $where) {
    id
    cod_ac
    elenco_citta
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCabinaGQL extends Apollo.Query<GetCabinaQuery, GetCabinaQueryVariables> {
    document = GetCabinaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCittaDocument = gql`
    query GetCitta {
  unita_amministrativa_citta(order_by: {denominazione_completa: asc}) {
    id
    codice_belfiore
    denominazione_completa
    denominazione
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCittaGQL extends Apollo.Query<GetCittaQuery, GetCittaQueryVariables> {
    document = GetCittaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCittaGeometryDocument = gql`
    query GetCittaGeometry($id: bigint!) {
  unita_amministrativa_citta_by_pk(id: $id) {
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCittaGeometryGQL extends Apollo.Query<GetCittaGeometryQuery, GetCittaGeometryQueryVariables> {
    document = GetCittaGeometryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCodiceAtecoDocument = gql`
    query GetCodiceAteco {
  anagrafica_codice_ateco(order_by: {id: asc}) {
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCodiceAtecoGQL extends Apollo.Query<GetCodiceAtecoQuery, GetCodiceAtecoQueryVariables> {
    document = GetCodiceAtecoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FeedbackDocument = gql`
    query Feedback {
  energy_village_feedback(order_by: {order: asc}) {
    id
    label
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FeedbackGQL extends Apollo.Query<FeedbackQuery, FeedbackQueryVariables> {
    document = FeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFormaGiuridicaDocument = gql`
    query GetFormaGiuridica {
  anagrafica_forma_giuridica(order_by: {order: asc}) {
    id
    label
    rules
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFormaGiuridicaGQL extends Apollo.Query<GetFormaGiuridicaQuery, GetFormaGiuridicaQueryVariables> {
    document = GetFormaGiuridicaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFormaGiuridicaCerDocument = gql`
    query GetFormaGiuridicaCer {
  anagrafica_forma_giuridica_cer(order_by: {order: asc}) {
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFormaGiuridicaCerGQL extends Apollo.Query<GetFormaGiuridicaCerQuery, GetFormaGiuridicaCerQueryVariables> {
    document = GetFormaGiuridicaCerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIncentivoImpiantoDocument = gql`
    query GetIncentivoImpianto {
  energy_village_incentivo_impianto(order_by: {order: asc}) {
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIncentivoImpiantoGQL extends Apollo.Query<GetIncentivoImpiantoQuery, GetIncentivoImpiantoQueryVariables> {
    document = GetIncentivoImpiantoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNazioneDocument = gql`
    query GetNazione {
  unita_amministrativa_nazione(order_by: [{order: asc}, {denominazione: asc}]) {
    id
    codice_belfiore
    denominazione
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNazioneGQL extends Apollo.Query<GetNazioneQuery, GetNazioneQueryVariables> {
    document = GetNazioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProvinciaDocument = gql`
    query GetProvincia {
  unita_amministrativa_provincia(order_by: {denominazione: asc}) {
    id
    denominazione
    sigla
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProvinciaGQL extends Apollo.Query<GetProvinciaQuery, GetProvinciaQueryVariables> {
    document = GetProvinciaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegioneDocument = gql`
    query GetRegione {
  unita_amministrativa_regione(order_by: {denominazione: asc}) {
    id
    denominazione
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegioneGQL extends Apollo.Query<GetRegioneQuery, GetRegioneQueryVariables> {
    document = GetRegioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTipoContattoDocument = gql`
    query GetTipoContatto {
  anagrafica_tipo_contatto(order_by: {order: asc}) {
    id
    label
    validation
    icon
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTipoContattoGQL extends Apollo.Query<GetTipoContattoQuery, GetTipoContattoQueryVariables> {
    document = GetTipoContattoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTipoPromotoreDocument = gql`
    query GetTipoPromotore {
  anagrafica_tipo_promotore(order_by: {order: asc}) {
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTipoPromotoreGQL extends Apollo.Query<GetTipoPromotoreQuery, GetTipoPromotoreQueryVariables> {
    document = GetTipoPromotoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTipoSpazioDisponibileDocument = gql`
    query GetTipoSpazioDisponibile {
  energy_village_tipo_spazio_disponibile(order_by: {order: asc}) {
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTipoSpazioDisponibileGQL extends Apollo.Query<GetTipoSpazioDisponibileQuery, GetTipoSpazioDisponibileQueryVariables> {
    document = GetTipoSpazioDisponibileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTipologieAssetDocument = gql`
    query GetTipologieAsset {
  energy_village_tipologia_asset(
    where: {root_id: {_is_null: true}}
    order_by: {order: desc}
  ) {
    id
    icon
    img
    label
    card_impianto
    tipologia
    order
    tipologia_asset_figli(order_by: {order: asc}) {
      id
      label
      profilo_consumo
      tipologia_asset_padre {
        id
        icon
        id
      }
      order
    }
    profilo_consumo
    orari(order_by: {order: asc}) {
      id
      label
      order
    }
    tipologie_abitativa(order_by: {order: asc}) {
      id
      label
      order
    }
    dimensioni(order_by: {order: asc}) {
      id
      label
      order
    }
    caratteristiche(order_by: {order: asc}) {
      id
      label
      description
      icon
      order
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTipologieAssetGQL extends Apollo.Query<GetTipologieAssetQuery, GetTipologieAssetQueryVariables> {
    document = GetTipologieAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTipologiaRappresentanteDocument = gql`
    query GetTipologiaRappresentante {
  anagrafica_tipologia_rappresentante(order_by: {order: asc}) {
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTipologiaRappresentanteGQL extends Apollo.Query<GetTipologiaRappresentanteQuery, GetTipologiaRappresentanteQueryVariables> {
    document = GetTipologiaRappresentanteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTitoloAutorizzativoDocument = gql`
    query GetTitoloAutorizzativo {
  energy_village_titolo_autorizzativo(order_by: {order: asc}) {
    id
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTitoloAutorizzativoGQL extends Apollo.Query<GetTitoloAutorizzativoQuery, GetTitoloAutorizzativoQueryVariables> {
    document = GetTitoloAutorizzativoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAreaCittaByPkDocument = gql`
    query GetAreaCittaByPk($id: bigint!) {
  energy_village_area_citta_by_pk(id: $id) {
    id
    geom
    cabina_ids
    citta {
      geom
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAreaCittaByPkGQL extends Apollo.Query<GetAreaCittaByPkQuery, GetAreaCittaByPkQueryVariables> {
    document = GetAreaCittaByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAreaProvinciaByPkDocument = gql`
    query GetAreaProvinciaByPk($id: bigint!) {
  energy_village_area_provincia_by_pk(id: $id) {
    id
    geom
    cabina_ids
    provincia {
      geom
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAreaProvinciaByPkGQL extends Apollo.Query<GetAreaProvinciaByPkQuery, GetAreaProvinciaByPkQueryVariables> {
    document = GetAreaProvinciaByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAreaRegioneByPkDocument = gql`
    query GetAreaRegioneByPk($id: bigint!) {
  energy_village_area_regione_by_pk(id: $id) {
    id
    geom
    cabina_ids
    regione {
      geom
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAreaRegioneByPkGQL extends Apollo.Query<GetAreaRegioneByPkQuery, GetAreaRegioneByPkQueryVariables> {
    document = GetAreaRegioneByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAreaByPkDocument = gql`
    query GetAreaByPk($id: Int!) {
  energy_village_area_by_pk(id: $id) {
    id
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAreaByPkGQL extends Apollo.Query<GetAreaByPkQuery, GetAreaByPkQueryVariables> {
    document = GetAreaByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCabinaIdByPointDocument = gql`
    query GetCabinaIdByPoint($point: geometry!) {
  energy_village_area(where: {geom: {_st_contains: $point}}) {
    id
    cabina {
      id
      cod_ac
      elenco_citta
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCabinaIdByPointGQL extends Apollo.Query<GetCabinaIdByPointQuery, GetCabinaIdByPointQueryVariables> {
    document = GetCabinaIdByPointDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCabinaByPointDocument = gql`
    query GetCabinaByPoint($point: geometry!, $id: Int = 0) {
  energy_village_area(
    where: {geom: {_st_contains: $point}, _and: {id: {_neq: $id}}}
  ) {
    id
    geom
    cabina {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCabinaByPointGQL extends Apollo.Query<GetCabinaByPointQuery, GetCabinaByPointQueryVariables> {
    document = GetCabinaByPointDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAreaCerByPkDocument = gql`
    query GetAreaCerByPk($id: uuid!) {
  cer_geom_by_pk(id: $id) {
    id
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAreaCerByPkGQL extends Apollo.Query<GetAreaCerByPkQuery, GetAreaCerByPkQueryVariables> {
    document = GetAreaCerByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetInCabinaIdsDocument = gql`
    subscription GetAssetInCabinaIds($cabina_ids: [Int!]) {
  asset(where: {cabina_id: {_in: $cabina_ids}}) {
    alias
    visibilita_nome
    cabina_id
    impianto
    tipologia_asset {
      id
      icon
      label
      tipologia_asset_padre {
        icon
      }
    }
    indirizzo {
      id
      geom
      completo
      toponimo
      civico
      cap
      manuale
      citta {
        denominazione
        provincia {
          sigla
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetInCabinaIdsGQL extends Apollo.Subscription<GetAssetInCabinaIdsSubscription, GetAssetInCabinaIdsSubscriptionVariables> {
    document = GetAssetInCabinaIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadConfirmoDocumentDocument = gql`
    query DownloadConfirmoDocument($id: uuid!) {
  confirmoGet(input: {id: $id}) {
    data
    success
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadConfirmoDocumentGQL extends Apollo.Query<DownloadConfirmoDocumentQuery, DownloadConfirmoDocumentQueryVariables> {
    document = DownloadConfirmoDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfirmoFirmaLinkDocument = gql`
    query GetConfirmoFirmaLink($id: uuid!) {
  confirmoGetFirma(input: {id: $id}) {
    data
    success
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfirmoFirmaLinkGQL extends Apollo.Query<GetConfirmoFirmaLinkQuery, GetConfirmoFirmaLinkQueryVariables> {
    document = GetConfirmoFirmaLinkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCittaByPointDocument = gql`
    query GetCittaByPoint($point: geometry!) {
  unita_amministrativa_citta(where: {geom: {_st_contains: $point}}) {
    id
    denominazione_completa
    abitanti
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCittaByPointGQL extends Apollo.Query<GetCittaByPointQuery, GetCittaByPointQueryVariables> {
    document = GetCittaByPointDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogoByTagDocument = gql`
    query getLogoByTag($tag: String!) {
  cer(where: {referral: {_eq: $tag}}) {
    whitelabel {
      configurazione {
        logo_chiaro {
          id
        }
        logo_scuro {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogoByTagGQL extends Apollo.Query<GetLogoByTagQuery, GetLogoByTagQueryVariables> {
    document = GetLogoByTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWhiteLabelByTagDocument = gql`
    query getWhiteLabelByTag($tag: String!) {
  white_label_configurazione(where: {referral: {_eq: $tag}}) {
    standard_login
    idps {
      tag
      label
      icon
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWhiteLabelByTagGQL extends Apollo.Query<GetWhiteLabelByTagQuery, GetWhiteLabelByTagQueryVariables> {
    document = GetWhiteLabelByTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTermsByTagDocument = gql`
    query getTermsByTag($tag: String!) {
  cer(where: {referral: {_eq: $tag}}) {
    alias
    whitelabel {
      configurazione {
        terms {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTermsByTagGQL extends Apollo.Query<GetTermsByTagQuery, GetTermsByTagQueryVariables> {
    document = GetTermsByTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParseBollettaDocument = gql`
    mutation ParseBolletta($input: ParseBollettaInput!) {
  parseBolletta(input: $input) {
    success
    data
    sottoscrizione {
      id
      data
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParseBollettaGQL extends Apollo.Mutation<ParseBollettaMutation, ParseBollettaMutationVariables> {
    document = ParseBollettaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioniFastDocument = gql`
    subscription GetConfigurazioniFast($where: cer_bool_exp = {}, $where1: cer_cabina_bool_exp = {}) {
  cer(where: $where) {
    id
    abilita_richieste
    documenti_richiesti
    cer_padre {
      alias
      descrizione
      stato_cer
      logo {
        id
      }
      regolamento {
        id
        name
      }
      volantino {
        id
        name
      }
      statuto {
        id
        name
      }
    }
    domande_richieste
    richiesta_iban
    richiesta_iniziativa_sociale
    alias
    descrizione
    stato_cer
    partecipanti
    richieste
    consumatori_dichiarati
    impianti
    produttori_dichiarati
    potenza
    potenza_dichiarata
    logo {
      id
      name
    }
    regolamento {
      id
      name
    }
    volantino {
      id
      name
    }
    cer_cabina(where: $where1) {
      id
      cabina {
        id
        cod_ac
      }
    }
    contatti {
      contatto {
        value
        tipo_contatto {
          id
          icon
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioniFastGQL extends Apollo.Subscription<GetConfigurazioniFastSubscription, GetConfigurazioniFastSubscriptionVariables> {
    document = GetConfigurazioniFastDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCerConfigurazioniSelectDocument = gql`
    query GetCerConfigurazioniSelect($where: cer_bool_exp = {}, $configurazioni: Boolean = false) {
  cer(where: $where, order_by: {alias: asc}) {
    id
    alias
    configurazioni(order_by: {alias: asc}) @skip(if: $configurazioni) {
      id
      alias
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCerConfigurazioniSelectGQL extends Apollo.Query<GetCerConfigurazioniSelectQuery, GetCerConfigurazioniSelectQueryVariables> {
    document = GetCerConfigurazioniSelectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDestinazioniCompatibiliDocument = gql`
    query GetDestinazioniCompatibili($cer_id: uuid!, $lng: float8, $lat: float8) {
  destinazioni_compatibili(args: {p_cer_id: $cer_id, p_lng: $lng, p_lat: $lat}) {
    id
    descrizione
    predefinita
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDestinazioniCompatibiliGQL extends Apollo.Query<GetDestinazioniCompatibiliQuery, GetDestinazioniCompatibiliQueryVariables> {
    document = GetDestinazioniCompatibiliDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCerDocument = gql`
    query GetCer($referral: String!) {
  cer(where: {referral: {_eq: $referral}}) {
    id
    stato_cer
    logo {
      id
      name
    }
    volantino {
      id
      name
    }
    regolamento {
      id
      name
    }
    statuto {
      id
      name
    }
    alias
    descrizione
    referral
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCerGQL extends Apollo.Query<GetCerQuery, GetCerQueryVariables> {
    document = GetCerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioniDocument = gql`
    subscription GetConfigurazioni($where: cer_bool_exp = {}) {
  cer(where: $where) {
    id
    abilita_richieste
    cer_padre {
      alias
      descrizione
      stato_cer
      logo {
        id
      }
      regolamento {
        id
        name
      }
      volantino {
        id
        name
      }
      statuto {
        id
        name
      }
    }
    alias
    descrizione
    stato_cer
    partecipanti
    richieste
    consumatori_dichiarati
    impianti
    produttori_dichiarati
    potenza
    potenza_dichiarata
    logo {
      id
      name
    }
    regolamento {
      id
      name
    }
    volantino {
      id
      name
    }
    cer_cabina {
      cabina {
        id
        cod_ac
      }
    }
    contatti {
      contatto {
        value
        tipo_contatto {
          id
          icon
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioniGQL extends Apollo.Subscription<GetConfigurazioniSubscription, GetConfigurazioniSubscriptionVariables> {
    document = GetConfigurazioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeomCabinaDocument = gql`
    query GetGeomCabina($_in: [Int!]) {
  energy_village_area(where: {id: {_in: $_in}}) {
    id
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeomCabinaGQL extends Apollo.Query<GetGeomCabinaQuery, GetGeomCabinaQueryVariables> {
    document = GetGeomCabinaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCabinePointsDocument = gql`
    query GetCabinePoints($cabina_ids: [Int!]) {
  energy_village_area(where: {cabina: {id: {_in: $cabina_ids}}}) {
    id
    point
    cabina {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCabinePointsGQL extends Apollo.Query<GetCabinePointsQuery, GetCabinePointsQueryVariables> {
    document = GetCabinePointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCabinaGeomDocument = gql`
    query GetCabinaGeom($cabina_id: Int!) {
  energy_village_area(where: {cabina: {id: {_eq: $cabina_id}}}) {
    id
    geom
    cabina {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCabinaGeomGQL extends Apollo.Query<GetCabinaGeomQuery, GetCabinaGeomQueryVariables> {
    document = GetCabinaGeomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBilancioCabineDocument = gql`
    query GetBilancioCabine($cabina_ids: [Int!]) {
  asset(
    where: {cabina: {id: {_in: $cabina_ids}}, consumi: {sottoscrizioni: {stato: {_nin: ["recessa", "recesso_richiesto", "disdetta_richiesta", "rifiutata"]}}}}
  ) {
    id
    cabina {
      id
    }
    tipologia_asset {
      tipologia_asset_padre {
        id
      }
    }
    energia(order_by: {created_at: desc}, limit: 1) {
      immessa
      prelevata
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBilancioCabineGQL extends Apollo.Query<GetBilancioCabineQuery, GetBilancioCabineQueryVariables> {
    document = GetBilancioCabineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetByCabinaIdDocument = gql`
    subscription GetAssetByCabinaId($cabina_id: Int!) {
  asset(where: {cabina: {id: {_eq: $cabina_id}}}) {
    alias
    visibilita_nome
    impianto
    tipologia_asset {
      id
      icon
      label
      tipologia_asset_padre {
        icon
      }
    }
    indirizzo {
      geom
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetByCabinaIdGQL extends Apollo.Subscription<GetAssetByCabinaIdSubscription, GetAssetByCabinaIdSubscriptionVariables> {
    document = GetAssetByCabinaIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeomConfigurazioniDocument = gql`
    query GetGeomConfigurazioni($_in: [uuid!]!) {
  cer_geom(where: {id: {_in: $_in}}) {
    id
    geom
    cer {
      alias
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeomConfigurazioniGQL extends Apollo.Query<GetGeomConfigurazioniQuery, GetGeomConfigurazioniQueryVariables> {
    document = GetGeomConfigurazioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCabineOverviewDocument = gql`
    query GetCabineOverview {
  energy_village_area {
    id
    point
    cabina {
      id
      cod_ac
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCabineOverviewGQL extends Apollo.Query<GetCabineOverviewQuery, GetCabineOverviewQueryVariables> {
    document = GetCabineOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartecipantiCabineDocument = gql`
    query GetPartecipantiCabine {
  cer_cabina {
    cabina_id
    cer {
      partecipanti
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartecipantiCabineGQL extends Apollo.Query<GetPartecipantiCabineQuery, GetPartecipantiCabineQueryVariables> {
    document = GetPartecipantiCabineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCabineByBboxDocument = gql`
    query GetCabineByBbox($bbox: geometry!) {
  energy_village_area(where: {geom: {_st_intersects: $bbox}}) {
    id
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCabineByBboxGQL extends Apollo.Query<GetCabineByBboxQuery, GetCabineByBboxQueryVariables> {
    document = GetCabineByBboxDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBilancioGlobaleDocument = gql`
    query GetBilancioGlobale {
  asset(
    where: {cabina_id: {_is_null: false}, consumi: {sottoscrizioni: {stato: {_nin: ["recessa", "recesso_richiesto", "disdetta_richiesta", "rifiutata"]}}}}
  ) {
    id
    cabina_id
    tipologia_asset {
      tipologia_asset_padre {
        id
      }
    }
    energia(order_by: {created_at: desc}, limit: 1) {
      immessa
      prelevata
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBilancioGlobaleGQL extends Apollo.Query<GetBilancioGlobaleQuery, GetBilancioGlobaleQueryVariables> {
    document = GetBilancioGlobaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioniLocaliDocument = gql`
    subscription GetConfigurazioniLocali($where: cer_bool_exp = {}) {
  cer(where: $where) {
    id
    alias
    descrizione
    stato_cer
    partecipanti
    richieste
    consumatori_dichiarati
    impianti
    produttori_dichiarati
    potenza
    potenza_dichiarata
    contatti {
      contatto {
        value
        tipo_contatto {
          id
          icon
        }
      }
    }
    cer_padre {
      referral
      logo {
        id
        name
      }
      volantino {
        id
        name
      }
      regolamento {
        id
        name
      }
      statuto {
        id
        name
      }
      alias
      descrizione
      stato_cer
    }
    logo {
      id
      name
    }
    volantino {
      id
      name
    }
    regolamento {
      id
      name
    }
    cer_cabina {
      cabina {
        id
        cod_ac
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioniLocaliGQL extends Apollo.Subscription<GetConfigurazioniLocaliSubscription, GetConfigurazioniLocaliSubscriptionVariables> {
    document = GetConfigurazioniLocaliDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCondivisioneCheckDocument = gql`
    query GetCondivisioneCheck {
  condivisione_condivisione(order_by: [{stato: desc}, {updated_at: desc}]) {
    id
    stato
    asset_alias
    asset_indirizzo
    proprietario {
      last_name
      first_name
      username
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCondivisioneCheckGQL extends Apollo.Query<GetCondivisioneCheckQuery, GetCondivisioneCheckQueryVariables> {
    document = GetCondivisioneCheckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AggiornaStatoCondivisioniDocument = gql`
    mutation AggiornaStatoCondivisioni($ids: [uuid!]!, $stato: condivisione__stato_condivisione_enum!, $utilizzatore_id: String!) {
  update_condivisione_condivisione(
    where: {id: {_in: $ids}, stato: {_eq: condiviso}}
    _set: {stato: $stato, utilizzatore_id: $utilizzatore_id}
  ) {
    affected_rows
    returning {
      id
      stato
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AggiornaStatoCondivisioniGQL extends Apollo.Mutation<AggiornaStatoCondivisioniMutation, AggiornaStatoCondivisioniMutationVariables> {
    document = AggiornaStatoCondivisioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshMvNowDocument = gql`
    mutation RefreshMvNow {
  staging_refresh_sottoscrizione_mv(args: {p_force: true}) {
    name
    dirty
    updated_at
    last_refresh_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshMvNowGQL extends Apollo.Mutation<RefreshMvNowMutation, RefreshMvNowMutationVariables> {
    document = RefreshMvNowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStagingSottoscrizioniDocument = gql`
    query GetStagingSottoscrizioni($where: staging_sottoscrizione_list_mv_bool_exp = {}) {
  staging_sottoscrizione_list_mv(
    where: $where
    order_by: [{created_at: asc}, {id: asc}]
  ) {
    id
    stato
    valido
    errore
    invalid_controls
    warning
    created_at
    updated_at
    lotto_id
    sottoscrizione_id
    azione
    lotto_nome
    azione_label
    azione_gruppo
    nome
    cognome
    email
    cellulare
    intestatario_email
    pod
    cer_alias
    cer_padre_alias
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStagingSottoscrizioniGQL extends Apollo.Query<GetStagingSottoscrizioniQuery, GetStagingSottoscrizioniQueryVariables> {
    document = GetStagingSottoscrizioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStagingLottiDocument = gql`
    subscription GetStagingLotti($where: staging_lotto_bool_exp = {}) {
  staging_lotto(order_by: {nome: asc}, where: $where) {
    id
    nome
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStagingLottiGQL extends Apollo.Subscription<GetStagingLottiSubscription, GetStagingLottiSubscriptionVariables> {
    document = GetStagingLottiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStagingSottoscrizioneDocument = gql`
    mutation DeleteStagingSottoscrizione($where: staging_sottoscrizione_bool_exp!) {
  delete_staging_sottoscrizione(where: $where) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStagingSottoscrizioneGQL extends Apollo.Mutation<DeleteStagingSottoscrizioneMutation, DeleteStagingSottoscrizioneMutationVariables> {
    document = DeleteStagingSottoscrizioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateStagingSottoscrizioneDocument = gql`
    mutation InsertOrUpdateStagingSottoscrizione($objects: [staging_sottoscrizione_insert_input!]!, $on_conflict: staging_sottoscrizione_on_conflict = {constraint: sottoscrizione_pkey}) {
  insert_staging_sottoscrizione(objects: $objects, on_conflict: $on_conflict) {
    affected_rows
    returning {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateStagingSottoscrizioneGQL extends Apollo.Mutation<InsertOrUpdateStagingSottoscrizioneMutation, InsertOrUpdateStagingSottoscrizioneMutationVariables> {
    document = InsertOrUpdateStagingSottoscrizioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAzioniStagingSottoscrizioniDocument = gql`
    query GetAzioniStagingSottoscrizioni {
  staging_azione_sottoscrizione(order_by: {order: asc}) {
    gruppo
    id
    label
    regole
    stato_di_arrivo
    attivo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAzioniStagingSottoscrizioniGQL extends Apollo.Query<GetAzioniStagingSottoscrizioniQuery, GetAzioniStagingSottoscrizioniQueryVariables> {
    document = GetAzioniStagingSottoscrizioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCersPerStagingDocument = gql`
    query GetCersPerStaging($where: cer_bool_exp = {}, $where1: cer_cabina_bool_exp = {}) {
  cer(where: $where) {
    id
    alias
    documenti_richiesti
    domande_richieste
    richiesta_iban
    richiesta_iniziativa_sociale
    categorie_adesione(order_by: {categoria: asc}) {
      categoria
      tipologia
      tipologia_richiesta
      chiesto
      id
      regole
    }
    cer_padre {
      id
      alias
    }
    cer_cabina(where: $where1) {
      id
      cabina {
        cod_ac
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCersPerStagingGQL extends Apollo.Query<GetCersPerStagingQuery, GetCersPerStagingQueryVariables> {
    document = GetCersPerStagingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLottiPerStagingDocument = gql`
    query GetLottiPerStaging($where: staging_lotto_bool_exp = {}) {
  staging_lotto(order_by: {nome: asc}, where: $where) {
    id
    nome
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLottiPerStagingGQL extends Apollo.Query<GetLottiPerStagingQuery, GetLottiPerStagingQueryVariables> {
    document = GetLottiPerStagingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStagingSottoscrizioneDocument = gql`
    query GetStagingSottoscrizione($id: uuid!) {
  staging_sottoscrizione_by_pk(id: $id) {
    azione
    stato
    data
    id
    errore
    lotto {
      id
      nome
      created_at
    }
    sottoscrizione_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStagingSottoscrizioneGQL extends Apollo.Query<GetStagingSottoscrizioneQuery, GetStagingSottoscrizioneQueryVariables> {
    document = GetStagingSottoscrizioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateStagingLottoDocument = gql`
    mutation InsertOrUpdateStagingLotto($objects: [staging_gestore_lotto_insert_input!] = {}, $on_conflict: staging_gestore_lotto_on_conflict = {constraint: gestore_lotto_pkey}) {
  insert_staging_gestore_lotto(objects: $objects, on_conflict: $on_conflict) {
    returning {
      id
      lotto {
        sottoscrizioni {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateStagingLottoGQL extends Apollo.Mutation<InsertOrUpdateStagingLottoMutation, InsertOrUpdateStagingLottoMutationVariables> {
    document = InsertOrUpdateStagingLottoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetOrUpdatePrivacyDocument = gql`
    mutation SetOrUpdatePrivacy($objects: [admin_consenso_privacy_insert_input!]!, $on_conflict: admin_consenso_privacy_on_conflict!) {
  insert_admin_consenso_privacy(objects: $objects, on_conflict: $on_conflict) {
    returning {
      newsletter
      sondaggi_statistici
      comunicazioni_commerciali
      created_at
      updated_at
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetOrUpdatePrivacyGQL extends Apollo.Mutation<SetOrUpdatePrivacyMutation, SetOrUpdatePrivacyMutationVariables> {
    document = SetOrUpdatePrivacyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPrivacyDocument = gql`
    query GetPrivacy {
  admin_consenso_privacy {
    newsletter
    sondaggi_statistici
    comunicazioni_commerciali
    created_at
    updated_at
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPrivacyGQL extends Apollo.Query<GetPrivacyQuery, GetPrivacyQueryVariables> {
    document = GetPrivacyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReferralDocument = gql`
    mutation GetReferral($type: admin__type_referral_enum = campagna) {
  insert_admin_referral_one(object: {type: $type}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReferralGQL extends Apollo.Mutation<GetReferralMutation, GetReferralMutationVariables> {
    document = GetReferralDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UseReferralDocument = gql`
    mutation UseReferral($referral_id: uuid!) {
  insert_admin_utilizzo_referral_one(object: {referral_id: $referral_id}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UseReferralGQL extends Apollo.Mutation<UseReferralMutation, UseReferralMutationVariables> {
    document = UseReferralDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileDocument = gql`
    query GetProfile {
  profilo {
    ambiti_attivita
    anno_fondazione
    area_geografica_operativa
    certificazioni
    created_at
    id
    interessi_specifici
    numero_dipendenti
    show_accesso_pro
    codice_amico
    persona {
      id
      codice_fiscale
      cognome
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
        }
      }
      indirizzo {
        id
        geom_
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          denominazione
          provincia {
            sigla
          }
        }
      }
      nome
      partita_iva
      ragione_sociale
      data_nascita
      nazione_nascita {
        id
      }
      citta_nascita {
        id
      }
    }
    referente_principale
    ruolo_referente
    sito_web
    target_clienti
    tipologia
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileGQL extends Apollo.Query<GetProfileQuery, GetProfileQueryVariables> {
    document = GetProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCodiceOperatoreDocument = gql`
    query GetCodiceOperatore($where: codice_operatore_bool_exp = {}) {
  codice_operatore(where: $where) {
    codice
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCodiceOperatoreGQL extends Apollo.Query<GetCodiceOperatoreQuery, GetCodiceOperatoreQueryVariables> {
    document = GetCodiceOperatoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNomeByAmicoCodeDocument = gql`
    query GetNomeByAmicoCode($codice: String!) {
  codice_operatore(where: {codice: {_eq: $codice}}, limit: 1) {
    codice
    user_entity {
      first_name
      last_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNomeByAmicoCodeGQL extends Apollo.Query<GetNomeByAmicoCodeQuery, GetNomeByAmicoCodeQueryVariables> {
    document = GetNomeByAmicoCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateProfileDocument = gql`
    mutation InsertOrUpdateProfile($objects: [profilo_insert_input!] = {}, $on_conflict: profilo_on_conflict = {constraint: profilo_pkey}) {
  insert_profilo(objects: $objects, on_conflict: $on_conflict) {
    returning {
      ambiti_attivita
      anno_fondazione
      area_geografica_operativa
      certificazioni
      created_at
      id
      interessi_specifici
      numero_dipendenti
      show_accesso_pro
      codice_amico
      persona {
        id
        codice_fiscale
        cognome
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
          }
        }
        indirizzo {
          id
          geom_
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            denominazione
            provincia {
              sigla
            }
          }
        }
        nome
        partita_iva
        ragione_sociale
        data_nascita
        nazione_nascita {
          id
        }
        citta_nascita {
          id
        }
      }
      referente_principale
      ruolo_referente
      sito_web
      target_clienti
      tipologia
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateProfileGQL extends Apollo.Mutation<InsertOrUpdateProfileMutation, InsertOrUpdateProfileMutationVariables> {
    document = InsertOrUpdateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccettaCondivisioneDocument = gql`
    mutation AccettaCondivisione($id: uuid!) {
  condivisione_accetta(args: {condivisioneid: $id}) {
    success
    message
    stato
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccettaCondivisioneGQL extends Apollo.Mutation<AccettaCondivisioneMutation, AccettaCondivisioneMutationVariables> {
    document = AccettaCondivisioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSottoscrizioniSegnalatoreDocument = gql`
    subscription SearchSottoscrizioniSegnalatore($args: search_sottoscrizioni_args!, $limit: Int, $offset: Int, $order_by: [sottoscrizione_order_by!]) {
  search_sottoscrizioni(
    args: $args
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    stato
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    cer_cabina {
      cabina {
        id
        cod_ac
      }
      cer {
        id
        logo {
          id
        }
        alias
        cer_padre {
          logo {
            id
          }
          alias
        }
      }
    }
    asset_consumo {
      intestatario {
        nome
        cognome
        ragione_sociale
      }
      asset {
        alias
        potenza_effettiva
        consumo
        caratteristiche {
          caratteristica {
            icon
          }
        }
        tipologia_asset {
          label
          percentuale_autoconsumo
          icon
          tipologia_asset_padre {
            icon
          }
        }
        gestori(order_by: {created_at: asc}, limit: 1) {
          utente {
            first_name
            last_name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSottoscrizioniSegnalatoreGQL extends Apollo.Subscription<SearchSottoscrizioniSegnalatoreSubscription, SearchSottoscrizioniSegnalatoreSubscriptionVariables> {
    document = SearchSottoscrizioniSegnalatoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSottoscrizioniSegnalatoreCountDocument = gql`
    subscription SearchSottoscrizioniSegnalatoreCount($args: search_sottoscrizioni_args!) {
  search_sottoscrizioni_aggregate(args: $args) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSottoscrizioniSegnalatoreCountGQL extends Apollo.Subscription<SearchSottoscrizioniSegnalatoreCountSubscription, SearchSottoscrizioniSegnalatoreCountSubscriptionVariables> {
    document = SearchSottoscrizioniSegnalatoreCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSottoscrizioniAmicoDocument = gql`
    subscription SearchSottoscrizioniAmico($args: search_sottoscrizioni_args!) {
  search_sottoscrizioni(args: $args, order_by: {updated_at: desc}) {
    cer_cabina {
      cabina {
        cod_ac
      }
      cer {
        id
        logo {
          id
        }
        alias
        cer_padre {
          logo {
            id
          }
          alias
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSottoscrizioniAmicoGQL extends Apollo.Subscription<SearchSottoscrizioniAmicoSubscription, SearchSottoscrizioniAmicoSubscriptionVariables> {
    document = SearchSottoscrizioniAmicoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAdminUtilizzoReferralDocument = gql`
    subscription GetAdminUtilizzoReferral($where: admin_utilizzo_referral_bool_exp = {}) {
  admin_utilizzo_referral(where: $where, distinct_on: auth_id) {
    nuovo_utente {
      last_name
      email
      first_name
      created_timestamp
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAdminUtilizzoReferralGQL extends Apollo.Subscription<GetAdminUtilizzoReferralSubscription, GetAdminUtilizzoReferralSubscriptionVariables> {
    document = GetAdminUtilizzoReferralDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAmiciPresentatiDocument = gql`
    query GetAmiciPresentati($args: search_user_entity_args!, $where: auth_user_entity_bool_exp, $limit: Int, $offset: Int, $order_by: [auth_user_entity_order_by!]) {
  search_user_entity(
    args: $args
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    first_name
    last_name
    email
    created_timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAmiciPresentatiGQL extends Apollo.Query<GetAmiciPresentatiQuery, GetAmiciPresentatiQueryVariables> {
    document = GetAmiciPresentatiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAmiciPresentatiCountDocument = gql`
    query GetAmiciPresentatiCount($args: search_user_entity_args!, $where: auth_user_entity_bool_exp) {
  search_user_entity_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAmiciPresentatiCountGQL extends Apollo.Query<GetAmiciPresentatiCountQuery, GetAmiciPresentatiCountQueryVariables> {
    document = GetAmiciPresentatiCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAmiciPresentatiCountSubscriptionDocument = gql`
    subscription GetAmiciPresentatiCountSubscription($args: search_user_entity_args!, $where: auth_user_entity_bool_exp) {
  search_user_entity_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAmiciPresentatiCountSubscriptionGQL extends Apollo.Subscription<GetAmiciPresentatiCountSubscriptionSubscription, GetAmiciPresentatiCountSubscriptionSubscriptionVariables> {
    document = GetAmiciPresentatiCountSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckPodAdesioniDocument = gql`
    query CheckPodAdesioni($pods: [String!]!, $codice_gse: String!) {
  sottoscrizione: sottoscrizione(
    where: {cer_cabina: {codice_gse: {_eq: $codice_gse}}, asset_consumo: {pod: {_in: $pods}}, data_ammissione: {_is_null: false}}
  ) {
    id
    data_recesso
    data_ammissione
    cer_categoria_adesione {
      id
      tipologia
      tipologia_richiesta
      regole
    }
    asset_consumo {
      pod
    }
  }
  altriPods: sottoscrizione(
    where: {cer_cabina: {codice_gse: {_eq: $codice_gse}}, asset_consumo: {pod: {_nin: $pods}}, data_ammissione: {_is_null: false}}
  ) {
    id
    data_recesso
    data_ammissione
    cer_categoria_adesione {
      id
      tipologia
      tipologia_richiesta
      regole
    }
    asset_consumo {
      id
      pod
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckPodAdesioniGQL extends Apollo.Query<CheckPodAdesioniQuery, CheckPodAdesioniQueryVariables> {
    document = CheckPodAdesioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCersSettingsDocument = gql`
    subscription GetCersSettings {
  cer(order_by: {alias: desc}, where: {root_id: {_is_null: true}}) {
    alias
    configurazioni(order_by: {alias: desc}) {
      id
      alias
      domande_richieste
      documenti_richiesti
      costi
      modulo_richiesta
      email_template
      richiesta_iban
      richiesta_iniziativa_sociale
      categorie_adesione(order_by: {categoria: asc}) {
        categoria
        tipologia
        tipologia_richiesta
        chiesto
        id
        regole
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCersSettingsGQL extends Apollo.Subscription<GetCersSettingsSubscription, GetCersSettingsSubscriptionVariables> {
    document = GetCersSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSottoscrizioniDocument = gql`
    subscription SearchSottoscrizioni($args: search_sottoscrizioni_args!, $limit: Int, $offset: Int, $order_by: [sottoscrizione_order_by!]) {
  search_sottoscrizioni(
    args: $args
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    stato
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    cer_cabina {
      stato
      codice_richiesta
      codice_gse
      cabina {
        cod_ac
      }
      cer {
        id
        logo {
          id
        }
        alias
        stato_cer
        abilita_richieste
        whitelabel {
          configurazione {
            referral
          }
        }
        cer_padre {
          logo {
            id
          }
          alias
        }
      }
    }
    asset_consumo {
      pod
      intestatario {
        nome
        cognome
        ragione_sociale
        contatti {
          contatto {
            tipo_contatto_id
            value
          }
        }
      }
      asset {
        associato
        opzionato
        alias
        potenza_effettiva
        consumo
        caratteristiche {
          caratteristica {
            icon
          }
        }
        tipologia_asset {
          label
          percentuale_autoconsumo
          icon
          tipologia_asset_padre {
            icon
          }
        }
        indirizzo {
          geom_
        }
        gestori(order_by: {created_at: asc}, limit: 1) {
          utente {
            first_name
            last_name
            username
          }
        }
        condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {created_at: asc}
        ) {
          id
          nome
          email
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSottoscrizioniGQL extends Apollo.Subscription<SearchSottoscrizioniSubscription, SearchSottoscrizioniSubscriptionVariables> {
    document = SearchSottoscrizioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSottoscrizioniCountDocument = gql`
    subscription SearchSottoscrizioniCount($args: search_sottoscrizioni_args!) {
  search_sottoscrizioni_aggregate(args: $args) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSottoscrizioniCountGQL extends Apollo.Subscription<SearchSottoscrizioniCountSubscription, SearchSottoscrizioniCountSubscriptionVariables> {
    document = SearchSottoscrizioniCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSottoscrizioniStatiDocument = gql`
    subscription SearchSottoscrizioniStati($args: search_sottoscrizioni_args!) {
  search_sottoscrizioni(args: $args) {
    stato
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSottoscrizioniStatiGQL extends Apollo.Subscription<SearchSottoscrizioniStatiSubscription, SearchSottoscrizioniStatiSubscriptionVariables> {
    document = SearchSottoscrizioniStatiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioniFounderStatiDocument = gql`
    subscription GetSottoscrizioniFounderStati($where: sottoscrizione_bool_exp) {
  sottoscrizione(where: $where, distinct_on: stato, order_by: {stato: asc}) {
    stato
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioniFounderStatiGQL extends Apollo.Subscription<GetSottoscrizioniFounderStatiSubscription, GetSottoscrizioniFounderStatiSubscriptionVariables> {
    document = GetSottoscrizioniFounderStatiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioneFounderDocument = gql`
    subscription GetSottoscrizioneFounder($id: uuid!) {
  sottoscrizione_by_pk(id: $id) {
    id
    stato
    categoria_adesione
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    data_associazione
    data_opzione
    data_scadenza
    data_recesso
    iban_accredito_incentivi
    intestatario_conto_corrente
    iniziative(order_by: {data_inizio: desc}) {
      id
      data_inizio
      data_fine
      destinazione_contributo_id
      cer_destinazione_contributo {
        id
        descrizione
      }
    }
    codice_univico_promotore
    link_fascicolo
    cer_cabina {
      id
      codice_gse
      cabina {
        id
        cod_ac
      }
      cer {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        richiesta_iniziativa_sociale
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        cer_padre {
          id
          alias
          domande_richieste
          documenti_richiesti
          costi
          modulo_richiesta
          email_template
          richiesta_iban
          categorie_adesione(order_by: {categoria: asc}) {
            categoria
            tipologia
            tipologia_richiesta
            chiesto
            id
            regole
          }
          descrizione
          stato_cer
          partecipanti
          consumatori_dichiarati
          impianti
          produttori_dichiarati
          potenza
          potenza_dichiarata
          domande_richieste
          data_costituzione
          referral
          pubblicata
          mostra
          abilita_richieste
          attive
          iniziative
          richieste
          notifiche
          geom {
            id
            cabina_ids
          }
          richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
            stato
            updated_at
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          white_label
          whitelabel {
            id
            configurazione {
              id
              terms {
                id
                name
              }
              logo_chiaro {
                id
                name
              }
              logo_scuro {
                id
                name
              }
            }
          }
          logo {
            id
            name
          }
          volantino {
            id
            name
          }
          regolamento {
            id
            name
          }
          statuto {
            id
            name
          }
          promotore {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          societa {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
        }
      }
    }
    cer_categoria_adesione {
      id
      categoria
    }
    cer_categoria_adesione_produttore {
      id
      categoria
    }
    confirmo_id
    domande {
      tipologia_domanda
      risposta
    }
    feedback {
      label
    }
    contratto {
      id
      name
    }
    feedback_altro
    documenti {
      id
      tipologia_documento
      file {
        id
        name
      }
    }
    segnalatore {
      user_entity {
        first_name
        last_name
      }
    }
    asset_consumo {
      id
      pod
      tipo_pod_id
      foglio
      particella
      subalterno
      sezione_catastale
      accumulo_standalone
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      dati_consumo(order_by: {data_inizio: asc}) {
        id
        f1
        f2
        f3
        data_inizio
        data_fine
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
    asset_produzione {
      id
      pod
      potenza_effettiva
      energia_immessa
      referente_gse_nome
      referente_gse_email
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      richiesta_pnrr
      cod_richiesta_terna
      cod_censimp
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      potenza_batteria
      sezione_catastale
      foglio
      particella
      subalterno
      ubicazione_impianto_aderente
      data_installazione_impianto
      configurazione_accumulo_id
      aderenza_delibera_autoconsumo
      data_adesione_autoconsumo
      prelievi_non_ausiliari
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      codice_fatturato_pnrr
      delibera_gse_pnrr {
        id
        name
      }
      documenti_pnrr {
        id
        tipologia_documento
        file {
          id
          name
        }
      }
      motivanzione_no_pnrr
      esito_pnrr
      unita {
        id
        cod_up
        data_attivazione
        data_disattivazione
        sezioni {
          id
          codice_sezione
          data_decorrenza_autoconsumo
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            id
            rispetto_principio_dns
            usufruito_incentivi_rilancio
            quota_potenza_rinnovabili_obbligo
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            id
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioneFounderGQL extends Apollo.Subscription<GetSottoscrizioneFounderSubscription, GetSottoscrizioneFounderSubscriptionVariables> {
    document = GetSottoscrizioneFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CambiaStatoFounderDocument = gql`
    mutation CambiaStatoFounder($args: cambia_stato_founder_args = {}) {
  cambia_stato_founder(args: $args) {
    stato
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CambiaStatoFounderGQL extends Apollo.Mutation<CambiaStatoFounderMutation, CambiaStatoFounderMutationVariables> {
    document = CambiaStatoFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCersDocument = gql`
    subscription GetCers($args: search_cer_args! = {}, $where: cer_bool_exp = {}, $limit: Int = 10, $offset: Int = 0, $order_by: [cer_order_by!] = [{abilita_richieste: desc}, {stato_cer: asc}, {created_at: desc}]) {
  cer: search_cer(
    args: $args
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    stato_cer
    alias
    attive
    iniziative
    produttori_dichiarati
    impianti
    potenza_dichiarata
    potenza
    consumatori_dichiarati
    partecipanti
    richieste
    notifiche
    richieste_pubblicazione(order_by: {created_at: desc}, limit: 1) {
      stato
      updated_at
    }
    logo {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCersGQL extends Apollo.Subscription<GetCersSubscription, GetCersSubscriptionVariables> {
    document = GetCersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCersCountDocument = gql`
    subscription GetCersCount($args: search_cer_args! = {}, $where: cer_bool_exp = {}) {
  cer_aggregate: search_cer_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCersCountGQL extends Apollo.Subscription<GetCersCountSubscription, GetCersCountSubscriptionVariables> {
    document = GetCersCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCerDocument = gql`
    mutation AddCer($objects: [cer_gestore_insert_input!]!) {
  insert_cer_gestore(objects: $objects) {
    returning {
      cer_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCerGQL extends Apollo.Mutation<AddCerMutation, AddCerMutationVariables> {
    document = AddCerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateCerDocument = gql`
    mutation InsertOrUpdateCer($objects: [cer_insert_input!] = {}, $on_conflict: cer_on_conflict = {constraint: cer_pkey}, $delete_destinazioni: cer_destinazione_contributo_bool_exp! = {id: {_in: []}}) {
  delete_cer_destinazione_contributo(where: $delete_destinazioni) {
    affected_rows
  }
  insert_cer(objects: $objects, on_conflict: $on_conflict) {
    returning {
      id
      alias
      root_id
      domande_richieste
      documenti_richiesti
      costi
      modulo_richiesta
      email_template
      richiesta_iban
      categorie_adesione(order_by: {categoria: asc}) {
        categoria
        tipologia
        tipologia_richiesta
        chiesto
        id
        regole
      }
      descrizione
      stato_cer
      partecipanti
      consumatori_dichiarati
      impianti
      produttori_dichiarati
      potenza
      potenza_dichiarata
      domande_richieste
      data_costituzione
      referral
      soggetto_referente_gse
      pubblicata
      mostra
      abilita_richieste
      attive
      iniziative
      richieste
      notifiche
      geom {
        id
        cabina_ids
      }
      richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
        stato
        updated_at
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      destinazioni_contributi(order_by: {created_at: asc}) {
        id
        descrizione
        iban
        ambito
        persona {
          id
          forma_giuridica {
            id
            label
            rules
          }
          nome
          cognome
          sesso
          data_nascita
          nazione_nascita_id
          citta_nascita_id
          ragione_sociale
          partita_iva
          codice_fiscale
          codice_ateco_id
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            geom_
          }
        }
      }
      white_label
      whitelabel {
        id
        configurazione {
          id
          referral
          terms {
            id
            name
          }
          logo_chiaro {
            id
            name
          }
          logo_scuro {
            id
            name
          }
        }
      }
      logo {
        id
        name
      }
      volantino {
        id
        name
      }
      regolamento {
        id
        name
      }
      statuto {
        id
        name
      }
      promotore {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      societa {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      cer_padre {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            referral
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateCerGQL extends Apollo.Mutation<InsertOrUpdateCerMutation, InsertOrUpdateCerMutationVariables> {
    document = InsertOrUpdateCerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioniCerDocument = gql`
    subscription GetConfigurazioniCer($args: search_cer_args! = {}, $where: cer_bool_exp = {}, $limit: Int = 10, $offset: Int = 0, $order_by: [cer_order_by!] = [{stato_cer: desc}, {created_at: desc}]) {
  cer: search_cer(
    args: $args
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    alias
    stato_cer
    mostra
    abilita_richieste
    impianti
    potenza
    partecipanti
    richieste
    notifiche
    logo {
      id
    }
    richieste_pubblicazione(order_by: {created_at: desc}, limit: 1) {
      stato
      updated_at
    }
    cer_cabina(order_by: {id: asc}) {
      cabina {
        cod_ac
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioniCerGQL extends Apollo.Subscription<GetConfigurazioniCerSubscription, GetConfigurazioniCerSubscriptionVariables> {
    document = GetConfigurazioniCerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioniCerCountDocument = gql`
    subscription GetConfigurazioniCerCount($where: cer_bool_exp = {}) {
  cer_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioniCerCountGQL extends Apollo.Subscription<GetConfigurazioniCerCountSubscription, GetConfigurazioniCerCountSubscriptionVariables> {
    document = GetConfigurazioniCerCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioneFounderDocument = gql`
    subscription GetConfigurazioneFounder($id: uuid!) {
  cer_by_pk(id: $id) {
    id
    alias
    domande_richieste
    documenti_richiesti
    costi
    modulo_richiesta
    email_template
    richiesta_iban
    richiesta_iniziativa_sociale
    destinazioni_contributi_collegate {
      id
      destinazione_contributo_id
    }
    categorie_adesione(order_by: {categoria: asc}) {
      categoria
      tipologia
      tipologia_richiesta
      chiesto
      id
      regole
    }
    descrizione
    stato_cer
    partecipanti
    consumatori_dichiarati
    impianti
    produttori_dichiarati
    potenza
    potenza_dichiarata
    domande_richieste
    data_costituzione
    referral
    pubblicata
    mostra
    abilita_richieste
    attive
    iniziative
    richieste
    notifiche
    geom {
      id
      cabina_ids
    }
    richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
      stato
      updated_at
    }
    contatti {
      id
      contatto {
        id
        tipo_contatto_id
        value
        tipo_contatto {
          id
          label
          icon
          validation
        }
      }
    }
    white_label
    whitelabel {
      id
      configurazione {
        id
        referral
        terms {
          id
          name
        }
        logo_chiaro {
          id
          name
        }
        logo_scuro {
          id
          name
        }
      }
    }
    logo {
      id
      name
    }
    volantino {
      id
      name
    }
    regolamento {
      id
      name
    }
    statuto {
      id
      name
    }
    promotore {
      id
      nome
      cognome
      ragione_sociale
      codice_fiscale
      sesso
      data_nascita
      forma_giuridica_cer_id
      tipo_promotore_id
      tipologia_rappresentante_id
      citta_nascita {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      nazione_nascita {
        id
        denominazione
      }
      partita_iva
      codice_ateco_id
      codice_ateco {
        id
        label
      }
      forma_giuridica {
        id
        label
        rules
      }
      tipologia_rappresentante {
        id
        label
      }
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      rappresentante_legale {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
      }
    }
    societa {
      id
      nome
      cognome
      ragione_sociale
      codice_fiscale
      sesso
      data_nascita
      forma_giuridica_cer_id
      tipo_promotore_id
      tipologia_rappresentante_id
      citta_nascita {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      nazione_nascita {
        id
        denominazione
      }
      partita_iva
      codice_ateco_id
      codice_ateco {
        id
        label
      }
      forma_giuridica {
        id
        label
        rules
      }
      tipologia_rappresentante {
        id
        label
      }
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      rappresentante_legale {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
      }
    }
    cer_padre {
      id
      alias
      domande_richieste
      documenti_richiesti
      costi
      modulo_richiesta
      email_template
      richiesta_iban
      richiesta_iniziativa_sociale
      destinazioni_contributi(order_by: {created_at: asc}) {
        id
        descrizione
        persona {
          id
          ragione_sociale
          nome
          cognome
        }
      }
      categorie_adesione(order_by: {categoria: asc}) {
        categoria
        tipologia
        tipologia_richiesta
        chiesto
        id
        regole
      }
      descrizione
      stato_cer
      partecipanti
      consumatori_dichiarati
      impianti
      produttori_dichiarati
      potenza
      potenza_dichiarata
      domande_richieste
      data_costituzione
      referral
      pubblicata
      mostra
      abilita_richieste
      attive
      iniziative
      richieste
      notifiche
      geom {
        id
        cabina_ids
      }
      richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
        stato
        updated_at
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      white_label
      whitelabel {
        id
        configurazione {
          id
          referral
          terms {
            id
            name
          }
          logo_chiaro {
            id
            name
          }
          logo_scuro {
            id
            name
          }
        }
      }
      logo {
        id
        name
      }
      volantino {
        id
        name
      }
      regolamento {
        id
        name
      }
      statuto {
        id
        name
      }
      promotore {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      societa {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
    }
    cer_cabina(order_by: {id: asc}) {
      id
      stato
      codice_gse
      codice_richiesta
      codice_modifica
      cabina {
        id
        cod_ac
      }
      snapshot(where: {applicato_at: {_is_null: true}}, order_by: {created_at: asc}) {
        id
        tipo
        sottoscrizione_id
        created_at
        sottoscrizione {
          id
          stato
          asset_consumo {
            pod
            intestatario {
              nome
              cognome
              ragione_sociale
            }
          }
          asset_produzione {
            pod
            intestatario {
              nome
              cognome
              ragione_sociale
            }
          }
        }
      }
      aderenti: sottoscrizioni(where: {stato: {_eq: "associata"}}) {
        id
      }
      pratiche_pod: sottoscrizioni(where: {stato: {_neq: "cancellata"}}) {
        id
        asset_consumo {
          pod
        }
        asset_produzione {
          pod
        }
      }
      pronte: sottoscrizioni(
        where: {stato: {_eq: "pronto_per_gse"}}
        order_by: {updated_at: asc}
      ) {
        id
        tipologia_richiesta
        asset_consumo {
          pod
          intestatario {
            nome
            cognome
            ragione_sociale
          }
        }
        asset_produzione {
          pod
          intestatario {
            nome
            cognome
            ragione_sociale
          }
        }
      }
      sottoscrizioni(
        where: {stato: {_eq: "inviato_al_gse"}}
        order_by: {updated_at: asc}
      ) {
        id
        stato
        tipologia_richiesta
        updated_at
        asset_consumo {
          pod
          intestatario {
            nome
            cognome
            ragione_sociale
          }
        }
        asset_produzione {
          pod
          intestatario {
            nome
            cognome
            ragione_sociale
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioneFounderGQL extends Apollo.Subscription<GetConfigurazioneFounderSubscription, GetConfigurazioneFounderSubscriptionVariables> {
    document = GetConfigurazioneFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateConfigurazioneDocument = gql`
    mutation InsertOrUpdateConfigurazione($objects: [cer_insert_input!] = {}, $on_conflict: cer_on_conflict = {constraint: cer_pkey}) {
  insert_cer(objects: $objects, on_conflict: $on_conflict) {
    returning {
      id
      alias
      domande_richieste
      documenti_richiesti
      costi
      modulo_richiesta
      email_template
      richiesta_iban
      richiesta_iniziativa_sociale
      destinazioni_contributi_collegate {
        id
        destinazione_contributo_id
      }
      categorie_adesione(order_by: {categoria: asc}) {
        categoria
        tipologia
        tipologia_richiesta
        chiesto
        id
        regole
      }
      descrizione
      stato_cer
      partecipanti
      consumatori_dichiarati
      impianti
      produttori_dichiarati
      potenza
      potenza_dichiarata
      domande_richieste
      data_costituzione
      referral
      pubblicata
      mostra
      abilita_richieste
      attive
      iniziative
      richieste
      notifiche
      geom {
        id
        cabina_ids
      }
      richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
        stato
        updated_at
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      white_label
      whitelabel {
        id
        configurazione {
          id
          referral
          terms {
            id
            name
          }
          logo_chiaro {
            id
            name
          }
          logo_scuro {
            id
            name
          }
        }
      }
      logo {
        id
        name
      }
      volantino {
        id
        name
      }
      regolamento {
        id
        name
      }
      statuto {
        id
        name
      }
      promotore {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      societa {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      cer_padre {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        richiesta_iniziativa_sociale
        destinazioni_contributi(order_by: {created_at: asc}) {
          id
          descrizione
          persona {
            id
            ragione_sociale
            nome
            cognome
          }
        }
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            referral
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
      }
      cer_cabina(order_by: {id: asc}) {
        id
        stato
        codice_gse
        codice_richiesta
        codice_modifica
        cabina {
          id
          cod_ac
        }
        snapshot(where: {applicato_at: {_is_null: true}}, order_by: {created_at: asc}) {
          id
          tipo
          sottoscrizione_id
          created_at
          sottoscrizione {
            id
            stato
            asset_consumo {
              pod
              intestatario {
                nome
                cognome
                ragione_sociale
              }
            }
            asset_produzione {
              pod
              intestatario {
                nome
                cognome
                ragione_sociale
              }
            }
          }
        }
        aderenti: sottoscrizioni(where: {stato: {_eq: "associata"}}) {
          id
        }
        pratiche_pod: sottoscrizioni(where: {stato: {_neq: "cancellata"}}) {
          id
          asset_consumo {
            pod
          }
          asset_produzione {
            pod
          }
        }
        pronte: sottoscrizioni(
          where: {stato: {_eq: "pronto_per_gse"}}
          order_by: {updated_at: asc}
        ) {
          id
          tipologia_richiesta
          asset_consumo {
            pod
            intestatario {
              nome
              cognome
              ragione_sociale
            }
          }
          asset_produzione {
            pod
            intestatario {
              nome
              cognome
              ragione_sociale
            }
          }
        }
        sottoscrizioni(
          where: {stato: {_eq: "inviato_al_gse"}}
          order_by: {updated_at: asc}
        ) {
          id
          stato
          tipologia_richiesta
          updated_at
          asset_consumo {
            pod
            intestatario {
              nome
              cognome
              ragione_sociale
            }
          }
          asset_produzione {
            pod
            intestatario {
              nome
              cognome
              ragione_sociale
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateConfigurazioneGQL extends Apollo.Mutation<InsertOrUpdateConfigurazioneMutation, InsertOrUpdateConfigurazioneMutationVariables> {
    document = InsertOrUpdateConfigurazioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChiediPubblicazioneDocument = gql`
    mutation ChiediPubblicazione($cer_id: uuid!) {
  insert_admin_richiesta_pubblicazione(objects: {cer_id: $cer_id}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChiediPubblicazioneGQL extends Apollo.Mutation<ChiediPubblicazioneMutation, ChiediPubblicazioneMutationVariables> {
    document = ChiediPubblicazioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MostraDocument = gql`
    mutation Mostra($cerid: uuid!) {
  mostra(args: {cerid: $cerid}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MostraGQL extends Apollo.Mutation<MostraMutation, MostraMutationVariables> {
    document = MostraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AbilitaRichiesteDocument = gql`
    mutation AbilitaRichieste($cerid: uuid!) {
  abilita_richieste(args: {cerid: $cerid}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AbilitaRichiesteGQL extends Apollo.Mutation<AbilitaRichiesteMutation, AbilitaRichiesteMutationVariables> {
    document = AbilitaRichiesteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogRipartizioneDocument = gql`
    subscription GetLogRipartizione($ripartizione_id: uuid!) {
  incentivi_log_ripartizione(
    where: {ripartizione_id: {_eq: $ripartizione_id}}
    order_by: {created_at: asc}
  ) {
    created_at
    testo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogRipartizioneGQL extends Apollo.Subscription<GetLogRipartizioneSubscription, GetLogRipartizioneSubscriptionVariables> {
    document = GetLogRipartizioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalcoloRipartizioneDocument = gql`
    mutation CalcoloRipartizione($id: uuid!, $calcolo: String!) {
  update_incentivi_ripartizione_by_pk(
    pk_columns: {id: $id}
    _set: {calcolo: $calcolo}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalcoloRipartizioneGQL extends Apollo.Mutation<CalcoloRipartizioneMutation, CalcoloRipartizioneMutationVariables> {
    document = CalcoloRipartizioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateIncentivoDocument = gql`
    mutation InsertOrUpdateIncentivo($objects: [incentivi_ripartizione_insert_input!] = {}, $on_conflict: incentivi_ripartizione_on_conflict = {constraint: ripartizione_pkey}) {
  insert_incentivi_ripartizione(objects: $objects, on_conflict: $on_conflict) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateIncentivoGQL extends Apollo.Mutation<InsertOrUpdateIncentivoMutation, InsertOrUpdateIncentivoMutationVariables> {
    document = InsertOrUpdateIncentivoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCodiceGseDocument = gql`
    mutation UpdateCodiceGse($id: uuid!, $codice_gse: String!) {
  update_cer_cabina_by_pk(pk_columns: {id: $id}, _set: {codice_gse: $codice_gse}) {
    updated_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCodiceGseGQL extends Apollo.Mutation<UpdateCodiceGseMutation, UpdateCodiceGseMutationVariables> {
    document = UpdateCodiceGseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdatePersonaFounderDocument = gql`
    mutation InsertOrUpdatePersonaFounder($objects: [persona_insert_input!] = {}, $on_conflict: persona_on_conflict = {constraint: persona_pkey}) {
  insert_persona(objects: $objects, on_conflict: $on_conflict) {
    returning {
      id
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        geom_
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdatePersonaFounderGQL extends Apollo.Mutation<InsertOrUpdatePersonaFounderMutation, InsertOrUpdatePersonaFounderMutationVariables> {
    document = InsertOrUpdatePersonaFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonaFounderDocument = gql`
    mutation UpdatePersonaFounder($id: uuid!, $_set: persona_set_input!) {
  update_persona_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonaFounderGQL extends Apollo.Mutation<UpdatePersonaFounderMutation, UpdatePersonaFounderMutationVariables> {
    document = UpdatePersonaFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContattoFounderDocument = gql`
    mutation UpdateContattoFounder($id: uuid!, $_set: contatto_set_input!) {
  update_contatto_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContattoFounderGQL extends Apollo.Mutation<UpdateContattoFounderMutation, UpdateContattoFounderMutationVariables> {
    document = UpdateContattoFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetFounderDocument = gql`
    mutation UpdateAssetFounder($id: uuid!, $_set: asset_set_input!) {
  update_asset_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetFounderGQL extends Apollo.Mutation<UpdateAssetFounderMutation, UpdateAssetFounderMutationVariables> {
    document = UpdateAssetFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetProduzioneFounderDocument = gql`
    mutation UpdateAssetProduzioneFounder($id: uuid!, $_set: asset_produzione_set_input!) {
  update_asset_produzione_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetProduzioneFounderGQL extends Apollo.Mutation<UpdateAssetProduzioneFounderMutation, UpdateAssetProduzioneFounderMutationVariables> {
    document = UpdateAssetProduzioneFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetProduzioneUnitaFounderDocument = gql`
    mutation UpdateAssetProduzioneUnitaFounder($id: uuid!, $_set: asset_produzione_unita_set_input!) {
  update_asset_produzione_unita_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetProduzioneUnitaFounderGQL extends Apollo.Mutation<UpdateAssetProduzioneUnitaFounderMutation, UpdateAssetProduzioneUnitaFounderMutationVariables> {
    document = UpdateAssetProduzioneUnitaFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetConsumoFounderDocument = gql`
    mutation UpdateAssetConsumoFounder($id: uuid!, $_set: asset_consumo_set_input!) {
  update_asset_consumo_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetConsumoFounderGQL extends Apollo.Mutation<UpdateAssetConsumoFounderMutation, UpdateAssetConsumoFounderMutationVariables> {
    document = UpdateAssetConsumoFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCondivisioneFounderDocument = gql`
    mutation UpdateCondivisioneFounder($id: uuid!, $_set: condivisione_condivisione_set_input!) {
  update_condivisione_condivisione_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCondivisioneFounderGQL extends Apollo.Mutation<UpdateCondivisioneFounderMutation, UpdateCondivisioneFounderMutationVariables> {
    document = UpdateCondivisioneFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertIndirizzoFounderDocument = gql`
    mutation InsertIndirizzoFounder($object: indirizzo_insert_input!, $on_conflict: indirizzo_on_conflict = {constraint: indirizzo_pkey}) {
  insert_indirizzo_one(object: $object, on_conflict: $on_conflict) {
    id
    completo
    toponimo
    civico
    cap
    manuale
    geom_
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertIndirizzoFounderGQL extends Apollo.Mutation<InsertIndirizzoFounderMutation, InsertIndirizzoFounderMutationVariables> {
    document = InsertIndirizzoFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIndirizzoFounderDocument = gql`
    mutation UpdateIndirizzoFounder($id: uuid!, $_set: indirizzo_set_input!) {
  update_indirizzo_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    completo
    toponimo
    civico
    cap
    manuale
    geom_
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIndirizzoFounderGQL extends Apollo.Mutation<UpdateIndirizzoFounderMutation, UpdateIndirizzoFounderMutationVariables> {
    document = UpdateIndirizzoFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCerFounderDocument = gql`
    subscription GetCerFounder($id: uuid!) {
  cer_by_pk(id: $id) {
    id
    alias
    root_id
    domande_richieste
    documenti_richiesti
    costi
    modulo_richiesta
    email_template
    richiesta_iban
    categorie_adesione(order_by: {categoria: asc}) {
      categoria
      tipologia
      tipologia_richiesta
      chiesto
      id
      regole
    }
    descrizione
    stato_cer
    partecipanti
    consumatori_dichiarati
    impianti
    produttori_dichiarati
    potenza
    potenza_dichiarata
    domande_richieste
    data_costituzione
    referral
    soggetto_referente_gse
    pubblicata
    mostra
    abilita_richieste
    attive
    iniziative
    richieste
    notifiche
    geom {
      id
      cabina_ids
    }
    richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
      stato
      updated_at
    }
    contatti {
      id
      contatto {
        id
        tipo_contatto_id
        value
        tipo_contatto {
          id
          label
          icon
          validation
        }
      }
    }
    destinazioni_contributi(order_by: {created_at: asc}) {
      id
      descrizione
      iban
      ambito
      persona {
        id
        forma_giuridica {
          id
          label
          rules
        }
        nome
        cognome
        sesso
        data_nascita
        nazione_nascita_id
        citta_nascita_id
        ragione_sociale
        partita_iva
        codice_fiscale
        codice_ateco_id
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          geom_
        }
      }
    }
    white_label
    whitelabel {
      id
      configurazione {
        id
        referral
        terms {
          id
          name
        }
        logo_chiaro {
          id
          name
        }
        logo_scuro {
          id
          name
        }
      }
    }
    logo {
      id
      name
    }
    volantino {
      id
      name
    }
    regolamento {
      id
      name
    }
    statuto {
      id
      name
    }
    promotore {
      id
      nome
      cognome
      ragione_sociale
      codice_fiscale
      sesso
      data_nascita
      forma_giuridica_cer_id
      tipo_promotore_id
      tipologia_rappresentante_id
      citta_nascita {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      nazione_nascita {
        id
        denominazione
      }
      partita_iva
      codice_ateco_id
      codice_ateco {
        id
        label
      }
      forma_giuridica {
        id
        label
        rules
      }
      tipologia_rappresentante {
        id
        label
      }
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      rappresentante_legale {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
      }
    }
    societa {
      id
      nome
      cognome
      ragione_sociale
      codice_fiscale
      sesso
      data_nascita
      forma_giuridica_cer_id
      tipo_promotore_id
      tipologia_rappresentante_id
      citta_nascita {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      nazione_nascita {
        id
        denominazione
      }
      partita_iva
      codice_ateco_id
      codice_ateco {
        id
        label
      }
      forma_giuridica {
        id
        label
        rules
      }
      tipologia_rappresentante {
        id
        label
      }
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      rappresentante_legale {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
      }
    }
    cer_padre {
      id
      alias
      domande_richieste
      documenti_richiesti
      costi
      modulo_richiesta
      email_template
      richiesta_iban
      categorie_adesione(order_by: {categoria: asc}) {
        categoria
        tipologia
        tipologia_richiesta
        chiesto
        id
        regole
      }
      descrizione
      stato_cer
      partecipanti
      consumatori_dichiarati
      impianti
      produttori_dichiarati
      potenza
      potenza_dichiarata
      domande_richieste
      data_costituzione
      referral
      pubblicata
      mostra
      abilita_richieste
      attive
      iniziative
      richieste
      notifiche
      geom {
        id
        cabina_ids
      }
      richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
        stato
        updated_at
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      white_label
      whitelabel {
        id
        configurazione {
          id
          referral
          terms {
            id
            name
          }
          logo_chiaro {
            id
            name
          }
          logo_scuro {
            id
            name
          }
        }
      }
      logo {
        id
        name
      }
      volantino {
        id
        name
      }
      regolamento {
        id
        name
      }
      statuto {
        id
        name
      }
      promotore {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      societa {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCerFounderGQL extends Apollo.Subscription<GetCerFounderSubscription, GetCerFounderSubscriptionVariables> {
    document = GetCerFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetElencoDatiProduttoreFounderDocument = gql`
    query GetElencoDatiProduttoreFounder($where: sottoscrizione_bool_exp) {
  sottoscrizione(where: $where) {
    id
    stato
    categoria_adesione
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    data_associazione
    data_opzione
    data_scadenza
    data_recesso
    iban_accredito_incentivi
    intestatario_conto_corrente
    codice_univico_promotore
    link_fascicolo
    cer_cabina {
      id
      codice_gse
      cabina {
        id
        cod_ac
      }
      cer {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        cer_padre {
          id
          alias
          domande_richieste
          documenti_richiesti
          costi
          modulo_richiesta
          email_template
          richiesta_iban
          categorie_adesione(order_by: {categoria: asc}) {
            categoria
            tipologia
            tipologia_richiesta
            chiesto
            id
            regole
          }
          descrizione
          stato_cer
          partecipanti
          consumatori_dichiarati
          impianti
          produttori_dichiarati
          potenza
          potenza_dichiarata
          domande_richieste
          data_costituzione
          referral
          pubblicata
          mostra
          abilita_richieste
          attive
          iniziative
          richieste
          notifiche
          geom {
            id
            cabina_ids
          }
          richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
            stato
            updated_at
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          white_label
          whitelabel {
            id
            configurazione {
              id
              terms {
                id
                name
              }
              logo_chiaro {
                id
                name
              }
              logo_scuro {
                id
                name
              }
            }
          }
          logo {
            id
            name
          }
          volantino {
            id
            name
          }
          regolamento {
            id
            name
          }
          statuto {
            id
            name
          }
          promotore {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          societa {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
        }
      }
    }
    cer_categoria_adesione {
      id
      categoria
    }
    cer_categoria_adesione_produttore {
      id
      categoria
    }
    confirmo_id
    domande {
      tipologia_domanda
      risposta
    }
    feedback {
      label
    }
    contratto {
      id
      name
    }
    feedback_altro
    documenti {
      id
      tipologia_documento
      file {
        id
        name
      }
    }
    segnalatore {
      user_entity {
        first_name
        last_name
      }
    }
    asset_consumo {
      id
      pod
      tipo_pod_id
      foglio
      particella
      subalterno
      sezione_catastale
      accumulo_standalone
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      dati_consumo(order_by: {data_inizio: asc}) {
        id
        f1
        f2
        f3
        data_inizio
        data_fine
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
    asset_produzione {
      id
      pod
      potenza_effettiva
      energia_immessa
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      richiesta_pnrr
      cod_richiesta_terna
      cod_censimp
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      potenza_batteria
      sezione_catastale
      foglio
      particella
      subalterno
      ubicazione_impianto_aderente
      data_installazione_impianto
      configurazione_accumulo_id
      aderenza_delibera_autoconsumo
      data_adesione_autoconsumo
      prelievi_non_ausiliari
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      codice_fatturato_pnrr
      delibera_gse_pnrr {
        id
        name
      }
      documenti_pnrr {
        id
        tipologia_documento
        file {
          id
          name
        }
      }
      motivanzione_no_pnrr
      esito_pnrr
      unita {
        id
        cod_up
        data_attivazione
        data_disattivazione
        sezioni {
          id
          codice_sezione
          data_decorrenza_autoconsumo
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            id
            rispetto_principio_dns
            usufruito_incentivi_rilancio
            quota_potenza_rinnovabili_obbligo
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            id
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetElencoDatiProduttoreFounderGQL extends Apollo.Query<GetElencoDatiProduttoreFounderQuery, GetElencoDatiProduttoreFounderQueryVariables> {
    document = GetElencoDatiProduttoreFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExportElencoRichiesteFounderDocument = gql`
    query GetExportElencoRichiesteFounder($where: sottoscrizione_bool_exp!, $abilita_richieste: Boolean = true, $accumulo_standalone: Boolean = true, $aderenza_delibera_autoconsumo: Boolean = true, $aiuto: Boolean = true, $alias: Boolean = true, $asset: Boolean = true, $asset_consumo: Boolean = true, $asset_produzione: Boolean = true, $associato: Boolean = true, $attive: Boolean = true, $auth: Boolean = true, $autoconsumo: Boolean = true, $cabina: Boolean = true, $cabina_ids: Boolean = true, $cap: Boolean = true, $capacita_batteria_prevista: Boolean = true, $caratteristica: Boolean = true, $caratteristiche: Boolean = true, $categoria: Boolean = true, $categoria_adesione: Boolean = true, $categorie_adesione: Boolean = true, $cer: Boolean = true, $cer_cabina: Boolean = true, $cer_categoria_adesione: Boolean = true, $cer_categoria_adesione_produttore: Boolean = true, $cer_padre: Boolean = true, $chiesto: Boolean = true, $citta: Boolean = true, $citta_nascita: Boolean = true, $civico: Boolean = true, $cod_ac: Boolean = true, $cod_censimp: Boolean = true, $cod_richiesta_terna: Boolean = true, $cod_up: Boolean = true, $codice_ateco: Boolean = true, $codice_ateco_id: Boolean = true, $codice_fatturato_pnrr: Boolean = true, $codice_fiscale: Boolean = true, $codice_gse: Boolean = true, $codice_sezione: Boolean = true, $codice_univico_promotore: Boolean = true, $cognome: Boolean = true, $completo: Boolean = true, $condivisioneInstallatore: Boolean = true, $condivisioneProsumer: Boolean = true, $condivisioneRecente: Boolean = true, $configurazione: Boolean = true, $configurazione_accumulo_id: Boolean = true, $confirmo_id: Boolean = true, $consumatori_dichiarati: Boolean = true, $consumo: Boolean = true, $contatti: Boolean = true, $contatto: Boolean = true, $contratto: Boolean = true, $contributi_id: Boolean = true, $costi: Boolean = true, $created_at: Boolean = true, $data: Boolean = true, $data_adesione_autoconsumo: Boolean = true, $data_allaccio_prevista: Boolean = true, $data_ammissione: Boolean = true, $data_associazione: Boolean = true, $data_attivazione: Boolean = true, $data_costituzione: Boolean = true, $data_decorrenza_autoconsumo: Boolean = true, $data_disattivazione: Boolean = true, $data_fine: Boolean = true, $data_inizio: Boolean = true, $data_installazione_impianto: Boolean = true, $data_nascita: Boolean = true, $data_opzione: Boolean = true, $data_recesso: Boolean = true, $data_scadenza: Boolean = true, $dati_consumo: Boolean = true, $delibera_gse_pnrr: Boolean = true, $denominazione: Boolean = true, $descrizione: Boolean = true, $dimensione: Boolean = true, $dimensione_id: Boolean = true, $dispositivo_inseguimento_solare: Boolean = true, $documenti: Boolean = true, $documenti_pnrr: Boolean = true, $documenti_richiesti: Boolean = true, $domande: Boolean = true, $domande_richieste: Boolean = true, $domenica_id: Boolean = true, $email: Boolean = true, $email_template: Boolean = true, $energia_immessa: Boolean = true, $ente: Boolean = true, $esito_pnrr: Boolean = true, $esposizione_prevalente_id: Boolean = true, $f1: Boolean = true, $f2: Boolean = true, $f3: Boolean = true, $feedback: Boolean = true, $feedback_altro: Boolean = true, $file: Boolean = true, $first_name: Boolean = true, $foglio: Boolean = true, $forma_giuridica: Boolean = true, $forma_giuridica_cer_id: Boolean = true, $geom: Boolean = true, $geom_: Boolean = true, $geom_obj: Boolean = true, $gestori: Boolean = true, $giovedi_id: Boolean = true, $iban_accredito_incentivi: Boolean = true, $icon: Boolean = true, $id_asset: Boolean = true, $id_asset_consumo: Boolean = true, $id_asset_produzione: Boolean = true, $id_cabina: Boolean = true, $id_caratteristica: Boolean = true, $id_categoria_adesione: Boolean = true, $id_cer: Boolean = true, $id_cer_cabina: Boolean = true, $id_cer_categoria_adesione: Boolean = true, $id_cer_categoria_adesione_produttore: Boolean = true, $id_cer_contatto: Boolean = true, $id_citta: Boolean = true, $id_codice_ateco: Boolean = true, $id_condivisione: Boolean = true, $id_configurazione: Boolean = true, $id_contatto: Boolean = true, $id_dati_consumo: Boolean = true, $id_documenti_pnrr: Boolean = true, $id_documento: Boolean = true, $id_file: Boolean = true, $id_forma_giuridica: Boolean = true, $id_geom: Boolean = true, $id_incentivo: Boolean = true, $id_indirizzo: Boolean = true, $id_nazione: Boolean = true, $id_persona: Boolean = true, $id_persona_contatto: Boolean = true, $id_provincia: Boolean = true, $id_sezione: Boolean = true, $id_sottoscrizione: Boolean = true, $id_spazi_disponibili: Boolean = true, $id_tipo_area: Boolean = true, $id_tipo_contatto: Boolean = true, $id_tipologia_abitativa: Boolean = true, $id_tipologia_asset: Boolean = true, $id_tipologia_rappresentante: Boolean = true, $id_titolo_autorizzativo: Boolean = true, $id_unita: Boolean = true, $id_user_entity: Boolean = true, $id_whitelabel: Boolean = true, $impianti: Boolean = true, $impianto: Boolean = true, $incentivi: Boolean = true, $incentivi_impianto: Boolean = true, $inclinazione_prevalente: Boolean = true, $incompatibilita_incentivi_altro: Boolean = true, $incompatibilita_incentivi_id: Boolean = true, $indirizzo: Boolean = true, $iniziative: Boolean = true, $intestatario: Boolean = true, $intestatario_conto_corrente: Boolean = true, $label: Boolean = true, $last_name: Boolean = true, $link_fascicolo: Boolean = true, $logo: Boolean = true, $logo_chiaro: Boolean = true, $logo_scuro: Boolean = true, $lunedi_id: Boolean = true, $manuale: Boolean = true, $martedi_id: Boolean = true, $mercoledi_id: Boolean = true, $modulo_richiesta: Boolean = true, $mostra: Boolean = true, $motivanzione_no_pnrr: Boolean = true, $name: Boolean = true, $nazione_nascita: Boolean = true, $nome: Boolean = true, $notifiche: Boolean = true, $opzionato: Boolean = true, $pannelli_bifacciali: Boolean = true, $partecipanti: Boolean = true, $particella: Boolean = true, $partita_iva: Boolean = true, $percentuale_autoconsumo: Boolean = true, $persona: Boolean = true, $pod: Boolean = true, $posizione_esatta: Boolean = true, $potenza: Boolean = true, $potenza_batteria: Boolean = true, $potenza_dichiarata: Boolean = true, $potenza_effettiva: Boolean = true, $potenza_impianto_prevista: Boolean = true, $prelievi_non_ausiliari: Boolean = true, $presenza_accumulo: Boolean = true, $produttori_dichiarati: Boolean = true, $profiloInstallatore: Boolean = true, $promotore: Boolean = true, $protocollo: Boolean = true, $provincia: Boolean = true, $pubblicata: Boolean = true, $quota_incentivo: Boolean = true, $quota_potenza_rinnovabili_obbligo: Boolean = true, $ragione_sociale: Boolean = true, $rappresentante_legale: Boolean = true, $realizzando_impianto: Boolean = true, $referral: Boolean = true, $regolamento: Boolean = true, $regole: Boolean = true, $richiesta_iban: Boolean = true, $richiesta_modello_unico: Boolean = true, $richiesta_pnrr: Boolean = true, $richieste: Boolean = true, $richieste_pubblicazione: Boolean = true, $rispetto_principio_dns: Boolean = true, $risposta: Boolean = true, $rules: Boolean = true, $sabato_id: Boolean = true, $scambio_su_posto: Boolean = true, $segnalatore: Boolean = true, $sesso: Boolean = true, $sezione_catastale: Boolean = true, $sezioni: Boolean = true, $sigla: Boolean = true, $societa: Boolean = true, $sottoscrizione_id: Boolean = true, $spazi_disponibili: Boolean = true, $spazio_disponibile: Boolean = true, $stato: Boolean = true, $stato_cer: Boolean = true, $statuto: Boolean = true, $subalterno: Boolean = true, $terms: Boolean = true, $tipo_area: Boolean = true, $tipo_contatto: Boolean = true, $tipo_contatto_id: Boolean = true, $tipo_pod_id: Boolean = true, $tipo_promotore_id: Boolean = true, $tipo_titolo_id: Boolean = true, $tipologia: Boolean = true, $tipologia_abitativa: Boolean = true, $tipologia_asset: Boolean = true, $tipologia_asset_padre: Boolean = true, $tipologia_documento: Boolean = true, $tipologia_domanda: Boolean = true, $tipologia_impianto_id: Boolean = true, $tipologia_prosumer: Boolean = true, $tipologia_rappresentante: Boolean = true, $tipologia_rappresentante_id: Boolean = true, $tipologia_richiesta: Boolean = true, $tipologia_sito_impianto_id: Boolean = true, $titoli_autorizzativi: Boolean = true, $toponimo: Boolean = true, $ubicazione_impianto_aderente: Boolean = true, $unita: Boolean = true, $updated_at: Boolean = true, $user_entity: Boolean = true, $username: Boolean = true, $usufruito_incentivi_rilancio: Boolean = true, $utente: Boolean = true, $validation: Boolean = true, $value: Boolean = true, $venerdi_id: Boolean = true, $visibilita_nome: Boolean = true, $volantino: Boolean = true, $white_label: Boolean = true, $whitelabel: Boolean = true) {
  sottoscrizione(where: $where, order_by: {updated_at: desc}) {
    id @skip(if: $id_sottoscrizione)
    stato @skip(if: $stato)
    categoria_adesione @skip(if: $categoria_adesione)
    tipologia_richiesta @skip(if: $tipologia_richiesta)
    data_ammissione @skip(if: $data_ammissione)
    created_at @skip(if: $created_at)
    updated_at @skip(if: $updated_at)
    data_associazione @skip(if: $data_associazione)
    data_opzione @skip(if: $data_opzione)
    data_scadenza @skip(if: $data_scadenza)
    data_recesso @skip(if: $data_recesso)
    iban_accredito_incentivi @skip(if: $iban_accredito_incentivi)
    intestatario_conto_corrente @skip(if: $intestatario_conto_corrente)
    codice_univico_promotore @skip(if: $codice_univico_promotore)
    link_fascicolo @skip(if: $link_fascicolo)
    cer_cabina @skip(if: $cer_cabina) {
      id @skip(if: $id_cer_cabina)
      codice_gse @skip(if: $codice_gse)
      cabina @skip(if: $cabina) {
        id @skip(if: $id_cabina)
        cod_ac @skip(if: $cod_ac)
      }
      cer @skip(if: $cer) {
        id @skip(if: $id_cer)
        alias @skip(if: $alias)
        domande_richieste @skip(if: $domande_richieste)
        documenti_richiesti @skip(if: $documenti_richiesti)
        costi @skip(if: $costi)
        modulo_richiesta @skip(if: $modulo_richiesta)
        email_template @skip(if: $email_template)
        richiesta_iban @skip(if: $richiesta_iban)
        categorie_adesione @skip(if: $categorie_adesione) {
          categoria @skip(if: $categoria)
          tipologia @skip(if: $tipologia)
          tipologia_richiesta @skip(if: $tipologia_richiesta)
          chiesto @skip(if: $chiesto)
          id @skip(if: $id_categoria_adesione)
          regole @skip(if: $regole)
        }
        descrizione @skip(if: $descrizione)
        stato_cer @skip(if: $stato_cer)
        partecipanti @skip(if: $partecipanti)
        consumatori_dichiarati @skip(if: $consumatori_dichiarati)
        impianti @skip(if: $impianti)
        produttori_dichiarati @skip(if: $produttori_dichiarati)
        potenza @skip(if: $potenza)
        potenza_dichiarata @skip(if: $potenza_dichiarata)
        domande_richieste @skip(if: $domande_richieste)
        data_costituzione @skip(if: $data_costituzione)
        referral @skip(if: $referral)
        pubblicata @skip(if: $pubblicata)
        mostra @skip(if: $mostra)
        abilita_richieste @skip(if: $abilita_richieste)
        attive @skip(if: $attive)
        iniziative @skip(if: $iniziative)
        richieste @skip(if: $richieste)
        notifiche @skip(if: $notifiche)
        geom_obj: geom @skip(if: $geom_obj) {
          id @skip(if: $id_geom)
          cabina_ids @skip(if: $cabina_ids)
        }
        richieste_pubblicazione @skip(if: $richieste_pubblicazione) {
          stato @skip(if: $stato)
          updated_at @skip(if: $updated_at)
        }
        contatti @skip(if: $contatti) {
          id @skip(if: $id_cer_contatto)
          contatto @skip(if: $contatto) {
            id @skip(if: $id_contatto)
            tipo_contatto_id @skip(if: $tipo_contatto_id)
            value @skip(if: $value)
            tipo_contatto @skip(if: $tipo_contatto) {
              id @skip(if: $id_tipo_contatto)
              label @skip(if: $label)
              icon @skip(if: $icon)
              validation @skip(if: $validation)
            }
          }
        }
        white_label @skip(if: $white_label)
        whitelabel @skip(if: $whitelabel) {
          id @skip(if: $id_whitelabel)
          configurazione @skip(if: $configurazione) {
            id @skip(if: $id_configurazione)
            terms @skip(if: $terms) {
              id @skip(if: $id_file)
              name @skip(if: $name)
            }
            logo_chiaro @skip(if: $logo_chiaro) {
              id @skip(if: $id_file)
              name @skip(if: $name)
            }
            logo_scuro @skip(if: $logo_scuro) {
              id @skip(if: $id_file)
              name @skip(if: $name)
            }
          }
        }
        logo @skip(if: $logo) {
          id @skip(if: $id_file)
          name @skip(if: $name)
        }
        volantino @skip(if: $volantino) {
          id @skip(if: $id_file)
          name @skip(if: $name)
        }
        regolamento @skip(if: $regolamento) {
          id @skip(if: $id_file)
          name @skip(if: $name)
        }
        statuto @skip(if: $statuto) {
          id @skip(if: $id_file)
          name @skip(if: $name)
        }
        promotore @skip(if: $promotore) {
          id @skip(if: $id_persona)
          nome @skip(if: $nome)
          cognome @skip(if: $cognome)
          ragione_sociale @skip(if: $ragione_sociale)
          codice_fiscale @skip(if: $codice_fiscale)
          sesso @skip(if: $sesso)
          data_nascita @skip(if: $data_nascita)
          forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
          tipo_promotore_id @skip(if: $tipo_promotore_id)
          tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
          citta_nascita @skip(if: $citta_nascita) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          nazione_nascita @skip(if: $nazione_nascita) {
            id @skip(if: $id_nazione)
            denominazione @skip(if: $denominazione)
          }
          partita_iva @skip(if: $partita_iva)
          codice_ateco_id @skip(if: $codice_ateco_id)
          codice_ateco @skip(if: $codice_ateco) {
            id @skip(if: $id_codice_ateco)
            label @skip(if: $label)
          }
          forma_giuridica @skip(if: $forma_giuridica) {
            id @skip(if: $id_forma_giuridica)
            label @skip(if: $label)
            rules @skip(if: $rules)
          }
          tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
            id @skip(if: $id_tipologia_rappresentante)
            label @skip(if: $label)
          }
          indirizzo @skip(if: $indirizzo) {
            id @skip(if: $id_indirizzo)
            completo @skip(if: $completo)
            manuale @skip(if: $manuale)
            toponimo @skip(if: $toponimo)
            civico @skip(if: $civico)
            cap @skip(if: $cap)
            citta @skip(if: $citta) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            geom_ @skip(if: $geom_)
            geom @skip(if: $geom)
          }
          contatti @skip(if: $contatti) {
            id @skip(if: $id_persona_contatto)
            contatto @skip(if: $contatto) {
              id @skip(if: $id_contatto)
              tipo_contatto_id @skip(if: $tipo_contatto_id)
              value @skip(if: $value)
              tipo_contatto @skip(if: $tipo_contatto) {
                id @skip(if: $id_tipo_contatto)
                label @skip(if: $label)
                icon @skip(if: $icon)
                validation @skip(if: $validation)
              }
            }
          }
          rappresentante_legale @skip(if: $rappresentante_legale) {
            id @skip(if: $id_persona)
            nome @skip(if: $nome)
            cognome @skip(if: $cognome)
            ragione_sociale @skip(if: $ragione_sociale)
            codice_fiscale @skip(if: $codice_fiscale)
            sesso @skip(if: $sesso)
            data_nascita @skip(if: $data_nascita)
            forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
            tipo_promotore_id @skip(if: $tipo_promotore_id)
            tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
            citta_nascita @skip(if: $citta_nascita) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            nazione_nascita @skip(if: $nazione_nascita) {
              id @skip(if: $id_nazione)
              denominazione @skip(if: $denominazione)
            }
            partita_iva @skip(if: $partita_iva)
            codice_ateco_id @skip(if: $codice_ateco_id)
            codice_ateco @skip(if: $codice_ateco) {
              id @skip(if: $id_codice_ateco)
              label @skip(if: $label)
            }
            forma_giuridica @skip(if: $forma_giuridica) {
              id @skip(if: $id_forma_giuridica)
              label @skip(if: $label)
              rules @skip(if: $rules)
            }
            tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
              id @skip(if: $id_tipologia_rappresentante)
              label @skip(if: $label)
            }
            indirizzo @skip(if: $indirizzo) {
              id @skip(if: $id_indirizzo)
              completo @skip(if: $completo)
              manuale @skip(if: $manuale)
              toponimo @skip(if: $toponimo)
              civico @skip(if: $civico)
              cap @skip(if: $cap)
              citta @skip(if: $citta) {
                id @skip(if: $id_citta)
                denominazione @skip(if: $denominazione)
                provincia @skip(if: $provincia) {
                  id @skip(if: $id_provincia)
                  denominazione @skip(if: $denominazione)
                  sigla @skip(if: $sigla)
                }
              }
              geom_ @skip(if: $geom_)
              geom @skip(if: $geom)
            }
            contatti @skip(if: $contatti) {
              id @skip(if: $id_persona_contatto)
              contatto @skip(if: $contatto) {
                id @skip(if: $id_contatto)
                tipo_contatto_id @skip(if: $tipo_contatto_id)
                value @skip(if: $value)
                tipo_contatto @skip(if: $tipo_contatto) {
                  id @skip(if: $id_tipo_contatto)
                  label @skip(if: $label)
                  icon @skip(if: $icon)
                  validation @skip(if: $validation)
                }
              }
            }
          }
        }
        societa @skip(if: $societa) {
          id @skip(if: $id_persona)
          nome @skip(if: $nome)
          cognome @skip(if: $cognome)
          ragione_sociale @skip(if: $ragione_sociale)
          codice_fiscale @skip(if: $codice_fiscale)
          sesso @skip(if: $sesso)
          data_nascita @skip(if: $data_nascita)
          forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
          tipo_promotore_id @skip(if: $tipo_promotore_id)
          tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
          citta_nascita @skip(if: $citta_nascita) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          nazione_nascita @skip(if: $nazione_nascita) {
            id @skip(if: $id_nazione)
            denominazione @skip(if: $denominazione)
          }
          partita_iva @skip(if: $partita_iva)
          codice_ateco_id @skip(if: $codice_ateco_id)
          codice_ateco @skip(if: $codice_ateco) {
            id @skip(if: $id_codice_ateco)
            label @skip(if: $label)
          }
          forma_giuridica @skip(if: $forma_giuridica) {
            id @skip(if: $id_forma_giuridica)
            label @skip(if: $label)
            rules @skip(if: $rules)
          }
          tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
            id @skip(if: $id_tipologia_rappresentante)
            label @skip(if: $label)
          }
          indirizzo @skip(if: $indirizzo) {
            id @skip(if: $id_indirizzo)
            completo @skip(if: $completo)
            manuale @skip(if: $manuale)
            toponimo @skip(if: $toponimo)
            civico @skip(if: $civico)
            cap @skip(if: $cap)
            citta @skip(if: $citta) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            geom_ @skip(if: $geom_)
            geom @skip(if: $geom)
          }
          contatti @skip(if: $contatti) {
            id @skip(if: $id_persona_contatto)
            contatto @skip(if: $contatto) {
              id @skip(if: $id_contatto)
              tipo_contatto_id @skip(if: $tipo_contatto_id)
              value @skip(if: $value)
              tipo_contatto @skip(if: $tipo_contatto) {
                id @skip(if: $id_tipo_contatto)
                label @skip(if: $label)
                icon @skip(if: $icon)
                validation @skip(if: $validation)
              }
            }
          }
          rappresentante_legale @skip(if: $rappresentante_legale) {
            id @skip(if: $id_persona)
            nome @skip(if: $nome)
            cognome @skip(if: $cognome)
            ragione_sociale @skip(if: $ragione_sociale)
            codice_fiscale @skip(if: $codice_fiscale)
            sesso @skip(if: $sesso)
            data_nascita @skip(if: $data_nascita)
            forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
            tipo_promotore_id @skip(if: $tipo_promotore_id)
            tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
            citta_nascita @skip(if: $citta_nascita) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            nazione_nascita @skip(if: $nazione_nascita) {
              id @skip(if: $id_nazione)
              denominazione @skip(if: $denominazione)
            }
            partita_iva @skip(if: $partita_iva)
            codice_ateco_id @skip(if: $codice_ateco_id)
            codice_ateco @skip(if: $codice_ateco) {
              id @skip(if: $id_codice_ateco)
              label @skip(if: $label)
            }
            forma_giuridica @skip(if: $forma_giuridica) {
              id @skip(if: $id_forma_giuridica)
              label @skip(if: $label)
              rules @skip(if: $rules)
            }
            tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
              id @skip(if: $id_tipologia_rappresentante)
              label @skip(if: $label)
            }
            indirizzo @skip(if: $indirizzo) {
              id @skip(if: $id_indirizzo)
              completo @skip(if: $completo)
              manuale @skip(if: $manuale)
              toponimo @skip(if: $toponimo)
              civico @skip(if: $civico)
              cap @skip(if: $cap)
              citta @skip(if: $citta) {
                id @skip(if: $id_citta)
                denominazione @skip(if: $denominazione)
                provincia @skip(if: $provincia) {
                  id @skip(if: $id_provincia)
                  denominazione @skip(if: $denominazione)
                  sigla @skip(if: $sigla)
                }
              }
              geom_ @skip(if: $geom_)
              geom @skip(if: $geom)
            }
            contatti @skip(if: $contatti) {
              id @skip(if: $id_persona_contatto)
              contatto @skip(if: $contatto) {
                id @skip(if: $id_contatto)
                tipo_contatto_id @skip(if: $tipo_contatto_id)
                value @skip(if: $value)
                tipo_contatto @skip(if: $tipo_contatto) {
                  id @skip(if: $id_tipo_contatto)
                  label @skip(if: $label)
                  icon @skip(if: $icon)
                  validation @skip(if: $validation)
                }
              }
            }
          }
        }
        cer_padre @skip(if: $cer_padre) {
          id @skip(if: $id_cer)
          alias @skip(if: $alias)
          domande_richieste @skip(if: $domande_richieste)
          documenti_richiesti @skip(if: $documenti_richiesti)
          costi @skip(if: $costi)
          modulo_richiesta @skip(if: $modulo_richiesta)
          email_template @skip(if: $email_template)
          richiesta_iban @skip(if: $richiesta_iban)
          categorie_adesione @skip(if: $categorie_adesione) {
            categoria @skip(if: $categoria)
            tipologia @skip(if: $tipologia)
            tipologia_richiesta @skip(if: $tipologia_richiesta)
            chiesto @skip(if: $chiesto)
            id @skip(if: $id_categoria_adesione)
            regole @skip(if: $regole)
          }
          descrizione @skip(if: $descrizione)
          stato_cer @skip(if: $stato_cer)
          partecipanti @skip(if: $partecipanti)
          consumatori_dichiarati @skip(if: $consumatori_dichiarati)
          impianti @skip(if: $impianti)
          produttori_dichiarati @skip(if: $produttori_dichiarati)
          potenza @skip(if: $potenza)
          potenza_dichiarata @skip(if: $potenza_dichiarata)
          domande_richieste @skip(if: $domande_richieste)
          data_costituzione @skip(if: $data_costituzione)
          referral @skip(if: $referral)
          pubblicata @skip(if: $pubblicata)
          mostra @skip(if: $mostra)
          abilita_richieste @skip(if: $abilita_richieste)
          attive @skip(if: $attive)
          iniziative @skip(if: $iniziative)
          richieste @skip(if: $richieste)
          notifiche @skip(if: $notifiche)
          geom_obj: geom @skip(if: $geom_obj) {
            id @skip(if: $id_geom)
            cabina_ids @skip(if: $cabina_ids)
          }
          richieste_pubblicazione @skip(if: $richieste_pubblicazione) {
            stato @skip(if: $stato)
            updated_at @skip(if: $updated_at)
          }
          contatti @skip(if: $contatti) {
            id @skip(if: $id_cer_contatto)
            contatto @skip(if: $contatto) {
              id @skip(if: $id_contatto)
              tipo_contatto_id @skip(if: $tipo_contatto_id)
              value @skip(if: $value)
              tipo_contatto @skip(if: $tipo_contatto) {
                id @skip(if: $id_tipo_contatto)
                label @skip(if: $label)
                icon @skip(if: $icon)
                validation @skip(if: $validation)
              }
            }
          }
          white_label @skip(if: $white_label)
          whitelabel @skip(if: $whitelabel) {
            id @skip(if: $id_whitelabel)
            configurazione @skip(if: $configurazione) {
              id @skip(if: $id_configurazione)
              terms @skip(if: $terms) {
                id @skip(if: $id_file)
                name @skip(if: $name)
              }
              logo_chiaro @skip(if: $logo_chiaro) {
                id @skip(if: $id_file)
                name @skip(if: $name)
              }
              logo_scuro @skip(if: $logo_scuro) {
                id @skip(if: $id_file)
                name @skip(if: $name)
              }
            }
          }
          logo @skip(if: $logo) {
            id @skip(if: $id_file)
            name @skip(if: $name)
          }
          volantino @skip(if: $volantino) {
            id @skip(if: $id_file)
            name @skip(if: $name)
          }
          regolamento @skip(if: $regolamento) {
            id @skip(if: $id_file)
            name @skip(if: $name)
          }
          statuto @skip(if: $statuto) {
            id @skip(if: $id_file)
            name @skip(if: $name)
          }
          promotore @skip(if: $promotore) {
            id @skip(if: $id_persona)
            nome @skip(if: $nome)
            cognome @skip(if: $cognome)
            ragione_sociale @skip(if: $ragione_sociale)
            codice_fiscale @skip(if: $codice_fiscale)
            sesso @skip(if: $sesso)
            data_nascita @skip(if: $data_nascita)
            forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
            tipo_promotore_id @skip(if: $tipo_promotore_id)
            tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
            citta_nascita @skip(if: $citta_nascita) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            nazione_nascita @skip(if: $nazione_nascita) {
              id @skip(if: $id_nazione)
              denominazione @skip(if: $denominazione)
            }
            partita_iva @skip(if: $partita_iva)
            codice_ateco_id @skip(if: $codice_ateco_id)
            codice_ateco @skip(if: $codice_ateco) {
              id @skip(if: $id_codice_ateco)
              label @skip(if: $label)
            }
            forma_giuridica @skip(if: $forma_giuridica) {
              id @skip(if: $id_forma_giuridica)
              label @skip(if: $label)
              rules @skip(if: $rules)
            }
            tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
              id @skip(if: $id_tipologia_rappresentante)
              label @skip(if: $label)
            }
            indirizzo @skip(if: $indirizzo) {
              id @skip(if: $id_indirizzo)
              completo @skip(if: $completo)
              manuale @skip(if: $manuale)
              toponimo @skip(if: $toponimo)
              civico @skip(if: $civico)
              cap @skip(if: $cap)
              citta @skip(if: $citta) {
                id @skip(if: $id_citta)
                denominazione @skip(if: $denominazione)
                provincia @skip(if: $provincia) {
                  id @skip(if: $id_provincia)
                  denominazione @skip(if: $denominazione)
                  sigla @skip(if: $sigla)
                }
              }
              geom_ @skip(if: $geom_)
              geom @skip(if: $geom)
            }
            contatti @skip(if: $contatti) {
              id @skip(if: $id_persona_contatto)
              contatto @skip(if: $contatto) {
                id @skip(if: $id_contatto)
                tipo_contatto_id @skip(if: $tipo_contatto_id)
                value @skip(if: $value)
                tipo_contatto @skip(if: $tipo_contatto) {
                  id @skip(if: $id_tipo_contatto)
                  label @skip(if: $label)
                  icon @skip(if: $icon)
                  validation @skip(if: $validation)
                }
              }
            }
            rappresentante_legale @skip(if: $rappresentante_legale) {
              id @skip(if: $id_persona)
              nome @skip(if: $nome)
              cognome @skip(if: $cognome)
              ragione_sociale @skip(if: $ragione_sociale)
              codice_fiscale @skip(if: $codice_fiscale)
              sesso @skip(if: $sesso)
              data_nascita @skip(if: $data_nascita)
              forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
              tipo_promotore_id @skip(if: $tipo_promotore_id)
              tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
              citta_nascita @skip(if: $citta_nascita) {
                id @skip(if: $id_citta)
                denominazione @skip(if: $denominazione)
                provincia @skip(if: $provincia) {
                  id @skip(if: $id_provincia)
                  denominazione @skip(if: $denominazione)
                  sigla @skip(if: $sigla)
                }
              }
              nazione_nascita @skip(if: $nazione_nascita) {
                id @skip(if: $id_nazione)
                denominazione @skip(if: $denominazione)
              }
              partita_iva @skip(if: $partita_iva)
              codice_ateco_id @skip(if: $codice_ateco_id)
              codice_ateco @skip(if: $codice_ateco) {
                id @skip(if: $id_codice_ateco)
                label @skip(if: $label)
              }
              forma_giuridica @skip(if: $forma_giuridica) {
                id @skip(if: $id_forma_giuridica)
                label @skip(if: $label)
                rules @skip(if: $rules)
              }
              tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
                id @skip(if: $id_tipologia_rappresentante)
                label @skip(if: $label)
              }
              indirizzo @skip(if: $indirizzo) {
                id @skip(if: $id_indirizzo)
                completo @skip(if: $completo)
                manuale @skip(if: $manuale)
                toponimo @skip(if: $toponimo)
                civico @skip(if: $civico)
                cap @skip(if: $cap)
                citta @skip(if: $citta) {
                  id @skip(if: $id_citta)
                  denominazione @skip(if: $denominazione)
                  provincia @skip(if: $provincia) {
                    id @skip(if: $id_provincia)
                    denominazione @skip(if: $denominazione)
                    sigla @skip(if: $sigla)
                  }
                }
                geom_ @skip(if: $geom_)
                geom @skip(if: $geom)
              }
              contatti @skip(if: $contatti) {
                id @skip(if: $id_persona_contatto)
                contatto @skip(if: $contatto) {
                  id @skip(if: $id_contatto)
                  tipo_contatto_id @skip(if: $tipo_contatto_id)
                  value @skip(if: $value)
                  tipo_contatto @skip(if: $tipo_contatto) {
                    id @skip(if: $id_tipo_contatto)
                    label @skip(if: $label)
                    icon @skip(if: $icon)
                    validation @skip(if: $validation)
                  }
                }
              }
            }
          }
          societa @skip(if: $societa) {
            id @skip(if: $id_persona)
            nome @skip(if: $nome)
            cognome @skip(if: $cognome)
            ragione_sociale @skip(if: $ragione_sociale)
            codice_fiscale @skip(if: $codice_fiscale)
            sesso @skip(if: $sesso)
            data_nascita @skip(if: $data_nascita)
            forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
            tipo_promotore_id @skip(if: $tipo_promotore_id)
            tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
            citta_nascita @skip(if: $citta_nascita) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            nazione_nascita @skip(if: $nazione_nascita) {
              id @skip(if: $id_nazione)
              denominazione @skip(if: $denominazione)
            }
            partita_iva @skip(if: $partita_iva)
            codice_ateco_id @skip(if: $codice_ateco_id)
            codice_ateco @skip(if: $codice_ateco) {
              id @skip(if: $id_codice_ateco)
              label @skip(if: $label)
            }
            forma_giuridica @skip(if: $forma_giuridica) {
              id @skip(if: $id_forma_giuridica)
              label @skip(if: $label)
              rules @skip(if: $rules)
            }
            tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
              id @skip(if: $id_tipologia_rappresentante)
              label @skip(if: $label)
            }
            indirizzo @skip(if: $indirizzo) {
              id @skip(if: $id_indirizzo)
              completo @skip(if: $completo)
              manuale @skip(if: $manuale)
              toponimo @skip(if: $toponimo)
              civico @skip(if: $civico)
              cap @skip(if: $cap)
              citta @skip(if: $citta) {
                id @skip(if: $id_citta)
                denominazione @skip(if: $denominazione)
                provincia @skip(if: $provincia) {
                  id @skip(if: $id_provincia)
                  denominazione @skip(if: $denominazione)
                  sigla @skip(if: $sigla)
                }
              }
              geom_ @skip(if: $geom_)
              geom @skip(if: $geom)
            }
            contatti @skip(if: $contatti) {
              id @skip(if: $id_persona_contatto)
              contatto @skip(if: $contatto) {
                id @skip(if: $id_contatto)
                tipo_contatto_id @skip(if: $tipo_contatto_id)
                value @skip(if: $value)
                tipo_contatto @skip(if: $tipo_contatto) {
                  id @skip(if: $id_tipo_contatto)
                  label @skip(if: $label)
                  icon @skip(if: $icon)
                  validation @skip(if: $validation)
                }
              }
            }
            rappresentante_legale @skip(if: $rappresentante_legale) {
              id @skip(if: $id_persona)
              nome @skip(if: $nome)
              cognome @skip(if: $cognome)
              ragione_sociale @skip(if: $ragione_sociale)
              codice_fiscale @skip(if: $codice_fiscale)
              sesso @skip(if: $sesso)
              data_nascita @skip(if: $data_nascita)
              forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
              tipo_promotore_id @skip(if: $tipo_promotore_id)
              tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
              citta_nascita @skip(if: $citta_nascita) {
                id @skip(if: $id_citta)
                denominazione @skip(if: $denominazione)
                provincia @skip(if: $provincia) {
                  id @skip(if: $id_provincia)
                  denominazione @skip(if: $denominazione)
                  sigla @skip(if: $sigla)
                }
              }
              nazione_nascita @skip(if: $nazione_nascita) {
                id @skip(if: $id_nazione)
                denominazione @skip(if: $denominazione)
              }
              partita_iva @skip(if: $partita_iva)
              codice_ateco_id @skip(if: $codice_ateco_id)
              codice_ateco @skip(if: $codice_ateco) {
                id @skip(if: $id_codice_ateco)
                label @skip(if: $label)
              }
              forma_giuridica @skip(if: $forma_giuridica) {
                id @skip(if: $id_forma_giuridica)
                label @skip(if: $label)
                rules @skip(if: $rules)
              }
              tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
                id @skip(if: $id_tipologia_rappresentante)
                label @skip(if: $label)
              }
              indirizzo @skip(if: $indirizzo) {
                id @skip(if: $id_indirizzo)
                completo @skip(if: $completo)
                manuale @skip(if: $manuale)
                toponimo @skip(if: $toponimo)
                civico @skip(if: $civico)
                cap @skip(if: $cap)
                citta @skip(if: $citta) {
                  id @skip(if: $id_citta)
                  denominazione @skip(if: $denominazione)
                  provincia @skip(if: $provincia) {
                    id @skip(if: $id_provincia)
                    denominazione @skip(if: $denominazione)
                    sigla @skip(if: $sigla)
                  }
                }
                geom_ @skip(if: $geom_)
                geom @skip(if: $geom)
              }
              contatti @skip(if: $contatti) {
                id @skip(if: $id_persona_contatto)
                contatto @skip(if: $contatto) {
                  id @skip(if: $id_contatto)
                  tipo_contatto_id @skip(if: $tipo_contatto_id)
                  value @skip(if: $value)
                  tipo_contatto @skip(if: $tipo_contatto) {
                    id @skip(if: $id_tipo_contatto)
                    label @skip(if: $label)
                    icon @skip(if: $icon)
                    validation @skip(if: $validation)
                  }
                }
              }
            }
          }
        }
      }
    }
    cer_categoria_adesione @skip(if: $cer_categoria_adesione) {
      id @skip(if: $id_cer_categoria_adesione)
      categoria @skip(if: $categoria)
    }
    cer_categoria_adesione_produttore @skip(if: $cer_categoria_adesione_produttore) {
      id @skip(if: $id_cer_categoria_adesione_produttore)
      categoria @skip(if: $categoria)
    }
    confirmo_id @skip(if: $confirmo_id)
    domande @skip(if: $domande) {
      tipologia_domanda @skip(if: $tipologia_domanda)
      risposta @skip(if: $risposta)
    }
    feedback @skip(if: $feedback) {
      label @skip(if: $label)
    }
    contratto @skip(if: $contratto) {
      id @skip(if: $id_file)
      name @skip(if: $name)
    }
    feedback_altro @skip(if: $feedback_altro)
    documenti @skip(if: $documenti) {
      id @skip(if: $id_documento)
      tipologia_documento @skip(if: $tipologia_documento)
      file @skip(if: $file) {
        id @skip(if: $id_file)
        name @skip(if: $name)
      }
    }
    segnalatore @skip(if: $segnalatore) {
      user_entity @skip(if: $user_entity) {
        first_name @skip(if: $first_name)
        last_name @skip(if: $last_name)
      }
    }
    asset_consumo @skip(if: $asset_consumo) {
      id @skip(if: $id_asset_consumo)
      pod @skip(if: $pod)
      tipo_pod_id @skip(if: $tipo_pod_id)
      foglio @skip(if: $foglio)
      particella @skip(if: $particella)
      subalterno @skip(if: $subalterno)
      sezione_catastale @skip(if: $sezione_catastale)
      accumulo_standalone @skip(if: $accumulo_standalone)
      intestatario @skip(if: $intestatario) {
        id @skip(if: $id_persona)
        nome @skip(if: $nome)
        cognome @skip(if: $cognome)
        ragione_sociale @skip(if: $ragione_sociale)
        codice_fiscale @skip(if: $codice_fiscale)
        sesso @skip(if: $sesso)
        data_nascita @skip(if: $data_nascita)
        forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
        tipo_promotore_id @skip(if: $tipo_promotore_id)
        tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
        citta_nascita @skip(if: $citta_nascita) {
          id @skip(if: $id_citta)
          denominazione @skip(if: $denominazione)
          provincia @skip(if: $provincia) {
            id @skip(if: $id_provincia)
            denominazione @skip(if: $denominazione)
            sigla @skip(if: $sigla)
          }
        }
        nazione_nascita @skip(if: $nazione_nascita) {
          id @skip(if: $id_nazione)
          denominazione @skip(if: $denominazione)
        }
        partita_iva @skip(if: $partita_iva)
        codice_ateco_id @skip(if: $codice_ateco_id)
        codice_ateco @skip(if: $codice_ateco) {
          id @skip(if: $id_codice_ateco)
          label @skip(if: $label)
        }
        forma_giuridica @skip(if: $forma_giuridica) {
          id @skip(if: $id_forma_giuridica)
          label @skip(if: $label)
          rules @skip(if: $rules)
        }
        tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
          id @skip(if: $id_tipologia_rappresentante)
          label @skip(if: $label)
        }
        indirizzo @skip(if: $indirizzo) {
          id @skip(if: $id_indirizzo)
          completo @skip(if: $completo)
          manuale @skip(if: $manuale)
          toponimo @skip(if: $toponimo)
          civico @skip(if: $civico)
          cap @skip(if: $cap)
          citta @skip(if: $citta) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          geom_ @skip(if: $geom_)
          geom @skip(if: $geom)
        }
        contatti @skip(if: $contatti) {
          id @skip(if: $id_persona_contatto)
          contatto @skip(if: $contatto) {
            id @skip(if: $id_contatto)
            tipo_contatto_id @skip(if: $tipo_contatto_id)
            value @skip(if: $value)
            tipo_contatto @skip(if: $tipo_contatto) {
              id @skip(if: $id_tipo_contatto)
              label @skip(if: $label)
              icon @skip(if: $icon)
              validation @skip(if: $validation)
            }
          }
        }
        rappresentante_legale @skip(if: $rappresentante_legale) {
          id @skip(if: $id_persona)
          nome @skip(if: $nome)
          cognome @skip(if: $cognome)
          ragione_sociale @skip(if: $ragione_sociale)
          codice_fiscale @skip(if: $codice_fiscale)
          sesso @skip(if: $sesso)
          data_nascita @skip(if: $data_nascita)
          forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
          tipo_promotore_id @skip(if: $tipo_promotore_id)
          tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
          citta_nascita @skip(if: $citta_nascita) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          nazione_nascita @skip(if: $nazione_nascita) {
            id @skip(if: $id_nazione)
            denominazione @skip(if: $denominazione)
          }
          partita_iva @skip(if: $partita_iva)
          codice_ateco_id @skip(if: $codice_ateco_id)
          codice_ateco @skip(if: $codice_ateco) {
            id @skip(if: $id_codice_ateco)
            label @skip(if: $label)
          }
          forma_giuridica @skip(if: $forma_giuridica) {
            id @skip(if: $id_forma_giuridica)
            label @skip(if: $label)
            rules @skip(if: $rules)
          }
          tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
            id @skip(if: $id_tipologia_rappresentante)
            label @skip(if: $label)
          }
          indirizzo @skip(if: $indirizzo) {
            id @skip(if: $id_indirizzo)
            completo @skip(if: $completo)
            manuale @skip(if: $manuale)
            toponimo @skip(if: $toponimo)
            civico @skip(if: $civico)
            cap @skip(if: $cap)
            citta @skip(if: $citta) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            geom_ @skip(if: $geom_)
            geom @skip(if: $geom)
          }
          contatti @skip(if: $contatti) {
            id @skip(if: $id_persona_contatto)
            contatto @skip(if: $contatto) {
              id @skip(if: $id_contatto)
              tipo_contatto_id @skip(if: $tipo_contatto_id)
              value @skip(if: $value)
              tipo_contatto @skip(if: $tipo_contatto) {
                id @skip(if: $id_tipo_contatto)
                label @skip(if: $label)
                icon @skip(if: $icon)
                validation @skip(if: $validation)
              }
            }
          }
        }
      }
      dati_consumo @skip(if: $dati_consumo) {
        id @skip(if: $id_dati_consumo)
        f1 @skip(if: $f1)
        f2 @skip(if: $f2)
        f3 @skip(if: $f3)
        data_inizio @skip(if: $data_inizio)
        data_fine @skip(if: $data_fine)
      }
      asset @skip(if: $asset) {
        id @skip(if: $id_asset)
        alias @skip(if: $alias)
        consumo @skip(if: $consumo)
        autoconsumo @skip(if: $autoconsumo)
        cabina @skip(if: $cabina) {
          id @skip(if: $id_cabina)
          cod_ac @skip(if: $cod_ac)
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) @skip(if: $condivisioneInstallatore) {
          id @skip(if: $id_condivisione)
          stato @skip(if: $stato)
          nome @skip(if: $nome)
          email @skip(if: $email)
          auth @skip(if: $auth) {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) @skip(if: $profiloInstallatore) {
              persona @skip(if: $persona) {
                nome @skip(if: $nome)
                ragione_sociale @skip(if: $ragione_sociale)
                contatti @skip(if: $contatti) {
                  contatto @skip(if: $contatto) {
                    value @skip(if: $value)
                    tipo_contatto @skip(if: $tipo_contatto) {
                      id @skip(if: $id_tipo_contatto)
                      label @skip(if: $label)
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) @skip(if: $condivisioneProsumer) {
          id @skip(if: $id_condivisione)
          stato @skip(if: $stato)
          nome @skip(if: $nome)
          email @skip(if: $email)
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) @skip(if: $condivisioneRecente) {
          id @skip(if: $id_condivisione)
          nome @skip(if: $nome)
          email @skip(if: $email)
        }
        gestori @skip(if: $gestori) {
          utente @skip(if: $utente) {
            id @skip(if: $id_user_entity)
            first_name @skip(if: $first_name)
            last_name @skip(if: $last_name)
            username @skip(if: $username)
            email @skip(if: $email)
          }
        }
        tipologia_abitativa @skip(if: $tipologia_abitativa) {
          id @skip(if: $id_tipologia_abitativa)
          label @skip(if: $label)
        }
        potenza_effettiva @skip(if: $potenza_effettiva)
        potenza_batteria @skip(if: $potenza_batteria)
        dimensione_id @skip(if: $dimensione_id)
        data_installazione_impianto @skip(if: $data_installazione_impianto)
        associato @skip(if: $associato)
        sottoscrizione_id @skip(if: $sottoscrizione_id)
        opzionato @skip(if: $opzionato)
        impianto @skip(if: $impianto)
        realizzando_impianto @skip(if: $realizzando_impianto)
        aiuto @skip(if: $aiuto)
        potenza_impianto_prevista @skip(if: $potenza_impianto_prevista)
        capacita_batteria_prevista @skip(if: $capacita_batteria_prevista)
        data_allaccio_prevista @skip(if: $data_allaccio_prevista)
        notifiche @skip(if: $notifiche)
        spazio_disponibile @skip(if: $spazio_disponibile)
        spazi_disponibili @skip(if: $spazi_disponibili) {
          id @skip(if: $id_spazi_disponibili)
          dimensione @skip(if: $dimensione)
          tipo_area @skip(if: $tipo_area) {
            id @skip(if: $id_tipo_area)
            label @skip(if: $label)
          }
        }
        lunedi_id @skip(if: $lunedi_id)
        martedi_id @skip(if: $martedi_id)
        mercoledi_id @skip(if: $mercoledi_id)
        giovedi_id @skip(if: $giovedi_id)
        venerdi_id @skip(if: $venerdi_id)
        sabato_id @skip(if: $sabato_id)
        domenica_id @skip(if: $domenica_id)
        visibilita_nome @skip(if: $visibilita_nome)
        posizione_esatta @skip(if: $posizione_esatta)
        scambio_su_posto @skip(if: $scambio_su_posto)
        incentivi_impianto @skip(if: $incentivi_impianto)
        dimensione @skip(if: $dimensione) {
          label @skip(if: $label)
        }
        tipologia_asset @skip(if: $tipologia_asset) {
          id @skip(if: $id_tipologia_asset)
          label @skip(if: $label)
          icon @skip(if: $icon)
          percentuale_autoconsumo @skip(if: $percentuale_autoconsumo)
          tipologia_prosumer @skip(if: $tipologia_prosumer)
          tipologia_asset_padre @skip(if: $tipologia_asset_padre) {
            id @skip(if: $id_tipologia_asset)
            label @skip(if: $label)
            icon @skip(if: $icon)
            percentuale_autoconsumo @skip(if: $percentuale_autoconsumo)
            tipologia_prosumer @skip(if: $tipologia_prosumer)
          }
        }
        indirizzo @skip(if: $indirizzo) {
          id @skip(if: $id_indirizzo)
          completo @skip(if: $completo)
          manuale @skip(if: $manuale)
          toponimo @skip(if: $toponimo)
          civico @skip(if: $civico)
          cap @skip(if: $cap)
          citta @skip(if: $citta) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          geom_ @skip(if: $geom_)
          geom @skip(if: $geom)
        }
        caratteristiche @skip(if: $caratteristiche) {
          caratteristica @skip(if: $caratteristica) {
            id @skip(if: $id_caratteristica)
            label @skip(if: $label)
            icon @skip(if: $icon)
          }
        }
      }
    }
    asset_produzione @skip(if: $asset_produzione) {
      id @skip(if: $id_asset_produzione)
      pod @skip(if: $pod)
      potenza_effettiva @skip(if: $potenza_effettiva)
      energia_immessa @skip(if: $energia_immessa)
      intestatario @skip(if: $intestatario) {
        id @skip(if: $id_persona)
        nome @skip(if: $nome)
        cognome @skip(if: $cognome)
        ragione_sociale @skip(if: $ragione_sociale)
        codice_fiscale @skip(if: $codice_fiscale)
        sesso @skip(if: $sesso)
        data_nascita @skip(if: $data_nascita)
        forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
        tipo_promotore_id @skip(if: $tipo_promotore_id)
        tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
        citta_nascita @skip(if: $citta_nascita) {
          id @skip(if: $id_citta)
          denominazione @skip(if: $denominazione)
          provincia @skip(if: $provincia) {
            id @skip(if: $id_provincia)
            denominazione @skip(if: $denominazione)
            sigla @skip(if: $sigla)
          }
        }
        nazione_nascita @skip(if: $nazione_nascita) {
          id @skip(if: $id_nazione)
          denominazione @skip(if: $denominazione)
        }
        partita_iva @skip(if: $partita_iva)
        codice_ateco_id @skip(if: $codice_ateco_id)
        codice_ateco @skip(if: $codice_ateco) {
          id @skip(if: $id_codice_ateco)
          label @skip(if: $label)
        }
        forma_giuridica @skip(if: $forma_giuridica) {
          id @skip(if: $id_forma_giuridica)
          label @skip(if: $label)
          rules @skip(if: $rules)
        }
        tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
          id @skip(if: $id_tipologia_rappresentante)
          label @skip(if: $label)
        }
        indirizzo @skip(if: $indirizzo) {
          id @skip(if: $id_indirizzo)
          completo @skip(if: $completo)
          manuale @skip(if: $manuale)
          toponimo @skip(if: $toponimo)
          civico @skip(if: $civico)
          cap @skip(if: $cap)
          citta @skip(if: $citta) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          geom_ @skip(if: $geom_)
          geom @skip(if: $geom)
        }
        contatti @skip(if: $contatti) {
          id @skip(if: $id_persona_contatto)
          contatto @skip(if: $contatto) {
            id @skip(if: $id_contatto)
            tipo_contatto_id @skip(if: $tipo_contatto_id)
            value @skip(if: $value)
            tipo_contatto @skip(if: $tipo_contatto) {
              id @skip(if: $id_tipo_contatto)
              label @skip(if: $label)
              icon @skip(if: $icon)
              validation @skip(if: $validation)
            }
          }
        }
        rappresentante_legale @skip(if: $rappresentante_legale) {
          id @skip(if: $id_persona)
          nome @skip(if: $nome)
          cognome @skip(if: $cognome)
          ragione_sociale @skip(if: $ragione_sociale)
          codice_fiscale @skip(if: $codice_fiscale)
          sesso @skip(if: $sesso)
          data_nascita @skip(if: $data_nascita)
          forma_giuridica_cer_id @skip(if: $forma_giuridica_cer_id)
          tipo_promotore_id @skip(if: $tipo_promotore_id)
          tipologia_rappresentante_id @skip(if: $tipologia_rappresentante_id)
          citta_nascita @skip(if: $citta_nascita) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          nazione_nascita @skip(if: $nazione_nascita) {
            id @skip(if: $id_nazione)
            denominazione @skip(if: $denominazione)
          }
          partita_iva @skip(if: $partita_iva)
          codice_ateco_id @skip(if: $codice_ateco_id)
          codice_ateco @skip(if: $codice_ateco) {
            id @skip(if: $id_codice_ateco)
            label @skip(if: $label)
          }
          forma_giuridica @skip(if: $forma_giuridica) {
            id @skip(if: $id_forma_giuridica)
            label @skip(if: $label)
            rules @skip(if: $rules)
          }
          tipologia_rappresentante @skip(if: $tipologia_rappresentante) {
            id @skip(if: $id_tipologia_rappresentante)
            label @skip(if: $label)
          }
          indirizzo @skip(if: $indirizzo) {
            id @skip(if: $id_indirizzo)
            completo @skip(if: $completo)
            manuale @skip(if: $manuale)
            toponimo @skip(if: $toponimo)
            civico @skip(if: $civico)
            cap @skip(if: $cap)
            citta @skip(if: $citta) {
              id @skip(if: $id_citta)
              denominazione @skip(if: $denominazione)
              provincia @skip(if: $provincia) {
                id @skip(if: $id_provincia)
                denominazione @skip(if: $denominazione)
                sigla @skip(if: $sigla)
              }
            }
            geom_ @skip(if: $geom_)
            geom @skip(if: $geom)
          }
          contatti @skip(if: $contatti) {
            id @skip(if: $id_persona_contatto)
            contatto @skip(if: $contatto) {
              id @skip(if: $id_contatto)
              tipo_contatto_id @skip(if: $tipo_contatto_id)
              value @skip(if: $value)
              tipo_contatto @skip(if: $tipo_contatto) {
                id @skip(if: $id_tipo_contatto)
                label @skip(if: $label)
                icon @skip(if: $icon)
                validation @skip(if: $validation)
              }
            }
          }
        }
      }
      richiesta_pnrr @skip(if: $richiesta_pnrr)
      cod_richiesta_terna @skip(if: $cod_richiesta_terna)
      cod_censimp @skip(if: $cod_censimp)
      tipologia_impianto_id @skip(if: $tipologia_impianto_id)
      richiesta_modello_unico @skip(if: $richiesta_modello_unico)
      presenza_accumulo @skip(if: $presenza_accumulo)
      potenza_batteria @skip(if: $potenza_batteria)
      sezione_catastale @skip(if: $sezione_catastale)
      foglio @skip(if: $foglio)
      particella @skip(if: $particella)
      subalterno @skip(if: $subalterno)
      ubicazione_impianto_aderente @skip(if: $ubicazione_impianto_aderente)
      data_installazione_impianto @skip(if: $data_installazione_impianto)
      configurazione_accumulo_id @skip(if: $configurazione_accumulo_id)
      aderenza_delibera_autoconsumo @skip(if: $aderenza_delibera_autoconsumo)
      data_adesione_autoconsumo @skip(if: $data_adesione_autoconsumo)
      prelievi_non_ausiliari @skip(if: $prelievi_non_ausiliari)
      indirizzo @skip(if: $indirizzo) {
        id @skip(if: $id_indirizzo)
        completo @skip(if: $completo)
        manuale @skip(if: $manuale)
        toponimo @skip(if: $toponimo)
        civico @skip(if: $civico)
        cap @skip(if: $cap)
        citta @skip(if: $citta) {
          id @skip(if: $id_citta)
          denominazione @skip(if: $denominazione)
          provincia @skip(if: $provincia) {
            id @skip(if: $id_provincia)
            denominazione @skip(if: $denominazione)
            sigla @skip(if: $sigla)
          }
        }
        geom_ @skip(if: $geom_)
        geom @skip(if: $geom)
      }
      codice_fatturato_pnrr @skip(if: $codice_fatturato_pnrr)
      delibera_gse_pnrr @skip(if: $delibera_gse_pnrr) {
        id @skip(if: $id_file)
        name @skip(if: $name)
      }
      documenti_pnrr @skip(if: $documenti_pnrr) {
        id @skip(if: $id_documenti_pnrr)
        tipologia_documento @skip(if: $tipologia_documento)
        file @skip(if: $file) {
          id @skip(if: $id_file)
          name @skip(if: $name)
        }
      }
      motivanzione_no_pnrr @skip(if: $motivanzione_no_pnrr)
      esito_pnrr @skip(if: $esito_pnrr)
      unita @skip(if: $unita) {
        id @skip(if: $id_unita)
        cod_up @skip(if: $cod_up)
        data_attivazione @skip(if: $data_attivazione)
        data_disattivazione @skip(if: $data_disattivazione)
        sezioni @skip(if: $sezioni) {
          id @skip(if: $id_sezione)
          codice_sezione @skip(if: $codice_sezione)
          data_decorrenza_autoconsumo @skip(if: $data_decorrenza_autoconsumo)
          incompatibilita_incentivi_id @skip(if: $incompatibilita_incentivi_id)
          incompatibilita_incentivi_altro @skip(if: $incompatibilita_incentivi_altro)
          tipologia_sito_impianto_id @skip(if: $tipologia_sito_impianto_id)
          dispositivo_inseguimento_solare @skip(if: $dispositivo_inseguimento_solare)
          pannelli_bifacciali @skip(if: $pannelli_bifacciali)
          esposizione_prevalente_id @skip(if: $esposizione_prevalente_id)
          inclinazione_prevalente @skip(if: $inclinazione_prevalente)
          incentivi @skip(if: $incentivi) {
            id @skip(if: $id_incentivo)
            rispetto_principio_dns @skip(if: $rispetto_principio_dns)
            usufruito_incentivi_rilancio @skip(if: $usufruito_incentivi_rilancio)
            quota_potenza_rinnovabili_obbligo @skip(if: $quota_potenza_rinnovabili_obbligo)
            contributi_id @skip(if: $contributi_id)
            quota_incentivo @skip(if: $quota_incentivo)
          }
          titoli_autorizzativi @skip(if: $titoli_autorizzativi) {
            id @skip(if: $id_titolo_autorizzativo)
            tipo_titolo_id @skip(if: $tipo_titolo_id)
            ente @skip(if: $ente)
            protocollo @skip(if: $protocollo)
            data @skip(if: $data)
          }
        }
      }
      asset @skip(if: $asset) {
        id @skip(if: $id_asset)
        alias @skip(if: $alias)
        consumo @skip(if: $consumo)
        autoconsumo @skip(if: $autoconsumo)
        cabina @skip(if: $cabina) {
          id @skip(if: $id_cabina)
          cod_ac @skip(if: $cod_ac)
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) @skip(if: $condivisioneInstallatore) {
          id @skip(if: $id_condivisione)
          stato @skip(if: $stato)
          nome @skip(if: $nome)
          email @skip(if: $email)
          auth @skip(if: $auth) {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) @skip(if: $profiloInstallatore) {
              persona @skip(if: $persona) {
                nome @skip(if: $nome)
                ragione_sociale @skip(if: $ragione_sociale)
                contatti @skip(if: $contatti) {
                  contatto @skip(if: $contatto) {
                    value @skip(if: $value)
                    tipo_contatto @skip(if: $tipo_contatto) {
                      id @skip(if: $id_tipo_contatto)
                      label @skip(if: $label)
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) @skip(if: $condivisioneProsumer) {
          id @skip(if: $id_condivisione)
          stato @skip(if: $stato)
          nome @skip(if: $nome)
          email @skip(if: $email)
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) @skip(if: $condivisioneRecente) {
          id @skip(if: $id_condivisione)
          nome @skip(if: $nome)
          email @skip(if: $email)
        }
        gestori @skip(if: $gestori) {
          utente @skip(if: $utente) {
            id @skip(if: $id_user_entity)
            first_name @skip(if: $first_name)
            last_name @skip(if: $last_name)
            username @skip(if: $username)
            email @skip(if: $email)
          }
        }
        tipologia_abitativa @skip(if: $tipologia_abitativa) {
          id @skip(if: $id_tipologia_abitativa)
          label @skip(if: $label)
        }
        potenza_effettiva @skip(if: $potenza_effettiva)
        potenza_batteria @skip(if: $potenza_batteria)
        dimensione_id @skip(if: $dimensione_id)
        data_installazione_impianto @skip(if: $data_installazione_impianto)
        associato @skip(if: $associato)
        sottoscrizione_id @skip(if: $sottoscrizione_id)
        opzionato @skip(if: $opzionato)
        impianto @skip(if: $impianto)
        realizzando_impianto @skip(if: $realizzando_impianto)
        aiuto @skip(if: $aiuto)
        potenza_impianto_prevista @skip(if: $potenza_impianto_prevista)
        capacita_batteria_prevista @skip(if: $capacita_batteria_prevista)
        data_allaccio_prevista @skip(if: $data_allaccio_prevista)
        notifiche @skip(if: $notifiche)
        spazio_disponibile @skip(if: $spazio_disponibile)
        spazi_disponibili @skip(if: $spazi_disponibili) {
          id @skip(if: $id_spazi_disponibili)
          dimensione @skip(if: $dimensione)
          tipo_area @skip(if: $tipo_area) {
            id @skip(if: $id_tipo_area)
            label @skip(if: $label)
          }
        }
        lunedi_id @skip(if: $lunedi_id)
        martedi_id @skip(if: $martedi_id)
        mercoledi_id @skip(if: $mercoledi_id)
        giovedi_id @skip(if: $giovedi_id)
        venerdi_id @skip(if: $venerdi_id)
        sabato_id @skip(if: $sabato_id)
        domenica_id @skip(if: $domenica_id)
        visibilita_nome @skip(if: $visibilita_nome)
        posizione_esatta @skip(if: $posizione_esatta)
        scambio_su_posto @skip(if: $scambio_su_posto)
        incentivi_impianto @skip(if: $incentivi_impianto)
        dimensione @skip(if: $dimensione) {
          label @skip(if: $label)
        }
        tipologia_asset @skip(if: $tipologia_asset) {
          id @skip(if: $id_tipologia_asset)
          label @skip(if: $label)
          icon @skip(if: $icon)
          percentuale_autoconsumo @skip(if: $percentuale_autoconsumo)
          tipologia_prosumer @skip(if: $tipologia_prosumer)
          tipologia_asset_padre @skip(if: $tipologia_asset_padre) {
            id @skip(if: $id_tipologia_asset)
            label @skip(if: $label)
            icon @skip(if: $icon)
            percentuale_autoconsumo @skip(if: $percentuale_autoconsumo)
            tipologia_prosumer @skip(if: $tipologia_prosumer)
          }
        }
        indirizzo @skip(if: $indirizzo) {
          id @skip(if: $id_indirizzo)
          completo @skip(if: $completo)
          manuale @skip(if: $manuale)
          toponimo @skip(if: $toponimo)
          civico @skip(if: $civico)
          cap @skip(if: $cap)
          citta @skip(if: $citta) {
            id @skip(if: $id_citta)
            denominazione @skip(if: $denominazione)
            provincia @skip(if: $provincia) {
              id @skip(if: $id_provincia)
              denominazione @skip(if: $denominazione)
              sigla @skip(if: $sigla)
            }
          }
          geom_ @skip(if: $geom_)
          geom @skip(if: $geom)
        }
        caratteristiche @skip(if: $caratteristiche) {
          caratteristica @skip(if: $caratteristica) {
            id @skip(if: $id_caratteristica)
            label @skip(if: $label)
            icon @skip(if: $icon)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExportElencoRichiesteFounderGQL extends Apollo.Query<GetExportElencoRichiesteFounderQuery, GetExportElencoRichiesteFounderQueryVariables> {
    document = GetExportElencoRichiesteFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExportFlussoConsumatori2026FounderDocument = gql`
    query GetExportFlussoConsumatori2026Founder($where: sottoscrizione_bool_exp!) {
  sottoscrizione(where: $where, order_by: {updated_at: desc}) {
    id
    stato
    tipologia_richiesta
    asset_consumo {
      pod
      accumulo_standalone
      intestatario {
        nome
        cognome
        codice_fiscale
        partita_iva
        ragione_sociale
        forma_giuridica {
          id
        }
        codice_ateco_id
        codice_ateco {
          id
        }
        rappresentante_legale {
          partita_iva
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExportFlussoConsumatori2026FounderGQL extends Apollo.Query<GetExportFlussoConsumatori2026FounderQuery, GetExportFlussoConsumatori2026FounderQueryVariables> {
    document = GetExportFlussoConsumatori2026FounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExportFlussoProduttoriGseFounderDocument = gql`
    query GetExportFlussoProduttoriGSEFounder($where: sottoscrizione_bool_exp) {
  sottoscrizione(where: $where) {
    id
    stato
    tipologia_richiesta
    data_ammissione
    asset_consumo {
      pod
    }
    asset_produzione {
      cod_censimp
      data_adesione_autoconsumo
      aderenza_delibera_autoconsumo
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      configurazione_accumulo_id
      ubicazione_impianto_aderente
      sezione_catastale
      foglio
      particella
      subalterno
      prelievi_non_ausiliari
      indirizzo {
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          denominazione
        }
        geom_
      }
      intestatario {
        nome
        cognome
        ragione_sociale
        codice_fiscale
        partita_iva
        rappresentante_legale {
          partita_iva
        }
      }
      unita {
        cod_up
        sezioni {
          codice_sezione
          data_decorrenza_autoconsumo
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            rispetto_principio_dns
            quota_potenza_rinnovabili_obbligo
            usufruito_incentivi_rilancio
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExportFlussoProduttoriGseFounderGQL extends Apollo.Query<GetExportFlussoProduttoriGseFounderQuery, GetExportFlussoProduttoriGseFounderQueryVariables> {
    document = GetExportFlussoProduttoriGseFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExportCustomFounderDocument = gql`
    query GetExportCustomFounder($where: sottoscrizione_bool_exp!) {
  sottoscrizione(where: $where, order_by: {updated_at: desc}) {
    stato
    tipologia_richiesta
    data_ammissione
    data_recesso
    codice_univico_promotore
    iban_accredito_incentivi
    intestatario_conto_corrente
    cer_cabina {
      cabina {
        cod_ac
      }
      cer {
        alias
        cer_padre {
          alias
        }
      }
    }
    asset_consumo {
      pod
      accumulo_standalone
      sezione_catastale
      foglio
      particella
      subalterno
      intestatario {
        nome
        cognome
        ragione_sociale
        codice_fiscale
        partita_iva
        codice_ateco {
          id
        }
        sesso
        data_nascita
        forma_giuridica {
          id
          label
        }
        nazione_nascita {
          denominazione
        }
        citta_nascita {
          denominazione
          provincia {
            sigla
          }
        }
        indirizzo {
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            denominazione
          }
          geom_
        }
        contatti {
          contatto {
            tipo_contatto_id
            value
          }
        }
        rappresentante_legale {
          nome
          cognome
          codice_fiscale
          data_nascita
          sesso
          nazione_nascita {
            denominazione
          }
          citta_nascita {
            denominazione
            provincia {
              sigla
            }
          }
          indirizzo {
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              denominazione
            }
            geom_
          }
          contatti {
            contatto {
              tipo_contatto_id
              value
            }
          }
        }
      }
      asset {
        alias
        consumo
        potenza_effettiva
        potenza_batteria
        data_installazione_impianto
        incentivi_impianto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        tipologia_asset {
          label
        }
        indirizzo {
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            denominazione
          }
          geom_
        }
        gestori(order_by: {created_at: asc}, limit: 1) {
          utente {
            first_name
            last_name
            email
          }
        }
        condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          nome
          email
        }
      }
    }
    asset_produzione {
      pod
      potenza_effettiva
      energia_immessa
      potenza_batteria
      cod_censimp
      cod_richiesta_terna
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      configurazione_accumulo_id
      aderenza_delibera_autoconsumo
      data_adesione_autoconsumo
      prelievi_non_ausiliari
      sezione_catastale
      foglio
      particella
      subalterno
      indirizzo {
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          denominazione
        }
        geom_
      }
      asset {
        condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          nome
          email
        }
      }
      unita {
        cod_up
        sezioni {
          codice_sezione
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            rispetto_principio_dns
            quota_potenza_rinnovabili_obbligo
            usufruito_incentivi_rilancio
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
    }
    cer_categoria_adesione {
      categoria
    }
    cer_categoria_adesione_produttore {
      categoria
    }
    segnalatore {
      user_entity {
        first_name
        last_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExportCustomFounderGQL extends Apollo.Query<GetExportCustomFounderQuery, GetExportCustomFounderQueryVariables> {
    document = GetExportCustomFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClearCerNotificationDocument = gql`
    mutation ClearCerNotification($id: uuid!) {
  update_cer(where: {id: {_eq: $id}}, _set: {notifiche: 0}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClearCerNotificationGQL extends Apollo.Mutation<ClearCerNotificationMutation, ClearCerNotificationMutationVariables> {
    document = ClearCerNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetElencoIncentiviByCerCabinaIdDocument = gql`
    subscription GetElencoIncentiviByCerCabinaId($cer_cabina_id: uuid!) {
  incentivi_ripartizione(
    where: {cer_cabina_id: {_eq: $cer_cabina_id}}
    order_by: {data: desc}
  ) {
    id
    parametri
    stato_calcolo
    data
    misure
    calcolati
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetElencoIncentiviByCerCabinaIdGQL extends Apollo.Subscription<GetElencoIncentiviByCerCabinaIdSubscription, GetElencoIncentiviByCerCabinaIdSubscriptionVariables> {
    document = GetElencoIncentiviByCerCabinaIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContrattoRidcDocument = gql`
    query GetContrattoRIDC($cer_cabina_id: uuid!) {
  sottoscrizione(
    where: {cer_cabina_id: {_eq: $cer_cabina_id}, data_ammissione: {_is_null: false}, asset_produzione_id: {_is_null: false}, asset_produzione: {contratto_ridc: {_is_null: false}}}
  ) {
    asset_produzione {
      asset_id
      contratto_ridc
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContrattoRidcGQL extends Apollo.Query<GetContrattoRidcQuery, GetContrattoRidcQueryVariables> {
    document = GetContrattoRidcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCerGeomDocument = gql`
    mutation UpdateCerGeom($id: uuid!, $_set: cer_geom_set_input!) {
  update_cer_geom_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCerGeomGQL extends Apollo.Mutation<UpdateCerGeomMutation, UpdateCerGeomMutationVariables> {
    document = UpdateCerGeomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioneGeomDocument = gql`
    query GetConfigurazioneGeom($id: uuid!) {
  cer_geom_by_pk(id: $id) {
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioneGeomGQL extends Apollo.Query<GetConfigurazioneGeomQuery, GetConfigurazioneGeomQueryVariables> {
    document = GetConfigurazioneGeomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioniCerListDocument = gql`
    query GetConfigurazioniCerList($where: cer_bool_exp = {}) {
  cer(where: $where, order_by: {stato_cer: desc, created_at: desc}) {
    alias
    configurazioni {
      id
      alias
      domande_richieste
      documenti_richiesti
      costi
      modulo_richiesta
      email_template
      richiesta_iban
      categorie_adesione(order_by: {categoria: asc}) {
        categoria
        tipologia
        tipologia_richiesta
        chiesto
        id
        regole
      }
      descrizione
      stato_cer
      partecipanti
      consumatori_dichiarati
      impianti
      produttori_dichiarati
      potenza
      potenza_dichiarata
      domande_richieste
      data_costituzione
      referral
      pubblicata
      mostra
      abilita_richieste
      attive
      iniziative
      richieste
      notifiche
      geom {
        id
        cabina_ids
      }
      richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
        stato
        updated_at
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      white_label
      whitelabel {
        id
        configurazione {
          id
          terms {
            id
            name
          }
          logo_chiaro {
            id
            name
          }
          logo_scuro {
            id
            name
          }
        }
      }
      logo {
        id
        name
      }
      volantino {
        id
        name
      }
      regolamento {
        id
        name
      }
      statuto {
        id
        name
      }
      promotore {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      societa {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      cer_padre {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
      }
      cer_cabina(order_by: {id: asc}) {
        id
        codice_gse
        cabina {
          id
          cod_ac
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioniCerListGQL extends Apollo.Query<GetConfigurazioniCerListQuery, GetConfigurazioniCerListQueryVariables> {
    document = GetConfigurazioniCerListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateReferralDocument = gql`
    query ValidateReferral($referral: String!) {
  cer(where: {referral: {_eq: $referral}}, limit: 1) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateReferralGQL extends Apollo.Query<ValidateReferralQuery, ValidateReferralQueryVariables> {
    document = ValidateReferralDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateReferralEditDocument = gql`
    query ValidateReferralEdit($id: uuid!, $referral: String!) {
  cer(where: {_and: {id: {_neq: $id}, referral: {_eq: $referral}}}, limit: 1) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateReferralEditGQL extends Apollo.Query<ValidateReferralEditQuery, ValidateReferralEditQueryVariables> {
    document = ValidateReferralEditDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEmailDocument = gql`
    mutation InsertEmail($destinatario: String!, $oggetto: String!, $message: String!) {
  insert_comunicazioni_email_one(
    object: {destinatario: $destinatario, oggetto: $oggetto, message: $message}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertEmailGQL extends Apollo.Mutation<InsertEmailMutation, InsertEmailMutationVariables> {
    document = InsertEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplatesDocument = gql`
    query GetEmailTemplates($where: comunicazioni_email_template_bool_exp) {
  comunicazioni_email_template(where: $where, order_by: {nome: asc}) {
    id
    nome
    oggetto
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailTemplatesGQL extends Apollo.Query<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables> {
    document = GetEmailTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEmailTemplateDocument = gql`
    mutation InsertEmailTemplate($object: comunicazioni_email_template_insert_input!) {
  insert_comunicazioni_email_template_one(object: $object) {
    id
    nome
    oggetto
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertEmailTemplateGQL extends Apollo.Mutation<InsertEmailTemplateMutation, InsertEmailTemplateMutationVariables> {
    document = InsertEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmailTemplateDocument = gql`
    mutation UpdateEmailTemplate($id: uuid!, $nome: String!, $oggetto: String!, $message: String!) {
  update_comunicazioni_email_template_by_pk(
    pk_columns: {id: $id}
    _set: {nome: $nome, oggetto: $oggetto, message: $message}
  ) {
    id
    nome
    oggetto
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmailTemplateGQL extends Apollo.Mutation<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables> {
    document = UpdateEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmailTemplateDocument = gql`
    mutation DeleteEmailTemplate($id: uuid!) {
  delete_comunicazioni_email_template_by_pk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmailTemplateGQL extends Apollo.Mutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables> {
    document = DeleteEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailInviateDocument = gql`
    query GetEmailInviate($limit: Int!, $offset: Int!, $where: comunicazioni_email_bool_exp, $order_by: [comunicazioni_email_order_by!]) {
  comunicazioni_email_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  comunicazioni_email(
    where: $where
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    id
    created_at
    destinatario
    oggetto
    message
    stato
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailInviateGQL extends Apollo.Query<GetEmailInviateQuery, GetEmailInviateQueryVariables> {
    document = GetEmailInviateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertSmsDocument = gql`
    mutation InsertSms($cer_id: uuid!, $cellulare: String!, $message: String!, $stato: String!) {
  insert_comunicazioni_sms_one(
    object: {cer_id: $cer_id, cellulare: $cellulare, message: $message, stato: $stato}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertSmsGQL extends Apollo.Mutation<InsertSmsMutation, InsertSmsMutationVariables> {
    document = InsertSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetListaUtentiFounderDocument = gql`
    query GetListaUtentiFounder($args: search_user_entity_args!, $limit: Int, $offset: Int, $where: auth_user_entity_bool_exp, $order_by: [auth_user_entity_order_by!]) {
  search_user_entity(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    email
    first_name
    last_name
    user_attributes {
      white_label {
        referral
      }
    }
    profili {
      tipologia
    }
    profilo_prosumer: profili(where: {tipologia: {_eq: prosumer}}) {
      codice_amico
    }
    codice_operatore {
      codice
    }
    consenso_privacy {
      newsletter
      sondaggi_statistici
      comunicazioni_commerciali
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetListaUtentiFounderGQL extends Apollo.Query<GetListaUtentiFounderQuery, GetListaUtentiFounderQueryVariables> {
    document = GetListaUtentiFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetListaUtentiFounderCountDocument = gql`
    query GetListaUtentiFounderCount($args: search_user_entity_args!, $where: auth_user_entity_bool_exp) {
  search_user_entity_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetListaUtentiFounderCountGQL extends Apollo.Query<GetListaUtentiFounderCountQuery, GetListaUtentiFounderCountQueryVariables> {
    document = GetListaUtentiFounderCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWhiteLabelsListaUtentiFounderDocument = gql`
    query GetWhiteLabelsListaUtentiFounder {
  cer(where: {root_id: {_is_null: true}}) {
    whitelabel {
      configurazione {
        referral
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWhiteLabelsListaUtentiFounderGQL extends Apollo.Query<GetWhiteLabelsListaUtentiFounderQuery, GetWhiteLabelsListaUtentiFounderQueryVariables> {
    document = GetWhiteLabelsListaUtentiFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCerSelectFounderDocument = gql`
    query GetCerSelectFounder($where: cer_bool_exp = {}, $configurazioni: Boolean = false) {
  cer(where: $where, order_by: {alias: asc}) {
    id
    alias
    configurazioni(order_by: {alias: asc}) @skip(if: $configurazioni) {
      id
      alias
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCerSelectFounderGQL extends Apollo.Query<GetCerSelectFounderQuery, GetCerSelectFounderQueryVariables> {
    document = GetCerSelectFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioneIdFounderDocument = gql`
    query GetConfigurazioneIdFounder($referral: String!) {
  white_label_configurazione(where: {referral: {_eq: $referral}}, limit: 1) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioneIdFounderGQL extends Apollo.Query<GetConfigurazioneIdFounderQuery, GetConfigurazioneIdFounderQueryVariables> {
    document = GetConfigurazioneIdFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPresetFounderDocument = gql`
    query GetPresetFounder($where: preset_bool_exp) {
  preset(where: $where, order_by: {nome: asc}) {
    id
    nome
    colonne
    filtro
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPresetFounderGQL extends Apollo.Query<GetPresetFounderQuery, GetPresetFounderQueryVariables> {
    document = GetPresetFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdatePresetFounderDocument = gql`
    mutation InsertOrUpdatePresetFounder($object: preset_insert_input!, $on_conflict: preset_on_conflict) {
  insert_preset_one(object: $object, on_conflict: $on_conflict) {
    id
    nome
    colonne
    filtro
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdatePresetFounderGQL extends Apollo.Mutation<InsertOrUpdatePresetFounderMutation, InsertOrUpdatePresetFounderMutationVariables> {
    document = InsertOrUpdatePresetFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePresetFounderDocument = gql`
    mutation DeletePresetFounder($id: uuid!) {
  delete_preset_by_pk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePresetFounderGQL extends Apollo.Mutation<DeletePresetFounderMutation, DeletePresetFounderMutationVariables> {
    document = DeletePresetFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetDestinazioniConfigurazioneDocument = gql`
    mutation SetDestinazioniConfigurazione($cer_id: uuid!, $keep_ids: [uuid!]!, $objects: [cer_configurazione_destinazione_contributo_insert_input!]!) {
  delete_cer_configurazione_destinazione_contributo(
    where: {cer_id: {_eq: $cer_id}, destinazione_contributo_id: {_nin: $keep_ids}}
  ) {
    affected_rows
  }
  insert_cer_configurazione_destinazione_contributo(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDestinazioniConfigurazioneGQL extends Apollo.Mutation<SetDestinazioniConfigurazioneMutation, SetDestinazioniConfigurazioneMutationVariables> {
    document = SetDestinazioniConfigurazioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CambiaStatoCabinaFounderDocument = gql`
    mutation CambiaStatoCabinaFounder($cercabinaid: uuid!, $action: String!, $codice: String) {
  cambia_stato_cabina(
    args: {cercabinaid: $cercabinaid, action: $action, codice: $codice}
  ) {
    id
    stato
    codice_gse
    codice_richiesta
    codice_modifica
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CambiaStatoCabinaFounderGQL extends Apollo.Mutation<CambiaStatoCabinaFounderMutation, CambiaStatoCabinaFounderMutationVariables> {
    document = CambiaStatoCabinaFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SalvaSnapshotCabinaFounderDocument = gql`
    mutation SalvaSnapshotCabinaFounder($cer_cabina_id: uuid!, $tipo: String!, $objects: [cer_cabina_snapshot_insert_input!]!) {
  delete_cer_cabina_snapshot(
    where: {cer_cabina_id: {_eq: $cer_cabina_id}, tipo: {_eq: $tipo}, applicato_at: {_is_null: true}}
  ) {
    affected_rows
  }
  insert_cer_cabina_snapshot(objects: $objects) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SalvaSnapshotCabinaFounderGQL extends Apollo.Mutation<SalvaSnapshotCabinaFounderMutation, SalvaSnapshotCabinaFounderMutationVariables> {
    document = SalvaSnapshotCabinaFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EliminaCabinaFounderDocument = gql`
    mutation EliminaCabinaFounder($id: uuid!) {
  update_cer_cabina(
    where: {id: {_eq: $id}, stato: {_eq: "da_aprire"}}
    _set: {cancellato: true}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EliminaCabinaFounderGQL extends Apollo.Mutation<EliminaCabinaFounderMutation, EliminaCabinaFounderMutationVariables> {
    document = EliminaCabinaFounderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBilancioAssetDocument = gql`
    subscription GetBilancioAsset($root_id: uuid!) {
  asset(
    where: {cabina: {cers: {cer: {root_id: {_eq: $root_id}}}}, consumi: {sottoscrizioni: {cer_cabina: {cer: {root_id: {_eq: $root_id}}}}}}
  ) {
    id
    sottoscrizione_id
    alias
    impianto
    tipologia_asset {
      id
      icon
      tipologia_asset_padre {
        id
        icon
      }
    }
    energia(order_by: {created_at: desc}, limit: 1) {
      immessa
      prelevata
    }
    gestori {
      utente {
        first_name
        last_name
      }
    }
    condivisioni(
      where: {tipo_profilo: {_neq: installatore}}
      order_by: {created_at: desc}
      limit: 1
    ) {
      nome
      email
    }
    indirizzo {
      geom
      citta {
        provincia {
          area
        }
      }
    }
    cabina {
      id
      cod_ac
    }
    consumi(order_by: {created_at: asc}, limit: 1) {
      pod
      sottoscrizioni {
        id
        stato
        tipologia_richiesta
        cer_cabina {
          cer {
            id
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBilancioAssetGQL extends Apollo.Subscription<GetBilancioAssetSubscription, GetBilancioAssetSubscriptionVariables> {
    document = GetBilancioAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBilancioCabinePointsDocument = gql`
    query GetBilancioCabinePoints($cabina_ids: [Int!]) {
  energy_village_area(where: {cabina: {id: {_in: $cabina_ids}}}) {
    id
    point
    cabina {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBilancioCabinePointsGQL extends Apollo.Query<GetBilancioCabinePointsQuery, GetBilancioCabinePointsQueryVariables> {
    document = GetBilancioCabinePointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBilancioCabinaGeomDocument = gql`
    query GetBilancioCabinaGeom($cabina_id: Int!) {
  energy_village_area(where: {cabina: {id: {_eq: $cabina_id}}}) {
    id
    geom
    cabina {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBilancioCabinaGeomGQL extends Apollo.Query<GetBilancioCabinaGeomQuery, GetBilancioCabinaGeomQueryVariables> {
    document = GetBilancioCabinaGeomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlussiGseDocument = gql`
    query GetFlussiGse($where: flussi_gse_flusso_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [flussi_gse_flusso_order_by!] = [{created_at: desc}]) {
  flussi_gse_flusso(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    created_at
    anno
    mese
    importo
    tipo_corrispettivo
    contratto_acc_cer
    soggetto_referente
    tipologia_calcolo_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlussiGseGQL extends Apollo.Query<GetFlussiGseQuery, GetFlussiGseQueryVariables> {
    document = GetFlussiGseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlussiGseCountDocument = gql`
    query GetFlussiGseCount($where: flussi_gse_flusso_bool_exp = {}) {
  flussi_gse_flusso_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlussiGseCountGQL extends Apollo.Query<GetFlussiGseCountQuery, GetFlussiGseCountQueryVariables> {
    document = GetFlussiGseCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStatiFatturaGseDocument = gql`
    query GetStatiFatturaGse($where: flussi_gse_flusso_bool_exp!) {
  flussi_gse_flusso(
    where: $where
    distinct_on: stato_fattura
    order_by: [{stato_fattura: asc}]
  ) {
    stato_fattura
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStatiFatturaGseGQL extends Apollo.Query<GetStatiFatturaGseQuery, GetStatiFatturaGseQueryVariables> {
    document = GetStatiFatturaGseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlussoGseExpansionDocument = gql`
    query GetFlussoGseExpansion($id: uuid!) {
  flussi_gse_flusso_by_pk(id: $id) {
    id
    nome
    contratto_ridc
    data_pubblicazione
    stato_fattura
    data_fatturazione
    numero_fattura
    data_pagamento
    data_incasso
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlussoGseExpansionGQL extends Apollo.Query<GetFlussoGseExpansionQuery, GetFlussoGseExpansionQueryVariables> {
    document = GetFlussoGseExpansionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlussoGseDocument = gql`
    query GetFlussoGse($id: uuid!) {
  flussi_gse_flusso_by_pk(id: $id) {
    id
    nome
    created_at
    file_id
    data
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlussoGseGQL extends Apollo.Query<GetFlussoGseQuery, GetFlussoGseQueryVariables> {
    document = GetFlussoGseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlussiGseExportDocument = gql`
    query GetFlussiGseExport($where: flussi_gse_flusso_bool_exp!, $order_by: [flussi_gse_flusso_order_by!] = [{created_at: desc}]) {
  flussi_gse_flusso(where: $where, order_by: $order_by) {
    id
    nome
    created_at
    anno
    mese
    importo
    tipo_corrispettivo
    contratto_acc_cer
    contratto_ridc
    soggetto_referente
    tipologia_calcolo_id
    data_pubblicazione
    stato_fattura
    data_fatturazione
    numero_fattura
    data_pagamento
    data_incasso
  }
  flussi_gse_flusso_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlussiGseExportGQL extends Apollo.Query<GetFlussiGseExportQuery, GetFlussiGseExportQueryVariables> {
    document = GetFlussiGseExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindFlussiGseDuplicatiDocument = gql`
    query FindFlussiGseDuplicati($where: flussi_gse_flusso_bool_exp!) {
  flussi_gse_flusso(where: $where, order_by: [{created_at: asc}, {id: asc}]) {
    id
    nome
    data_pubblicazione
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindFlussiGseDuplicatiGQL extends Apollo.Query<FindFlussiGseDuplicatiQuery, FindFlussiGseDuplicatiQueryVariables> {
    document = FindFlussiGseDuplicatiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertFlussoGseDocument = gql`
    mutation InsertFlussoGse($object: flussi_gse_flusso_insert_input!) {
  insert_flussi_gse_flusso_one(object: $object) {
    id
    nome
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertFlussoGseGQL extends Apollo.Mutation<InsertFlussoGseMutation, InsertFlussoGseMutationVariables> {
    document = InsertFlussoGseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFlussiGseDocument = gql`
    mutation DeleteFlussiGse($where: flussi_gse_flusso_bool_exp!) {
  delete_flussi_gse_flusso(where: $where) {
    affected_rows
    returning {
      id
      file_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFlussiGseGQL extends Apollo.Mutation<DeleteFlussiGseMutation, DeleteFlussiGseMutationVariables> {
    document = DeleteFlussiGseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSoggettiReferentiGseCerDocument = gql`
    query GetSoggettiReferentiGseCer($auth_id: String!) {
  cer(
    where: {gestori: {auth_id: {_eq: $auth_id}}, soggetto_referente_gse: {_is_null: false}}
  ) {
    id
    soggetto_referente_gse
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSoggettiReferentiGseCerGQL extends Apollo.Query<GetSoggettiReferentiGseCerQuery, GetSoggettiReferentiGseCerQueryVariables> {
    document = GetSoggettiReferentiGseCerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeomarketingConfigurazioniCerListDocument = gql`
    query GetGeomarketingConfigurazioniCerList($where: cer_bool_exp!) {
  cer(where: $where) {
    alias
    configurazioni {
      alias
      cer_cabina {
        cabina {
          id
          cod_ac
          elenco_citta
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeomarketingConfigurazioniCerListGQL extends Apollo.Query<GetGeomarketingConfigurazioniCerListQuery, GetGeomarketingConfigurazioniCerListQueryVariables> {
    document = GetGeomarketingConfigurazioniCerListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeomarketingCabinaGeomDocument = gql`
    query GetGeomarketingCabinaGeom($_in: [Int!]) {
  energy_village_area(where: {cabina: {id: {_in: $_in}}}, limit: 1) {
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeomarketingCabinaGeomGQL extends Apollo.Query<GetGeomarketingCabinaGeomQuery, GetGeomarketingCabinaGeomQueryVariables> {
    document = GetGeomarketingCabinaGeomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeomarketingCitiesByCabinaGeomDocument = gql`
    query GetGeomarketingCitiesByCabinaGeom($geom: geometry!) {
  unita_amministrativa_citta(where: {geom: {_st_intersects: $geom}}) {
    denominazione
    provincia {
      sigla
    }
    geom
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeomarketingCitiesByCabinaGeomGQL extends Apollo.Query<GetGeomarketingCitiesByCabinaGeomQuery, GetGeomarketingCitiesByCabinaGeomQueryVariables> {
    document = GetGeomarketingCitiesByCabinaGeomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeomarketingAssetsWithoutSubscriptionInCabinaDocument = gql`
    query GetGeomarketingAssetsWithoutSubscriptionInCabina($where: asset_bool_exp!) {
  asset(where: $where) {
    alias
    gestori(order_by: {created_at: asc}, limit: 1) {
      utente {
        first_name
        last_name
        email
        username
      }
    }
    tipologia_asset {
      icon
      tipologia_asset_padre {
        icon
      }
    }
    indirizzo {
      completo
      toponimo
      civico
      cap
      manuale
      citta {
        denominazione
      }
      geom
      geom_
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeomarketingAssetsWithoutSubscriptionInCabinaGQL extends Apollo.Query<GetGeomarketingAssetsWithoutSubscriptionInCabinaQuery, GetGeomarketingAssetsWithoutSubscriptionInCabinaQueryVariables> {
    document = GetGeomarketingAssetsWithoutSubscriptionInCabinaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CambiaStatoInstallatoreDocument = gql`
    mutation CambiaStatoInstallatore($args: cambia_stato_installatore_args = {}) {
  cambia_stato_installatore(args: $args) {
    stato
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CambiaStatoInstallatoreGQL extends Apollo.Mutation<CambiaStatoInstallatoreMutation, CambiaStatoInstallatoreMutationVariables> {
    document = CambiaStatoInstallatoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioneInstallatoreDocument = gql`
    subscription GetSottoscrizioneInstallatore($id: uuid!) {
  sottoscrizione_by_pk(id: $id) {
    id
    stato
    categoria_adesione
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    data_associazione
    data_opzione
    data_scadenza
    data_recesso
    iban_accredito_incentivi
    intestatario_conto_corrente
    iniziative(order_by: {data_inizio: desc}) {
      id
      data_inizio
      data_fine
      destinazione_contributo_id
      cer_destinazione_contributo {
        id
        descrizione
      }
    }
    codice_univico_promotore
    link_fascicolo
    cer_cabina {
      id
      codice_gse
      cabina {
        id
        cod_ac
      }
      cer {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        richiesta_iniziativa_sociale
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        cer_padre {
          id
          alias
          domande_richieste
          documenti_richiesti
          costi
          modulo_richiesta
          email_template
          richiesta_iban
          richiesta_iniziativa_sociale
          categorie_adesione(order_by: {categoria: asc}) {
            categoria
            tipologia
            tipologia_richiesta
            chiesto
            id
            regole
          }
          descrizione
          stato_cer
          partecipanti
          consumatori_dichiarati
          impianti
          produttori_dichiarati
          potenza
          potenza_dichiarata
          domande_richieste
          data_costituzione
          referral
          pubblicata
          mostra
          abilita_richieste
          attive
          iniziative
          richieste
          notifiche
          geom {
            id
            cabina_ids
          }
          richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
            stato
            updated_at
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          white_label
          whitelabel {
            id
            configurazione {
              id
              terms {
                id
                name
              }
              logo_chiaro {
                id
                name
              }
              logo_scuro {
                id
                name
              }
            }
          }
          logo {
            id
            name
          }
          volantino {
            id
            name
          }
          regolamento {
            id
            name
          }
          statuto {
            id
            name
          }
          promotore {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          societa {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
        }
      }
    }
    cer_categoria_adesione {
      id
      categoria
    }
    cer_categoria_adesione_produttore {
      id
      categoria
    }
    confirmo_id
    domande {
      tipologia_domanda
      risposta
    }
    feedback {
      label
    }
    contratto {
      id
      name
    }
    feedback_altro
    documenti {
      id
      tipologia_documento
      file {
        id
        name
      }
    }
    segnalatore {
      user_entity {
        first_name
        last_name
      }
    }
    asset_consumo {
      id
      pod
      tipo_pod_id
      foglio
      particella
      subalterno
      sezione_catastale
      accumulo_standalone
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      dati_consumo(order_by: {data_inizio: asc}) {
        id
        f1
        f2
        f3
        data_inizio
        data_fine
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
    asset_produzione {
      id
      pod
      potenza_effettiva
      energia_immessa
      referente_gse_nome
      referente_gse_email
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      richiesta_pnrr
      cod_richiesta_terna
      cod_censimp
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      potenza_batteria
      sezione_catastale
      foglio
      particella
      subalterno
      ubicazione_impianto_aderente
      data_installazione_impianto
      configurazione_accumulo_id
      aderenza_delibera_autoconsumo
      data_adesione_autoconsumo
      prelievi_non_ausiliari
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      codice_fatturato_pnrr
      delibera_gse_pnrr {
        id
        name
      }
      documenti_pnrr {
        id
        tipologia_documento
        file {
          id
          name
        }
      }
      motivanzione_no_pnrr
      esito_pnrr
      unita {
        id
        cod_up
        data_attivazione
        data_disattivazione
        sezioni {
          id
          codice_sezione
          data_decorrenza_autoconsumo
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            id
            rispetto_principio_dns
            usufruito_incentivi_rilancio
            quota_potenza_rinnovabili_obbligo
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            id
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioneInstallatoreGQL extends Apollo.Subscription<GetSottoscrizioneInstallatoreSubscription, GetSottoscrizioneInstallatoreSubscriptionVariables> {
    document = GetSottoscrizioneInstallatoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCerFilterOptionsInstallatoreDocument = gql`
    query GetCerFilterOptionsInstallatore {
  sottoscrizione(distinct_on: cer_cabina_id) {
    cer_cabina {
      cer {
        id
        alias
        cer_padre {
          id
          alias
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCerFilterOptionsInstallatoreGQL extends Apollo.Query<GetCerFilterOptionsInstallatoreQuery, GetCerFilterOptionsInstallatoreQueryVariables> {
    document = GetCerFilterOptionsInstallatoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioniInstallatoreCountDocument = gql`
    subscription GetSottoscrizioniInstallatoreCount($args: search_sottoscrizioni_args!) {
  search_sottoscrizioni_aggregate(args: $args) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioniInstallatoreCountGQL extends Apollo.Subscription<GetSottoscrizioniInstallatoreCountSubscription, GetSottoscrizioniInstallatoreCountSubscriptionVariables> {
    document = GetSottoscrizioniInstallatoreCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioniInstallatoreDocument = gql`
    subscription GetSottoscrizioniInstallatore($args: search_sottoscrizioni_args!, $limit: Int, $offset: Int, $order_by: [sottoscrizione_order_by!]) {
  search_sottoscrizioni(
    args: $args
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    id
    stato
    tipologia_richiesta
    updated_at
    cer_cabina {
      stato
      codice_richiesta
      codice_gse
      cabina {
        cod_ac
      }
      cer {
        alias
        stato_cer
        abilita_richieste
        logo {
          id
        }
        cer_padre {
          alias
          logo {
            id
          }
        }
      }
    }
    asset_consumo {
      pod
      intestatario {
        nome
        cognome
        ragione_sociale
      }
      asset {
        associato
        opzionato
        potenza_effettiva
        caratteristiche {
          caratteristica {
            icon
          }
        }
        alias
        indirizzo {
          geom_
        }
        tipologia_asset {
          icon
          tipologia_asset_padre {
            icon
          }
        }
        gestori(order_by: {created_at: asc}, limit: 1) {
          utente {
            first_name
            last_name
            username
          }
        }
        condivisioni(order_by: {created_at: desc}, limit: 1) {
          id
          nome
          email
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioniInstallatoreGQL extends Apollo.Subscription<GetSottoscrizioniInstallatoreSubscription, GetSottoscrizioniInstallatoreSubscriptionVariables> {
    document = GetSottoscrizioniInstallatoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetsDocument = gql`
    subscription GetAssets($args: search_asset_args!, $limit: Int, $offset: Int, $order_by: [asset_order_by!] = [{created_at: desc}]) {
  search_asset(args: $args, order_by: $order_by, limit: $limit, offset: $offset) {
    id
    notifiche
    has_sottoscrizioni_attive
    condivisioneProsumer: condivisioni(
      where: {tipo_profilo: {_eq: prosumer}}
      order_by: {updated_at: desc}
      limit: 1
    ) {
      id
      stato
      nome
      email
    }
    tipologia_asset {
      id
      icon
      label
      tipologia_asset_padre {
        icon
        label
      }
    }
    alias
    indirizzo {
      completo
      citta {
        denominazione
      }
    }
    autoconsumo
    consumi(order_by: {created_at: desc}, limit: 1) {
      sottoscrizioniAttive: sottoscrizioni(order_by: {updated_at: desc}, limit: 1) {
        id
        stato
        confirmo_id
        cer_cabina {
          cer {
            id
            alias
            logo {
              id
            }
            cer_padre {
              alias
              logo {
                id
              }
            }
          }
        }
      }
    }
    produzioni(order_by: {created_at: desc}, limit: 1) {
      sottoscrizioniAttive: sottoscrizioni(order_by: {updated_at: desc}, limit: 1) {
        id
        stato
        confirmo_id
        cer_cabina {
          cer {
            id
            alias
            logo {
              id
            }
            cer_padre {
              alias
              logo {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsGQL extends Apollo.Subscription<GetAssetsSubscription, GetAssetsSubscriptionVariables> {
    document = GetAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetsCountDocument = gql`
    subscription GetAssetsCount($args: search_asset_args!) {
  search_asset_aggregate(args: $args) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsCountGQL extends Apollo.Subscription<GetAssetsCountSubscription, GetAssetsCountSubscriptionVariables> {
    document = GetAssetsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetDocument = gql`
    subscription GetAsset($id: uuid!) {
  asset_by_pk(id: $id) {
    id
    alias
    consumo
    autoconsumo
    cabina {
      id
    }
    condivisioneInstallatore: condivisioni(
      where: {tipo_profilo: {_eq: installatore}}
      order_by: {updated_at: desc}
    ) {
      id
      stato
      nome
      email
    }
    potenza_effettiva
    potenza_batteria
    dimensione_id
    data_installazione_impianto
    associato
    sottoscrizione_id
    opzionato
    impianto
    realizzando_impianto
    potenza_impianto_prevista
    capacita_batteria_prevista
    data_allaccio_prevista
    spazio_disponibile
    spazi_disponibili {
      id
      dimensione
      tipo_area {
        id
        label
      }
    }
    lunedi_id
    martedi_id
    mercoledi_id
    giovedi_id
    venerdi_id
    sabato_id
    domenica_id
    visibilita_nome
    posizione_esatta
    scambio_su_posto
    incentivi_impianto
    tipologia_asset {
      id
      label
      icon
      tipologia_asset_padre {
        id
        label
        icon
      }
    }
    indirizzo {
      id
      completo
      manuale
      toponimo
      civico
      cap
      citta {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      geom_
      geom
    }
    caratteristiche {
      caratteristica {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetGQL extends Apollo.Subscription<GetAssetSubscription, GetAssetSubscriptionVariables> {
    document = GetAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddAssetDocument = gql`
    mutation AddAsset($objects: [asset_gestore_insert_input!]!) {
  insert_asset_gestore(objects: $objects) {
    returning {
      asset_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAssetGQL extends Apollo.Mutation<AddAssetMutation, AddAssetMutationVariables> {
    document = AddAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateAssetsDocument = gql`
    mutation InsertOrUpdateAssets($objects: [asset_insert_input!] = {}, $on_conflict: asset_on_conflict = {constraint: asset_pkey}) {
  insert_asset(objects: $objects, on_conflict: $on_conflict) {
    returning {
      id
      alias
      consumo
      autoconsumo
      cabina {
        id
        cod_ac
      }
      condivisioneInstallatore: condivisioni(
        where: {tipo_profilo: {_eq: installatore}}
        order_by: {updated_at: desc}
      ) {
        id
        stato
        nome
        email
        auth {
          profiloInstallatore: profili(
            where: {tipologia: {_eq: installatore}}
            order_by: {updated_at: desc}
            limit: 1
          ) {
            persona {
              nome
              ragione_sociale
              contatti {
                contatto {
                  value
                  tipo_contatto {
                    id
                    label
                  }
                }
              }
            }
          }
        }
      }
      condivisioneProsumer: condivisioni(
        where: {tipo_profilo: {_eq: prosumer}}
        order_by: {updated_at: desc}
        limit: 1
      ) {
        id
        stato
        nome
        email
      }
      condivisioneRecente: condivisioni(
        where: {tipo_profilo: {_neq: installatore}}
        order_by: {created_at: desc}
        limit: 1
      ) {
        id
        nome
        email
      }
      gestori {
        utente {
          id
          first_name
          last_name
          username
          email
        }
      }
      tipologia_abitativa {
        id
        label
      }
      potenza_effettiva
      potenza_batteria
      dimensione_id
      data_installazione_impianto
      associato
      sottoscrizione_id
      opzionato
      impianto
      realizzando_impianto
      aiuto
      potenza_impianto_prevista
      capacita_batteria_prevista
      data_allaccio_prevista
      notifiche
      spazio_disponibile
      spazi_disponibili {
        id
        dimensione
        tipo_area {
          id
          label
        }
      }
      lunedi_id
      martedi_id
      mercoledi_id
      giovedi_id
      venerdi_id
      sabato_id
      domenica_id
      visibilita_nome
      posizione_esatta
      scambio_su_posto
      incentivi_impianto
      tipologia_abitativa {
        label
      }
      dimensione {
        label
      }
      tipologia_asset {
        id
        label
        icon
        percentuale_autoconsumo
        tipologia_prosumer
        tipologia_asset_padre {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
        }
      }
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      caratteristiche {
        caratteristica {
          id
          label
          icon
        }
      }
      consumi {
        id
        pod
        tipo_pod_id
        foglio
        particella
        subalterno
        sezione_catastale
        accumulo_standalone
        intestatario {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        dati_consumo(order_by: {data_inizio: asc}) {
          id
          f1
          f2
          f3
          data_inizio
          data_fine
        }
      }
      produzioni {
        id
        pod
        potenza_effettiva
        energia_immessa
        intestatario {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        richiesta_pnrr
        cod_richiesta_terna
        cod_censimp
        tipologia_impianto_id
        richiesta_modello_unico
        presenza_accumulo
        potenza_batteria
        sezione_catastale
        foglio
        particella
        subalterno
        ubicazione_impianto_aderente
        data_installazione_impianto
        configurazione_accumulo_id
        aderenza_delibera_autoconsumo
        data_adesione_autoconsumo
        prelievi_non_ausiliari
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        codice_fatturato_pnrr
        delibera_gse_pnrr {
          id
          name
        }
        documenti_pnrr {
          id
          tipologia_documento
          file {
            id
            name
          }
        }
        motivanzione_no_pnrr
        esito_pnrr
        unita {
          id
          cod_up
          data_attivazione
          data_disattivazione
          sezioni {
            id
            codice_sezione
            data_decorrenza_autoconsumo
            incompatibilita_incentivi_id
            incompatibilita_incentivi_altro
            tipologia_sito_impianto_id
            dispositivo_inseguimento_solare
            pannelli_bifacciali
            esposizione_prevalente_id
            inclinazione_prevalente
            incentivi {
              id
              rispetto_principio_dns
              usufruito_incentivi_rilancio
              quota_potenza_rinnovabili_obbligo
              contributi_id
              quota_incentivo
            }
            titoli_autorizzativi {
              id
              tipo_titolo_id
              ente
              protocollo
              data
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateAssetsGQL extends Apollo.Mutation<InsertOrUpdateAssetsMutation, InsertOrUpdateAssetsMutationVariables> {
    document = InsertOrUpdateAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAssetDocument = gql`
    mutation DeleteAsset($where: asset_bool_exp = {}) {
  delete_asset(where: $where) {
    affected_rows
    returning {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAssetGQL extends Apollo.Mutation<DeleteAssetMutation, DeleteAssetMutationVariables> {
    document = DeleteAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClearAssetNotificationDocument = gql`
    mutation ClearAssetNotification($id: uuid!) {
  update_asset(where: {id: {_eq: $id}}, _set: {notifiche: 0}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClearAssetNotificationGQL extends Apollo.Mutation<ClearAssetNotificationMutation, ClearAssetNotificationMutationVariables> {
    document = ClearAssetNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioniProsumerDocument = gql`
    subscription GetSottoscrizioniProsumer($where: sottoscrizione_bool_exp!) {
  sottoscrizione(where: $where, order_by: {updated_at: desc}) {
    id
    cer_cabina {
      cer {
        id
        logo {
          id
        }
        cer_padre {
          logo {
            id
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioniProsumerGQL extends Apollo.Subscription<GetSottoscrizioniProsumerSubscription, GetSottoscrizioniProsumerSubscriptionVariables> {
    document = GetSottoscrizioniProsumerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCerDisponibiliProsumerDocument = gql`
    subscription GetCerDisponibiliProsumer($where: cer_bool_exp = {}, $where_cer_cabina: cer_cabina_bool_exp = {}, $where_sottoscrizioni: sottoscrizione_bool_exp = {}) {
  cer(where: $where, order_by: [{abilita_richieste: desc}, {created_at: desc}]) {
    id
    abilita_richieste
    logo {
      id
    }
    alias
    partecipanti
    richieste
    consumatori_dichiarati
    produttori_dichiarati
    cer_padre {
      alias
      stato_cer
      logo {
        id
      }
    }
    cer_cabina(where: $where_cer_cabina) {
      id
      sottoscrizioni(where: $where_sottoscrizioni) {
        id
        stato
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCerDisponibiliProsumerGQL extends Apollo.Subscription<GetCerDisponibiliProsumerSubscription, GetCerDisponibiliProsumerSubscriptionVariables> {
    document = GetCerDisponibiliProsumerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioneProsumerDocument = gql`
    subscription GetSottoscrizioneProsumer($id: uuid!) {
  sottoscrizione_by_pk(id: $id) {
    id
    stato
    categoria_adesione
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    data_associazione
    data_opzione
    data_scadenza
    data_recesso
    iban_accredito_incentivi
    intestatario_conto_corrente
    iniziative(order_by: {data_inizio: desc}) {
      id
      data_inizio
      data_fine
      destinazione_contributo_id
      cer_destinazione_contributo {
        id
        descrizione
      }
    }
    codice_univico_promotore
    link_fascicolo
    cer_cabina {
      id
      codice_gse
      cabina {
        id
        cod_ac
      }
      cer {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        richiesta_iniziativa_sociale
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        cer_padre {
          id
          alias
          domande_richieste
          documenti_richiesti
          costi
          modulo_richiesta
          email_template
          richiesta_iban
          richiesta_iniziativa_sociale
          categorie_adesione(order_by: {categoria: asc}) {
            categoria
            tipologia
            tipologia_richiesta
            chiesto
            id
            regole
          }
          descrizione
          stato_cer
          partecipanti
          consumatori_dichiarati
          impianti
          produttori_dichiarati
          potenza
          potenza_dichiarata
          domande_richieste
          data_costituzione
          referral
          pubblicata
          mostra
          abilita_richieste
          attive
          iniziative
          richieste
          notifiche
          geom {
            id
            cabina_ids
          }
          richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
            stato
            updated_at
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          white_label
          whitelabel {
            id
            configurazione {
              id
              terms {
                id
                name
              }
              logo_chiaro {
                id
                name
              }
              logo_scuro {
                id
                name
              }
            }
          }
          logo {
            id
            name
          }
          volantino {
            id
            name
          }
          regolamento {
            id
            name
          }
          statuto {
            id
            name
          }
          promotore {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          societa {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
        }
      }
    }
    cer_categoria_adesione {
      id
      categoria
    }
    cer_categoria_adesione_produttore {
      id
      categoria
    }
    confirmo_id
    domande {
      tipologia_domanda
      risposta
    }
    feedback {
      label
    }
    contratto {
      id
      name
    }
    feedback_altro
    documenti {
      id
      tipologia_documento
      file {
        id
        name
      }
    }
    segnalatore {
      user_entity {
        first_name
        last_name
      }
    }
    asset_consumo {
      id
      pod
      tipo_pod_id
      foglio
      particella
      subalterno
      sezione_catastale
      accumulo_standalone
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      dati_consumo(order_by: {data_inizio: asc}) {
        id
        f1
        f2
        f3
        data_inizio
        data_fine
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
    asset_produzione {
      id
      pod
      potenza_effettiva
      energia_immessa
      referente_gse_nome
      referente_gse_email
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      richiesta_pnrr
      cod_richiesta_terna
      cod_censimp
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      potenza_batteria
      sezione_catastale
      foglio
      particella
      subalterno
      ubicazione_impianto_aderente
      data_installazione_impianto
      configurazione_accumulo_id
      aderenza_delibera_autoconsumo
      data_adesione_autoconsumo
      prelievi_non_ausiliari
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      codice_fatturato_pnrr
      delibera_gse_pnrr {
        id
        name
      }
      documenti_pnrr {
        id
        tipologia_documento
        file {
          id
          name
        }
      }
      motivanzione_no_pnrr
      esito_pnrr
      unita {
        id
        cod_up
        data_attivazione
        data_disattivazione
        sezioni {
          id
          codice_sezione
          data_decorrenza_autoconsumo
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            id
            rispetto_principio_dns
            usufruito_incentivi_rilancio
            quota_potenza_rinnovabili_obbligo
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            id
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioneProsumerGQL extends Apollo.Subscription<GetSottoscrizioneProsumerSubscription, GetSottoscrizioneProsumerSubscriptionVariables> {
    document = GetSottoscrizioneProsumerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigurazioneDocument = gql`
    query GetConfigurazione($id: uuid!, $cabina_id: Int_comparison_exp = {}) {
  cer_by_pk(id: $id) {
    id
    alias
    domande_richieste
    documenti_richiesti
    costi
    modulo_richiesta
    email_template
    richiesta_iban
    richiesta_iniziativa_sociale
    categorie_adesione(order_by: {categoria: asc}) {
      categoria
      tipologia
      tipologia_richiesta
      chiesto
      id
      regole
    }
    descrizione
    stato_cer
    partecipanti
    consumatori_dichiarati
    impianti
    produttori_dichiarati
    potenza
    potenza_dichiarata
    domande_richieste
    data_costituzione
    referral
    pubblicata
    mostra
    abilita_richieste
    attive
    iniziative
    richieste
    notifiche
    geom {
      id
      cabina_ids
    }
    richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
      stato
      updated_at
    }
    contatti {
      id
      contatto {
        id
        tipo_contatto_id
        value
        tipo_contatto {
          id
          label
          icon
          validation
        }
      }
    }
    white_label
    whitelabel {
      id
      configurazione {
        id
        terms {
          id
          name
        }
        logo_chiaro {
          id
          name
        }
        logo_scuro {
          id
          name
        }
      }
    }
    logo {
      id
      name
    }
    volantino {
      id
      name
    }
    regolamento {
      id
      name
    }
    statuto {
      id
      name
    }
    promotore {
      id
      nome
      cognome
      ragione_sociale
      codice_fiscale
      sesso
      data_nascita
      forma_giuridica_cer_id
      tipo_promotore_id
      tipologia_rappresentante_id
      citta_nascita {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      nazione_nascita {
        id
        denominazione
      }
      partita_iva
      codice_ateco_id
      codice_ateco {
        id
        label
      }
      forma_giuridica {
        id
        label
        rules
      }
      tipologia_rappresentante {
        id
        label
      }
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      rappresentante_legale {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
      }
    }
    societa {
      id
      nome
      cognome
      ragione_sociale
      codice_fiscale
      sesso
      data_nascita
      forma_giuridica_cer_id
      tipo_promotore_id
      tipologia_rappresentante_id
      citta_nascita {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      nazione_nascita {
        id
        denominazione
      }
      partita_iva
      codice_ateco_id
      codice_ateco {
        id
        label
      }
      forma_giuridica {
        id
        label
        rules
      }
      tipologia_rappresentante {
        id
        label
      }
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      rappresentante_legale {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
      }
    }
    cer_padre {
      id
      alias
      domande_richieste
      documenti_richiesti
      costi
      modulo_richiesta
      email_template
      richiesta_iban
      richiesta_iniziativa_sociale
      categorie_adesione(order_by: {categoria: asc}) {
        categoria
        tipologia
        tipologia_richiesta
        chiesto
        id
        regole
      }
      descrizione
      stato_cer
      partecipanti
      consumatori_dichiarati
      impianti
      produttori_dichiarati
      potenza
      potenza_dichiarata
      domande_richieste
      data_costituzione
      referral
      pubblicata
      mostra
      abilita_richieste
      attive
      iniziative
      richieste
      notifiche
      geom {
        id
        cabina_ids
      }
      richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
        stato
        updated_at
      }
      contatti {
        id
        contatto {
          id
          tipo_contatto_id
          value
          tipo_contatto {
            id
            label
            icon
            validation
          }
        }
      }
      white_label
      whitelabel {
        id
        configurazione {
          id
          terms {
            id
            name
          }
          logo_chiaro {
            id
            name
          }
          logo_scuro {
            id
            name
          }
        }
      }
      logo {
        id
        name
      }
      volantino {
        id
        name
      }
      regolamento {
        id
        name
      }
      statuto {
        id
        name
      }
      promotore {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      societa {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
    }
    cer_cabina(where: {cabina_id: $cabina_id}) {
      id
      codice_gse
      cabina {
        id
        cod_ac
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigurazioneGQL extends Apollo.Query<GetConfigurazioneQuery, GetConfigurazioneQueryVariables> {
    document = GetConfigurazioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CambiaStatoProsumerDocument = gql`
    mutation CambiaStatoProsumer($args: cambia_stato_prosumer_args = {}) {
  cambia_stato_prosumer(args: $args) {
    stato
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CambiaStatoProsumerGQL extends Apollo.Mutation<CambiaStatoProsumerMutation, CambiaStatoProsumerMutationVariables> {
    document = CambiaStatoProsumerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertSottoscrizioneDocument = gql`
    mutation InsertSottoscrizione($object: sottoscrizione_insert_input!) {
  insert_sottoscrizione_one(object: $object) {
    id
    stato
    categoria_adesione
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    data_associazione
    data_opzione
    data_scadenza
    data_recesso
    iban_accredito_incentivi
    intestatario_conto_corrente
    iniziative(order_by: {data_inizio: desc}) {
      id
      data_inizio
      data_fine
      destinazione_contributo_id
      cer_destinazione_contributo {
        id
        descrizione
      }
    }
    codice_univico_promotore
    link_fascicolo
    cer_cabina {
      id
      codice_gse
      cabina {
        id
        cod_ac
      }
      cer {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        richiesta_iniziativa_sociale
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        cer_padre {
          id
          alias
          domande_richieste
          documenti_richiesti
          costi
          modulo_richiesta
          email_template
          richiesta_iban
          richiesta_iniziativa_sociale
          categorie_adesione(order_by: {categoria: asc}) {
            categoria
            tipologia
            tipologia_richiesta
            chiesto
            id
            regole
          }
          descrizione
          stato_cer
          partecipanti
          consumatori_dichiarati
          impianti
          produttori_dichiarati
          potenza
          potenza_dichiarata
          domande_richieste
          data_costituzione
          referral
          pubblicata
          mostra
          abilita_richieste
          attive
          iniziative
          richieste
          notifiche
          geom {
            id
            cabina_ids
          }
          richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
            stato
            updated_at
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          white_label
          whitelabel {
            id
            configurazione {
              id
              terms {
                id
                name
              }
              logo_chiaro {
                id
                name
              }
              logo_scuro {
                id
                name
              }
            }
          }
          logo {
            id
            name
          }
          volantino {
            id
            name
          }
          regolamento {
            id
            name
          }
          statuto {
            id
            name
          }
          promotore {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          societa {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
        }
      }
    }
    cer_categoria_adesione {
      id
      categoria
    }
    cer_categoria_adesione_produttore {
      id
      categoria
    }
    confirmo_id
    domande {
      tipologia_domanda
      risposta
    }
    feedback {
      label
    }
    contratto {
      id
      name
    }
    feedback_altro
    documenti {
      id
      tipologia_documento
      file {
        id
        name
      }
    }
    segnalatore {
      user_entity {
        first_name
        last_name
      }
    }
    asset_consumo {
      id
      pod
      tipo_pod_id
      foglio
      particella
      subalterno
      sezione_catastale
      accumulo_standalone
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      dati_consumo(order_by: {data_inizio: asc}) {
        id
        f1
        f2
        f3
        data_inizio
        data_fine
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
    asset_produzione {
      id
      pod
      potenza_effettiva
      energia_immessa
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      richiesta_pnrr
      cod_richiesta_terna
      cod_censimp
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      potenza_batteria
      sezione_catastale
      foglio
      particella
      subalterno
      ubicazione_impianto_aderente
      data_installazione_impianto
      configurazione_accumulo_id
      aderenza_delibera_autoconsumo
      data_adesione_autoconsumo
      prelievi_non_ausiliari
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      codice_fatturato_pnrr
      delibera_gse_pnrr {
        id
        name
      }
      documenti_pnrr {
        id
        tipologia_documento
        file {
          id
          name
        }
      }
      motivanzione_no_pnrr
      esito_pnrr
      unita {
        id
        cod_up
        data_attivazione
        data_disattivazione
        sezioni {
          id
          codice_sezione
          data_decorrenza_autoconsumo
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            id
            rispetto_principio_dns
            usufruito_incentivi_rilancio
            quota_potenza_rinnovabili_obbligo
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            id
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertSottoscrizioneGQL extends Apollo.Mutation<InsertSottoscrizioneMutation, InsertSottoscrizioneMutationVariables> {
    document = InsertSottoscrizioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrUpdateSottoscrizioneDocument = gql`
    mutation InsertOrUpdateSottoscrizione($on_conflict: sottoscrizione_on_conflict!, $objects: [sottoscrizione_insert_input!]!) {
  insert_sottoscrizione(objects: $objects, on_conflict: $on_conflict) {
    returning {
      id
      stato
      categoria_adesione
      tipologia_richiesta
      data_ammissione
      created_at
      updated_at
      data_associazione
      data_opzione
      data_scadenza
      data_recesso
      iban_accredito_incentivi
      intestatario_conto_corrente
      iniziative(order_by: {data_inizio: desc}) {
        id
        data_inizio
        data_fine
        destinazione_contributo_id
        cer_destinazione_contributo {
          id
          descrizione
        }
      }
      codice_univico_promotore
      link_fascicolo
      cer_cabina {
        id
        codice_gse
        cabina {
          id
          cod_ac
        }
        cer {
          id
          alias
          domande_richieste
          documenti_richiesti
          costi
          modulo_richiesta
          email_template
          richiesta_iban
          richiesta_iniziativa_sociale
          categorie_adesione(order_by: {categoria: asc}) {
            categoria
            tipologia
            tipologia_richiesta
            chiesto
            id
            regole
          }
          descrizione
          stato_cer
          partecipanti
          consumatori_dichiarati
          impianti
          produttori_dichiarati
          potenza
          potenza_dichiarata
          domande_richieste
          data_costituzione
          referral
          pubblicata
          mostra
          abilita_richieste
          attive
          iniziative
          richieste
          notifiche
          geom {
            id
            cabina_ids
          }
          richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
            stato
            updated_at
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          white_label
          whitelabel {
            id
            configurazione {
              id
              terms {
                id
                name
              }
              logo_chiaro {
                id
                name
              }
              logo_scuro {
                id
                name
              }
            }
          }
          logo {
            id
            name
          }
          volantino {
            id
            name
          }
          regolamento {
            id
            name
          }
          statuto {
            id
            name
          }
          promotore {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          societa {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          cer_padre {
            id
            alias
            domande_richieste
            documenti_richiesti
            costi
            modulo_richiesta
            email_template
            richiesta_iban
            richiesta_iniziativa_sociale
            categorie_adesione(order_by: {categoria: asc}) {
              categoria
              tipologia
              tipologia_richiesta
              chiesto
              id
              regole
            }
            descrizione
            stato_cer
            partecipanti
            consumatori_dichiarati
            impianti
            produttori_dichiarati
            potenza
            potenza_dichiarata
            domande_richieste
            data_costituzione
            referral
            pubblicata
            mostra
            abilita_richieste
            attive
            iniziative
            richieste
            notifiche
            geom {
              id
              cabina_ids
            }
            richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
              stato
              updated_at
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            white_label
            whitelabel {
              id
              configurazione {
                id
                terms {
                  id
                  name
                }
                logo_chiaro {
                  id
                  name
                }
                logo_scuro {
                  id
                  name
                }
              }
            }
            logo {
              id
              name
            }
            volantino {
              id
              name
            }
            regolamento {
              id
              name
            }
            statuto {
              id
              name
            }
            promotore {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
              rappresentante_legale {
                id
                nome
                cognome
                ragione_sociale
                codice_fiscale
                sesso
                data_nascita
                forma_giuridica_cer_id
                tipo_promotore_id
                tipologia_rappresentante_id
                citta_nascita {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                nazione_nascita {
                  id
                  denominazione
                }
                partita_iva
                codice_ateco_id
                codice_ateco {
                  id
                  label
                }
                forma_giuridica {
                  id
                  label
                  rules
                }
                tipologia_rappresentante {
                  id
                  label
                }
                indirizzo {
                  id
                  completo
                  manuale
                  toponimo
                  civico
                  cap
                  citta {
                    id
                    denominazione
                    provincia {
                      id
                      denominazione
                      sigla
                    }
                  }
                  geom_
                  geom
                }
                contatti {
                  id
                  contatto {
                    id
                    tipo_contatto_id
                    value
                    tipo_contatto {
                      id
                      label
                      icon
                      validation
                    }
                  }
                }
              }
            }
            societa {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
              rappresentante_legale {
                id
                nome
                cognome
                ragione_sociale
                codice_fiscale
                sesso
                data_nascita
                forma_giuridica_cer_id
                tipo_promotore_id
                tipologia_rappresentante_id
                citta_nascita {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                nazione_nascita {
                  id
                  denominazione
                }
                partita_iva
                codice_ateco_id
                codice_ateco {
                  id
                  label
                }
                forma_giuridica {
                  id
                  label
                  rules
                }
                tipologia_rappresentante {
                  id
                  label
                }
                indirizzo {
                  id
                  completo
                  manuale
                  toponimo
                  civico
                  cap
                  citta {
                    id
                    denominazione
                    provincia {
                      id
                      denominazione
                      sigla
                    }
                  }
                  geom_
                  geom
                }
                contatti {
                  id
                  contatto {
                    id
                    tipo_contatto_id
                    value
                    tipo_contatto {
                      id
                      label
                      icon
                      validation
                    }
                  }
                }
              }
            }
          }
        }
      }
      cer_categoria_adesione {
        id
        categoria
      }
      cer_categoria_adesione_produttore {
        id
        categoria
      }
      confirmo_id
      domande {
        tipologia_domanda
        risposta
      }
      feedback {
        label
      }
      contratto {
        id
        name
      }
      feedback_altro
      documenti {
        id
        tipologia_documento
        file {
          id
          name
        }
      }
      segnalatore {
        user_entity {
          first_name
          last_name
        }
      }
      asset_consumo {
        id
        pod
        tipo_pod_id
        foglio
        particella
        subalterno
        sezione_catastale
        accumulo_standalone
        intestatario {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        dati_consumo(order_by: {data_inizio: asc}) {
          id
          f1
          f2
          f3
          data_inizio
          data_fine
        }
        asset {
          id
          alias
          consumo
          autoconsumo
          cabina {
            id
            cod_ac
          }
          condivisioneInstallatore: condivisioni(
            where: {tipo_profilo: {_eq: installatore}}
            order_by: {updated_at: desc}
          ) {
            id
            stato
            nome
            email
            auth {
              profiloInstallatore: profili(
                where: {tipologia: {_eq: installatore}}
                order_by: {updated_at: desc}
                limit: 1
              ) {
                persona {
                  nome
                  ragione_sociale
                  contatti {
                    contatto {
                      value
                      tipo_contatto {
                        id
                        label
                      }
                    }
                  }
                }
              }
            }
          }
          condivisioneProsumer: condivisioni(
            where: {tipo_profilo: {_eq: prosumer}}
            order_by: {updated_at: desc}
            limit: 1
          ) {
            id
            stato
            nome
            email
          }
          condivisioneRecente: condivisioni(
            where: {tipo_profilo: {_neq: installatore}}
            order_by: {created_at: desc}
            limit: 1
          ) {
            id
            nome
            email
          }
          gestori {
            utente {
              id
              first_name
              last_name
              username
              email
            }
          }
          tipologia_abitativa {
            id
            label
          }
          potenza_effettiva
          potenza_batteria
          dimensione_id
          data_installazione_impianto
          associato
          sottoscrizione_id
          opzionato
          impianto
          realizzando_impianto
          aiuto
          potenza_impianto_prevista
          capacita_batteria_prevista
          data_allaccio_prevista
          notifiche
          spazio_disponibile
          spazi_disponibili {
            id
            dimensione
            tipo_area {
              id
              label
            }
          }
          lunedi_id
          martedi_id
          mercoledi_id
          giovedi_id
          venerdi_id
          sabato_id
          domenica_id
          visibilita_nome
          posizione_esatta
          scambio_su_posto
          incentivi_impianto
          tipologia_abitativa {
            label
          }
          dimensione {
            label
          }
          tipologia_asset {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
            tipologia_asset_padre {
              id
              label
              icon
              percentuale_autoconsumo
              tipologia_prosumer
            }
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          caratteristiche {
            caratteristica {
              id
              label
              icon
            }
          }
        }
      }
      asset_produzione {
        id
        pod
        potenza_effettiva
        energia_immessa
        intestatario {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        richiesta_pnrr
        cod_richiesta_terna
        cod_censimp
        tipologia_impianto_id
        richiesta_modello_unico
        presenza_accumulo
        potenza_batteria
        sezione_catastale
        foglio
        particella
        subalterno
        ubicazione_impianto_aderente
        data_installazione_impianto
        configurazione_accumulo_id
        aderenza_delibera_autoconsumo
        data_adesione_autoconsumo
        prelievi_non_ausiliari
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        codice_fatturato_pnrr
        delibera_gse_pnrr {
          id
          name
        }
        documenti_pnrr {
          id
          tipologia_documento
          file {
            id
            name
          }
        }
        motivanzione_no_pnrr
        esito_pnrr
        unita {
          id
          cod_up
          data_attivazione
          data_disattivazione
          sezioni {
            id
            codice_sezione
            data_decorrenza_autoconsumo
            incompatibilita_incentivi_id
            incompatibilita_incentivi_altro
            tipologia_sito_impianto_id
            dispositivo_inseguimento_solare
            pannelli_bifacciali
            esposizione_prevalente_id
            inclinazione_prevalente
            incentivi {
              id
              rispetto_principio_dns
              usufruito_incentivi_rilancio
              quota_potenza_rinnovabili_obbligo
              contributi_id
              quota_incentivo
            }
            titoli_autorizzativi {
              id
              tipo_titolo_id
              ente
              protocollo
              data
            }
          }
        }
        asset {
          id
          alias
          consumo
          autoconsumo
          cabina {
            id
            cod_ac
          }
          condivisioneInstallatore: condivisioni(
            where: {tipo_profilo: {_eq: installatore}}
            order_by: {updated_at: desc}
          ) {
            id
            stato
            nome
            email
            auth {
              profiloInstallatore: profili(
                where: {tipologia: {_eq: installatore}}
                order_by: {updated_at: desc}
                limit: 1
              ) {
                persona {
                  nome
                  ragione_sociale
                  contatti {
                    contatto {
                      value
                      tipo_contatto {
                        id
                        label
                      }
                    }
                  }
                }
              }
            }
          }
          condivisioneProsumer: condivisioni(
            where: {tipo_profilo: {_eq: prosumer}}
            order_by: {updated_at: desc}
            limit: 1
          ) {
            id
            stato
            nome
            email
          }
          condivisioneRecente: condivisioni(
            where: {tipo_profilo: {_neq: installatore}}
            order_by: {created_at: desc}
            limit: 1
          ) {
            id
            nome
            email
          }
          gestori {
            utente {
              id
              first_name
              last_name
              username
              email
            }
          }
          tipologia_abitativa {
            id
            label
          }
          potenza_effettiva
          potenza_batteria
          dimensione_id
          data_installazione_impianto
          associato
          sottoscrizione_id
          opzionato
          impianto
          realizzando_impianto
          aiuto
          potenza_impianto_prevista
          capacita_batteria_prevista
          data_allaccio_prevista
          notifiche
          spazio_disponibile
          spazi_disponibili {
            id
            dimensione
            tipo_area {
              id
              label
            }
          }
          lunedi_id
          martedi_id
          mercoledi_id
          giovedi_id
          venerdi_id
          sabato_id
          domenica_id
          visibilita_nome
          posizione_esatta
          scambio_su_posto
          incentivi_impianto
          tipologia_abitativa {
            label
          }
          dimensione {
            label
          }
          tipologia_asset {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
            tipologia_asset_padre {
              id
              label
              icon
              percentuale_autoconsumo
              tipologia_prosumer
            }
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          caratteristiche {
            caratteristica {
              id
              label
              icon
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrUpdateSottoscrizioneGQL extends Apollo.Mutation<InsertOrUpdateSottoscrizioneMutation, InsertOrUpdateSottoscrizioneMutationVariables> {
    document = InsertOrUpdateSottoscrizioneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSottoscrizioneDocumentiDocument = gql`
    mutation DeleteSottoscrizioneDocumenti($where: sottoscrizione_documenti_bool_exp = {}) {
  delete_sottoscrizione_documenti(where: $where) {
    affected_rows
    returning {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSottoscrizioneDocumentiGQL extends Apollo.Mutation<DeleteSottoscrizioneDocumentiMutation, DeleteSottoscrizioneDocumentiMutationVariables> {
    document = DeleteSottoscrizioneDocumentiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePnrrDocumentiDocument = gql`
    mutation DeletePnrrDocumenti($where: pnrr_documenti_bool_exp = {}) {
  delete_pnrr_documenti(where: $where) {
    affected_rows
    returning {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePnrrDocumentiGQL extends Apollo.Mutation<DeletePnrrDocumentiMutation, DeletePnrrDocumentiMutationVariables> {
    document = DeletePnrrDocumentiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRipartizioniDocument = gql`
    subscription GetRipartizioni($cer_id: uuid!, $sottoscrizione_id: uuid!) {
  incentivi_calcolati(
    where: {sottoscrizione_id: {_eq: $sottoscrizione_id}, ripartizione: {cer_cabina: {cer_id: {_eq: $cer_id}}, stato_calcolo: {_eq: completato}}}
    order_by: {updated_at: desc}
  ) {
    misure
    aggregati
    ripartizione {
      data
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRipartizioniGQL extends Apollo.Subscription<GetRipartizioniSubscription, GetRipartizioniSubscriptionVariables> {
    document = GetRipartizioniDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRipartizioniTotaliDocument = gql`
    subscription GetRipartizioniTotali($sottoscrizione_ids: [uuid!]!) {
  incentivi_calcolati(
    where: {sottoscrizione_id: {_in: $sottoscrizione_ids}, ripartizione: {stato_calcolo: {_eq: completato}}}
  ) {
    sottoscrizione_id
    aggregati
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRipartizioniTotaliGQL extends Apollo.Subscription<GetRipartizioniTotaliSubscription, GetRipartizioniTotaliSubscriptionVariables> {
    document = GetRipartizioniTotaliDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CondividiAssetDocument = gql`
    mutation CondividiAsset($object: condivisione_condivisione_insert_input!) {
  insert_condivisione_condivisione_one(object: $object) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CondividiAssetGQL extends Apollo.Mutation<CondividiAssetMutation, CondividiAssetMutationVariables> {
    document = CondividiAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancellaCondivisioneAssetDocument = gql`
    mutation CancellaCondivisioneAsset($id: uuid!) {
  update_condivisione_condivisione_by_pk(
    pk_columns: {id: $id}
    _set: {stato: cancellata}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancellaCondivisioneAssetGQL extends Apollo.Mutation<CancellaCondivisioneAssetMutation, CancellaCondivisioneAssetMutationVariables> {
    document = CancellaCondivisioneAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetForSuperadminDocument = gql`
    subscription GetAssetForSuperadmin($id: uuid!) {
  asset_by_pk(id: $id) {
    id
    alias
    consumo
    autoconsumo
    visibilita_nome
    posizione_esatta
    associato
    impianto
    realizzando_impianto
    potenza_effettiva
    potenza_batteria
    dimensione_id
    potenza_impianto_prevista
    capacita_batteria_prevista
    data_installazione_impianto
    data_allaccio_prevista
    spazio_disponibile
    incentivi_impianto
    lunedi_id
    martedi_id
    mercoledi_id
    giovedi_id
    venerdi_id
    sabato_id
    domenica_id
    tipologia_asset {
      id
      label
      icon
      percentuale_autoconsumo
      tipologia_prosumer
      tipologia_asset_padre {
        id
        label
        icon
        percentuale_autoconsumo
        tipologia_prosumer
      }
    }
    indirizzo {
      id
      completo
      manuale
      toponimo
      civico
      cap
      citta {
        id
        denominazione
        provincia {
          id
          denominazione
          sigla
        }
      }
      geom_
      geom
    }
    spazi_disponibili {
      id
      dimensione
      tipo_area {
        id
        label
      }
    }
    caratteristiche {
      caratteristica {
        id
        label
        icon
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetForSuperadminGQL extends Apollo.Subscription<GetAssetForSuperadminSubscription, GetAssetForSuperadminSubscriptionVariables> {
    document = GetAssetForSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetListaUtentiSuperadminDocument = gql`
    query GetListaUtentiSuperadmin($args: search_user_entity_args!, $limit: Int, $offset: Int, $where: auth_user_entity_bool_exp, $order_by: [auth_user_entity_order_by!]) {
  search_user_entity(
    args: $args
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    id
    email
    first_name
    last_name
    user_attributes {
      white_label {
        referral
      }
    }
    profili {
      tipologia
    }
    profilo_prosumer: profili(where: {tipologia: {_eq: prosumer}}) {
      codice_amico
    }
    codice_operatore {
      codice
    }
    assets_aggregate {
      aggregate {
        count
      }
    }
    consenso_privacy {
      newsletter
      sondaggi_statistici
      comunicazioni_commerciali
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetListaUtentiSuperadminGQL extends Apollo.Query<GetListaUtentiSuperadminQuery, GetListaUtentiSuperadminQueryVariables> {
    document = GetListaUtentiSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetListaUtentiSuperadminCountDocument = gql`
    query GetListaUtentiSuperadminCount($args: search_user_entity_args!, $where: auth_user_entity_bool_exp) {
  search_user_entity_aggregate(args: $args, where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetListaUtentiSuperadminCountGQL extends Apollo.Query<GetListaUtentiSuperadminCountQuery, GetListaUtentiSuperadminCountQueryVariables> {
    document = GetListaUtentiSuperadminCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetListaCerSuperadminDocument = gql`
    query GetListaCerSuperadmin($limit: Int, $offset: Int, $where: cer_bool_exp, $order_by: [cer_order_by!]) {
  cer(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    id
    alias
    mostra
    abilita_richieste
    richieste_pubblicazione {
      stato
    }
    gestori_aggregate {
      aggregate {
        count
      }
    }
    gestori {
      id
      gestore {
        first_name
        last_name
        email
        id
      }
    }
    cer_padre {
      id
      alias
      mostra
      whitelabel {
        configurazione {
          referral
        }
      }
      richieste_pubblicazione {
        stato
      }
      gestori_aggregate {
        aggregate {
          count
        }
      }
      gestori {
        id
        gestore {
          first_name
          last_name
          email
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetListaCerSuperadminGQL extends Apollo.Query<GetListaCerSuperadminQuery, GetListaCerSuperadminQueryVariables> {
    document = GetListaCerSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCerGestoreManyDocument = gql`
    mutation DeleteCerGestoreMany($ids: [uuid!]!) {
  delete_cer_gestore(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCerGestoreManyGQL extends Apollo.Mutation<DeleteCerGestoreManyMutation, DeleteCerGestoreManyMutationVariables> {
    document = DeleteCerGestoreManyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccettaPubblicazioneSuperadminDocument = gql`
    mutation AccettaPubblicazioneSuperadmin($cer_id: uuid!) {
  update_admin_richiesta_pubblicazione(
    where: {cer_id: {_eq: $cer_id}}
    _set: {stato: accettata}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccettaPubblicazioneSuperadminGQL extends Apollo.Mutation<AccettaPubblicazioneSuperadminMutation, AccettaPubblicazioneSuperadminMutationVariables> {
    document = AccettaPubblicazioneSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCerFieldDocument = gql`
    mutation UpdateCerField($id: uuid!, $set: cer_set_input!) {
  update_cer_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
    mostra
    abilita_richieste
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCerFieldGQL extends Apollo.Mutation<UpdateCerFieldMutation, UpdateCerFieldMutationVariables> {
    document = UpdateCerFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUtentiForGestoriDocument = gql`
    query GetUtentiForGestori {
  auth_user_entity(order_by: {email: asc}) {
    id
    email
    first_name
    last_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUtentiForGestoriGQL extends Apollo.Query<GetUtentiForGestoriQuery, GetUtentiForGestoriQueryVariables> {
    document = GetUtentiForGestoriDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCerGestoriDocument = gql`
    mutation InsertCerGestori($objects: [cer_gestore_insert_input!]!) {
  insert_cer_gestore(objects: $objects) {
    returning {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertCerGestoriGQL extends Apollo.Mutation<InsertCerGestoriMutation, InsertCerGestoriMutationVariables> {
    document = InsertCerGestoriDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetListaCerSuperadminCountDocument = gql`
    query GetListaCerSuperadminCount($where: cer_bool_exp) {
  cer_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetListaCerSuperadminCountGQL extends Apollo.Query<GetListaCerSuperadminCountQuery, GetListaCerSuperadminCountQueryVariables> {
    document = GetListaCerSuperadminCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWhiteLabelsListaUtentiSuperadminDocument = gql`
    query GetWhiteLabelsListaUtentiSuperadmin {
  white_label_configurazione(order_by: {referral: asc}) {
    referral
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWhiteLabelsListaUtentiSuperadminGQL extends Apollo.Query<GetWhiteLabelsListaUtentiSuperadminQuery, GetWhiteLabelsListaUtentiSuperadminQueryVariables> {
    document = GetWhiteLabelsListaUtentiSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetsForUtenteSuperadminDocument = gql`
    query GetAssetsForUtenteSuperadmin($user_id: String!, $limit: Int, $offset: Int, $order_by: [asset_gestore_order_by!]) {
  auth_user_entity_by_pk(id: $user_id) {
    assets(limit: $limit, offset: $offset, order_by: $order_by) {
      asset {
        id
        alias
        indirizzo {
          completo
        }
        consumo
        potenza_effettiva
        potenza_batteria
        tipologia_asset {
          id
          icon
          label
          tipologia_asset_padre {
            id
            icon
            label
          }
        }
      }
    }
  }
  asset_gestore_aggregate(where: {auth_id: {_eq: $user_id}}) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsForUtenteSuperadminGQL extends Apollo.Query<GetAssetsForUtenteSuperadminQuery, GetAssetsForUtenteSuperadminQueryVariables> {
    document = GetAssetsForUtenteSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioniSuperadminDocument = gql`
    query GetSottoscrizioniSuperadmin($limit: Int!, $offset: Int!, $where: v_superadmin_sottoscrizioni_bool_exp, $order_by: [v_superadmin_sottoscrizioni_order_by!]) {
  v_superadmin_sottoscrizioni(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    sottoscrizione_id
    created_at
    stato
    tipologia_richiesta
    pod
    asset_id
    intestatario_nome
    intestatario_cognome
    intestatario_ragione_sociale
    intestatario_codice_fiscale
    intestatario_partita_iva
    n_sottoscrizioni_stesso_pod
    n_asset_stesso_pod
    is_duplicato
    updated_at
    cer_alias
    cer_padre_alias
    cabina_cod_ac
    gestore_first_name
    gestore_last_name
    gestore_username
    condivisione_account_nome
    condivisione_account_email
    installatori
  }
  v_superadmin_sottoscrizioni_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioniSuperadminGQL extends Apollo.Query<GetSottoscrizioniSuperadminQuery, GetSottoscrizioniSuperadminQueryVariables> {
    document = GetSottoscrizioniSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EliminaSottoscrizioneSuperadminDocument = gql`
    mutation EliminaSottoscrizioneSuperadmin($id: uuid!) {
  superadmin_elimina_sottoscrizione(args: {p_sottoscrizione_id: $id}) {
    sottoscrizione_id
    modalita
    asset_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EliminaSottoscrizioneSuperadminGQL extends Apollo.Mutation<EliminaSottoscrizioneSuperadminMutation, EliminaSottoscrizioneSuperadminMutationVariables> {
    document = EliminaSottoscrizioneSuperadminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CambiaStatoTecnicoDocument = gql`
    mutation CambiaStatoTecnico($args: cambia_stato_tecnico_args = {}) {
  cambia_stato_tecnico(args: $args) {
    stato
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CambiaStatoTecnicoGQL extends Apollo.Mutation<CambiaStatoTecnicoMutation, CambiaStatoTecnicoMutationVariables> {
    document = CambiaStatoTecnicoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioneTecnicoDocument = gql`
    subscription GetSottoscrizioneTecnico($id: uuid!) {
  sottoscrizione_by_pk(id: $id) {
    id
    stato
    categoria_adesione
    tipologia_richiesta
    data_ammissione
    created_at
    updated_at
    data_associazione
    data_opzione
    data_scadenza
    data_recesso
    iban_accredito_incentivi
    intestatario_conto_corrente
    iniziative(order_by: {data_inizio: desc}) {
      id
      data_inizio
      data_fine
      destinazione_contributo_id
      cer_destinazione_contributo {
        id
        descrizione
      }
    }
    codice_univico_promotore
    link_fascicolo
    cer_cabina {
      id
      codice_gse
      cabina {
        id
        cod_ac
      }
      cer {
        id
        alias
        domande_richieste
        documenti_richiesti
        costi
        modulo_richiesta
        email_template
        richiesta_iban
        richiesta_iniziativa_sociale
        categorie_adesione(order_by: {categoria: asc}) {
          categoria
          tipologia
          tipologia_richiesta
          chiesto
          id
          regole
        }
        descrizione
        stato_cer
        partecipanti
        consumatori_dichiarati
        impianti
        produttori_dichiarati
        potenza
        potenza_dichiarata
        domande_richieste
        data_costituzione
        referral
        pubblicata
        mostra
        abilita_richieste
        attive
        iniziative
        richieste
        notifiche
        geom {
          id
          cabina_ids
        }
        richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
          stato
          updated_at
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        white_label
        whitelabel {
          id
          configurazione {
            id
            terms {
              id
              name
            }
            logo_chiaro {
              id
              name
            }
            logo_scuro {
              id
              name
            }
          }
        }
        logo {
          id
          name
        }
        volantino {
          id
          name
        }
        regolamento {
          id
          name
        }
        statuto {
          id
          name
        }
        promotore {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        societa {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          rappresentante_legale {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
          }
        }
        cer_padre {
          id
          alias
          domande_richieste
          documenti_richiesti
          costi
          modulo_richiesta
          email_template
          richiesta_iban
          richiesta_iniziativa_sociale
          categorie_adesione(order_by: {categoria: asc}) {
            categoria
            tipologia
            tipologia_richiesta
            chiesto
            id
            regole
          }
          descrizione
          stato_cer
          partecipanti
          consumatori_dichiarati
          impianti
          produttori_dichiarati
          potenza
          potenza_dichiarata
          domande_richieste
          data_costituzione
          referral
          pubblicata
          mostra
          abilita_richieste
          attive
          iniziative
          richieste
          notifiche
          geom {
            id
            cabina_ids
          }
          richieste_pubblicazione(order_by: {updated_at: desc}, limit: 1) {
            stato
            updated_at
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
          white_label
          whitelabel {
            id
            configurazione {
              id
              terms {
                id
                name
              }
              logo_chiaro {
                id
                name
              }
              logo_scuro {
                id
                name
              }
            }
          }
          logo {
            id
            name
          }
          volantino {
            id
            name
          }
          regolamento {
            id
            name
          }
          statuto {
            id
            name
          }
          promotore {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
          societa {
            id
            nome
            cognome
            ragione_sociale
            codice_fiscale
            sesso
            data_nascita
            forma_giuridica_cer_id
            tipo_promotore_id
            tipologia_rappresentante_id
            citta_nascita {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            nazione_nascita {
              id
              denominazione
            }
            partita_iva
            codice_ateco_id
            codice_ateco {
              id
              label
            }
            forma_giuridica {
              id
              label
              rules
            }
            tipologia_rappresentante {
              id
              label
            }
            indirizzo {
              id
              completo
              manuale
              toponimo
              civico
              cap
              citta {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              geom_
              geom
            }
            contatti {
              id
              contatto {
                id
                tipo_contatto_id
                value
                tipo_contatto {
                  id
                  label
                  icon
                  validation
                }
              }
            }
            rappresentante_legale {
              id
              nome
              cognome
              ragione_sociale
              codice_fiscale
              sesso
              data_nascita
              forma_giuridica_cer_id
              tipo_promotore_id
              tipologia_rappresentante_id
              citta_nascita {
                id
                denominazione
                provincia {
                  id
                  denominazione
                  sigla
                }
              }
              nazione_nascita {
                id
                denominazione
              }
              partita_iva
              codice_ateco_id
              codice_ateco {
                id
                label
              }
              forma_giuridica {
                id
                label
                rules
              }
              tipologia_rappresentante {
                id
                label
              }
              indirizzo {
                id
                completo
                manuale
                toponimo
                civico
                cap
                citta {
                  id
                  denominazione
                  provincia {
                    id
                    denominazione
                    sigla
                  }
                }
                geom_
                geom
              }
              contatti {
                id
                contatto {
                  id
                  tipo_contatto_id
                  value
                  tipo_contatto {
                    id
                    label
                    icon
                    validation
                  }
                }
              }
            }
          }
        }
      }
    }
    cer_categoria_adesione {
      id
      categoria
    }
    cer_categoria_adesione_produttore {
      id
      categoria
    }
    confirmo_id
    domande {
      tipologia_domanda
      risposta
    }
    feedback {
      label
    }
    contratto {
      id
      name
    }
    feedback_altro
    documenti {
      id
      tipologia_documento
      file {
        id
        name
      }
    }
    segnalatore {
      user_entity {
        first_name
        last_name
      }
    }
    asset_consumo {
      id
      pod
      tipo_pod_id
      foglio
      particella
      subalterno
      sezione_catastale
      accumulo_standalone
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      dati_consumo(order_by: {data_inizio: asc}) {
        id
        f1
        f2
        f3
        data_inizio
        data_fine
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
    asset_produzione {
      id
      pod
      potenza_effettiva
      energia_immessa
      referente_gse_nome
      referente_gse_email
      intestatario {
        id
        nome
        cognome
        ragione_sociale
        codice_fiscale
        sesso
        data_nascita
        forma_giuridica_cer_id
        tipo_promotore_id
        tipologia_rappresentante_id
        citta_nascita {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        nazione_nascita {
          id
          denominazione
        }
        partita_iva
        codice_ateco_id
        codice_ateco {
          id
          label
        }
        forma_giuridica {
          id
          label
          rules
        }
        tipologia_rappresentante {
          id
          label
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        contatti {
          id
          contatto {
            id
            tipo_contatto_id
            value
            tipo_contatto {
              id
              label
              icon
              validation
            }
          }
        }
        rappresentante_legale {
          id
          nome
          cognome
          ragione_sociale
          codice_fiscale
          sesso
          data_nascita
          forma_giuridica_cer_id
          tipo_promotore_id
          tipologia_rappresentante_id
          citta_nascita {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          nazione_nascita {
            id
            denominazione
          }
          partita_iva
          codice_ateco_id
          codice_ateco {
            id
            label
          }
          forma_giuridica {
            id
            label
            rules
          }
          tipologia_rappresentante {
            id
            label
          }
          indirizzo {
            id
            completo
            manuale
            toponimo
            civico
            cap
            citta {
              id
              denominazione
              provincia {
                id
                denominazione
                sigla
              }
            }
            geom_
            geom
          }
          contatti {
            id
            contatto {
              id
              tipo_contatto_id
              value
              tipo_contatto {
                id
                label
                icon
                validation
              }
            }
          }
        }
      }
      richiesta_pnrr
      cod_richiesta_terna
      cod_censimp
      tipologia_impianto_id
      richiesta_modello_unico
      presenza_accumulo
      potenza_batteria
      sezione_catastale
      foglio
      particella
      subalterno
      ubicazione_impianto_aderente
      data_installazione_impianto
      configurazione_accumulo_id
      aderenza_delibera_autoconsumo
      data_adesione_autoconsumo
      prelievi_non_ausiliari
      indirizzo {
        id
        completo
        manuale
        toponimo
        civico
        cap
        citta {
          id
          denominazione
          provincia {
            id
            denominazione
            sigla
          }
        }
        geom_
        geom
      }
      codice_fatturato_pnrr
      delibera_gse_pnrr {
        id
        name
      }
      documenti_pnrr {
        id
        tipologia_documento
        file {
          id
          name
        }
      }
      motivanzione_no_pnrr
      esito_pnrr
      unita {
        id
        cod_up
        data_attivazione
        data_disattivazione
        sezioni {
          id
          codice_sezione
          data_decorrenza_autoconsumo
          incompatibilita_incentivi_id
          incompatibilita_incentivi_altro
          tipologia_sito_impianto_id
          dispositivo_inseguimento_solare
          pannelli_bifacciali
          esposizione_prevalente_id
          inclinazione_prevalente
          incentivi {
            id
            rispetto_principio_dns
            usufruito_incentivi_rilancio
            quota_potenza_rinnovabili_obbligo
            contributi_id
            quota_incentivo
          }
          titoli_autorizzativi {
            id
            tipo_titolo_id
            ente
            protocollo
            data
          }
        }
      }
      asset {
        id
        alias
        consumo
        autoconsumo
        cabina {
          id
          cod_ac
        }
        condivisioneInstallatore: condivisioni(
          where: {tipo_profilo: {_eq: installatore}}
          order_by: {updated_at: desc}
        ) {
          id
          stato
          nome
          email
          auth {
            profiloInstallatore: profili(
              where: {tipologia: {_eq: installatore}}
              order_by: {updated_at: desc}
              limit: 1
            ) {
              persona {
                nome
                ragione_sociale
                contatti {
                  contatto {
                    value
                    tipo_contatto {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
        condivisioneProsumer: condivisioni(
          where: {tipo_profilo: {_eq: prosumer}}
          order_by: {updated_at: desc}
          limit: 1
        ) {
          id
          stato
          nome
          email
        }
        condivisioneRecente: condivisioni(
          where: {tipo_profilo: {_neq: installatore}}
          order_by: {created_at: desc}
          limit: 1
        ) {
          id
          nome
          email
        }
        gestori {
          utente {
            id
            first_name
            last_name
            username
            email
          }
        }
        tipologia_abitativa {
          id
          label
        }
        potenza_effettiva
        potenza_batteria
        dimensione_id
        data_installazione_impianto
        associato
        sottoscrizione_id
        opzionato
        impianto
        realizzando_impianto
        aiuto
        potenza_impianto_prevista
        capacita_batteria_prevista
        data_allaccio_prevista
        notifiche
        spazio_disponibile
        spazi_disponibili {
          id
          dimensione
          tipo_area {
            id
            label
          }
        }
        lunedi_id
        martedi_id
        mercoledi_id
        giovedi_id
        venerdi_id
        sabato_id
        domenica_id
        visibilita_nome
        posizione_esatta
        scambio_su_posto
        incentivi_impianto
        tipologia_abitativa {
          label
        }
        dimensione {
          label
        }
        tipologia_asset {
          id
          label
          icon
          percentuale_autoconsumo
          tipologia_prosumer
          tipologia_asset_padre {
            id
            label
            icon
            percentuale_autoconsumo
            tipologia_prosumer
          }
        }
        indirizzo {
          id
          completo
          manuale
          toponimo
          civico
          cap
          citta {
            id
            denominazione
            provincia {
              id
              denominazione
              sigla
            }
          }
          geom_
          geom
        }
        caratteristiche {
          caratteristica {
            id
            label
            icon
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioneTecnicoGQL extends Apollo.Subscription<GetSottoscrizioneTecnicoSubscription, GetSottoscrizioneTecnicoSubscriptionVariables> {
    document = GetSottoscrizioneTecnicoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCerFilterOptionsTecnicoDocument = gql`
    query GetCerFilterOptionsTecnico {
  sottoscrizione(distinct_on: cer_cabina_id) {
    cer_cabina {
      cer {
        id
        alias
        cer_padre {
          id
          alias
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCerFilterOptionsTecnicoGQL extends Apollo.Query<GetCerFilterOptionsTecnicoQuery, GetCerFilterOptionsTecnicoQueryVariables> {
    document = GetCerFilterOptionsTecnicoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioniTecnicoCountDocument = gql`
    subscription GetSottoscrizioniTecnicoCount($args: search_sottoscrizioni_args!) {
  search_sottoscrizioni_aggregate(args: $args) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioniTecnicoCountGQL extends Apollo.Subscription<GetSottoscrizioniTecnicoCountSubscription, GetSottoscrizioniTecnicoCountSubscriptionVariables> {
    document = GetSottoscrizioniTecnicoCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSottoscrizioniTecnicoDocument = gql`
    subscription GetSottoscrizioniTecnico($args: search_sottoscrizioni_args!, $limit: Int, $offset: Int, $order_by: [sottoscrizione_order_by!]) {
  search_sottoscrizioni(
    args: $args
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    id
    stato
    tipologia_richiesta
    updated_at
    cer_cabina {
      cabina {
        cod_ac
      }
      cer {
        alias
        stato_cer
        abilita_richieste
        logo {
          id
        }
        cer_padre {
          alias
          logo {
            id
          }
        }
      }
    }
    asset_consumo {
      pod
      intestatario {
        nome
        cognome
        ragione_sociale
      }
      asset {
        associato
        opzionato
        potenza_effettiva
        caratteristiche {
          caratteristica {
            icon
          }
        }
        indirizzo {
          geom_
        }
        tipologia_asset {
          icon
          tipologia_asset_padre {
            icon
          }
        }
        alias
        gestori(order_by: {created_at: asc}, limit: 1) {
          utente {
            first_name
            last_name
            username
          }
        }
        condivisioni(order_by: {created_at: desc}, limit: 1) {
          id
          nome
          email
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSottoscrizioniTecnicoGQL extends Apollo.Subscription<GetSottoscrizioniTecnicoSubscription, GetSottoscrizioniTecnicoSubscriptionVariables> {
    document = GetSottoscrizioniTecnicoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }